import { r as __toESM, t as __commonJSMin } from "./rolldown-runtime-DC62tzP2.js";
import { $sr as require_react_is$1, Asr as createStyled, Bsr as hasOwn, CM as Start_default, Csr as applyChildrenFocusVisible, DWt as KeyboardArrowDown_default, Dsr as alpha, Eo as Warning_default, Esr as DefaultPropsProvider, Fqt as InfoOutlined_default$1, Fsr as styled$1, Gsr as styleFunctionSx_default, Hsr as useInsertionEffectWithLayoutFallback, Hzn as CheckCircle_default, Isr as styled$3, Jsr as getPath, Ksr as createUnarySpacing, Lsr as Emotion$1, Msr as generateUtilityClass, Nsr as createTheme, Osr as emphasize, Psr as internal_serializeStyles, Qsr as deepmerge, Rsr as ThemeContext$1, Ssr as createTypography, Tsr as outsetFocusRing, Usr as serializeStyles, Vsr as withEmotionCache, Wfn as Error_default, Wsr as insertStyles, Wxt as NewReleases_default, Xsr as mergeBreakpointsInOrder, Ysr as handleBreakpoints, Zsr as resolveBreakpointValues, _bn as DoneRounded_default, _sr as identifier_default, acr as capitalize, asr as createSvgIcon, bsr as getOverlayAlpha, c5n as ArrowDropDown_default$1, csr as getTransitionProps, dsr as reflow, ecr as composeClasses, fWt as KeyboardArrowUp_default, fsr as useDefaultProps, gsr as slotShouldForwardProp, hsr as rootShouldForwardProp, icr as capitalize_default, j6 as RemoveRounded_default, jsr as generateUtilityClasses, ksr as resolveProps, lsr as getTransitionStyles, lzn as ChevronRight_default, msr as styled$2, ncr as require_prop_types, ocr as ClassNameGenerator, osr as getReducedMotionStyles, psr as memoTheme, qsr as getValue, rRn as Close_default$1, rcr as require_react_is, ssr as getTransitionChildStyle, tcr as clsx, usr as normalizedTransitionCallback, vsr as defaultTheme$4, wsr as applyInsetFocusVisible, xsr as duration, ysr as createTheme$1, zsr as createEmotionProps } from "./webIcons-B3fe3Gv7.js";
import { a as Color, l as BREAKPOINTS, t as getTheme } from "./core-Y6q9HfN-.js";
import * as React$1 from "react";
import React, { Children, cloneElement, createContext, createElement, forwardRef, isValidElement, useCallback, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState, useSyncExternalStore } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import * as ReactDOM from "react-dom";
import constate from "constate";
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/createChainedFunction/createChainedFunction.mjs
/**
* Safe chained function.
*
* Will only create a new function if needed,
* otherwise will pass back existing functions or null.
*/
function createChainedFunction(...funcs) {
	return funcs.reduce((acc, func) => {
		if (func == null) return acc;
		return function chainedFunction(...args) {
			acc.apply(this, args);
			func.apply(this, args);
		};
	}, () => {});
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/createChainedFunction.mjs
var createChainedFunction_default = createChainedFunction;
(/* @__PURE__ */ __commonJSMin(((exports, module) => {
	var reactIs = require_react_is();
	/**
	* Copyright 2015, Yahoo! Inc.
	* Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	*/
	var REACT_STATICS = {
		childContextTypes: true,
		contextType: true,
		contextTypes: true,
		defaultProps: true,
		displayName: true,
		getDefaultProps: true,
		getDerivedStateFromError: true,
		getDerivedStateFromProps: true,
		mixins: true,
		propTypes: true,
		type: true
	};
	var KNOWN_STATICS = {
		name: true,
		length: true,
		prototype: true,
		caller: true,
		callee: true,
		arguments: true,
		arity: true
	};
	var FORWARD_REF_STATICS = {
		"$$typeof": true,
		render: true,
		defaultProps: true,
		displayName: true,
		propTypes: true
	};
	var MEMO_STATICS = {
		"$$typeof": true,
		compare: true,
		defaultProps: true,
		displayName: true,
		propTypes: true,
		type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	function getStatics(component) {
		if (reactIs.isMemo(component)) return MEMO_STATICS;
		return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
	}
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
		if (typeof sourceComponent !== "string") {
			if (objectPrototype) {
				var inheritedComponent = getPrototypeOf(sourceComponent);
				if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
			}
			var keys = getOwnPropertyNames(sourceComponent);
			if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
			var targetStatics = getStatics(targetComponent);
			var sourceStatics = getStatics(sourceComponent);
			for (var i = 0; i < keys.length; ++i) {
				var key = keys[i];
				if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
					var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
					try {
						defineProperty(targetComponent, key, descriptor);
					} catch (e) {}
				}
			}
		}
		return targetComponent;
	}
	module.exports = hoistNonReactStatics;
})))();
var jsx$1 = function jsx(type, props) {
	var args = arguments;
	if (props == null || !hasOwn.call(props, "css")) return React$1.createElement.apply(void 0, args);
	var argsLength = args.length;
	var createElementArgArray = new Array(argsLength);
	createElementArgArray[0] = Emotion$1;
	createElementArgArray[1] = createEmotionProps(type, props);
	for (var i = 2; i < argsLength; i++) createElementArgArray[i] = args[i];
	return React$1.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
	var JSX;
	JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})(jsx$1 || (jsx$1 = {}));
var Global = /* #__PURE__ */ withEmotionCache(function(props, cache) {
	var styles = props.styles;
	var serialized = serializeStyles([styles], void 0, React$1.useContext(ThemeContext$1));
	var sheetRef = React$1.useRef();
	useInsertionEffectWithLayoutFallback(function() {
		var key = cache.key + "-global";
		var sheet = new cache.sheet.constructor({
			key,
			nonce: cache.sheet.nonce,
			container: cache.sheet.container,
			speedy: cache.sheet.isSpeedy
		});
		var rehydrating = false;
		var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
		if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
		if (node !== null) {
			rehydrating = true;
			node.setAttribute("data-emotion", key);
			sheet.hydrate([node]);
		}
		sheetRef.current = [sheet, rehydrating];
		return function() {
			sheet.flush();
		};
	}, [cache]);
	useInsertionEffectWithLayoutFallback(function() {
		var sheetRefCurrent = sheetRef.current;
		var sheet = sheetRefCurrent[0];
		if (sheetRefCurrent[1]) {
			sheetRefCurrent[1] = false;
			return;
		}
		if (serialized.next !== void 0) insertStyles(cache, serialized.next, true);
		if (sheet.tags.length) {
			sheet.before = sheet.tags[sheet.tags.length - 1].nextElementSibling;
			sheet.flush();
		}
		cache.insert("", serialized, sheet, false);
	}, [cache, serialized.name]);
	return null;
});
function css() {
	for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
	return serializeStyles(args);
}
function keyframes() {
	var insertable = css.apply(void 0, arguments);
	var name = "animation-" + insertable.name;
	return {
		name,
		styles: "@keyframes " + name + "{" + insertable.styles + "}",
		anim: 1,
		toString: function toString() {
			return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
		}
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+styled-engine@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_suppo_7279fa21ed6ae9d5d6c40e379100ad9c/node_modules/@mui/styled-engine/GlobalStyles/GlobalStyles.mjs
var import_prop_types = /* @__PURE__ */ __toESM(require_prop_types(), 1);
function isEmpty$2(obj) {
	return obj === void 0 || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles$2(props) {
	const { styles, defaultTheme = {} } = props;
	return /*#__PURE__*/ jsx(Global, { styles: typeof styles === "function" ? (themeInput) => styles(isEmpty$2(themeInput) ? defaultTheme : themeInput) : styles });
}
GlobalStyles$2.propTypes = {
	defaultTheme: import_prop_types.default.object,
	styles: import_prop_types.default.oneOfType([
		import_prop_types.default.array,
		import_prop_types.default.string,
		import_prop_types.default.object,
		import_prop_types.default.func
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/useThemeWithoutDefault/useThemeWithoutDefault.mjs
function isObjectEmpty$1(obj) {
	return Object.keys(obj).length === 0;
}
function useThemeWithoutDefault(defaultTheme = null) {
	const contextTheme = React$1.useContext(ThemeContext$1);
	return !contextTheme || isObjectEmpty$1(contextTheme) ? defaultTheme : contextTheme;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/useTheme/useTheme.mjs
const systemDefaultTheme = createTheme();
function useTheme$3(defaultTheme = systemDefaultTheme) {
	return useThemeWithoutDefault(defaultTheme);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/GlobalStyles/GlobalStyles.mjs
function wrapGlobalLayer(styles) {
	const serialized = internal_serializeStyles(styles);
	if (styles !== serialized && serialized.styles) {
		if (!serialized.styles.match(/^@layer\s+[^{]*$/)) serialized.styles = `@layer global{${serialized.styles}}`;
		return serialized;
	}
	return styles;
}
function GlobalStyles$1({ styles, themeId, defaultTheme = {} }) {
	const upperTheme = useTheme$3(defaultTheme);
	const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
	let globalStyles = typeof styles === "function" ? styles(resolvedTheme) : styles;
	if (resolvedTheme.modularCssLayers) {
		if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg) => {
			if (typeof styleArg === "function") return wrapGlobalLayer(styleArg(resolvedTheme));
			return wrapGlobalLayer(styleArg);
		});
		else globalStyles = wrapGlobalLayer(globalStyles);
	}
	return /*#__PURE__*/ jsx(GlobalStyles$2, { styles: globalStyles });
}
GlobalStyles$1.propTypes = {
	/**
	* @ignore
	*/
	defaultTheme: import_prop_types.default.object,
	/**
	* @ignore
	*/
	styles: import_prop_types.default.oneOfType([
		import_prop_types.default.array,
		import_prop_types.default.func,
		import_prop_types.default.number,
		import_prop_types.default.object,
		import_prop_types.default.string,
		import_prop_types.default.bool
	]),
	/**
	* @ignore
	*/
	themeId: import_prop_types.default.string
};
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/createBox/createBox.mjs
function createBox(options = {}) {
	const { themeId, defaultTheme, defaultClassName = "MuiBox-root", generateClassName } = options;
	const BoxRoot = styled$1("div", { shouldForwardProp: (prop) => prop !== "theme" && prop !== "sx" && prop !== "as" })(styleFunctionSx_default);
	return /* @__PURE__ */ React$1.forwardRef(function Box(inProps, ref) {
		const theme = useTheme$3(defaultTheme);
		const { className, component = "div", ...other } = inProps;
		return /*#__PURE__*/ jsx(BoxRoot, {
			as: component,
			ref,
			className: clsx(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
			theme: themeId ? theme[themeId] || theme : theme,
			...other
		});
	});
}
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/styled/styled.mjs
const styled = createStyled();
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/useThemeProps/getThemeProps.mjs
function getThemeProps(params) {
	const { theme, name, props } = params;
	if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
	return resolveProps(theme.components[name].defaultProps, props);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/useThemeProps/useThemeProps.mjs
function useThemeProps(params) {
	const { props, name, defaultTheme, themeId } = params;
	let theme = useTheme$3(defaultTheme);
	if (themeId) theme = theme[themeId] || theme;
	return getThemeProps({
		theme,
		name,
		props
	});
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useEnhancedEffect/useEnhancedEffect.mjs
/**
* A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
* This is useful for effects that are only needed for client-side rendering but not for SSR.
*
* Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
* and confirm it doesn't apply to your use-case.
*/
const useEnhancedEffect = typeof window !== "undefined" ? React$1.useLayoutEffect : React$1.useEffect;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/exactProp/exactProp.mjs
const specialProperty = "exact-prop: ​";
function exactProp(propTypes) {
	return {
		...propTypes,
		[specialProperty]: (props) => {
			const unsupportedProps = Object.keys(props).filter((prop) => !propTypes.hasOwnProperty(prop));
			if (unsupportedProps.length > 0) return /* @__PURE__ */ new Error(`The following props are not supported: ${unsupportedProps.map((prop) => `\`${prop}\``).join(", ")}. Please remove them.`);
			return null;
		}
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+private-theming@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/private-theming/useTheme/ThemeContext.mjs
const ThemeContext = /*#__PURE__*/ React$1.createContext(null);
ThemeContext.displayName = "ThemeContext";
//#endregion
//#region ../node_modules/.pnpm/@mui+private-theming@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/private-theming/useTheme/useTheme.mjs
function useTheme$2() {
	const theme = React$1.useContext(ThemeContext);
	React$1.useDebugValue(theme);
	return theme;
}
var nested_default = typeof Symbol === "function" && Symbol.for ? Symbol.for("mui.nested") : "__THEME_NESTED__";
//#endregion
//#region ../node_modules/.pnpm/@mui+private-theming@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/private-theming/ThemeProvider/ThemeProvider.mjs
function mergeOuterLocalTheme(outerTheme, localTheme) {
	if (typeof localTheme === "function") {
		const mergedTheme = localTheme(outerTheme);
		if (!mergedTheme) console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join("\n"));
		return mergedTheme;
	}
	return {
		...outerTheme,
		...localTheme
	};
}
/**
* This component takes a `theme` prop.
* It makes the `theme` available down the React tree thanks to React context.
* This component should preferably be used at **the root of your component tree**.
*/
function ThemeProvider$3(props) {
	const { children, theme: localTheme } = props;
	const outerTheme = useTheme$2();
	if (outerTheme === null && typeof localTheme === "function") console.error([
		"MUI: You are providing a theme function prop to the ThemeProvider component:",
		"<ThemeProvider theme={outerTheme => outerTheme} />",
		"",
		"However, no outer theme is present.",
		"Make sure a theme is already injected higher in the React tree or provide a theme object."
	].join("\n"));
	const theme = React$1.useMemo(() => {
		const output = outerTheme === null ? { ...localTheme } : mergeOuterLocalTheme(outerTheme, localTheme);
		if (output != null) output[nested_default] = outerTheme !== null;
		return output;
	}, [localTheme, outerTheme]);
	return /*#__PURE__*/ jsx(ThemeContext.Provider, {
		value: theme,
		children
	});
}
ThemeProvider$3.propTypes = {
	/**
	* Your component tree.
	*/
	children: import_prop_types.default.node,
	/**
	* A theme object. You can provide a function to extend the outer theme.
	*/
	theme: import_prop_types.default.oneOfType([import_prop_types.default.object, import_prop_types.default.func]).isRequired
};
ThemeProvider$3.propTypes = exactProp(ThemeProvider$3.propTypes);
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/RtlProvider/index.mjs
const RtlContext = /*#__PURE__*/ React$1.createContext();
function RtlProvider({ value, ...props }) {
	return /*#__PURE__*/ jsx(RtlContext.Provider, {
		value: value ?? true,
		...props
	});
}
RtlProvider.propTypes = {
	children: import_prop_types.default.node,
	value: import_prop_types.default.bool
};
const useRtl = () => {
	return React$1.useContext(RtlContext) ?? false;
};
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useId/useId.mjs
let globalId = 0;
function useGlobalId(idOverride) {
	const [defaultId, setDefaultId] = React$1.useState(idOverride);
	const id = idOverride || defaultId;
	React$1.useEffect(() => {
		if (defaultId == null) {
			globalId += 1;
			setDefaultId(`mui-${globalId}`);
		}
	}, [defaultId]);
	return id;
}
const maybeReactUseId = { ...React$1 }.useId;
/**
*
* @example <div id={useId()} />
* @param idOverride
* @returns {string}
*/
function useId(idOverride) {
	if (maybeReactUseId !== void 0) {
		const reactId = maybeReactUseId();
		return idOverride ?? reactId;
	}
	return useGlobalId(idOverride);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/ThemeProvider/useLayerOrder.mjs
/**
* This hook returns a `GlobalStyles` component that sets the CSS layer order (for server-side rendering).
* Then on client-side, it injects the CSS layer order into the document head to ensure that the layer order is always present first before other Emotion styles.
*/
function useLayerOrder(theme) {
	const upperTheme = useThemeWithoutDefault();
	const id = useId() || "";
	const { modularCssLayers } = theme;
	let layerOrder = "mui.global, mui.components, mui.theme, mui.custom, mui.sx";
	if (!modularCssLayers || upperTheme !== null) layerOrder = "";
	else if (typeof modularCssLayers === "string") layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
	else layerOrder = `@layer ${layerOrder};`;
	useEnhancedEffect(() => {
		const head = document.querySelector("head");
		if (!head) return;
		const firstChild = head.firstChild;
		if (layerOrder) {
			if (firstChild && firstChild.hasAttribute?.("data-mui-layer-order") && firstChild.getAttribute("data-mui-layer-order") === id) return;
			const styleElement = document.createElement("style");
			styleElement.setAttribute("data-mui-layer-order", id);
			styleElement.textContent = layerOrder;
			head.prepend(styleElement);
		} else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
	}, [layerOrder, id]);
	if (!layerOrder) return null;
	return /*#__PURE__*/ jsx(GlobalStyles$1, { styles: layerOrder });
}
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/ThemeProvider/ThemeProvider.mjs
const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
	return React$1.useMemo(() => {
		const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
		if (typeof localTheme === "function") {
			const mergedTheme = localTheme(resolvedTheme);
			const result = themeId ? {
				...upperTheme,
				[themeId]: mergedTheme
			} : mergedTheme;
			if (isPrivate) return () => result;
			return result;
		}
		return themeId ? {
			...upperTheme,
			[themeId]: localTheme
		} : {
			...upperTheme,
			...localTheme
		};
	}, [
		themeId,
		upperTheme,
		localTheme,
		isPrivate
	]);
}
/**
* This component makes the `theme` available down the React tree.
* It should preferably be used at **the root of your component tree**.
*
* <ThemeProvider theme={theme}> // existing use case
* <ThemeProvider theme={{ id: theme }}> // theme scoping
*/
function ThemeProvider$2(props) {
	const { children, theme: localTheme, themeId } = props;
	const upperTheme = useThemeWithoutDefault(EMPTY_THEME);
	const upperPrivateTheme = useTheme$2() || EMPTY_THEME;
	if (upperTheme === null && typeof localTheme === "function" || themeId && upperTheme && !upperTheme[themeId] && typeof localTheme === "function") console.error([
		"MUI: You are providing a theme function prop to the ThemeProvider component:",
		"<ThemeProvider theme={outerTheme => outerTheme} />",
		"",
		"However, no outer theme is present.",
		"Make sure a theme is already injected higher in the React tree or provide a theme object."
	].join("\n"));
	const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
	const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
	const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === "rtl";
	const layerOrder = useLayerOrder(engineTheme);
	return /*#__PURE__*/ jsx(ThemeProvider$3, {
		theme: privateTheme,
		children: /*#__PURE__*/ jsx(ThemeContext$1.Provider, {
			value: engineTheme,
			children: /*#__PURE__*/ jsx(RtlProvider, {
				value: rtlValue,
				children: /*#__PURE__*/ jsxs(DefaultPropsProvider, {
					value: themeId ? engineTheme[themeId].components : engineTheme.components,
					children: [layerOrder, children]
				})
			})
		})
	});
}
ThemeProvider$2.propTypes = {
	/**
	* Your component tree.
	*/
	children: import_prop_types.default.node,
	/**
	* A theme object. You can provide a function to extend the outer theme.
	*/
	theme: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]).isRequired,
	/**
	* The design system's unique id for getting the corresponded theme when there are multiple design systems.
	*/
	themeId: import_prop_types.default.string
};
ThemeProvider$2["propTypes"] = exactProp(ThemeProvider$2.propTypes);
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/InitColorSchemeScript/InitColorSchemeScript.mjs
const DEFAULT_MODE_STORAGE_KEY = "mode";
const DEFAULT_COLOR_SCHEME_STORAGE_KEY = "color-scheme";
const DEFAULT_ATTRIBUTE = "data-color-scheme";
const maybeReactUseSyncExternalStore$1 = { ...React$1 }.useSyncExternalStore;
const subscribe = () => () => {};
/**
* `true` during the server render and the matching hydration render, `false`
* on every client render afterwards. React warns when a `<script>` is
* created during a client render (such scripts never execute), so the inline
* script is only emitted on the server pass and dropped after hydration — the
* attribute it already set on the document persists. React <18 has no
* `useSyncExternalStore` and no such warning, so the script is always emitted.
*/
function useIsServerRender() {
	if (maybeReactUseSyncExternalStore$1 === void 0) return true;
	return maybeReactUseSyncExternalStore$1(subscribe, () => false, () => true);
}
function buildInitColorSchemeScript(options) {
	const { defaultMode = "system", defaultLightColorScheme = "light", defaultDarkColorScheme = "dark", modeStorageKey = DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey = DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = DEFAULT_ATTRIBUTE, colorSchemeNode = "document.documentElement", nonce } = options || {};
	let setter = "";
	let attribute = initialAttribute;
	if (initialAttribute === "class") attribute = ".%s";
	if (initialAttribute === "data") attribute = "[data-%s]";
	if (attribute.startsWith(".")) {
		const selector = attribute.substring(1);
		setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
	}
	const matches = attribute.match(/\[([^[\]]+)\]/);
	if (matches) {
		const [attr, value] = matches[1].split("=");
		if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
		setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : "\"\""});`;
	} else if (attribute !== ".%s") setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
	return /*#__PURE__*/ jsx("script", {
		suppressHydrationWarning: true,
		nonce: typeof window === "undefined" ? nonce : "",
		dangerouslySetInnerHTML: { __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();` }
	}, "mui-color-scheme-init");
}
function InitColorSchemeScript$1(options) {
	if (!useIsServerRender()) return null;
	return buildInitColorSchemeScript(options);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/cssVars/localStorageManager.mjs
function noop$2() {}
const localStorageManager = ({ key, storageWindow }) => {
	if (!storageWindow && typeof window !== "undefined") storageWindow = window;
	return {
		get(defaultValue) {
			if (typeof window === "undefined") return;
			if (!storageWindow) return defaultValue;
			let value;
			try {
				value = storageWindow.localStorage.getItem(key);
			} catch {}
			return value || defaultValue;
		},
		set: (value) => {
			if (storageWindow) try {
				storageWindow.localStorage.setItem(key, value);
			} catch {}
		},
		subscribe: (handler) => {
			if (!storageWindow) return noop$2;
			const listener = (event) => {
				const value = event.newValue;
				if (event.key === key) handler(value);
			};
			storageWindow.addEventListener("storage", listener);
			return () => {
				storageWindow.removeEventListener("storage", listener);
			};
		}
	};
};
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/cssVars/useCurrentColorScheme.mjs
function noop$1() {}
function getSystemMode(mode) {
	if (typeof window !== "undefined" && typeof window.matchMedia === "function" && mode === "system") {
		if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
		return "light";
	}
}
function processState(state, callback) {
	if (state.mode === "light" || state.mode === "system" && state.systemMode === "light") return callback("light");
	if (state.mode === "dark" || state.mode === "system" && state.systemMode === "dark") return callback("dark");
}
function getColorScheme(state) {
	return processState(state, (mode) => {
		if (mode === "light") return state.lightColorScheme;
		if (mode === "dark") return state.darkColorScheme;
	});
}
function useCurrentColorScheme(options) {
	const { defaultMode = "light", defaultLightColorScheme, defaultDarkColorScheme, supportedColorSchemes = [], modeStorageKey = DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey = DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow = typeof window === "undefined" ? void 0 : window, storageManager = localStorageManager, noSsr = false } = options;
	const joinedColorSchemes = supportedColorSchemes.join(",");
	const isMultiSchemes = supportedColorSchemes.length > 1;
	const modeStorage = React$1.useMemo(() => storageManager?.({
		key: modeStorageKey,
		storageWindow
	}), [
		storageManager,
		modeStorageKey,
		storageWindow
	]);
	const lightStorage = React$1.useMemo(() => storageManager?.({
		key: `${colorSchemeStorageKey}-light`,
		storageWindow
	}), [
		storageManager,
		colorSchemeStorageKey,
		storageWindow
	]);
	const darkStorage = React$1.useMemo(() => storageManager?.({
		key: `${colorSchemeStorageKey}-dark`,
		storageWindow
	}), [
		storageManager,
		colorSchemeStorageKey,
		storageWindow
	]);
	const [state, setState] = React$1.useState(() => {
		const initialMode = modeStorage?.get(defaultMode) || defaultMode;
		const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
		const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
		return {
			mode: initialMode,
			systemMode: getSystemMode(initialMode),
			lightColorScheme,
			darkColorScheme
		};
	});
	const [isClient, setIsClient] = React$1.useState(noSsr || !isMultiSchemes);
	React$1.useEffect(() => {
		setIsClient(true);
	}, []);
	const colorScheme = getColorScheme(state);
	const setMode = React$1.useCallback((mode) => {
		setState((currentState) => {
			if (mode === currentState.mode) return currentState;
			const newMode = mode ?? defaultMode;
			modeStorage?.set(newMode);
			return {
				...currentState,
				mode: newMode,
				systemMode: getSystemMode(newMode)
			};
		});
	}, [modeStorage, defaultMode]);
	const setColorScheme = React$1.useCallback((value) => {
		if (!value) setState((currentState) => {
			lightStorage?.set(defaultLightColorScheme);
			darkStorage?.set(defaultDarkColorScheme);
			return {
				...currentState,
				lightColorScheme: defaultLightColorScheme,
				darkColorScheme: defaultDarkColorScheme
			};
		});
		else if (typeof value === "string") {
			if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
			else setState((currentState) => {
				const newState = { ...currentState };
				processState(currentState, (mode) => {
					if (mode === "light") {
						lightStorage?.set(value);
						newState.lightColorScheme = value;
					}
					if (mode === "dark") {
						darkStorage?.set(value);
						newState.darkColorScheme = value;
					}
				});
				return newState;
			});
		} else setState((currentState) => {
			const newState = { ...currentState };
			const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
			const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
			if (newLightColorScheme) {
				if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
				else {
					newState.lightColorScheme = newLightColorScheme;
					lightStorage?.set(newLightColorScheme);
				}
			}
			if (newDarkColorScheme) {
				if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
				else {
					newState.darkColorScheme = newDarkColorScheme;
					darkStorage?.set(newDarkColorScheme);
				}
			}
			return newState;
		});
	}, [
		joinedColorSchemes,
		lightStorage,
		darkStorage,
		defaultLightColorScheme,
		defaultDarkColorScheme
	]);
	const handleMediaQuery = React$1.useCallback((event) => {
		if (state.mode === "system") setState((currentState) => {
			const systemMode = event?.matches ? "dark" : "light";
			if (currentState.systemMode === systemMode) return currentState;
			return {
				...currentState,
				systemMode
			};
		});
	}, [state.mode]);
	const mediaListener = React$1.useRef(handleMediaQuery);
	mediaListener.current = handleMediaQuery;
	React$1.useEffect(() => {
		if (typeof window.matchMedia !== "function" || !isMultiSchemes) return;
		const handler = (...args) => mediaListener.current(...args);
		const media = window.matchMedia("(prefers-color-scheme: dark)");
		media.addListener(handler);
		handler(media);
		return () => {
			media.removeListener(handler);
		};
	}, [isMultiSchemes]);
	React$1.useEffect(() => {
		if (isMultiSchemes) {
			const unsubscribeMode = modeStorage?.subscribe((value) => {
				if (!value || [
					"light",
					"dark",
					"system"
				].includes(value)) setMode(value || defaultMode);
			}) || noop$1;
			const unsubscribeLight = lightStorage?.subscribe((value) => {
				if (!value || joinedColorSchemes.match(value)) setColorScheme({ light: value });
			}) || noop$1;
			const unsubscribeDark = darkStorage?.subscribe((value) => {
				if (!value || joinedColorSchemes.match(value)) setColorScheme({ dark: value });
			}) || noop$1;
			return () => {
				unsubscribeMode();
				unsubscribeLight();
				unsubscribeDark();
			};
		}
	}, [
		setColorScheme,
		setMode,
		joinedColorSchemes,
		defaultMode,
		storageWindow,
		isMultiSchemes,
		modeStorage,
		lightStorage,
		darkStorage
	]);
	return {
		...state,
		mode: isClient ? state.mode : void 0,
		systemMode: isClient ? state.systemMode : void 0,
		colorScheme: isClient ? colorScheme : void 0,
		setMode,
		setColorScheme
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/cssVars/createCssVarsProvider.mjs
const DISABLE_CSS_TRANSITION = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function createCssVarsProvider(options) {
	const { themeId, theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme, resolveTheme } = options;
	const defaultContext = {
		allColorSchemes: [],
		colorScheme: void 0,
		darkColorScheme: void 0,
		lightColorScheme: void 0,
		mode: void 0,
		setColorScheme: () => {},
		setMode: () => {},
		systemMode: void 0
	};
	const ColorSchemeContext = /*#__PURE__*/ React$1.createContext(void 0);
	ColorSchemeContext.displayName = "ColorSchemeContext";
	const useColorScheme = () => React$1.useContext(ColorSchemeContext) || defaultContext;
	const defaultColorSchemes = {};
	const defaultComponents = {};
	function CssVarsProvider(props) {
		const { children, theme: themeProp, modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange = designSystemTransitionOnChange, storageManager, storageWindow = typeof window === "undefined" ? void 0 : window, documentNode = typeof document === "undefined" ? void 0 : document, colorSchemeNode = typeof document === "undefined" ? void 0 : document.documentElement, disableNestedContext = false, disableStyleSheetGeneration = false, defaultMode: initialMode = "system", forceThemeRerender = false, noSsr } = props;
		const hasMounted = React$1.useRef(false);
		const upperTheme = useTheme$2();
		const ctx = React$1.useContext(ColorSchemeContext);
		const nested = !!ctx && !disableNestedContext;
		const initialTheme = React$1.useMemo(() => {
			if (themeProp) return themeProp;
			return typeof defaultTheme === "function" ? defaultTheme() : defaultTheme;
		}, [themeProp]);
		const scopedTheme = initialTheme[themeId];
		const restThemeProp = scopedTheme || initialTheme;
		const { colorSchemes = defaultColorSchemes, components = defaultComponents, cssVarPrefix } = restThemeProp;
		const joinedColorSchemes = Object.keys(colorSchemes).filter((k) => !!colorSchemes[k]).join(",");
		const allColorSchemes = React$1.useMemo(() => joinedColorSchemes.split(","), [joinedColorSchemes]);
		const defaultLightColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.light;
		const defaultDarkColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.dark;
		const { mode: stateMode, setMode, systemMode, lightColorScheme, darkColorScheme, colorScheme: stateColorScheme, setColorScheme } = useCurrentColorScheme({
			supportedColorSchemes: allColorSchemes,
			defaultLightColorScheme,
			defaultDarkColorScheme,
			modeStorageKey,
			colorSchemeStorageKey,
			defaultMode: colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode,
			storageManager,
			storageWindow,
			noSsr
		});
		let mode = stateMode;
		let colorScheme = stateColorScheme;
		if (nested) {
			mode = ctx.mode;
			colorScheme = ctx.colorScheme;
		}
		if (forceThemeRerender && !restThemeProp.vars) console.warn(["MUI: The `forceThemeRerender` prop should only be used with CSS theme variables.", "Note that it will slow down the app when changing between modes, so only do this when you cannot find a better solution."].join("\n"));
		let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
		if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
		const memoTheme = React$1.useMemo(() => {
			const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
			const theme = {
				...restThemeProp,
				components,
				colorSchemes,
				cssVarPrefix,
				vars: themeVars
			};
			if (typeof theme.generateSpacing === "function") theme.spacing = theme.generateSpacing();
			if (calculatedColorScheme) {
				const scheme = colorSchemes[calculatedColorScheme];
				if (scheme && typeof scheme === "object") Object.keys(scheme).forEach((schemeKey) => {
					if (scheme[schemeKey] && typeof scheme[schemeKey] === "object") theme[schemeKey] = {
						...theme[schemeKey],
						...scheme[schemeKey]
					};
					else theme[schemeKey] = scheme[schemeKey];
				});
			}
			return resolveTheme ? resolveTheme(theme) : theme;
		}, [
			restThemeProp,
			calculatedColorScheme,
			components,
			colorSchemes,
			cssVarPrefix
		]);
		const colorSchemeSelector = restThemeProp.colorSchemeSelector;
		useEnhancedEffect(() => {
			if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== "media") {
				const selector = colorSchemeSelector;
				let rule = colorSchemeSelector;
				if (selector === "class") rule = `.%s`;
				if (selector === "data") rule = `[data-%s]`;
				if (selector?.startsWith("data-") && !selector.includes("%s")) rule = `[${selector}="%s"]`;
				if (rule.startsWith(".")) {
					colorSchemeNode.classList.remove(...allColorSchemes.map((scheme) => rule.substring(1).replace("%s", scheme)));
					colorSchemeNode.classList.add(rule.substring(1).replace("%s", colorScheme));
				} else {
					const matches = rule.replace("%s", colorScheme).match(/\[([^\]]+)\]/);
					if (matches) {
						const [attr, value] = matches[1].split("=");
						if (!value) allColorSchemes.forEach((scheme) => {
							colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
						});
						colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, "") : "");
					} else colorSchemeNode.setAttribute(rule, colorScheme);
				}
			}
		}, [
			colorScheme,
			colorSchemeSelector,
			colorSchemeNode,
			allColorSchemes
		]);
		React$1.useEffect(() => {
			let timer;
			if (disableTransitionOnChange && hasMounted.current && documentNode) {
				const css = documentNode.createElement("style");
				css.appendChild(documentNode.createTextNode(DISABLE_CSS_TRANSITION));
				documentNode.head.appendChild(css);
				(() => window.getComputedStyle(documentNode.body))();
				timer = setTimeout(() => {
					documentNode.head.removeChild(css);
				}, 1);
			}
			return () => {
				clearTimeout(timer);
			};
		}, [
			colorScheme,
			disableTransitionOnChange,
			documentNode
		]);
		React$1.useEffect(() => {
			hasMounted.current = true;
			return () => {
				hasMounted.current = false;
			};
		}, []);
		const contextValue = React$1.useMemo(() => ({
			allColorSchemes,
			colorScheme,
			darkColorScheme,
			lightColorScheme,
			mode,
			setColorScheme,
			setMode: (newMode) => {
				if (memoTheme.colorSchemeSelector === "media") console.error([
					"MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).",
					"To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.",
					"To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually"
				].join("\n"));
				setMode(newMode);
			},
			systemMode
		}), [
			allColorSchemes,
			colorScheme,
			darkColorScheme,
			lightColorScheme,
			mode,
			setColorScheme,
			setMode,
			systemMode,
			memoTheme.colorSchemeSelector
		]);
		let shouldGenerateStyleSheet = true;
		if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
		const element = /*#__PURE__*/ jsxs(React$1.Fragment, { children: [/*#__PURE__*/ jsx(ThemeProvider$2, {
			themeId: scopedTheme ? themeId : void 0,
			theme: memoTheme,
			children
		}), shouldGenerateStyleSheet && /*#__PURE__*/ jsx(GlobalStyles$2, { styles: memoTheme.generateStyleSheets?.() || [] })] });
		if (nested) return element;
		return /*#__PURE__*/ jsx(ColorSchemeContext.Provider, {
			value: contextValue,
			children: element
		});
	}
	CssVarsProvider.propTypes = {
		/**
		* The component tree.
		*/
		children: import_prop_types.default.node,
		/**
		* The node used to attach the color-scheme attribute
		*/
		colorSchemeNode: import_prop_types.default.any,
		/**
		* localStorage key used to store `colorScheme`
		*/
		colorSchemeStorageKey: import_prop_types.default.string,
		/**
		* The default mode when the storage is empty,
		* require the theme to have `colorSchemes` with light and dark.
		*/
		defaultMode: import_prop_types.default.string,
		/**
		* If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
		*/
		disableNestedContext: import_prop_types.default.bool,
		/**
		* If `true`, the style sheet won't be generated.
		*
		* This is useful for controlling nested CssVarsProvider behavior.
		*/
		disableStyleSheetGeneration: import_prop_types.default.bool,
		/**
		* Disable CSS transitions when switching between modes or color schemes.
		*/
		disableTransitionOnChange: import_prop_types.default.bool,
		/**
		* The document to attach the attribute to.
		*/
		documentNode: import_prop_types.default.any,
		/**
		* If `true`, theme values are recalculated when the mode changes.
		*/
		forceThemeRerender: import_prop_types.default.bool,
		/**
		* The key in the local storage used to store current color scheme.
		*/
		modeStorageKey: import_prop_types.default.string,
		/**
		* If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
		* You should use this option in conjunction with `InitColorSchemeScript` component.
		*/
		noSsr: import_prop_types.default.bool,
		/**
		* The storage manager to be used for storing the mode and color scheme
		* @default using `window.localStorage`
		*/
		storageManager: import_prop_types.default.func,
		/**
		* The window that attaches the 'storage' event listener.
		* @default window
		*/
		storageWindow: import_prop_types.default.any,
		/**
		* The calculated theme object that will be passed through context.
		*/
		theme: import_prop_types.default.object
	};
	const defaultLightColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.light;
	const defaultDarkColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.dark;
	const getInitColorSchemeScript = (params) => buildInitColorSchemeScript({
		colorSchemeStorageKey: defaultColorSchemeStorageKey,
		defaultLightColorScheme,
		defaultDarkColorScheme,
		modeStorageKey: defaultModeStorageKey,
		...params
	});
	return {
		CssVarsProvider,
		useColorScheme,
		getInitColorSchemeScript
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/Container/createContainer.mjs
const defaultTheme$3 = createTheme();
const defaultCreateStyledComponent$2 = styled("div", {
	name: "MuiContainer",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[`maxWidth${capitalize(String(ownerState.maxWidth))}`],
			ownerState.fixed && styles.fixed,
			ownerState.disableGutters && styles.disableGutters
		];
	}
});
const useThemePropsDefault$2 = (inProps) => useThemeProps({
	props: inProps,
	name: "MuiContainer",
	defaultTheme: defaultTheme$3
});
const useUtilityClasses$76 = (ownerState, componentName) => {
	const getContainerUtilityClass = (slot) => {
		return generateUtilityClass(componentName, slot);
	};
	const { classes, fixed, disableGutters, maxWidth } = ownerState;
	const slots = { root: [
		"root",
		maxWidth && `maxWidth${capitalize(String(maxWidth))}`,
		fixed && "fixed",
		disableGutters && "disableGutters"
	] };
	return composeClasses(slots, getContainerUtilityClass, classes);
};
function createContainer(options = {}) {
	const { createStyledComponent = defaultCreateStyledComponent$2, useThemeProps = useThemePropsDefault$2, componentName = "MuiContainer" } = options;
	const ContainerRoot = createStyledComponent(({ theme, ownerState }) => ({
		width: "100%",
		marginLeft: "auto",
		boxSizing: "border-box",
		marginRight: "auto",
		...!ownerState.disableGutters && {
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(2),
			[theme.breakpoints.up("sm")]: {
				paddingLeft: theme.spacing(3),
				paddingRight: theme.spacing(3)
			}
		}
	}), ({ theme, ownerState }) => ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey) => {
		const breakpoint = breakpointValueKey;
		const value = theme.breakpoints.values[breakpoint];
		if (value !== 0) acc[theme.breakpoints.up(breakpoint)] = { maxWidth: `${value}${theme.breakpoints.unit}` };
		return acc;
	}, {}), ({ theme, ownerState }) => ({
		...ownerState.maxWidth === "xs" && { [theme.breakpoints.up("xs")]: { maxWidth: Math.max(theme.breakpoints.values.xs, 444) } },
		...ownerState.maxWidth && ownerState.maxWidth !== "xs" && { [theme.breakpoints.up(ownerState.maxWidth)]: { maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}` } }
	}));
	const Container = /*#__PURE__*/ React$1.forwardRef(function Container(inProps, ref) {
		const props = useThemeProps(inProps);
		const { className, component = "div", disableGutters = false, fixed = false, maxWidth = "lg", classes: classesProp, ...other } = props;
		const ownerState = {
			...props,
			component,
			disableGutters,
			fixed,
			maxWidth
		};
		const classes = useUtilityClasses$76(ownerState, componentName);
		return /*#__PURE__*/ jsx(ContainerRoot, {
			as: component,
			ownerState,
			className: clsx(classes.root, className),
			ref,
			...other
		});
	});
	Container.propTypes = {
		children: import_prop_types.default.node,
		classes: import_prop_types.default.object,
		className: import_prop_types.default.string,
		component: import_prop_types.default.elementType,
		disableGutters: import_prop_types.default.bool,
		fixed: import_prop_types.default.bool,
		maxWidth: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
			"xs",
			"sm",
			"md",
			"lg",
			"xl",
			false
		]), import_prop_types.default.string]),
		sx: import_prop_types.default.oneOfType([
			import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
				import_prop_types.default.func,
				import_prop_types.default.object,
				import_prop_types.default.bool
			])),
			import_prop_types.default.func,
			import_prop_types.default.object
		])
	};
	return Container;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/isMuiElement/isMuiElement.mjs
function isMuiElement(element, muiNames) {
	return /*#__PURE__*/ React$1.isValidElement(element) && muiNames.indexOf(element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/Grid/traverseBreakpoints.mjs
const filterBreakpointKeys = (breakpointsKeys, responsiveKeys) => breakpointsKeys.filter((key) => responsiveKeys.includes(key));
const traverseBreakpoints = (breakpoints, responsive, iterator) => {
	const smallestBreakpoint = breakpoints.keys[0];
	if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index) => {
		iterator((responsiveStyles, style) => {
			if (index <= breakpoints.keys.length - 1) {
				if (index === 0) Object.assign(responsiveStyles, style);
				else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
			}
		}, breakpointValue);
	});
	else if (responsive && typeof responsive === "object") (Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : filterBreakpointKeys(breakpoints.keys, Object.keys(responsive))).forEach((key) => {
		if (breakpoints.keys.includes(key)) {
			const breakpointValue = responsive[key];
			if (breakpointValue !== void 0) iterator((responsiveStyles, style) => {
				if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
				else responsiveStyles[breakpoints.up(key)] = style;
			}, breakpointValue);
		}
	});
	else if (typeof responsive === "number" || typeof responsive === "string") iterator((responsiveStyles, style) => {
		Object.assign(responsiveStyles, style);
	}, responsive);
};
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/Grid/gridGenerator.mjs
function getSelfSpacingVar(axis) {
	return `--Grid-${axis}Spacing`;
}
function getParentSpacingVar(axis) {
	return `--Grid-parent-${axis}Spacing`;
}
const selfColumnsVar = "--Grid-columns";
const parentColumnsVar = "--Grid-parent-columns";
const generateGridSizeStyles = ({ theme, ownerState }) => {
	const styles = {};
	traverseBreakpoints(theme.breakpoints, ownerState.size, (appendStyle, value) => {
		let style = {};
		if (value === "grow") style = {
			flexBasis: 0,
			flexGrow: 1,
			maxWidth: "100%"
		};
		if (value === "auto") style = {
			flexBasis: "auto",
			flexGrow: 0,
			flexShrink: 0,
			maxWidth: "none",
			width: "auto"
		};
		if (typeof value === "number") style = {
			flexGrow: 0,
			flexBasis: "auto",
			width: `calc(100% * ${value} / var(${parentColumnsVar}) - (var(${parentColumnsVar}) - ${value}) * (var(${getParentSpacingVar("column")}) / var(${parentColumnsVar})))`
		};
		appendStyle(styles, style);
	});
	return styles;
};
const generateGridOffsetStyles = ({ theme, ownerState }) => {
	const styles = {};
	traverseBreakpoints(theme.breakpoints, ownerState.offset, (appendStyle, value) => {
		let style = {};
		if (value === "auto") style = { marginLeft: "auto" };
		if (typeof value === "number") style = { marginLeft: value === 0 ? "0px" : `calc(100% * ${value} / var(${parentColumnsVar}) + var(${getParentSpacingVar("column")}) * ${value} / var(${parentColumnsVar}))` };
		appendStyle(styles, style);
	});
	return styles;
};
const generateGridColumnsStyles = ({ theme, ownerState }) => {
	if (!ownerState.container) return {};
	const styles = { [selfColumnsVar]: 12 };
	traverseBreakpoints(theme.breakpoints, ownerState.columns, (appendStyle, value) => {
		const columns = value ?? 12;
		appendStyle(styles, {
			[selfColumnsVar]: columns,
			"> *": { [parentColumnsVar]: columns }
		});
	});
	return styles;
};
const generateGridRowSpacingStyles = ({ theme, ownerState }) => {
	if (!ownerState.container) return {};
	const styles = {};
	traverseBreakpoints(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value) => {
		const spacing = typeof value === "string" ? value : theme.spacing?.(value);
		appendStyle(styles, {
			[getSelfSpacingVar("row")]: spacing,
			"> *": { [getParentSpacingVar("row")]: spacing }
		});
	});
	return styles;
};
const generateGridColumnSpacingStyles = ({ theme, ownerState }) => {
	if (!ownerState.container) return {};
	const styles = {};
	traverseBreakpoints(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value) => {
		const spacing = typeof value === "string" ? value : theme.spacing?.(value);
		appendStyle(styles, {
			[getSelfSpacingVar("column")]: spacing,
			"> *": { [getParentSpacingVar("column")]: spacing }
		});
	});
	return styles;
};
const generateGridDirectionStyles = ({ theme, ownerState }) => {
	if (!ownerState.container) return {};
	const styles = {};
	traverseBreakpoints(theme.breakpoints, ownerState.direction, (appendStyle, value) => {
		appendStyle(styles, { flexDirection: value });
	});
	return styles;
};
const generateGridStyles = ({ ownerState }) => {
	return {
		minWidth: 0,
		boxSizing: "border-box",
		...ownerState.container && {
			display: "flex",
			flexWrap: "wrap",
			...ownerState.wrap && ownerState.wrap !== "wrap" && { flexWrap: ownerState.wrap },
			gap: `var(${getSelfSpacingVar("row")}) var(${getSelfSpacingVar("column")})`
		}
	};
};
const generateSizeClassNames = (size) => {
	const classNames = [];
	Object.entries(size).forEach(([key, value]) => {
		if (value !== false && value !== void 0) classNames.push(`grid-${key}-${String(value)}`);
	});
	return classNames;
};
const generateSpacingClassNames = (spacing, smallestBreakpoint = "xs") => {
	function isValidSpacing(val) {
		if (val === void 0) return false;
		return typeof val === "string" && !Number.isNaN(Number(val)) || typeof val === "number" && val > 0;
	}
	if (isValidSpacing(spacing)) return [`spacing-${smallestBreakpoint}-${String(spacing)}`];
	if (typeof spacing === "object" && !Array.isArray(spacing)) {
		const classNames = [];
		Object.entries(spacing).forEach(([key, value]) => {
			if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
		});
		return classNames;
	}
	return [];
};
const generateDirectionClasses = (direction) => {
	if (direction === void 0) return [];
	if (typeof direction === "object") return Object.entries(direction).map(([key, value]) => `direction-${key}-${value}`);
	return [`direction-xs-${String(direction)}`];
};
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/Grid/createGrid.mjs
const defaultTheme$2 = createTheme();
const defaultCreateStyledComponent$1 = styled("div", {
	name: "MuiGrid",
	slot: "Root"
});
function useThemePropsDefault$1(props) {
	return useThemeProps({
		props,
		name: "MuiGrid",
		defaultTheme: defaultTheme$2
	});
}
function createGrid(options = {}) {
	const { createStyledComponent = defaultCreateStyledComponent$1, useThemeProps = useThemePropsDefault$1, useTheme = useTheme$3, componentName = "MuiGrid" } = options;
	const useUtilityClasses = (ownerState, theme) => {
		const { container, direction, spacing, wrap, size } = ownerState;
		const slots = { root: [
			"root",
			container && "container",
			wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
			...generateDirectionClasses(direction),
			...generateSizeClassNames(size),
			...container ? generateSpacingClassNames(spacing, theme.breakpoints.keys[0]) : []
		] };
		return composeClasses(slots, (slot) => generateUtilityClass(componentName, slot), {});
	};
	function parseResponsiveProp(propValue, breakpoints, shouldUseValue = () => true) {
		const parsedProp = {};
		if (propValue === null) return parsedProp;
		if (Array.isArray(propValue)) propValue.forEach((value, index) => {
			if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
		});
		else if (typeof propValue === "object") Object.keys(propValue).forEach((key) => {
			const value = propValue[key];
			if (value !== null && value !== void 0 && shouldUseValue(value)) parsedProp[key] = value;
		});
		else parsedProp[breakpoints.keys[0]] = propValue;
		return parsedProp;
	}
	const GridRoot = createStyledComponent(generateGridColumnsStyles, generateGridColumnSpacingStyles, generateGridRowSpacingStyles, generateGridSizeStyles, generateGridDirectionStyles, generateGridStyles, generateGridOffsetStyles);
	const Grid = /*#__PURE__*/ React$1.forwardRef(function Grid(inProps, ref) {
		const theme = useTheme();
		const props = useThemeProps(inProps);
		const { className, children, columns: columnsProp = 12, container = false, component = "div", direction = "row", wrap = "wrap", size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
		const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val) => val !== false);
		const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
		const columns = inProps.columns ?? (level ? void 0 : columnsProp);
		const spacing = inProps.spacing ?? (level ? void 0 : spacingProp);
		const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? void 0 : rowSpacingProp);
		const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? void 0 : columnSpacingProp);
		const ownerState = {
			...props,
			level,
			columns,
			container,
			direction,
			wrap,
			spacing,
			rowSpacing,
			columnSpacing,
			size,
			offset
		};
		const classes = useUtilityClasses(ownerState, theme);
		return /*#__PURE__*/ jsx(GridRoot, {
			ref,
			as: component,
			ownerState,
			className: clsx(classes.root, className),
			...other,
			children: React$1.Children.map(children, (child) => {
				if (/*#__PURE__*/ React$1.isValidElement(child) && isMuiElement(child, ["Grid"]) && container && child.props.container) return /*#__PURE__*/ React$1.cloneElement(child, { unstable_level: child.props?.unstable_level ?? level + 1 });
				return child;
			})
		});
	});
	Grid.propTypes = {
		children: import_prop_types.default.node,
		className: import_prop_types.default.string,
		columns: import_prop_types.default.oneOfType([
			import_prop_types.default.arrayOf(import_prop_types.default.number),
			import_prop_types.default.number,
			import_prop_types.default.object
		]),
		columnSpacing: import_prop_types.default.oneOfType([
			import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string])),
			import_prop_types.default.number,
			import_prop_types.default.object,
			import_prop_types.default.string
		]),
		component: import_prop_types.default.elementType,
		container: import_prop_types.default.bool,
		direction: import_prop_types.default.oneOfType([
			import_prop_types.default.oneOf([
				"column-reverse",
				"column",
				"row-reverse",
				"row"
			]),
			import_prop_types.default.arrayOf(import_prop_types.default.oneOf([
				"column-reverse",
				"column",
				"row-reverse",
				"row"
			])),
			import_prop_types.default.object
		]),
		offset: import_prop_types.default.oneOfType([
			import_prop_types.default.string,
			import_prop_types.default.number,
			import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.number])),
			import_prop_types.default.object
		]),
		rowSpacing: import_prop_types.default.oneOfType([
			import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string])),
			import_prop_types.default.number,
			import_prop_types.default.object,
			import_prop_types.default.string
		]),
		size: import_prop_types.default.oneOfType([
			import_prop_types.default.string,
			import_prop_types.default.bool,
			import_prop_types.default.number,
			import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
				import_prop_types.default.string,
				import_prop_types.default.bool,
				import_prop_types.default.number
			])),
			import_prop_types.default.object
		]),
		spacing: import_prop_types.default.oneOfType([
			import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string])),
			import_prop_types.default.number,
			import_prop_types.default.object,
			import_prop_types.default.string
		]),
		sx: import_prop_types.default.oneOfType([
			import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
				import_prop_types.default.func,
				import_prop_types.default.object,
				import_prop_types.default.bool
			])),
			import_prop_types.default.func,
			import_prop_types.default.object
		]),
		wrap: import_prop_types.default.oneOf([
			"nowrap",
			"wrap-reverse",
			"wrap"
		])
	};
	Grid.muiName = "Grid";
	return Grid;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+system@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-col_1750534045934c05f3f236609f7ec241/node_modules/@mui/system/Stack/createStack.mjs
const defaultTheme$1 = createTheme();
const defaultCreateStyledComponent = styled("div", {
	name: "MuiStack",
	slot: "Root"
});
function useThemePropsDefault(props) {
	return useThemeProps({
		props,
		name: "MuiStack",
		defaultTheme: defaultTheme$1
	});
}
/**
* Return an array with the separator React element interspersed between
* each React node of the input children.
*
* > joinChildren([1,2,3], 0)
* [1,0,2,0,3]
*/
function joinChildren(children, separator) {
	const childrenArray = React$1.Children.toArray(children).filter(Boolean);
	return childrenArray.reduce((output, child, index) => {
		output.push(child);
		if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ React$1.cloneElement(separator, { key: `separator-${index}` }));
		return output;
	}, []);
}
const getSideFromDirection = (direction) => {
	return {
		row: "Left",
		"row-reverse": "Right",
		column: "Top",
		"column-reverse": "Bottom"
	}[direction];
};
const style = ({ ownerState, theme }) => {
	let styles = {
		display: "flex",
		flexDirection: "column",
		...handleBreakpoints({ theme }, resolveBreakpointValues({
			values: ownerState.direction,
			breakpoints: theme.breakpoints.values
		}), (propValue) => ({ flexDirection: propValue }))
	};
	if (ownerState.spacing) {
		const transformer = createUnarySpacing(theme);
		const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint) => {
			if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
			return acc;
		}, {});
		const directionValues = resolveBreakpointValues({
			values: ownerState.direction,
			base
		});
		const spacingValues = resolveBreakpointValues({
			values: ownerState.spacing,
			base
		});
		if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints) => {
			if (!directionValues[breakpoint]) {
				const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
				directionValues[breakpoint] = previousDirectionValue;
			}
		});
		const styleFromPropValue = (propValue, breakpoint) => {
			if (ownerState.useFlexGap) return { gap: getValue(transformer, propValue) };
			return {
				"& > :not(style):not(style)": { margin: 0 },
				"& > :not(style) ~ :not(style)": { [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: getValue(transformer, propValue) }
			};
		};
		styles = deepmerge(styles, handleBreakpoints({ theme }, spacingValues, styleFromPropValue));
	}
	styles = mergeBreakpointsInOrder(theme.breakpoints, styles);
	return styles;
};
function createStack(options = {}) {
	const { createStyledComponent = defaultCreateStyledComponent, useThemeProps = useThemePropsDefault, componentName = "MuiStack" } = options;
	const useUtilityClasses = () => {
		return composeClasses({ root: ["root"] }, (slot) => generateUtilityClass(componentName, slot), {});
	};
	const StackRoot = createStyledComponent(style);
	const Stack = /*#__PURE__*/ React$1.forwardRef(function Grid(inProps, ref) {
		const { component = "div", direction = "column", spacing = 0, divider, children, className, useFlexGap = false, ...other } = useThemeProps(inProps);
		const ownerState = {
			direction,
			spacing,
			useFlexGap
		};
		const classes = useUtilityClasses();
		return /*#__PURE__*/ jsx(StackRoot, {
			as: component,
			ownerState,
			ref,
			className: clsx(classes.root, className),
			...other,
			children: divider ? joinChildren(children, divider) : children
		});
	});
	Stack.propTypes = {
		children: import_prop_types.default.node,
		direction: import_prop_types.default.oneOfType([
			import_prop_types.default.oneOf([
				"column-reverse",
				"column",
				"row-reverse",
				"row"
			]),
			import_prop_types.default.arrayOf(import_prop_types.default.oneOf([
				"column-reverse",
				"column",
				"row-reverse",
				"row"
			])),
			import_prop_types.default.object
		]),
		divider: import_prop_types.default.node,
		spacing: import_prop_types.default.oneOfType([
			import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string])),
			import_prop_types.default.number,
			import_prop_types.default.object,
			import_prop_types.default.string
		]),
		sx: import_prop_types.default.oneOfType([
			import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
				import_prop_types.default.func,
				import_prop_types.default.object,
				import_prop_types.default.bool
			])),
			import_prop_types.default.func,
			import_prop_types.default.object
		])
	};
	return Stack;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/styles/useTheme.mjs
function useTheme$1() {
	const theme = useTheme$3(defaultTheme$4);
	React$1.useDebugValue(theme);
	return theme["$$material"] || theme;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/GlobalStyles/GlobalStyles.mjs
function GlobalStyles(props) {
	return /*#__PURE__*/ jsx(GlobalStyles$1, {
		...props,
		defaultTheme: defaultTheme$4,
		themeId: identifier_default
	});
}
GlobalStyles.propTypes = { 
/**
* The styles you want to apply globally.
*/
styles: import_prop_types.default.oneOfType([
	import_prop_types.default.array,
	import_prop_types.default.func,
	import_prop_types.default.number,
	import_prop_types.default.object,
	import_prop_types.default.string,
	import_prop_types.default.bool
]) };
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/zero-styled/index.mjs
function globalCss(styles) {
	return function GlobalStylesWrapper(props) {
		return /*#__PURE__*/ jsx(GlobalStyles, { styles: typeof styles === "function" ? (theme) => styles({
			theme,
			...props
		}) : styles });
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/debounce/debounce.mjs
function debounce$1(func, wait = 166) {
	let timeout;
	function debounced(...args) {
		const later = () => {
			func.apply(this, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	}
	debounced.clear = () => {
		clearTimeout(timeout);
	};
	return debounced;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/debounce.mjs
var debounce_default = debounce$1;
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/isMuiElement.mjs
var isMuiElement_default = isMuiElement;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/getActiveElement/getActiveElement.mjs
/**
* Gets the actual active element, traversing through shadow roots if necessary.
*
* When an element inside a shadow root has focus, `document.activeElement` returns
* the shadow host element. This function recursively traverses shadow roots to find
* the actual focused element.
*
* @param root - The document or shadow root to start the search from.
* @returns The actual focused element, or null if no element has focus.
*
* @example
* // In a shadow DOM context
* const activeElement = getActiveElement(document);
* // Returns the actual focused element inside the shadow root
*
* @example
* // Starting from a specific document
* const activeElement = getActiveElement(ownerDocument(element));
*/
function activeElement(doc) {
	let element = doc.activeElement;
	while (element?.shadowRoot?.activeElement != null) element = element.shadowRoot.activeElement;
	return element;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/getActiveElement.mjs
var getActiveElement_default = activeElement;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/ownerDocument/ownerDocument.mjs
function ownerDocument(node) {
	return node && node.ownerDocument || document;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/ownerDocument.mjs
var ownerDocument_default = ownerDocument;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/ownerWindow/ownerWindow.mjs
function ownerWindow(node) {
	return ownerDocument(node).defaultView || window;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/ownerWindow.mjs
var ownerWindow_default = ownerWindow;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/requirePropFactory/requirePropFactory.mjs
function requirePropFactory(componentNameInError, Component) {
	const prevPropTypes = Component ? { ...Component.propTypes } : null;
	const requireProp = (requiredProp) => (props, propName, componentName, location, propFullName, ...args) => {
		const propFullNameSafe = propFullName || propName;
		const defaultTypeChecker = prevPropTypes?.[propFullNameSafe];
		if (defaultTypeChecker) {
			const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
			if (typeCheckerResult) return typeCheckerResult;
		}
		if (typeof props[propName] !== "undefined" && !props[requiredProp]) return /* @__PURE__ */ new Error(`The prop \`${propFullNameSafe}\` of \`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
		return null;
	};
	return requireProp;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/requirePropFactory.mjs
var requirePropFactory_default = requirePropFactory;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/setRef/setRef.mjs
/**
* TODO v5: consider making it private
*
* passes {value} to {ref}
*
* WARNING: Be sure to only call this inside a callback that is passed as a ref.
* Otherwise, make sure to cleanup the previous {ref} if it changes. See
* https://github.com/mui/material-ui/issues/13539
*
* Useful if you want to expose the ref of an inner component to the public API
* while still using it inside the component.
* @param ref A ref callback or ref object. If anything falsy, this is a no-op.
*/
function setRef(ref, value) {
	if (typeof ref === "function") ref(value);
	else if (ref) ref.current = value;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/useEnhancedEffect.mjs
var useEnhancedEffect_default = useEnhancedEffect;
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/useId.mjs
var useId_default = useId;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/unsupportedProp/unsupportedProp.mjs
function unsupportedProp(props, propName, componentName, location, propFullName) {
	const propFullNameSafe = propFullName || propName;
	if (typeof props[propName] !== "undefined") return /* @__PURE__ */ new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
	return null;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/unsupportedProp.mjs
var unsupportedProp_default = unsupportedProp;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useControlled/useControlled.mjs
function useControlled(props) {
	const { controlled, default: defaultProp, name, state = "value" } = props;
	const { current: isControlled } = React$1.useRef(controlled !== void 0);
	const [valueState, setValue] = React$1.useState(defaultProp);
	const value = isControlled ? controlled : valueState;
	{
		React$1.useEffect(() => {
			if (isControlled !== (controlled !== void 0)) console.error([
				`MUI: A component is changing the ${isControlled ? "" : "un"}controlled ${state} state of ${name} to be ${isControlled ? "un" : ""}controlled.`,
				"Elements should not switch from uncontrolled to controlled (or vice versa).",
				`Decide between using a controlled or uncontrolled ${name} element for the lifetime of the component.`,
				"The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
				"More info: https://fb.me/react-controlled-components"
			].join("\n"));
		}, [
			state,
			name,
			controlled
		]);
		const { current: defaultValue } = React$1.useRef(defaultProp);
		React$1.useEffect(() => {
			if (!isControlled && JSON.stringify(defaultProp) !== JSON.stringify(defaultValue)) console.error([`MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. To suppress this warning opt to use a controlled ${name}.`].join("\n"));
		}, [JSON.stringify(defaultProp)]);
	}
	return [value, React$1.useCallback((newValue) => {
		if (!isControlled) setValue(newValue);
	}, [])];
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/useControlled.mjs
var useControlled_default = useControlled;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useEventCallback/useEventCallback.mjs
/**
* Inspired by https://github.com/react/react/issues/14099#issuecomment-440013892
* See RFC in https://github.com/reactjs/rfcs/pull/220
*/
function useEventCallback(fn) {
	const ref = React$1.useRef(fn);
	useEnhancedEffect(() => {
		ref.current = fn;
	});
	return React$1.useRef((...args) => (0, ref.current)(...args)).current;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/useEventCallback.mjs
var useEventCallback_default = useEventCallback;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useForkRef/useForkRef.mjs
/**
* Merges refs into a single memoized callback ref or `null`.
*
* ```tsx
* const rootRef = React.useRef<Instance>(null);
* const refFork = useForkRef(rootRef, props.ref);
*
* return (
*   <Root {...props} ref={refFork} />
* );
* ```
*
* @param {Array<React.Ref<Instance> | undefined>} refs The ref array.
* @returns {React.RefCallback<Instance> | null} The new ref callback.
*/
function useForkRef(...refs) {
	const cleanupRef = React$1.useRef(void 0);
	const refEffect = React$1.useCallback((instance) => {
		const cleanups = refs.map((ref) => {
			if (ref == null) return null;
			if (typeof ref === "function") {
				const refCallback = ref;
				const refCleanup = refCallback(instance);
				return typeof refCleanup === "function" ? refCleanup : () => {
					refCallback(null);
				};
			}
			ref.current = instance;
			return () => {
				ref.current = null;
			};
		});
		return () => {
			cleanups.forEach((refCleanup) => refCleanup?.());
		};
	}, refs);
	return React$1.useMemo(() => {
		if (refs.every((ref) => ref == null)) return null;
		return (value) => {
			if (cleanupRef.current) {
				cleanupRef.current();
				cleanupRef.current = void 0;
			}
			if (value != null) cleanupRef.current = refEffect(value);
		};
	}, refs);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/useForkRef.mjs
var useForkRef_default = useForkRef;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/isEventHandler/isEventHandler.mjs
function isEventHandler(key, value) {
	const thirdCharCode = key.charCodeAt(2);
	return key[0] === "o" && key[1] === "n" && thirdCharCode >= 65 && thirdCharCode <= 90 && typeof value === "function";
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/mergeSlotProps.mjs
function mergeSlotProps$1(externalSlotProps, defaultSlotProps) {
	if (!externalSlotProps) return defaultSlotProps;
	function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
		const handlers = {};
		Object.keys(defaultSlotPropsValue).forEach((key) => {
			if (isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === "function") handlers[key] = (...args) => {
				externalSlotPropsValue[key](...args);
				defaultSlotPropsValue[key](...args);
			};
		});
		return handlers;
	}
	if (typeof externalSlotProps === "function" || typeof defaultSlotProps === "function") return (ownerState) => {
		const defaultSlotPropsValue = typeof defaultSlotProps === "function" ? defaultSlotProps(ownerState) : defaultSlotProps;
		const externalSlotPropsValue = typeof externalSlotProps === "function" ? externalSlotProps({
			...ownerState,
			...defaultSlotPropsValue
		}) : externalSlotProps;
		const className = clsx(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
		const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
		return {
			...defaultSlotPropsValue,
			...externalSlotPropsValue,
			...handlers,
			...!!className && { className },
			...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && { style: {
				...defaultSlotPropsValue.style,
				...externalSlotPropsValue.style
			} },
			...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && { sx: [...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [defaultSlotPropsValue.sx], ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [externalSlotPropsValue.sx]] }
		};
	};
	const typedDefaultSlotProps = defaultSlotProps;
	const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
	const className = clsx(typedDefaultSlotProps?.className, externalSlotProps?.className);
	return {
		...defaultSlotProps,
		...externalSlotProps,
		...handlers,
		...!!className && { className },
		...typedDefaultSlotProps?.style && externalSlotProps?.style && { style: {
			...typedDefaultSlotProps.style,
			...externalSlotProps.style
		} },
		...typedDefaultSlotProps?.sx && externalSlotProps?.sx && { sx: [...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [typedDefaultSlotProps.sx], ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [externalSlotProps.sx]] }
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Checkbox/checkboxClasses.mjs
function getCheckboxUtilityClass(slot) {
	return generateUtilityClass("MuiCheckbox", slot);
}
const checkboxClasses = generateUtilityClasses("MuiCheckbox", [
	"root",
	"checked",
	"disabled",
	"indeterminate",
	"colorPrimary",
	"colorSecondary",
	"sizeSmall",
	"sizeMedium"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/chainPropTypes/chainPropTypes.mjs
function chainPropTypes(propType1, propType2) {
	return function validate(...args) {
		return propType1(...args) || propType2(...args);
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/elementTypeAcceptingRef/elementTypeAcceptingRef.mjs
function isClassComponent$1(elementType) {
	const { prototype = {} } = elementType;
	return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
	const propValue = props[propName];
	const safePropName = propFullName || propName;
	if (propValue == null || typeof window === "undefined") return null;
	let warningHint;
	/**
	* Blacklisting instead of whitelisting
	*
	* Blacklisting will miss some components, such as React.Fragment. Those will at least
	* trigger a warning in React.
	* We can't whitelist because there is no safe way to detect React.forwardRef
	* or class components. "Safe" means there's no public API.
	*
	*/
	if (typeof propValue === "function" && !isClassComponent$1(propValue)) warningHint = "Did you accidentally provide a plain function component instead?";
	if (propValue === React$1.Fragment) warningHint = "Did you accidentally provide a React.Fragment instead?";
	if (warningHint !== void 0) return /* @__PURE__ */ new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. Expected an element type that can hold a ref. ${warningHint} For more information see https://mui.com/r/caveat-with-refs-guide`);
	return null;
}
var elementTypeAcceptingRef_default = chainPropTypes(import_prop_types.default.elementType, elementTypeAcceptingRef);
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/refType/refType.mjs
const refType = import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]);
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/isHostComponent/isHostComponent.mjs
/**
* Determines if a given element is a DOM element name (i.e. not a React component).
*/
function isHostComponent(element) {
	return typeof element === "string";
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TextareaAutosize/TextareaAutosize.mjs
function getStyleValue(value) {
	return parseInt(value, 10) || 0;
}
const styles$3 = { shadow: {
	visibility: "hidden",
	position: "absolute",
	overflow: "hidden",
	height: 0,
	top: 0,
	left: 0,
	transform: "translateZ(0)"
} };
function isObjectEmpty(object) {
	for (const _ in object) return false;
	return true;
}
function isEmpty$1(obj) {
	return isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
*
* Demos:
*
* - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
*
* API:
*
* - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
*/
const TextareaAutosize = /*#__PURE__*/ React$1.forwardRef(function TextareaAutosize(props, forwardedRef) {
	const { onChange, maxRows, minRows = 1, style, value, ...other } = props;
	const { current: isControlled } = React$1.useRef(value != null);
	const textareaRef = React$1.useRef(null);
	const handleRef = useForkRef(forwardedRef, textareaRef);
	const heightRef = React$1.useRef(null);
	const hiddenTextareaRef = React$1.useRef(null);
	const calculateTextareaStyles = React$1.useCallback(() => {
		const textarea = textareaRef.current;
		const hiddenTextarea = hiddenTextareaRef.current;
		if (!textarea || !hiddenTextarea) return;
		const computedStyle = ownerWindow(textarea).getComputedStyle(textarea);
		if (computedStyle.width === "0px") return {
			outerHeightStyle: 0,
			overflowing: false
		};
		hiddenTextarea.style.width = computedStyle.width;
		hiddenTextarea.value = textarea.value || props.placeholder || "x";
		if (hiddenTextarea.value.slice(-1) === "\n") hiddenTextarea.value += " ";
		const boxSizing = computedStyle.boxSizing;
		const padding = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
		const border = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);
		const innerHeight = hiddenTextarea.scrollHeight;
		hiddenTextarea.value = "x";
		const singleRowHeight = hiddenTextarea.scrollHeight;
		let outerHeight = innerHeight;
		if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
		if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
		outerHeight = Math.max(outerHeight, singleRowHeight);
		return {
			outerHeightStyle: outerHeight + (boxSizing === "border-box" ? padding + border : 0),
			overflowing: Math.abs(outerHeight - innerHeight) <= 1
		};
	}, [
		maxRows,
		minRows,
		props.placeholder
	]);
	const didHeightChange = useEventCallback(() => {
		const textarea = textareaRef.current;
		const textareaStyles = calculateTextareaStyles();
		if (!textarea || !textareaStyles || isEmpty$1(textareaStyles)) return false;
		const outerHeightStyle = textareaStyles.outerHeightStyle;
		return heightRef.current != null && heightRef.current !== outerHeightStyle;
	});
	const syncHeight = React$1.useCallback(() => {
		const textarea = textareaRef.current;
		const textareaStyles = calculateTextareaStyles();
		if (!textarea || !textareaStyles || isEmpty$1(textareaStyles)) return;
		const outerHeightStyle = textareaStyles.outerHeightStyle;
		if (heightRef.current !== outerHeightStyle) {
			heightRef.current = outerHeightStyle;
			textarea.style.height = `${outerHeightStyle}px`;
		}
		textarea.style.overflow = textareaStyles.overflowing ? "hidden" : "";
	}, [calculateTextareaStyles]);
	const frameRef = React$1.useRef(-1);
	useEnhancedEffect(() => {
		const debouncedHandleResize = debounce$1(syncHeight);
		const textarea = textareaRef?.current;
		if (!textarea) return;
		const containerWindow = ownerWindow(textarea);
		containerWindow.addEventListener("resize", debouncedHandleResize);
		let resizeObserver;
		if (typeof ResizeObserver !== "undefined") {
			resizeObserver = new ResizeObserver(() => {
				if (didHeightChange()) {
					resizeObserver.unobserve(textarea);
					cancelAnimationFrame(frameRef.current);
					syncHeight();
					frameRef.current = requestAnimationFrame(() => {
						resizeObserver.observe(textarea);
					});
				}
			});
			resizeObserver.observe(textarea);
		}
		return () => {
			debouncedHandleResize.clear();
			cancelAnimationFrame(frameRef.current);
			containerWindow.removeEventListener("resize", debouncedHandleResize);
			if (resizeObserver) resizeObserver.disconnect();
		};
	}, [
		calculateTextareaStyles,
		syncHeight,
		didHeightChange
	]);
	useEnhancedEffect(() => {
		syncHeight();
	});
	const handleChange = (event) => {
		if (!isControlled) syncHeight();
		const textarea = event.target;
		const countOfCharacters = textarea.value.length;
		const isLastCharacterNewLine = textarea.value.endsWith("\n");
		const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
		if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
		if (onChange) onChange(event);
	};
	return /*#__PURE__*/ jsxs(React$1.Fragment, { children: [/*#__PURE__*/ jsx("textarea", {
		value,
		onChange: handleChange,
		ref: handleRef,
		rows: minRows,
		style,
		...other
	}), /*#__PURE__*/ jsx("textarea", {
		"aria-hidden": true,
		className: props.className,
		readOnly: true,
		ref: hiddenTextareaRef,
		tabIndex: -1,
		style: {
			...styles$3.shadow,
			...style,
			paddingTop: 0,
			paddingBottom: 0
		}
	})] });
});
TextareaAutosize.propTypes = {
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* Maximum number of rows to display.
	*/
	maxRows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* Minimum number of rows to display.
	* @default 1
	*/
	minRows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* @ignore
	*/
	onChange: import_prop_types.default.func,
	/**
	* @ignore
	*/
	placeholder: import_prop_types.default.string,
	/**
	* @ignore
	*/
	style: import_prop_types.default.object,
	/**
	* @ignore
	*/
	value: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.string),
		import_prop_types.default.number,
		import_prop_types.default.string
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormControl/FormControlContext.mjs
/**
* @ignore - internal component.
*/
const FormControlContext = /*#__PURE__*/ React$1.createContext(void 0);
FormControlContext.displayName = "FormControlContext";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormControl/useFormControl.mjs
function useFormControl() {
	return React$1.useContext(FormControlContext);
}
function useFormControlState({ props, states }) {
	const muiFormControl = React$1.useContext(FormControlContext);
	const result = {};
	states.forEach((state) => {
		const value = props[state];
		result[state] = value === void 0 && muiFormControl ? muiFormControl[state] : value;
	});
	return [result, muiFormControl];
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/InputBase/utils.mjs
function hasValue(value) {
	return value != null && !(Array.isArray(value) && value.length === 0);
}
function isFilled(obj, SSR = false) {
	return obj && (hasValue(obj.value) && obj.value !== "" || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== "");
}
function isAdornedStart(obj) {
	return obj.startAdornment;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/InputBase/inputBaseClasses.mjs
function getInputBaseUtilityClass(slot) {
	return generateUtilityClass("MuiInputBase", slot);
}
const inputBaseClasses = generateUtilityClasses("MuiInputBase", [
	"root",
	"formControl",
	"focused",
	"disabled",
	"adornedStart",
	"adornedEnd",
	"error",
	"sizeSmall",
	"multiline",
	"colorSecondary",
	"fullWidth",
	"hiddenLabel",
	"readOnly",
	"input",
	"inputTypeSearch"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/InputBase/InputBase.mjs
var _InputGlobalStyles;
const MUI_AUTO_FILL = "mui-auto-fill";
const MUI_AUTO_FILL_CANCEL = "mui-auto-fill-cancel";
const rootOverridesResolver = (props, styles) => {
	const { ownerState } = props;
	return [
		styles.root,
		ownerState.formControl && styles.formControl,
		ownerState.startAdornment && styles.adornedStart,
		ownerState.endAdornment && styles.adornedEnd,
		ownerState.error && styles.error,
		ownerState.size === "small" && styles.sizeSmall,
		ownerState.multiline && styles.multiline,
		ownerState.color && styles[`color${capitalize_default(ownerState.color)}`],
		ownerState.fullWidth && styles.fullWidth,
		ownerState.hiddenLabel && styles.hiddenLabel
	];
};
const inputOverridesResolver = (props, styles) => {
	const { ownerState } = props;
	return [styles.input, ownerState.type === "search" && styles.inputTypeSearch];
};
const useUtilityClasses$75 = (ownerState) => {
	const { classes, color, disabled, error, endAdornment, focused, formControl, fullWidth, hiddenLabel, multiline, readOnly, size, startAdornment, type } = ownerState;
	const slots = {
		root: [
			"root",
			`color${capitalize_default(color)}`,
			disabled && "disabled",
			error && "error",
			fullWidth && "fullWidth",
			focused && "focused",
			formControl && "formControl",
			size && size !== "medium" && `size${capitalize_default(size)}`,
			multiline && "multiline",
			startAdornment && "adornedStart",
			endAdornment && "adornedEnd",
			hiddenLabel && "hiddenLabel",
			readOnly && "readOnly"
		],
		input: [
			"input",
			disabled && "disabled",
			type === "search" && "inputTypeSearch",
			readOnly && "readOnly"
		]
	};
	return composeClasses(slots, getInputBaseUtilityClass, classes);
};
const InputBaseRoot = styled$2("div", {
	name: "MuiInputBase",
	slot: "Root",
	overridesResolver: rootOverridesResolver
})(memoTheme(({ theme }) => ({
	...theme.typography.body1,
	color: (theme.vars || theme).palette.text.primary,
	lineHeight: "1.4375em",
	boxSizing: "border-box",
	position: "relative",
	cursor: "text",
	display: "inline-flex",
	alignItems: "center",
	[`&.${inputBaseClasses.disabled}`]: {
		color: (theme.vars || theme).palette.text.disabled,
		cursor: "default"
	},
	variants: [
		{
			props: ({ ownerState }) => ownerState.multiline,
			style: { padding: "4px 0 5px" }
		},
		{
			props: ({ ownerState, size }) => ownerState.multiline && size === "small",
			style: { paddingTop: 1 }
		},
		{
			props: ({ ownerState }) => ownerState.fullWidth,
			style: { width: "100%" }
		}
	]
})));
const InputBaseInput = styled$2("input", {
	name: "MuiInputBase",
	slot: "Input",
	overridesResolver: inputOverridesResolver
})(memoTheme(({ theme }) => {
	const light = theme.palette.mode === "light";
	const placeholder = {
		color: "currentColor",
		...theme.vars ? { opacity: theme.vars.opacity.inputPlaceholder } : { opacity: light ? .42 : .5 },
		...getTransitionStyles(theme, "opacity", { duration: theme.transitions.duration.shorter })
	};
	const placeholderHidden = { opacity: "0 !important" };
	const placeholderVisible = theme.vars ? { opacity: theme.vars.opacity.inputPlaceholder } : { opacity: light ? .42 : .5 };
	return {
		font: "inherit",
		letterSpacing: "inherit",
		color: "currentColor",
		padding: "4px 0 5px",
		border: 0,
		boxSizing: "content-box",
		background: "none",
		height: "1.4375em",
		margin: 0,
		WebkitTapHighlightColor: "transparent",
		display: "block",
		minWidth: 0,
		width: "100%",
		"&::-webkit-input-placeholder": placeholder,
		"&::-moz-placeholder": placeholder,
		"&::-ms-input-placeholder": placeholder,
		"&:focus": { outline: 0 },
		"&:invalid": { boxShadow: "none" },
		"&::-webkit-search-decoration": { WebkitAppearance: "none" },
		[`label[data-shrink=false] + .${inputBaseClasses.formControl} &`]: {
			"&::-webkit-input-placeholder": placeholderHidden,
			"&::-moz-placeholder": placeholderHidden,
			"&::-ms-input-placeholder": placeholderHidden,
			"&:focus::-webkit-input-placeholder": placeholderVisible,
			"&:focus::-moz-placeholder": placeholderVisible,
			"&:focus::-ms-input-placeholder": placeholderVisible
		},
		[`&.${inputBaseClasses.disabled}`]: {
			opacity: 1,
			WebkitTextFillColor: (theme.vars || theme).palette.text.disabled
		},
		variants: [
			{
				props: ({ ownerState }) => !ownerState.disableInjectingGlobalStyles,
				style: {
					animationName: MUI_AUTO_FILL_CANCEL,
					animationDuration: "10ms",
					"&:-webkit-autofill": {
						animationDuration: "5000s",
						animationName: MUI_AUTO_FILL
					}
				}
			},
			{
				props: { size: "small" },
				style: { paddingTop: 1 }
			},
			{
				props: ({ ownerState }) => ownerState.multiline,
				style: {
					height: "auto",
					resize: "none",
					padding: 0,
					paddingTop: 0
				}
			},
			{
				props: { type: "search" },
				style: { MozAppearance: "textfield" }
			}
		]
	};
}));
const InputGlobalStyles = globalCss({
	[`@keyframes ${MUI_AUTO_FILL}`]: { from: { animationName: MUI_AUTO_FILL } },
	[`@keyframes ${MUI_AUTO_FILL_CANCEL}`]: { from: { animationName: MUI_AUTO_FILL_CANCEL } }
});
/**
* `InputBase` contains as few styles as possible.
* It aims to be a simple building block for creating an input.
* It contains a load of style reset and some state logic.
*/
const InputBase = /*#__PURE__*/ React$1.forwardRef(function InputBase(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiInputBase"
	});
	const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoComplete, autoFocus, className, color, defaultValue, disabled, disableInjectingGlobalStyles, endAdornment, error, fullWidth = false, id, inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin, maxRows, minRows, multiline = false, name, onBlur, onChange, onClick, onFocus, onKeyDown, onKeyUp, placeholder, readOnly, renderSuffix, rows, size, slotProps = {}, slots = {}, startAdornment, type = "text", value: valueProp, ...other } = props;
	const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
	const { current: isControlled } = React$1.useRef(value != null);
	const inputRef = React$1.useRef();
	const handleInputRefWarning = React$1.useCallback((instance) => {
		if (instance && instance.nodeName !== "INPUT" && !instance.focus) console.error([
			"MUI: You have provided a `inputComponent` to the input component",
			"that does not correctly handle the `ref` prop.",
			"Make sure the `ref` prop is called with a HTMLInputElement."
		].join("\n"));
	}, []);
	const handleInputRef = useForkRef_default(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
	const [focused, setFocused] = React$1.useState(false);
	const [fcs, muiFormControl] = useFormControlState({
		props,
		states: [
			"color",
			"disabled",
			"error",
			"hiddenLabel",
			"size",
			"required",
			"filled"
		]
	});
	React$1.useEffect(() => {
		if (muiFormControl) return muiFormControl.registerEffect();
	}, [muiFormControl]);
	fcs.focused = muiFormControl ? muiFormControl.focused : focused;
	React$1.useEffect(() => {
		if (!muiFormControl && disabled && focused) {
			setFocused(false);
			if (onBlur) onBlur();
		}
	}, [
		muiFormControl,
		disabled,
		focused,
		onBlur
	]);
	const onFilled = muiFormControl && muiFormControl.onFilled;
	const onEmpty = muiFormControl && muiFormControl.onEmpty;
	const checkDirty = React$1.useCallback((obj) => {
		if (isFilled(obj)) {
			if (onFilled) onFilled();
		} else if (onEmpty) onEmpty();
	}, [onFilled, onEmpty]);
	useEnhancedEffect_default(() => {
		if (isControlled) checkDirty({ value });
	}, [
		value,
		checkDirty,
		isControlled
	]);
	useEnhancedEffect_default(() => {
		if (!autoFocus) return;
		const input = inputRef.current;
		if (!input) return;
		const doc = ownerDocument_default(input);
		const activeElement = getActiveElement_default(doc);
		const noElementFocused = activeElement == null || activeElement === doc.body || activeElement === doc.documentElement;
		if (input === activeElement) {
			if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus();
			else setFocused(true);
		} else if (noElementFocused) input.focus();
	}, [autoFocus]);
	const handleFocus = (event) => {
		if (onFocus) onFocus(event);
		if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
		if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
		else setFocused(true);
	};
	const handleBlur = (event) => {
		if (onBlur) onBlur(event);
		if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
		if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
		else setFocused(false);
	};
	const handleChange = (event, ...args) => {
		if (!isControlled) {
			const element = event.target || inputRef.current;
			if (element == null) throw new Error("MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info.");
			checkDirty({ value: element.value });
		}
		if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
		if (onChange) onChange(event, ...args);
	};
	React$1.useEffect(() => {
		checkDirty(inputRef.current);
	}, []);
	const handleClick = (event) => {
		if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
		if (onClick) onClick(event);
	};
	let InputComponent = inputComponent;
	let inputProps = inputPropsProp;
	if (multiline && InputComponent === "input") {
		if (rows) {
			if (minRows || maxRows) console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set.");
			inputProps = {
				type: void 0,
				minRows: rows,
				maxRows: rows,
				...inputProps
			};
		} else inputProps = {
			type: void 0,
			maxRows,
			minRows,
			...inputProps
		};
		InputComponent = TextareaAutosize;
	}
	const handleAutoFill = (event) => {
		checkDirty(event.animationName === MUI_AUTO_FILL_CANCEL ? inputRef.current : { value: "x" });
	};
	React$1.useEffect(() => {
		if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
	}, [muiFormControl, startAdornment]);
	const ownerState = {
		...props,
		color: fcs.color || "primary",
		disabled: fcs.disabled,
		endAdornment,
		error: fcs.error,
		focused: fcs.focused,
		formControl: muiFormControl,
		fullWidth,
		hiddenLabel: fcs.hiddenLabel,
		multiline,
		size: fcs.size,
		startAdornment,
		type
	};
	const classes = useUtilityClasses$75(ownerState);
	const Root = slots.root || InputBaseRoot;
	const rootProps = slotProps.root || {};
	const Input = slots.input || InputBaseInput;
	inputProps = {
		...inputProps,
		...slotProps.input
	};
	return /*#__PURE__*/ jsxs(React$1.Fragment, { children: [!disableInjectingGlobalStyles && typeof InputGlobalStyles === "function" && (_InputGlobalStyles || (_InputGlobalStyles = /*#__PURE__*/ jsx(InputGlobalStyles, {}))), /*#__PURE__*/ jsxs(Root, {
		...rootProps,
		ref,
		onClick: handleClick,
		...other,
		...!isHostComponent(Root) && { ownerState: {
			...ownerState,
			...rootProps.ownerState
		} },
		className: clsx(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
		children: [
			startAdornment,
			/*#__PURE__*/ jsx(FormControlContext.Provider, {
				value: null,
				children: /*#__PURE__*/ jsx(Input, {
					"aria-invalid": fcs.error,
					"aria-describedby": ariaDescribedby,
					"aria-label": ariaLabel,
					autoComplete,
					autoFocus,
					defaultValue,
					disabled: fcs.disabled,
					id,
					onAnimationStart: handleAutoFill,
					name,
					placeholder,
					readOnly,
					required: fcs.required,
					rows,
					value,
					onKeyDown,
					onKeyUp,
					type,
					...inputProps,
					...!isHostComponent(Input) && {
						as: InputComponent,
						ownerState: {
							...ownerState,
							...inputProps.ownerState
						}
					},
					ref: handleInputRef,
					className: clsx(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
					onBlur: handleBlur,
					onChange: handleChange,
					onFocus: handleFocus
				})
			}),
			endAdornment,
			renderSuffix ? renderSuffix({
				...fcs,
				startAdornment
			}) : null
		]
	})] });
});
InputBase.propTypes = {
	/**
	* @ignore
	*/
	"aria-describedby": import_prop_types.default.string,
	/**
	* @ignore
	*/
	"aria-label": import_prop_types.default.string,
	/**
	* This prop helps users to fill forms faster, especially on mobile devices.
	* The name can be confusing, as it's more like an autofill.
	* You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	*/
	autoComplete: import_prop_types.default.string,
	/**
	* If `true`, the `input` element is focused during the first mount.
	*/
	autoFocus: import_prop_types.default.bool,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* The default value. Use when the component is not controlled.
	*/
	defaultValue: import_prop_types.default.any,
	/**
	* If `true`, the component is disabled.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
	* This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
	* @default false
	*/
	disableInjectingGlobalStyles: import_prop_types.default.bool,
	/**
	* End `InputAdornment` for this component.
	*/
	endAdornment: import_prop_types.default.node,
	/**
	* If `true`, the `input` will indicate an error.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	error: import_prop_types.default.bool,
	/**
	* If `true`, the `input` will take up the full width of its container.
	* @default false
	*/
	fullWidth: import_prop_types.default.bool,
	/**
	* The id of the `input` element.
	*/
	id: import_prop_types.default.string,
	/**
	* The component used for the `input` element.
	* Either a string to use a HTML element or a component.
	* @default 'input'
	*/
	inputComponent: elementTypeAcceptingRef_default,
	/**
	* [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
	* @default {}
	*/
	inputProps: import_prop_types.default.object,
	/**
	* Pass a ref to the `input` element.
	*/
	inputRef: refType,
	/**
	* If `dense`, will adjust vertical spacing. This is normally obtained via context from
	* FormControl.
	* The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
	*/
	margin: import_prop_types.default.oneOf(["dense", "none"]),
	/**
	* Maximum number of rows to display when multiline option is set to true.
	*/
	maxRows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* Minimum number of rows to display when multiline option is set to true.
	*/
	minRows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
	* @default false
	*/
	multiline: import_prop_types.default.bool,
	/**
	* Name attribute of the `input` element.
	*/
	name: import_prop_types.default.string,
	/**
	* Callback fired when the `input` is blurred.
	*
	* Notice that the first argument (event) might be undefined.
	*/
	onBlur: import_prop_types.default.func,
	/**
	* Callback fired when the value is changed.
	*
	* @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
	* You can pull out the new value by accessing `event.target.value` (string).
	*/
	onChange: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onClick: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onFocus: import_prop_types.default.func,
	/**
	* Callback fired when the `input` doesn't satisfy its constraints.
	*/
	onInvalid: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onKeyDown: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onKeyUp: import_prop_types.default.func,
	/**
	* The short hint displayed in the `input` before the user enters a value.
	*/
	placeholder: import_prop_types.default.string,
	/**
	* It prevents the user from changing the value of the field
	* (not from interacting with the field).
	*/
	readOnly: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	renderSuffix: import_prop_types.default.func,
	/**
	* If `true`, the `input` element is required.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	required: import_prop_types.default.bool,
	/**
	* Number of rows to display when multiline option is set to true.
	*/
	rows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* The size of the component.
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["medium", "small"]), import_prop_types.default.string]),
	/**
	* The extra props for the slot components.
	* You can override the existing props or add new ones.
	*
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		input: import_prop_types.default.object,
		root: import_prop_types.default.object
	}),
	/**
	* The components used for each slot inside.
	*
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		input: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* Start `InputAdornment` for this component.
	*/
	startAdornment: import_prop_types.default.node,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
	* @default 'text'
	*/
	type: import_prop_types.default.string,
	/**
	* The value of the `input` element, required for a controlled component.
	*/
	value: import_prop_types.default.any
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FilledInput/filledInputClasses.mjs
function getFilledInputUtilityClass(slot) {
	return generateUtilityClass("MuiFilledInput", slot);
}
const filledInputClasses = {
	...inputBaseClasses,
	...generateUtilityClasses("MuiFilledInput", [
		"root",
		"underline",
		"input",
		"adornedStart",
		"adornedEnd",
		"sizeSmall",
		"multiline",
		"hiddenLabel"
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormControlLabel/formControlLabelClasses.mjs
function getFormControlLabelUtilityClasses(slot) {
	return generateUtilityClass("MuiFormControlLabel", slot);
}
const formControlLabelClasses = generateUtilityClasses("MuiFormControlLabel", [
	"root",
	"labelPlacementStart",
	"labelPlacementEnd",
	"labelPlacementTop",
	"labelPlacementBottom",
	"disabled",
	"label",
	"error",
	"required",
	"asterisk"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormHelperText/formHelperTextClasses.mjs
function getFormHelperTextUtilityClasses(slot) {
	return generateUtilityClass("MuiFormHelperText", slot);
}
const formHelperTextClasses = generateUtilityClasses("MuiFormHelperText", [
	"root",
	"error",
	"disabled",
	"sizeSmall",
	"sizeMedium",
	"contained",
	"focused",
	"filled",
	"required"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormLabel/formLabelClasses.mjs
function getFormLabelUtilityClasses(slot) {
	return generateUtilityClass("MuiFormLabel", slot);
}
const formLabelClasses = generateUtilityClasses("MuiFormLabel", [
	"root",
	"colorSecondary",
	"focused",
	"disabled",
	"error",
	"filled",
	"required",
	"asterisk"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Input/inputClasses.mjs
function getInputUtilityClass(slot) {
	return generateUtilityClass("MuiInput", slot);
}
const inputClasses = {
	...inputBaseClasses,
	...generateUtilityClasses("MuiInput", [
		"root",
		"underline",
		"input"
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ListItemButton/listItemButtonClasses.mjs
function getListItemButtonUtilityClass(slot) {
	return generateUtilityClass("MuiListItemButton", slot);
}
const listItemButtonClasses = generateUtilityClasses("MuiListItemButton", [
	"root",
	"focusVisible",
	"dense",
	"alignItemsFlexStart",
	"disabled",
	"divider",
	"gutters",
	"selected"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/MenuItem/menuItemClasses.mjs
function getMenuItemUtilityClass(slot) {
	return generateUtilityClass("MuiMenuItem", slot);
}
const menuItemClasses = generateUtilityClasses("MuiMenuItem", [
	"root",
	"focusVisible",
	"dense",
	"disabled",
	"divider",
	"gutters",
	"selected"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/NativeSelect/nativeSelectClasses.mjs
function getNativeSelectUtilityClasses(slot) {
	return generateUtilityClass("MuiNativeSelect", slot);
}
const nativeSelectClasses = generateUtilityClasses("MuiNativeSelect", [
	"root",
	"select",
	"multiple",
	"filled",
	"outlined",
	"standard",
	"disabled",
	"icon",
	"iconOpen",
	"iconFilled",
	"iconOutlined",
	"iconStandard",
	"nativeInput",
	"error"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/OutlinedInput/outlinedInputClasses.mjs
function getOutlinedInputUtilityClass(slot) {
	return generateUtilityClass("MuiOutlinedInput", slot);
}
const outlinedInputClasses = {
	...inputBaseClasses,
	...generateUtilityClasses("MuiOutlinedInput", [
		"root",
		"notchedOutline",
		"input"
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Radio/radioClasses.mjs
function getRadioUtilityClass(slot) {
	return generateUtilityClass("MuiRadio", slot);
}
const radioClasses = generateUtilityClasses("MuiRadio", [
	"root",
	"checked",
	"disabled",
	"colorPrimary",
	"colorSecondary",
	"sizeSmall"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ToggleButton/toggleButtonClasses.mjs
function getToggleButtonUtilityClass(slot) {
	return generateUtilityClass("MuiToggleButton", slot);
}
const toggleButtonClasses = generateUtilityClasses("MuiToggleButton", [
	"root",
	"disabled",
	"selected",
	"standard",
	"primary",
	"secondary",
	"sizeSmall",
	"sizeMedium",
	"sizeLarge",
	"fullWidth"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/styles/cssUtils.mjs
function getUnit(input) {
	return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function toUnitless(length) {
	return parseFloat(length);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/styles/ThemeProviderNoVars.mjs
function ThemeProviderNoVars({ theme: themeInput, ...props }) {
	const scopedTheme = "$$material" in themeInput ? themeInput[identifier_default] : void 0;
	return /*#__PURE__*/ jsx(ThemeProvider$2, {
		...props,
		themeId: scopedTheme ? identifier_default : void 0,
		theme: scopedTheme || themeInput
	});
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/InitColorSchemeScript/InitColorSchemeScript.mjs
const defaultConfig = {
	attribute: "data-mui-color-scheme",
	colorSchemeStorageKey: "mui-color-scheme",
	defaultLightColorScheme: "light",
	defaultDarkColorScheme: "dark",
	modeStorageKey: "mui-mode"
};
/**
*
* Demos:
*
* - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
*
* API:
*
* - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
*/
function InitColorSchemeScript(props) {
	const { defaultMode = "system", defaultLightColorScheme = defaultConfig.defaultLightColorScheme, defaultDarkColorScheme = defaultConfig.defaultDarkColorScheme, modeStorageKey = defaultConfig.modeStorageKey, colorSchemeStorageKey = defaultConfig.colorSchemeStorageKey, attribute: initialAttribute = defaultConfig.attribute, colorSchemeNode = "document.documentElement", nonce } = props;
	return /*#__PURE__*/ jsx(InitColorSchemeScript$1, {
		defaultMode,
		defaultLightColorScheme,
		defaultDarkColorScheme,
		modeStorageKey,
		colorSchemeStorageKey,
		attribute: initialAttribute,
		colorSchemeNode,
		nonce
	});
}
InitColorSchemeScript.propTypes = {
	/**
	* DOM attribute for applying a color scheme.
	* @default 'data-mui-color-scheme'
	* @example '.mode-%s' // for class based color scheme
	* @example '[data-mode-%s]' // for data-attribute without '='
	*/
	attribute: import_prop_types.default.string,
	/**
	* The node (provided as string) used to attach the color-scheme attribute.
	* @default 'document.documentElement'
	*/
	colorSchemeNode: import_prop_types.default.string,
	/**
	* localStorage key used to store `colorScheme`.
	* @default 'mui-color-scheme'
	*/
	colorSchemeStorageKey: import_prop_types.default.string,
	/**
	* The default color scheme to be used in dark mode.
	* @default 'dark'
	*/
	defaultDarkColorScheme: import_prop_types.default.string,
	/**
	* The default color scheme to be used in light mode.
	* @default 'light'
	*/
	defaultLightColorScheme: import_prop_types.default.string,
	/**
	* The default mode when the storage is empty (user's first visit).
	* @default 'system'
	*/
	defaultMode: import_prop_types.default.oneOf([
		"dark",
		"light",
		"system"
	]),
	/**
	* localStorage key used to store `mode`.
	* @default 'mui-mode'
	*/
	modeStorageKey: import_prop_types.default.string,
	/**
	* Nonce string to pass to the inline script for CSP headers.
	*/
	nonce: import_prop_types.default.string
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/styles/ThemeProviderWithVars.mjs
const { CssVarsProvider: InternalCssVarsProvider, useColorScheme, getInitColorSchemeScript: deprecatedGetInitColorSchemeScript } = createCssVarsProvider({
	themeId: identifier_default,
	theme: () => createTheme$1({ cssVariables: true }),
	colorSchemeStorageKey: defaultConfig.colorSchemeStorageKey,
	modeStorageKey: defaultConfig.modeStorageKey,
	defaultColorScheme: {
		light: defaultConfig.defaultLightColorScheme,
		dark: defaultConfig.defaultDarkColorScheme
	},
	resolveTheme: (theme) => {
		const newTheme = {
			...theme,
			typography: createTypography(theme.palette, theme.typography)
		};
		newTheme.unstable_sx = function sx(props) {
			return styleFunctionSx_default({
				sx: props,
				theme: this
			});
		};
		return newTheme;
	}
});
/**
* TODO: remove this export in v7
* @deprecated
* The `CssVarsProvider` component has been deprecated and ported into `ThemeProvider`.
*
* You should use `ThemeProvider` and `createTheme()` instead:
*
* ```diff
* - import { CssVarsProvider, extendTheme } from '@mui/material/styles';
* + import { ThemeProvider, createTheme } from '@mui/material/styles';
*
* - const theme = extendTheme();
* + const theme = createTheme({
* +   cssVariables: true,
* +   colorSchemes: { light: true, dark: true },
* + });
*
* - <CssVarsProvider theme={theme}>
* + <ThemeProvider theme={theme}>
* ```
*
* To see the full documentation, check out https://mui.com/material-ui/customization/css-theme-variables/usage/.
*/
const CssVarsProvider = InternalCssVarsProvider;
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/styles/ThemeProvider.mjs
function ThemeProvider$1({ theme, ...props }) {
	const noVarsTheme = React$1.useMemo(() => {
		if (typeof theme === "function") return theme;
		const muiTheme = "$$material" in theme ? theme[identifier_default] : theme;
		if (!("colorSchemes" in muiTheme)) {
			if (!("vars" in muiTheme)) return {
				...theme,
				vars: null
			};
			return theme;
		}
		return null;
	}, [theme]);
	if (noVarsTheme) return /*#__PURE__*/ jsx(ThemeProviderNoVars, {
		theme: noVarsTheme,
		...props
	});
	return /*#__PURE__*/ jsx(CssVarsProvider, {
		theme,
		...props
	});
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useLazyRef/useLazyRef.mjs
const UNINITIALIZED = {};
/**
* A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
* initialization argument, so the initialization function doesn't need to be an inline closure.
*
* @usage
*   const ref = useLazyRef(sortColumns, columns)
*/
function useLazyRef(init, initArg) {
	const ref = React$1.useRef(UNINITIALIZED);
	if (ref.current === UNINITIALIZED) ref.current = init(initArg);
	return ref;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useValueAsRef/useValueAsRef.mjs
/**
* Copied from `@base-ui/utils/useValueAsRef`.
*
* Stores the latest value in a stable ref. The ref updates after React commits,
* so effects and delayed callbacks can read the current value without depending
* on it and rerunning.
*/
function useValueAsRef(value) {
	const latest = useLazyRef(() => createValueRef(value)).current;
	latest.next = value;
	useEnhancedEffect(latest.effect);
	return latest;
}
function createValueRef(value) {
	const latest = {
		current: value,
		next: value,
		effect: () => {
			latest.current = latest.next;
		}
	};
	return latest;
}
//#endregion
//#region ../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext_default = React.createContext(null);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/Transition.mjs
function resolveTimeouts(timeout) {
	if (timeout == null) return {
		appear: void 0,
		enter: void 0,
		exit: void 0
	};
	if (typeof timeout === "number") return {
		appear: timeout,
		enter: timeout,
		exit: timeout
	};
	const enter = timeout.enter;
	const exit = timeout.exit;
	return {
		appear: timeout.appear !== void 0 ? timeout.appear : enter,
		enter,
		exit
	};
}
/**
* Resolves the authored completion timeout for the current transition phase.
* Auto durations are read by the caller at scheduling time so Grow/Collapse
* can pass the latest measured value without storing it in React state.
*/
function getCompletionTimeout(params) {
	if (params.autoTimeout != null) return params.autoTimeout;
	const resolved = resolveTimeouts(params.timeout);
	if (params.currentStatus === "entering") return params.isAppearing ? resolved.appear ?? resolved.enter ?? null : resolved.enter ?? null;
	return resolved.exit ?? null;
}
function Transition(props) {
	const { in: inProp = false, appear = false, enter = true, exit = true, mountOnEnter = false, unmountOnExit = false, timeout, addEndListener, reduceMotion = false, getAutoTimeout, nodeRef, onEnter, onEntering, onEntered, onExit, onExiting, onExited, children, ...childProps } = props;
	const parentGroup = React$1.useContext(TransitionGroupContext_default);
	const shouldEnterOnMount = parentGroup && !parentGroup.isMounting ? enter : appear;
	const [status, setStatus] = React$1.useState(() => {
		if (inProp) return shouldEnterOnMount ? "exited" : "entered";
		if (mountOnEnter || unmountOnExit) return "unmounted";
		return "exited";
	});
	const statusRef = React$1.useRef(status);
	statusRef.current = status;
	if (inProp && status === "unmounted") {
		statusRef.current = "exited";
		setStatus("exited");
	}
	const shouldAppearOnMountRef = React$1.useRef(inProp && shouldEnterOnMount);
	const mountedRef = React$1.useRef(false);
	const nextCallbackRef = React$1.useRef(null);
	const lastFiredStatusRef = React$1.useRef(status);
	const isAppearingRef = React$1.useRef(false);
	const transitionReduceMotionRef = React$1.useRef(reduceMotion);
	const propsRef = useValueAsRef({
		timeout,
		addEndListener,
		reduceMotion,
		getAutoTimeout,
		onEnter,
		onEntering,
		onEntered,
		onExit,
		onExiting,
		onExited,
		enter,
		exit,
		mountOnEnter,
		unmountOnExit,
		nodeRef,
		parentGroup
	});
	const cancelPendingCallback = React$1.useCallback(() => {
		if (nextCallbackRef.current !== null) {
			nextCallbackRef.current.cancel();
			nextCallbackRef.current = null;
		}
	}, []);
	const makeCallback = React$1.useCallback((handler) => {
		let active = true;
		const wrapped = () => {
			if (active) {
				active = false;
				nextCallbackRef.current = null;
				handler();
			}
		};
		wrapped.cancel = () => {
			active = false;
		};
		nextCallbackRef.current = wrapped;
		return wrapped;
	}, []);
	const scheduleTransitionEnd = React$1.useCallback((nextStatus, currentStatus) => {
		let timeoutId;
		const clearTimer = () => {
			if (timeoutId !== void 0) {
				clearTimeout(timeoutId);
				timeoutId = void 0;
			}
		};
		const done = makeCallback(() => {
			clearTimer();
			statusRef.current = nextStatus;
			setStatus(nextStatus);
		});
		const cancelDone = done.cancel;
		done.cancel = () => {
			clearTimer();
			cancelDone();
		};
		const node = propsRef.current.nodeRef.current;
		const listener = propsRef.current.addEndListener;
		const hasAutoTimeout = propsRef.current.getAutoTimeout !== void 0;
		const autoTimeout = propsRef.current.getAutoTimeout?.();
		const authoredTimeout = getCompletionTimeout({
			currentStatus,
			isAppearing: isAppearingRef.current,
			timeout: propsRef.current.timeout,
			autoTimeout
		});
		const transitionReduceMotion = transitionReduceMotionRef.current;
		const fallbackTimeout = authoredTimeout ?? (transitionReduceMotion && hasAutoTimeout ? 0 : null);
		const scheduleTimer = (value) => {
			timeoutId = setTimeout(done, value);
		};
		if (!node) {
			console.warn([
				"MUI: The transition child does not expose a DOM element.",
				"Make sure the child accepts a ref and forwards it to the underlying DOM element.",
				"The transition animation cannot be observed without a DOM element and will be skipped."
			].join("\n"));
			scheduleTimer(0);
			return;
		}
		if (listener) {
			if (fallbackTimeout != null) scheduleTimer(transitionReduceMotion ? 0 : fallbackTimeout);
			if (listener.length >= 2) listener(node, done);
			else listener(done);
			return;
		}
		scheduleTimer(transitionReduceMotion ? 0 : authoredTimeout ?? 0);
	}, [makeCallback, propsRef]);
	const performEnter = React$1.useCallback((mounting) => {
		const current = propsRef.current;
		const isAppearing = current.parentGroup ? current.parentGroup.isMounting : mounting;
		isAppearingRef.current = isAppearing;
		if (!mounting && !current.enter) {
			statusRef.current = "entered";
			setStatus("entered");
			return;
		}
		transitionReduceMotionRef.current = current.reduceMotion;
		current.onEnter?.(isAppearing);
		statusRef.current = "entering";
		setStatus("entering");
	}, [propsRef]);
	const performExit = React$1.useCallback(() => {
		const current = propsRef.current;
		if (!current.exit) {
			statusRef.current = "exited";
			setStatus("exited");
			return;
		}
		transitionReduceMotionRef.current = current.reduceMotion;
		current.onExit?.();
		statusRef.current = "exiting";
		setStatus("exiting");
	}, [propsRef]);
	const updateStatus = React$1.useCallback((mounting, nextStatus) => {
		cancelPendingCallback();
		if (nextStatus === "entering") {
			const current = propsRef.current;
			if (current.mountOnEnter || current.unmountOnExit) {
				const node = current.nodeRef.current;
				if (node) reflow(node);
			}
			performEnter(mounting);
		} else performExit();
	}, [
		cancelPendingCallback,
		performEnter,
		performExit,
		propsRef
	]);
	useEnhancedEffect(() => {
		mountedRef.current = true;
		if (shouldAppearOnMountRef.current) {
			shouldAppearOnMountRef.current = false;
			updateStatus(true, "entering");
		}
		return () => {
			mountedRef.current = false;
			cancelPendingCallback();
		};
	}, [cancelPendingCallback, updateStatus]);
	useEnhancedEffect(() => {
		if (!mountedRef.current) return;
		const current = statusRef.current;
		if (inProp) {
			if (current !== "entering" && current !== "entered") updateStatus(false, "entering");
		} else if (current === "entering" || current === "entered") updateStatus(false, "exiting");
		else if (current === "exited" && unmountOnExit) {
			statusRef.current = "unmounted";
			setStatus("unmounted");
		}
	}, [
		inProp,
		status,
		unmountOnExit,
		updateStatus
	]);
	useEnhancedEffect(() => {
		if (status === "unmounted" || lastFiredStatusRef.current === "unmounted") {
			lastFiredStatusRef.current = status;
			return;
		}
		const statusChanged = lastFiredStatusRef.current !== status;
		if (statusChanged) lastFiredStatusRef.current = status;
		const current = propsRef.current;
		if (status === "entering") {
			if (statusChanged) current.onEntering?.(isAppearingRef.current);
			if (nextCallbackRef.current === null && statusRef.current === status) scheduleTransitionEnd("entered", "entering");
		} else if (status === "exiting") {
			if (statusChanged) current.onExiting?.();
			if (nextCallbackRef.current === null && statusRef.current === status) scheduleTransitionEnd("exited", "exiting");
		} else if (status === "entered" && statusChanged) current.onEntered?.(isAppearingRef.current);
		else if (status === "exited" && statusChanged) current.onExited?.();
	}, [
		propsRef,
		scheduleTransitionEnd,
		status
	]);
	if (status === "unmounted") return null;
	return /*#__PURE__*/ jsx(TransitionGroupContext_default.Provider, {
		value: null,
		children: children(status, childProps)
	});
}
Transition.propTypes = {
	/**
	* @ignore
	*/
	addEndListener: import_prop_types.default.func,
	/**
	* @ignore
	*/
	appear: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	children: import_prop_types.default.func.isRequired,
	/**
	* @ignore
	*/
	enter: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	exit: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	getAutoTimeout: import_prop_types.default.func,
	/**
	* @ignore
	*/
	in: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	mountOnEnter: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	nodeRef: import_prop_types.default.shape({ current: (props, propName) => {
		if (props[propName] == null) return null;
		if (typeof props[propName] !== "object" || props[propName].nodeType !== 1) return /* @__PURE__ */ new Error(`Expected prop '${propName}' to be of type Element`);
		return null;
	} }).isRequired,
	/**
	* @ignore
	*/
	onEnter: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onEntered: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onEntering: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExit: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExited: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExiting: import_prop_types.default.func,
	/**
	* @ignore
	*/
	reduceMotion: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	timeout: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.shape({
		appear: import_prop_types.default.number,
		enter: import_prop_types.default.number,
		exit: import_prop_types.default.number
	})]),
	/**
	* @ignore
	*/
	unmountOnExit: import_prop_types.default.bool
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/transitions/useReducedMotion.mjs
const MEDIA_QUERY = "(prefers-reduced-motion: reduce)";
const REDUCED_MOTION_DURATION = 0;
const REDUCED_MOTION_DELAY = "0ms";
const NOOP$1 = () => {};
const getDefaultSnapshot = () => false;
const getReducedMotionSnapshot = () => true;
const subscribeNoop = () => NOOP$1;
/**
* Subscribes to the OS reduced-motion media query only when the theme mode needs it.
* React 17 reads the media query after mount, matching useMediaQuery's fallback path.
*/
function useReducedMotionMediaQueryOld(enabled) {
	const [queryState, setQueryState] = React$1.useState(() => ({
		enabled,
		matches: enabled ? null : false
	}));
	let matches = queryState.matches;
	if (queryState.enabled !== enabled) {
		matches = null;
		if (!enabled) matches = false;
	}
	useEnhancedEffect(() => {
		const setResolvedMatches = (nextMatches) => {
			setQueryState((previousState) => {
				if (previousState.enabled === enabled && previousState.matches === nextMatches) return previousState;
				return {
					enabled,
					matches: nextMatches
				};
			});
		};
		if (!enabled) {
			if (queryState.enabled) setResolvedMatches(false);
			return;
		}
		if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
			setResolvedMatches(false);
			return;
		}
		const mediaQueryList = window.matchMedia(MEDIA_QUERY);
		const update = () => {
			setResolvedMatches(mediaQueryList.matches);
		};
		update();
		mediaQueryList.addEventListener("change", update);
		return () => {
			mediaQueryList.removeEventListener("change", update);
		};
	}, [enabled, queryState.enabled]);
	return matches;
}
const maybeReactUseSyncExternalStore = { ...React$1 }.useSyncExternalStore;
/**
* React 18+ can read the media query during client renders, so newly mounted
* transitions do not start from the SSR-safe reduced-motion default.
*/
function useReducedMotionMediaQueryNew(enabled) {
	const getServerSnapshot = enabled ? getReducedMotionSnapshot : getDefaultSnapshot;
	const [getSnapshot, subscribe] = React$1.useMemo(() => {
		if (!enabled || typeof window === "undefined" || typeof window.matchMedia !== "function") return [getDefaultSnapshot, subscribeNoop];
		const mediaQueryList = window.matchMedia(MEDIA_QUERY);
		return [() => mediaQueryList.matches, (notify) => {
			mediaQueryList.addEventListener("change", notify);
			return () => {
				mediaQueryList.removeEventListener("change", notify);
			};
		}];
	}, [enabled]);
	return maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
const useReducedMotionMediaQuery = maybeReactUseSyncExternalStore !== void 0 ? useReducedMotionMediaQueryNew : useReducedMotionMediaQueryOld;
/**
* Resolves whether a Material UI transition should reduce motion and provides
* adjusted CSS transition timing for MUI-owned duration/delay values.
*/
function useReducedMotion(mode, disablePrefersReducedMotion) {
	const prefersReducedMotion = useReducedMotionMediaQuery(!disablePrefersReducedMotion && mode === "system");
	const shouldReduceMotion = !disablePrefersReducedMotion && (mode === "always" || mode === "system" && prefersReducedMotion !== false);
	return React$1.useMemo(() => ({
		shouldReduceMotion,
		getTransitionTiming(timing) {
			if (!shouldReduceMotion) return timing;
			return {
				duration: REDUCED_MOTION_DURATION,
				delay: REDUCED_MOTION_DELAY
			};
		}
	}), [shouldReduceMotion]);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/appendOwnerState/appendOwnerState.mjs
/**
* Type of the ownerState based on the type of an element it applies to.
* This resolves to the provided OwnerState for React components and `undefined` for host components.
* Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
*/
/**
* Appends the ownerState object to the props, merging with the existing one if necessary.
*
* @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
* @param otherProps Props of the element.
* @param ownerState
*/
function appendOwnerState(elementType, otherProps, ownerState) {
	if (elementType === void 0 || isHostComponent(elementType)) return otherProps;
	return {
		...otherProps,
		ownerState: {
			...otherProps.ownerState,
			...ownerState
		}
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/resolveComponentProps/resolveComponentProps.mjs
/**
* If `componentProps` is a function, calls it with the provided `ownerState`.
* Otherwise, just returns `componentProps`.
*/
function resolveComponentProps(componentProps, ownerState, slotState) {
	if (typeof componentProps === "function") return componentProps(ownerState, slotState);
	return componentProps;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/extractEventHandlers/extractEventHandlers.mjs
/**
* Extracts event handlers from a given object.
* A prop is considered an event handler if it is a function and its name starts with `on`.
*
* @param object An object to extract event handlers from.
*/
function extractEventHandlers(object) {
	if (object === void 0) return {};
	const result = {};
	for (const prop of Object.keys(object)) if (isEventHandler(prop, object[prop])) result[prop] = object[prop];
	return result;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/omitEventHandlers/omitEventHandlers.mjs
/**
* Removes event handlers from the given object.
* A field is considered an event handler if it is a function with a name beginning with `on`.
*
* @param object Object to remove event handlers from.
* @returns Object with event handlers removed.
*/
function omitEventHandlers(object) {
	if (object === void 0) return {};
	const result = {};
	Object.keys(object).filter((prop) => !(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop) => {
		result[prop] = object[prop];
	});
	return result;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/mergeSlotProps/mergeSlotProps.mjs
/**
* Merges the slot component internal props (usually coming from a hook)
* with the externally provided ones.
*
* The merge order is (the latter overrides the former):
* 1. The internal props (specified as a getter function to work with get*Props hook result)
* 2. Additional props (specified internally on a Base UI component)
* 3. External props specified on the owner component. These should only be used on a root slot.
* 4. External props specified in the `slotProps.*` prop.
* 5. The `className` prop - combined from all the above.
* @param parameters
* @returns
*/
function mergeSlotProps(parameters) {
	const { getSlotProps, additionalProps, externalSlotProps, externalForwardedProps, className } = parameters;
	if (!getSlotProps) {
		const joinedClasses = clsx(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
		const mergedStyle = {
			...additionalProps?.style,
			...externalForwardedProps?.style,
			...externalSlotProps?.style
		};
		const props = {
			...additionalProps,
			...externalForwardedProps,
			...externalSlotProps
		};
		if (joinedClasses.length > 0) props.className = joinedClasses;
		if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
		return {
			props,
			internalRef: void 0
		};
	}
	const eventHandlers = extractEventHandlers({
		...externalForwardedProps,
		...externalSlotProps
	});
	const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
	const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
	const internalSlotProps = getSlotProps(eventHandlers);
	const joinedClasses = clsx(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
	const mergedStyle = {
		...internalSlotProps?.style,
		...additionalProps?.style,
		...externalForwardedProps?.style,
		...externalSlotProps?.style
	};
	const props = {
		...internalSlotProps,
		...additionalProps,
		...otherPropsWithoutEventHandlers,
		...componentsPropsWithoutEventHandlers
	};
	if (joinedClasses.length > 0) props.className = joinedClasses;
	if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
	return {
		props,
		internalRef: internalSlotProps.ref
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/useSlot.mjs
/**
* An internal function to create a Material UI slot.
*
* This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
* while Base UI does not need to support leaf component customization.
*
* @param {string} name: name of the slot
* @param {object} parameters
* @returns {[Slot, slotProps]} The slot's React component and the slot's props
*
* Note: the returned slot's props
* - will never contain `component` prop.
* - might contain `as` prop.
*/
function useSlot(name, parameters) {
	const { className, elementType: initialElementType, ownerState, externalForwardedProps, internalForwardedProps, shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
	const { component: rootComponent, slots = { [name]: void 0 }, slotProps = { [name]: void 0 }, ...other } = externalForwardedProps;
	const elementType = slots[name] || initialElementType;
	const resolvedComponentsProps = resolveComponentProps(slotProps[name], ownerState);
	const { props: { component: slotComponent, ...mergedProps }, internalRef } = mergeSlotProps({
		className,
		...useSlotPropsParams,
		externalForwardedProps: name === "root" ? other : void 0,
		externalSlotProps: resolvedComponentsProps
	});
	const ref = useForkRef(internalRef, resolvedComponentsProps?.ref, parameters.ref);
	const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
	return [elementType, appendOwnerState(elementType, {
		...name === "root" && !rootComponent && !slots[name] && internalForwardedProps,
		...name !== "root" && !slots[name] && internalForwardedProps,
		...mergedProps,
		...LeafComponent && !shouldForwardComponentProp && { as: LeafComponent },
		...LeafComponent && shouldForwardComponentProp && { component: LeafComponent },
		ref
	}, ownerState)];
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Collapse/collapseClasses.mjs
function getCollapseUtilityClass(slot) {
	return generateUtilityClass("MuiCollapse", slot);
}
generateUtilityClasses("MuiCollapse", [
	"root",
	"horizontal",
	"vertical",
	"entered",
	"hidden",
	"wrapper",
	"wrapperInner"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Collapse/Collapse.mjs
const EMPTY_OBJECT = {};
const useUtilityClasses$74 = (ownerState) => {
	const { orientation, classes } = ownerState;
	return composeClasses({
		root: ["root", orientation],
		entered: ["entered"],
		hidden: ["hidden"],
		wrapper: ["wrapper", orientation],
		wrapperInner: ["wrapperInner", orientation]
	}, getCollapseUtilityClass, classes);
};
const CollapseRoot = styled$2("div", {
	name: "MuiCollapse",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[ownerState.orientation],
			ownerState.state === "entered" && styles.entered,
			ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
		];
	}
})(memoTheme(({ theme }) => ({
	height: 0,
	overflow: "hidden",
	transition: theme.transitions.create("height"),
	variants: [
		{
			props: { orientation: "horizontal" },
			style: {
				height: "auto",
				width: 0,
				transition: theme.transitions.create("width")
			}
		},
		{
			props: { state: "entered" },
			style: {
				height: "auto",
				overflow: "visible"
			}
		},
		{
			props: {
				state: "entered",
				orientation: "horizontal"
			},
			style: { width: "auto" }
		},
		{
			props: ({ ownerState }) => ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px",
			style: { visibility: "hidden" }
		}
	]
})));
const CollapseWrapper = styled$2("div", {
	name: "MuiCollapse",
	slot: "Wrapper"
})({
	display: "flex",
	width: "100%",
	variants: [{
		props: { orientation: "horizontal" },
		style: {
			width: "auto",
			height: "100%"
		}
	}]
});
const CollapseWrapperInner = styled$2("div", {
	name: "MuiCollapse",
	slot: "WrapperInner"
})({
	width: "100%",
	variants: [{
		props: { orientation: "horizontal" },
		style: {
			width: "auto",
			height: "100%"
		}
	}]
});
/**
* The Collapse transition is used by the
* [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
*/
const Collapse$1 = /*#__PURE__*/ React$1.forwardRef(function Collapse(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiCollapse"
	});
	const { addEndListener, children, className, collapsedSize: collapsedSizeProp = "0px", component, disablePrefersReducedMotion = false, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, orientation = "vertical", slots = EMPTY_OBJECT, slotProps = EMPTY_OBJECT, style, timeout = duration.standard, TransitionComponent = Transition, ...other } = props;
	const ownerState = {
		...props,
		orientation,
		collapsedSize: collapsedSizeProp
	};
	const classes = useUtilityClasses$74(ownerState);
	const theme = useTheme$1();
	const wrapperRef = React$1.useRef(null);
	const autoTransitionDuration = React$1.useRef(null);
	const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
	const isHorizontal = orientation === "horizontal";
	const size = isHorizontal ? "width" : "height";
	const reducedMotion = useReducedMotion(theme.motion.reducedMotion, disablePrefersReducedMotion);
	const nodeRef = React$1.useRef(null);
	const handleRef = useForkRef_default(ref, nodeRef);
	const getWrapperSize = () => wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
	const handleEnter = normalizedTransitionCallback(nodeRef, (node, isAppearing) => {
		if (wrapperRef.current && isHorizontal) wrapperRef.current.style.position = "absolute";
		node.style[size] = collapsedSize;
		if (onEnter) onEnter(node, isAppearing);
	});
	const handleEntering = normalizedTransitionCallback(nodeRef, (node, isAppearing) => {
		const wrapperSize = getWrapperSize();
		if (wrapperRef.current && isHorizontal) wrapperRef.current.style.position = "";
		const { duration: transitionDuration, easing: transitionTimingFunction } = getTransitionProps({
			style,
			timeout,
			easing
		}, { mode: "enter" });
		if (timeout === "auto" && !reducedMotion.shouldReduceMotion) {
			const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
			autoTransitionDuration.current = duration2;
		} else autoTransitionDuration.current = null;
		const transitionTiming = reducedMotion.getTransitionTiming({
			duration: autoTransitionDuration.current ?? transitionDuration,
			delay: void 0
		});
		node.style.transitionDuration = typeof transitionTiming.duration === "string" ? transitionTiming.duration : `${transitionTiming.duration}ms`;
		node.style[size] = `${wrapperSize}px`;
		node.style.transitionTimingFunction = transitionTimingFunction;
		if (onEntering) onEntering(node, isAppearing);
	});
	const handleEntered = normalizedTransitionCallback(nodeRef, (node, isAppearing) => {
		node.style[size] = "auto";
		if (onEntered) onEntered(node, isAppearing);
	});
	const handleExit = normalizedTransitionCallback(nodeRef, (node) => {
		node.style[size] = `${getWrapperSize()}px`;
		if (onExit) onExit(node);
	});
	const handleExited = normalizedTransitionCallback(nodeRef, onExited);
	const handleExiting = normalizedTransitionCallback(nodeRef, (node) => {
		const wrapperSize = getWrapperSize();
		const { duration: transitionDuration, easing: transitionTimingFunction } = getTransitionProps({
			style,
			timeout,
			easing
		}, { mode: "exit" });
		if (timeout === "auto" && !reducedMotion.shouldReduceMotion) {
			const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
			autoTransitionDuration.current = duration2;
		} else autoTransitionDuration.current = null;
		const transitionTiming = reducedMotion.getTransitionTiming({
			duration: autoTransitionDuration.current ?? transitionDuration,
			delay: void 0
		});
		node.style.transitionDuration = typeof transitionTiming.duration === "string" ? transitionTiming.duration : `${transitionTiming.duration}ms`;
		node.style[size] = collapsedSize;
		node.style.transitionTimingFunction = transitionTimingFunction;
		if (onExiting) onExiting(node);
	});
	const handleAddEndListener = addEndListener ? (next) => {
		addEndListener(nodeRef.current, next);
	} : void 0;
	const externalForwardedProps = {
		slots,
		slotProps,
		component
	};
	const [RootSlot, rootSlotProps] = useSlot("root", {
		ref: handleRef,
		className: clsx(classes.root, className),
		elementType: CollapseRoot,
		externalForwardedProps,
		ownerState,
		additionalProps: { style: {
			[isHorizontal ? "minWidth" : "minHeight"]: collapsedSize,
			...style
		} }
	});
	const [WrapperSlot, wrapperSlotProps] = useSlot("wrapper", {
		ref: wrapperRef,
		className: classes.wrapper,
		elementType: CollapseWrapper,
		externalForwardedProps,
		ownerState
	});
	const [WrapperInnerSlot, wrapperInnerSlotProps] = useSlot("wrapperInner", {
		className: classes.wrapperInner,
		elementType: CollapseWrapperInner,
		externalForwardedProps,
		ownerState
	});
	return /*#__PURE__*/ jsx(TransitionComponent, {
		in: inProp,
		onEnter: handleEnter,
		onEntered: handleEntered,
		onEntering: handleEntering,
		onExit: handleExit,
		onExited: handleExited,
		onExiting: handleExiting,
		addEndListener: handleAddEndListener,
		getAutoTimeout: timeout === "auto" ? () => autoTransitionDuration.current : void 0,
		reduceMotion: reducedMotion.shouldReduceMotion,
		nodeRef,
		timeout: timeout === "auto" ? null : timeout,
		...other,
		children: (state, { ownerState: incomingOwnerState, ...restChildProps }) => {
			const stateOwnerState = {
				...ownerState,
				state
			};
			return /*#__PURE__*/ jsx(RootSlot, {
				...rootSlotProps,
				className: clsx(rootSlotProps.className, {
					"entered": classes.entered,
					"exited": !inProp && collapsedSize === "0px" && classes.hidden
				}[state]),
				ownerState: stateOwnerState,
				...restChildProps,
				children: /*#__PURE__*/ jsx(WrapperSlot, {
					...wrapperSlotProps,
					ownerState: stateOwnerState,
					children: /*#__PURE__*/ jsx(WrapperInnerSlot, {
						...wrapperInnerSlotProps,
						ownerState: stateOwnerState,
						children
					})
				})
			});
		}
	});
});
Collapse$1.propTypes = {
	/**
	* Add a custom transition end trigger.
	* Use it when you need custom logic to decide when the transition has ended.
	* Note: Timeouts are still used as a fallback if provided.
	*
	* @param {HTMLElement} node The transitioning DOM node.
	* @param {Function} done Call this when the transition has finished.
	*/
	addEndListener: import_prop_types.default.func,
	/**
	* The content node to be collapsed.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The width (horizontal) or height (vertical) of the container when collapsed.
	* @default '0px'
	*/
	collapsedSize: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: elementTypeAcceptingRef_default,
	/**
	* If `true`, the transition ignores `theme.motion.reducedMotion` and keeps its normal timing.
	* @default false
	*/
	disablePrefersReducedMotion: import_prop_types.default.bool,
	/**
	* The transition timing function.
	* You may specify a single easing or a object containing enter and exit values.
	*/
	easing: import_prop_types.default.oneOfType([import_prop_types.default.shape({
		enter: import_prop_types.default.string,
		exit: import_prop_types.default.string
	}), import_prop_types.default.string]),
	/**
	* If `true`, the component will transition in.
	*/
	in: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	onEnter: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onEntered: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onEntering: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExit: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExited: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExiting: import_prop_types.default.func,
	/**
	* The transition orientation.
	* @default 'vertical'
	*/
	orientation: import_prop_types.default.oneOf(["horizontal", "vertical"]),
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		wrapper: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		wrapperInner: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		root: import_prop_types.default.elementType,
		wrapper: import_prop_types.default.elementType,
		wrapperInner: import_prop_types.default.elementType
	}),
	/**
	* @ignore
	*/
	style: import_prop_types.default.object,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The duration for the transition, in milliseconds.
	* You may specify a single timeout for all transitions, or individually with an object.
	*
	* Set to 'auto' to automatically calculate transition time based on height.
	* @default duration.standard
	*/
	timeout: import_prop_types.default.oneOfType([
		import_prop_types.default.oneOf(["auto"]),
		import_prop_types.default.number,
		import_prop_types.default.shape({
			appear: import_prop_types.default.number,
			enter: import_prop_types.default.number,
			exit: import_prop_types.default.number
		})
	])
};
if (Collapse$1) Collapse$1.muiSupportAuto = true;
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/integerPropType/integerPropType.mjs
function getTypeByValue(value) {
	const valueType = typeof value;
	switch (valueType) {
		case "number":
			if (Number.isNaN(value)) return "NaN";
			if (!Number.isFinite(value)) return "Infinity";
			if (value !== Math.floor(value)) return "float";
			return "number";
		case "object":
			if (value === null) return "null";
			return value.constructor.name;
		default: return valueType;
	}
}
function requiredInteger(props, propName, componentName, location) {
	const propValue = props[propName];
	if (propValue == null || !Number.isInteger(propValue)) {
		const propType = getTypeByValue(propValue);
		return /* @__PURE__ */ new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
	}
	return null;
}
function validator(props, propName, componentName, location) {
	if (props[propName] === void 0) return null;
	return requiredInteger(props, propName, componentName, location);
}
function validatorNoop() {
	return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
const integerPropType = validator;
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Paper/paperClasses.mjs
function getPaperUtilityClass(slot) {
	return generateUtilityClass("MuiPaper", slot);
}
generateUtilityClasses("MuiPaper", [
	"root",
	"rounded",
	"outlined",
	"elevation",
	"elevation0",
	"elevation1",
	"elevation2",
	"elevation3",
	"elevation4",
	"elevation5",
	"elevation6",
	"elevation7",
	"elevation8",
	"elevation9",
	"elevation10",
	"elevation11",
	"elevation12",
	"elevation13",
	"elevation14",
	"elevation15",
	"elevation16",
	"elevation17",
	"elevation18",
	"elevation19",
	"elevation20",
	"elevation21",
	"elevation22",
	"elevation23",
	"elevation24"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Paper/Paper.mjs
const useUtilityClasses$73 = (ownerState) => {
	const { square, elevation, variant, classes } = ownerState;
	const slots = { root: [
		"root",
		variant,
		!square && "rounded",
		variant === "elevation" && `elevation${elevation}`
	] };
	return composeClasses(slots, getPaperUtilityClass, classes);
};
const PaperRoot = styled$2("div", {
	name: "MuiPaper",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[ownerState.variant],
			!ownerState.square && styles.rounded,
			ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
		];
	}
})(memoTheme(({ theme }) => ({
	backgroundColor: (theme.vars || theme).palette.background.paper,
	color: (theme.vars || theme).palette.text.primary,
	...getTransitionStyles(theme, "box-shadow"),
	variants: [
		{
			props: ({ ownerState }) => !ownerState.square,
			style: { borderRadius: theme.shape.borderRadius }
		},
		{
			props: { variant: "outlined" },
			style: { border: `1px solid ${(theme.vars || theme).palette.divider}` }
		},
		{
			props: { variant: "elevation" },
			style: {
				boxShadow: "var(--Paper-shadow)",
				backgroundImage: "var(--Paper-overlay)"
			}
		}
	]
})));
const Paper = /*#__PURE__*/ React$1.forwardRef(function Paper(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiPaper"
	});
	const theme = useTheme$1();
	const { className, component = "div", elevation = 1, square = false, variant = "elevation", ...other } = props;
	const ownerState = {
		...props,
		component,
		elevation,
		square,
		variant
	};
	const classes = useUtilityClasses$73(ownerState);
	if (theme.shadows[elevation] === void 0) console.error([`MUI: The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${elevation}]\` is defined.`].join("\n"));
	return /*#__PURE__*/ jsx(PaperRoot, {
		as: component,
		ownerState,
		className: clsx(classes.root, className),
		ref,
		...other,
		style: {
			...variant === "elevation" && {
				"--Paper-shadow": (theme.vars || theme).shadows[elevation],
				...theme.vars && { "--Paper-overlay": theme.vars.overlays?.[elevation] },
				...!theme.vars && theme.palette.mode === "dark" && { "--Paper-overlay": `linear-gradient(${alpha("#fff", getOverlayAlpha(elevation))}, ${alpha("#fff", getOverlayAlpha(elevation))})` }
			},
			...other.style
		}
	});
});
Paper.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* Shadow depth, corresponds to `dp` in the spec.
	* It accepts values between 0 and 24 inclusive.
	* @default 1
	*/
	elevation: chainPropTypes(integerPropType, (props) => {
		const { elevation, variant } = props;
		if (elevation > 0 && variant === "outlined") return /* @__PURE__ */ new Error(`MUI: Combining \`elevation={${elevation}}\` with \`variant="${variant}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`);
		return null;
	}),
	/**
	* If `true`, rounded corners are disabled.
	* @default false
	*/
	square: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	style: import_prop_types.default.object,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The variant to use.
	* @default 'elevation'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["elevation", "outlined"]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/isFocusVisible/isFocusVisible.mjs
/**
* Returns a boolean indicating if the event's target has :focus-visible
*/
function isFocusVisible(element) {
	try {
		return element.matches(":focus-visible");
	} catch (error) {
		if (!window.navigator.userAgent.includes("jsdom")) console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join("\n"));
	}
	return false;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/useFocusableWhenDisabled.mjs
function useFocusableWhenDisabled(parameters) {
	const { focusableWhenDisabled, disabled, composite = false, tabIndex: tabIndexProp = 0, isNativeButton } = parameters;
	const isFocusableComposite = composite && focusableWhenDisabled !== false;
	const isNonFocusableComposite = composite && focusableWhenDisabled === false;
	return React$1.useMemo(() => {
		const additionalProps = { onKeyDown(event) {
			if (disabled && focusableWhenDisabled && event.key !== "Tab") event.preventDefault();
		} };
		if (!composite) {
			additionalProps.tabIndex = tabIndexProp;
			if (!isNativeButton && disabled) additionalProps.tabIndex = focusableWhenDisabled ? tabIndexProp : -1;
		}
		if (isNativeButton && (focusableWhenDisabled || isFocusableComposite) || !isNativeButton && disabled) additionalProps["aria-disabled"] = disabled;
		if (isNativeButton && (!focusableWhenDisabled || isNonFocusableComposite)) additionalProps.disabled = disabled;
		return additionalProps;
	}, [
		composite,
		disabled,
		focusableWhenDisabled,
		isFocusableComposite,
		isNonFocusableComposite,
		isNativeButton,
		tabIndexProp
	]);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ButtonBase/useButtonBase.mjs
const EMPTY$1 = {};
function useButtonBase(parameters) {
	const { nativeButton, nativeButtonProp, internalNativeButton = nativeButton, allowInferredHostMismatch = false, disabled, type, hasFormAction = false, tabIndex = 0, focusableWhenDisabled: focusableWhenDisabledParam, stopEventPropagation = false, onBeforeKeyDown, onBeforeKeyUp } = parameters;
	const rootRef = React$1.useRef(null);
	const focusableWhenDisabled = focusableWhenDisabledParam === true;
	const focusableWhenDisabledProps = useFocusableWhenDisabled({
		focusableWhenDisabled,
		disabled,
		isNativeButton: nativeButton,
		tabIndex
	});
	React$1.useEffect(() => {
		const root = rootRef.current;
		if (root == null) return;
		const isButtonTag = root.tagName === "BUTTON";
		if (nativeButtonProp !== void 0) {
			if (nativeButtonProp && !isButtonTag) console.error("MUI: A component that acts as a button expected a native <button> because the `nativeButton` prop is true. Rendering a non-<button> removes native button semantics, which can impact forms and accessibility. Render a real <button> or set `nativeButton` to `false`.");
			if (!nativeButtonProp && isButtonTag) console.error("MUI: A component that acts as a button expected a non-<button> because the `nativeButton` prop is false. Rendering a <button> keeps native behavior while additionally applies non-native attributes and handlers, which can add unintended extra attributes (such as `role` or `aria-disabled`). Render a non-<button> such as <div>, or set `nativeButton` to `true`.");
			return;
		}
		if (allowInferredHostMismatch) return;
		if (internalNativeButton && !isButtonTag) console.error("MUI: A component rendering a native <button> resolved to a non-<button> element, but `nativeButton={false}` was not specified and the resolved root is a non-<button>. When rendering a custom component, set `nativeButton={false}` explicitly or render a <button> element.");
		if (!internalNativeButton && isButtonTag) console.error("MUI: A component that acts as a non-native button resolved to a native <button> element, but `nativeButton={true}` was not specified. When rendering a custom component, set `nativeButton={true}` explicitly or render a non-<button> element.");
	}, [
		allowInferredHostMismatch,
		internalNativeButton,
		nativeButtonProp
	]);
	const hasNativeKeyboardActivation = React$1.useCallback(() => {
		const root = rootRef.current;
		if (root == null) return nativeButton;
		if (root.tagName === "BUTTON") return true;
		return Boolean(root.tagName === "A" && root.href);
	}, [nativeButton]);
	const buttonProps = React$1.useMemo(() => {
		const resolvedButtonProps = focusableWhenDisabled ? {} : { tabIndex: disabled ? -1 : tabIndex };
		if (nativeButton) {
			resolvedButtonProps.type = type === void 0 && !hasFormAction ? "button" : type;
			if (!focusableWhenDisabled) resolvedButtonProps.disabled = disabled;
		} else {
			resolvedButtonProps.role = "button";
			if (!focusableWhenDisabled && disabled) resolvedButtonProps["aria-disabled"] = disabled;
		}
		if (focusableWhenDisabled) return {
			...resolvedButtonProps,
			...focusableWhenDisabledProps
		};
		return resolvedButtonProps;
	}, [
		disabled,
		focusableWhenDisabled,
		focusableWhenDisabledProps,
		hasFormAction,
		nativeButton,
		tabIndex,
		type
	]);
	return {
		getButtonProps: React$1.useCallback((externalProps = EMPTY$1) => {
			const { onClick: externalOnClick, onKeyDown: externalOnKeyDown, onKeyUp: externalOnKeyUp, ...otherExternalProps } = externalProps;
			const handleClick = (event) => {
				if (stopEventPropagation) event.stopPropagation();
				if (disabled) {
					event.preventDefault();
					return;
				}
				externalOnClick?.(event);
			};
			const handleKeyDown = (event) => {
				if (focusableWhenDisabled) focusableWhenDisabledProps.onKeyDown(event);
				if (disabled) return;
				onBeforeKeyDown?.(event);
				externalOnKeyDown?.(event);
				if (event.target !== event.currentTarget || hasNativeKeyboardActivation()) return;
				if (event.key === " ") {
					event.preventDefault();
					return;
				}
				if (event.key === "Enter") {
					event.preventDefault();
					event.currentTarget.click();
				}
			};
			const handleKeyUp = (event) => {
				if (disabled) return;
				onBeforeKeyUp?.(event);
				externalOnKeyUp?.(event);
				if (event.target === event.currentTarget && !hasNativeKeyboardActivation() && event.key === " " && !event.defaultPrevented) event.currentTarget.click();
			};
			return {
				...buttonProps,
				...otherExternalProps,
				onClick: handleClick,
				onKeyDown: handleKeyDown,
				onKeyUp: handleKeyUp
			};
		}, [
			buttonProps,
			disabled,
			focusableWhenDisabled,
			focusableWhenDisabledProps,
			hasNativeKeyboardActivation,
			onBeforeKeyDown,
			onBeforeKeyUp,
			stopEventPropagation
		]),
		rootRef
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/useLazyRipple/useLazyRipple.mjs
/**
* Lazy initialization container for the Ripple instance. This improves
* performance by delaying mounting the ripple until it's needed.
*/
var LazyRipple = class LazyRipple {
	/** React ref to the ripple instance */
	/** If the ripple component should be mounted */
	/** Promise that resolves when the ripple component is mounted */
	/** If the ripple component has been mounted */
	/** React state hook setter */
	static create() {
		return new LazyRipple();
	}
	static use() {
		const ripple = useLazyRef(LazyRipple.create).current;
		const [shouldMount, setShouldMount] = React$1.useState(false);
		ripple.shouldMount = shouldMount;
		ripple.setShouldMount = setShouldMount;
		React$1.useEffect(ripple.mountEffect, [shouldMount]);
		return ripple;
	}
	constructor() {
		this.ref = { current: null };
		this.mounted = null;
		this.didMount = false;
		this.shouldMount = false;
		this.setShouldMount = null;
	}
	mount() {
		if (!this.mounted) {
			this.mounted = createControlledPromise();
			this.shouldMount = true;
			this.setShouldMount(this.shouldMount);
		}
		return this.mounted;
	}
	mountEffect = () => {
		if (this.shouldMount && !this.didMount) {
			if (this.ref.current !== null) {
				this.didMount = true;
				this.mounted.resolve();
			}
		}
	};
	start(...args) {
		this.mount().then(() => this.ref.current?.start(...args));
	}
	stop(...args) {
		this.mount().then(() => this.ref.current?.stop(...args));
	}
	pulsate(...args) {
		this.mount().then(() => this.ref.current?.pulsate(...args));
	}
};
function useLazyRipple() {
	return LazyRipple.use();
}
function createControlledPromise() {
	let resolve;
	let reject;
	const p = new Promise((resolveFn, rejectFn) => {
		resolve = resolveFn;
		reject = rejectFn;
	});
	p.resolve = resolve;
	p.reject = reject;
	return p;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useOnMount/useOnMount.mjs
const EMPTY = [];
/**
* A React.useEffect equivalent that runs once, when the component is mounted.
*/
function useOnMount(fn) {
	React$1.useEffect(fn, EMPTY);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useTimeout/useTimeout.mjs
var Timeout = class Timeout {
	static create() {
		return new Timeout();
	}
	currentId = null;
	/**
	* Executes `fn` after `delay`, clearing any previously scheduled call.
	*/
	start(delay, fn) {
		this.clear();
		this.currentId = setTimeout(() => {
			this.currentId = null;
			fn();
		}, delay);
	}
	clear = () => {
		if (this.currentId !== null) {
			clearTimeout(this.currentId);
			this.currentId = null;
		}
	};
	disposeEffect = () => {
		return this.clear;
	};
};
function useTimeout() {
	const timeout = useLazyRef(Timeout.create).current;
	useOnMount(timeout.disposeEffect);
	return timeout;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ButtonBase/Ripple.mjs
/**
* @ignore - internal component.
*/
function Ripple(props) {
	const { className, classes, pulsate = false, rippleX, rippleY, rippleSize, in: inProp, onExited, timeout } = props;
	const [leaving, setLeaving] = React$1.useState(false);
	const exitTimer = useTimeout();
	const exitTimerStartedRef = React$1.useRef(false);
	const onExitedRef = React$1.useRef(onExited);
	onExitedRef.current = onExited;
	const hasExitedCallback = onExited != null;
	const rippleClassName = clsx(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
	const rippleStyles = {
		width: rippleSize,
		height: rippleSize,
		top: -(rippleSize / 2) + rippleY,
		left: -(rippleSize / 2) + rippleX
	};
	const childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
	if (!inProp && !leaving) setLeaving(true);
	React$1.useEffect(() => {
		if (!inProp && hasExitedCallback) {
			if (!exitTimerStartedRef.current) {
				exitTimerStartedRef.current = true;
				exitTimer.start(timeout, () => {
					exitTimerStartedRef.current = false;
					onExitedRef.current?.();
				});
			}
		} else {
			exitTimerStartedRef.current = false;
			exitTimer.clear();
		}
	}, [
		exitTimer,
		hasExitedCallback,
		inProp,
		timeout
	]);
	return /*#__PURE__*/ jsx("span", {
		className: rippleClassName,
		style: rippleStyles,
		children: /*#__PURE__*/ jsx("span", { className: childClassName })
	});
}
Ripple.propTypes = {
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object.isRequired,
	className: import_prop_types.default.string,
	/**
	* @ignore - controlled by TouchRipple
	*/
	in: import_prop_types.default.bool,
	/**
	* @ignore - controlled by TouchRipple
	*/
	onExited: import_prop_types.default.func,
	/**
	* If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	*/
	pulsate: import_prop_types.default.bool,
	/**
	* Diameter of the ripple.
	*/
	rippleSize: import_prop_types.default.number,
	/**
	* Horizontal position of the ripple center.
	*/
	rippleX: import_prop_types.default.number,
	/**
	* Vertical position of the ripple center.
	*/
	rippleY: import_prop_types.default.number,
	/**
	* Exit delay.
	*/
	timeout: import_prop_types.default.number.isRequired
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ButtonBase/touchRippleClasses.mjs
const touchRippleClasses = generateUtilityClasses("MuiTouchRipple", [
	"root",
	"ripple",
	"rippleVisible",
	"ripplePulsate",
	"child",
	"childLeaving",
	"childPulsate"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ButtonBase/TouchRipple.mjs
const DURATION = 550;
const EMPTY_OBJ = {};
const EMPTY_ARRAY = [];
const NOOP = () => {};
/**
* Keep the same DOM order TouchRipple had when it used react-transition-group:
* exiting ripples stay in place, and new ripples are inserted before the final
* group of ripples that are waiting for their exit animation to finish.
*
* @param {number[]} prevOrder The previous DOM order, including ripples that may be exiting.
* @param {number[]} nextActiveKeys The ripples that should still be treated as active.
* @returns {number[]} The next DOM order, preserving the position of exiting ripples where possible.
*/
function mergeRippleOrder(prevOrder, nextActiveKeys) {
	const nextKeySet = new Set(nextActiveKeys);
	const nextKeysPending = /* @__PURE__ */ new Map();
	let pendingKeys = [];
	for (const prevKey of prevOrder) if (nextKeySet.has(prevKey)) {
		if (pendingKeys.length > 0) {
			nextKeysPending.set(prevKey, pendingKeys);
			pendingKeys = [];
		}
	} else pendingKeys.push(prevKey);
	const nextOrder = [];
	for (const nextKey of nextActiveKeys) {
		const pendingBefore = nextKeysPending.get(nextKey);
		if (pendingBefore) nextOrder.push(...pendingBefore);
		nextOrder.push(nextKey);
	}
	nextOrder.push(...pendingKeys);
	return nextOrder;
}
/**
* Calculate where the ripple should start and how large it must be to cover the host element.
*
* @param {object} params
* @param {object} params.event The mouse or touch event that started the ripple.
* @param {HTMLElement | null} params.element The host element used for measurements. Tests pass `null`.
* @param {boolean} params.center If `true`, start the ripple from the center of the host element.
* @returns {{ rippleX: number, rippleY: number, rippleSize: number }} The ripple position and size.
*/
function computeRippleState({ event, element, center }) {
	const rect = element ? element.getBoundingClientRect() : {
		width: 0,
		height: 0,
		left: 0,
		top: 0
	};
	let rippleX;
	let rippleY;
	if (center || event === void 0 || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
		rippleX = Math.round(rect.width / 2);
		rippleY = Math.round(rect.height / 2);
	} else {
		const { clientX, clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
		rippleX = Math.round(clientX - rect.left);
		rippleY = Math.round(clientY - rect.top);
	}
	let rippleSize;
	if (center) {
		rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
		if (rippleSize % 2 === 0) rippleSize += 1;
	} else {
		const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
		const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
		rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
	}
	return {
		rippleX,
		rippleY,
		rippleSize
	};
}
const enterKeyframe = keyframes`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const exitKeyframe = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const pulsateKeyframe = keyframes`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
function getAnimationStyles(theme) {
	if (theme.motion.reducedMotion === "always") return null;
	const styles = css`
    &.${touchRippleClasses.rippleVisible} {
      animation-name: ${enterKeyframe};
      animation-duration: ${DURATION}ms;
      animation-timing-function: ${theme.transitions.easing.easeInOut};
    }

    &.${touchRippleClasses.ripplePulsate} {
      animation-duration: ${theme.transitions.duration.shorter}ms;
    }

    & .${touchRippleClasses.childLeaving} {
      animation-name: ${exitKeyframe};
      animation-duration: ${DURATION}ms;
      animation-timing-function: ${theme.transitions.easing.easeInOut};
    }

    & .${touchRippleClasses.childPulsate} {
      animation-name: ${pulsateKeyframe};
      animation-duration: 2500ms;
      animation-timing-function: ${theme.transitions.easing.easeInOut};
      animation-iteration-count: infinite;
      animation-delay: 200ms;
    }
  `;
	if (theme.motion.reducedMotion === "system") return css`
      @media (prefers-reduced-motion: no-preference) {
        ${styles}
      }
    `;
	return styles;
}
const TouchRippleRoot = styled$2("span", {
	name: "MuiTouchRipple",
	slot: "Root"
})({
	overflow: "hidden",
	pointerEvents: "none",
	position: "absolute",
	zIndex: 0,
	top: 0,
	right: 0,
	bottom: 0,
	left: 0,
	borderRadius: "inherit"
});
const TouchRippleRipple = styled$2(Ripple, {
	name: "MuiTouchRipple",
	slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${touchRippleClasses.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
  }

  /*
   * Order matters: 'child', 'childLeaving' and 'childPulsate' apply to the same
   * element with equal specificity, so the later rule wins. 'child' must come
   * before 'childLeaving' so the leaving 'opacity: 0' takes precedence. A focus
   * (pulsate) ripple keeps 'pulsateKeyframe' (no opacity animation) on exit, so
   * it relies on this static 'opacity: 0' to disappear on blur instead of
   * lingering until removal.
   */
  & .${touchRippleClasses.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${touchRippleClasses.childLeaving} {
    opacity: 0;
  }

  & .${touchRippleClasses.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
  }

  ${({ theme }) => getAnimationStyles(theme)}
`;
/**
* @ignore - internal component.
*/
const TouchRipple = /*#__PURE__*/ React$1.forwardRef(function TouchRipple(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTouchRipple"
	});
	const reducedMotion = useReducedMotion(useTheme$1().motion.reducedMotion, false);
	const { center: centerProp = false, classes = EMPTY_OBJ, className, ...other } = props;
	const [rippleState, setRippleState] = React$1.useState({
		items: EMPTY_ARRAY,
		order: EMPTY_ARRAY
	});
	const ripples = rippleState.items;
	const nextKey = React$1.useRef(0);
	const rippleCallback = React$1.useRef(null);
	const mountedRef = React$1.useRef(false);
	useOnMount(() => {
		mountedRef.current = true;
		return () => {
			mountedRef.current = false;
		};
	});
	React$1.useEffect(() => {
		if (rippleCallback.current) {
			rippleCallback.current();
			rippleCallback.current = null;
		}
	}, [ripples]);
	const ignoringMouseDown = React$1.useRef(false);
	const startTimer = useTimeout();
	const startTimerCommit = React$1.useRef(null);
	const container = React$1.useRef(null);
	const handleExited = useEventCallback_default((key) => {
		if (!mountedRef.current) return;
		setRippleState((prevState) => {
			const nextItems = prevState.items.filter((ripple) => ripple.key !== key);
			return {
				items: nextItems,
				order: mergeRippleOrder(prevState.order.filter((rippleKey) => rippleKey !== key), nextItems.filter((ripple) => !ripple.exiting).map((ripple) => ripple.key))
			};
		});
	});
	const startCommit = useEventCallback_default((params) => {
		const { pulsate, rippleX, rippleY, rippleSize, cb } = params;
		const key = nextKey.current;
		nextKey.current += 1;
		setRippleState((prevState) => {
			const nextItems = [...prevState.items, {
				key,
				pulsate,
				rippleX,
				rippleY,
				rippleSize,
				exiting: false
			}];
			return {
				items: nextItems,
				order: mergeRippleOrder(prevState.order, nextItems.filter((ripple) => !ripple.exiting).map((ripple) => ripple.key))
			};
		});
		rippleCallback.current = cb;
	});
	const start = useEventCallback_default((event = EMPTY_OBJ, options = EMPTY_OBJ, cb = NOOP) => {
		const { pulsate = false, center = centerProp || options.pulsate, fakeElement = false } = options;
		if (event?.type === "mousedown" && ignoringMouseDown.current) {
			ignoringMouseDown.current = false;
			return;
		}
		if (event?.type === "touchstart") ignoringMouseDown.current = true;
		const { rippleX, rippleY, rippleSize } = computeRippleState({
			event,
			element: fakeElement ? null : container.current,
			center
		});
		if (event?.touches) {
			if (startTimerCommit.current === null) {
				startTimerCommit.current = () => {
					startCommit({
						pulsate,
						rippleX,
						rippleY,
						rippleSize,
						cb
					});
				};
				startTimer.start(80, () => {
					if (startTimerCommit.current) {
						startTimerCommit.current();
						startTimerCommit.current = null;
					}
				});
			}
		} else startCommit({
			pulsate,
			rippleX,
			rippleY,
			rippleSize,
			cb
		});
	});
	const pulsate = useEventCallback_default(() => {
		start(EMPTY_OBJ, { pulsate: true });
	});
	const stop = useEventCallback_default((event, cb) => {
		startTimer.clear();
		if (event?.type === "touchend" && startTimerCommit.current) {
			startTimerCommit.current();
			startTimerCommit.current = null;
			startTimer.start(0, () => {
				stop(event, cb);
			});
			return;
		}
		startTimerCommit.current = null;
		setRippleState((prevState) => {
			const firstActiveIndex = prevState.items.findIndex((ripple) => !ripple.exiting);
			if (firstActiveIndex === -1) return prevState;
			const nextItems = prevState.items.slice();
			nextItems[firstActiveIndex] = {
				...nextItems[firstActiveIndex],
				exiting: true
			};
			return {
				items: nextItems,
				order: mergeRippleOrder(prevState.order, nextItems.filter((ripple) => !ripple.exiting).map((ripple) => ripple.key))
			};
		});
		rippleCallback.current = cb;
	});
	React$1.useImperativeHandle(ref, () => ({
		pulsate,
		start,
		stop
	}), [
		pulsate,
		start,
		stop
	]);
	const rippleByKey = new Map(ripples.map((ripple) => [ripple.key, ripple]));
	const orderedRipples = rippleState.order.map((rippleKey) => rippleByKey.get(rippleKey)).filter(Boolean);
	return /*#__PURE__*/ jsx(TouchRippleRoot, {
		className: clsx(touchRippleClasses.root, classes.root, className),
		ref: container,
		...other,
		children: orderedRipples.map((ripple) => /*#__PURE__*/ jsx(TouchRippleRipple, {
			classes: {
				ripple: clsx(classes.ripple, touchRippleClasses.ripple),
				rippleVisible: clsx(classes.rippleVisible, touchRippleClasses.rippleVisible),
				ripplePulsate: clsx(classes.ripplePulsate, touchRippleClasses.ripplePulsate),
				child: clsx(classes.child, touchRippleClasses.child),
				childLeaving: clsx(classes.childLeaving, touchRippleClasses.childLeaving),
				childPulsate: clsx(classes.childPulsate, touchRippleClasses.childPulsate)
			},
			timeout: reducedMotion.shouldReduceMotion ? 0 : DURATION,
			pulsate: ripple.pulsate,
			rippleX: ripple.rippleX,
			rippleY: ripple.rippleY,
			rippleSize: ripple.rippleSize,
			in: !ripple.exiting,
			onExited: () => handleExited(ripple.key)
		}, ripple.key))
	});
});
TouchRipple.propTypes = {
	/**
	* If `true`, the ripple starts at the center of the component
	* rather than at the point of interaction.
	*/
	center: import_prop_types.default.bool,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ButtonBase/buttonBaseClasses.mjs
function getButtonBaseUtilityClass(slot) {
	return generateUtilityClass("MuiButtonBase", slot);
}
const buttonBaseClasses = generateUtilityClasses("MuiButtonBase", [
	"root",
	"disabled",
	"focusVisible"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ButtonBase/ButtonBase.mjs
const useUtilityClasses$72 = (ownerState) => {
	const { disabled, focusVisible, focusVisibleClassName, suppressFocusVisible, classes } = ownerState;
	const composedClasses = composeClasses({ root: [
		"root",
		disabled && "disabled",
		focusVisible && !suppressFocusVisible && "focusVisible"
	] }, getButtonBaseUtilityClass, classes);
	if (focusVisible && !suppressFocusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
	return composedClasses;
};
const ButtonBaseRoot = styled$2("button", {
	name: "MuiButtonBase",
	slot: "Root"
})(memoTheme(({ theme }) => ({
	display: "inline-flex",
	alignItems: "center",
	justifyContent: "center",
	position: "relative",
	boxSizing: "border-box",
	WebkitTapHighlightColor: "transparent",
	backgroundColor: "transparent",
	outline: 0,
	border: 0,
	margin: 0,
	borderRadius: 0,
	padding: 0,
	cursor: "pointer",
	userSelect: "none",
	verticalAlign: "middle",
	MozAppearance: "none",
	WebkitAppearance: "none",
	textDecoration: "none",
	color: "inherit",
	"&::-moz-focus-inner": { borderStyle: "none" },
	[`&.${buttonBaseClasses.disabled}`]: {
		pointerEvents: "none",
		cursor: "default"
	},
	"@media print": { colorAdjust: "exact" },
	variants: [{
		props: { internalDisabledThemeFocusVisible: false },
		style: theme.focusVisible && {
			...outsetFocusRing,
			[`&.${buttonBaseClasses.focusVisible}`]: theme.focusVisible
		}
	}]
})));
/**
* `ButtonBase` contains as few styles as possible.
* It aims to be a simple building block for creating a button.
* It contains a load of style reset and some focus/ripple logic.
*/
const ButtonBase = /*#__PURE__*/ React$1.forwardRef(function ButtonBase(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiButtonBase"
	});
	const { action, centerRipple = false, children, className, component = "button", disabled = false, disableRipple = false, disableTouchRipple = false, focusRipple = false, focusVisibleClassName, focusableWhenDisabled, suppressFocusVisible = false, internalNativeButton: internalNativeButtonProp, internalDisabledThemeFocusVisible = false, LinkComponent = "a", nativeButton: nativeButtonProp, onBlur, onClick: onClickProp, onContextMenu, onDragLeave, onFocus, onFocusVisible, onKeyDown: onKeyDownProp, onKeyUp: onKeyUpProp, onMouseDown, onMouseLeave, onMouseUp, onTouchEnd, onTouchMove, onTouchStart, tabIndex = 0, TouchRippleProps, touchRippleRef, type, ...other } = props;
	const isLink = Boolean(other.href || other.to);
	const hasFormAction = Boolean(other.formAction);
	let ComponentProp = component;
	if (ComponentProp === "button" && isLink) ComponentProp = LinkComponent;
	const internalNativeButton = typeof ComponentProp === "string" ? ComponentProp === "button" : internalNativeButtonProp ?? false;
	const nativeButton = nativeButtonProp ?? internalNativeButton;
	const ripple = useLazyRipple();
	const handleRippleRef = useForkRef_default(ripple.ref, touchRippleRef);
	const [focusVisible, setFocusVisible] = React$1.useState(false);
	if ((disabled || suppressFocusVisible) && focusVisible) setFocusVisible(false);
	const handleBeforeKeyDown = useEventCallback_default((event) => {
		if (focusRipple && !event.repeat && focusVisible && event.key === " ") ripple.stop(event, () => {
			ripple.start(event);
		});
	});
	const handleBeforeKeyUp = useEventCallback_default((event) => {
		if (focusRipple && event.key === " " && focusVisible && !event.defaultPrevented) ripple.stop(event, () => {
			ripple.pulsate(event);
		});
	});
	const { getButtonProps, rootRef: buttonRef } = useButtonBase({
		nativeButton,
		nativeButtonProp,
		internalNativeButton,
		allowInferredHostMismatch: isLink || typeof ComponentProp === "string",
		disabled,
		type,
		hasFormAction,
		tabIndex,
		onBeforeKeyDown: handleBeforeKeyDown,
		onBeforeKeyUp: handleBeforeKeyUp
	});
	const { onClick, onKeyDown, onKeyUp, ...buttonProps } = getButtonProps({
		onClick: onClickProp,
		onKeyDown: onKeyDownProp,
		onKeyUp: onKeyUpProp
	});
	React$1.useImperativeHandle(action, () => ({ focusVisible: () => {
		setFocusVisible(true);
		buttonRef.current.focus();
	} }), [buttonRef]);
	const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
	React$1.useEffect(() => {
		if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
	}, [
		disableRipple,
		focusRipple,
		focusVisible,
		ripple
	]);
	const handleMouseDown = useRippleHandler(ripple, "start", onMouseDown, disableTouchRipple);
	const handleContextMenu = useRippleHandler(ripple, "stop", onContextMenu, disableTouchRipple);
	const handleDragLeave = useRippleHandler(ripple, "stop", onDragLeave, disableTouchRipple);
	const handleMouseUp = useRippleHandler(ripple, "stop", onMouseUp, disableTouchRipple);
	const handleMouseLeave = useRippleHandler(ripple, "stop", (event) => {
		if (focusVisible) event.preventDefault();
		if (onMouseLeave) onMouseLeave(event);
	}, disableTouchRipple);
	const handleTouchStart = useRippleHandler(ripple, "start", onTouchStart, disableTouchRipple);
	const handleTouchEnd = useRippleHandler(ripple, "stop", onTouchEnd, disableTouchRipple);
	const handleTouchMove = useRippleHandler(ripple, "stop", onTouchMove, disableTouchRipple);
	const handleBlur = useRippleHandler(ripple, "stop", (event) => {
		if (!isFocusVisible(event.target)) setFocusVisible(false);
		if (onBlur) onBlur(event);
	}, false);
	const handleFocus = useEventCallback_default((event) => {
		if (!buttonRef.current) buttonRef.current = event.currentTarget;
		if (!suppressFocusVisible && isFocusVisible(event.target)) {
			setFocusVisible(true);
			if (onFocusVisible) onFocusVisible(event);
		}
		if (onFocus) onFocus(event);
	});
	const linkProps = {};
	if (isLink) {
		linkProps.tabIndex = disabled ? -1 : tabIndex;
		if (disabled) linkProps["aria-disabled"] = disabled;
		linkProps.type = type;
	}
	const handleRef = useForkRef_default(ref, buttonRef);
	const ownerState = {
		...props,
		centerRipple,
		component,
		disabled,
		disableRipple,
		disableTouchRipple,
		focusRipple,
		suppressFocusVisible,
		tabIndex,
		focusVisible,
		internalDisabledThemeFocusVisible
	};
	const classes = useUtilityClasses$72(ownerState);
	return /*#__PURE__*/ jsxs(ButtonBaseRoot, {
		as: ComponentProp,
		className: clsx(classes.root, className),
		ownerState,
		onBlur: handleBlur,
		onClick,
		onContextMenu: handleContextMenu,
		onFocus: handleFocus,
		onKeyDown,
		onKeyUp,
		onMouseDown: handleMouseDown,
		onMouseLeave: handleMouseLeave,
		onMouseUp: handleMouseUp,
		onDragLeave: handleDragLeave,
		onTouchEnd: handleTouchEnd,
		onTouchMove: handleTouchMove,
		onTouchStart: handleTouchStart,
		ref: handleRef,
		...isLink ? linkProps : buttonProps,
		...other,
		children: [children, enableTouchRipple ? /*#__PURE__*/ jsx(TouchRipple, {
			ref: handleRippleRef,
			center: centerRipple,
			...TouchRippleProps
		}) : null]
	});
});
function useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
	return useEventCallback_default((event) => {
		if (eventCallback) eventCallback(event);
		if (!skipRippleAction) ripple[rippleAction](event);
		return true;
	});
}
ButtonBase.propTypes = {
	/**
	* A ref for imperative actions.
	* It currently only supports `focusVisible()` action.
	*/
	action: refType,
	/**
	* If `true`, the ripples are centered.
	* They won't start at the cursor interaction position.
	* @default false
	*/
	centerRipple: import_prop_types.default.bool,
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: elementTypeAcceptingRef_default,
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the ripple effect is disabled.
	*
	* ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	* to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
	* @default false
	*/
	disableRipple: import_prop_types.default.bool,
	/**
	* If `true`, the touch ripple effect is disabled.
	* @default false
	*/
	disableTouchRipple: import_prop_types.default.bool,
	/**
	* If `true`, the base button will have a keyboard focus ripple.
	* @default false
	*/
	focusRipple: import_prop_types.default.bool,
	/**
	* This prop can help identify which element has keyboard focus.
	* The class name will be applied when the element gains the focus through keyboard interaction.
	* It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	* The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
	* A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
	* if needed.
	*/
	focusVisibleClassName: import_prop_types.default.string,
	/**
	* @ignore
	*/
	formAction: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.string]),
	/**
	* @ignore
	*/
	href: import_prop_types.default.any,
	/**
	* The component used to render a link when the `href` prop is provided.
	* @default 'a'
	*/
	LinkComponent: import_prop_types.default.elementType,
	/**
	* Whether the custom component is expected to render a native `<button>` element
	* when passing a React component to the `component` or `slots` prop.
	*/
	nativeButton: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	onBlur: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onClick: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onContextMenu: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onDragLeave: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onFocus: import_prop_types.default.func,
	/**
	* Callback fired when the component is focused with a keyboard.
	* We trigger a `onFocus` callback too.
	*/
	onFocusVisible: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onKeyDown: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onKeyUp: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onMouseDown: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onMouseLeave: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onMouseUp: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onTouchEnd: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onTouchMove: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onTouchStart: import_prop_types.default.func,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* @default 0
	*/
	tabIndex: import_prop_types.default.number,
	/**
	* Props applied to the `TouchRipple` element.
	*/
	TouchRippleProps: import_prop_types.default.object,
	/**
	* A ref that points to the `TouchRipple` element.
	*/
	touchRippleRef: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.shape({ current: import_prop_types.default.shape({
		pulsate: import_prop_types.default.func.isRequired,
		start: import_prop_types.default.func.isRequired,
		stop: import_prop_types.default.func.isRequired
	}) })]),
	/**
	* The HTML [`type`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/button#type)
	* attribute applied to `button` and `a` elements.
	* Ignored when rendering non-native buttons.
	* @default 'button'
	*/
	type: import_prop_types.default.string
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/createSimplePaletteValueFilter.mjs
/**
* Type guard to check if the object has a "main" property of type string.
*
* @param obj - the object to check
* @returns boolean
*/
function hasCorrectMainProperty(obj) {
	return typeof obj.main === "string";
}
/**
* Checks if the object conforms to the SimplePaletteColorOptions type.
* The minimum requirement is that the object has a "main" property of type string, this is always checked.
* Optionally, you can pass additional properties to check.
*
* @param obj - The object to check
* @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
* @returns boolean
*/
function checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
	if (!hasCorrectMainProperty(obj)) return false;
	for (const value of additionalPropertiesToCheck) if (!obj.hasOwnProperty(value) || typeof obj[value] !== "string") return false;
	return true;
}
/**
* Creates a filter function used to filter simple palette color options.
* The minimum requirement is that the object has a "main" property of type string, this is always checked.
* Optionally, you can pass additional properties to check.
*
* @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
* @returns ([, value]: [any, PaletteColorOptions]) => boolean
*/
function createSimplePaletteValueFilter(additionalPropertiesToCheck = []) {
	return ([, value]) => value && checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Alert/alertClasses.mjs
function getAlertUtilityClass(slot) {
	return generateUtilityClass("MuiAlert", slot);
}
const alertClasses = generateUtilityClasses("MuiAlert", [
	"root",
	"action",
	"icon",
	"message",
	"filled",
	"colorSuccess",
	"colorInfo",
	"colorWarning",
	"colorError",
	"outlined",
	"standard"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/CircularProgress/circularProgressClasses.mjs
function getCircularProgressUtilityClass(slot) {
	return generateUtilityClass("MuiCircularProgress", slot);
}
const circularProgressClasses = generateUtilityClasses("MuiCircularProgress", [
	"root",
	"determinate",
	"indeterminate",
	"colorPrimary",
	"colorSecondary",
	"svg",
	"track",
	"circle",
	"circleDisableShrink"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/CircularProgress/CircularProgress.mjs
const SIZE = 44;
let warnedMinMaxWithoutVariant$1 = false;
let warnedInvalidMinMaxValue$1 = false;
const circularRotateKeyframe = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const circularDashKeyframe = keyframes`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
const rotateAnimation = typeof circularRotateKeyframe !== "string" ? css`
        animation: ${circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const dashAnimation = typeof circularDashKeyframe !== "string" ? css`
        animation: ${circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const useUtilityClasses$71 = (ownerState) => {
	const { classes, variant, color, disableShrink } = ownerState;
	const slots = {
		root: [
			"root",
			variant,
			`color${capitalize_default(color)}`
		],
		svg: ["svg"],
		track: ["track"],
		circle: ["circle", disableShrink && "circleDisableShrink"]
	};
	return composeClasses(slots, getCircularProgressUtilityClass, classes);
};
const CircularProgressRoot = styled$2("span", {
	name: "MuiCircularProgress",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[ownerState.variant],
			styles[`color${capitalize_default(ownerState.color)}`]
		];
	}
})(memoTheme(({ theme }) => {
	const reducedMotionAnimationStyles = getReducedMotionStyles(theme, { animation: "none" });
	return {
		display: "inline-block",
		variants: [
			{
				props: { variant: "determinate" },
				style: { ...getTransitionStyles(theme, "transform") }
			},
			{
				props: { variant: "indeterminate" },
				style: rotateAnimation || { animation: `${circularRotateKeyframe} 1.4s linear infinite` }
			},
			...reducedMotionAnimationStyles ? [{
				props: { variant: "indeterminate" },
				style: reducedMotionAnimationStyles
			}] : [],
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
				props: { color },
				style: { color: (theme.vars || theme).palette[color].main }
			}))
		]
	};
}));
const CircularProgressSVG = styled$2("svg", {
	name: "MuiCircularProgress",
	slot: "Svg"
})({ display: "block" });
const CircularProgressCircle = styled$2("circle", {
	name: "MuiCircularProgress",
	slot: "Circle",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.circle, ownerState.disableShrink && styles.circleDisableShrink];
	}
})(memoTheme(({ theme }) => {
	const reducedMotionAnimationStyles = getReducedMotionStyles(theme, { animation: "none" });
	return {
		stroke: "currentColor",
		variants: [
			{
				props: { variant: "determinate" },
				style: { ...getTransitionStyles(theme, "stroke-dashoffset") }
			},
			{
				props: { variant: "indeterminate" },
				style: {
					strokeDasharray: "80px, 200px",
					strokeDashoffset: 0
				}
			},
			{
				props: ({ ownerState }) => ownerState.variant === "indeterminate" && !ownerState.disableShrink,
				style: dashAnimation || { animation: `${circularDashKeyframe} 1.4s ease-in-out infinite` }
			},
			...reducedMotionAnimationStyles ? [{
				props: ({ ownerState }) => ownerState.variant === "indeterminate" && !ownerState.disableShrink,
				style: reducedMotionAnimationStyles
			}] : []
		]
	};
}));
const CircularProgressTrack = styled$2("circle", {
	name: "MuiCircularProgress",
	slot: "Track"
})(memoTheme(({ theme }) => ({
	stroke: "currentColor",
	opacity: (theme.vars || theme).palette.action.activatedOpacity
})));
/**
* ## ARIA
*
* If the progress bar is describing the loading progress of a particular region of a page,
* you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
* attribute to `true` on that region until it has finished loading.
*/
const CircularProgress$1 = /*#__PURE__*/ React$1.forwardRef(function CircularProgress(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiCircularProgress"
	});
	const { className, color = "primary", disableShrink = false, enableTrackSlot = false, min: minProp, max: maxProp, size = 40, style, thickness = 3.6, value = props.min ?? 0, variant = "indeterminate", ...other } = props;
	if (!warnedMinMaxWithoutVariant$1 && variant === "indeterminate" && (minProp !== void 0 || maxProp !== void 0)) {
		console.warn(`MUI: You have provided the \`min\` or \`max\` props with an 'indeterminate' variant. These props will have no effect.`);
		warnedMinMaxWithoutVariant$1 = true;
	}
	const min = minProp ?? 0;
	const max = maxProp ?? 100;
	const ownerState = {
		...props,
		color,
		disableShrink,
		size,
		thickness,
		value,
		variant,
		enableTrackSlot
	};
	const classes = useUtilityClasses$71(ownerState);
	const circleStyle = {};
	const rootStyle = {};
	const rootProps = {};
	if (variant === "determinate") {
		const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
		if (!warnedInvalidMinMaxValue$1 && (value < min || value > max || min >= max)) {
			console.error(`MUI: The min, max, and value props in CircularProgress should be numbers where min < max and min <= value <= max. Received min=${min}, max=${max}, value=${value}.`);
			warnedInvalidMinMaxValue$1 = true;
		}
		const range = max - min;
		circleStyle.strokeDasharray = circumference.toFixed(3);
		circleStyle.strokeDashoffset = range > 0 ? `${((max - value) / range * circumference).toFixed(3)}px` : `${circumference.toFixed(3)}px`;
		rootStyle.transform = "rotate(-90deg)";
		rootProps["aria-valuenow"] = value;
		rootProps["aria-valuemin"] = min;
		rootProps["aria-valuemax"] = max;
	}
	return /*#__PURE__*/ jsx(CircularProgressRoot, {
		className: clsx(classes.root, className),
		style: {
			width: size,
			height: size,
			...rootStyle,
			...style
		},
		ownerState,
		ref,
		role: "progressbar",
		...rootProps,
		...other,
		children: /*#__PURE__*/ jsxs(CircularProgressSVG, {
			className: classes.svg,
			ownerState,
			viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
			children: [enableTrackSlot ? /*#__PURE__*/ jsx(CircularProgressTrack, {
				className: classes.track,
				ownerState,
				cx: SIZE,
				cy: SIZE,
				r: (SIZE - thickness) / 2,
				fill: "none",
				strokeWidth: thickness,
				"aria-hidden": "true"
			}) : null, /*#__PURE__*/ jsx(CircularProgressCircle, {
				className: classes.circle,
				style: circleStyle,
				ownerState,
				cx: SIZE,
				cy: SIZE,
				r: (SIZE - thickness) / 2,
				fill: "none",
				strokeWidth: thickness
			})]
		})
	});
});
CircularProgress$1.propTypes = {
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'primary'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"inherit",
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* If `true`, the shrink animation is disabled.
	* This only works if variant is `indeterminate`.
	* @default false
	*/
	disableShrink: chainPropTypes(import_prop_types.default.bool, (props) => {
		if (props.disableShrink && props.variant && props.variant !== "indeterminate") return /* @__PURE__ */ new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.");
		return null;
	}),
	/**
	* If `true`, a track circle slot is mounted to show a subtle background for the progress.
	* The `size` and `thickness` apply to the track slot to be consistent with the progress circle.
	* @default false
	*/
	enableTrackSlot: import_prop_types.default.bool,
	/**
	* The maximum value for the progress indicator for the determinate variant.
	* @default 100
	*/
	max: import_prop_types.default.number,
	/**
	* The minimum value for the progress indicator for the determinate variant.
	* @default 0
	*/
	min: import_prop_types.default.number,
	/**
	* The size of the component.
	* If using a number, the pixel unit is assumed.
	* If using a string, you need to provide the CSS unit, for example '3rem'.
	* @default 40
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* @ignore
	*/
	style: import_prop_types.default.object,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The thickness of the circle.
	* @default 3.6
	*/
	thickness: import_prop_types.default.number,
	/**
	* The value of the progress indicator for the determinate variant.
	* Value between `min` and `max`.
	* @default props.min ?? 0
	*/
	value: import_prop_types.default.number,
	/**
	* The variant to use.
	* Use indeterminate when there is no progress value.
	* @default 'indeterminate'
	*/
	variant: import_prop_types.default.oneOf(["determinate", "indeterminate"])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/IconButton/iconButtonClasses.mjs
function getIconButtonUtilityClass(slot) {
	return generateUtilityClass("MuiIconButton", slot);
}
const iconButtonClasses = generateUtilityClasses("MuiIconButton", [
	"root",
	"disabled",
	"colorInherit",
	"colorPrimary",
	"colorSecondary",
	"colorError",
	"colorInfo",
	"colorSuccess",
	"colorWarning",
	"edgeStart",
	"edgeEnd",
	"sizeSmall",
	"sizeMedium",
	"sizeLarge",
	"loading",
	"loadingIndicator",
	"loadingWrapper"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/IconButton/IconButton.mjs
const useUtilityClasses$70 = (ownerState) => {
	const { classes, disabled, color, edge, size, loading } = ownerState;
	const slots = {
		root: [
			"root",
			loading && "loading",
			disabled && "disabled",
			color !== "default" && `color${capitalize_default(color)}`,
			edge && `edge${capitalize_default(edge)}`,
			`size${capitalize_default(size)}`
		],
		loadingIndicator: ["loadingIndicator"],
		loadingWrapper: ["loadingWrapper"]
	};
	return composeClasses(slots, getIconButtonUtilityClass, classes);
};
const IconButtonRoot = styled$2(ButtonBase, {
	name: "MuiIconButton",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.loading && styles.loading,
			ownerState.color !== "default" && styles[`color${capitalize_default(ownerState.color)}`],
			ownerState.edge && styles[`edge${capitalize_default(ownerState.edge)}`],
			styles[`size${capitalize_default(ownerState.size)}`]
		];
	}
})(memoTheme(({ theme }) => ({
	textAlign: "center",
	flex: "0 0 auto",
	fontSize: theme.typography.pxToRem(24),
	padding: 8,
	borderRadius: "50%",
	color: (theme.vars || theme).palette.action.active,
	...getTransitionStyles(theme, "background-color", { duration: theme.transitions.duration.shortest }),
	variants: [
		{
			props: (props) => !props.disableRipple,
			style: {
				"--IconButton-hoverBg": theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
				"&:hover": {
					backgroundColor: "var(--IconButton-hoverBg)",
					"@media (hover: none)": { backgroundColor: "transparent" }
				}
			}
		},
		{
			props: { edge: "start" },
			style: { marginLeft: -12 }
		},
		{
			props: {
				edge: "start",
				size: "small"
			},
			style: { marginLeft: -3 }
		},
		{
			props: { edge: "end" },
			style: { marginRight: -12 }
		},
		{
			props: {
				edge: "end",
				size: "small"
			},
			style: { marginRight: -3 }
		}
	]
})), memoTheme(({ theme }) => ({
	variants: [
		{
			props: { color: "inherit" },
			style: { color: "inherit" }
		},
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
			props: { color },
			style: {
				color: (theme.vars || theme).palette[color].main,
				"--IconButton-hoverBg": theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
			}
		})),
		{
			props: { size: "small" },
			style: {
				padding: 5,
				fontSize: theme.typography.pxToRem(18)
			}
		},
		{
			props: { size: "large" },
			style: {
				padding: 12,
				fontSize: theme.typography.pxToRem(28)
			}
		}
	],
	[`&.${iconButtonClasses.disabled}`]: {
		backgroundColor: "transparent",
		color: (theme.vars || theme).palette.action.disabled
	},
	[`&.${iconButtonClasses.loading}`]: { color: "transparent" }
})));
const IconButtonLoadingIndicator = styled$2("span", {
	name: "MuiIconButton",
	slot: "LoadingIndicator"
})(({ theme }) => ({
	display: "none",
	position: "absolute",
	visibility: "visible",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	color: (theme.vars || theme).palette.action.disabled,
	variants: [{
		props: { loading: true },
		style: { display: "flex" }
	}]
}));
/**
* Refer to the [Icons](/material-ui/icons/) section of the documentation
* regarding the available icon options.
*/
const IconButton$1 = /*#__PURE__*/ React$1.forwardRef(function IconButton(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiIconButton"
	});
	const { edge = false, children, className, color = "default", disabled = false, disableFocusRipple = false, size = "medium", id: idProp, loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
	const loadingId = useId_default(idProp);
	const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ jsx(CircularProgress$1, {
		"aria-labelledby": loadingId,
		color: "inherit",
		size: 16
	});
	const ownerState = {
		...props,
		edge,
		color,
		disabled,
		disableFocusRipple,
		loading,
		loadingIndicator,
		size
	};
	const classes = useUtilityClasses$70(ownerState);
	return /*#__PURE__*/ jsxs(IconButtonRoot, {
		id: loading ? loadingId : idProp,
		className: clsx(classes.root, className),
		centerRipple: true,
		internalNativeButton: true,
		focusRipple: !disableFocusRipple,
		disabled: disabled || loading,
		ref,
		...other,
		ownerState,
		children: [typeof loading === "boolean" && /*#__PURE__*/ jsx("span", {
			className: classes.loadingWrapper,
			style: { display: "contents" },
			children: /*#__PURE__*/ jsx(IconButtonLoadingIndicator, {
				className: classes.loadingIndicator,
				ownerState,
				children: loading && loadingIndicator
			})
		}), children]
	});
});
IconButton$1.propTypes = {
	/**
	* The icon to display.
	*/
	children: chainPropTypes(import_prop_types.default.node, (props) => {
		if (React$1.Children.toArray(props.children).some((child) => /*#__PURE__*/ React$1.isValidElement(child) && child.props.onClick)) return new Error([
			"MUI: You are providing an onClick event listener to a child of a button element.",
			"Prefer applying it to the IconButton directly.",
			"This guarantees that the whole <button> will be responsive to click events."
		].join("\n"));
		return null;
	}),
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'default'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"inherit",
		"default",
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the  keyboard focus ripple is disabled.
	* @default false
	*/
	disableFocusRipple: import_prop_types.default.bool,
	/**
	* If `true`, the ripple effect is disabled.
	*
	* ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	* to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
	* @default false
	*/
	disableRipple: import_prop_types.default.bool,
	/**
	* If given, uses a negative margin to counteract the padding on one
	* side (this is often helpful for aligning the left or right
	* side of the icon with content above or below, without ruining the border
	* size and shape).
	* @default false
	*/
	edge: import_prop_types.default.oneOf([
		"end",
		"start",
		false
	]),
	/**
	* @ignore
	*/
	id: import_prop_types.default.string,
	/**
	* If `true`, the loading indicator is visible and the button is disabled.
	* If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
	* @default null
	*/
	loading: import_prop_types.default.bool,
	/**
	* Element placed before the children if the button is in loading state.
	* The node should contain an element with `role="progressbar"` with an accessible name.
	* By default, it renders a `CircularProgress` that is labeled by the button itself.
	* @default <CircularProgress color="inherit" size={16} />
	*/
	loadingIndicator: import_prop_types.default.node,
	/**
	* The size of the component.
	* `small` is equivalent to the dense button styling.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"small",
		"medium",
		"large"
	]), import_prop_types.default.string]),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/SuccessOutlined.mjs
/**
* @ignore - internal component.
*/
var SuccessOutlined_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" }), "SuccessOutlined");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/ReportProblemOutlined.mjs
/**
* @ignore - internal component.
*/
var ReportProblemOutlined_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z" }), "ReportProblemOutlined");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/ErrorOutline.mjs
/**
* @ignore - internal component.
*/
var ErrorOutline_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" }), "ErrorOutline");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/InfoOutlined.mjs
/**
* @ignore - internal component.
*/
var InfoOutlined_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z" }), "InfoOutlined");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/Close.mjs
/**
* @ignore - internal component.
*
* Alias to `Clear`.
*/
var Close_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }), "Close");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Alert/Alert.mjs
const useUtilityClasses$69 = (ownerState) => {
	const { variant, color, severity, classes } = ownerState;
	const slots = {
		root: [
			"root",
			`color${capitalize_default(color || severity)}`,
			`${variant}`
		],
		icon: ["icon"],
		message: ["message"],
		action: ["action"]
	};
	return composeClasses(slots, getAlertUtilityClass, classes);
};
const AlertRoot = styled$2(Paper, {
	name: "MuiAlert",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, styles[ownerState.variant]];
	}
})(memoTheme(({ theme }) => {
	const getColor = theme.palette.mode === "light" ? theme.darken : theme.lighten;
	const getBackgroundColor = theme.palette.mode === "light" ? theme.lighten : theme.darken;
	return {
		...theme.typography.body2,
		backgroundColor: "transparent",
		display: "flex",
		padding: "6px 16px",
		variants: [
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["light"])).map(([color]) => ({
				props: {
					colorSeverity: color,
					variant: "standard"
				},
				style: {
					color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, .6),
					backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, .9),
					[`& .${alertClasses.icon}`]: theme.vars ? { color: theme.vars.palette.Alert[`${color}IconColor`] } : { color: theme.palette[color].main }
				}
			})),
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["light"])).map(([color]) => ({
				props: {
					colorSeverity: color,
					variant: "outlined"
				},
				style: {
					color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, .6),
					border: `1px solid ${(theme.vars || theme).palette[color].light}`,
					[`& .${alertClasses.icon}`]: theme.vars ? { color: theme.vars.palette.Alert[`${color}IconColor`] } : { color: theme.palette[color].main }
				}
			})),
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["dark"])).map(([color]) => ({
				props: {
					colorSeverity: color,
					variant: "filled"
				},
				style: {
					...theme.focusVisible && applyChildrenFocusVisible(`0 0 0 4px ${(theme.vars || theme).palette.background.default}`),
					fontWeight: theme.typography.fontWeightMedium,
					...theme.vars ? {
						color: theme.vars.palette.Alert[`${color}FilledColor`],
						backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
					} : {
						backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
						color: theme.palette.getContrastText(theme.palette[color].main)
					}
				}
			}))
		]
	};
}));
const AlertIcon = styled$2("div", {
	name: "MuiAlert",
	slot: "Icon"
})({
	marginRight: 12,
	padding: "7px 0",
	display: "flex",
	fontSize: 22,
	opacity: .9
});
const AlertMessage = styled$2("div", {
	name: "MuiAlert",
	slot: "Message"
})({
	padding: "8px 0",
	minWidth: 0,
	overflow: "auto"
});
const AlertAction = styled$2("div", {
	name: "MuiAlert",
	slot: "Action"
})({
	display: "flex",
	alignItems: "flex-start",
	padding: "4px 0 0 16px",
	marginLeft: "auto",
	marginRight: -8
});
const defaultIconMapping = {
	success: /*#__PURE__*/ jsx(SuccessOutlined_default, { fontSize: "inherit" }),
	warning: /*#__PURE__*/ jsx(ReportProblemOutlined_default, { fontSize: "inherit" }),
	error: /*#__PURE__*/ jsx(ErrorOutline_default, { fontSize: "inherit" }),
	info: /*#__PURE__*/ jsx(InfoOutlined_default, { fontSize: "inherit" })
};
const Alert$1 = /*#__PURE__*/ React$1.forwardRef(function Alert(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiAlert"
	});
	const { action, children, className, closeText = "Close", color, icon, iconMapping = defaultIconMapping, onClose, role = "alert", severity = "success", slotProps = {}, slots = {}, variant = "standard", ...other } = props;
	const ownerState = {
		...props,
		color,
		severity,
		variant,
		colorSeverity: color || severity
	};
	const classes = useUtilityClasses$69(ownerState);
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [RootSlot, rootSlotProps] = useSlot("root", {
		ref,
		shouldForwardComponentProp: true,
		className: clsx(classes.root, className),
		elementType: AlertRoot,
		externalForwardedProps: {
			...externalForwardedProps,
			...other
		},
		ownerState,
		additionalProps: {
			role,
			elevation: 0
		}
	});
	const [IconSlot, iconSlotProps] = useSlot("icon", {
		className: classes.icon,
		elementType: AlertIcon,
		externalForwardedProps,
		ownerState
	});
	const [MessageSlot, messageSlotProps] = useSlot("message", {
		className: classes.message,
		elementType: AlertMessage,
		externalForwardedProps,
		ownerState
	});
	const [ActionSlot, actionSlotProps] = useSlot("action", {
		className: classes.action,
		elementType: AlertAction,
		externalForwardedProps,
		ownerState
	});
	const [CloseButtonSlot, closeButtonProps] = useSlot("closeButton", {
		elementType: IconButton$1,
		externalForwardedProps,
		ownerState
	});
	const [CloseIconSlot, closeIconProps] = useSlot("closeIcon", {
		elementType: Close_default,
		externalForwardedProps,
		ownerState
	});
	return /*#__PURE__*/ jsxs(RootSlot, {
		...rootSlotProps,
		children: [
			icon !== false ? /*#__PURE__*/ jsx(IconSlot, {
				...iconSlotProps,
				children: icon || iconMapping[severity] || defaultIconMapping[severity]
			}) : null,
			/*#__PURE__*/ jsx(MessageSlot, {
				...messageSlotProps,
				children
			}),
			action != null ? /*#__PURE__*/ jsx(ActionSlot, {
				...actionSlotProps,
				children: action
			}) : null,
			action == null && onClose ? /*#__PURE__*/ jsx(ActionSlot, {
				...actionSlotProps,
				children: /*#__PURE__*/ jsx(CloseButtonSlot, {
					size: "small",
					"aria-label": closeText,
					title: closeText,
					color: "inherit",
					onClick: onClose,
					...closeButtonProps,
					children: /*#__PURE__*/ jsx(CloseIconSlot, {
						fontSize: "small",
						...closeIconProps
					})
				})
			}) : null
		]
	});
});
Alert$1.propTypes = {
	/**
	* The action to display. It renders after the message, at the end of the alert.
	*/
	action: import_prop_types.default.node,
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* Override the default label for the *close popup* icon button.
	*
	* For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
	* @default 'Close'
	*/
	closeText: import_prop_types.default.string,
	/**
	* The color of the component. Unless provided, the value is taken from the `severity` prop.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* Override the icon displayed before the children.
	* Unless provided, the icon is mapped to the value of the `severity` prop.
	* Set to `false` to remove the `icon`.
	*/
	icon: import_prop_types.default.node,
	/**
	* The component maps the `severity` prop to a range of different icons,
	* for instance success to `<SuccessOutlined>`.
	* If you wish to change this mapping, you can provide your own.
	* Alternatively, you can use the `icon` prop to override the icon displayed.
	*/
	iconMapping: import_prop_types.default.shape({
		error: import_prop_types.default.node,
		info: import_prop_types.default.node,
		success: import_prop_types.default.node,
		warning: import_prop_types.default.node
	}),
	/**
	* Callback fired when the component requests to be closed.
	* When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
	* @param {React.SyntheticEvent} event The event source of the callback.
	*/
	onClose: import_prop_types.default.func,
	/**
	* The ARIA role attribute of the element.
	* @default 'alert'
	*/
	role: import_prop_types.default.string,
	/**
	* The severity of the alert. This defines the color and icon used.
	* @default 'success'
	*/
	severity: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		action: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		closeButton: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		closeIcon: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		icon: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		message: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		action: import_prop_types.default.elementType,
		closeButton: import_prop_types.default.elementType,
		closeIcon: import_prop_types.default.elementType,
		icon: import_prop_types.default.elementType,
		message: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The variant to use.
	* @default 'standard'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"filled",
		"outlined",
		"standard"
	]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Typography/typographyClasses.mjs
function getTypographyUtilityClass(slot) {
	return generateUtilityClass("MuiTypography", slot);
}
generateUtilityClasses("MuiTypography", [
	"root",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"subtitle1",
	"subtitle2",
	"body1",
	"body2",
	"inherit",
	"button",
	"caption",
	"overline",
	"alignLeft",
	"alignRight",
	"alignCenter",
	"alignJustify",
	"noWrap",
	"gutterBottom"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Typography/Typography.mjs
const useUtilityClasses$68 = (ownerState) => {
	const { align, gutterBottom, noWrap, variant, classes } = ownerState;
	const slots = { root: [
		"root",
		variant,
		ownerState.align !== "inherit" && `align${capitalize_default(align)}`,
		gutterBottom && "gutterBottom",
		noWrap && "noWrap"
	] };
	return composeClasses(slots, getTypographyUtilityClass, classes);
};
const TypographyRoot = styled$2("span", {
	name: "MuiTypography",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.variant && styles[ownerState.variant],
			ownerState.align !== "inherit" && styles[`align${capitalize_default(ownerState.align)}`],
			ownerState.noWrap && styles.noWrap,
			ownerState.gutterBottom && styles.gutterBottom
		];
	}
})(memoTheme(({ theme }) => ({
	margin: 0,
	variants: [
		{
			props: { variant: "inherit" },
			style: {
				font: "inherit",
				lineHeight: "inherit",
				letterSpacing: "inherit"
			}
		},
		...Object.entries(theme.typography).filter(([variant, value]) => variant !== "inherit" && value && typeof value === "object").map(([variant, value]) => ({
			props: { variant },
			style: value
		})),
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
			props: { color },
			style: { color: (theme.vars || theme).palette[color].main }
		})),
		...Object.entries(theme.palette?.text || {}).filter(([, value]) => typeof value === "string").map(([color]) => ({
			props: { color: `text${capitalize_default(color)}` },
			style: { color: (theme.vars || theme).palette.text[color] }
		})),
		{
			props: ({ ownerState }) => ownerState.align !== "inherit",
			style: { textAlign: "var(--Typography-textAlign)" }
		},
		{
			props: ({ ownerState }) => ownerState.noWrap,
			style: {
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap"
			}
		},
		{
			props: ({ ownerState }) => ownerState.gutterBottom,
			style: { marginBottom: "0.35em" }
		}
	]
})));
const defaultVariantMapping = {
	h1: "h1",
	h2: "h2",
	h3: "h3",
	h4: "h4",
	h5: "h5",
	h6: "h6",
	subtitle1: "h6",
	subtitle2: "h6",
	body1: "p",
	body2: "p",
	inherit: "p"
};
const Typography$1 = /*#__PURE__*/ React$1.forwardRef(function Typography(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTypography"
	});
	const { color, align = "inherit", className, component, gutterBottom = false, noWrap = false, variant = "body1", variantMapping = defaultVariantMapping, ...other } = props;
	const ownerState = {
		...props,
		align,
		color,
		className,
		component,
		gutterBottom,
		noWrap,
		variant,
		variantMapping
	};
	const Component = component || variantMapping[variant] || defaultVariantMapping[variant] || "span";
	const classes = useUtilityClasses$68(ownerState);
	return /*#__PURE__*/ jsx(TypographyRoot, {
		as: Component,
		ref,
		className: clsx(classes.root, className),
		...other,
		ownerState,
		style: {
			...align !== "inherit" && { "--Typography-textAlign": align },
			...other.style
		}
	});
});
Typography$1.propTypes = {
	/**
	* Set the text-align on the component.
	* @default 'inherit'
	*/
	align: import_prop_types.default.oneOf([
		"center",
		"inherit",
		"justify",
		"left",
		"right"
	]),
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"primary",
		"secondary",
		"success",
		"error",
		"info",
		"warning",
		"textPrimary",
		"textSecondary",
		"textDisabled"
	]), import_prop_types.default.string]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, the text will have a bottom margin.
	* @default false
	*/
	gutterBottom: import_prop_types.default.bool,
	/**
	* If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
	*
	* Note that text overflow can only happen with block or inline-block level elements
	* (the element needs to have a width in order to overflow).
	* @default false
	*/
	noWrap: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	style: import_prop_types.default.object,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* Applies the theme typography styles.
	* @default 'body1'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"body1",
		"body2",
		"button",
		"caption",
		"h1",
		"h2",
		"h3",
		"h4",
		"h5",
		"h6",
		"inherit",
		"overline",
		"subtitle1",
		"subtitle2"
	]), import_prop_types.default.string]),
	/**
	* The component maps the variant prop to a range of different HTML element types.
	* For instance, subtitle1 to `<h6>`.
	* If you wish to change that mapping, you can provide your own.
	* Alternatively, you can use the `component` prop.
	* @default {
	*   h1: 'h1',
	*   h2: 'h2',
	*   h3: 'h3',
	*   h4: 'h4',
	*   h5: 'h5',
	*   h6: 'h6',
	*   subtitle1: 'h6',
	*   subtitle2: 'h6',
	*   body1: 'p',
	*   body2: 'p',
	*   inherit: 'p',
	* }
	*/
	variantMapping: import_prop_types.default.object
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/AlertTitle/alertTitleClasses.mjs
function getAlertTitleUtilityClass(slot) {
	return generateUtilityClass("MuiAlertTitle", slot);
}
generateUtilityClasses("MuiAlertTitle", ["root"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/AlertTitle/AlertTitle.mjs
const useUtilityClasses$67 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({ root: ["root"] }, getAlertTitleUtilityClass, classes);
};
const AlertTitleRoot = styled$2(Typography$1, {
	name: "MuiAlertTitle",
	slot: "Root"
})(memoTheme(({ theme }) => {
	return {
		fontWeight: theme.typography.fontWeightMedium,
		marginTop: -2
	};
}));
const AlertTitle$1 = /*#__PURE__*/ React$1.forwardRef(function AlertTitle(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiAlertTitle"
	});
	const { className, ...other } = props;
	const ownerState = props;
	const classes = useUtilityClasses$67(ownerState);
	return /*#__PURE__*/ jsx(AlertTitleRoot, {
		gutterBottom: true,
		component: "div",
		ownerState,
		ref,
		className: clsx(classes.root, className),
		...other
	});
});
AlertTitle$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/AppBar/appBarClasses.mjs
function getAppBarUtilityClass(slot) {
	return generateUtilityClass("MuiAppBar", slot);
}
const appBarClasses = generateUtilityClasses("MuiAppBar", [
	"root",
	"positionFixed",
	"positionAbsolute",
	"positionSticky",
	"positionStatic",
	"positionRelative",
	"colorDefault",
	"colorPrimary",
	"colorSecondary",
	"colorInherit",
	"colorTransparent",
	"colorError",
	"colorInfo",
	"colorSuccess",
	"colorWarning"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/AppBar/AppBar.mjs
const useUtilityClasses$66 = (ownerState) => {
	const { color, position, classes } = ownerState;
	const slots = { root: [
		"root",
		`color${capitalize_default(color)}`,
		`position${capitalize_default(position)}`
	] };
	return composeClasses(slots, getAppBarUtilityClass, classes);
};
const joinVars = (var1, var2) => var1 ? `${var1.replace(")", "")}, ${var2})` : var2;
const AppBarRoot$1 = styled$2(Paper, {
	name: "MuiAppBar",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[`position${capitalize_default(ownerState.position)}`],
			styles[`color${capitalize_default(ownerState.color)}`]
		];
	}
})(memoTheme(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	width: "100%",
	boxSizing: "border-box",
	flexShrink: 0,
	variants: [
		{
			props: { position: "fixed" },
			style: {
				position: "fixed",
				zIndex: (theme.vars || theme).zIndex.appBar,
				top: 0,
				left: "auto",
				right: 0,
				"@media print": { position: "absolute" }
			}
		},
		{
			props: { position: "absolute" },
			style: {
				position: "absolute",
				zIndex: (theme.vars || theme).zIndex.appBar,
				top: 0,
				left: "auto",
				right: 0
			}
		},
		{
			props: { position: "sticky" },
			style: {
				position: "sticky",
				zIndex: (theme.vars || theme).zIndex.appBar,
				top: 0,
				left: "auto",
				right: 0
			}
		},
		{
			props: { position: "static" },
			style: { position: "static" }
		},
		{
			props: { position: "relative" },
			style: { position: "relative" }
		},
		{
			props: { color: "inherit" },
			style: {
				"--AppBar-color": "inherit",
				color: "var(--AppBar-color)"
			}
		},
		{
			props: { color: "default" },
			style: {
				"--AppBar-background": theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[100],
				"--AppBar-color": theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[100]),
				...theme.applyStyles("dark", {
					"--AppBar-background": theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[900],
					"--AppBar-color": theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[900])
				})
			}
		},
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["contrastText"])).map(([color]) => ({
			props: { color },
			style: {
				"--AppBar-background": (theme.vars ?? theme).palette[color].main,
				"--AppBar-color": (theme.vars ?? theme).palette[color].contrastText,
				...theme.focusVisible && applyChildrenFocusVisible(`0 0 0 4px ${(theme.vars || theme).palette.background.default}`)
			}
		})),
		{
			props: (props) => props.enableColorOnDark === true && !["inherit", "transparent"].includes(props.color),
			style: {
				backgroundColor: "var(--AppBar-background)",
				color: "var(--AppBar-color)"
			}
		},
		{
			props: (props) => props.enableColorOnDark === false && !["inherit", "transparent"].includes(props.color),
			style: {
				backgroundColor: "var(--AppBar-background)",
				color: "var(--AppBar-color)",
				...theme.applyStyles("dark", {
					backgroundColor: theme.vars ? joinVars(theme.vars.palette.AppBar.darkBg, "var(--AppBar-background)") : null,
					color: theme.vars ? joinVars(theme.vars.palette.AppBar.darkColor, "var(--AppBar-color)") : null
				})
			}
		},
		{
			props: { color: "transparent" },
			style: {
				"--AppBar-background": "transparent",
				"--AppBar-color": "inherit",
				backgroundColor: "var(--AppBar-background)",
				color: "var(--AppBar-color)",
				...theme.applyStyles("dark", { backgroundImage: "none" })
			}
		}
	]
})));
const AppBar$1 = /*#__PURE__*/ React$1.forwardRef(function AppBar(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiAppBar"
	});
	const { className, color = "primary", enableColorOnDark = false, position = "fixed", ...other } = props;
	const ownerState = {
		...props,
		color,
		position,
		enableColorOnDark
	};
	const classes = useUtilityClasses$66(ownerState);
	return /*#__PURE__*/ jsx(AppBarRoot$1, {
		square: true,
		component: "header",
		ownerState,
		elevation: 4,
		className: clsx(classes.root, className, position === "fixed" && "mui-fixed"),
		ref,
		...other
	});
});
AppBar$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'primary'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"default",
		"inherit",
		"primary",
		"secondary",
		"transparent",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* Shadow depth, corresponds to `dp` in the spec.
	* It accepts values between 0 and 24 inclusive.
	* @default 4
	*/
	elevation: import_prop_types.default.number,
	/**
	* If true, the `color` prop is applied in dark mode.
	* @default false
	*/
	enableColorOnDark: import_prop_types.default.bool,
	/**
	* The positioning type. The behavior of the different options is described
	* [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Web/CSS/Reference/Properties/position).
	* Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
	* @default 'fixed'
	*/
	position: import_prop_types.default.oneOf([
		"absolute",
		"fixed",
		"relative",
		"static",
		"sticky"
	]),
	/**
	* If `false`, rounded corners are enabled.
	* @default true
	*/
	square: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/contains/contains.mjs
/**
* Copied from @base-ui/utils
*
* Shadow DOM-aware containment check.
*
* Native `parent.contains(child)` returns `false` when the child is inside a
* shadow root that is a descendant of the parent. This function handles that
* case by traversing up through shadow root hosts.
*
* @param parent - The potential ancestor element.
* @param child - The potential descendant element.
* @returns Whether `parent` contains `child`, even across shadow root boundaries.
*/
function contains$1(parent, child) {
	if (!parent || !child) return false;
	if (parent.contains(child)) return true;
	const rootNode = child.getRootNode?.();
	if (rootNode && rootNode instanceof ShadowRoot) {
		let next = child;
		while (next) {
			if (parent === next) return true;
			next = next.parentNode ?? next.host ?? null;
		}
	}
	return false;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/usePreviousProps/usePreviousProps.mjs
function usePreviousProps(value) {
	const ref = React$1.useRef({});
	React$1.useEffect(() => {
		ref.current = value;
	});
	return ref.current;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/HTMLElementType/HTMLElementType.mjs
function HTMLElementType(props, propName, componentName, location, propFullName) {
	const propValue = props[propName];
	const safePropName = propFullName || propName;
	if (propValue == null) return null;
	if (propValue && propValue.nodeType !== 1) return /* @__PURE__ */ new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. Expected an HTMLElement.`);
	return null;
}
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [
	"top",
	bottom,
	right,
	left
];
var start = "start";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
	return acc.concat([placement + "-" + start, placement + "-end"]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
	return acc.concat([
		placement,
		placement + "-" + start,
		placement + "-end"
	]);
}, []);
var modifierPhases = [
	"beforeRead",
	"read",
	"afterRead",
	"beforeMain",
	"main",
	"afterMain",
	"beforeWrite",
	"write",
	"afterWrite"
];
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
	return element ? (element.nodeName || "").toLowerCase() : null;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
	if (node == null) return window;
	if (node.toString() !== "[object Window]") {
		var ownerDocument = node.ownerDocument;
		return ownerDocument ? ownerDocument.defaultView || window : window;
	}
	return node;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
function isElement(node) {
	return node instanceof getWindow(node).Element || node instanceof Element;
}
function isHTMLElement$1(node) {
	return node instanceof getWindow(node).HTMLElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
	if (typeof ShadowRoot === "undefined") return false;
	return node instanceof getWindow(node).ShadowRoot || node instanceof ShadowRoot;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/applyStyles.js
function applyStyles(_ref) {
	var state = _ref.state;
	Object.keys(state.elements).forEach(function(name) {
		var style = state.styles[name] || {};
		var attributes = state.attributes[name] || {};
		var element = state.elements[name];
		if (!isHTMLElement$1(element) || !getNodeName(element)) return;
		Object.assign(element.style, style);
		Object.keys(attributes).forEach(function(name) {
			var value = attributes[name];
			if (value === false) element.removeAttribute(name);
			else element.setAttribute(name, value === true ? "" : value);
		});
	});
}
function effect$2(_ref2) {
	var state = _ref2.state;
	var initialStyles = {
		popper: {
			position: state.options.strategy,
			left: "0",
			top: "0",
			margin: "0"
		},
		arrow: { position: "absolute" },
		reference: {}
	};
	Object.assign(state.elements.popper.style, initialStyles.popper);
	state.styles = initialStyles;
	if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
	return function() {
		Object.keys(state.elements).forEach(function(name) {
			var element = state.elements[name];
			var attributes = state.attributes[name] || {};
			var style = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]).reduce(function(style, property) {
				style[property] = "";
				return style;
			}, {});
			if (!isHTMLElement$1(element) || !getNodeName(element)) return;
			Object.assign(element.style, style);
			Object.keys(attributes).forEach(function(attribute) {
				element.removeAttribute(attribute);
			});
		});
	};
}
var applyStyles_default = {
	name: "applyStyles",
	enabled: true,
	phase: "write",
	fn: applyStyles,
	effect: effect$2,
	requires: ["computeStyles"]
};
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getBasePlacement.js
function getBasePlacement(placement) {
	return placement.split("-")[0];
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/math.js
var max = Math.max;
var min = Math.min;
var round$1 = Math.round;
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
	var uaData = navigator.userAgentData;
	if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
		return item.brand + "/" + item.version;
	}).join(" ");
	return navigator.userAgent;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js
function isLayoutViewport() {
	return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
	if (includeScale === void 0) includeScale = false;
	if (isFixedStrategy === void 0) isFixedStrategy = false;
	var clientRect = element.getBoundingClientRect();
	var scaleX = 1;
	var scaleY = 1;
	if (includeScale && isHTMLElement$1(element)) {
		scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
		scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
	}
	var visualViewport = (isElement(element) ? getWindow(element) : window).visualViewport;
	var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
	var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
	var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
	var width = clientRect.width / scaleX;
	var height = clientRect.height / scaleY;
	return {
		width,
		height,
		top: y,
		right: x + width,
		bottom: y + height,
		left: x,
		x,
		y
	};
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
function getLayoutRect(element) {
	var clientRect = getBoundingClientRect(element);
	var width = element.offsetWidth;
	var height = element.offsetHeight;
	if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
	if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
	return {
		x: element.offsetLeft,
		y: element.offsetTop,
		width,
		height
	};
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/contains.js
function contains(parent, child) {
	var rootNode = child.getRootNode && child.getRootNode();
	if (parent.contains(child)) return true;
	else if (rootNode && isShadowRoot(rootNode)) {
		var next = child;
		do {
			if (next && parent.isSameNode(next)) return true;
			next = next.parentNode || next.host;
		} while (next);
	}
	return false;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
function getComputedStyle$1(element) {
	return getWindow(element).getComputedStyle(element);
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isTableElement.js
function isTableElement(element) {
	return [
		"table",
		"td",
		"th"
	].indexOf(getNodeName(element)) >= 0;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
function getDocumentElement(element) {
	return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
function getParentNode(element) {
	if (getNodeName(element) === "html") return element;
	return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js
function getTrueOffsetParent(element) {
	if (!isHTMLElement$1(element) || getComputedStyle$1(element).position === "fixed") return null;
	return element.offsetParent;
}
function getContainingBlock(element) {
	var isFirefox = /firefox/i.test(getUAString());
	if (/Trident/i.test(getUAString()) && isHTMLElement$1(element)) {
		if (getComputedStyle$1(element).position === "fixed") return null;
	}
	var currentNode = getParentNode(element);
	if (isShadowRoot(currentNode)) currentNode = currentNode.host;
	while (isHTMLElement$1(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
		var css = getComputedStyle$1(currentNode);
		if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
		else currentNode = currentNode.parentNode;
	}
	return null;
}
function getOffsetParent(element) {
	var window = getWindow(element);
	var offsetParent = getTrueOffsetParent(element);
	while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") offsetParent = getTrueOffsetParent(offsetParent);
	if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static")) return window;
	return offsetParent || getContainingBlock(element) || window;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
	return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/within.js
function within(min$2, value, max$2) {
	return max(min$2, min(value, max$2));
}
function withinMaxClamp(min, value, max) {
	var v = within(min, value, max);
	return v > max ? max : v;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0
	};
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
function mergePaddingObject(paddingObject) {
	return Object.assign({}, getFreshSideObject(), paddingObject);
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
	return keys.reduce(function(hashMap, key) {
		hashMap[key] = value;
		return hashMap;
	}, {});
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/arrow.js
var toPaddingObject = function toPaddingObject(padding, state) {
	padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, { placement: state.placement })) : padding;
	return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
	var _state$modifiersData$;
	var state = _ref.state, name = _ref.name, options = _ref.options;
	var arrowElement = state.elements.arrow;
	var popperOffsets = state.modifiersData.popperOffsets;
	var basePlacement = getBasePlacement(state.placement);
	var axis = getMainAxisFromPlacement(basePlacement);
	var len = ["left", "right"].indexOf(basePlacement) >= 0 ? "height" : "width";
	if (!arrowElement || !popperOffsets) return;
	var paddingObject = toPaddingObject(options.padding, state);
	var arrowRect = getLayoutRect(arrowElement);
	var minProp = axis === "y" ? "top" : left;
	var maxProp = axis === "y" ? bottom : right;
	var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
	var startDiff = popperOffsets[axis] - state.rects.reference[axis];
	var arrowOffsetParent = getOffsetParent(arrowElement);
	var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
	var centerToReference = endDiff / 2 - startDiff / 2;
	var min = paddingObject[minProp];
	var max = clientSize - arrowRect[len] - paddingObject[maxProp];
	var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
	var offset = within(min, center, max);
	var axisProp = axis;
	state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect$1(_ref2) {
	var state = _ref2.state;
	var _options$element = _ref2.options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
	if (arrowElement == null) return;
	if (typeof arrowElement === "string") {
		arrowElement = state.elements.popper.querySelector(arrowElement);
		if (!arrowElement) return;
	}
	if (!contains(state.elements.popper, arrowElement)) return;
	state.elements.arrow = arrowElement;
}
var arrow_default = {
	name: "arrow",
	enabled: true,
	phase: "main",
	fn: arrow,
	effect: effect$1,
	requires: ["popperOffsets"],
	requiresIfExists: ["preventOverflow"]
};
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
	return placement.split("-")[1];
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var unsetSides = {
	top: "auto",
	right: "auto",
	bottom: "auto",
	left: "auto"
};
function roundOffsetsByDPR(_ref, win) {
	var x = _ref.x, y = _ref.y;
	var dpr = win.devicePixelRatio || 1;
	return {
		x: round$1(x * dpr) / dpr || 0,
		y: round$1(y * dpr) / dpr || 0
	};
}
function mapToStyles(_ref2) {
	var _Object$assign2;
	var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
	var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
	var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
		x,
		y
	}) : {
		x,
		y
	};
	x = _ref3.x;
	y = _ref3.y;
	var hasX = offsets.hasOwnProperty("x");
	var hasY = offsets.hasOwnProperty("y");
	var sideX = left;
	var sideY = "top";
	var win = window;
	if (adaptive) {
		var offsetParent = getOffsetParent(popper);
		var heightProp = "clientHeight";
		var widthProp = "clientWidth";
		if (offsetParent === getWindow(popper)) {
			offsetParent = getDocumentElement(popper);
			if (getComputedStyle$1(offsetParent).position !== "static" && position === "absolute") {
				heightProp = "scrollHeight";
				widthProp = "scrollWidth";
			}
		}
		offsetParent = offsetParent;
		if (placement === "top" || (placement === "left" || placement === "right") && variation === "end") {
			sideY = bottom;
			var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
			y -= offsetY - popperRect.height;
			y *= gpuAcceleration ? 1 : -1;
		}
		if (placement === "left" || (placement === "top" || placement === "bottom") && variation === "end") {
			sideX = right;
			var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
			x -= offsetX - popperRect.width;
			x *= gpuAcceleration ? 1 : -1;
		}
	}
	var commonStyles = Object.assign({ position }, adaptive && unsetSides);
	var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
		x,
		y
	}, getWindow(popper)) : {
		x,
		y
	};
	x = _ref4.x;
	y = _ref4.y;
	if (gpuAcceleration) {
		var _Object$assign;
		return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
	}
	return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
	var state = _ref5.state, options = _ref5.options;
	var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
	var commonStyles = {
		placement: getBasePlacement(state.placement),
		variation: getVariation(state.placement),
		popper: state.elements.popper,
		popperRect: state.rects.popper,
		gpuAcceleration,
		isFixed: state.options.strategy === "fixed"
	};
	if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
		offsets: state.modifiersData.popperOffsets,
		position: state.options.strategy,
		adaptive,
		roundOffsets
	})));
	if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
		offsets: state.modifiersData.arrow,
		position: "absolute",
		adaptive: false,
		roundOffsets
	})));
	state.attributes.popper = Object.assign({}, state.attributes.popper, { "data-popper-placement": state.placement });
}
var computeStyles_default = {
	name: "computeStyles",
	enabled: true,
	phase: "beforeWrite",
	fn: computeStyles,
	data: {}
};
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/eventListeners.js
var passive = { passive: true };
function effect(_ref) {
	var state = _ref.state, instance = _ref.instance, options = _ref.options;
	var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
	var window = getWindow(state.elements.popper);
	var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
	if (scroll) scrollParents.forEach(function(scrollParent) {
		scrollParent.addEventListener("scroll", instance.update, passive);
	});
	if (resize) window.addEventListener("resize", instance.update, passive);
	return function() {
		if (scroll) scrollParents.forEach(function(scrollParent) {
			scrollParent.removeEventListener("scroll", instance.update, passive);
		});
		if (resize) window.removeEventListener("resize", instance.update, passive);
	};
}
var eventListeners_default = {
	name: "eventListeners",
	enabled: true,
	phase: "write",
	fn: function fn() {},
	effect,
	data: {}
};
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash$1 = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function getOppositePlacement(placement) {
	return placement.replace(/left|right|bottom|top/g, function(matched) {
		return hash$1[matched];
	});
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var hash = {
	start: "end",
	end: "start"
};
function getOppositeVariationPlacement(placement) {
	return placement.replace(/start|end/g, function(matched) {
		return hash[matched];
	});
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
function getWindowScroll(node) {
	var win = getWindow(node);
	return {
		scrollLeft: win.pageXOffset,
		scrollTop: win.pageYOffset
	};
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
function getWindowScrollBarX(element) {
	return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js
function getViewportRect(element, strategy) {
	var win = getWindow(element);
	var html = getDocumentElement(element);
	var visualViewport = win.visualViewport;
	var width = html.clientWidth;
	var height = html.clientHeight;
	var x = 0;
	var y = 0;
	if (visualViewport) {
		width = visualViewport.width;
		height = visualViewport.height;
		var layoutViewport = isLayoutViewport();
		if (layoutViewport || !layoutViewport && strategy === "fixed") {
			x = visualViewport.offsetLeft;
			y = visualViewport.offsetTop;
		}
	}
	return {
		width,
		height,
		x: x + getWindowScrollBarX(element),
		y
	};
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js
function getDocumentRect(element) {
	var _element$ownerDocumen;
	var html = getDocumentElement(element);
	var winScroll = getWindowScroll(element);
	var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
	var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
	var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
	var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
	var y = -winScroll.scrollTop;
	if (getComputedStyle$1(body || html).direction === "rtl") x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
	return {
		width,
		height,
		x,
		y
	};
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
function isScrollParent(element) {
	var _getComputedStyle = getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
	return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js
function getScrollParent(node) {
	if ([
		"html",
		"body",
		"#document"
	].indexOf(getNodeName(node)) >= 0) return node.ownerDocument.body;
	if (isHTMLElement$1(node) && isScrollParent(node)) return node;
	return getScrollParent(getParentNode(node));
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js
function listScrollParents(element, list) {
	var _element$ownerDocumen;
	if (list === void 0) list = [];
	var scrollParent = getScrollParent(element);
	var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
	var win = getWindow(scrollParent);
	var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
	var updatedList = list.concat(target);
	return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
	return Object.assign({}, rect, {
		left: rect.x,
		top: rect.y,
		right: rect.x + rect.width,
		bottom: rect.y + rect.height
	});
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js
function getInnerBoundingClientRect(element, strategy) {
	var rect = getBoundingClientRect(element, false, strategy === "fixed");
	rect.top = rect.top + element.clientTop;
	rect.left = rect.left + element.clientLeft;
	rect.bottom = rect.top + element.clientHeight;
	rect.right = rect.left + element.clientWidth;
	rect.width = element.clientWidth;
	rect.height = element.clientHeight;
	rect.x = rect.left;
	rect.y = rect.top;
	return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
	return clippingParent === "viewport" ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
	var clippingParents = listScrollParents(getParentNode(element));
	var clipperElement = ["absolute", "fixed"].indexOf(getComputedStyle$1(element).position) >= 0 && isHTMLElement$1(element) ? getOffsetParent(element) : element;
	if (!isElement(clipperElement)) return [];
	return clippingParents.filter(function(clippingParent) {
		return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
	});
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
	var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
	var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
	var firstClippingParent = clippingParents[0];
	var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
		var rect = getClientRectFromMixedType(element, clippingParent, strategy);
		accRect.top = max(rect.top, accRect.top);
		accRect.right = min(rect.right, accRect.right);
		accRect.bottom = min(rect.bottom, accRect.bottom);
		accRect.left = max(rect.left, accRect.left);
		return accRect;
	}, getClientRectFromMixedType(element, firstClippingParent, strategy));
	clippingRect.width = clippingRect.right - clippingRect.left;
	clippingRect.height = clippingRect.bottom - clippingRect.top;
	clippingRect.x = clippingRect.left;
	clippingRect.y = clippingRect.top;
	return clippingRect;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/computeOffsets.js
function computeOffsets(_ref) {
	var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
	var basePlacement = placement ? getBasePlacement(placement) : null;
	var variation = placement ? getVariation(placement) : null;
	var commonX = reference.x + reference.width / 2 - element.width / 2;
	var commonY = reference.y + reference.height / 2 - element.height / 2;
	var offsets;
	switch (basePlacement) {
		case "top":
			offsets = {
				x: commonX,
				y: reference.y - element.height
			};
			break;
		case bottom:
			offsets = {
				x: commonX,
				y: reference.y + reference.height
			};
			break;
		case right:
			offsets = {
				x: reference.x + reference.width,
				y: commonY
			};
			break;
		case left:
			offsets = {
				x: reference.x - element.width,
				y: commonY
			};
			break;
		default: offsets = {
			x: reference.x,
			y: reference.y
		};
	}
	var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
	if (mainAxis != null) {
		var len = mainAxis === "y" ? "height" : "width";
		switch (variation) {
			case start:
				offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
				break;
			case "end": offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
		}
	}
	return offsets;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/detectOverflow.js
function detectOverflow(state, options) {
	if (options === void 0) options = {};
	var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
	var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
	var altContext = elementContext === "popper" ? reference : popper;
	var popperRect = state.rects.popper;
	var element = state.elements[altBoundary ? altContext : elementContext];
	var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
	var referenceClientRect = getBoundingClientRect(state.elements.reference);
	var popperOffsets = computeOffsets({
		reference: referenceClientRect,
		element: popperRect,
		strategy: "absolute",
		placement
	});
	var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
	var elementClientRect = elementContext === "popper" ? popperClientRect : referenceClientRect;
	var overflowOffsets = {
		top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
		bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
		left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
		right: elementClientRect.right - clippingClientRect.right + paddingObject.right
	};
	var offsetData = state.modifiersData.offset;
	if (elementContext === "popper" && offsetData) {
		var offset = offsetData[placement];
		Object.keys(overflowOffsets).forEach(function(key) {
			var multiply = ["right", "bottom"].indexOf(key) >= 0 ? 1 : -1;
			var axis = ["top", "bottom"].indexOf(key) >= 0 ? "y" : "x";
			overflowOffsets[key] += offset[axis] * multiply;
		});
	}
	return overflowOffsets;
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js
function computeAutoPlacement(state, options) {
	if (options === void 0) options = {};
	var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
	var variation = getVariation(placement);
	var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement) {
		return getVariation(placement) === variation;
	}) : basePlacements;
	var allowedPlacements = placements$1.filter(function(placement) {
		return allowedAutoPlacements.indexOf(placement) >= 0;
	});
	if (allowedPlacements.length === 0) allowedPlacements = placements$1;
	var overflows = allowedPlacements.reduce(function(acc, placement) {
		acc[placement] = detectOverflow(state, {
			placement,
			boundary,
			rootBoundary,
			padding
		})[getBasePlacement(placement)];
		return acc;
	}, {});
	return Object.keys(overflows).sort(function(a, b) {
		return overflows[a] - overflows[b];
	});
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/flip.js
function getExpandedFallbackPlacements(placement) {
	if (getBasePlacement(placement) === "auto") return [];
	var oppositePlacement = getOppositePlacement(placement);
	return [
		getOppositeVariationPlacement(placement),
		oppositePlacement,
		getOppositeVariationPlacement(oppositePlacement)
	];
}
function flip(_ref) {
	var state = _ref.state, options = _ref.options, name = _ref.name;
	if (state.modifiersData[name]._skip) return;
	var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
	var preferredPlacement = state.options.placement;
	var isBasePlacement = getBasePlacement(preferredPlacement) === preferredPlacement;
	var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
	var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement) {
		return acc.concat(getBasePlacement(placement) === "auto" ? computeAutoPlacement(state, {
			placement,
			boundary,
			rootBoundary,
			padding,
			flipVariations,
			allowedAutoPlacements
		}) : placement);
	}, []);
	var referenceRect = state.rects.reference;
	var popperRect = state.rects.popper;
	var checksMap = /* @__PURE__ */ new Map();
	var makeFallbackChecks = true;
	var firstFittingPlacement = placements[0];
	for (var i = 0; i < placements.length; i++) {
		var placement = placements[i];
		var _basePlacement = getBasePlacement(placement);
		var isStartVariation = getVariation(placement) === start;
		var isVertical = ["top", bottom].indexOf(_basePlacement) >= 0;
		var len = isVertical ? "width" : "height";
		var overflow = detectOverflow(state, {
			placement,
			boundary,
			rootBoundary,
			altBoundary,
			padding
		});
		var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : "top";
		if (referenceRect[len] > popperRect[len]) mainVariationSide = getOppositePlacement(mainVariationSide);
		var altVariationSide = getOppositePlacement(mainVariationSide);
		var checks = [];
		if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
		if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
		if (checks.every(function(check) {
			return check;
		})) {
			firstFittingPlacement = placement;
			makeFallbackChecks = false;
			break;
		}
		checksMap.set(placement, checks);
	}
	if (makeFallbackChecks) {
		var numberOfChecks = flipVariations ? 3 : 1;
		var _loop = function _loop(_i) {
			var fittingPlacement = placements.find(function(placement) {
				var checks = checksMap.get(placement);
				if (checks) return checks.slice(0, _i).every(function(check) {
					return check;
				});
			});
			if (fittingPlacement) {
				firstFittingPlacement = fittingPlacement;
				return "break";
			}
		};
		for (var _i = numberOfChecks; _i > 0; _i--) if (_loop(_i) === "break") break;
	}
	if (state.placement !== firstFittingPlacement) {
		state.modifiersData[name]._skip = true;
		state.placement = firstFittingPlacement;
		state.reset = true;
	}
}
var flip_default = {
	name: "flip",
	enabled: true,
	phase: "main",
	fn: flip,
	requiresIfExists: ["offset"],
	data: { _skip: false }
};
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/hide.js
function getSideOffsets(overflow, rect, preventedOffsets) {
	if (preventedOffsets === void 0) preventedOffsets = {
		x: 0,
		y: 0
	};
	return {
		top: overflow.top - rect.height - preventedOffsets.y,
		right: overflow.right - rect.width + preventedOffsets.x,
		bottom: overflow.bottom - rect.height + preventedOffsets.y,
		left: overflow.left - rect.width - preventedOffsets.x
	};
}
function isAnySideFullyClipped(overflow) {
	return [
		"top",
		right,
		bottom,
		left
	].some(function(side) {
		return overflow[side] >= 0;
	});
}
function hide(_ref) {
	var state = _ref.state, name = _ref.name;
	var referenceRect = state.rects.reference;
	var popperRect = state.rects.popper;
	var preventedOffsets = state.modifiersData.preventOverflow;
	var referenceOverflow = detectOverflow(state, { elementContext: "reference" });
	var popperAltOverflow = detectOverflow(state, { altBoundary: true });
	var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
	var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
	var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
	var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
	state.modifiersData[name] = {
		referenceClippingOffsets,
		popperEscapeOffsets,
		isReferenceHidden,
		hasPopperEscaped
	};
	state.attributes.popper = Object.assign({}, state.attributes.popper, {
		"data-popper-reference-hidden": isReferenceHidden,
		"data-popper-escaped": hasPopperEscaped
	});
}
var hide_default = {
	name: "hide",
	enabled: true,
	phase: "main",
	requiresIfExists: ["preventOverflow"],
	fn: hide
};
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/offset.js
function distanceAndSkiddingToXY(placement, rects, offset) {
	var basePlacement = getBasePlacement(placement);
	var invertDistance = ["left", "top"].indexOf(basePlacement) >= 0 ? -1 : 1;
	var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, { placement })) : offset, skidding = _ref[0], distance = _ref[1];
	skidding = skidding || 0;
	distance = (distance || 0) * invertDistance;
	return ["left", "right"].indexOf(basePlacement) >= 0 ? {
		x: distance,
		y: skidding
	} : {
		x: skidding,
		y: distance
	};
}
function offset(_ref2) {
	var state = _ref2.state, options = _ref2.options, name = _ref2.name;
	var _options$offset = options.offset, offset = _options$offset === void 0 ? [0, 0] : _options$offset;
	var data = placements.reduce(function(acc, placement) {
		acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
		return acc;
	}, {});
	var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
	if (state.modifiersData.popperOffsets != null) {
		state.modifiersData.popperOffsets.x += x;
		state.modifiersData.popperOffsets.y += y;
	}
	state.modifiersData[name] = data;
}
var offset_default = {
	name: "offset",
	enabled: true,
	phase: "main",
	requires: ["popperOffsets"],
	fn: offset
};
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
function popperOffsets(_ref) {
	var state = _ref.state, name = _ref.name;
	state.modifiersData[name] = computeOffsets({
		reference: state.rects.reference,
		element: state.rects.popper,
		strategy: "absolute",
		placement: state.placement
	});
}
var popperOffsets_default = {
	name: "popperOffsets",
	enabled: true,
	phase: "read",
	fn: popperOffsets,
	data: {}
};
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
	return axis === "x" ? "y" : "x";
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/preventOverflow.js
function preventOverflow(_ref) {
	var state = _ref.state, options = _ref.options, name = _ref.name;
	var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
	var overflow = detectOverflow(state, {
		boundary,
		rootBoundary,
		padding,
		altBoundary
	});
	var basePlacement = getBasePlacement(state.placement);
	var variation = getVariation(state.placement);
	var isBasePlacement = !variation;
	var mainAxis = getMainAxisFromPlacement(basePlacement);
	var altAxis = getAltAxis(mainAxis);
	var popperOffsets = state.modifiersData.popperOffsets;
	var referenceRect = state.rects.reference;
	var popperRect = state.rects.popper;
	var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, { placement: state.placement })) : tetherOffset;
	var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
		mainAxis: tetherOffsetValue,
		altAxis: tetherOffsetValue
	} : Object.assign({
		mainAxis: 0,
		altAxis: 0
	}, tetherOffsetValue);
	var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
	var data = {
		x: 0,
		y: 0
	};
	if (!popperOffsets) return;
	if (checkMainAxis) {
		var _offsetModifierState$;
		var mainSide = mainAxis === "y" ? "top" : left;
		var altSide = mainAxis === "y" ? bottom : right;
		var len = mainAxis === "y" ? "height" : "width";
		var offset = popperOffsets[mainAxis];
		var min$1 = offset + overflow[mainSide];
		var max$1 = offset - overflow[altSide];
		var additive = tether ? -popperRect[len] / 2 : 0;
		var minLen = variation === "start" ? referenceRect[len] : popperRect[len];
		var maxLen = variation === "start" ? -popperRect[len] : -referenceRect[len];
		var arrowElement = state.elements.arrow;
		var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
			width: 0,
			height: 0
		};
		var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
		var arrowPaddingMin = arrowPaddingObject[mainSide];
		var arrowPaddingMax = arrowPaddingObject[altSide];
		var arrowLen = within(0, referenceRect[len], arrowRect[len]);
		var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
		var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
		var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
		var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
		var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
		var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
		var tetherMax = offset + maxOffset - offsetModifierValue;
		var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
		popperOffsets[mainAxis] = preventedOffset;
		data[mainAxis] = preventedOffset - offset;
	}
	if (checkAltAxis) {
		var _offsetModifierState$2;
		var _mainSide = mainAxis === "x" ? "top" : left;
		var _altSide = mainAxis === "x" ? bottom : right;
		var _offset = popperOffsets[altAxis];
		var _len = altAxis === "y" ? "height" : "width";
		var _min = _offset + overflow[_mainSide];
		var _max = _offset - overflow[_altSide];
		var isOriginSide = ["top", left].indexOf(basePlacement) !== -1;
		var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
		var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
		var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
		var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
		popperOffsets[altAxis] = _preventedOffset;
		data[altAxis] = _preventedOffset - _offset;
	}
	state.modifiersData[name] = data;
}
var preventOverflow_default = {
	name: "preventOverflow",
	enabled: true,
	phase: "main",
	fn: preventOverflow,
	requiresIfExists: ["offset"]
};
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
	return {
		scrollLeft: element.scrollLeft,
		scrollTop: element.scrollTop
	};
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js
function getNodeScroll(node) {
	if (node === getWindow(node) || !isHTMLElement$1(node)) return getWindowScroll(node);
	else return getHTMLElementScroll(node);
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js
function isElementScaled(element) {
	var rect = element.getBoundingClientRect();
	var scaleX = round$1(rect.width) / element.offsetWidth || 1;
	var scaleY = round$1(rect.height) / element.offsetHeight || 1;
	return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
	if (isFixed === void 0) isFixed = false;
	var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
	var offsetParentIsScaled = isHTMLElement$1(offsetParent) && isElementScaled(offsetParent);
	var documentElement = getDocumentElement(offsetParent);
	var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
	var scroll = {
		scrollLeft: 0,
		scrollTop: 0
	};
	var offsets = {
		x: 0,
		y: 0
	};
	if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
		if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) scroll = getNodeScroll(offsetParent);
		if (isHTMLElement$1(offsetParent)) {
			offsets = getBoundingClientRect(offsetParent, true);
			offsets.x += offsetParent.clientLeft;
			offsets.y += offsetParent.clientTop;
		} else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
	}
	return {
		x: rect.left + scroll.scrollLeft - offsets.x,
		y: rect.top + scroll.scrollTop - offsets.y,
		width: rect.width,
		height: rect.height
	};
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/orderModifiers.js
function order(modifiers) {
	var map = /* @__PURE__ */ new Map();
	var visited = /* @__PURE__ */ new Set();
	var result = [];
	modifiers.forEach(function(modifier) {
		map.set(modifier.name, modifier);
	});
	function sort(modifier) {
		visited.add(modifier.name);
		[].concat(modifier.requires || [], modifier.requiresIfExists || []).forEach(function(dep) {
			if (!visited.has(dep)) {
				var depModifier = map.get(dep);
				if (depModifier) sort(depModifier);
			}
		});
		result.push(modifier);
	}
	modifiers.forEach(function(modifier) {
		if (!visited.has(modifier.name)) sort(modifier);
	});
	return result;
}
function orderModifiers(modifiers) {
	var orderedModifiers = order(modifiers);
	return modifierPhases.reduce(function(acc, phase) {
		return acc.concat(orderedModifiers.filter(function(modifier) {
			return modifier.phase === phase;
		}));
	}, []);
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
	var pending;
	return function() {
		if (!pending) pending = new Promise(function(resolve) {
			Promise.resolve().then(function() {
				pending = void 0;
				resolve(fn());
			});
		});
		return pending;
	};
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
	var merged = modifiers.reduce(function(merged, current) {
		var existing = merged[current.name];
		merged[current.name] = existing ? Object.assign({}, existing, current, {
			options: Object.assign({}, existing.options, current.options),
			data: Object.assign({}, existing.data, current.data)
		}) : current;
		return merged;
	}, {});
	return Object.keys(merged).map(function(key) {
		return merged[key];
	});
}
//#endregion
//#region ../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/createPopper.js
var DEFAULT_OPTIONS = {
	placement: "bottom",
	modifiers: [],
	strategy: "absolute"
};
function areValidElements() {
	for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
	return !args.some(function(element) {
		return !(element && typeof element.getBoundingClientRect === "function");
	});
}
function popperGenerator(generatorOptions) {
	if (generatorOptions === void 0) generatorOptions = {};
	var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
	return function createPopper(reference, popper, options) {
		if (options === void 0) options = defaultOptions;
		var state = {
			placement: "bottom",
			orderedModifiers: [],
			options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
			modifiersData: {},
			elements: {
				reference,
				popper
			},
			attributes: {},
			styles: {}
		};
		var effectCleanupFns = [];
		var isDestroyed = false;
		var instance = {
			state,
			setOptions: function setOptions(setOptionsAction) {
				var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
				cleanupModifierEffects();
				state.options = Object.assign({}, defaultOptions, state.options, options);
				state.scrollParents = {
					reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
					popper: listScrollParents(popper)
				};
				var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers)));
				state.orderedModifiers = orderedModifiers.filter(function(m) {
					return m.enabled;
				});
				runModifierEffects();
				return instance.update();
			},
			forceUpdate: function forceUpdate() {
				if (isDestroyed) return;
				var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
				if (!areValidElements(reference, popper)) return;
				state.rects = {
					reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === "fixed"),
					popper: getLayoutRect(popper)
				};
				state.reset = false;
				state.placement = state.options.placement;
				state.orderedModifiers.forEach(function(modifier) {
					return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
				});
				for (var index = 0; index < state.orderedModifiers.length; index++) {
					if (state.reset === true) {
						state.reset = false;
						index = -1;
						continue;
					}
					var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
					if (typeof fn === "function") state = fn({
						state,
						options: _options,
						name,
						instance
					}) || state;
				}
			},
			update: debounce(function() {
				return new Promise(function(resolve) {
					instance.forceUpdate();
					resolve(state);
				});
			}),
			destroy: function destroy() {
				cleanupModifierEffects();
				isDestroyed = true;
			}
		};
		if (!areValidElements(reference, popper)) return instance;
		instance.setOptions(options).then(function(state) {
			if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
		});
		function runModifierEffects() {
			state.orderedModifiers.forEach(function(_ref) {
				var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
				if (typeof effect === "function") {
					var cleanupFn = effect({
						state,
						name,
						instance,
						options
					});
					effectCleanupFns.push(cleanupFn || function noopFn() {});
				}
			});
		}
		function cleanupModifierEffects() {
			effectCleanupFns.forEach(function(fn) {
				return fn();
			});
			effectCleanupFns = [];
		}
		return instance;
	};
}
var createPopper = /*#__PURE__*/ popperGenerator({ defaultModifiers: [
	eventListeners_default,
	popperOffsets_default,
	computeStyles_default,
	applyStyles_default,
	offset_default,
	flip_default,
	preventOverflow_default,
	arrow_default,
	hide_default
] });
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useSlotProps/useSlotProps.mjs
/**
* @ignore - do not document.
* Builds the props to be passed into the slot of an unstyled component.
* It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
* If the slot component is not a host component, it also merges in the `ownerState`.
*
* @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
*/
function useSlotProps(parameters) {
	const { elementType, externalSlotProps, ownerState, skipResolvingSlotProps = false, ...other } = parameters;
	const resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
	const { props: mergedProps, internalRef } = mergeSlotProps({
		...other,
		externalSlotProps: resolvedComponentsProps
	});
	const ref = useForkRef(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
	return appendOwnerState(elementType, {
		...mergedProps,
		ref
	}, ownerState);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/isLayoutSupported.mjs
function isLayoutSupported() {
	return !(/jsdom|HappyDOM/.test(window.navigator.userAgent) || false);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/getReactElementRef/getReactElementRef.mjs
/**
* Returns the ref of a React element handling differences between React 19 and older versions.
* It will throw runtime error if the element is not a valid React element.
*
* @param element React.ReactElement
* @returns React.Ref<any> | null
*/
function getReactElementRef(element) {
	if (parseInt(React$1.version, 10) >= 19) return element?.props?.ref || null;
	return element?.ref || null;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Portal/Portal.mjs
function getContainer$1(container) {
	return typeof container === "function" ? container() : container;
}
/**
* Portals provide a first-class way to render children into a DOM node
* that exists outside the DOM hierarchy of the parent component.
*
* Demos:
*
* - [Portal](https://mui.com/material-ui/react-portal/)
*
* API:
*
* - [Portal API](https://mui.com/material-ui/api/portal/)
*/
const Portal = /*#__PURE__*/ React$1.forwardRef(function Portal(props, forwardedRef) {
	const { children, container, disablePortal = false } = props;
	const [mountNode, setMountNode] = React$1.useState(null);
	const handleRef = useForkRef(/*#__PURE__*/ React$1.isValidElement(children) ? getReactElementRef(children) : null, forwardedRef);
	useEnhancedEffect(() => {
		if (!disablePortal) setMountNode(getContainer$1(container) || document.body);
	}, [container, disablePortal]);
	useEnhancedEffect(() => {
		if (mountNode && !disablePortal) {
			setRef(forwardedRef, mountNode);
			return () => {
				setRef(forwardedRef, null);
			};
		}
	}, [
		forwardedRef,
		mountNode,
		disablePortal
	]);
	if (disablePortal) {
		if (/*#__PURE__*/ React$1.isValidElement(children)) {
			const newProps = { ref: handleRef };
			return /*#__PURE__*/ React$1.cloneElement(children, newProps);
		}
		return children;
	}
	return mountNode ? /*#__PURE__*/ ReactDOM.createPortal(children, mountNode) : mountNode;
});
Portal.propTypes = {
	/**
	* The children to render into the `container`.
	*/
	children: import_prop_types.default.node,
	/**
	* An HTML element or function that returns one.
	* The `container` will have the portal children appended to it.
	*
	* You can also provide a callback, which is called in a React layout effect.
	* This lets you set the container from a ref, and also makes server-side rendering possible.
	*
	* By default, it uses the body of the top-level document object,
	* so it's simply `document.body` most of the time.
	*/
	container: import_prop_types.default.oneOfType([HTMLElementType, import_prop_types.default.func]),
	/**
	* The `children` will be under the DOM hierarchy of the parent component.
	* @default false
	*/
	disablePortal: import_prop_types.default.bool
};
Portal["propTypes"] = exactProp(Portal.propTypes);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Popper/popperClasses.mjs
function getPopperUtilityClass(slot) {
	return generateUtilityClass("MuiPopper", slot);
}
generateUtilityClasses("MuiPopper", ["root"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Popper/BasePopper.mjs
function flipPlacement(placement, direction) {
	if (direction === "ltr") return placement;
	switch (placement) {
		case "bottom-end": return "bottom-start";
		case "bottom-start": return "bottom-end";
		case "top-end": return "top-start";
		case "top-start": return "top-end";
		default: return placement;
	}
}
function resolveAnchorEl$1(anchorEl) {
	return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function isHTMLElement(element) {
	return element.nodeType !== void 0;
}
function isVirtualElement(element) {
	return !isHTMLElement(element);
}
const useUtilityClasses$65 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({ root: ["root"] }, getPopperUtilityClass, classes);
};
const defaultPopperOptions = {};
const PopperTooltip = /*#__PURE__*/ React$1.forwardRef(function PopperTooltip(props, forwardedRef) {
	const { anchorEl, children, direction, disablePortal, modifiers, open, placement: initialPlacement, popperOptions, popperRef: popperRefProp, slotProps = {}, slots = {}, TransitionProps, ownerState: ownerStateProp, ...other } = props;
	const tooltipRef = React$1.useRef(null);
	const ownRef = useForkRef(tooltipRef, forwardedRef);
	const popperRef = React$1.useRef(null);
	const handlePopperRef = useForkRef(popperRef, popperRefProp);
	const handlePopperRefRef = React$1.useRef(handlePopperRef);
	useEnhancedEffect(() => {
		handlePopperRefRef.current = handlePopperRef;
	}, [handlePopperRef]);
	React$1.useImperativeHandle(popperRefProp, () => popperRef.current, []);
	const rtlPlacement = flipPlacement(initialPlacement, direction);
	/**
	* placement initialized from prop but can change during lifetime if modifiers.flip.
	* modifiers.flip is essentially a flip for controlled/uncontrolled behavior
	*/
	const [placement, setPlacement] = React$1.useState(rtlPlacement);
	const resolvedAnchorElement = React$1.useMemo(() => resolveAnchorEl$1(anchorEl), [anchorEl]);
	React$1.useEffect(() => {
		if (popperRef.current) popperRef.current.forceUpdate();
	});
	useEnhancedEffect(() => {
		if (!resolvedAnchorElement || !open) return;
		const handlePopperUpdate = (data) => {
			setPlacement(data.placement);
		};
		if (resolvedAnchorElement && isHTMLElement(resolvedAnchorElement) && resolvedAnchorElement.nodeType === 1) {
			const box = resolvedAnchorElement.getBoundingClientRect();
			if (isLayoutSupported() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) console.warn([
				"MUI: The `anchorEl` prop provided to the component is invalid.",
				"The anchor element should be part of the document layout.",
				"Make sure the element is present in the document or that it's not display none."
			].join("\n"));
		}
		let popperModifiers = [
			{
				name: "preventOverflow",
				options: { altBoundary: disablePortal }
			},
			{
				name: "flip",
				options: { altBoundary: disablePortal }
			},
			{
				name: "onUpdate",
				enabled: true,
				phase: "afterWrite",
				fn: ({ state }) => {
					handlePopperUpdate(state);
				}
			}
		];
		if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
		if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
		const popper = createPopper(resolvedAnchorElement, tooltipRef.current, {
			placement: rtlPlacement,
			...popperOptions,
			modifiers: popperModifiers
		});
		handlePopperRefRef.current(popper);
		const popperElement = tooltipRef.current;
		return () => {
			if (popperElement) {
				const { style } = popperElement;
				const position = style.position;
				const top = style.top;
				const left = style.left;
				const transform = style.transform;
				popper.destroy();
				style.position = position;
				style.top = top;
				style.left = left;
				style.transform = transform;
			} else popper.destroy();
			handlePopperRefRef.current(null);
		};
	}, [
		resolvedAnchorElement,
		disablePortal,
		modifiers,
		open,
		popperOptions,
		rtlPlacement
	]);
	const childProps = { placement };
	if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
	const classes = useUtilityClasses$65(props);
	const Root = slots.root ?? "div";
	const rootProps = useSlotProps({
		elementType: Root,
		externalSlotProps: slotProps.root,
		externalForwardedProps: other,
		additionalProps: {
			role: "tooltip",
			ref: ownRef
		},
		ownerState: props,
		className: classes.root
	});
	return /*#__PURE__*/ jsx(Root, {
		...rootProps,
		children: typeof children === "function" ? children(childProps) : children
	});
});
/**
* @ignore - internal component.
*/
const Popper$1 = /*#__PURE__*/ React$1.forwardRef(function Popper(props, forwardedRef) {
	const { anchorEl, children, container: containerProp, direction = "ltr", disablePortal = false, keepMounted = false, modifiers, open, placement = "bottom", popperOptions = defaultPopperOptions, popperRef, style, transition = false, slotProps = {}, slots = {}, ...other } = props;
	const [exited, setExited] = React$1.useState(true);
	const handleEnter = () => {
		setExited(false);
	};
	const handleExited = () => {
		setExited(true);
	};
	if (!keepMounted && !open && (!transition || exited)) return null;
	let container;
	if (containerProp) container = containerProp;
	else if (anchorEl) {
		const resolvedAnchorEl = resolveAnchorEl$1(anchorEl);
		container = resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) ? ownerDocument(resolvedAnchorEl).body : ownerDocument(null).body;
	}
	const display = !open && keepMounted && (!transition || exited) ? "none" : void 0;
	const transitionProps = transition ? {
		in: open,
		onEnter: handleEnter,
		onExited: handleExited
	} : void 0;
	return /*#__PURE__*/ jsx(Portal, {
		disablePortal,
		container,
		children: /*#__PURE__*/ jsx(PopperTooltip, {
			anchorEl,
			direction,
			disablePortal,
			modifiers,
			ref: forwardedRef,
			open: transition ? !exited : open,
			placement,
			popperOptions,
			popperRef,
			slotProps,
			slots,
			...other,
			style: {
				position: "fixed",
				top: 0,
				left: 0,
				display,
				...style
			},
			TransitionProps: transitionProps,
			children
		})
	});
});
Popper$1.propTypes = {
	/**
	* An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
	* or a function that returns either.
	* It's used to set the position of the popper.
	* The return value will passed as the reference object of the Popper instance.
	*/
	anchorEl: chainPropTypes(import_prop_types.default.oneOfType([
		HTMLElementType,
		import_prop_types.default.object,
		import_prop_types.default.func
	]), (props) => {
		if (props.open) {
			const resolvedAnchorEl = resolveAnchorEl$1(props.anchorEl);
			if (resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) && resolvedAnchorEl.nodeType === 1) {
				const box = resolvedAnchorEl.getBoundingClientRect();
				if (isLayoutSupported() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
					"MUI: The `anchorEl` prop provided to the component is invalid.",
					"The anchor element should be part of the document layout.",
					"Make sure the element is present in the document or that it's not display none."
				].join("\n"));
			} else if (!resolvedAnchorEl || typeof resolvedAnchorEl.getBoundingClientRect !== "function" || isVirtualElement(resolvedAnchorEl) && resolvedAnchorEl.contextElement != null && resolvedAnchorEl.contextElement.nodeType !== 1) return new Error([
				"MUI: The `anchorEl` prop provided to the component is invalid.",
				"It should be an HTML element instance or a virtualElement ",
				"(https://popper.js.org/docs/v2/virtual-elements/)."
			].join("\n"));
		}
		return null;
	}),
	/**
	* Popper render function or node.
	*/
	children: import_prop_types.default.oneOfType([import_prop_types.default.node, import_prop_types.default.func]),
	/**
	* An HTML element or function that returns one.
	* The `container` will have the portal children appended to it.
	*
	* You can also provide a callback, which is called in a React layout effect.
	* This lets you set the container from a ref, and also makes server-side rendering possible.
	*
	* By default, it uses the body of the top-level document object,
	* so it's simply `document.body` most of the time.
	*/
	container: import_prop_types.default.oneOfType([HTMLElementType, import_prop_types.default.func]),
	/**
	* Direction of the text.
	* @default 'ltr'
	*/
	direction: import_prop_types.default.oneOf(["ltr", "rtl"]),
	/**
	* The `children` will be under the DOM hierarchy of the parent component.
	* @default false
	*/
	disablePortal: import_prop_types.default.bool,
	/**
	* Always keep the children in the DOM.
	* This prop can be useful in SEO situation or
	* when you want to maximize the responsiveness of the Popper.
	* @default false
	*/
	keepMounted: import_prop_types.default.bool,
	/**
	* Popper.js is based on a "plugin-like" architecture,
	* most of its features are fully encapsulated "modifiers".
	*
	* A modifier is a function that is called each time Popper.js needs to
	* compute the position of the popper.
	* For this reason, modifiers should be very performant to avoid bottlenecks.
	* To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
	*/
	modifiers: import_prop_types.default.arrayOf(import_prop_types.default.shape({
		data: import_prop_types.default.object,
		effect: import_prop_types.default.func,
		enabled: import_prop_types.default.bool,
		fn: import_prop_types.default.func,
		name: import_prop_types.default.any,
		options: import_prop_types.default.object,
		phase: import_prop_types.default.oneOf([
			"afterMain",
			"afterRead",
			"afterWrite",
			"beforeMain",
			"beforeRead",
			"beforeWrite",
			"main",
			"read",
			"write"
		]),
		requires: import_prop_types.default.arrayOf(import_prop_types.default.string),
		requiresIfExists: import_prop_types.default.arrayOf(import_prop_types.default.string)
	})),
	/**
	* If `true`, the component is shown.
	*/
	open: import_prop_types.default.bool.isRequired,
	/**
	* Popper placement.
	* @default 'bottom'
	*/
	placement: import_prop_types.default.oneOf([
		"auto-end",
		"auto-start",
		"auto",
		"bottom-end",
		"bottom-start",
		"bottom",
		"left-end",
		"left-start",
		"left",
		"right-end",
		"right-start",
		"right",
		"top-end",
		"top-start",
		"top"
	]),
	/**
	* Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
	* @default {}
	*/
	popperOptions: import_prop_types.default.shape({
		modifiers: import_prop_types.default.array,
		onFirstUpdate: import_prop_types.default.func,
		placement: import_prop_types.default.oneOf([
			"auto-end",
			"auto-start",
			"auto",
			"bottom-end",
			"bottom-start",
			"bottom",
			"left-end",
			"left-start",
			"left",
			"right-end",
			"right-start",
			"right",
			"top-end",
			"top-start",
			"top"
		]),
		strategy: import_prop_types.default.oneOf(["absolute", "fixed"])
	}),
	/**
	* A ref that points to the used popper instance.
	*/
	popperRef: refType,
	/**
	* The props used for each slot inside the Popper.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({ root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]) }),
	/**
	* The components used for each slot inside the Popper.
	* Either a string to use a HTML element or a component.
	* @default {}
	*/
	slots: import_prop_types.default.shape({ root: import_prop_types.default.elementType }),
	/**
	* Help supporting a react-transition-group/Transition component.
	* @default false
	*/
	transition: import_prop_types.default.bool
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Popper/Popper.mjs
const PopperRoot = styled$2(Popper$1, {
	name: "MuiPopper",
	slot: "Root"
})({});
/**
*
* Demos:
*
* - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
* - [Menu](https://mui.com/material-ui/react-menu/)
* - [Popper](https://mui.com/material-ui/react-popper/)
*
* API:
*
* - [Popper API](https://mui.com/material-ui/api/popper/)
*/
const Popper = /*#__PURE__*/ React$1.forwardRef(function Popper(inProps, ref) {
	const isRtl = useRtl();
	const { anchorEl, component, container, disablePortal, keepMounted, modifiers, open, placement, popperOptions, popperRef, transition, slots, slotProps, ...other } = useDefaultProps({
		props: inProps,
		name: "MuiPopper"
	});
	const otherProps = {
		anchorEl,
		container,
		disablePortal,
		keepMounted,
		modifiers,
		open,
		placement,
		popperOptions,
		popperRef,
		transition,
		...other
	};
	return /*#__PURE__*/ jsx(PopperRoot, {
		as: component,
		direction: isRtl ? "rtl" : "ltr",
		slots,
		slotProps,
		...otherProps,
		ref
	});
});
Popper.propTypes = {
	/**
	* An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
	* or a function that returns either.
	* It's used to set the position of the popper.
	* The return value will passed as the reference object of the Popper instance.
	*/
	anchorEl: import_prop_types.default.oneOfType([
		HTMLElementType,
		import_prop_types.default.object,
		import_prop_types.default.func
	]),
	/**
	* Popper render function or node.
	*/
	children: import_prop_types.default.oneOfType([import_prop_types.default.node, import_prop_types.default.func]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* An HTML element or function that returns one.
	* The `container` will have the portal children appended to it.
	*
	* You can also provide a callback, which is called in a React layout effect.
	* This lets you set the container from a ref, and also makes server-side rendering possible.
	*
	* By default, it uses the body of the top-level document object,
	* so it's simply `document.body` most of the time.
	*/
	container: import_prop_types.default.oneOfType([HTMLElementType, import_prop_types.default.func]),
	/**
	* The `children` will be under the DOM hierarchy of the parent component.
	* @default false
	*/
	disablePortal: import_prop_types.default.bool,
	/**
	* Always keep the children in the DOM.
	* This prop can be useful in SEO situation or
	* when you want to maximize the responsiveness of the Popper.
	* @default false
	*/
	keepMounted: import_prop_types.default.bool,
	/**
	* Popper.js is based on a "plugin-like" architecture,
	* most of its features are fully encapsulated "modifiers".
	*
	* A modifier is a function that is called each time Popper.js needs to
	* compute the position of the popper.
	* For this reason, modifiers should be very performant to avoid bottlenecks.
	* To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
	*/
	modifiers: import_prop_types.default.arrayOf(import_prop_types.default.shape({
		data: import_prop_types.default.object,
		effect: import_prop_types.default.func,
		enabled: import_prop_types.default.bool,
		fn: import_prop_types.default.func,
		name: import_prop_types.default.any,
		options: import_prop_types.default.object,
		phase: import_prop_types.default.oneOf([
			"afterMain",
			"afterRead",
			"afterWrite",
			"beforeMain",
			"beforeRead",
			"beforeWrite",
			"main",
			"read",
			"write"
		]),
		requires: import_prop_types.default.arrayOf(import_prop_types.default.string),
		requiresIfExists: import_prop_types.default.arrayOf(import_prop_types.default.string)
	})),
	/**
	* If `true`, the component is shown.
	*/
	open: import_prop_types.default.bool.isRequired,
	/**
	* Popper placement.
	* @default 'bottom'
	*/
	placement: import_prop_types.default.oneOf([
		"auto-end",
		"auto-start",
		"auto",
		"bottom-end",
		"bottom-start",
		"bottom",
		"left-end",
		"left-start",
		"left",
		"right-end",
		"right-start",
		"right",
		"top-end",
		"top-start",
		"top"
	]),
	/**
	* Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
	* @default {}
	*/
	popperOptions: import_prop_types.default.shape({
		modifiers: import_prop_types.default.array,
		onFirstUpdate: import_prop_types.default.func,
		placement: import_prop_types.default.oneOf([
			"auto-end",
			"auto-start",
			"auto",
			"bottom-end",
			"bottom-start",
			"bottom",
			"left-end",
			"left-start",
			"left",
			"right-end",
			"right-start",
			"right",
			"top-end",
			"top-start",
			"top"
		]),
		strategy: import_prop_types.default.oneOf(["absolute", "fixed"])
	}),
	/**
	* A ref that points to the used popper instance.
	*/
	popperRef: refType,
	/**
	* The props used for each slot inside the Popper.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({ root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]) }),
	/**
	* The components used for each slot inside the Popper.
	* Either a string to use a HTML element or a component.
	* @default {}
	*/
	slots: import_prop_types.default.shape({ root: import_prop_types.default.elementType }),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* Help supporting a react-transition-group/Transition component.
	* @default false
	*/
	transition: import_prop_types.default.bool
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ListSubheader/listSubheaderClasses.mjs
function getListSubheaderUtilityClass(slot) {
	return generateUtilityClass("MuiListSubheader", slot);
}
const listSubheaderClasses = generateUtilityClasses("MuiListSubheader", [
	"root",
	"colorPrimary",
	"colorInherit",
	"gutters",
	"inset",
	"sticky"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ListSubheader/ListSubheader.mjs
const useUtilityClasses$64 = (ownerState) => {
	const { classes, color, disableGutters, inset, disableSticky } = ownerState;
	const slots = { root: [
		"root",
		color !== "default" && `color${capitalize_default(color)}`,
		!disableGutters && "gutters",
		inset && "inset",
		!disableSticky && "sticky"
	] };
	return composeClasses(slots, getListSubheaderUtilityClass, classes);
};
const ListSubheaderRoot = styled$2("li", {
	name: "MuiListSubheader",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.color !== "default" && styles[`color${capitalize_default(ownerState.color)}`],
			!ownerState.disableGutters && styles.gutters,
			ownerState.inset && styles.inset,
			!ownerState.disableSticky && styles.sticky
		];
	}
})(memoTheme(({ theme }) => ({
	boxSizing: "border-box",
	lineHeight: "48px",
	listStyle: "none",
	color: (theme.vars || theme).palette.text.secondary,
	fontFamily: theme.typography.fontFamily,
	fontWeight: theme.typography.fontWeightMedium,
	fontSize: theme.typography.pxToRem(14),
	variants: [
		{
			props: { color: "primary" },
			style: { color: (theme.vars || theme).palette.primary.main }
		},
		{
			props: { color: "inherit" },
			style: { color: "inherit" }
		},
		{
			props: ({ ownerState }) => !ownerState.disableGutters,
			style: {
				paddingLeft: 16,
				paddingRight: 16
			}
		},
		{
			props: ({ ownerState }) => ownerState.inset,
			style: { paddingLeft: 72 }
		},
		{
			props: ({ ownerState }) => !ownerState.disableSticky,
			style: {
				position: "sticky",
				top: 0,
				zIndex: 1,
				backgroundColor: (theme.vars || theme).palette.background.paper
			}
		}
	]
})));
const ListSubheader = /*#__PURE__*/ React$1.forwardRef(function ListSubheader(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiListSubheader"
	});
	const { className, color = "default", component = "li", disableGutters = false, disableSticky = false, inset = false, ...other } = props;
	const ownerState = {
		...props,
		color,
		component,
		disableGutters,
		disableSticky,
		inset
	};
	const classes = useUtilityClasses$64(ownerState);
	return /*#__PURE__*/ jsx(ListSubheaderRoot, {
		as: component,
		className: clsx(classes.root, className),
		ref,
		ownerState,
		...other
	});
});
ListSubheader.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component. It supports those theme colors that make sense for this component.
	* @default 'default'
	*/
	color: import_prop_types.default.oneOf([
		"default",
		"inherit",
		"primary"
	]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, the List Subheader will not have gutters.
	* @default false
	*/
	disableGutters: import_prop_types.default.bool,
	/**
	* If `true`, the List Subheader will not stick to the top during scroll.
	* @default false
	*/
	disableSticky: import_prop_types.default.bool,
	/**
	* If `true`, the List Subheader is indented.
	* @default false
	*/
	inset: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/Cancel.mjs
/**
* @ignore - internal component.
*/
var Cancel_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" }), "Cancel");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Chip/chipClasses.mjs
function getChipUtilityClass(slot) {
	return generateUtilityClass("MuiChip", slot);
}
const chipClasses = generateUtilityClasses("MuiChip", [
	"root",
	"sizeSmall",
	"sizeMedium",
	"colorDefault",
	"colorError",
	"colorInfo",
	"colorPrimary",
	"colorSecondary",
	"colorSuccess",
	"colorWarning",
	"disabled",
	"clickable",
	"deletable",
	"outlined",
	"filled",
	"avatar",
	"icon",
	"label",
	"deleteIcon",
	"focusVisible"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Chip/Chip.mjs
const useUtilityClasses$63 = (ownerState) => {
	const { classes, disabled, size, color, onDelete, clickable, variant } = ownerState;
	const slots = {
		root: [
			"root",
			variant,
			disabled && "disabled",
			`size${capitalize_default(size)}`,
			`color${capitalize_default(color)}`,
			clickable && "clickable",
			onDelete && "deletable"
		],
		label: ["label"],
		avatar: ["avatar"],
		icon: ["icon"],
		deleteIcon: ["deleteIcon"]
	};
	return composeClasses(slots, getChipUtilityClass, classes);
};
const ChipRoot = styled$2("div", {
	name: "MuiChip",
	slot: "Root",
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) && prop !== "focusableWhenDisabled" && prop !== "skipFocusWhenDisabled",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		const { color, clickable, onDelete, size, variant } = ownerState;
		return [
			{ [`& .${chipClasses.avatar}`]: styles.avatar },
			{ [`& .${chipClasses.icon}`]: styles.icon },
			{ [`& .${chipClasses.deleteIcon}`]: styles.deleteIcon },
			styles.root,
			styles[`size${capitalize_default(size)}`],
			styles[`color${capitalize_default(color)}`],
			clickable && styles.clickable,
			onDelete && styles.deletable,
			styles[variant]
		];
	}
})(memoTheme(({ theme }) => {
	const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
	return {
		maxWidth: "100%",
		fontFamily: theme.typography.fontFamily,
		fontSize: theme.typography.pxToRem(13),
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		height: 32,
		lineHeight: 1.5,
		color: (theme.vars || theme).palette.text.primary,
		backgroundColor: (theme.vars || theme).palette.action.selected,
		borderRadius: 16,
		whiteSpace: "nowrap",
		...getTransitionStyles(theme, ["background-color", "box-shadow"]),
		cursor: "unset",
		outline: 0,
		textDecoration: "none",
		border: 0,
		padding: 0,
		verticalAlign: "middle",
		boxSizing: "border-box",
		[`&.${chipClasses.disabled}`]: {
			opacity: (theme.vars || theme).palette.action.disabledOpacity,
			pointerEvents: "none"
		},
		[`& .${chipClasses.avatar}`]: {
			marginLeft: 5,
			marginRight: -6,
			width: 24,
			height: 24,
			color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
			fontSize: theme.typography.pxToRem(12)
		},
		[`& .${chipClasses.icon}`]: {
			marginLeft: 5,
			marginRight: -6
		},
		[`& .${chipClasses.deleteIcon}`]: {
			WebkitTapHighlightColor: "transparent",
			color: theme.alpha((theme.vars || theme).palette.text.primary, .26),
			fontSize: 22,
			cursor: "pointer",
			margin: "0 5px 0 -6px",
			"&:hover": { color: theme.alpha((theme.vars || theme).palette.text.primary, .4) }
		},
		variants: [
			{
				props: { color: "primary" },
				style: { [`& .${chipClasses.avatar}`]: {
					color: (theme.vars || theme).palette.primary.contrastText,
					backgroundColor: (theme.vars || theme).palette.primary.dark
				} }
			},
			{
				props: { color: "secondary" },
				style: { [`& .${chipClasses.avatar}`]: {
					color: (theme.vars || theme).palette.secondary.contrastText,
					backgroundColor: (theme.vars || theme).palette.secondary.dark
				} }
			},
			{
				props: { size: "small" },
				style: {
					height: 24,
					[`& .${chipClasses.avatar}`]: {
						marginLeft: 4,
						marginRight: -4,
						width: 18,
						height: 18,
						fontSize: theme.typography.pxToRem(10)
					},
					[`& .${chipClasses.icon}`]: {
						fontSize: 18,
						marginLeft: 4,
						marginRight: -4
					},
					[`& .${chipClasses.deleteIcon}`]: {
						fontSize: 16,
						marginRight: 4,
						marginLeft: -4
					}
				}
			},
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["contrastText"])).map(([color]) => {
				return {
					props: { color },
					style: {
						backgroundColor: (theme.vars || theme).palette[color].main,
						color: (theme.vars || theme).palette[color].contrastText,
						[`& .${chipClasses.deleteIcon}`]: {
							color: theme.alpha((theme.vars || theme).palette[color].contrastText, .7),
							"&:hover, &:active": { color: (theme.vars || theme).palette[color].contrastText }
						}
					}
				};
			}),
			{
				props: (props) => props.iconColor === props.color,
				style: { [`& .${chipClasses.icon}`]: { color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor } }
			},
			{
				props: (props) => props.iconColor === props.color && props.color !== "default",
				style: { [`& .${chipClasses.icon}`]: { color: "inherit" } }
			},
			{
				props: { onDelete: true },
				style: !theme.focusVisible && { [`&.${chipClasses.focusVisible}`]: { backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`) } }
			},
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["dark"])).map(([color]) => {
				return {
					props: {
						color,
						onDelete: true
					},
					style: !theme.focusVisible && { [`&.${chipClasses.focusVisible}`]: { background: (theme.vars || theme).palette[color].dark } }
				};
			}),
			{
				props: { clickable: true },
				style: {
					userSelect: "none",
					WebkitTapHighlightColor: "transparent",
					cursor: "pointer",
					"&:hover": { backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`) },
					...!theme.focusVisible && { [`&.${chipClasses.focusVisible}`]: { backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`) } },
					"&:active": { boxShadow: (theme.vars || theme).shadows[1] }
				}
			},
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["dark"])).map(([color]) => ({
				props: {
					color,
					clickable: true
				},
				style: {
					"&:hover": { backgroundColor: (theme.vars || theme).palette[color].dark },
					...!theme.focusVisible && { [`&.${chipClasses.focusVisible}`]: { backgroundColor: (theme.vars || theme).palette[color].dark } }
				}
			})),
			{
				props: { variant: "outlined" },
				style: {
					backgroundColor: "transparent",
					border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
					[`&.${chipClasses.clickable}:hover`]: { backgroundColor: (theme.vars || theme).palette.action.hover },
					...!theme.focusVisible && { [`&.${chipClasses.focusVisible}`]: { backgroundColor: (theme.vars || theme).palette.action.focus } },
					[`& .${chipClasses.avatar}`]: { marginLeft: 4 },
					[`& .${chipClasses.icon}`]: { marginLeft: 4 },
					[`& .${chipClasses.deleteIcon}`]: { marginRight: 5 }
				}
			},
			{
				props: {
					size: "small",
					variant: "outlined"
				},
				style: {
					[`& .${chipClasses.avatar}`]: { marginLeft: 2 },
					[`& .${chipClasses.icon}`]: { marginLeft: 2 },
					[`& .${chipClasses.deleteIcon}`]: { marginRight: 3 }
				}
			},
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
				props: {
					variant: "outlined",
					color
				},
				style: {
					color: (theme.vars || theme).palette[color].main,
					border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, .7)}`,
					[`&.${chipClasses.clickable}:hover`]: { backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity) },
					...!theme.focusVisible && { [`&.${chipClasses.focusVisible}`]: { backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.focusOpacity) } },
					[`& .${chipClasses.deleteIcon}`]: {
						color: theme.alpha((theme.vars || theme).palette[color].main, .7),
						"&:hover, &:active": { color: (theme.vars || theme).palette[color].main }
					}
				}
			}))
		]
	};
}));
const ChipLabel = styled$2("span", {
	name: "MuiChip",
	slot: "Label"
})({
	overflow: "hidden",
	textOverflow: "ellipsis",
	paddingLeft: 12,
	paddingRight: 12,
	whiteSpace: "nowrap",
	variants: [
		{
			props: { variant: "outlined" },
			style: {
				paddingLeft: 11,
				paddingRight: 11
			}
		},
		{
			props: { size: "small" },
			style: {
				paddingLeft: 8,
				paddingRight: 8
			}
		},
		{
			props: {
				size: "small",
				variant: "outlined"
			},
			style: {
				paddingLeft: 7,
				paddingRight: 7
			}
		}
	]
});
function isDeleteKeyboardEvent(keyboardEvent) {
	return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
* Chips represent complex entities in small blocks, such as a contact.
*/
const Chip$1 = /*#__PURE__*/ React$1.forwardRef(function Chip(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiChip"
	});
	const { avatar: avatarProp, className, clickable: clickableProp, color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled = false, icon: iconProp, label, onClick, onDelete, onKeyDown, onKeyUp, size = "medium", variant = "filled", tabIndex, skipFocusWhenDisabled = false, slots = {}, slotProps = {}, ...other } = props;
	const { nativeButton, ...buttonBaseProps } = other;
	const handleRef = useForkRef_default(React$1.useRef(null), ref);
	const handleDeleteIconClick = (event) => {
		event.stopPropagation();
		onDelete(event);
	};
	const handleKeyDown = (event) => {
		if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) event.preventDefault();
		if (onKeyDown) onKeyDown(event);
	};
	const handleKeyUp = (event) => {
		if (event.currentTarget === event.target) {
			if (onDelete && isDeleteKeyboardEvent(event)) onDelete(event);
		}
		if (onKeyUp) onKeyUp(event);
	};
	const clickable = clickableProp !== false && onClick ? true : clickableProp;
	const component = clickable || onDelete ? ButtonBase : ComponentProp || "div";
	const ownerState = {
		...props,
		component,
		disabled,
		size,
		color,
		iconColor: /*#__PURE__*/ React$1.isValidElement(iconProp) ? iconProp.props.color || color : color,
		onDelete: !!onDelete,
		clickable,
		variant
	};
	const classes = useUtilityClasses$63(ownerState);
	const moreProps = component === ButtonBase ? {
		component: ComponentProp || "div",
		internalNativeButton: false,
		focusVisibleClassName: classes.focusVisible,
		...onDelete && { disableRipple: true },
		...nativeButton !== void 0 && { nativeButton }
	} : {};
	let deleteIcon = null;
	if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ React$1.isValidElement(deleteIconProp) ? /*#__PURE__*/ React$1.cloneElement(deleteIconProp, {
		className: clsx(deleteIconProp.props.className, classes.deleteIcon),
		onClick: handleDeleteIconClick
	}) : /*#__PURE__*/ jsx(Cancel_default, {
		className: classes.deleteIcon,
		onClick: handleDeleteIconClick
	});
	let avatar = null;
	if (avatarProp && /*#__PURE__*/ React$1.isValidElement(avatarProp)) avatar = /*#__PURE__*/ React$1.cloneElement(avatarProp, { className: clsx(classes.avatar, avatarProp.props.className) });
	let icon = null;
	if (iconProp && /*#__PURE__*/ React$1.isValidElement(iconProp)) icon = /*#__PURE__*/ React$1.cloneElement(iconProp, { className: clsx(classes.icon, iconProp.props.className) });
	if (avatar && icon) console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one.");
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [RootSlot, rootProps] = useSlot("root", {
		elementType: ChipRoot,
		externalForwardedProps: {
			...externalForwardedProps,
			...buttonBaseProps
		},
		ownerState,
		shouldForwardComponentProp: true,
		ref: handleRef,
		className: clsx(classes.root, className),
		additionalProps: {
			disabled: clickable && disabled ? true : void 0,
			tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
			...moreProps
		},
		getSlotProps: (handlers) => ({
			...handlers,
			onClick: (event) => {
				handlers.onClick?.(event);
				onClick?.(event);
			},
			onKeyDown: (event) => {
				handlers.onKeyDown?.(event);
				handleKeyDown(event);
			},
			onKeyUp: (event) => {
				handlers.onKeyUp?.(event);
				handleKeyUp(event);
			}
		})
	});
	const [LabelSlot, labelProps] = useSlot("label", {
		elementType: ChipLabel,
		externalForwardedProps,
		ownerState,
		className: classes.label
	});
	return /*#__PURE__*/ jsxs(RootSlot, {
		as: component,
		...rootProps,
		children: [
			avatar || icon,
			/*#__PURE__*/ jsx(LabelSlot, {
				...labelProps,
				children: label
			}),
			deleteIcon
		]
	});
});
Chip$1.propTypes = {
	/**
	* The Avatar element to display.
	*/
	avatar: import_prop_types.default.element,
	/**
	* This prop isn't supported.
	* Use the `component` prop if you need to change the children structure.
	*/
	children: unsupportedProp_default,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* If `true`, the chip will appear clickable, and will raise when pressed,
	* even if the onClick prop is not defined.
	* If `false`, the chip will not appear clickable, even if onClick prop is defined.
	* This can be used, for example,
	* along with the component prop to indicate an anchor Chip is clickable.
	* Note: this controls the UI and does not affect the onClick event.
	*/
	clickable: import_prop_types.default.bool,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'default'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"default",
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* Override the default delete icon element. Shown only if `onDelete` is set.
	*/
	deleteIcon: import_prop_types.default.element,
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* Icon element.
	*/
	icon: import_prop_types.default.element,
	/**
	* The content of the component.
	*/
	label: import_prop_types.default.node,
	/**
	* If `true`, the component is expected to resolve to a native `<button>` element.
	* When omitted, custom components inherit the default button semantics of the current wrapper.
	* Set to `true` when a custom component resolves to a native `<button>`, or `false`
	* when it resolves to a non-button host.
	*/
	nativeButton: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	onClick: import_prop_types.default.func,
	/**
	* Callback fired when the delete icon is clicked.
	* If set, the delete icon will be shown.
	*/
	onDelete: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onKeyDown: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onKeyUp: import_prop_types.default.func,
	/**
	* The size of the component.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["medium", "small"]), import_prop_types.default.string]),
	/**
	* If `true`, allows the disabled chip to escape focus.
	* If `false`, allows the disabled chip to receive focus.
	* @default false
	*/
	skipFocusWhenDisabled: import_prop_types.default.bool,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		label: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		label: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* @ignore
	*/
	tabIndex: import_prop_types.default.number,
	/**
	* The variant to use.
	* @default 'filled'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["filled", "outlined"]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/ArrowDropDown.mjs
/**
* @ignore - internal component.
*/
var ArrowDropDown_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M7 10l5 5 5-5z" }), "ArrowDropDown");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/Person.mjs
/**
* @ignore - internal component.
*/
var Person_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" }), "Person");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Avatar/avatarClasses.mjs
function getAvatarUtilityClass(slot) {
	return generateUtilityClass("MuiAvatar", slot);
}
const avatarClasses = generateUtilityClasses("MuiAvatar", [
	"root",
	"colorDefault",
	"circular",
	"rounded",
	"square",
	"img",
	"fallback"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Avatar/Avatar.mjs
const useUtilityClasses$62 = (ownerState) => {
	const { classes, variant, colorDefault } = ownerState;
	return composeClasses({
		root: [
			"root",
			variant,
			colorDefault && "colorDefault"
		],
		img: ["img"],
		fallback: ["fallback"]
	}, getAvatarUtilityClass, classes);
};
const AvatarRoot$1 = styled$2("div", {
	name: "MuiAvatar",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[ownerState.variant],
			ownerState.colorDefault && styles.colorDefault
		];
	}
})(memoTheme(({ theme }) => ({
	position: "relative",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	flexShrink: 0,
	width: 40,
	height: 40,
	fontFamily: theme.typography.fontFamily,
	fontSize: theme.typography.pxToRem(20),
	lineHeight: 1,
	borderRadius: "50%",
	overflow: "hidden",
	userSelect: "none",
	variants: [
		{
			props: { variant: "rounded" },
			style: { borderRadius: (theme.vars || theme).shape.borderRadius }
		},
		{
			props: { variant: "square" },
			style: { borderRadius: 0 }
		},
		{
			props: { colorDefault: true },
			style: {
				color: (theme.vars || theme).palette.background.default,
				"@media (forced-colors: active)": {
					boxSizing: "border-box",
					border: "1px solid ButtonBorder"
				},
				...theme.vars ? { backgroundColor: theme.vars.palette.Avatar.defaultBg } : {
					backgroundColor: theme.palette.grey[400],
					...theme.applyStyles("dark", { backgroundColor: theme.palette.grey[600] })
				}
			}
		}
	]
})));
const AvatarImg = styled$2("img", {
	name: "MuiAvatar",
	slot: "Img"
})({
	width: "100%",
	height: "100%",
	textAlign: "center",
	objectFit: "cover",
	color: "transparent",
	textIndent: 1e4
});
const AvatarFallback = styled$2(Person_default, {
	name: "MuiAvatar",
	slot: "Fallback"
})({
	width: "75%",
	height: "75%"
});
function useLoaded(src, srcSet, crossOrigin, referrerPolicy) {
	const [loaded, setLoaded] = React$1.useState(false);
	React$1.useEffect(() => {
		if (!src && !srcSet) return;
		setLoaded(false);
		let active = true;
		const image = new Image();
		image.onload = () => {
			if (!active) return;
			setLoaded("loaded");
		};
		image.onerror = () => {
			if (!active) return;
			setLoaded("error");
		};
		image.crossOrigin = crossOrigin;
		image.referrerPolicy = referrerPolicy;
		image.src = src;
		if (srcSet) image.srcset = srcSet;
		return () => {
			active = false;
		};
	}, [
		crossOrigin,
		referrerPolicy,
		src,
		srcSet
	]);
	return loaded;
}
const Avatar$1 = /*#__PURE__*/ React$1.forwardRef(function Avatar(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiAvatar"
	});
	const { alt, children: childrenProp, className, component = "div", slots = {}, slotProps = {}, sizes, src, srcSet, variant = "circular", ...other } = props;
	let children = null;
	const ownerState = {
		...props,
		component,
		variant
	};
	const { crossOrigin, referrerPolicy } = (typeof slotProps.img === "function" ? slotProps.img(ownerState) : slotProps.img) ?? {};
	const loaded = useLoaded(src, srcSet, crossOrigin, referrerPolicy);
	const hasImg = src || srcSet;
	const hasImgNotFailing = hasImg && loaded !== "error";
	ownerState.colorDefault = !hasImgNotFailing;
	delete ownerState.ownerState;
	const classes = useUtilityClasses$62(ownerState);
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [RootSlot, rootSlotProps] = useSlot("root", {
		ref,
		className: clsx(classes.root, className),
		elementType: AvatarRoot$1,
		externalForwardedProps: {
			...externalForwardedProps,
			component,
			...other
		},
		ownerState
	});
	const [ImgSlot, imgSlotProps] = useSlot("img", {
		className: classes.img,
		elementType: AvatarImg,
		externalForwardedProps,
		additionalProps: {
			alt,
			src,
			srcSet,
			sizes
		},
		ownerState
	});
	const [FallbackSlot, fallbackSlotProps] = useSlot("fallback", {
		className: classes.fallback,
		elementType: AvatarFallback,
		externalForwardedProps,
		shouldForwardComponentProp: true,
		ownerState
	});
	if (hasImgNotFailing) children = /*#__PURE__*/ jsx(ImgSlot, { ...imgSlotProps });
	else if (!!childrenProp || childrenProp === 0) children = childrenProp;
	else if (hasImg && alt) children = alt[0];
	else children = /*#__PURE__*/ jsx(FallbackSlot, { ...fallbackSlotProps });
	return /*#__PURE__*/ jsx(RootSlot, {
		...rootSlotProps,
		children
	});
});
Avatar$1.propTypes = {
	/**
	* Used in combination with `src` or `srcSet` to
	* provide an alt attribute for the rendered `img` element.
	*/
	alt: import_prop_types.default.string,
	/**
	* Used to render icon or text elements inside the Avatar if `src` is not set.
	* This can be an element, or just a string.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* The `sizes` attribute for the `img` element.
	*/
	sizes: import_prop_types.default.string,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		fallback: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		img: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		fallback: import_prop_types.default.elementType,
		img: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* The `src` attribute for the `img` element.
	*/
	src: import_prop_types.default.string,
	/**
	* The `srcSet` attribute for the `img` element.
	* Use this attribute for responsive image display.
	*/
	srcSet: import_prop_types.default.string,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The shape of the avatar.
	* @default 'circular'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"circular",
		"rounded",
		"square"
	]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/AvatarGroup/avatarGroupClasses.mjs
function getAvatarGroupUtilityClass(slot) {
	return generateUtilityClass("MuiAvatarGroup", slot);
}
const avatarGroupClasses = generateUtilityClasses("MuiAvatarGroup", ["root", "avatar"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/AvatarGroup/AvatarGroup.mjs
var import_react_is = require_react_is$1();
const SPACINGS = {
	small: -16,
	medium: -8
};
const useUtilityClasses$61 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({
		root: ["root"],
		avatar: ["avatar"]
	}, getAvatarGroupUtilityClass, classes);
};
const AvatarGroupRoot = styled$2("div", {
	name: "MuiAvatarGroup",
	slot: "Root",
	overridesResolver: (props, styles) => {
		return [{ [`& .${avatarGroupClasses.avatar}`]: styles.avatar }, styles.root];
	}
})(memoTheme(({ theme }) => ({
	display: "flex",
	flexDirection: "row-reverse",
	[`& .${avatarClasses.root}`]: {
		border: `2px solid ${(theme.vars || theme).palette.background.default}`,
		boxSizing: "content-box",
		marginLeft: "var(--AvatarGroup-spacing, -8px)",
		"&:last-child": { marginLeft: 0 }
	}
})));
const AvatarGroup$1 = /*#__PURE__*/ React$1.forwardRef(function AvatarGroup(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiAvatarGroup"
	});
	const { children: childrenProp, className, component = "div", max = 5, renderSurplus, slotProps = {}, slots = {}, spacing = "medium", total, variant = "circular", ...other } = props;
	let clampedMax = max < 2 ? 2 : max;
	const ownerState = {
		...props,
		max,
		spacing,
		component,
		variant
	};
	const classes = useUtilityClasses$61(ownerState);
	const children = React$1.Children.toArray(childrenProp).filter((child) => {
		if ((0, import_react_is.isFragment)(child)) console.error(["MUI: The AvatarGroup component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join("\n"));
		return /*#__PURE__*/ React$1.isValidElement(child);
	});
	const totalAvatars = total || children.length;
	if (totalAvatars === clampedMax) clampedMax += 1;
	clampedMax = Math.min(totalAvatars + 1, clampedMax);
	const maxAvatars = Math.min(children.length, clampedMax - 1);
	const extraAvatars = Math.max(totalAvatars - clampedMax, totalAvatars - maxAvatars, 0);
	const extraAvatarsElement = renderSurplus ? renderSurplus(extraAvatars) : `+${extraAvatars}`;
	let marginValue;
	if (ownerState.spacing && SPACINGS[ownerState.spacing] !== void 0) marginValue = SPACINGS[ownerState.spacing];
	else if (ownerState.spacing === 0) marginValue = 0;
	else marginValue = -ownerState.spacing || SPACINGS.medium;
	const [SurplusSlot, surplusProps] = useSlot("surplus", {
		elementType: Avatar$1,
		externalForwardedProps: {
			slots,
			slotProps
		},
		className: classes.avatar,
		ownerState,
		additionalProps: { variant }
	});
	return /*#__PURE__*/ jsxs(AvatarGroupRoot, {
		as: component,
		ownerState,
		className: clsx(classes.root, className),
		ref,
		...other,
		style: {
			"--AvatarGroup-spacing": `${marginValue}px`,
			...other.style
		},
		children: [extraAvatars ? /*#__PURE__*/ jsx(SurplusSlot, {
			...surplusProps,
			children: extraAvatarsElement
		}) : null, children.slice(0, maxAvatars).reverse().map((child) => {
			return /*#__PURE__*/ React$1.cloneElement(child, {
				className: clsx(child.props.className, classes.avatar),
				variant: child.props.variant || variant
			});
		})]
	});
});
AvatarGroup$1.propTypes = {
	/**
	* The avatars to stack.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* Max avatars to show before +x.
	* @default 5
	*/
	max: chainPropTypes(import_prop_types.default.number, (props) => {
		if (props.max < 2) return new Error(["MUI: The prop `max` should be equal to 2 or above.", "A value below is clamped to 2."].join("\n"));
		return null;
	}),
	/**
	* custom renderer of extraAvatars
	* @param {number} surplus number of extra avatars
	* @returns {React.ReactNode} custom element to display
	*/
	renderSurplus: import_prop_types.default.func,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({ surplus: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]) }),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({ surplus: import_prop_types.default.elementType }),
	/**
	* Spacing between avatars.
	* @default 'medium'
	*/
	spacing: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["medium", "small"]), import_prop_types.default.number]),
	/**
	* @ignore
	*/
	style: import_prop_types.default.object,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The total number of avatars. Used for calculating the number of extra avatars.
	* @default children.length
	*/
	total: import_prop_types.default.number,
	/**
	* The variant to use.
	* @default 'circular'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"circular",
		"rounded",
		"square"
	]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/elementAcceptingRef/elementAcceptingRef.mjs
function isClassComponent(elementType) {
	const { prototype = {} } = elementType;
	return Boolean(prototype.isReactComponent);
}
function acceptingRef(props, propName, componentName, location, propFullName) {
	const element = props[propName];
	const safePropName = propFullName || propName;
	if (element == null || typeof window === "undefined") return null;
	let warningHint;
	const elementType = element.type;
	/**
	* Blacklisting instead of whitelisting
	*
	* Blacklisting will miss some components, such as React.Fragment. Those will at least
	* trigger a warning in React.
	* We can't whitelist because there is no safe way to detect React.forwardRef
	* or class components. "Safe" means there's no public API.
	*
	*/
	if (typeof elementType === "function" && !isClassComponent(elementType)) warningHint = "Did you accidentally use a plain function component for an element instead?";
	if (warningHint !== void 0) return /* @__PURE__ */ new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. Expected an element that can hold a ref. ${warningHint} For more information see https://mui.com/r/caveat-with-refs-guide`);
	return null;
}
const elementAcceptingRef = chainPropTypes(import_prop_types.default.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(import_prop_types.default.element.isRequired, acceptingRef);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Fade/Fade.mjs
const styles$2 = {
	entering: { opacity: 1 },
	entered: { opacity: 1 },
	exiting: { opacity: 0 },
	exited: { opacity: 0 }
};
const hiddenStyles$1 = {
	opacity: 0,
	visibility: "hidden"
};
/**
* The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
*/
const Fade = /*#__PURE__*/ React$1.forwardRef(function Fade(props, ref) {
	const theme = useTheme$1();
	const defaultTimeout = {
		enter: theme.transitions.duration.enteringScreen,
		exit: theme.transitions.duration.leavingScreen
	};
	const { addEndListener, appear = true, children, disablePrefersReducedMotion = false, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = defaultTimeout, ...other } = props;
	const reducedMotion = useReducedMotion(theme.motion.reducedMotion, disablePrefersReducedMotion);
	const nodeRef = React$1.useRef(null);
	const handleRef = useForkRef_default(nodeRef, getReactElementRef(children), ref);
	const handleEntering = normalizedTransitionCallback(nodeRef, onEntering);
	const handleEnter = normalizedTransitionCallback(nodeRef, (node, isAppearing) => {
		if (!reducedMotion.shouldReduceMotion) reflow(node);
		const transitionProps = getTransitionProps({
			style,
			timeout,
			easing
		}, { mode: "enter" });
		const transitionTiming = reducedMotion.getTransitionTiming({
			duration: transitionProps.duration,
			delay: transitionProps.delay
		});
		node.style.transition = theme.transitions.create("opacity", {
			duration: transitionTiming.duration,
			easing: transitionProps.easing,
			delay: transitionTiming.delay
		});
		if (onEnter) onEnter(node, isAppearing);
	});
	const handleEntered = normalizedTransitionCallback(nodeRef, onEntered);
	const handleExiting = normalizedTransitionCallback(nodeRef, onExiting);
	const handleExit = normalizedTransitionCallback(nodeRef, (node) => {
		const transitionProps = getTransitionProps({
			style,
			timeout,
			easing
		}, { mode: "exit" });
		const transitionTiming = reducedMotion.getTransitionTiming({
			duration: transitionProps.duration,
			delay: transitionProps.delay
		});
		node.style.transition = theme.transitions.create("opacity", {
			duration: transitionTiming.duration,
			easing: transitionProps.easing,
			delay: transitionTiming.delay
		});
		if (onExit) onExit(node);
	});
	const handleExited = normalizedTransitionCallback(nodeRef, (node) => {
		node.style.transition = "";
		if (onExited) onExited(node);
	});
	return /*#__PURE__*/ jsx(Transition, {
		appear,
		in: inProp,
		nodeRef,
		onEnter: handleEnter,
		onEntered: handleEntered,
		onEntering: handleEntering,
		onExit: handleExit,
		onExited: handleExited,
		onExiting: handleExiting,
		addEndListener: addEndListener ? (next) => {
			addEndListener(nodeRef.current, next);
		} : void 0,
		reduceMotion: reducedMotion.shouldReduceMotion,
		timeout,
		...other,
		children: (state, { ownerState, ...restChildProps }) => {
			const childStyle = getTransitionChildStyle(state, inProp, styles$2, hiddenStyles$1, style, children.props.style);
			return /*#__PURE__*/ React$1.cloneElement(children, {
				style: childStyle,
				ref: handleRef,
				...restChildProps
			});
		}
	});
});
Fade.propTypes = {
	/**
	* Add a custom transition end trigger.
	* Use it when you need custom logic to decide when the transition has ended.
	* Note: Timeouts are still used as a fallback if provided.
	*
	* @param {HTMLElement} node The transitioning DOM node.
	* @param {Function} done Call this when the transition has finished.
	*/
	addEndListener: import_prop_types.default.func,
	/**
	* Perform the enter transition when it first mounts if `in` is also `true`.
	* Set this to `false` to disable this behavior.
	* @default true
	*/
	appear: import_prop_types.default.bool,
	/**
	* A single child content element.
	*/
	children: elementAcceptingRef.isRequired,
	/**
	* If `true`, the transition ignores `theme.motion.reducedMotion` and keeps its normal timing.
	* @default false
	*/
	disablePrefersReducedMotion: import_prop_types.default.bool,
	/**
	* The transition timing function.
	* You may specify a single easing or a object containing enter and exit values.
	*/
	easing: import_prop_types.default.oneOfType([import_prop_types.default.shape({
		enter: import_prop_types.default.string,
		exit: import_prop_types.default.string
	}), import_prop_types.default.string]),
	/**
	* If `true`, the component will transition in.
	*/
	in: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	onEnter: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onEntered: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onEntering: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExit: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExited: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExiting: import_prop_types.default.func,
	/**
	* @ignore
	*/
	style: import_prop_types.default.object,
	/**
	* The duration for the transition, in milliseconds.
	* You may specify a single timeout for all transitions, or individually with an object.
	* @default {
	*   enter: theme.transitions.duration.enteringScreen,
	*   exit: theme.transitions.duration.leavingScreen,
	* }
	*/
	timeout: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.shape({
		appear: import_prop_types.default.number,
		enter: import_prop_types.default.number,
		exit: import_prop_types.default.number
	})])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Backdrop/backdropClasses.mjs
function getBackdropUtilityClass(slot) {
	return generateUtilityClass("MuiBackdrop", slot);
}
const backdropClasses = generateUtilityClasses("MuiBackdrop", ["root", "invisible"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Backdrop/Backdrop.mjs
const useUtilityClasses$60 = (ownerState) => {
	const { classes, invisible } = ownerState;
	return composeClasses({ root: ["root", invisible && "invisible"] }, getBackdropUtilityClass, classes);
};
const BackdropRoot = styled$2("div", {
	name: "MuiBackdrop",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, ownerState.invisible && styles.invisible];
	}
})({
	position: "fixed",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	right: 0,
	bottom: 0,
	top: 0,
	left: 0,
	backgroundColor: "rgba(0, 0, 0, 0.5)",
	WebkitTapHighlightColor: "transparent",
	variants: [{
		props: { invisible: true },
		style: { backgroundColor: "transparent" }
	}]
});
const Backdrop$1 = /*#__PURE__*/ React$1.forwardRef(function Backdrop(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiBackdrop"
	});
	const { children, className, component = "div", invisible = false, open, slotProps = {}, slots = {}, transitionDuration, ...other } = props;
	const ownerState = {
		...props,
		component,
		invisible
	};
	const classes = useUtilityClasses$60(ownerState);
	const externalForwardedProps = {
		component,
		slots,
		slotProps
	};
	const [RootSlot, rootProps] = useSlot("root", {
		elementType: BackdropRoot,
		externalForwardedProps,
		className: clsx(classes.root, className),
		ownerState
	});
	const [TransitionSlot, transitionProps] = useSlot("transition", {
		elementType: Fade,
		externalForwardedProps,
		ownerState
	});
	return /*#__PURE__*/ jsx(TransitionSlot, {
		in: open,
		timeout: transitionDuration,
		...other,
		...transitionProps,
		children: /*#__PURE__*/ jsx(RootSlot, {
			...rootProps,
			ref,
			children
		})
	});
});
Backdrop$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, the backdrop is invisible.
	* It can be used when rendering a popover or a custom select component.
	* @default false
	*/
	invisible: import_prop_types.default.bool,
	/**
	* If `true`, the component is shown.
	*/
	open: import_prop_types.default.bool.isRequired,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		transition: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		root: import_prop_types.default.elementType,
		transition: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The duration for the transition, in milliseconds.
	* You may specify a single timeout for all transitions, or individually with an object.
	*/
	transitionDuration: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.shape({
		appear: import_prop_types.default.number,
		enter: import_prop_types.default.number,
		exit: import_prop_types.default.number
	})])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Badge/useBadge.mjs
function useBadge(parameters) {
	const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero = false } = parameters;
	const prevProps = usePreviousProps({
		badgeContent: badgeContentProp,
		max: maxProp
	});
	let invisible = invisibleProp;
	if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
	const { badgeContent, max = maxProp } = invisible ? prevProps : parameters;
	const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
	return {
		badgeContent,
		invisible,
		max,
		displayValue
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Badge/badgeClasses.mjs
function getBadgeUtilityClass(slot) {
	return generateUtilityClass("MuiBadge", slot);
}
const badgeClasses = generateUtilityClasses("MuiBadge", [
	"root",
	"badge",
	"dot",
	"standard",
	"anchorOriginTopRight",
	"anchorOriginBottomRight",
	"anchorOriginTopLeft",
	"anchorOriginBottomLeft",
	"invisible",
	"colorError",
	"colorInfo",
	"colorPrimary",
	"colorSecondary",
	"colorSuccess",
	"colorWarning",
	"overlapRectangular",
	"overlapCircular",
	"anchorOriginTopLeftCircular",
	"anchorOriginTopLeftRectangular",
	"anchorOriginTopRightCircular",
	"anchorOriginTopRightRectangular",
	"anchorOriginBottomLeftCircular",
	"anchorOriginBottomLeftRectangular",
	"anchorOriginBottomRightCircular",
	"anchorOriginBottomRightRectangular"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Badge/Badge.mjs
const RADIUS_STANDARD = 10;
const RADIUS_DOT = 4;
const useUtilityClasses$59 = (ownerState) => {
	const { color, anchorOrigin, invisible, overlap, variant, classes = {} } = ownerState;
	const slots = {
		root: ["root"],
		badge: [
			"badge",
			variant,
			invisible && "invisible",
			`anchorOrigin${capitalize_default(anchorOrigin.vertical)}${capitalize_default(anchorOrigin.horizontal)}`,
			`anchorOrigin${capitalize_default(anchorOrigin.vertical)}${capitalize_default(anchorOrigin.horizontal)}${capitalize_default(overlap)}`,
			`overlap${capitalize_default(overlap)}`,
			color !== "default" && `color${capitalize_default(color)}`
		]
	};
	return composeClasses(slots, getBadgeUtilityClass, classes);
};
const BadgeRoot = styled$2("span", {
	name: "MuiBadge",
	slot: "Root"
})({
	position: "relative",
	display: "inline-flex",
	verticalAlign: "middle",
	flexShrink: 0
});
const BadgeBadge = styled$2("span", {
	name: "MuiBadge",
	slot: "Badge",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.badge,
			styles[ownerState.variant],
			styles[`anchorOrigin${capitalize_default(ownerState.anchorOrigin.vertical)}${capitalize_default(ownerState.anchorOrigin.horizontal)}${capitalize_default(ownerState.overlap)}`],
			ownerState.color !== "default" && styles[`color${capitalize_default(ownerState.color)}`],
			ownerState.invisible && styles.invisible
		];
	}
})(memoTheme(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	flexWrap: "wrap",
	justifyContent: "center",
	alignContent: "center",
	alignItems: "center",
	position: "absolute",
	boxSizing: "border-box",
	fontFamily: theme.typography.fontFamily,
	fontWeight: theme.typography.fontWeightMedium,
	fontSize: theme.typography.pxToRem(12),
	minWidth: 20,
	lineHeight: 1,
	padding: "0 6px",
	height: 20,
	borderRadius: RADIUS_STANDARD,
	zIndex: 1,
	"@media (forced-colors: active)": { border: "1px solid ButtonBorder" },
	...getTransitionStyles(theme, "transform", {
		easing: theme.transitions.easing.easeInOut,
		duration: theme.transitions.duration.enteringScreen
	}),
	variants: [
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["contrastText"])).map(([color]) => ({
			props: { color },
			style: {
				backgroundColor: (theme.vars || theme).palette[color].main,
				color: (theme.vars || theme).palette[color].contrastText
			}
		})),
		{
			props: { variant: "dot" },
			style: {
				borderRadius: RADIUS_DOT,
				height: 8,
				minWidth: 8,
				padding: 0
			}
		},
		{
			props: { invisible: true },
			style: { ...getTransitionStyles(theme, "transform", {
				easing: theme.transitions.easing.easeInOut,
				duration: theme.transitions.duration.leavingScreen
			}) }
		},
		{ style: {
			inset: "var(--Badge-inset)",
			transform: "scale(1) translate(var(--Badge-translate))",
			transformOrigin: "var(--Badge-origin)",
			[`&.${badgeClasses.invisible}`]: { transform: "scale(0) translate(var(--Badge-translate))" }
		} }
	]
})));
function getAnchorOrigin(anchorOrigin) {
	return {
		vertical: anchorOrigin?.vertical ?? "top",
		horizontal: anchorOrigin?.horizontal ?? "right"
	};
}
const Badge$1 = /*#__PURE__*/ React$1.forwardRef(function Badge(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiBadge"
	});
	const { anchorOrigin: anchorOriginProp, className, classes: classesProp, component, children, overlap: overlapProp = "rectangular", color: colorProp = "default", invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots, slotProps, showZero = false, variant: variantProp = "standard", ...other } = props;
	const { badgeContent, invisible: invisibleFromHook, max, displayValue: displayValueFromHook } = useBadge({
		max: maxProp,
		invisible: invisibleProp,
		badgeContent: badgeContentProp,
		showZero
	});
	const prevProps = usePreviousProps({
		anchorOrigin: getAnchorOrigin(anchorOriginProp),
		color: colorProp,
		overlap: overlapProp,
		variant: variantProp,
		badgeContent: badgeContentProp
	});
	const invisible = invisibleFromHook || badgeContent == null && variantProp !== "dot";
	const { color = colorProp, overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant = variantProp } = invisible ? prevProps : props;
	const anchorOrigin = getAnchorOrigin(anchorOriginPropProp);
	const displayValue = variant !== "dot" ? displayValueFromHook : void 0;
	const ownerState = {
		...props,
		badgeContent,
		invisible,
		max,
		displayValue,
		showZero,
		anchorOrigin,
		color,
		overlap,
		variant
	};
	const classes = useUtilityClasses$59(ownerState);
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [RootSlot, rootProps] = useSlot("root", {
		elementType: BadgeRoot,
		externalForwardedProps: {
			...externalForwardedProps,
			...other
		},
		ownerState,
		className: clsx(classes.root, className),
		ref,
		additionalProps: { as: component }
	});
	const { vertical, horizontal } = anchorOrigin;
	const offset = overlap === "circular" ? "14%" : "0";
	const top = vertical === "top" ? offset : "auto";
	const bottom = vertical === "bottom" ? offset : "auto";
	const right = horizontal === "right" ? offset : "auto";
	const left = horizontal === "left" ? offset : "auto";
	const [BadgeSlot, badgeProps] = useSlot("badge", {
		elementType: BadgeBadge,
		externalForwardedProps,
		ownerState,
		className: classes.badge,
		additionalProps: {
			"aria-hidden": true,
			style: {
				"--Badge-translate": `${horizontal === "right" ? "50%" : "-50%"}, ${vertical === "top" ? "-50%" : "50%"}`,
				"--Badge-inset": `${top} ${right} ${bottom} ${left}`,
				"--Badge-origin": `${horizontal === "right" ? "100%" : "0%"} ${vertical === "top" ? "0%" : "100%"}`
			}
		}
	});
	return /*#__PURE__*/ jsxs(RootSlot, {
		...rootProps,
		children: [children, /*#__PURE__*/ jsx(BadgeSlot, {
			...badgeProps,
			children: displayValue
		})]
	});
});
Badge$1.propTypes = {
	/**
	* The anchor of the badge.
	* @default {
	*   vertical: 'top',
	*   horizontal: 'right',
	* }
	*/
	anchorOrigin: import_prop_types.default.shape({
		horizontal: import_prop_types.default.oneOf(["left", "right"]),
		vertical: import_prop_types.default.oneOf(["bottom", "top"])
	}),
	/**
	* The content rendered within the badge.
	*/
	badgeContent: import_prop_types.default.node,
	/**
	* The badge will be added relative to this node.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'default'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"default",
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, the badge is invisible.
	* @default false
	*/
	invisible: import_prop_types.default.bool,
	/**
	* Max count to show.
	* @default 99
	*/
	max: import_prop_types.default.number,
	/**
	* Wrapped shape the badge should overlap.
	* @default 'rectangular'
	*/
	overlap: import_prop_types.default.oneOf(["circular", "rectangular"]),
	/**
	* Controls whether the badge is hidden when `badgeContent` is zero.
	* @default false
	*/
	showZero: import_prop_types.default.bool,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		badge: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		badge: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The variant to use.
	* @default 'standard'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["dot", "standard"]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Box/boxClasses.mjs
const boxClasses = generateUtilityClasses("MuiBox", ["root"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Box/Box.mjs
const defaultTheme = createTheme$1();
const Box = createBox({
	themeId: identifier_default,
	defaultTheme,
	defaultClassName: boxClasses.root,
	generateClassName: ClassNameGenerator.generate
});
Box.propTypes = {
	/**
	* @ignore
	*/
	children: import_prop_types.default.node,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/MoreHoriz.mjs
/**
* @ignore - internal component.
*/
var MoreHoriz_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }), "MoreHoriz");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Breadcrumbs/BreadcrumbCollapsed.mjs
const BreadcrumbCollapsedButton = styled$2(ButtonBase, { name: "MuiBreadcrumbCollapsed" })(memoTheme(({ theme }) => ({
	display: "flex",
	marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
	marginRight: `calc(${theme.spacing(1)} * 0.5)`,
	...theme.palette.mode === "light" ? {
		backgroundColor: theme.palette.grey[100],
		color: theme.palette.grey[700]
	} : {
		backgroundColor: theme.palette.grey[700],
		color: theme.palette.grey[100]
	},
	borderRadius: 2,
	"&:hover, &:focus": { ...theme.palette.mode === "light" ? { backgroundColor: theme.palette.grey[200] } : { backgroundColor: theme.palette.grey[600] } },
	"&:active": {
		boxShadow: theme.shadows[0],
		...theme.palette.mode === "light" ? { backgroundColor: emphasize(theme.palette.grey[200], .12) } : { backgroundColor: emphasize(theme.palette.grey[600], .12) }
	}
})));
const BreadcrumbCollapsedIcon = styled$2(MoreHoriz_default)({
	width: 24,
	height: 16
});
/**
* @ignore - internal component.
*/
function BreadcrumbCollapsed(props) {
	const { slots = {}, slotProps = {}, ...otherProps } = props;
	const { nativeButton, ...buttonBaseProps } = otherProps;
	const ownerState = props;
	return /*#__PURE__*/ jsx("li", { children: /*#__PURE__*/ jsx(BreadcrumbCollapsedButton, {
		focusRipple: true,
		...buttonBaseProps,
		ownerState,
		children: /*#__PURE__*/ jsx(BreadcrumbCollapsedIcon, {
			as: slots.CollapsedIcon,
			ownerState,
			...slotProps.collapsedIcon
		})
	}) });
}
BreadcrumbCollapsed.propTypes = {
	/**
	* The props used for the CollapsedIcon slot.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({ collapsedIcon: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]) }),
	/**
	* The components used for each slot inside the BreadcumbCollapsed.
	* Either a string to use a HTML element or a component.
	* @default {}
	*/
	slots: import_prop_types.default.shape({ CollapsedIcon: import_prop_types.default.elementType }),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.object
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Breadcrumbs/breadcrumbsClasses.mjs
function getBreadcrumbsUtilityClass(slot) {
	return generateUtilityClass("MuiBreadcrumbs", slot);
}
const breadcrumbsClasses = generateUtilityClasses("MuiBreadcrumbs", [
	"root",
	"ol",
	"li",
	"separator"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Breadcrumbs/Breadcrumbs.mjs
const useUtilityClasses$58 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({
		root: ["root"],
		li: ["li"],
		ol: ["ol"],
		separator: ["separator"]
	}, getBreadcrumbsUtilityClass, classes);
};
const BreadcrumbsRoot = styled$2(Typography$1, {
	name: "MuiBreadcrumbs",
	slot: "Root",
	overridesResolver: (props, styles) => {
		return [{ [`& .${breadcrumbsClasses.li}`]: styles.li }, styles.root];
	}
})({});
const BreadcrumbsOl = styled$2("ol", {
	name: "MuiBreadcrumbs",
	slot: "Ol"
})({
	display: "flex",
	flexWrap: "wrap",
	alignItems: "center",
	padding: 0,
	margin: 0,
	listStyle: "none"
});
const BreadcrumbsSeparator = styled$2("li", {
	name: "MuiBreadcrumbs",
	slot: "Separator"
})({
	display: "flex",
	userSelect: "none",
	marginLeft: 8,
	marginRight: 8
});
function insertSeparators(items, className, separator, ownerState) {
	return items.reduce((acc, current, index) => {
		if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ jsx(BreadcrumbsSeparator, {
			"aria-hidden": true,
			className,
			ownerState,
			children: separator
		}, `separator-${index}`));
		else acc.push(current);
		return acc;
	}, []);
}
const Breadcrumbs$1 = /*#__PURE__*/ React$1.forwardRef(function Breadcrumbs(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiBreadcrumbs"
	});
	const { children, className, component = "nav", slots = {}, slotProps = {}, expandText = "Show path", itemsAfterCollapse = 1, itemsBeforeCollapse = 1, maxItems = 8, separator = "/", ...other } = props;
	const [expanded, setExpanded] = React$1.useState(false);
	const ownerState = {
		...props,
		component,
		expanded,
		expandText,
		itemsAfterCollapse,
		itemsBeforeCollapse,
		maxItems,
		separator
	};
	const classes = useUtilityClasses$58(ownerState);
	const collapsedIconSlotProps = useSlotProps({
		elementType: slots.CollapsedIcon,
		externalSlotProps: slotProps.collapsedIcon,
		ownerState
	});
	const listRef = React$1.useRef(null);
	const renderItemsBeforeAndAfter = (allItems) => {
		const handleClickExpand = () => {
			setExpanded(true);
			const focusable = listRef.current.querySelector("a[href],button,[tabindex]");
			if (focusable) focusable.focus();
		};
		if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
			console.error(["MUI: You have provided an invalid combination of props to the Breadcrumbs.", `itemsAfterCollapse={${itemsAfterCollapse}} + itemsBeforeCollapse={${itemsBeforeCollapse}} >= maxItems={${maxItems}}`].join("\n"));
			return allItems;
		}
		return [
			...allItems.slice(0, itemsBeforeCollapse),
			/*#__PURE__*/ jsx(BreadcrumbCollapsed, {
				"aria-label": expandText,
				slots: { CollapsedIcon: slots.CollapsedIcon },
				slotProps: { collapsedIcon: collapsedIconSlotProps },
				onClick: handleClickExpand
			}, "ellipsis"),
			...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
		];
	};
	const allItems = React$1.Children.toArray(children).filter((child) => {
		if ((0, import_react_is.isFragment)(child)) console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join("\n"));
		return /*#__PURE__*/ React$1.isValidElement(child);
	}).map((child, index) => /*#__PURE__*/ jsx("li", {
		className: classes.li,
		children: child
	}, `child-${index}`));
	return /*#__PURE__*/ jsx(BreadcrumbsRoot, {
		ref,
		component,
		color: "textSecondary",
		className: clsx(classes.root, className),
		ownerState,
		...other,
		children: /*#__PURE__*/ jsx(BreadcrumbsOl, {
			className: classes.ol,
			ref: listRef,
			ownerState,
			children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
		})
	});
});
Breadcrumbs$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* Override the default label for the expand button.
	*
	* For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
	* @default 'Show path'
	*/
	expandText: import_prop_types.default.string,
	/**
	* If max items is exceeded, the number of items to show after the ellipsis.
	* @default 1
	*/
	itemsAfterCollapse: integerPropType,
	/**
	* If max items is exceeded, the number of items to show before the ellipsis.
	* @default 1
	*/
	itemsBeforeCollapse: integerPropType,
	/**
	* Specifies the maximum number of breadcrumbs to display. When there are more
	* than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
	* will be shown, with an ellipsis in between.
	* @default 8
	*/
	maxItems: integerPropType,
	/**
	* Custom separator node.
	* @default '/'
	*/
	separator: import_prop_types.default.node,
	/**
	* The props used for each slot inside the Breadcumb.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({ collapsedIcon: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]) }),
	/**
	* The components used for each slot inside the Breadcumb.
	* Either a string to use a HTML element or a component.
	* @default {}
	*/
	slots: import_prop_types.default.shape({ CollapsedIcon: import_prop_types.default.elementType }),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Button/buttonClasses.mjs
function getButtonUtilityClass(slot) {
	return generateUtilityClass("MuiButton", slot);
}
const buttonClasses = generateUtilityClasses("MuiButton", [
	"root",
	"text",
	"outlined",
	"contained",
	"disableElevation",
	"focusVisible",
	"disabled",
	"colorInherit",
	"colorPrimary",
	"colorSecondary",
	"colorSuccess",
	"colorError",
	"colorInfo",
	"colorWarning",
	"sizeMedium",
	"sizeSmall",
	"sizeLarge",
	"fullWidth",
	"startIcon",
	"endIcon",
	"icon",
	"loading",
	"loadingWrapper",
	"loadingIconPlaceholder",
	"loadingIndicator",
	"loadingPositionCenter",
	"loadingPositionStart",
	"loadingPositionEnd"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ButtonGroup/ButtonGroupContext.mjs
/**
* @ignore - internal component.
*/
const ButtonGroupContext = /*#__PURE__*/ React$1.createContext({});
ButtonGroupContext.displayName = "ButtonGroupContext";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ButtonGroup/ButtonGroupButtonContext.mjs
/**
* @ignore - internal component.
*/
const ButtonGroupButtonContext = /*#__PURE__*/ React$1.createContext(void 0);
ButtonGroupButtonContext.displayName = "ButtonGroupButtonContext";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Button/Button.mjs
const useUtilityClasses$57 = (ownerState) => {
	const { color, disableElevation, fullWidth, size, variant, loading, loadingPosition, classes } = ownerState;
	const slots = {
		root: [
			"root",
			loading && "loading",
			variant,
			`size${capitalize_default(size)}`,
			`color${capitalize_default(color)}`,
			disableElevation && "disableElevation",
			fullWidth && "fullWidth",
			loading && `loadingPosition${capitalize_default(loadingPosition)}`
		],
		startIcon: ["icon", "startIcon"],
		endIcon: ["icon", "endIcon"],
		loadingIndicator: ["loadingIndicator"],
		loadingWrapper: ["loadingWrapper"]
	};
	const composedClasses = composeClasses(slots, getButtonUtilityClass, classes);
	return {
		...classes,
		...composedClasses
	};
};
const commonIconStyles = [
	{
		props: { size: "small" },
		style: { "& > *:nth-of-type(1)": { fontSize: 18 } }
	},
	{
		props: { size: "medium" },
		style: { "& > *:nth-of-type(1)": { fontSize: 20 } }
	},
	{
		props: { size: "large" },
		style: { "& > *:nth-of-type(1)": { fontSize: 22 } }
	}
];
const ButtonRoot = styled$2(ButtonBase, {
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
	name: "MuiButton",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[ownerState.variant],
			styles[`size${capitalize_default(ownerState.size)}`],
			ownerState.color === "inherit" && styles.colorInherit,
			ownerState.disableElevation && styles.disableElevation,
			ownerState.fullWidth && styles.fullWidth,
			ownerState.loading && styles.loading
		];
	}
})(memoTheme(({ theme }) => {
	const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
	const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
	return {
		...theme.typography.button,
		minWidth: 64,
		padding: "6px 16px",
		border: 0,
		borderRadius: (theme.vars || theme).shape.borderRadius,
		...getTransitionStyles(theme, [
			"background-color",
			"box-shadow",
			"border-color",
			"color"
		], { duration: theme.transitions.duration.short }),
		"&:hover": { textDecoration: "none" },
		[`&.${buttonClasses.disabled}`]: { color: (theme.vars || theme).palette.action.disabled },
		variants: [
			{
				props: { variant: "contained" },
				style: {
					color: `var(--variant-containedColor)`,
					backgroundColor: `var(--variant-containedBg)`,
					boxShadow: (theme.vars || theme).shadows[2],
					"&:hover": {
						boxShadow: (theme.vars || theme).shadows[4],
						"@media (hover: none)": { boxShadow: (theme.vars || theme).shadows[2] }
					},
					"&:active": { boxShadow: (theme.vars || theme).shadows[8] },
					[`&.${buttonClasses.focusVisible}`]: {
						...theme.focusVisible,
						boxShadow: theme.focusVisible?.boxShadow ? `${(theme.vars || theme).shadows[6]}, ${theme.focusVisible.boxShadow}` : (theme.vars || theme).shadows[6]
					},
					[`&.${buttonClasses.disabled}`]: {
						color: (theme.vars || theme).palette.action.disabled,
						boxShadow: (theme.vars || theme).shadows[0],
						backgroundColor: (theme.vars || theme).palette.action.disabledBackground
					}
				}
			},
			{
				props: { variant: "outlined" },
				style: {
					padding: "5px 15px",
					border: "1px solid currentColor",
					borderColor: `var(--variant-outlinedBorder, currentColor)`,
					backgroundColor: `var(--variant-outlinedBg)`,
					color: `var(--variant-outlinedColor)`,
					[`&.${buttonClasses.disabled}`]: { border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}` }
				}
			},
			{
				props: { variant: "text" },
				style: {
					padding: "6px 8px",
					color: `var(--variant-textColor)`,
					backgroundColor: `var(--variant-textBg)`
				}
			},
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
				props: { color },
				style: {
					"--variant-textColor": (theme.vars || theme).palette[color].main,
					"--variant-outlinedColor": (theme.vars || theme).palette[color].main,
					"--variant-outlinedBorder": theme.alpha((theme.vars || theme).palette[color].main, .5),
					"--variant-containedColor": (theme.vars || theme).palette[color].contrastText,
					"--variant-containedBg": (theme.vars || theme).palette[color].main,
					"@media (hover: hover)": { "&:hover": {
						"--variant-containedBg": (theme.vars || theme).palette[color].dark,
						"--variant-textBg": theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
						"--variant-outlinedBorder": (theme.vars || theme).palette[color].main,
						"--variant-outlinedBg": theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
					} }
				}
			})),
			{
				props: { color: "inherit" },
				style: {
					color: "inherit",
					borderColor: "currentColor",
					"--variant-containedBg": theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
					"@media (hover: hover)": { "&:hover": {
						"--variant-containedBg": theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
						"--variant-textBg": theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
						"--variant-outlinedBg": theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
					} }
				}
			},
			{
				props: {
					size: "small",
					variant: "text"
				},
				style: {
					padding: "4px 5px",
					fontSize: theme.typography.pxToRem(13)
				}
			},
			{
				props: {
					size: "large",
					variant: "text"
				},
				style: {
					padding: "8px 11px",
					fontSize: theme.typography.pxToRem(15)
				}
			},
			{
				props: {
					size: "small",
					variant: "outlined"
				},
				style: {
					padding: "3px 9px",
					fontSize: theme.typography.pxToRem(13)
				}
			},
			{
				props: {
					size: "large",
					variant: "outlined"
				},
				style: {
					padding: "7px 21px",
					fontSize: theme.typography.pxToRem(15)
				}
			},
			{
				props: {
					size: "small",
					variant: "contained"
				},
				style: {
					padding: "4px 10px",
					fontSize: theme.typography.pxToRem(13)
				}
			},
			{
				props: {
					size: "large",
					variant: "contained"
				},
				style: {
					padding: "8px 22px",
					fontSize: theme.typography.pxToRem(15)
				}
			},
			{
				props: { disableElevation: true },
				style: {
					boxShadow: "none",
					"&:hover": { boxShadow: "none" },
					[`&.${buttonClasses.focusVisible}`]: { boxShadow: theme.focusVisible?.boxShadow ?? "none" },
					"&:active": { boxShadow: "none" },
					[`&.${buttonClasses.disabled}`]: { boxShadow: "none" }
				}
			},
			{
				props: { fullWidth: true },
				style: { width: "100%" }
			},
			{
				props: { loadingPosition: "center" },
				style: {
					...getTransitionStyles(theme, [
						"background-color",
						"box-shadow",
						"border-color"
					], { duration: theme.transitions.duration.short }),
					[`&.${buttonClasses.loading}`]: { color: "transparent" }
				}
			}
		]
	};
}));
const ButtonStartIcon = styled$2("span", {
	name: "MuiButton",
	slot: "StartIcon",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.startIcon, ownerState.loading && styles.startIconLoadingStart];
	}
})(({ theme }) => ({
	display: "inherit",
	alignItems: "center",
	marginRight: 8,
	marginLeft: -4,
	"&::before": {
		content: "\"\\200b\"",
		width: 0,
		overflow: "hidden"
	},
	variants: [
		{
			props: { size: "small" },
			style: { marginLeft: -2 }
		},
		{
			props: {
				loadingPosition: "start",
				loading: true
			},
			style: {
				...getTransitionStyles(theme, ["opacity"], { duration: theme.transitions.duration.short }),
				opacity: 0
			}
		},
		{
			props: {
				loadingPosition: "start",
				loading: true,
				fullWidth: true
			},
			style: { marginRight: -8 }
		},
		...commonIconStyles
	]
}));
const ButtonEndIcon = styled$2("span", {
	name: "MuiButton",
	slot: "EndIcon",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.endIcon, ownerState.loading && styles.endIconLoadingEnd];
	}
})(({ theme }) => ({
	display: "inherit",
	marginRight: -4,
	marginLeft: 8,
	variants: [
		{
			props: { size: "small" },
			style: { marginRight: -2 }
		},
		{
			props: {
				loadingPosition: "end",
				loading: true
			},
			style: {
				...getTransitionStyles(theme, ["opacity"], { duration: theme.transitions.duration.short }),
				opacity: 0
			}
		},
		{
			props: {
				loadingPosition: "end",
				loading: true,
				fullWidth: true
			},
			style: { marginLeft: -8 }
		},
		...commonIconStyles
	]
}));
const ButtonLoadingIndicator = styled$2("span", {
	name: "MuiButton",
	slot: "LoadingIndicator"
})(({ theme }) => ({
	display: "none",
	position: "absolute",
	visibility: "visible",
	variants: [
		{
			props: { loading: true },
			style: { display: "flex" }
		},
		{
			props: { loadingPosition: "start" },
			style: { left: 14 }
		},
		{
			props: {
				loadingPosition: "start",
				size: "small"
			},
			style: { left: 10 }
		},
		{
			props: {
				variant: "text",
				loadingPosition: "start"
			},
			style: { left: 6 }
		},
		{
			props: { loadingPosition: "center" },
			style: {
				left: "50%",
				transform: "translate(-50%)",
				color: (theme.vars || theme).palette.action.disabled
			}
		},
		{
			props: { loadingPosition: "end" },
			style: { right: 14 }
		},
		{
			props: {
				loadingPosition: "end",
				size: "small"
			},
			style: { right: 10 }
		},
		{
			props: {
				variant: "text",
				loadingPosition: "end"
			},
			style: { right: 6 }
		},
		{
			props: {
				loadingPosition: "start",
				fullWidth: true
			},
			style: {
				position: "relative",
				left: -10
			}
		},
		{
			props: {
				loadingPosition: "end",
				fullWidth: true
			},
			style: {
				position: "relative",
				right: -10
			}
		}
	]
}));
const ButtonLoadingIconPlaceholder = styled$2("span", {
	name: "MuiButton",
	slot: "LoadingIconPlaceholder"
})({
	display: "inline-block",
	width: "1em",
	height: "1em"
});
const Button$1 = /*#__PURE__*/ React$1.forwardRef(function Button(inProps, ref) {
	const contextProps = React$1.useContext(ButtonGroupContext);
	const buttonGroupButtonContextPositionClassName = React$1.useContext(ButtonGroupButtonContext);
	const resolvedProps = resolveProps(contextProps, inProps);
	const props = useDefaultProps({
		props: resolvedProps,
		name: "MuiButton"
	});
	const { children, color = "primary", component = "button", className, disabled = false, disableElevation = false, disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName, fullWidth = false, id: idProp, loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition = "center", size = "medium", startIcon: startIconProp, type, variant = "text", ...other } = props;
	const loadingId = useId_default(idProp);
	const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ jsx(CircularProgress$1, {
		"aria-labelledby": loadingId,
		color: "inherit",
		size: 16
	});
	const ownerState = {
		...props,
		color,
		component,
		disabled,
		disableElevation,
		disableFocusRipple,
		fullWidth,
		loading,
		loadingIndicator,
		loadingPosition,
		size,
		type,
		variant
	};
	const classes = useUtilityClasses$57(ownerState);
	const startIcon = (startIconProp || loading && loadingPosition === "start") && /*#__PURE__*/ jsx(ButtonStartIcon, {
		className: classes.startIcon,
		ownerState,
		children: startIconProp || /*#__PURE__*/ jsx(ButtonLoadingIconPlaceholder, {
			className: classes.loadingIconPlaceholder,
			ownerState
		})
	});
	const endIcon = (endIconProp || loading && loadingPosition === "end") && /*#__PURE__*/ jsx(ButtonEndIcon, {
		className: classes.endIcon,
		ownerState,
		children: endIconProp || /*#__PURE__*/ jsx(ButtonLoadingIconPlaceholder, {
			className: classes.loadingIconPlaceholder,
			ownerState
		})
	});
	const positionClassName = buttonGroupButtonContextPositionClassName || "";
	const loader = typeof loading === "boolean" ? /*#__PURE__*/ jsx("span", {
		className: classes.loadingWrapper,
		style: { display: "contents" },
		children: loading && /*#__PURE__*/ jsx(ButtonLoadingIndicator, {
			className: classes.loadingIndicator,
			ownerState,
			children: loadingIndicator
		})
	}) : null;
	const { root, ...forwardedClasses } = classes;
	return /*#__PURE__*/ jsxs(ButtonRoot, {
		ownerState,
		className: clsx(contextProps.className, classes.root, className, positionClassName),
		component,
		disabled: disabled || loading,
		focusRipple: !disableFocusRipple,
		focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
		ref,
		internalNativeButton: true,
		type,
		id: loading ? loadingId : idProp,
		...other,
		classes: forwardedClasses,
		children: [
			startIcon,
			loadingPosition !== "end" && loader,
			children,
			loadingPosition === "end" && loader,
			endIcon
		]
	});
});
Button$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'primary'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"inherit",
		"primary",
		"secondary",
		"success",
		"error",
		"info",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, no elevation is used.
	* @default false
	*/
	disableElevation: import_prop_types.default.bool,
	/**
	* If `true`, the  keyboard focus ripple is disabled.
	* @default false
	*/
	disableFocusRipple: import_prop_types.default.bool,
	/**
	* If `true`, the ripple effect is disabled.
	*
	* ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	* to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
	* @default false
	*/
	disableRipple: import_prop_types.default.bool,
	/**
	* Element placed after the children.
	*/
	endIcon: import_prop_types.default.node,
	/**
	* @ignore
	*/
	focusVisibleClassName: import_prop_types.default.string,
	/**
	* If `true`, the button will take up the full width of its container.
	* @default false
	*/
	fullWidth: import_prop_types.default.bool,
	/**
	* The URL to link to when the button is clicked.
	* If defined, an `a` element will be used as the root node.
	*/
	href: import_prop_types.default.string,
	/**
	* @ignore
	*/
	id: import_prop_types.default.string,
	/**
	* If `true`, the loading indicator is visible and the button is disabled.
	* If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
	* @default null
	*/
	loading: import_prop_types.default.bool,
	/**
	* Element placed before the children if the button is in loading state.
	* The node should contain an element with `role="progressbar"` with an accessible name.
	* By default, it renders a `CircularProgress` that is labeled by the button itself.
	* @default <CircularProgress color="inherit" size={16} />
	*/
	loadingIndicator: import_prop_types.default.node,
	/**
	* The loading indicator can be positioned on the start, end, or the center of the button.
	* @default 'center'
	*/
	loadingPosition: import_prop_types.default.oneOf([
		"center",
		"end",
		"start"
	]),
	/**
	* The size of the component.
	* `small` is equivalent to the dense button styling.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"small",
		"medium",
		"large"
	]), import_prop_types.default.string]),
	/**
	* Element placed before the children.
	*/
	startIcon: import_prop_types.default.node,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* @ignore
	*/
	type: import_prop_types.default.string,
	/**
	* The variant to use.
	* @default 'text'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"contained",
		"outlined",
		"text"
	]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/getValidReactChildren/getValidReactChildren.mjs
/**
* Gets only the valid children of a component,
* and ignores any nullish or falsy child.
*
* @param children the children
*/
function getValidReactChildren(children) {
	return React$1.Children.toArray(children).filter((child) => /*#__PURE__*/ React$1.isValidElement(child));
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/switchBaseClasses.mjs
function getSwitchBaseUtilityClass(slot) {
	return generateUtilityClass("PrivateSwitchBase", slot);
}
generateUtilityClasses("PrivateSwitchBase", [
	"root",
	"checked",
	"disabled",
	"input",
	"edgeStart",
	"edgeEnd"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/SwitchBase.mjs
const useUtilityClasses$56 = (ownerState) => {
	const { classes, checked, disabled, edge } = ownerState;
	const slots = {
		root: [
			"root",
			checked && "checked",
			disabled && "disabled",
			edge && `edge${capitalize_default(edge)}`
		],
		input: ["input"]
	};
	return composeClasses(slots, getSwitchBaseUtilityClass, classes);
};
const SwitchBaseRoot = styled$2(ButtonBase, { name: "MuiSwitchBase" })({
	padding: 9,
	borderRadius: "50%",
	variants: [
		{
			props: {
				edge: "start",
				size: "small"
			},
			style: { marginLeft: -3 }
		},
		{
			props: ({ edge, ownerState }) => edge === "start" && ownerState.size !== "small",
			style: { marginLeft: -12 }
		},
		{
			props: {
				edge: "end",
				size: "small"
			},
			style: { marginRight: -3 }
		},
		{
			props: ({ edge, ownerState }) => edge === "end" && ownerState.size !== "small",
			style: { marginRight: -12 }
		}
	]
});
const SwitchBaseInput = styled$2("input", {
	name: "MuiSwitchBase",
	shouldForwardProp: rootShouldForwardProp
})({
	cursor: "inherit",
	position: "absolute",
	opacity: 0,
	width: "100%",
	height: "100%",
	top: 0,
	left: 0,
	margin: 0,
	padding: 0,
	zIndex: 1
});
/**
* @ignore - internal component.
*/
const SwitchBase = /*#__PURE__*/ React$1.forwardRef(function SwitchBase(props, ref) {
	const { autoFocus, checked: checkedProp, checkedIcon, defaultChecked, disabled: disabledProp, disableFocusRipple = false, edge = false, icon, id, name, onBlur, onChange, onFocus, readOnly, required = false, tabIndex, type, value, slots = {}, slotProps = {}, ...other } = props;
	const { nativeButton, ...buttonBaseProps } = other;
	const [checked, setCheckedState] = useControlled_default({
		controlled: checkedProp,
		default: Boolean(defaultChecked),
		name: "SwitchBase",
		state: "checked"
	});
	const muiFormControl = useFormControl();
	const handleFocus = (event) => {
		if (onFocus) onFocus(event);
		if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
	};
	const handleBlur = (event) => {
		if (onBlur) onBlur(event);
		if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
	};
	const handleInputChange = (event) => {
		if (event.nativeEvent.defaultPrevented || readOnly) return;
		const newChecked = event.target.checked;
		setCheckedState(newChecked);
		if (onChange) onChange(event, newChecked);
	};
	let disabled = disabledProp;
	if (muiFormControl) {
		if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
	}
	const hasLabelFor = type === "checkbox" || type === "radio";
	const ownerState = {
		...props,
		checked,
		disabled,
		disableFocusRipple,
		edge
	};
	const classes = useUtilityClasses$56(ownerState);
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [RootSlot, rootSlotProps] = useSlot("root", {
		ref,
		elementType: SwitchBaseRoot,
		className: classes.root,
		shouldForwardComponentProp: true,
		externalForwardedProps: {
			...externalForwardedProps,
			component: "span",
			...buttonBaseProps
		},
		getSlotProps: (handlers) => ({
			...handlers,
			onFocus: (event) => {
				handlers.onFocus?.(event);
				handleFocus(event);
			},
			onBlur: (event) => {
				handlers.onBlur?.(event);
				handleBlur(event);
			}
		}),
		ownerState,
		additionalProps: {
			centerRipple: true,
			focusRipple: !disableFocusRipple,
			role: void 0,
			tabIndex: null,
			internalDisabledThemeFocusVisible: true
		}
	});
	const [InputSlot, inputSlotProps] = useSlot("input", {
		elementType: SwitchBaseInput,
		className: classes.input,
		externalForwardedProps,
		getSlotProps: (handlers) => ({
			...handlers,
			onChange: (event) => {
				handlers.onChange?.(event);
				handleInputChange(event);
			}
		}),
		ownerState,
		additionalProps: {
			autoFocus,
			checked: checkedProp,
			defaultChecked,
			disabled,
			id: hasLabelFor ? id : void 0,
			name,
			readOnly,
			required,
			tabIndex,
			type,
			...type === "checkbox" && value === void 0 ? {} : { value }
		}
	});
	return /*#__PURE__*/ jsxs(RootSlot, {
		...rootSlotProps,
		children: [/*#__PURE__*/ jsx(InputSlot, { ...inputSlotProps }), checked ? checkedIcon : icon]
	});
});
SwitchBase.propTypes = {
	/**
	* If `true`, the `input` element is focused during the first mount.
	*/
	autoFocus: import_prop_types.default.bool,
	/**
	* If `true`, the component is checked.
	*/
	checked: import_prop_types.default.bool,
	/**
	* The icon to display when the component is checked.
	*/
	checkedIcon: import_prop_types.default.node.isRequired,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* @ignore
	*/
	defaultChecked: import_prop_types.default.bool,
	/**
	* If `true`, the component is disabled.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the  keyboard focus ripple is disabled.
	* @default false
	*/
	disableFocusRipple: import_prop_types.default.bool,
	/**
	* If given, uses a negative margin to counteract the padding on one
	* side (this is often helpful for aligning the left or right
	* side of the icon with content above or below, without ruining the border
	* size and shape).
	* @default false
	*/
	edge: import_prop_types.default.oneOf([
		"end",
		"start",
		false
	]),
	/**
	* The icon to display when the component is unchecked.
	*/
	icon: import_prop_types.default.node.isRequired,
	/**
	* The id of the `input` element.
	*/
	id: import_prop_types.default.string,
	name: import_prop_types.default.string,
	/**
	* @ignore
	*/
	onBlur: import_prop_types.default.func,
	/**
	* Callback fired when the state is changed.
	*
	* @param {object} event The event source of the callback.
	* You can pull out the new checked state by accessing `event.target.checked` (boolean).
	*/
	onChange: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onFocus: import_prop_types.default.func,
	/**
	* It prevents the user from changing the value of the field
	* (not from interacting with the field).
	*/
	readOnly: import_prop_types.default.bool,
	/**
	* If `true`, the `input` element is required.
	*/
	required: import_prop_types.default.bool,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		input: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		input: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.object,
	/**
	* @ignore
	*/
	tabIndex: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* The input component prop `type`.
	*/
	type: import_prop_types.default.string.isRequired,
	/**
	* The value of the component.
	*/
	value: import_prop_types.default.any
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/CheckBoxOutlineBlank.mjs
/**
* @ignore - internal component.
*/
var CheckBoxOutlineBlank_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" }), "CheckBoxOutlineBlank");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/CheckBox.mjs
/**
* @ignore - internal component.
*/
var CheckBox_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" }), "CheckBox");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/IndeterminateCheckBox.mjs
/**
* @ignore - internal component.
*/
var IndeterminateCheckBox_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z" }), "IndeterminateCheckBox");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Checkbox/Checkbox.mjs
const useUtilityClasses$55 = (ownerState) => {
	const { classes, indeterminate, color, size } = ownerState;
	const slots = { root: [
		"root",
		indeterminate && "indeterminate",
		`color${capitalize_default(color)}`,
		`size${capitalize_default(size)}`
	] };
	const composedClasses = composeClasses(slots, getCheckboxUtilityClass, classes);
	return {
		...classes,
		...composedClasses
	};
};
const CheckboxRoot = styled$2(SwitchBase, {
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
	name: "MuiCheckbox",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.indeterminate && styles.indeterminate,
			styles[`size${capitalize_default(ownerState.size)}`],
			ownerState.color !== "default" && styles[`color${capitalize_default(ownerState.color)}`]
		];
	}
})(memoTheme(({ theme }) => ({
	color: (theme.vars || theme).palette.text.secondary,
	...theme.focusVisible && { [`&.${buttonBaseClasses.focusVisible} svg:first-of-type`]: {
		...outsetFocusRing,
		borderRadius: (theme.vars || theme).shape.borderRadius,
		...theme.focusVisible
	} },
	variants: [
		{
			props: {
				color: "default",
				disableRipple: false
			},
			style: { "&:hover": { backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity) } }
		},
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
			props: {
				color,
				disableRipple: false
			},
			style: { "&:hover": { backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity) } }
		})),
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
			props: { color },
			style: {
				[`&.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]: { color: (theme.vars || theme).palette[color].main },
				[`&.${checkboxClasses.disabled}`]: { color: (theme.vars || theme).palette.action.disabled }
			}
		})),
		{
			props: { disableRipple: false },
			style: { "&:hover": { "@media (hover: none)": { backgroundColor: "transparent" } } }
		}
	]
})));
const defaultCheckedIcon$1 = /*#__PURE__*/ jsx(CheckBox_default, {});
const defaultIcon$1 = /*#__PURE__*/ jsx(CheckBoxOutlineBlank_default, {});
const defaultIndeterminateIcon = /*#__PURE__*/ jsx(IndeterminateCheckBox_default, {});
const Checkbox$1 = /*#__PURE__*/ React$1.forwardRef(function Checkbox(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiCheckbox"
	});
	const { checkedIcon = defaultCheckedIcon$1, color = "primary", icon: iconProp = defaultIcon$1, indeterminate = false, indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon, size = "medium", disableRipple = false, className, slots = {}, slotProps = {}, ...other } = props;
	const icon = indeterminate ? indeterminateIconProp : iconProp;
	const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
	const ownerState = {
		...props,
		disableRipple,
		color,
		indeterminate,
		size
	};
	const classes = useUtilityClasses$55(ownerState);
	const externalInputProps = slotProps.input;
	const [RootSlot, rootSlotProps] = useSlot("root", {
		ref,
		elementType: CheckboxRoot,
		className: clsx(classes.root, className),
		shouldForwardComponentProp: true,
		externalForwardedProps: {
			slots,
			slotProps,
			...other
		},
		ownerState,
		additionalProps: {
			type: "checkbox",
			icon: /*#__PURE__*/ React$1.cloneElement(icon, { fontSize: icon.props.fontSize ?? size }),
			checkedIcon: /*#__PURE__*/ React$1.cloneElement(indeterminateIcon, { fontSize: indeterminateIcon.props.fontSize ?? size }),
			disableRipple: props.disableRipple,
			slots,
			slotProps: { input: mergeSlotProps$1(typeof externalInputProps === "function" ? externalInputProps(ownerState) : externalInputProps, {
				"data-indeterminate": indeterminate,
				"aria-checked": indeterminate ? "mixed" : void 0
			}) }
		}
	});
	return /*#__PURE__*/ jsx(RootSlot, {
		...rootSlotProps,
		classes
	});
});
Checkbox$1.propTypes = {
	/**
	* If `true`, the component is checked.
	*/
	checked: import_prop_types.default.bool,
	/**
	* The icon to display when the component is checked.
	* @default <CheckBoxIcon />
	*/
	checkedIcon: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'primary'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"default",
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* The default checked state. Use when the component is not controlled.
	*/
	defaultChecked: import_prop_types.default.bool,
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the ripple effect is disabled.
	* @default false
	*/
	disableRipple: import_prop_types.default.bool,
	/**
	* The icon to display when the component is unchecked.
	* @default <CheckBoxOutlineBlankIcon />
	*/
	icon: import_prop_types.default.node,
	/**
	* The id of the `input` element.
	*/
	id: import_prop_types.default.string,
	/**
	* If `true`, the component appears indeterminate.
	* This does not set the native input element to indeterminate due
	* to inconsistent behavior across browsers.
	* However, we set a `data-indeterminate` attribute on the `input`.
	* @default false
	*/
	indeterminate: import_prop_types.default.bool,
	/**
	* The icon to display when the component is indeterminate.
	* @default <IndeterminateCheckBoxIcon />
	*/
	indeterminateIcon: import_prop_types.default.node,
	/**
	* Callback fired when the state is changed.
	*
	* @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
	* You can pull out the new checked state by accessing `event.target.checked` (boolean).
	*/
	onChange: import_prop_types.default.func,
	/**
	* If `true`, the `input` element is required.
	* @default false
	*/
	required: import_prop_types.default.bool,
	/**
	* The size of the component.
	* `small` is equivalent to the dense checkbox styling.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["medium", "small"]), import_prop_types.default.string]),
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		input: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		input: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The value of the component. The DOM API casts this to a string.
	* The browser uses "on" as the default value.
	*/
	value: import_prop_types.default.any
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ClickAwayListener/ClickAwayListener.mjs
function mapEventPropToEvent(eventProp) {
	return eventProp.substring(2).toLowerCase();
}
function clickedRootScrollbar(event, doc) {
	return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
* Listen for click events that occur somewhere in the document, outside of the element itself.
* For instance, if you need to hide a menu when people click anywhere else on your page.
*
* Demos:
*
* - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
* - [Menu](https://mui.com/material-ui/react-menu/)
*
* API:
*
* - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
*/
function ClickAwayListener(props) {
	const { children, disableReactTree = false, mouseEvent = "onClick", onClickAway, touchEvent = "onTouchEnd" } = props;
	const movedRef = React$1.useRef(false);
	const nodeRef = React$1.useRef(null);
	const activatedRef = React$1.useRef(false);
	const syntheticEventRef = React$1.useRef(false);
	React$1.useEffect(() => {
		setTimeout(() => {
			activatedRef.current = true;
		}, 0);
		return () => {
			activatedRef.current = false;
		};
	}, []);
	const handleRef = useForkRef(getReactElementRef(children), nodeRef);
	const handleClickAway = useEventCallback((event) => {
		const insideReactTree = syntheticEventRef.current;
		syntheticEventRef.current = false;
		const doc = ownerDocument(nodeRef.current);
		if (!activatedRef.current || !nodeRef.current || "clientX" in event && clickedRootScrollbar(event, doc)) return;
		if (movedRef.current) {
			movedRef.current = false;
			return;
		}
		let insideDOM;
		if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
		else insideDOM = !contains$1(doc.documentElement, event.target) || contains$1(nodeRef.current, event.target);
		if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
	});
	const createHandleSynthetic = (handlerName) => (event) => {
		syntheticEventRef.current = true;
		const childrenPropsHandler = children.props[handlerName];
		if (childrenPropsHandler) childrenPropsHandler(event);
	};
	const childrenProps = { ref: handleRef };
	if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
	React$1.useEffect(() => {
		if (touchEvent !== false) {
			const mappedTouchEvent = mapEventPropToEvent(touchEvent);
			const doc = ownerDocument(nodeRef.current);
			const handleTouchMove = () => {
				movedRef.current = true;
			};
			doc.addEventListener(mappedTouchEvent, handleClickAway);
			doc.addEventListener("touchmove", handleTouchMove);
			return () => {
				doc.removeEventListener(mappedTouchEvent, handleClickAway);
				doc.removeEventListener("touchmove", handleTouchMove);
			};
		}
	}, [handleClickAway, touchEvent]);
	if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
	React$1.useEffect(() => {
		if (mouseEvent !== false) {
			const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
			const doc = ownerDocument(nodeRef.current);
			doc.addEventListener(mappedMouseEvent, handleClickAway);
			return () => {
				doc.removeEventListener(mappedMouseEvent, handleClickAway);
			};
		}
	}, [handleClickAway, mouseEvent]);
	return /*#__PURE__*/ React$1.cloneElement(children, childrenProps);
}
ClickAwayListener.propTypes = {
	/**
	* The wrapped element.
	*/
	children: elementAcceptingRef.isRequired,
	/**
	* If `true`, the React tree is ignored and only the DOM tree is considered.
	* This prop changes how portaled elements are handled.
	* @default false
	*/
	disableReactTree: import_prop_types.default.bool,
	/**
	* The mouse event to listen to. You can disable the listener by providing `false`.
	* @default 'onClick'
	*/
	mouseEvent: import_prop_types.default.oneOf([
		"onClick",
		"onMouseDown",
		"onMouseUp",
		"onPointerDown",
		"onPointerUp",
		false
	]),
	/**
	* Callback fired when a "click away" event is detected.
	*/
	onClickAway: import_prop_types.default.func.isRequired,
	/**
	* The touch event to listen to. You can disable the listener by providing `false`.
	* @default 'onTouchEnd'
	*/
	touchEvent: import_prop_types.default.oneOf([
		"onTouchEnd",
		"onTouchStart",
		false
	])
};
ClickAwayListener["propTypes"] = exactProp(ClickAwayListener.propTypes);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Container/Container.mjs
const Container$1 = createContainer({
	createStyledComponent: styled$2("div", {
		name: "MuiContainer",
		slot: "Root",
		overridesResolver: (props, styles) => {
			const { ownerState } = props;
			return [
				styles.root,
				styles[`maxWidth${capitalize_default(String(ownerState.maxWidth))}`],
				ownerState.fixed && styles.fixed,
				ownerState.disableGutters && styles.disableGutters
			];
		}
	}),
	useThemeProps: (inProps) => useDefaultProps({
		props: inProps,
		name: "MuiContainer"
	})
});
Container$1.propTypes = {
	/**
	* @ignore
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, the left and right padding is removed.
	* @default false
	*/
	disableGutters: import_prop_types.default.bool,
	/**
	* Set the max-width to match the min-width of the current breakpoint.
	* This is useful if you'd prefer to design for a fixed set of sizes
	* instead of trying to accommodate a fully fluid viewport.
	* It's fluid by default.
	* @default false
	*/
	fixed: import_prop_types.default.bool,
	/**
	* Determine the max-width of the container.
	* The container width grows with the size of the screen.
	* Set to `false` to disable `maxWidth`.
	* @default 'lg'
	*/
	maxWidth: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"xs",
		"sm",
		"md",
		"lg",
		"xl",
		false
	]), import_prop_types.default.string]),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/getScrollbarSize/getScrollbarSize.mjs
function getScrollbarSize(win = window) {
	const documentWidth = win.document.documentElement.clientWidth;
	return win.innerWidth - documentWidth;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Modal/ModalManager.mjs
function isOverflowing(container) {
	const doc = ownerDocument(container);
	if (container === doc.body || container === doc.documentElement) return ownerWindow(container).innerWidth > doc.documentElement.clientWidth;
	return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, hide) {
	if (hide) element.setAttribute("aria-hidden", "true");
	else element.removeAttribute("aria-hidden");
}
function getPaddingRight(element) {
	return parseFloat(ownerWindow(element).getComputedStyle(element).paddingRight) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
	const isForbiddenTagName = [
		"TEMPLATE",
		"SCRIPT",
		"STYLE",
		"LINK",
		"MAP",
		"META",
		"NOSCRIPT",
		"PICTURE",
		"COL",
		"COLGROUP",
		"PARAM",
		"SLOT",
		"SOURCE",
		"TRACK"
	].includes(element.tagName);
	const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
	return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
	const blacklist = [
		mountElement,
		currentElement,
		...elementsToExclude
	];
	[].forEach.call(container.children, (element) => {
		const isNotExcludedElement = !blacklist.includes(element);
		const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
		if (isNotExcludedElement && isNotForbiddenElement) ariaHidden(element, hide);
	});
}
function handleContainer(containerInfo, props) {
	const restoreStyle = [];
	const container = containerInfo.container;
	if (!props.disableScrollLock) {
		let scrollContainer;
		if (container.parentNode instanceof DocumentFragment) scrollContainer = ownerDocument(container).body;
		else {
			const parent = container.parentElement;
			const containerWindow = ownerWindow(container);
			scrollContainer = parent?.nodeName === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
		}
		if (isOverflowing(scrollContainer)) {
			const scrollbarSize = getScrollbarSize(ownerWindow(scrollContainer));
			restoreStyle.push({
				value: scrollContainer.style.paddingRight,
				property: "padding-right",
				el: scrollContainer
			});
			scrollContainer.style.paddingRight = `${getPaddingRight(scrollContainer) + scrollbarSize}px`;
			const fixedElements = ownerDocument(container).querySelectorAll(".mui-fixed");
			[].forEach.call(fixedElements, (element) => {
				restoreStyle.push({
					value: element.style.paddingRight,
					property: "padding-right",
					el: element
				});
				element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
			});
		}
		restoreStyle.push({
			value: scrollContainer.style.overflow,
			property: "overflow",
			el: scrollContainer
		}, {
			value: scrollContainer.style.overflowX,
			property: "overflow-x",
			el: scrollContainer
		}, {
			value: scrollContainer.style.overflowY,
			property: "overflow-y",
			el: scrollContainer
		});
		scrollContainer.style.overflow = "hidden";
	}
	const restore = () => {
		restoreStyle.forEach(({ value, el, property }) => {
			if (value) el.style.setProperty(property, value);
			else el.style.removeProperty(property);
		});
	};
	return restore;
}
function getHiddenSiblings(container) {
	const hiddenSiblings = [];
	[].forEach.call(container.children, (element) => {
		if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
	});
	return hiddenSiblings;
}
/**
* @ignore - do not document.
*
* Proper state management for containers and the modals in those containers.
* Simplified, but inspired by react-overlay's ModalManager class.
* Used by the Modal to ensure proper styling of containers.
*/
var ModalManager = class {
	constructor() {
		this.modals = [];
		this.containers = [];
	}
	add(modal, container) {
		let modalIndex = this.modals.indexOf(modal);
		if (modalIndex !== -1) return modalIndex;
		modalIndex = this.modals.length;
		this.modals.push(modal);
		if (modal.modalRef) ariaHidden(modal.modalRef, false);
		const hiddenSiblings = getHiddenSiblings(container);
		ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
		const containerIndex = this.containers.findIndex((item) => item.container === container);
		if (containerIndex !== -1) {
			this.containers[containerIndex].modals.push(modal);
			return modalIndex;
		}
		this.containers.push({
			modals: [modal],
			container,
			restore: null,
			hiddenSiblings
		});
		return modalIndex;
	}
	mount(modal, props) {
		const containerIndex = this.containers.findIndex((item) => item.modals.includes(modal));
		const containerInfo = this.containers[containerIndex];
		if (!containerInfo.restore) containerInfo.restore = handleContainer(containerInfo, props);
	}
	remove(modal, ariaHiddenState = true) {
		const modalIndex = this.modals.indexOf(modal);
		if (modalIndex === -1) return modalIndex;
		const containerIndex = this.containers.findIndex((item) => item.modals.includes(modal));
		const containerInfo = this.containers[containerIndex];
		containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
		this.modals.splice(modalIndex, 1);
		if (containerInfo.modals.length === 0) {
			if (containerInfo.restore) containerInfo.restore();
			if (modal.modalRef) ariaHidden(modal.modalRef, ariaHiddenState);
			ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
			this.containers.splice(containerIndex, 1);
		} else {
			const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
			if (nextTop.modalRef) ariaHidden(nextTop.modalRef, false);
		}
		return modalIndex;
	}
	isTopModal(modal) {
		return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
	}
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/contains.mjs
var contains_default = contains$1;
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/focusable.mjs
const FOCUSABLE_ATTRIBUTE = "data-mui-focusable";
/**
* Returns the element marked as the initial focus target inside a focus trap.
* The root element takes precedence over marked descendants so components can
* opt into focusing their own root surface directly.
*/
function getFocusTarget(rootElement) {
	if (!rootElement) return null;
	return rootElement.hasAttribute("data-mui-focusable") ? rootElement : rootElement.querySelector(`[${FOCUSABLE_ATTRIBUTE}]`);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Unstable_TrapFocus/FocusTrap.mjs
const candidatesSelector = [
	"input",
	"select",
	"textarea",
	"a[href]",
	"button",
	"[tabindex]",
	"audio[controls]",
	"video[controls]",
	"[contenteditable]:not([contenteditable=\"false\"])"
].join(",");
function getTabIndex(node) {
	const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
	if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
	if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
	return node.tabIndex;
}
function isNonTabbableRadio(node) {
	if (node.tagName !== "INPUT" || node.type !== "radio") return false;
	if (!node.name) return false;
	const getRadio = (selector) => node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
	let roving = getRadio(`[name="${node.name}"]:checked`);
	if (!roving) roving = getRadio(`[name="${node.name}"]`);
	return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
	if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || isNonTabbableRadio(node)) return false;
	return true;
}
function defaultGetTabbable(root) {
	const regularTabNodes = [];
	const orderedTabNodes = [];
	Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i) => {
		const nodeTabIndex = getTabIndex(node);
		if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) return;
		if (nodeTabIndex === 0) regularTabNodes.push(node);
		else orderedTabNodes.push({
			documentOrder: i,
			tabIndex: nodeTabIndex,
			node
		});
	});
	return orderedTabNodes.sort((a, b) => a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a) => a.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
	return true;
}
/**
* @ignore - internal component.
*/
function FocusTrap(props) {
	const { children, disableAutoFocus = false, disableEnforceFocus = false, disableRestoreFocus = false, getTabbable = defaultGetTabbable, isEnabled = defaultIsEnabled, open } = props;
	const ignoreNextEnforceFocus = React$1.useRef(false);
	const sentinelStart = React$1.useRef(null);
	const sentinelEnd = React$1.useRef(null);
	const nodeToRestore = React$1.useRef(null);
	const reactFocusEventTarget = React$1.useRef(null);
	const activated = React$1.useRef(false);
	const rootRef = React$1.useRef(null);
	const handleRef = useForkRef(getReactElementRef(children), rootRef);
	const lastKeydown = React$1.useRef(null);
	React$1.useEffect(() => {
		if (!open || !rootRef.current) return;
		activated.current = !disableAutoFocus;
	}, [disableAutoFocus, open]);
	React$1.useEffect(() => {
		ignoreNextEnforceFocus.current = false;
		if (!open || !rootRef.current) return;
		const activeElement = getActiveElement_default(ownerDocument(rootRef.current));
		const focusTarget = getFocusTarget(rootRef.current) ?? rootRef.current;
		if (!contains_default(rootRef.current, activeElement)) {
			if (!focusTarget.hasAttribute("tabIndex")) {
				console.error(["MUI: The modal content node does not accept focus.", "For the benefit of assistive technologies, the tabIndex of the node is being set to \"-1\"."].join("\n"));
				focusTarget.setAttribute("tabIndex", "-1");
			}
			if (activated.current) focusTarget.focus();
		}
		return () => {
			if (!disableRestoreFocus && nodeToRestore.current) {
				ignoreNextEnforceFocus.current = true;
				nodeToRestore.current.focus();
				nodeToRestore.current = null;
			}
		};
	}, [open]);
	React$1.useEffect(() => {
		if (!open || !rootRef.current) return;
		const doc = ownerDocument(rootRef.current);
		const loopFocus = (nativeEvent) => {
			lastKeydown.current = nativeEvent;
			if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
			const rootElement = rootRef.current;
			const activeElement = getActiveElement_default(doc);
			if (rootElement === null) return;
			const focusTarget = getFocusTarget(rootElement);
			if (activeElement === rootElement || activeElement === focusTarget) {
				const tabbable = getTabbable(rootElement);
				if (tabbable.length === 0) return;
				nativeEvent.preventDefault();
				if (nativeEvent.shiftKey) tabbable[tabbable.length - 1].focus();
				else tabbable[0].focus();
				return;
			}
			if (contains_default(rootElement, activeElement)) {
				const tabbable = getTabbable(rootElement);
				const currentIndex = tabbable.indexOf(activeElement);
				if (currentIndex === -1) return;
				if (!tabbable.some((node) => getTabIndex(node) > 0)) return;
				nativeEvent.preventDefault();
				let nextIndex = 0;
				if (nativeEvent.shiftKey) nextIndex = currentIndex <= 0 ? tabbable.length - 1 : currentIndex - 1;
				else nextIndex = currentIndex === tabbable.length - 1 ? 0 : currentIndex + 1;
				tabbable[nextIndex].focus();
			}
		};
		const contain = () => {
			const rootElement = rootRef.current;
			if (rootElement === null) return;
			const activeEl = getActiveElement_default(doc);
			if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
				ignoreNextEnforceFocus.current = false;
				return;
			}
			if (contains_default(rootElement, activeEl)) return;
			if (disableEnforceFocus && activeEl !== sentinelStart.current && activeEl !== sentinelEnd.current) return;
			if (activeEl !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
			else if (reactFocusEventTarget.current !== null) return;
			if (!activated.current) return;
			let tabbable = [];
			if (activeEl === sentinelStart.current || activeEl === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
			if (tabbable.length > 0) {
				const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === "Tab");
				const focusNext = tabbable[0];
				const focusPrevious = tabbable[tabbable.length - 1];
				if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
					if (isShiftTab) focusPrevious.focus();
					else focusNext.focus();
				}
			} else rootElement.focus();
		};
		doc.addEventListener("focusin", contain);
		doc.addEventListener("keydown", loopFocus, true);
		const interval = setInterval(() => {
			const activeEl = getActiveElement_default(doc);
			if (activeEl && activeEl.tagName === "BODY") contain();
		}, 50);
		return () => {
			clearInterval(interval);
			doc.removeEventListener("focusin", contain);
			doc.removeEventListener("keydown", loopFocus, true);
		};
	}, [
		disableAutoFocus,
		disableEnforceFocus,
		disableRestoreFocus,
		isEnabled,
		open,
		getTabbable
	]);
	const onFocus = (event) => {
		if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
		activated.current = true;
		reactFocusEventTarget.current = event.target;
		const childrenPropsHandler = children.props.onFocus;
		if (childrenPropsHandler) childrenPropsHandler(event);
	};
	const handleFocusSentinel = (event) => {
		if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
		activated.current = true;
	};
	return /*#__PURE__*/ jsxs(React$1.Fragment, { children: [
		/*#__PURE__*/ jsx("div", {
			tabIndex: open ? 0 : -1,
			onFocus: handleFocusSentinel,
			ref: sentinelStart,
			"data-testid": "sentinelStart"
		}),
		/*#__PURE__*/ React$1.cloneElement(children, {
			ref: handleRef,
			onFocus
		}),
		/*#__PURE__*/ jsx("div", {
			tabIndex: open ? 0 : -1,
			onFocus: handleFocusSentinel,
			ref: sentinelEnd,
			"data-testid": "sentinelEnd"
		})
	] });
}
FocusTrap.propTypes = {
	/**
	* A single child content element.
	*/
	children: elementAcceptingRef,
	/**
	* If `true`, the focus trap will not automatically shift focus to itself when it opens, and
	* replace it to the last focused element when it closes.
	* This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
	*
	* Generally this should never be set to `true` as it makes the focus trap less
	* accessible to assistive technologies, like screen readers.
	* @default false
	*/
	disableAutoFocus: import_prop_types.default.bool,
	/**
	* If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
	*
	* Generally this should never be set to `true` as it makes the focus trap less
	* accessible to assistive technologies, like screen readers.
	* @default false
	*/
	disableEnforceFocus: import_prop_types.default.bool,
	/**
	* If `true`, the focus trap will not restore focus to previously focused element once
	* focus trap is hidden or unmounted.
	* @default false
	*/
	disableRestoreFocus: import_prop_types.default.bool,
	/**
	* Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
	* For instance, you can provide the "tabbable" npm dependency.
	* @param {HTMLElement} root
	*/
	getTabbable: import_prop_types.default.func,
	/**
	* This prop extends the `open` prop.
	* It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
	* This prop should be memoized.
	* It can be used to support multiple focus trap mounted at the same time.
	* @default function defaultIsEnabled(): boolean {
	*   return true;
	* }
	*/
	isEnabled: import_prop_types.default.func,
	/**
	* If `true`, focus is locked.
	*/
	open: import_prop_types.default.bool.isRequired
};
FocusTrap["propTypes"] = exactProp(FocusTrap.propTypes);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Modal/useModal.mjs
function getContainer(container) {
	return typeof container === "function" ? container() : container;
}
function getHasTransition(children) {
	return children ? children.props.hasOwnProperty("in") : false;
}
const noop = () => {};
const manager = new ModalManager();
function useModal(parameters) {
	const { container, disableScrollLock = false, closeAfterTransition = false, onTransitionEnter, onTransitionExited, children, onClose, open, rootRef } = parameters;
	const modal = React$1.useRef({});
	const mountNodeRef = React$1.useRef(null);
	const lastMountNodeRef = React$1.useRef(null);
	const modalRef = React$1.useRef(null);
	const handleRef = useForkRef(modalRef, rootRef);
	const [exited, setExited] = React$1.useState(!open);
	const hasTransition = getHasTransition(children);
	let ariaHiddenProp = true;
	if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
	const getDoc = () => ownerDocument(mountNodeRef.current);
	const getModal = () => {
		modal.current.modalRef = modalRef.current;
		modal.current.mount = mountNodeRef.current;
		return modal.current;
	};
	const handleMounted = () => {
		manager.mount(getModal(), { disableScrollLock });
		if (modalRef.current) modalRef.current.scrollTop = 0;
	};
	const handleOpen = useEventCallback(() => {
		const resolvedContainer = getContainer(container) || getDoc().body;
		manager.add(getModal(), resolvedContainer);
		if (modalRef.current) handleMounted();
	});
	const isTopModal = () => manager.isTopModal(getModal());
	const handlePortalRef = useEventCallback((node) => {
		mountNodeRef.current = node;
		if (!node) return;
		lastMountNodeRef.current = node;
		if (open && isTopModal()) handleMounted();
		else if (modalRef.current) ariaHidden(modalRef.current, ariaHiddenProp);
	});
	const handleClose = React$1.useCallback(() => {
		manager.remove(getModal(), ariaHiddenProp);
	}, [ariaHiddenProp]);
	React$1.useEffect(() => {
		return () => {
			handleClose();
		};
	}, [handleClose]);
	React$1.useEffect(() => {
		if (open) handleOpen();
		else if (!hasTransition || !closeAfterTransition) handleClose();
	}, [
		open,
		handleClose,
		hasTransition,
		closeAfterTransition,
		handleOpen
	]);
	const createHandleKeyDown = (otherHandlers) => (event) => {
		otherHandlers.onKeyDown?.(event);
		if (event.key !== "Escape" || event.which === 229 || !isTopModal()) return;
		event.stopPropagation();
		if (onClose) onClose(event, "escapeKeyDown");
	};
	const createHandleBackdropClick = (otherHandlers) => (event) => {
		otherHandlers.onClick?.(event);
		if (event.target !== event.currentTarget) return;
		if (onClose) onClose(event, "backdropClick");
	};
	const getRootProps = (otherHandlers = {}) => {
		const propsEventHandlers = extractEventHandlers(parameters);
		delete propsEventHandlers.onTransitionEnter;
		delete propsEventHandlers.onTransitionExited;
		const externalEventHandlers = {
			...propsEventHandlers,
			...otherHandlers
		};
		return {
			role: "presentation",
			...externalEventHandlers,
			onKeyDown: createHandleKeyDown(externalEventHandlers),
			ref: handleRef
		};
	};
	const getBackdropProps = (otherHandlers = {}) => {
		const externalEventHandlers = otherHandlers;
		return {
			"aria-hidden": true,
			...externalEventHandlers,
			onClick: createHandleBackdropClick(externalEventHandlers),
			open
		};
	};
	const getTransitionProps = () => {
		const handleEnter = () => {
			setExited(false);
			if (onTransitionEnter) onTransitionEnter();
		};
		const handleExited = () => {
			setExited(true);
			if (onTransitionExited) onTransitionExited();
			if (closeAfterTransition) handleClose();
		};
		return {
			onEnter: createChainedFunction(handleEnter, children?.props.onEnter ?? noop),
			onExited: createChainedFunction(handleExited, children?.props.onExited ?? noop)
		};
	};
	return {
		getRootProps,
		getBackdropProps,
		getTransitionProps,
		rootRef: handleRef,
		portalRef: handlePortalRef,
		portalContainer: !open && hasTransition && !exited ? lastMountNodeRef.current ?? container : container,
		isTopModal,
		exited,
		hasTransition
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Modal/modalClasses.mjs
function getModalUtilityClass(slot) {
	return generateUtilityClass("MuiModal", slot);
}
generateUtilityClasses("MuiModal", [
	"root",
	"hidden",
	"backdrop"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Modal/Modal.mjs
const useUtilityClasses$54 = (ownerState) => {
	const { open, exited, classes } = ownerState;
	return composeClasses({
		root: ["root", !open && exited && "hidden"],
		backdrop: ["backdrop"]
	}, getModalUtilityClass, classes);
};
const ModalRoot = styled$2("div", {
	name: "MuiModal",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, !ownerState.open && ownerState.exited && styles.hidden];
	}
})(memoTheme(({ theme }) => ({
	position: "fixed",
	zIndex: (theme.vars || theme).zIndex.modal,
	right: 0,
	bottom: 0,
	top: 0,
	left: 0,
	variants: [{
		props: ({ ownerState }) => !ownerState.open && ownerState.exited,
		style: { visibility: "hidden" }
	}]
})));
const ModalBackdrop = styled$2(Backdrop$1, {
	name: "MuiModal",
	slot: "Backdrop"
})({ zIndex: -1 });
/**
* Modal is a lower-level construct that is leveraged by the following components:
*
* - [Dialog](/material-ui/api/dialog/)
* - [Drawer](/material-ui/api/drawer/)
* - [Menu](/material-ui/api/menu/)
* - [Popover](/material-ui/api/popover/)
*
* If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
* rather than directly using Modal.
*
* This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
*/
const Modal = /*#__PURE__*/ React$1.forwardRef(function Modal(inProps, ref) {
	const props = useDefaultProps({
		name: "MuiModal",
		props: inProps
	});
	const { classes: classesProp, className, closeAfterTransition = false, children, container, component, disableAutoFocus = false, disableEnforceFocus = false, disablePortal = false, disableRestoreFocus = false, disableScrollLock = false, hideBackdrop = false, keepMounted = false, onClose, onTransitionEnter, onTransitionExited, open, slotProps = {}, slots = {}, theme, ...other } = props;
	const propsWithDefaults = {
		...props,
		closeAfterTransition,
		disableAutoFocus,
		disableEnforceFocus,
		disablePortal,
		disableRestoreFocus,
		disableScrollLock,
		hideBackdrop,
		keepMounted
	};
	const { getRootProps, getBackdropProps, getTransitionProps, portalRef, portalContainer, isTopModal, exited, hasTransition } = useModal({
		...propsWithDefaults,
		rootRef: ref
	});
	const ownerState = {
		...propsWithDefaults,
		exited
	};
	const classes = useUtilityClasses$54(ownerState);
	const childProps = {};
	if (children.props.tabIndex === void 0) childProps.tabIndex = "-1";
	if (hasTransition) {
		const { onEnter, onExited } = getTransitionProps();
		childProps.onEnter = onEnter;
		childProps.onExited = onExited;
	}
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [RootSlot, rootProps] = useSlot("root", {
		ref,
		elementType: ModalRoot,
		externalForwardedProps: {
			...externalForwardedProps,
			...other,
			component
		},
		getSlotProps: getRootProps,
		ownerState,
		className: clsx(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
	});
	const [BackdropSlot, backdropProps] = useSlot("backdrop", {
		elementType: ModalBackdrop,
		externalForwardedProps,
		shouldForwardComponentProp: true,
		getSlotProps: (otherHandlers) => {
			return getBackdropProps({
				...otherHandlers,
				onClick: (event) => {
					if (otherHandlers?.onClick) otherHandlers.onClick(event);
				}
			});
		},
		className: classes?.backdrop,
		ownerState
	});
	if (!keepMounted && !open && (!hasTransition || exited)) return null;
	return /*#__PURE__*/ jsx(Portal, {
		ref: portalRef,
		container: portalContainer,
		disablePortal,
		children: /*#__PURE__*/ jsxs(RootSlot, {
			...rootProps,
			children: [!hideBackdrop ? /*#__PURE__*/ jsx(BackdropSlot, { ...backdropProps }) : null, /*#__PURE__*/ jsx(FocusTrap, {
				disableEnforceFocus,
				disableAutoFocus,
				disableRestoreFocus,
				isEnabled: isTopModal,
				open,
				children: /*#__PURE__*/ React$1.cloneElement(children, childProps)
			})]
		})
	});
});
Modal.propTypes = {
	/**
	* A single child content element.
	*/
	children: elementAcceptingRef.isRequired,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* When set to true the Modal waits until a nested Transition is completed before closing.
	* @default false
	*/
	closeAfterTransition: import_prop_types.default.bool,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* An HTML element or function that returns one.
	* The `container` will have the portal children appended to it.
	*
	* You can also provide a callback, which is called in a React layout effect.
	* This lets you set the container from a ref, and also makes server-side rendering possible.
	*
	* By default, it uses the body of the top-level document object,
	* so it's simply `document.body` most of the time.
	*/
	container: import_prop_types.default.oneOfType([HTMLElementType, import_prop_types.default.func]),
	/**
	* If `true`, the modal will not automatically shift focus to itself when it opens, and
	* replace it to the last focused element when it closes.
	* This also works correctly with any modal children that have the `disableAutoFocus` prop.
	*
	* Generally this should never be set to `true` as it makes the modal less
	* accessible to assistive technologies, like screen readers.
	* @default false
	*/
	disableAutoFocus: import_prop_types.default.bool,
	/**
	* If `true`, the modal will not prevent focus from leaving the modal while open.
	*
	* Generally this should never be set to `true` as it makes the modal less
	* accessible to assistive technologies, like screen readers.
	* @default false
	*/
	disableEnforceFocus: import_prop_types.default.bool,
	/**
	* The `children` will be under the DOM hierarchy of the parent component.
	* @default false
	*/
	disablePortal: import_prop_types.default.bool,
	/**
	* If `true`, the modal will not restore focus to previously focused element once
	* modal is hidden or unmounted.
	* @default false
	*/
	disableRestoreFocus: import_prop_types.default.bool,
	/**
	* Disable the scroll lock behavior.
	* @default false
	*/
	disableScrollLock: import_prop_types.default.bool,
	/**
	* If `true`, the backdrop is not rendered.
	* @default false
	*/
	hideBackdrop: import_prop_types.default.bool,
	/**
	* Always keep the children in the DOM.
	* This prop can be useful in SEO situation or
	* when you want to maximize the responsiveness of the Modal.
	* @default false
	*/
	keepMounted: import_prop_types.default.bool,
	/**
	* Callback fired when the component requests to be closed.
	* The `reason` parameter can optionally be used to control the response to `onClose`.
	*
	* @param {object} event The event source of the callback.
	* @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	*/
	onClose: import_prop_types.default.func,
	/**
	* A function called when a transition enters.
	*/
	onTransitionEnter: import_prop_types.default.func,
	/**
	* A function called when a transition has exited.
	*/
	onTransitionExited: import_prop_types.default.func,
	/**
	* If `true`, the component is shown.
	*/
	open: import_prop_types.default.bool.isRequired,
	/**
	* The props used for each slot inside the Modal.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		backdrop: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside the Modal.
	* Either a string to use a HTML element or a component.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		backdrop: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Dialog/dialogClasses.mjs
function getDialogUtilityClass(slot) {
	return generateUtilityClass("MuiDialog", slot);
}
const dialogClasses = generateUtilityClasses("MuiDialog", [
	"root",
	"backdrop",
	"scrollPaper",
	"scrollBody",
	"container",
	"paper",
	"paperWidthFalse",
	"paperWidthXs",
	"paperWidthSm",
	"paperWidthMd",
	"paperWidthLg",
	"paperWidthXl",
	"paperFullWidth",
	"paperFullScreen"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Dialog/DialogContext.mjs
const DialogContext = /*#__PURE__*/ React$1.createContext({});
DialogContext.displayName = "DialogContext";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Dialog/Dialog.mjs
const DialogBackdrop = styled$2(Backdrop$1, {
	name: "MuiDialog",
	slot: "Backdrop"
})({ zIndex: -1 });
const useUtilityClasses$53 = (ownerState) => {
	const { classes, scroll, maxWidth, fullWidth, fullScreen } = ownerState;
	const slots = {
		root: ["root"],
		backdrop: ["backdrop"],
		container: ["container", `scroll${capitalize_default(scroll)}`],
		paper: [
			"paper",
			`paperWidth${capitalize_default(String(maxWidth))}`,
			fullWidth && "paperFullWidth",
			fullScreen && "paperFullScreen"
		]
	};
	return composeClasses(slots, getDialogUtilityClass, classes);
};
const DialogRoot = styled$2(Modal, {
	name: "MuiDialog",
	slot: "Root"
})({ "@media print": { position: "absolute !important" } });
const DialogContainer = styled$2("div", {
	name: "MuiDialog",
	slot: "Container",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.container, styles[`scroll${capitalize_default(ownerState.scroll)}`]];
	}
})({
	height: "100%",
	"@media print": { height: "auto" },
	outline: 0,
	variants: [{
		props: { scroll: "paper" },
		style: {
			display: "flex",
			justifyContent: "center",
			alignItems: "center"
		}
	}, {
		props: { scroll: "body" },
		style: {
			overflowY: "auto",
			overflowX: "hidden",
			textAlign: "center",
			"&::after": {
				content: "\"\"",
				display: "inline-block",
				verticalAlign: "middle",
				height: "100%",
				width: "0"
			}
		}
	}]
});
const DialogPaper = styled$2(Paper, {
	name: "MuiDialog",
	slot: "Paper",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.paper,
			styles[`paperWidth${capitalize_default(String(ownerState.maxWidth))}`],
			ownerState.fullWidth && styles.paperFullWidth,
			ownerState.fullScreen && styles.paperFullScreen
		];
	}
})(memoTheme(({ theme }) => ({
	margin: 32,
	position: "relative",
	overflowY: "auto",
	outline: 0,
	"@media print": {
		overflowY: "visible",
		boxShadow: "none"
	},
	variants: [
		{
			props: { scroll: "paper" },
			style: {
				display: "flex",
				flexDirection: "column",
				maxHeight: "calc(100% - 64px)"
			}
		},
		{
			props: { scroll: "body" },
			style: {
				display: "inline-block",
				verticalAlign: "middle",
				textAlign: "initial"
			}
		},
		{
			props: ({ ownerState }) => !ownerState.maxWidth,
			style: { maxWidth: "calc(100% - 64px)" }
		},
		{
			props: { maxWidth: "xs" },
			style: { maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)` }
		},
		{
			props: {
				maxWidth: "xs",
				scroll: "body"
			},
			style: { [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: { maxWidth: "calc(100% - 64px)" } }
		},
		...Object.keys(theme.breakpoints.values).filter((maxWidth) => maxWidth !== "xs").map((maxWidth) => ({
			props: { maxWidth },
			style: { maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}` }
		})),
		...Object.keys(theme.breakpoints.values).filter((maxWidth) => maxWidth !== "xs").map((maxWidth) => ({
			props: {
				maxWidth,
				scroll: "body"
			},
			style: { [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: { maxWidth: "calc(100% - 64px)" } }
		})),
		{
			props: ({ ownerState }) => ownerState.fullWidth,
			style: { width: "calc(100% - 64px)" }
		},
		{
			props: ({ ownerState }) => ownerState.fullScreen,
			style: {
				margin: 0,
				width: "100%",
				maxWidth: "100%",
				height: "100%",
				maxHeight: "none",
				borderRadius: 0
			}
		},
		{
			props: ({ ownerState }) => ownerState.fullScreen && ownerState.scroll === "body",
			style: {
				margin: 0,
				maxWidth: "100%"
			}
		}
	]
})));
/**
* Dialogs are overlaid modal paper based components with a backdrop.
*/
const Dialog$1 = /*#__PURE__*/ React$1.forwardRef(function Dialog(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiDialog"
	});
	const theme = useTheme$1();
	const defaultTransitionDuration = {
		enter: theme.transitions.duration.enteringScreen,
		exit: theme.transitions.duration.leavingScreen
	};
	const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, "aria-modal": ariaModal = true, children, className, fullScreen = false, fullWidth = false, maxWidth = "sm", onClick, onClose, open, PaperComponent = Paper, role = "dialog", scroll = "paper", slots = {}, slotProps = {}, transitionDuration = defaultTransitionDuration, ...other } = props;
	const ownerState = {
		...props,
		fullScreen,
		fullWidth,
		maxWidth,
		scroll
	};
	const classes = useUtilityClasses$53(ownerState);
	const backdropClick = React$1.useRef();
	const handleMouseDown = (event) => {
		backdropClick.current = event.target === event.currentTarget;
	};
	const handleBackdropClick = (event) => {
		if (onClick) onClick(event);
		if (!backdropClick.current) return;
		backdropClick.current = null;
		if (onClose) onClose(event, "backdropClick");
	};
	const ariaLabelledby = useId(ariaLabelledbyProp);
	const dialogContextValue = React$1.useMemo(() => {
		return { titleId: ariaLabelledby };
	}, [ariaLabelledby]);
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [RootSlot, rootSlotProps] = useSlot("root", {
		elementType: DialogRoot,
		shouldForwardComponentProp: true,
		externalForwardedProps,
		ownerState,
		className: clsx(classes.root, className),
		ref
	});
	const [BackdropSlot, backdropSlotProps] = useSlot("backdrop", {
		elementType: DialogBackdrop,
		shouldForwardComponentProp: true,
		externalForwardedProps,
		ownerState,
		className: classes.backdrop
	});
	const [PaperSlot, paperSlotProps] = useSlot("paper", {
		elementType: DialogPaper,
		shouldForwardComponentProp: true,
		externalForwardedProps,
		ownerState,
		className: classes.paper,
		additionalProps: {
			elevation: 24,
			role,
			"aria-describedby": ariaDescribedby,
			"aria-labelledby": ariaLabelledby,
			"aria-modal": ariaModal,
			tabIndex: -1,
			[FOCUSABLE_ATTRIBUTE]: ""
		}
	});
	const [ContainerSlot, containerSlotProps] = useSlot("container", {
		elementType: DialogContainer,
		externalForwardedProps,
		ownerState,
		className: classes.container
	});
	const [TransitionSlot, transitionSlotProps] = useSlot("transition", {
		elementType: Fade,
		externalForwardedProps,
		ownerState,
		additionalProps: {
			appear: true,
			in: open,
			timeout: transitionDuration,
			role: "presentation"
		}
	});
	return /*#__PURE__*/ jsx(RootSlot, {
		closeAfterTransition: true,
		slots: { backdrop: BackdropSlot },
		slotProps: { backdrop: {
			transitionDuration,
			...backdropSlotProps
		} },
		onClose,
		open,
		onClick: handleBackdropClick,
		...rootSlotProps,
		...other,
		children: /*#__PURE__*/ jsx(TransitionSlot, {
			...transitionSlotProps,
			children: /*#__PURE__*/ jsx(ContainerSlot, {
				onMouseDown: handleMouseDown,
				...containerSlotProps,
				children: /*#__PURE__*/ jsx(PaperSlot, {
					as: PaperComponent,
					...paperSlotProps,
					children: /*#__PURE__*/ jsx(DialogContext.Provider, {
						value: dialogContextValue,
						children
					})
				})
			})
		})
	});
});
Dialog$1.propTypes = {
	/**
	* The id(s) of the element(s) that describe the dialog.
	*/
	"aria-describedby": import_prop_types.default.string,
	/**
	* The id(s) of the element(s) that label the dialog.
	*/
	"aria-labelledby": import_prop_types.default.string,
	/**
	* Informs assistive technologies that the element is modal.
	* It's added on the element with role="dialog".
	* @default true
	*/
	"aria-modal": import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["false", "true"]), import_prop_types.default.bool]),
	/**
	* Dialog children, usually the included sub-components.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* If `true`, the dialog is full-screen.
	* @default false
	*/
	fullScreen: import_prop_types.default.bool,
	/**
	* If `true`, the dialog stretches to `maxWidth`.
	*
	* Notice that the dialog width grow is limited by the default margin.
	* @default false
	*/
	fullWidth: import_prop_types.default.bool,
	/**
	* Determine the max-width of the dialog.
	* The dialog width grows with the size of the screen.
	* Set to `false` to disable `maxWidth`.
	* @default 'sm'
	*/
	maxWidth: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"xs",
		"sm",
		"md",
		"lg",
		"xl",
		false
	]), import_prop_types.default.string]),
	/**
	* @ignore
	*/
	onClick: import_prop_types.default.func,
	/**
	* Callback fired when the component requests to be closed.
	*
	* @param {object} event The event source of the callback.
	* @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	*/
	onClose: import_prop_types.default.func,
	/**
	* If `true`, the component is shown.
	*/
	open: import_prop_types.default.bool.isRequired,
	/**
	* The component used to render the body of the dialog.
	* @default Paper
	*/
	PaperComponent: import_prop_types.default.elementType,
	/**
	* The ARIA role for the dialog element.
	* The main dialog role is `dialog`, but `alertdialog` can be used if the content of the dialog requires immediate attention.
	* See https://www.w3.org/TR/wai-aria-1.2/#dialog and https://www.w3.org/TR/wai-aria-1.2/#alertdialog for more details.
	* @default 'dialog'
	*/
	role: import_prop_types.default.oneOf(["alertdialog", "dialog"]),
	/**
	* Determine the container for scrolling the dialog.
	* @default 'paper'
	*/
	scroll: import_prop_types.default.oneOf(["body", "paper"]),
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		backdrop: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		container: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		paper: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		transition: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		backdrop: import_prop_types.default.elementType,
		container: import_prop_types.default.elementType,
		paper: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType,
		transition: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The duration for the transition, in milliseconds.
	* You may specify a single timeout for all transitions, or individually with an object.
	* @default {
	*   enter: theme.transitions.duration.enteringScreen,
	*   exit: theme.transitions.duration.leavingScreen,
	* }
	*/
	transitionDuration: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.shape({
		appear: import_prop_types.default.number,
		enter: import_prop_types.default.number,
		exit: import_prop_types.default.number
	})])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/DialogActions/dialogActionsClasses.mjs
function getDialogActionsUtilityClass(slot) {
	return generateUtilityClass("MuiDialogActions", slot);
}
const dialogActionsClasses = generateUtilityClasses("MuiDialogActions", ["root", "spacing"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/DialogActions/DialogActions.mjs
const useUtilityClasses$52 = (ownerState) => {
	const { classes, disableSpacing } = ownerState;
	return composeClasses({ root: ["root", !disableSpacing && "spacing"] }, getDialogActionsUtilityClass, classes);
};
const DialogActionsRoot = styled$2("div", {
	name: "MuiDialogActions",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, !ownerState.disableSpacing && styles.spacing];
	}
})({
	display: "flex",
	alignItems: "center",
	padding: 8,
	justifyContent: "flex-end",
	flex: "0 0 auto",
	variants: [{
		props: ({ ownerState }) => !ownerState.disableSpacing,
		style: { "& > :not(style) ~ :not(style)": { marginLeft: 8 } }
	}]
});
const DialogActions$1 = /*#__PURE__*/ React$1.forwardRef(function DialogActions(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiDialogActions"
	});
	const { className, disableSpacing = false, ...other } = props;
	const ownerState = {
		...props,
		disableSpacing
	};
	const classes = useUtilityClasses$52(ownerState);
	return /*#__PURE__*/ jsx(DialogActionsRoot, {
		className: clsx(classes.root, className),
		ownerState,
		ref,
		...other
	});
});
DialogActions$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* If `true`, the actions do not have additional margin.
	* @default false
	*/
	disableSpacing: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/DialogContent/dialogContentClasses.mjs
function getDialogContentUtilityClass(slot) {
	return generateUtilityClass("MuiDialogContent", slot);
}
const dialogContentClasses = generateUtilityClasses("MuiDialogContent", ["root", "dividers"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/DialogTitle/dialogTitleClasses.mjs
function getDialogTitleUtilityClass(slot) {
	return generateUtilityClass("MuiDialogTitle", slot);
}
const dialogTitleClasses = generateUtilityClasses("MuiDialogTitle", ["root"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/DialogContent/DialogContent.mjs
const useUtilityClasses$51 = (ownerState) => {
	const { classes, dividers } = ownerState;
	return composeClasses({ root: ["root", dividers && "dividers"] }, getDialogContentUtilityClass, classes);
};
const DialogContentRoot = styled$2("div", {
	name: "MuiDialogContent",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, ownerState.dividers && styles.dividers];
	}
})(memoTheme(({ theme }) => ({
	flex: "1 1 auto",
	WebkitOverflowScrolling: "touch",
	overflowY: "auto",
	padding: "20px 24px",
	variants: [{
		props: ({ ownerState }) => ownerState.dividers,
		style: {
			padding: "16px 24px",
			borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
			borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
		}
	}, {
		props: ({ ownerState }) => !ownerState.dividers,
		style: { [`.${dialogTitleClasses.root} + &`]: { paddingTop: 0 } }
	}]
})));
const DialogContent$1 = /*#__PURE__*/ React$1.forwardRef(function DialogContent(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiDialogContent"
	});
	const { className, dividers = false, ...other } = props;
	const ownerState = {
		...props,
		dividers
	};
	const classes = useUtilityClasses$51(ownerState);
	return /*#__PURE__*/ jsx(DialogContentRoot, {
		className: clsx(classes.root, className),
		ownerState,
		ref,
		...other
	});
});
DialogContent$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* Display the top and bottom dividers.
	* @default false
	*/
	dividers: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/DialogContentText/dialogContentTextClasses.mjs
function getDialogContentTextUtilityClass(slot) {
	return generateUtilityClass("MuiDialogContentText", slot);
}
const dialogContentTextClasses = generateUtilityClasses("MuiDialogContentText", ["root"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/DialogContentText/DialogContentText.mjs
const useUtilityClasses$50 = (ownerState) => {
	const { classes } = ownerState;
	const composedClasses = composeClasses({ root: ["root"] }, getDialogContentTextUtilityClass, classes);
	return {
		...classes,
		...composedClasses
	};
};
const DialogContentTextRoot = styled$2(Typography$1, {
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
	name: "MuiDialogContentText",
	slot: "Root"
})({});
const DialogContentText$1 = /*#__PURE__*/ React$1.forwardRef(function DialogContentText(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiDialogContentText"
	});
	const { children, className, ...ownerState } = props;
	const classes = useUtilityClasses$50(ownerState);
	return /*#__PURE__*/ jsx(DialogContentTextRoot, {
		component: "p",
		variant: "body1",
		color: "textSecondary",
		ref,
		ownerState,
		className: clsx(classes.root, className),
		...props,
		classes
	});
});
DialogContentText$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/DialogTitle/DialogTitle.mjs
const useUtilityClasses$49 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({ root: ["root"] }, getDialogTitleUtilityClass, classes);
};
const DialogTitleRoot = styled$2(Typography$1, {
	name: "MuiDialogTitle",
	slot: "Root"
})({
	padding: "16px 24px",
	flex: "0 0 auto"
});
const DialogTitle$1 = /*#__PURE__*/ React$1.forwardRef(function DialogTitle(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiDialogTitle"
	});
	const { className, id: idProp, ...other } = props;
	const ownerState = props;
	const classes = useUtilityClasses$49(ownerState);
	const { titleId = idProp } = React$1.useContext(DialogContext);
	return /*#__PURE__*/ jsx(DialogTitleRoot, {
		component: "h2",
		className: clsx(classes.root, className),
		ownerState,
		ref,
		variant: "h6",
		id: idProp ?? titleId,
		...other
	});
});
DialogTitle$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* @ignore
	*/
	id: import_prop_types.default.string,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Divider/dividerClasses.mjs
function getDividerUtilityClass(slot) {
	return generateUtilityClass("MuiDivider", slot);
}
const dividerClasses = generateUtilityClasses("MuiDivider", [
	"root",
	"absolute",
	"fullWidth",
	"inset",
	"middle",
	"flexItem",
	"vertical",
	"withChildren",
	"textAlignRight",
	"textAlignLeft",
	"wrapper",
	"wrapperVertical"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Divider/Divider.mjs
const useUtilityClasses$48 = (ownerState) => {
	const { absolute, children, classes, flexItem, orientation, textAlign, variant } = ownerState;
	return composeClasses({
		root: [
			"root",
			absolute && "absolute",
			variant,
			orientation === "vertical" && "vertical",
			flexItem && "flexItem",
			children && "withChildren",
			textAlign === "right" && orientation !== "vertical" && "textAlignRight",
			textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
		],
		wrapper: ["wrapper", orientation === "vertical" && "wrapperVertical"]
	}, getDividerUtilityClass, classes);
};
const DividerRoot = styled$2("div", {
	name: "MuiDivider",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.absolute && styles.absolute,
			styles[ownerState.variant],
			ownerState.orientation === "vertical" && styles.vertical,
			ownerState.flexItem && styles.flexItem,
			ownerState.children && styles.withChildren,
			ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
			ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
		];
	}
})(memoTheme(({ theme }) => ({
	margin: 0,
	flexShrink: 0,
	borderWidth: 0,
	borderStyle: "solid",
	borderColor: (theme.vars || theme).palette.divider,
	borderBottomWidth: "thin",
	variants: [
		{
			props: { absolute: true },
			style: {
				position: "absolute",
				bottom: 0,
				left: 0,
				width: "100%"
			}
		},
		{
			props: { variant: "inset" },
			style: { marginLeft: 72 }
		},
		{
			props: {
				variant: "middle",
				orientation: "horizontal"
			},
			style: {
				marginLeft: theme.spacing(2),
				marginRight: theme.spacing(2)
			}
		},
		{
			props: {
				variant: "middle",
				orientation: "vertical"
			},
			style: {
				marginTop: theme.spacing(1),
				marginBottom: theme.spacing(1)
			}
		},
		{
			props: { orientation: "vertical" },
			style: {
				height: "100%",
				borderBottomWidth: 0,
				borderRightWidth: "thin"
			}
		},
		{
			props: { flexItem: true },
			style: {
				alignSelf: "stretch",
				height: "auto"
			}
		},
		{
			props: ({ ownerState }) => !!ownerState.children,
			style: {
				display: "flex",
				textAlign: "center",
				border: 0,
				borderTopStyle: "solid",
				borderLeftStyle: "solid",
				"&::before, &::after": {
					content: "\"\"",
					alignSelf: "center"
				}
			}
		},
		{
			props: ({ ownerState }) => ownerState.children && ownerState.orientation !== "vertical",
			style: { "&::before, &::after": {
				width: "100%",
				borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
				borderTopStyle: "inherit"
			} }
		},
		{
			props: ({ ownerState }) => ownerState.orientation === "vertical" && ownerState.children,
			style: {
				flexDirection: "column",
				"&::before, &::after": {
					height: "100%",
					borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
					borderLeftStyle: "inherit"
				}
			}
		},
		{
			props: ({ ownerState }) => ownerState.textAlign === "right" && ownerState.orientation !== "vertical",
			style: {
				"&::before": { width: "90%" },
				"&::after": { width: "10%" }
			}
		},
		{
			props: ({ ownerState }) => ownerState.textAlign === "left" && ownerState.orientation !== "vertical",
			style: {
				"&::before": { width: "10%" },
				"&::after": { width: "90%" }
			}
		}
	]
})));
const DividerWrapper = styled$2("span", {
	name: "MuiDivider",
	slot: "Wrapper",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.wrapper, ownerState.orientation === "vertical" && styles.wrapperVertical];
	}
})(memoTheme(({ theme }) => ({
	display: "inline-block",
	paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
	paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
	whiteSpace: "nowrap",
	variants: [{
		props: { orientation: "vertical" },
		style: {
			paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
			paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
		}
	}]
})));
const Divider = /*#__PURE__*/ React$1.forwardRef(function Divider(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiDivider"
	});
	const { absolute = false, children, className, orientation = "horizontal", component = children || orientation === "vertical" ? "div" : "hr", flexItem = false, role = component !== "hr" ? "separator" : void 0, textAlign = "center", variant = "fullWidth", ...other } = props;
	const ownerState = {
		...props,
		absolute,
		component,
		flexItem,
		orientation,
		role,
		textAlign,
		variant
	};
	const classes = useUtilityClasses$48(ownerState);
	return /*#__PURE__*/ jsx(DividerRoot, {
		as: component,
		className: clsx(classes.root, className),
		role,
		ref,
		ownerState,
		"aria-orientation": role === "separator" && (component !== "hr" || orientation === "vertical") ? orientation : void 0,
		...other,
		children: children ? /*#__PURE__*/ jsx(DividerWrapper, {
			className: classes.wrapper,
			ownerState,
			children
		}) : null
	});
});
Divider.propTypes = {
	/**
	* Absolutely position the element.
	* @default false
	*/
	absolute: import_prop_types.default.bool,
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, a vertical divider will have the correct height when used in flex container.
	* (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
	* @default false
	*/
	flexItem: import_prop_types.default.bool,
	/**
	* The component orientation.
	* @default 'horizontal'
	*/
	orientation: import_prop_types.default.oneOf(["horizontal", "vertical"]),
	/**
	* @ignore
	*/
	role: import_prop_types.default.string,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The text alignment.
	* @default 'center'
	*/
	textAlign: import_prop_types.default.oneOf([
		"center",
		"left",
		"right"
	]),
	/**
	* The variant to use.
	* @default 'fullWidth'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"fullWidth",
		"inset",
		"middle"
	]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Select/selectClasses.mjs
function getSelectUtilityClasses(slot) {
	return generateUtilityClass("MuiSelect", slot);
}
const selectClasses = generateUtilityClasses("MuiSelect", [
	"root",
	"select",
	"multiple",
	"filled",
	"outlined",
	"standard",
	"disabled",
	"focused",
	"icon",
	"iconOpen",
	"nativeInput",
	"error"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FilledInput/FilledInput.mjs
const useUtilityClasses$47 = (ownerState) => {
	const { classes, disableUnderline, startAdornment, endAdornment, size, hiddenLabel, multiline } = ownerState;
	const slots = {
		root: [
			"root",
			!disableUnderline && "underline",
			startAdornment && "adornedStart",
			endAdornment && "adornedEnd",
			size === "small" && `size${capitalize_default(size)}`,
			hiddenLabel && "hiddenLabel",
			multiline && "multiline"
		],
		input: ["input"]
	};
	const composedClasses = composeClasses(slots, getFilledInputUtilityClass, classes);
	return {
		...classes,
		...composedClasses
	};
};
const FilledInputRoot = styled$2(InputBaseRoot, {
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
	name: "MuiFilledInput",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [...rootOverridesResolver(props, styles), !ownerState.disableUnderline && styles.underline];
	}
})(memoTheme(({ theme }) => {
	const light = theme.palette.mode === "light";
	const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
	const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
	const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
	const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
	return {
		position: "relative",
		backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
		borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
		borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
		...getTransitionStyles(theme, "background-color", {
			duration: theme.transitions.duration.shorter,
			easing: theme.transitions.easing.easeOut
		}),
		"&:hover": {
			backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
			"@media (hover: none)": { backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor }
		},
		[`&.${filledInputClasses.focused}`]: { backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor },
		[`&.${filledInputClasses.disabled}`]: { backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground },
		variants: [
			{
				props: ({ ownerState }) => !ownerState.disableUnderline,
				style: {
					"&::after": {
						left: 0,
						bottom: 0,
						content: "\"\"",
						position: "absolute",
						right: 0,
						transform: "scaleX(0)",
						...getTransitionStyles(theme, "transform", {
							duration: theme.transitions.duration.shorter,
							easing: theme.transitions.easing.easeOut
						}),
						pointerEvents: "none"
					},
					[`&.${filledInputClasses.focused}:after`]: { transform: "scaleX(1) translateX(0)" },
					[`&.${filledInputClasses.error}`]: { "&::before, &::after": { borderBottomColor: (theme.vars || theme).palette.error.main } },
					"&::before": {
						borderBottom: `1px solid ${theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline) : bottomLineColor}`,
						left: 0,
						bottom: 0,
						content: "\"\"",
						position: "absolute",
						right: 0,
						...getTransitionStyles(theme, "border-bottom-color", { duration: theme.transitions.duration.shorter }),
						pointerEvents: "none"
					},
					[`&:hover:not(.${filledInputClasses.disabled}, .${filledInputClasses.error}):before`]: { borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}` },
					[`&.${filledInputClasses.disabled}:before`]: { borderBottomStyle: "dotted" }
				}
			},
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
				props: {
					disableUnderline: false,
					color
				},
				style: { "&::after": { borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}` } }
			})),
			{
				props: ({ ownerState }) => ownerState.startAdornment,
				style: { paddingLeft: 12 }
			},
			{
				props: ({ ownerState }) => ownerState.endAdornment,
				style: {
					"--_trailingPad": "12px",
					paddingRight: "var(--_trailingPad)",
					[`&.${selectClasses.root}`]: { "--_trailingPad": "0px" }
				}
			},
			{
				props: ({ ownerState }) => ownerState.multiline,
				style: { padding: "25px 12px 8px" }
			},
			{
				props: ({ ownerState, size }) => ownerState.multiline && size === "small",
				style: {
					paddingTop: 21,
					paddingBottom: 4
				}
			},
			{
				props: ({ ownerState }) => ownerState.multiline && ownerState.hiddenLabel,
				style: {
					paddingTop: 16,
					paddingBottom: 17
				}
			},
			{
				props: ({ ownerState }) => ownerState.multiline && ownerState.hiddenLabel && ownerState.size === "small",
				style: {
					paddingTop: 8,
					paddingBottom: 9
				}
			}
		]
	};
}));
const FilledInputInput = styled$2(InputBaseInput, {
	name: "MuiFilledInput",
	slot: "Input",
	overridesResolver: inputOverridesResolver
})(memoTheme(({ theme }) => ({
	paddingTop: 25,
	paddingRight: 12,
	paddingBottom: 8,
	paddingLeft: 12,
	"&:-webkit-autofill": {
		...!theme.vars && {
			WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
			WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
			caretColor: theme.palette.mode === "light" ? null : "#fff"
		},
		borderTopLeftRadius: "inherit",
		borderTopRightRadius: "inherit",
		...theme.vars && theme.applyStyles("dark", {
			WebkitBoxShadow: "0 0 0 100px #266798 inset",
			WebkitTextFillColor: "#fff",
			caretColor: "#fff"
		})
	},
	variants: [
		{
			props: { size: "small" },
			style: {
				paddingTop: 21,
				paddingBottom: 4
			}
		},
		{
			props: ({ ownerState }) => ownerState.hiddenLabel,
			style: {
				paddingTop: 16,
				paddingBottom: 17
			}
		},
		{
			props: ({ ownerState }) => ownerState.startAdornment,
			style: { paddingLeft: 0 }
		},
		{
			props: ({ ownerState }) => ownerState.endAdornment,
			style: { paddingRight: 0 }
		},
		{
			props: ({ ownerState }) => ownerState.hiddenLabel && ownerState.size === "small",
			style: {
				paddingTop: 8,
				paddingBottom: 9
			}
		},
		{
			props: ({ ownerState }) => ownerState.multiline,
			style: {
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 0,
				paddingRight: 0
			}
		}
	]
})));
const FilledInput = /*#__PURE__*/ React$1.forwardRef(function FilledInput(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiFilledInput"
	});
	const { disableUnderline = false, fullWidth = false, hiddenLabel, inputComponent = "input", multiline = false, notched, slotProps, slots = {}, type = "text", ...other } = props;
	const ownerState = {
		...props,
		disableUnderline,
		fullWidth,
		inputComponent,
		multiline,
		type
	};
	const classes = useUtilityClasses$47(props);
	const filledInputComponentsProps = {
		root: { ownerState },
		input: { ownerState }
	};
	const componentsProps = slotProps ? deepmerge(filledInputComponentsProps, slotProps) : filledInputComponentsProps;
	const RootSlot = slots.root ?? FilledInputRoot;
	const InputSlot = slots.input ?? FilledInputInput;
	return /*#__PURE__*/ jsx(InputBase, {
		slots: {
			root: RootSlot,
			input: InputSlot
		},
		slotProps: componentsProps,
		fullWidth,
		inputComponent,
		multiline,
		ref,
		type,
		...other,
		classes
	});
});
FilledInput.propTypes = {
	/**
	* This prop helps users to fill forms faster, especially on mobile devices.
	* The name can be confusing, as it's more like an autofill.
	* You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	*/
	autoComplete: import_prop_types.default.string,
	/**
	* If `true`, the `input` element is focused during the first mount.
	*/
	autoFocus: import_prop_types.default.bool,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["primary", "secondary"]), import_prop_types.default.string]),
	/**
	* The default value. Use when the component is not controlled.
	*/
	defaultValue: import_prop_types.default.any,
	/**
	* If `true`, the component is disabled.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the input will not have an underline.
	* @default false
	*/
	disableUnderline: import_prop_types.default.bool,
	/**
	* End `InputAdornment` for this component.
	*/
	endAdornment: import_prop_types.default.node,
	/**
	* If `true`, the `input` will indicate an error.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	error: import_prop_types.default.bool,
	/**
	* If `true`, the `input` will take up the full width of its container.
	* @default false
	*/
	fullWidth: import_prop_types.default.bool,
	/**
	* If `true`, the label is hidden.
	* This is used to increase density for a `FilledInput`.
	* Be sure to add `aria-label` to the `input` element.
	* @default false
	*/
	hiddenLabel: import_prop_types.default.bool,
	/**
	* The id of the `input` element.
	*/
	id: import_prop_types.default.string,
	/**
	* The component used for the `input` element.
	* Either a string to use a HTML element or a component.
	* @default 'input'
	*/
	inputComponent: import_prop_types.default.elementType,
	/**
	* [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
	* @default {}
	*/
	inputProps: import_prop_types.default.object,
	/**
	* Pass a ref to the `input` element.
	*/
	inputRef: refType,
	/**
	* If `dense`, will adjust vertical spacing. This is normally obtained via context from
	* FormControl.
	* The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
	*/
	margin: import_prop_types.default.oneOf(["dense", "none"]),
	/**
	* Maximum number of rows to display when multiline option is set to true.
	*/
	maxRows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* Minimum number of rows to display when multiline option is set to true.
	*/
	minRows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
	* @default false
	*/
	multiline: import_prop_types.default.bool,
	/**
	* Name attribute of the `input` element.
	*/
	name: import_prop_types.default.string,
	/**
	* @internal
	*/
	notched: import_prop_types.default.bool,
	/**
	* Callback fired when the value is changed.
	*
	* @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
	* You can pull out the new value by accessing `event.target.value` (string).
	*/
	onChange: import_prop_types.default.func,
	/**
	* The short hint displayed in the `input` before the user enters a value.
	*/
	placeholder: import_prop_types.default.string,
	/**
	* It prevents the user from changing the value of the field
	* (not from interacting with the field).
	*/
	readOnly: import_prop_types.default.bool,
	/**
	* If `true`, the `input` element is required.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	required: import_prop_types.default.bool,
	/**
	* Number of rows to display when multiline option is set to true.
	*/
	rows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* The extra props for the slot components.
	* You can override the existing props or add new ones.
	*
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		input: import_prop_types.default.object,
		root: import_prop_types.default.object
	}),
	/**
	* The components used for each slot inside.
	*
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		input: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* Start `InputAdornment` for this component.
	*/
	startAdornment: import_prop_types.default.node,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
	* @default 'text'
	*/
	type: import_prop_types.default.string,
	/**
	* The value of the `input` element, required for a controlled component.
	*/
	value: import_prop_types.default.any
};
FilledInput.muiName = "Input";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormControl/formControlClasses.mjs
function getFormControlUtilityClasses(slot) {
	return generateUtilityClass("MuiFormControl", slot);
}
generateUtilityClasses("MuiFormControl", [
	"root",
	"marginNone",
	"marginNormal",
	"marginDense",
	"fullWidth",
	"disabled"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormControl/FormControl.mjs
const useUtilityClasses$46 = (ownerState) => {
	const { classes, margin, fullWidth } = ownerState;
	const slots = { root: [
		"root",
		margin !== "none" && `margin${capitalize_default(margin)}`,
		fullWidth && "fullWidth"
	] };
	return composeClasses(slots, getFormControlUtilityClasses, classes);
};
const FormControlRoot = styled$2("div", {
	name: "MuiFormControl",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[`margin${capitalize_default(ownerState.margin)}`],
			ownerState.fullWidth && styles.fullWidth
		];
	}
})({
	display: "inline-flex",
	flexDirection: "column",
	position: "relative",
	minWidth: 0,
	padding: 0,
	margin: 0,
	border: 0,
	verticalAlign: "top",
	variants: [
		{
			props: { margin: "normal" },
			style: {
				marginTop: 16,
				marginBottom: 8
			}
		},
		{
			props: { margin: "dense" },
			style: {
				marginTop: 8,
				marginBottom: 4
			}
		},
		{
			props: { fullWidth: true },
			style: { width: "100%" }
		}
	]
});
/**
* Provides context such as filled/focused/error/required for form inputs.
* Relying on the context provides high flexibility and ensures that the state always stays
* consistent across the children of the `FormControl`.
* This context is used by the following components:
*
*  - FormLabel
*  - FormHelperText
*  - Input
*  - InputLabel
*
* You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
*
* ```jsx
* <FormControl>
*   <InputLabel htmlFor="my-input">Email address</InputLabel>
*   <Input id="my-input" aria-describedby="my-helper-text" />
*   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
* </FormControl>
* ```
*
* ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
* For instance, only one input can be focused at the same time, the state shouldn't be shared.
*/
const FormControl$1 = /*#__PURE__*/ React$1.forwardRef(function FormControl(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiFormControl"
	});
	const { children, className, color = "primary", component = "div", disabled = false, error = false, focused: visuallyFocused, fullWidth = false, hiddenLabel = false, margin = "none", required = false, size = "medium", variant = "outlined", ...other } = props;
	const ownerState = {
		...props,
		color,
		component,
		disabled,
		error,
		fullWidth,
		hiddenLabel,
		margin,
		required,
		size,
		variant
	};
	const classes = useUtilityClasses$46(ownerState);
	const [adornedStart, setAdornedStart] = React$1.useState(() => {
		let initialAdornedStart = false;
		if (children) React$1.Children.forEach(children, (child) => {
			if (!isMuiElement_default(child, ["Input", "Select"])) return;
			const input = isMuiElement_default(child, ["Select"]) ? child.props.input : child;
			if (input && isAdornedStart(input.props)) initialAdornedStart = true;
		});
		return initialAdornedStart;
	});
	const [filled, setFilled] = React$1.useState(() => {
		let initialFilled = false;
		if (children) React$1.Children.forEach(children, (child) => {
			if (!isMuiElement_default(child, ["Input", "Select"])) return;
			if (isFilled(child.props, true) || isFilled(child.props.inputProps, true)) initialFilled = true;
		});
		return initialFilled;
	});
	const [focusedState, setFocused] = React$1.useState(false);
	if (disabled && focusedState) setFocused(false);
	const focused = visuallyFocused !== void 0 && !disabled ? visuallyFocused : focusedState;
	let registerEffect;
	const registeredInput = React$1.useRef(false);
	registerEffect = () => {
		if (registeredInput.current) console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join("\n"));
		registeredInput.current = true;
		return () => {
			registeredInput.current = false;
		};
	};
	const onFilled = React$1.useCallback(() => {
		setFilled(true);
	}, []);
	const onEmpty = React$1.useCallback(() => {
		setFilled(false);
	}, []);
	const childContext = React$1.useMemo(() => {
		return {
			adornedStart,
			setAdornedStart,
			color,
			disabled,
			error,
			filled,
			focused,
			fullWidth,
			hiddenLabel,
			size,
			onBlur: () => {
				setFocused(false);
			},
			onFocus: () => {
				setFocused(true);
			},
			onEmpty,
			onFilled,
			registerEffect,
			required,
			variant
		};
	}, [
		adornedStart,
		color,
		disabled,
		error,
		filled,
		focused,
		fullWidth,
		hiddenLabel,
		registerEffect,
		onEmpty,
		onFilled,
		required,
		size,
		variant
	]);
	return /*#__PURE__*/ jsx(FormControlContext.Provider, {
		value: childContext,
		children: /*#__PURE__*/ jsx(FormControlRoot, {
			as: component,
			ownerState,
			className: clsx(classes.root, className),
			ref,
			...other,
			children
		})
	});
});
FormControl$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'primary'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, the label, input and helper text should be displayed in a disabled state.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the label is displayed in an error state.
	* @default false
	*/
	error: import_prop_types.default.bool,
	/**
	* If `true`, the component is displayed in focused state.
	*/
	focused: import_prop_types.default.bool,
	/**
	* If `true`, the component will take up the full width of its container.
	* @default false
	*/
	fullWidth: import_prop_types.default.bool,
	/**
	* If `true`, the label is hidden.
	* This is used to increase density for a `FilledInput`.
	* Be sure to add `aria-label` to the `input` element.
	* @default false
	*/
	hiddenLabel: import_prop_types.default.bool,
	/**
	* If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	* @default 'none'
	*/
	margin: import_prop_types.default.oneOf([
		"dense",
		"none",
		"normal"
	]),
	/**
	* If `true`, the label will indicate that the `input` is required.
	* @default false
	*/
	required: import_prop_types.default.bool,
	/**
	* The size of the component.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["medium", "small"]), import_prop_types.default.string]),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The variant to use.
	* @default 'outlined'
	*/
	variant: import_prop_types.default.oneOf([
		"filled",
		"outlined",
		"standard"
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormControlLabel/FormControlLabel.mjs
const useUtilityClasses$45 = (ownerState) => {
	const { classes, disabled, labelPlacement, error, required } = ownerState;
	const slots = {
		root: [
			"root",
			disabled && "disabled",
			`labelPlacement${capitalize_default(labelPlacement)}`,
			error && "error",
			required && "required"
		],
		label: ["label", disabled && "disabled"],
		asterisk: ["asterisk", error && "error"]
	};
	return composeClasses(slots, getFormControlLabelUtilityClasses, classes);
};
const FormControlLabelRoot = styled$2("label", {
	name: "MuiFormControlLabel",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			{ [`& .${formControlLabelClasses.label}`]: styles.label },
			styles.root,
			styles[`labelPlacement${capitalize_default(ownerState.labelPlacement)}`]
		];
	}
})(memoTheme(({ theme }) => ({
	display: "inline-flex",
	alignItems: "center",
	cursor: "pointer",
	verticalAlign: "middle",
	WebkitTapHighlightColor: "transparent",
	marginLeft: -11,
	marginRight: 16,
	[`&.${formControlLabelClasses.disabled}`]: { cursor: "default" },
	[`& .${formControlLabelClasses.label}`]: { [`&.${formControlLabelClasses.disabled}`]: { color: (theme.vars || theme).palette.text.disabled } },
	variants: [
		{
			props: { labelPlacement: "start" },
			style: {
				flexDirection: "row-reverse",
				marginRight: -11
			}
		},
		{
			props: { labelPlacement: "top" },
			style: { flexDirection: "column-reverse" }
		},
		{
			props: { labelPlacement: "bottom" },
			style: { flexDirection: "column" }
		},
		{
			props: ({ labelPlacement }) => labelPlacement === "start" || labelPlacement === "top" || labelPlacement === "bottom",
			style: { marginLeft: 16 }
		}
	]
})));
const AsteriskComponent$1 = styled$2("span", {
	name: "MuiFormControlLabel",
	slot: "Asterisk"
})(memoTheme(({ theme }) => ({ [`&.${formControlLabelClasses.error}`]: { color: (theme.vars || theme).palette.error.main } })));
/**
* Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
* Use this component if you want to display an extra label.
*/
const FormControlLabel$1 = /*#__PURE__*/ React$1.forwardRef(function FormControlLabel(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiFormControlLabel"
	});
	const { checked, className, control, disabled: disabledProp, disableTypography, inputRef, label: labelProp, labelPlacement = "end", name, onChange, required: requiredProp, slots = {}, slotProps = {}, value, ...other } = props;
	const [fcs, muiFormControl] = useFormControlState({
		props,
		states: ["error"]
	});
	const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
	const required = requiredProp ?? control.props.required;
	const controlProps = {
		disabled,
		required
	};
	[
		"checked",
		"name",
		"onChange",
		"value",
		"inputRef"
	].forEach((key) => {
		if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
	});
	const ownerState = {
		...props,
		disabled,
		labelPlacement,
		required,
		error: fcs.error
	};
	const classes = useUtilityClasses$45(ownerState);
	const [TypographySlot, typographySlotProps] = useSlot("typography", {
		elementType: Typography$1,
		externalForwardedProps: {
			slots,
			slotProps
		},
		ownerState
	});
	let label = labelProp;
	if (label != null && label.type !== Typography$1 && !disableTypography) label = /*#__PURE__*/ jsx(TypographySlot, {
		component: "span",
		...typographySlotProps,
		className: clsx(classes.label, typographySlotProps?.className),
		children: label
	});
	return /*#__PURE__*/ jsxs(FormControlLabelRoot, {
		className: clsx(classes.root, className),
		ownerState,
		ref,
		...other,
		children: [/*#__PURE__*/ React$1.cloneElement(control, controlProps), required ? /*#__PURE__*/ jsxs("div", { children: [label, /*#__PURE__*/ jsxs(AsteriskComponent$1, {
			ownerState,
			"aria-hidden": true,
			className: classes.asterisk,
			children: [" ", "*"]
		})] }) : label]
	});
});
FormControlLabel$1.propTypes = {
	/**
	* If `true`, the component appears selected.
	*/
	checked: import_prop_types.default.bool,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
	*/
	control: import_prop_types.default.element.isRequired,
	/**
	* If `true`, the control is disabled.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the label is rendered as it is passed without an additional typography node.
	*/
	disableTypography: import_prop_types.default.bool,
	/**
	* Pass a ref to the `input` element.
	*/
	inputRef: refType,
	/**
	* A text or an element to be used in an enclosing label element.
	*/
	label: import_prop_types.default.node,
	/**
	* The position of the label.
	* @default 'end'
	*/
	labelPlacement: import_prop_types.default.oneOf([
		"bottom",
		"end",
		"start",
		"top"
	]),
	/**
	* @ignore
	*/
	name: import_prop_types.default.string,
	/**
	* Callback fired when the state is changed.
	*
	* @param {React.SyntheticEvent} event The event source of the callback.
	* You can pull out the new checked state by accessing `event.target.checked` (boolean).
	*/
	onChange: import_prop_types.default.func,
	/**
	* If `true`, the label will indicate that the `input` is required.
	*/
	required: import_prop_types.default.bool,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({ typography: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]) }),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({ typography: import_prop_types.default.elementType }),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The value of the component.
	*/
	value: import_prop_types.default.any
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormGroup/formGroupClasses.mjs
function getFormGroupUtilityClass(slot) {
	return generateUtilityClass("MuiFormGroup", slot);
}
generateUtilityClasses("MuiFormGroup", [
	"root",
	"row",
	"error"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormGroup/FormGroup.mjs
const useUtilityClasses$44 = (ownerState) => {
	const { classes, row, error } = ownerState;
	return composeClasses({ root: [
		"root",
		row && "row",
		error && "error"
	] }, getFormGroupUtilityClass, classes);
};
const FormGroupRoot = styled$2("div", {
	name: "MuiFormGroup",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, ownerState.row && styles.row];
	}
})({
	display: "flex",
	flexDirection: "column",
	flexWrap: "wrap",
	variants: [{
		props: { row: true },
		style: { flexDirection: "row" }
	}]
});
/**
* `FormGroup` wraps controls such as `Checkbox` and `Switch`.
* It provides compact row layout.
* For the `Radio`, you should be using the `RadioGroup` component instead of this one.
*/
const FormGroup$1 = /*#__PURE__*/ React$1.forwardRef(function FormGroup(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiFormGroup"
	});
	const { className, row = false, ...other } = props;
	const [fcs] = useFormControlState({
		props,
		states: ["error"]
	});
	const ownerState = {
		...props,
		row,
		error: fcs.error
	};
	const classes = useUtilityClasses$44(ownerState);
	return /*#__PURE__*/ jsx(FormGroupRoot, {
		className: clsx(classes.root, className),
		ownerState,
		ref,
		...other
	});
});
FormGroup$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* Display group of elements in a compact row.
	* @default false
	*/
	row: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormHelperText/FormHelperText.mjs
var _span$3;
const useUtilityClasses$43 = (ownerState) => {
	const { classes, contained, size, disabled, error, filled, focused, required } = ownerState;
	const slots = { root: [
		"root",
		disabled && "disabled",
		error && "error",
		size && `size${capitalize_default(size)}`,
		contained && "contained",
		focused && "focused",
		filled && "filled",
		required && "required"
	] };
	return composeClasses(slots, getFormHelperTextUtilityClasses, classes);
};
const FormHelperTextRoot = styled$2("p", {
	name: "MuiFormHelperText",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.size && styles[`size${capitalize_default(ownerState.size)}`],
			ownerState.contained && styles.contained,
			ownerState.filled && styles.filled
		];
	}
})(memoTheme(({ theme }) => ({
	color: (theme.vars || theme).palette.text.secondary,
	...theme.typography.caption,
	textAlign: "left",
	marginTop: 3,
	marginRight: 0,
	marginBottom: 0,
	marginLeft: 0,
	[`&.${formHelperTextClasses.disabled}`]: { color: (theme.vars || theme).palette.text.disabled },
	[`&.${formHelperTextClasses.error}`]: { color: (theme.vars || theme).palette.error.main },
	variants: [{
		props: { size: "small" },
		style: { marginTop: 4 }
	}, {
		props: ({ ownerState }) => ownerState.contained,
		style: {
			marginLeft: 14,
			marginRight: 14
		}
	}]
})));
const FormHelperText$1 = /*#__PURE__*/ React$1.forwardRef(function FormHelperText(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiFormHelperText"
	});
	const { children, className, component = "p", disabled, error, filled, focused, margin, required, variant, ...other } = props;
	const [fcs] = useFormControlState({
		props,
		states: [
			"variant",
			"size",
			"disabled",
			"error",
			"filled",
			"focused",
			"required"
		]
	});
	const ownerState = {
		...props,
		component,
		contained: fcs.variant === "filled" || fcs.variant === "outlined",
		variant: fcs.variant,
		size: fcs.size,
		disabled: fcs.disabled,
		error: fcs.error,
		filled: fcs.filled,
		focused: fcs.focused,
		required: fcs.required
	};
	delete ownerState.ownerState;
	const classes = useUtilityClasses$43(ownerState);
	return /*#__PURE__*/ jsx(FormHelperTextRoot, {
		as: component,
		className: clsx(classes.root, className),
		ref,
		...other,
		ownerState,
		children: children === " " ? _span$3 || (_span$3 = /*#__PURE__*/ jsx("span", {
			className: "notranslate",
			"aria-hidden": true,
			children: "​"
		})) : children
	});
});
FormHelperText$1.propTypes = {
	/**
	* The content of the component.
	*
	* If `' '` is provided, the component reserves one line height for displaying a future message.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, the helper text should be displayed in a disabled state.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, helper text should be displayed in an error state.
	*/
	error: import_prop_types.default.bool,
	/**
	* If `true`, the helper text should use filled classes key.
	*/
	filled: import_prop_types.default.bool,
	/**
	* If `true`, the helper text should use focused classes key.
	*/
	focused: import_prop_types.default.bool,
	/**
	* If `dense`, will adjust vertical spacing. This is normally obtained via context from
	* FormControl.
	*/
	margin: import_prop_types.default.oneOf(["dense"]),
	/**
	* If `true`, the helper text should use required classes key.
	*/
	required: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The variant to use.
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"filled",
		"outlined",
		"standard"
	]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/FormLabel/FormLabel.mjs
const useUtilityClasses$42 = (ownerState) => {
	const { classes, color, focused, disabled, error, filled, required } = ownerState;
	const slots = {
		root: [
			"root",
			`color${capitalize_default(color)}`,
			disabled && "disabled",
			error && "error",
			filled && "filled",
			focused && "focused",
			required && "required"
		],
		asterisk: ["asterisk", error && "error"]
	};
	return composeClasses(slots, getFormLabelUtilityClasses, classes);
};
const FormLabelRoot = styled$2("label", {
	name: "MuiFormLabel",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.color === "secondary" && styles.colorSecondary,
			ownerState.filled && styles.filled
		];
	}
})(memoTheme(({ theme }) => ({
	color: (theme.vars || theme).palette.text.secondary,
	...theme.typography.body1,
	lineHeight: "1.4375em",
	padding: 0,
	position: "relative",
	variants: [...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
		props: { color },
		style: { [`&.${formLabelClasses.focused}`]: { color: (theme.vars || theme).palette[color].main } }
	})), {
		props: {},
		style: {
			[`&.${formLabelClasses.disabled}`]: { color: (theme.vars || theme).palette.text.disabled },
			[`&.${formLabelClasses.error}`]: { color: (theme.vars || theme).palette.error.main }
		}
	}]
})));
const AsteriskComponent = styled$2("span", {
	name: "MuiFormLabel",
	slot: "Asterisk"
})(memoTheme(({ theme }) => ({ [`&.${formLabelClasses.error}`]: { color: (theme.vars || theme).palette.error.main } })));
const FormLabel$1 = /*#__PURE__*/ React$1.forwardRef(function FormLabel(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiFormLabel"
	});
	const { children, className, color, component = "label", disabled, error, filled, focused, required, ...other } = props;
	const [fcs] = useFormControlState({
		props,
		states: [
			"color",
			"required",
			"focused",
			"disabled",
			"error",
			"filled"
		]
	});
	const ownerState = {
		...props,
		color: fcs.color || "primary",
		component,
		disabled: fcs.disabled,
		error: fcs.error,
		filled: fcs.filled,
		focused: fcs.focused,
		required: fcs.required
	};
	const classes = useUtilityClasses$42(ownerState);
	return /*#__PURE__*/ jsxs(FormLabelRoot, {
		as: component,
		ownerState,
		className: clsx(classes.root, className),
		ref,
		...other,
		children: [children, fcs.required && /*#__PURE__*/ jsxs(AsteriskComponent, {
			ownerState,
			"aria-hidden": true,
			className: classes.asterisk,
			children: [" ", "*"]
		})]
	});
});
FormLabel$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"error",
		"info",
		"primary",
		"secondary",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, the label should be displayed in a disabled state.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the label is displayed in an error state.
	*/
	error: import_prop_types.default.bool,
	/**
	* If `true`, the label should use filled classes key.
	*/
	filled: import_prop_types.default.bool,
	/**
	* If `true`, the input of this label is focused (used by `FormGroup` components).
	*/
	focused: import_prop_types.default.bool,
	/**
	* If `true`, the label will indicate that the `input` is required.
	*/
	required: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Grid/Grid.mjs
/**
*
* Demos:
*
* - [Grid](https://mui.com/material-ui/react-grid/)
*
* API:
*
* - [Grid API](https://mui.com/material-ui/api/grid/)
*/
const Grid = createGrid({
	createStyledComponent: styled$2("div", {
		name: "MuiGrid",
		slot: "Root",
		overridesResolver: (props, styles) => {
			const { ownerState } = props;
			return [styles.root, ownerState.container && styles.container];
		}
	}),
	componentName: "MuiGrid",
	useThemeProps: (inProps) => useDefaultProps({
		props: inProps,
		name: "MuiGrid"
	}),
	useTheme: useTheme$1
});
Grid.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* The number of columns.
	* @default 12
	*/
	columns: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.number),
		import_prop_types.default.number,
		import_prop_types.default.object
	]),
	/**
	* Defines the horizontal space between the type `item` components.
	* It overrides the value of the `spacing` prop.
	*/
	columnSpacing: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string])),
		import_prop_types.default.number,
		import_prop_types.default.object,
		import_prop_types.default.string
	]),
	/**
	* If `true`, the component will have the flex *container* behavior.
	* You should be wrapping *items* with a *container*.
	* @default false
	*/
	container: import_prop_types.default.bool,
	/**
	* Defines the `flex-direction` style property for the container.
	*
	* ⚠️ Only `row` and `row-reverse` are supported. `column` and `column-reverse` are not supported,
	* because the Grid component is designed to subdivide layouts into **columns**, not rows.
	*
	* For vertical layouts, use `Stack` instead.
	*
	* @default 'row'
	*/
	direction: import_prop_types.default.oneOfType([
		import_prop_types.default.oneOf(["row-reverse", "row"]),
		import_prop_types.default.arrayOf(import_prop_types.default.oneOf(["row-reverse", "row"])),
		import_prop_types.default.object
	]),
	/**
	* Defines the offset value for the type `item` components.
	*/
	offset: import_prop_types.default.oneOfType([
		import_prop_types.default.string,
		import_prop_types.default.number,
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.number])),
		import_prop_types.default.object
	]),
	/**
	* Defines the vertical space between the type `item` components.
	* It overrides the value of the `spacing` prop.
	*/
	rowSpacing: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string])),
		import_prop_types.default.number,
		import_prop_types.default.object,
		import_prop_types.default.string
	]),
	/**
	* Defines the size of the the type `item` components.
	*/
	size: import_prop_types.default.oneOfType([
		import_prop_types.default.string,
		import_prop_types.default.bool,
		import_prop_types.default.number,
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.string,
			import_prop_types.default.bool,
			import_prop_types.default.number
		])),
		import_prop_types.default.object
	]),
	/**
	* Defines the space between the type `item` components.
	* It can only be used on a type `container` component.
	* @default 0
	*/
	spacing: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string])),
		import_prop_types.default.number,
		import_prop_types.default.object,
		import_prop_types.default.string
	]),
	/**
	* @ignore
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* @internal
	* The level of the grid starts from `0` and increases when the grid nests
	* inside another grid. Nesting is defined as a container Grid being a direct
	* child of a container Grid.
	*
	* ```js
	* <Grid container> // level 0
	*   <Grid container> // level 1
	*     <Grid container> // level 2
	* ```
	*
	* Only consecutive grid is considered nesting. A grid container will start at
	* `0` if there are non-Grid container element above it.
	*
	* ```js
	* <Grid container> // level 0
	*   <div>
	*     <Grid container> // level 0
	* ```
	*
	* ```js
	* <Grid container> // level 0
	*   <Grid>
	*     <Grid container> // level 0
	* ```
	*/
	unstable_level: import_prop_types.default.number,
	/**
	* Defines the `flex-wrap` style property.
	* It's applied for all screen sizes.
	* @default 'wrap'
	*/
	wrap: import_prop_types.default.oneOf([
		"nowrap",
		"wrap-reverse",
		"wrap"
	])
};
{
	const Component = Grid;
	const requireProp = requirePropFactory_default("Grid", Component);
	Component["propTypes"] = {
		...Component.propTypes,
		direction: requireProp("container"),
		spacing: requireProp("container"),
		wrap: requireProp("container")
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Grow/Grow.mjs
function getScale(value) {
	return `scale(${value}, ${value ** 2})`;
}
const styles$1 = {
	entering: {
		opacity: 1,
		transform: getScale(1)
	},
	entered: {
		opacity: 1,
		transform: "none"
	},
	exiting: {
		opacity: 0,
		transform: getScale(.75)
	},
	exited: {
		opacity: 0,
		transform: getScale(.75)
	}
};
const hiddenStyles = {
	opacity: 0,
	transform: getScale(.75),
	visibility: "hidden"
};
/**
* The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
* [Popover](/material-ui/react-popover/) components.
*/
const Grow = /*#__PURE__*/ React$1.forwardRef(function Grow(props, ref) {
	const { addEndListener, appear = true, children, disablePrefersReducedMotion = false, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = "auto", ...other } = props;
	const autoTimeout = React$1.useRef(null);
	const theme = useTheme$1();
	const reducedMotion = useReducedMotion(theme.motion.reducedMotion, disablePrefersReducedMotion);
	const nodeRef = React$1.useRef(null);
	const handleRef = useForkRef_default(nodeRef, getReactElementRef(children), ref);
	const handleEntering = normalizedTransitionCallback(nodeRef, onEntering);
	const handleEnter = normalizedTransitionCallback(nodeRef, (node, isAppearing) => {
		if (!reducedMotion.shouldReduceMotion) reflow(node);
		const { duration: transitionDuration, delay, easing: transitionTimingFunction } = getTransitionProps({
			style,
			timeout,
			easing
		}, { mode: "enter" });
		let duration;
		if (timeout === "auto" && !reducedMotion.shouldReduceMotion) {
			duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
			autoTimeout.current = duration;
		} else {
			duration = transitionDuration;
			autoTimeout.current = null;
		}
		const transitionTiming = reducedMotion.getTransitionTiming({
			duration,
			delay
		});
		node.style.transition = [theme.transitions.create("opacity", {
			duration: transitionTiming.duration,
			delay: transitionTiming.delay
		}), theme.transitions.create("transform", {
			duration: typeof transitionTiming.duration === "string" ? transitionTiming.duration : transitionTiming.duration * .666,
			delay: transitionTiming.delay,
			easing: transitionTimingFunction
		})].join(",");
		if (onEnter) onEnter(node, isAppearing);
	});
	const handleEntered = normalizedTransitionCallback(nodeRef, onEntered);
	const handleExiting = normalizedTransitionCallback(nodeRef, onExiting);
	const handleExit = normalizedTransitionCallback(nodeRef, (node) => {
		const { duration: transitionDuration, delay, easing: transitionTimingFunction } = getTransitionProps({
			style,
			timeout,
			easing
		}, { mode: "exit" });
		let duration;
		if (timeout === "auto" && !reducedMotion.shouldReduceMotion) {
			duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
			autoTimeout.current = duration;
		} else {
			duration = transitionDuration;
			autoTimeout.current = null;
		}
		const transitionTiming = reducedMotion.getTransitionTiming({
			duration,
			delay
		});
		node.style.transition = [theme.transitions.create("opacity", {
			duration: transitionTiming.duration,
			delay: transitionTiming.delay
		}), theme.transitions.create("transform", {
			duration: typeof transitionTiming.duration === "string" ? transitionTiming.duration : transitionTiming.duration * .666,
			delay: transitionTiming.delay || (typeof transitionTiming.duration === "string" ? transitionTiming.duration : transitionTiming.duration * .333),
			easing: transitionTimingFunction
		})].join(",");
		node.style.opacity = 0;
		node.style.transform = getScale(.75);
		if (onExit) onExit(node);
	});
	const handleExited = normalizedTransitionCallback(nodeRef, (node) => {
		node.style.transition = "";
		if (onExited) onExited(node);
	});
	return /*#__PURE__*/ jsx(Transition, {
		appear,
		in: inProp,
		nodeRef,
		onEnter: handleEnter,
		onEntered: handleEntered,
		onEntering: handleEntering,
		onExit: handleExit,
		onExited: handleExited,
		onExiting: handleExiting,
		addEndListener: addEndListener ? (next) => {
			addEndListener(nodeRef.current, next);
		} : void 0,
		getAutoTimeout: timeout === "auto" ? () => autoTimeout.current : void 0,
		reduceMotion: reducedMotion.shouldReduceMotion,
		timeout: timeout === "auto" ? null : timeout,
		...other,
		children: (state, { ownerState, ...restChildProps }) => {
			const childStyle = getTransitionChildStyle(state, inProp, styles$1, hiddenStyles, style, children.props.style);
			return /*#__PURE__*/ React$1.cloneElement(children, {
				style: childStyle,
				ref: handleRef,
				...restChildProps
			});
		}
	});
});
Grow.propTypes = {
	/**
	* Add a custom transition end trigger.
	* Use it when you need custom logic to decide when the transition has ended.
	* Note: Timeouts are still used as a fallback if provided.
	*
	* @param {HTMLElement} node The transitioning DOM node.
	* @param {Function} done Call this when the transition has finished.
	*/
	addEndListener: import_prop_types.default.func,
	/**
	* Perform the enter transition when it first mounts if `in` is also `true`.
	* Set this to `false` to disable this behavior.
	* @default true
	*/
	appear: import_prop_types.default.bool,
	/**
	* A single child content element.
	*/
	children: elementAcceptingRef.isRequired,
	/**
	* If `true`, the transition ignores `theme.motion.reducedMotion` and keeps its normal timing.
	* @default false
	*/
	disablePrefersReducedMotion: import_prop_types.default.bool,
	/**
	* The transition timing function.
	* You may specify a single easing or a object containing enter and exit values.
	*/
	easing: import_prop_types.default.oneOfType([import_prop_types.default.shape({
		enter: import_prop_types.default.string,
		exit: import_prop_types.default.string
	}), import_prop_types.default.string]),
	/**
	* If `true`, the component will transition in.
	*/
	in: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	onEnter: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onEntered: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onEntering: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExit: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExited: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onExiting: import_prop_types.default.func,
	/**
	* @ignore
	*/
	style: import_prop_types.default.object,
	/**
	* The duration for the transition, in milliseconds.
	* You may specify a single timeout for all transitions, or individually with an object.
	*
	* Set to 'auto' to automatically calculate transition time based on height.
	* @default 'auto'
	*/
	timeout: import_prop_types.default.oneOfType([
		import_prop_types.default.oneOf(["auto"]),
		import_prop_types.default.number,
		import_prop_types.default.shape({
			appear: import_prop_types.default.number,
			enter: import_prop_types.default.number,
			exit: import_prop_types.default.number
		})
	])
};
if (Grow) Grow.muiSupportAuto = true;
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Icon/iconClasses.mjs
function getIconUtilityClass(slot) {
	return generateUtilityClass("MuiIcon", slot);
}
generateUtilityClasses("MuiIcon", [
	"root",
	"colorPrimary",
	"colorSecondary",
	"colorAction",
	"colorError",
	"colorDisabled",
	"fontSizeInherit",
	"fontSizeSmall",
	"fontSizeMedium",
	"fontSizeLarge"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Icon/Icon.mjs
const useUtilityClasses$41 = (ownerState) => {
	const { color, fontSize, classes } = ownerState;
	const slots = { root: [
		"root",
		color !== "inherit" && `color${capitalize_default(color)}`,
		`fontSize${capitalize_default(fontSize)}`
	] };
	return composeClasses(slots, getIconUtilityClass, classes);
};
const IconRoot = styled$2("span", {
	name: "MuiIcon",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.color !== "inherit" && styles[`color${capitalize_default(ownerState.color)}`],
			styles[`fontSize${capitalize_default(ownerState.fontSize)}`]
		];
	}
})(memoTheme(({ theme }) => ({
	userSelect: "none",
	width: "1em",
	height: "1em",
	overflow: "hidden",
	display: "inline-block",
	textAlign: "center",
	flexShrink: 0,
	variants: [
		{
			props: { fontSize: "inherit" },
			style: { fontSize: "inherit" }
		},
		{
			props: { fontSize: "small" },
			style: { fontSize: theme.typography.pxToRem(20) }
		},
		{
			props: { fontSize: "medium" },
			style: { fontSize: theme.typography.pxToRem(24) }
		},
		{
			props: { fontSize: "large" },
			style: { fontSize: theme.typography.pxToRem(36) }
		},
		{
			props: { color: "action" },
			style: { color: (theme.vars || theme).palette.action.active }
		},
		{
			props: { color: "disabled" },
			style: { color: (theme.vars || theme).palette.action.disabled }
		},
		{
			props: { color: "inherit" },
			style: { color: void 0 }
		},
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
			props: { color },
			style: { color: (theme.vars || theme).palette[color].main }
		}))
	]
})));
const Icon = /*#__PURE__*/ React$1.forwardRef(function Icon(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiIcon"
	});
	const { baseClassName = "material-icons", className, color = "inherit", component: Component = "span", fontSize = "medium", ...other } = props;
	const ownerState = {
		...props,
		baseClassName,
		color,
		component: Component,
		fontSize
	};
	const classes = useUtilityClasses$41(ownerState);
	return /*#__PURE__*/ jsx(IconRoot, {
		as: Component,
		className: clsx(baseClassName, "notranslate", classes.root, className),
		ownerState,
		"aria-hidden": true,
		ref,
		...other
	});
});
Icon.propTypes = {
	/**
	* The base class applied to the icon. Defaults to 'material-icons', but can be changed to any
	* other base class that suits the icon font you're using (for example material-icons-rounded, fas, etc).
	* @default 'material-icons'
	*/
	baseClassName: import_prop_types.default.string,
	/**
	* The name of the icon font ligature.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'inherit'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"inherit",
		"action",
		"disabled",
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	* @default 'medium'
	*/
	fontSize: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"inherit",
		"large",
		"medium",
		"small"
	]), import_prop_types.default.string]),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
Icon.muiName = "Icon";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/InputLabel/inputLabelClasses.mjs
const inputLabelClasses = generateUtilityClasses("MuiInputLabel", [
	"root",
	"focused",
	"disabled",
	"error",
	"required",
	"asterisk",
	"formControl",
	"sizeSmall",
	"shrink",
	"animated",
	"standard",
	"filled",
	"outlined"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Input/Input.mjs
const useUtilityClasses$40 = (ownerState) => {
	const { classes, disableUnderline } = ownerState;
	const composedClasses = composeClasses({
		root: ["root", !disableUnderline && "underline"],
		input: ["input"]
	}, getInputUtilityClass, classes);
	return {
		...classes,
		...composedClasses
	};
};
const InputRoot = styled$2(InputBaseRoot, {
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
	name: "MuiInput",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [...rootOverridesResolver(props, styles), !ownerState.disableUnderline && styles.underline];
	}
})(memoTheme(({ theme }) => {
	let bottomLineColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
	if (theme.vars) bottomLineColor = theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline);
	return {
		position: "relative",
		variants: [
			{
				props: ({ ownerState }) => ownerState.formControl,
				style: { [`label + &, .${inputLabelClasses.root} + &`]: { marginTop: 16 } }
			},
			{
				props: ({ ownerState }) => !ownerState.disableUnderline,
				style: {
					"&::after": {
						left: 0,
						bottom: 0,
						content: "\"\"",
						position: "absolute",
						right: 0,
						transform: "scaleX(0)",
						...getTransitionStyles(theme, "transform", {
							duration: theme.transitions.duration.shorter,
							easing: theme.transitions.easing.easeOut
						}),
						pointerEvents: "none"
					},
					[`&.${inputClasses.focused}:after`]: { transform: "scaleX(1) translateX(0)" },
					[`&.${inputClasses.error}`]: { "&::before, &::after": { borderBottomColor: (theme.vars || theme).palette.error.main } },
					"&::before": {
						borderBottom: `1px solid ${bottomLineColor}`,
						left: 0,
						bottom: 0,
						content: "\"\"",
						position: "absolute",
						right: 0,
						...getTransitionStyles(theme, "border-bottom-color", { duration: theme.transitions.duration.shorter }),
						pointerEvents: "none"
					},
					[`&:hover:not(.${inputClasses.disabled}, .${inputClasses.error}):before`]: {
						borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
						"@media (hover: none)": { borderBottom: `1px solid ${bottomLineColor}` }
					},
					[`&.${inputClasses.disabled}:before`]: { borderBottomStyle: "dotted" }
				}
			},
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
				props: {
					color,
					disableUnderline: false
				},
				style: { "&::after": { borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}` } }
			}))
		]
	};
}));
const InputInput = styled$2(InputBaseInput, {
	name: "MuiInput",
	slot: "Input",
	overridesResolver: inputOverridesResolver
})({});
const Input$1 = /*#__PURE__*/ React$1.forwardRef(function Input(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiInput"
	});
	const { disableUnderline = false, fullWidth = false, inputComponent = "input", multiline = false, notched, slotProps, slots = {}, type = "text", ...other } = props;
	const classes = useUtilityClasses$40(props);
	const inputComponentsProps = { root: { ownerState: { disableUnderline } } };
	const componentsProps = slotProps ? deepmerge(slotProps, inputComponentsProps) : inputComponentsProps;
	const RootSlot = slots.root ?? InputRoot;
	const InputSlot = slots.input ?? InputInput;
	return /*#__PURE__*/ jsx(InputBase, {
		slots: {
			root: RootSlot,
			input: InputSlot
		},
		slotProps: componentsProps,
		fullWidth,
		inputComponent,
		multiline,
		ref,
		type,
		...other,
		classes
	});
});
Input$1.propTypes = {
	/**
	* This prop helps users to fill forms faster, especially on mobile devices.
	* The name can be confusing, as it's more like an autofill.
	* You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	*/
	autoComplete: import_prop_types.default.string,
	/**
	* If `true`, the `input` element is focused during the first mount.
	*/
	autoFocus: import_prop_types.default.bool,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["primary", "secondary"]), import_prop_types.default.string]),
	/**
	* The default value. Use when the component is not controlled.
	*/
	defaultValue: import_prop_types.default.any,
	/**
	* If `true`, the component is disabled.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the `input` will not have an underline.
	* @default false
	*/
	disableUnderline: import_prop_types.default.bool,
	/**
	* End `InputAdornment` for this component.
	*/
	endAdornment: import_prop_types.default.node,
	/**
	* If `true`, the `input` will indicate an error.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	error: import_prop_types.default.bool,
	/**
	* If `true`, the `input` will take up the full width of its container.
	* @default false
	*/
	fullWidth: import_prop_types.default.bool,
	/**
	* The id of the `input` element.
	*/
	id: import_prop_types.default.string,
	/**
	* The component used for the `input` element.
	* Either a string to use a HTML element or a component.
	* @default 'input'
	*/
	inputComponent: import_prop_types.default.elementType,
	/**
	* [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
	* @default {}
	*/
	inputProps: import_prop_types.default.object,
	/**
	* Pass a ref to the `input` element.
	*/
	inputRef: refType,
	/**
	* If `dense`, will adjust vertical spacing. This is normally obtained via context from
	* FormControl.
	* The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
	*/
	margin: import_prop_types.default.oneOf(["dense", "none"]),
	/**
	* Maximum number of rows to display when multiline option is set to true.
	*/
	maxRows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* Minimum number of rows to display when multiline option is set to true.
	*/
	minRows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
	* @default false
	*/
	multiline: import_prop_types.default.bool,
	/**
	* Name attribute of the `input` element.
	*/
	name: import_prop_types.default.string,
	/**
	* @internal
	*/
	notched: import_prop_types.default.bool,
	/**
	* Callback fired when the value is changed.
	*
	* @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
	* You can pull out the new value by accessing `event.target.value` (string).
	*/
	onChange: import_prop_types.default.func,
	/**
	* The short hint displayed in the `input` before the user enters a value.
	*/
	placeholder: import_prop_types.default.string,
	/**
	* It prevents the user from changing the value of the field
	* (not from interacting with the field).
	*/
	readOnly: import_prop_types.default.bool,
	/**
	* If `true`, the `input` element is required.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	required: import_prop_types.default.bool,
	/**
	* Number of rows to display when multiline option is set to true.
	*/
	rows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* The extra props for the slot components.
	* You can override the existing props or add new ones.
	*
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		input: import_prop_types.default.object,
		root: import_prop_types.default.object
	}),
	/**
	* The components used for each slot inside.
	*
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		input: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* Start `InputAdornment` for this component.
	*/
	startAdornment: import_prop_types.default.node,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
	* @default 'text'
	*/
	type: import_prop_types.default.string,
	/**
	* The value of the `input` element, required for a controlled component.
	*/
	value: import_prop_types.default.any
};
Input$1.muiName = "Input";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/InputAdornment/inputAdornmentClasses.mjs
function getInputAdornmentUtilityClass(slot) {
	return generateUtilityClass("MuiInputAdornment", slot);
}
const inputAdornmentClasses = generateUtilityClasses("MuiInputAdornment", [
	"root",
	"filled",
	"standard",
	"outlined",
	"positionStart",
	"positionEnd",
	"disablePointerEvents",
	"hiddenLabel",
	"sizeSmall"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/InputAdornment/InputAdornment.mjs
var _span$2;
const overridesResolver$4 = (props, styles) => {
	const { ownerState } = props;
	return [
		styles.root,
		styles[`position${capitalize_default(ownerState.position)}`],
		ownerState.disablePointerEvents === true && styles.disablePointerEvents,
		styles[ownerState.variant]
	];
};
const useUtilityClasses$39 = (ownerState) => {
	const { classes, disablePointerEvents, hiddenLabel, position, size, variant } = ownerState;
	const slots = { root: [
		"root",
		disablePointerEvents && "disablePointerEvents",
		position && `position${capitalize_default(position)}`,
		variant,
		hiddenLabel && "hiddenLabel",
		size && `size${capitalize_default(size)}`
	] };
	return composeClasses(slots, getInputAdornmentUtilityClass, classes);
};
const InputAdornmentRoot = styled$2("div", {
	name: "MuiInputAdornment",
	slot: "Root",
	overridesResolver: overridesResolver$4
})(memoTheme(({ theme }) => ({
	display: "flex",
	maxHeight: "2em",
	alignItems: "center",
	whiteSpace: "nowrap",
	color: (theme.vars || theme).palette.action.active,
	variants: [
		{
			props: { variant: "filled" },
			style: { [`&.${inputAdornmentClasses.positionStart}&:not(.${inputAdornmentClasses.hiddenLabel})`]: { marginTop: 16 } }
		},
		{
			props: { position: "start" },
			style: { marginRight: 8 }
		},
		{
			props: { position: "end" },
			style: { marginLeft: 8 }
		},
		{
			props: { disablePointerEvents: true },
			style: { pointerEvents: "none" }
		}
	]
})));
const InputAdornment = /*#__PURE__*/ React$1.forwardRef(function InputAdornment(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiInputAdornment"
	});
	const { children, className, component = "div", disablePointerEvents = false, disableTypography = false, position, variant: variantProp, ...other } = props;
	const muiFormControl = useFormControl() || {};
	let variant = variantProp;
	if (variantProp && muiFormControl.variant) {
		if (variantProp === muiFormControl.variant) console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one.");
	}
	if (muiFormControl && !variant) variant = muiFormControl.variant;
	const ownerState = {
		...props,
		hiddenLabel: muiFormControl.hiddenLabel,
		size: muiFormControl.size,
		disablePointerEvents,
		position,
		variant
	};
	const classes = useUtilityClasses$39(ownerState);
	return /*#__PURE__*/ jsx(FormControlContext.Provider, {
		value: null,
		children: /*#__PURE__*/ jsx(InputAdornmentRoot, {
			as: component,
			ownerState,
			className: clsx(classes.root, className),
			ref,
			...other,
			children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ jsx(Typography$1, {
				color: "textSecondary",
				children
			}) : /*#__PURE__*/ jsxs(React$1.Fragment, { children: [position === "start" ? _span$2 || (_span$2 = /*#__PURE__*/ jsx("span", {
				className: "notranslate",
				"aria-hidden": true,
				children: "​"
			})) : null, children] })
		})
	});
});
InputAdornment.propTypes = {
	/**
	* The content of the component, normally an `IconButton` or string.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* Disable pointer events on the root.
	* This allows for the content of the adornment to focus the `input` on click.
	* @default false
	*/
	disablePointerEvents: import_prop_types.default.bool,
	/**
	* If children is a string then disable wrapping in a Typography component.
	* @default false
	*/
	disableTypography: import_prop_types.default.bool,
	/**
	* The position this adornment should appear relative to the `Input`.
	*/
	position: import_prop_types.default.oneOf(["end", "start"]).isRequired,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The variant to use.
	* Note: If you are using the `TextField` component or the `FormControl` component
	* you do not have to set this manually.
	*/
	variant: import_prop_types.default.oneOf([
		"filled",
		"outlined",
		"standard"
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/LinearProgress/linearProgressClasses.mjs
function getLinearProgressUtilityClass(slot) {
	return generateUtilityClass("MuiLinearProgress", slot);
}
const linearProgressClasses = generateUtilityClasses("MuiLinearProgress", [
	"root",
	"colorPrimary",
	"colorSecondary",
	"determinate",
	"indeterminate",
	"buffer",
	"query",
	"dashed",
	"bar",
	"bar1",
	"bar2"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/LinearProgress/LinearProgress.mjs
const TRANSITION_DURATION = 4;
const EMPTY_STYLE = {};
let warnedMinMaxWithoutVariant = false;
let warnedInvalidMinMaxValue = false;
let warnedValueRequired = false;
let warnedInvalidMinMaxValueBuffer = false;
let warnedValueBufferRequired = false;
const indeterminate1Keyframe = keyframes`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
const indeterminate1Animation = typeof indeterminate1Keyframe !== "string" ? css`
        animation: ${indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const indeterminate2Keyframe = keyframes`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const indeterminate2Animation = typeof indeterminate2Keyframe !== "string" ? css`
        animation: ${indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const bufferKeyframe = keyframes`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const bufferAnimation = typeof bufferKeyframe !== "string" ? css`
        animation: ${bufferKeyframe} 3s infinite linear;
      ` : null;
const useUtilityClasses$38 = (ownerState) => {
	const { classes, variant, color } = ownerState;
	const slots = {
		root: [
			"root",
			`color${capitalize_default(color)}`,
			variant
		],
		dashed: ["dashed"],
		bar1: ["bar", "bar1"],
		bar2: [
			"bar",
			"bar2",
			variant === "buffer" && `color${capitalize_default(color)}`
		]
	};
	return composeClasses(slots, getLinearProgressUtilityClass, classes);
};
const getColorShade = (theme, color) => {
	if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
	return theme.palette.mode === "light" ? theme.lighten(theme.palette[color].main, .62) : theme.darken(theme.palette[color].main, .5);
};
const LinearProgressRoot = styled$2("span", {
	name: "MuiLinearProgress",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[`color${capitalize_default(ownerState.color)}`],
			styles[ownerState.variant]
		];
	}
})(memoTheme(({ theme }) => ({
	position: "relative",
	overflow: "hidden",
	display: "block",
	height: 4,
	zIndex: 0,
	"@media print": { colorAdjust: "exact" },
	variants: [
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
			props: { color },
			style: { backgroundColor: getColorShade(theme, color) }
		})),
		{
			props: ({ ownerState }) => ownerState.color === "inherit" && ownerState.variant !== "buffer",
			style: { "&::before": {
				content: "\"\"",
				position: "absolute",
				left: 0,
				top: 0,
				right: 0,
				bottom: 0,
				backgroundColor: "currentColor",
				opacity: .3
			} }
		},
		{
			props: { variant: "buffer" },
			style: { backgroundColor: "transparent" }
		},
		{
			props: { variant: "query" },
			style: { transform: "rotate(180deg)" }
		}
	]
})));
const LinearProgressDashed = styled$2("span", {
	name: "MuiLinearProgress",
	slot: "Dashed"
})(memoTheme(({ theme }) => ({
	position: "absolute",
	marginTop: 0,
	height: "100%",
	width: "100%",
	backgroundSize: "10px 10px",
	backgroundPosition: "0 -23px",
	variants: [{
		props: { color: "inherit" },
		style: {
			opacity: .3,
			backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
		}
	}, ...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => {
		const backgroundColor = getColorShade(theme, color);
		return {
			props: { color },
			style: { backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)` }
		};
	})]
})), bufferAnimation || { animation: `${bufferKeyframe} 3s infinite linear` }, memoTheme(({ theme }) => getReducedMotionStyles(theme, { animation: "none" }) || EMPTY_STYLE));
const LinearProgressBar1 = styled$2("span", {
	name: "MuiLinearProgress",
	slot: "Bar1",
	overridesResolver: (props, styles) => {
		return [styles.bar, styles.bar1];
	}
})(memoTheme(({ theme }) => {
	const reducedMotionIndeterminateStyles = getReducedMotionStyles(theme, {
		animation: "none",
		left: "30%",
		right: "auto",
		width: "40%"
	});
	return {
		width: "100%",
		position: "absolute",
		left: 0,
		bottom: 0,
		top: 0,
		...getTransitionStyles(theme, "transform", {
			duration: "0.2s",
			easing: "linear"
		}),
		transformOrigin: "left",
		variants: [
			{
				props: { color: "inherit" },
				style: { backgroundColor: "currentColor" }
			},
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
				props: { color },
				style: { backgroundColor: (theme.vars || theme).palette[color].main }
			})),
			{
				props: { variant: "determinate" },
				style: { ...getTransitionStyles(theme, "transform", {
					duration: `.${TRANSITION_DURATION}s`,
					easing: "linear"
				}) }
			},
			{
				props: { variant: "buffer" },
				style: {
					zIndex: 1,
					...getTransitionStyles(theme, "transform", {
						duration: `.${TRANSITION_DURATION}s`,
						easing: "linear"
					})
				}
			},
			{
				props: ({ ownerState }) => ownerState.variant === "indeterminate" || ownerState.variant === "query",
				style: { width: "auto" }
			},
			{
				props: ({ ownerState }) => ownerState.variant === "indeterminate" || ownerState.variant === "query",
				style: indeterminate1Animation || { animation: `${indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite` }
			},
			...reducedMotionIndeterminateStyles ? [{
				props: ({ ownerState }) => ownerState.variant === "indeterminate" || ownerState.variant === "query",
				style: reducedMotionIndeterminateStyles
			}] : []
		]
	};
}));
const LinearProgressBar2 = styled$2("span", {
	name: "MuiLinearProgress",
	slot: "Bar2",
	overridesResolver: (props, styles) => {
		return [styles.bar, styles.bar2];
	}
})(memoTheme(({ theme }) => {
	const reducedMotionIndeterminateStyles = getReducedMotionStyles(theme, {
		animation: "none",
		display: "none"
	});
	return {
		width: "100%",
		position: "absolute",
		left: 0,
		bottom: 0,
		top: 0,
		...getTransitionStyles(theme, "transform", {
			duration: "0.2s",
			easing: "linear"
		}),
		transformOrigin: "left",
		variants: [
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
				props: { color },
				style: { "--LinearProgressBar2-barColor": (theme.vars || theme).palette[color].main }
			})),
			{
				props: ({ ownerState }) => ownerState.variant !== "buffer" && ownerState.color !== "inherit",
				style: { backgroundColor: "var(--LinearProgressBar2-barColor, currentColor)" }
			},
			{
				props: ({ ownerState }) => ownerState.variant !== "buffer" && ownerState.color === "inherit",
				style: { backgroundColor: "currentColor" }
			},
			{
				props: { color: "inherit" },
				style: { opacity: .3 }
			},
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
				props: {
					color,
					variant: "buffer"
				},
				style: {
					backgroundColor: getColorShade(theme, color),
					...getTransitionStyles(theme, "transform", {
						duration: `.${TRANSITION_DURATION}s`,
						easing: "linear"
					})
				}
			})),
			{
				props: ({ ownerState }) => ownerState.variant === "indeterminate" || ownerState.variant === "query",
				style: { width: "auto" }
			},
			{
				props: ({ ownerState }) => ownerState.variant === "indeterminate" || ownerState.variant === "query",
				style: indeterminate2Animation || { animation: `${indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite` }
			},
			...reducedMotionIndeterminateStyles ? [{
				props: ({ ownerState }) => ownerState.variant === "indeterminate" || ownerState.variant === "query",
				style: reducedMotionIndeterminateStyles
			}] : []
		]
	};
}));
/**
* ## ARIA
*
* If the progress bar is describing the loading progress of a particular region of a page,
* you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
* attribute to `true` on that region until it has finished loading.
*/
const LinearProgress$1 = /*#__PURE__*/ React$1.forwardRef(function LinearProgress(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiLinearProgress"
	});
	const { className, color = "primary", max: maxProp, min: minProp, value, valueBuffer, variant = "indeterminate", ...other } = props;
	const ownerState = {
		...props,
		color,
		variant
	};
	if (!warnedMinMaxWithoutVariant && ["indeterminate", "query"].includes(variant) && (minProp !== void 0 || maxProp !== void 0)) {
		console.warn(`MUI: You have provided the \`min\` or \`max\` props with an 'indeterminate' or 'query' variant. These props will have no effect.`);
		warnedMinMaxWithoutVariant = true;
	}
	const min = minProp ?? 0;
	const max = maxProp ?? 100;
	const classes = useUtilityClasses$38(ownerState);
	const isRtl = useRtl();
	const rootProps = {};
	const inlineStyles = {
		bar1: {},
		bar2: {}
	};
	if (variant === "determinate" || variant === "buffer") {
		if (value !== void 0) {
			if (!warnedInvalidMinMaxValue && (value < min || value > max || min >= max)) {
				console.error(`MUI: The min, max, and value props in LinearProgress should be numbers where min < max and min <= value <= max. Received min=${min}, max=${max}, value=${value}.`);
				warnedInvalidMinMaxValue = true;
			}
			const range = max - min;
			let transform = (value - min) / range * 100 - 100;
			if (isRtl) transform = -transform;
			inlineStyles.bar1.transform = range > 0 ? `translateX(${transform}%)` : "translateX(-100%)";
			rootProps["aria-valuenow"] = value;
			rootProps["aria-valuemin"] = min;
			rootProps["aria-valuemax"] = max;
		} else if (!warnedValueRequired) {
			console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress.");
			warnedValueRequired = true;
		}
	}
	if (variant === "buffer") {
		if (valueBuffer !== void 0) {
			if (!warnedInvalidMinMaxValueBuffer && (valueBuffer < min || valueBuffer > max || valueBuffer < value || min >= max)) {
				console.error(`MUI: The min, max, value, and valueBuffer props in LinearProgress should be numbers where min < max and min <= value <= valueBuffer <= max. Received min=${min}, max=${max}, value=${value}, valueBuffer=${valueBuffer}.`);
				warnedInvalidMinMaxValueBuffer = true;
			}
			const range = max - min;
			let transform = (valueBuffer - min) / range * 100 - 100;
			if (isRtl) transform = -transform;
			inlineStyles.bar2.transform = range > 0 ? `translateX(${transform}%)` : "translateX(-100%)";
		} else if (!warnedValueBufferRequired) {
			console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
			warnedValueBufferRequired = true;
		}
	}
	return /*#__PURE__*/ jsxs(LinearProgressRoot, {
		className: clsx(classes.root, className),
		ownerState,
		role: "progressbar",
		...rootProps,
		ref,
		...other,
		children: [
			variant === "buffer" ? /*#__PURE__*/ jsx(LinearProgressDashed, {
				className: classes.dashed,
				ownerState
			}) : null,
			/*#__PURE__*/ jsx(LinearProgressBar1, {
				className: classes.bar1,
				ownerState,
				style: inlineStyles.bar1
			}),
			variant === "determinate" ? null : /*#__PURE__*/ jsx(LinearProgressBar2, {
				className: classes.bar2,
				ownerState,
				style: inlineStyles.bar2
			})
		]
	});
});
LinearProgress$1.propTypes = {
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'primary'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"inherit",
		"primary",
		"secondary"
	]), import_prop_types.default.string]),
	/**
	* The maximum value for the progress indicator for the determinate and buffer variants.
	* @default 100
	*/
	max: import_prop_types.default.number,
	/**
	* The minimum value for the progress indicator for the determinate and buffer variants.
	* @default 0
	*/
	min: import_prop_types.default.number,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The value of the progress indicator for the determinate and buffer variants.
	* Value between `min` and `max`.
	*/
	value: import_prop_types.default.number,
	/**
	* The value for the buffer variant.
	* Value between `min` and `max`.
	*/
	valueBuffer: import_prop_types.default.number,
	/**
	* The variant to use.
	* Use indeterminate or query when there is no progress value.
	* @default 'indeterminate'
	*/
	variant: import_prop_types.default.oneOf([
		"buffer",
		"determinate",
		"indeterminate",
		"query"
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Link/linkClasses.mjs
function getLinkUtilityClass(slot) {
	return generateUtilityClass("MuiLink", slot);
}
const linkClasses = generateUtilityClasses("MuiLink", [
	"root",
	"underlineNone",
	"underlineHover",
	"underlineAlways",
	"button",
	"focusVisible"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Link/getTextDecoration.mjs
const getTextDecoration = ({ theme, ownerState }) => {
	const transformedColor = ownerState.color;
	if ("colorSpace" in theme && theme.colorSpace) {
		const color = getPath(theme, `palette.${transformedColor}.main`) || getPath(theme, `palette.${transformedColor}`) || ownerState.color;
		return theme.alpha(color, .4);
	}
	const color = getPath(theme, `palette.${transformedColor}.main`, false) || getPath(theme, `palette.${transformedColor}`, false) || ownerState.color;
	const channelColor = getPath(theme, `palette.${transformedColor}.mainChannel`) || getPath(theme, `palette.${transformedColor}Channel`);
	if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
	return alpha(color, .4);
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Link/Link.mjs
const v6Colors = {
	primary: true,
	secondary: true,
	error: true,
	info: true,
	success: true,
	warning: true,
	textPrimary: true,
	textSecondary: true,
	textDisabled: true
};
const useUtilityClasses$37 = (ownerState) => {
	const { classes, component, focusVisible, underline } = ownerState;
	const slots = { root: [
		"root",
		`underline${capitalize_default(underline)}`,
		component === "button" && "button",
		focusVisible && "focusVisible"
	] };
	return composeClasses(slots, getLinkUtilityClass, classes);
};
const LinkRoot = styled$2(Typography$1, {
	name: "MuiLink",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[`underline${capitalize_default(ownerState.underline)}`],
			ownerState.component === "button" && styles.button
		];
	}
})(memoTheme(({ theme }) => {
	return {
		...theme.focusVisible && { [`&.${linkClasses.focusVisible}`]: {
			...outsetFocusRing,
			...theme.focusVisible
		} },
		variants: [
			{
				props: { underline: "none" },
				style: { textDecoration: "none" }
			},
			{
				props: { underline: "hover" },
				style: {
					textDecoration: "none",
					"&:hover": { textDecoration: "underline" }
				}
			},
			{
				props: { underline: "always" },
				style: {
					textDecoration: "underline",
					"&:hover": { textDecorationColor: "inherit" }
				}
			},
			{
				props: ({ underline, ownerState }) => underline === "always" && ownerState.color !== "inherit",
				style: { textDecorationColor: "var(--Link-underlineColor)" }
			},
			{
				props: ({ underline, ownerState }) => underline === "always" && ownerState.color === "inherit",
				style: theme.colorSpace ? { textDecorationColor: theme.alpha("currentColor", .4) } : null
			},
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
				props: {
					underline: "always",
					color
				},
				style: { "--Link-underlineColor": theme.alpha((theme.vars || theme).palette[color].main, .4) }
			})),
			{
				props: {
					underline: "always",
					color: "textPrimary"
				},
				style: { "--Link-underlineColor": theme.alpha((theme.vars || theme).palette.text.primary, .4) }
			},
			{
				props: {
					underline: "always",
					color: "textSecondary"
				},
				style: { "--Link-underlineColor": theme.alpha((theme.vars || theme).palette.text.secondary, .4) }
			},
			{
				props: {
					underline: "always",
					color: "textDisabled"
				},
				style: { "--Link-underlineColor": (theme.vars || theme).palette.text.disabled }
			},
			{
				props: { component: "button" },
				style: {
					position: "relative",
					WebkitTapHighlightColor: "transparent",
					backgroundColor: "transparent",
					outline: 0,
					border: 0,
					margin: 0,
					borderRadius: 0,
					padding: 0,
					cursor: "pointer",
					userSelect: "none",
					verticalAlign: "middle",
					MozAppearance: "none",
					WebkitAppearance: "none",
					"&::-moz-focus-inner": { borderStyle: "none" },
					...!theme.focusVisible && { [`&.${linkClasses.focusVisible}`]: { outline: "auto" } }
				}
			}
		]
	};
}));
const Link$1 = /*#__PURE__*/ React$1.forwardRef(function Link(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiLink"
	});
	const theme = useTheme$1();
	const { className, color = "primary", component = "a", onBlur, onFocus, TypographyClasses, underline = "always", variant = "inherit", sx, ...other } = props;
	const [focusVisible, setFocusVisible] = React$1.useState(false);
	const handleBlur = (event) => {
		if (!isFocusVisible(event.target)) setFocusVisible(false);
		if (onBlur) onBlur(event);
	};
	const handleFocus = (event) => {
		if (isFocusVisible(event.target)) setFocusVisible(true);
		if (onFocus) onFocus(event);
	};
	const ownerState = {
		...props,
		color,
		component,
		focusVisible,
		underline,
		variant
	};
	const classes = useUtilityClasses$37(ownerState);
	return /*#__PURE__*/ jsx(LinkRoot, {
		color,
		className: clsx(classes.root, className),
		classes: TypographyClasses,
		component,
		onBlur: handleBlur,
		onFocus: handleFocus,
		ref,
		ownerState,
		variant,
		...other,
		sx: [...v6Colors[color] === void 0 ? [{ color }] : [], ...Array.isArray(sx) ? sx : [sx]],
		style: {
			...other.style,
			...underline === "always" && color !== "inherit" && !v6Colors[color] && { "--Link-underlineColor": getTextDecoration({
				theme,
				ownerState
			}) }
		}
	});
});
Link$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the link.
	* @default 'primary'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"primary",
		"secondary",
		"success",
		"error",
		"info",
		"warning",
		"textPrimary",
		"textSecondary",
		"textDisabled"
	]), import_prop_types.default.string]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: elementTypeAcceptingRef_default,
	/**
	* @ignore
	*/
	onBlur: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onFocus: import_prop_types.default.func,
	/**
	* @ignore
	*/
	style: import_prop_types.default.object,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* `classes` prop applied to the [`Typography`](https://mui.com/material-ui/api/typography/) element.
	*/
	TypographyClasses: import_prop_types.default.object,
	/**
	* Controls when the link should have an underline.
	* @default 'always'
	*/
	underline: import_prop_types.default.oneOf([
		"always",
		"hover",
		"none"
	]),
	/**
	* Applies the theme typography styles.
	* @default 'inherit'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"body1",
		"body2",
		"button",
		"caption",
		"h1",
		"h2",
		"h3",
		"h4",
		"h5",
		"h6",
		"inherit",
		"overline",
		"subtitle1",
		"subtitle2"
	]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/List/ListContext.mjs
/**
* @ignore - internal component.
*/
const ListContext = /*#__PURE__*/ React$1.createContext({});
ListContext.displayName = "ListContext";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/List/listClasses.mjs
function getListUtilityClass(slot) {
	return generateUtilityClass("MuiList", slot);
}
const listClasses = generateUtilityClasses("MuiList", [
	"root",
	"padding",
	"dense",
	"subheader"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/List/List.mjs
const useUtilityClasses$36 = (ownerState) => {
	const { classes, disablePadding, dense, subheader } = ownerState;
	return composeClasses({ root: [
		"root",
		!disablePadding && "padding",
		dense && "dense",
		subheader && "subheader"
	] }, getListUtilityClass, classes);
};
const ListRoot = styled$2("ul", {
	name: "MuiList",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			!ownerState.disablePadding && styles.padding,
			ownerState.dense && styles.dense,
			ownerState.subheader && styles.subheader
		];
	}
})({
	listStyle: "none",
	margin: 0,
	padding: 0,
	position: "relative",
	variants: [{
		props: ({ ownerState }) => !ownerState.disablePadding,
		style: {
			paddingTop: 8,
			paddingBottom: 8
		}
	}, {
		props: ({ ownerState }) => ownerState.subheader,
		style: {
			paddingTop: 0,
			isolation: "isolate"
		}
	}]
});
const List$1 = /*#__PURE__*/ React$1.forwardRef(function List(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiList"
	});
	const { children, className, component = "ul", dense = false, disablePadding = false, subheader, ...other } = props;
	const context = React$1.useMemo(() => ({ dense }), [dense]);
	const ownerState = {
		...props,
		component,
		dense,
		disablePadding
	};
	const classes = useUtilityClasses$36(ownerState);
	return /*#__PURE__*/ jsx(ListContext.Provider, {
		value: context,
		children: /*#__PURE__*/ jsxs(ListRoot, {
			as: component,
			className: clsx(classes.root, className),
			ref,
			ownerState,
			...other,
			children: [subheader, children]
		})
	});
});
List$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, compact vertical padding designed for keyboard and mouse input is used for
	* the list and list items.
	* The prop is available to descendant components as the `dense` context.
	* @default false
	*/
	dense: import_prop_types.default.bool,
	/**
	* If `true`, vertical padding is removed from the list.
	* @default false
	*/
	disablePadding: import_prop_types.default.bool,
	/**
	* The content of the subheader, normally `ListSubheader`.
	*/
	subheader: import_prop_types.default.node,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ListItem/listItemClasses.mjs
function getListItemUtilityClass(slot) {
	return generateUtilityClass("MuiListItem", slot);
}
generateUtilityClasses("MuiListItem", [
	"root",
	"dense",
	"alignItemsFlexStart",
	"divider",
	"gutters",
	"padding",
	"secondaryAction"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ListItemButton/ListItemButton.mjs
const overridesResolver$3 = (props, styles) => {
	const { ownerState } = props;
	return [
		styles.root,
		ownerState.dense && styles.dense,
		ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
		ownerState.divider && styles.divider,
		!ownerState.disableGutters && styles.gutters
	];
};
const useUtilityClasses$35 = (ownerState) => {
	const { alignItems, classes, dense, disabled, disableGutters, divider, selected } = ownerState;
	const composedClasses = composeClasses({ root: [
		"root",
		dense && "dense",
		!disableGutters && "gutters",
		divider && "divider",
		disabled && "disabled",
		alignItems === "flex-start" && "alignItemsFlexStart",
		selected && "selected"
	] }, getListItemButtonUtilityClass, classes);
	return {
		...classes,
		...composedClasses
	};
};
const ListItemButtonRoot = styled$2(ButtonBase, {
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
	name: "MuiListItemButton",
	slot: "Root",
	overridesResolver: overridesResolver$3
})(memoTheme(({ theme }) => ({
	display: "flex",
	flexGrow: 1,
	justifyContent: "flex-start",
	alignItems: "center",
	position: "relative",
	textDecoration: "none",
	minWidth: 0,
	boxSizing: "border-box",
	textAlign: "left",
	paddingTop: 8,
	paddingBottom: 8,
	...getTransitionStyles(theme, "background-color", { duration: theme.transitions.duration.shortest }),
	"&:hover": {
		textDecoration: "none",
		backgroundColor: (theme.vars || theme).palette.action.hover,
		"@media (hover: none)": { backgroundColor: "transparent" }
	},
	[`&.${listItemButtonClasses.selected}`]: {
		backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
		...!theme.focusVisible && { [`&.${listItemButtonClasses.focusVisible}`]: { backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`) } }
	},
	[`&.${listItemButtonClasses.selected}:hover`]: {
		backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
		"@media (hover: none)": { backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity) }
	},
	...theme.focusVisible ? applyInsetFocusVisible(1) : { [`&.${listItemButtonClasses.focusVisible}`]: { backgroundColor: (theme.vars || theme).palette.action.focus } },
	[`&.${listItemButtonClasses.disabled}`]: { opacity: (theme.vars || theme).palette.action.disabledOpacity },
	variants: [
		{
			props: ({ ownerState }) => ownerState.divider,
			style: {
				borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
				backgroundClip: "padding-box"
			}
		},
		{
			props: { alignItems: "flex-start" },
			style: { alignItems: "flex-start" }
		},
		{
			props: ({ ownerState }) => !ownerState.disableGutters,
			style: {
				paddingLeft: 16,
				paddingRight: 16
			}
		},
		{
			props: ({ ownerState }) => ownerState.dense,
			style: {
				paddingTop: 4,
				paddingBottom: 4
			}
		}
	]
})));
const ListItemButton = /*#__PURE__*/ React$1.forwardRef(function ListItemButton(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiListItemButton"
	});
	const { alignItems = "center", autoFocus = false, component = "div", children, dense = false, disableGutters = false, divider = false, focusVisibleClassName, selected = false, className, ...other } = props;
	const context = React$1.useContext(ListContext);
	const childContext = React$1.useMemo(() => ({
		dense: dense || context.dense || false,
		alignItems,
		disableGutters
	}), [
		alignItems,
		context.dense,
		dense,
		disableGutters
	]);
	const listItemRef = React$1.useRef(null);
	useEnhancedEffect_default(() => {
		if (autoFocus) {
			if (listItemRef.current) listItemRef.current.focus();
			else console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered.");
		}
	}, [autoFocus]);
	const ownerState = {
		...props,
		alignItems,
		dense: childContext.dense,
		disableGutters,
		divider,
		selected
	};
	const classes = useUtilityClasses$35(ownerState);
	const { root, ...forwardedClasses } = classes;
	const handleRef = useForkRef_default(listItemRef, ref);
	return /*#__PURE__*/ jsx(ListContext.Provider, {
		value: childContext,
		children: /*#__PURE__*/ jsx(ListItemButtonRoot, {
			ref: handleRef,
			href: other.href || other.to,
			component: (other.href || other.to) && component === "div" ? "button" : component,
			internalNativeButton: false,
			focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
			ownerState,
			className: clsx(classes.root, className),
			...other,
			classes: forwardedClasses,
			children
		})
	});
});
ListItemButton.propTypes = {
	/**
	* Defines the `align-items` style property.
	* @default 'center'
	*/
	alignItems: import_prop_types.default.oneOf(["center", "flex-start"]),
	/**
	* If `true`, the list item is focused during the first mount.
	* Focus will also be triggered if the value changes from false to true.
	* @default false
	*/
	autoFocus: import_prop_types.default.bool,
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, compact vertical padding designed for keyboard and mouse input is used.
	* The prop defaults to the value inherited from the parent List component.
	* @default false
	*/
	dense: import_prop_types.default.bool,
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the left and right padding is removed.
	* @default false
	*/
	disableGutters: import_prop_types.default.bool,
	/**
	* If `true`, a 1px light border is added to the bottom of the list item.
	* @default false
	*/
	divider: import_prop_types.default.bool,
	/**
	* This prop can help identify which element has keyboard focus.
	* The class name will be applied when the element gains the focus through keyboard interaction.
	* It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	* The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
	* A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
	* if needed.
	*/
	focusVisibleClassName: import_prop_types.default.string,
	/**
	* @ignore
	*/
	href: import_prop_types.default.string,
	/**
	* Use to apply selected styling.
	* @default false
	*/
	selected: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ListItemSecondaryAction/listItemSecondaryActionClasses.mjs
function getListItemSecondaryActionClassesUtilityClass(slot) {
	return generateUtilityClass("MuiListItemSecondaryAction", slot);
}
generateUtilityClasses("MuiListItemSecondaryAction", ["root", "disableGutters"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ListItemSecondaryAction/ListItemSecondaryAction.mjs
const useUtilityClasses$34 = (ownerState) => {
	const { disableGutters, classes } = ownerState;
	return composeClasses({ root: ["root", disableGutters && "disableGutters"] }, getListItemSecondaryActionClassesUtilityClass, classes);
};
const ListItemSecondaryActionRoot = styled$2("div", {
	name: "MuiListItemSecondaryAction",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, ownerState.disableGutters && styles.disableGutters];
	}
})({
	position: "absolute",
	right: 16,
	top: "50%",
	transform: "translateY(-50%)",
	variants: [{
		props: ({ ownerState }) => ownerState.disableGutters,
		style: { right: 0 }
	}]
});
/**
* Must be used as the last child of ListItem to function properly.
*/
const ListItemSecondaryAction = /*#__PURE__*/ React$1.forwardRef(function ListItemSecondaryAction(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiListItemSecondaryAction"
	});
	const { className, component, ...other } = props;
	const context = React$1.useContext(ListContext);
	const ownerState = {
		...props,
		disableGutters: context.disableGutters
	};
	const classes = useUtilityClasses$34(ownerState);
	return /*#__PURE__*/ jsx(ListItemSecondaryActionRoot, {
		as: component,
		className: clsx(classes.root, className),
		ownerState,
		ref,
		...other
	});
});
ListItemSecondaryAction.propTypes = {
	/**
	* The content of the component, normally an `IconButton` or selection control.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ListItem/ListItem.mjs
const overridesResolver$2 = (props, styles) => {
	const { ownerState } = props;
	return [
		styles.root,
		ownerState.dense && styles.dense,
		ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
		ownerState.divider && styles.divider,
		!ownerState.disableGutters && styles.gutters,
		!ownerState.disablePadding && styles.padding
	];
};
const useUtilityClasses$33 = (ownerState) => {
	const { alignItems, classes, dense, disableGutters, disablePadding, divider } = ownerState;
	return composeClasses({
		root: [
			"root",
			dense && "dense",
			!disableGutters && "gutters",
			!disablePadding && "padding",
			divider && "divider",
			alignItems === "flex-start" && "alignItemsFlexStart"
		],
		secondaryAction: ["secondaryAction"]
	}, getListItemUtilityClass, classes);
};
const ListItemRoot = styled$2("div", {
	name: "MuiListItem",
	slot: "Root",
	overridesResolver: overridesResolver$2
})(memoTheme(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-start",
	alignItems: "center",
	position: "relative",
	textDecoration: "none",
	width: "100%",
	boxSizing: "border-box",
	textAlign: "left",
	variants: [
		{
			props: ({ ownerState }) => !ownerState.disablePadding,
			style: {
				paddingTop: 8,
				paddingBottom: 8
			}
		},
		{
			props: ({ ownerState }) => !ownerState.disablePadding && ownerState.dense,
			style: {
				paddingTop: 4,
				paddingBottom: 4
			}
		},
		{
			props: ({ ownerState }) => !ownerState.disablePadding && !ownerState.disableGutters,
			style: {
				paddingLeft: 16,
				paddingRight: 16
			}
		},
		{
			props: ({ ownerState }) => !ownerState.disablePadding && !!ownerState.secondaryAction,
			style: { paddingRight: 48 }
		},
		{
			props: ({ ownerState }) => !!ownerState.secondaryAction,
			style: { [`& > .${listItemButtonClasses.root}`]: { paddingRight: 48 } }
		},
		{
			props: { alignItems: "flex-start" },
			style: { alignItems: "flex-start" }
		},
		{
			props: ({ ownerState }) => ownerState.divider,
			style: {
				borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
				backgroundClip: "padding-box"
			}
		},
		{
			props: ({ ownerState }) => ownerState.button,
			style: {
				...getTransitionStyles(theme, "background-color", { duration: theme.transitions.duration.shortest }),
				"&:hover": {
					textDecoration: "none",
					backgroundColor: (theme.vars || theme).palette.action.hover,
					"@media (hover: none)": { backgroundColor: "transparent" }
				}
			}
		}
	]
})));
const StyledListItemSecondaryAction = styled$2(ListItemSecondaryAction, {
	name: "MuiListItem",
	slot: "secondaryAction"
})({});
const ListItem = /*#__PURE__*/ React$1.forwardRef(function ListItem(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiListItem"
	});
	const { alignItems = "center", children: childrenProp, className, component: componentProp = "li", dense = false, disableGutters = false, disablePadding = false, divider = false, secondaryAction, slotProps = {}, slots = {}, ...other } = props;
	const context = React$1.useContext(ListContext);
	const childContext = React$1.useMemo(() => ({
		dense: dense || context.dense || false,
		alignItems,
		disableGutters
	}), [
		alignItems,
		context.dense,
		dense,
		disableGutters
	]);
	const ownerState = {
		...props,
		alignItems,
		dense: childContext.dense,
		disableGutters,
		disablePadding,
		divider,
		secondaryAction
	};
	const classes = useUtilityClasses$33(ownerState);
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [RootSlot, rootSlotProps] = useSlot("root", {
		ref,
		elementType: ListItemRoot,
		externalForwardedProps: {
			component: componentProp,
			...externalForwardedProps,
			...other
		},
		ownerState,
		className: clsx(classes.root, className)
	});
	const [SecondaryActionSlot, secondaryActionSlotProps] = useSlot("secondaryAction", {
		elementType: StyledListItemSecondaryAction,
		shouldForwardComponentProp: true,
		externalForwardedProps,
		ownerState,
		className: classes.secondaryAction
	});
	return /*#__PURE__*/ jsx(ListContext.Provider, {
		value: childContext,
		children: /*#__PURE__*/ jsxs(RootSlot, {
			...rootSlotProps,
			children: [childrenProp, secondaryAction && /*#__PURE__*/ jsx(SecondaryActionSlot, {
				...secondaryActionSlotProps,
				children: secondaryAction
			})]
		})
	});
});
ListItem.propTypes = {
	/**
	* Defines the `align-items` style property.
	* @default 'center'
	*/
	alignItems: import_prop_types.default.oneOf(["center", "flex-start"]),
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, compact vertical padding designed for keyboard and mouse input is used.
	* The prop defaults to the value inherited from the parent List component.
	* @default false
	*/
	dense: import_prop_types.default.bool,
	/**
	* If `true`, the left and right padding is removed.
	* @default false
	*/
	disableGutters: import_prop_types.default.bool,
	/**
	* If `true`, all padding is removed.
	* @default false
	*/
	disablePadding: import_prop_types.default.bool,
	/**
	* If `true`, a 1px light border is added to the bottom of the list item.
	* @default false
	*/
	divider: import_prop_types.default.bool,
	/**
	* The element to display at the end of ListItem.
	*/
	secondaryAction: import_prop_types.default.node,
	/**
	* The extra props for the slot components.
	* You can override the existing props or add new ones.
	*
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		secondaryAction: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	*
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		root: import_prop_types.default.elementType,
		secondaryAction: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ListItemIcon/listItemIconClasses.mjs
function getListItemIconUtilityClass(slot) {
	return generateUtilityClass("MuiListItemIcon", slot);
}
const listItemIconClasses = generateUtilityClasses("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ListItemIcon/ListItemIcon.mjs
const useUtilityClasses$32 = (ownerState) => {
	const { alignItems, classes } = ownerState;
	return composeClasses({ root: ["root", alignItems === "flex-start" && "alignItemsFlexStart"] }, getListItemIconUtilityClass, classes);
};
const ListItemIconRoot = styled$2("div", {
	name: "MuiListItemIcon",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart];
	}
})(memoTheme(({ theme }) => ({
	minWidth: theme.spacing(4.5),
	color: (theme.vars || theme).palette.action.active,
	flexShrink: 0,
	display: "inline-flex",
	variants: [{
		props: { alignItems: "flex-start" },
		style: { marginTop: 8 }
	}]
})));
/**
* A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
*/
const ListItemIcon = /*#__PURE__*/ React$1.forwardRef(function ListItemIcon(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiListItemIcon"
	});
	const { className, ...other } = props;
	const context = React$1.useContext(ListContext);
	const ownerState = {
		...props,
		alignItems: context.alignItems
	};
	const classes = useUtilityClasses$32(ownerState);
	return /*#__PURE__*/ jsx(ListItemIconRoot, {
		className: clsx(classes.root, className),
		ownerState,
		ref,
		...other
	});
});
ListItemIcon.propTypes = {
	/**
	* The content of the component, normally `Icon`, `SvgIcon`,
	* or a `@mui/icons-material` SVG icon element.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ListItemText/listItemTextClasses.mjs
const listItemTextClasses = generateUtilityClasses("MuiListItemText", [
	"root",
	"multiline",
	"dense",
	"inset",
	"primary",
	"secondary"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useRovingTabIndex/RovingTabIndexContext.mjs
const RovingTabIndexContext = /*#__PURE__*/ React$1.createContext(void 0);
RovingTabIndexContext.displayName = "RovingTabIndexContext";
function useRovingTabIndexContext() {
	const context = React$1.useContext(RovingTabIndexContext);
	if (context === void 0) throw new Error("MUI: RovingTabIndexContext is missing. Roving tab index items must be placed within a roving tab index provider.");
	return context;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/fastObjectShallowCompare/fastObjectShallowCompare.mjs
const is = Object.is;
/**
* Fast shallow compare for plain objects.
* Returns `true` when both objects have the same own enumerable keys and each value is equal
* according to `Object.is()`.
*/
function fastObjectShallowCompare(a, b) {
	if (a === b) return true;
	if (!(a instanceof Object) || !(b instanceof Object)) return false;
	let aLength = 0;
	let bLength = 0;
	for (const key in a) {
		aLength += 1;
		if (!is(a[key], b[key])) return false;
		if (!(key in b)) return false;
	}
	for (const _ in b) bLength += 1;
	return aLength === bLength;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+utils@9.4.0_@types+react@18.3.31_react@18.3.1/node_modules/@mui/utils/useRovingTabIndex/useRovingTabIndex.mjs
const SUPPORTED_KEYS = [
	"ArrowRight",
	"ArrowLeft",
	"ArrowUp",
	"ArrowDown",
	"Home",
	"End"
];
/**
* Provides roving tab index behavior for a composite container and its focusable children.
* This is useful for implementing keyboard navigation in components like menus, tabs, and lists.
* The hook manages the focus state of child elements and provides props to be spread on both the container and the items.
* The container will handle keyboard events to move focus between items based on the specified orientation and wrapping behavior.
*/
function useRovingTabIndexRoot(params) {
	const { activeItemId: activeItemIdProp, getDefaultActiveItemId, orientation, isRtl = false, isItemFocusable: itemFilter = isItemFocusable, wrap = true } = params;
	const [activeItemIdState, setActiveItemIdState] = React$1.useState(activeItemIdProp);
	const [previousActiveItemIdProp, setPreviousActiveItemIdProp] = React$1.useState(activeItemIdProp);
	let activeItemIdCandidate = activeItemIdState;
	if (activeItemIdProp !== previousActiveItemIdProp) {
		setPreviousActiveItemIdProp(activeItemIdProp);
		if (activeItemIdProp !== void 0 && activeItemIdProp !== activeItemIdState) {
			activeItemIdCandidate = activeItemIdProp;
			setActiveItemIdState(activeItemIdProp);
		}
	}
	const containerRef = React$1.useRef(null);
	const itemMapRef = React$1.useRef(/* @__PURE__ */ new Map());
	const [mapTick, setMapTick] = React$1.useState(0);
	const orderedItems = React$1.useMemo(() => {
		return getOrderedItems(itemMapRef.current);
	}, [mapTick]);
	const resolvedActiveItemId = resolveActiveItemId(activeItemIdCandidate, orderedItems, itemFilter, getDefaultActiveItemId);
	const activeItemIdRef = React$1.useRef(resolvedActiveItemId);
	activeItemIdRef.current = resolvedActiveItemId;
	const getActiveItem = React$1.useCallback(() => {
		const snapshot = getOrderedItems(itemMapRef.current);
		return getItemById(snapshot, resolveActiveItemId(activeItemIdRef.current, snapshot, itemFilter, getDefaultActiveItemId));
	}, [getDefaultActiveItemId, itemFilter]);
	const getItemMap = React$1.useCallback(() => {
		return itemMapRef.current;
	}, []);
	const registerItem = useEventCallback((item) => {
		if (fastObjectShallowCompare(itemMapRef.current.get(item.id) ?? null, item)) return;
		itemMapRef.current.set(item.id, item);
		setMapTick((value) => value + 1);
	});
	const unregisterItem = useEventCallback((itemId) => {
		if (itemMapRef.current.delete(itemId)) setMapTick((value) => value + 1);
	});
	const setActiveItemId = useEventCallback((itemId) => {
		setActiveItemIdState(itemId);
	});
	const isItemActive = React$1.useCallback((itemId) => {
		return activeItemIdRef.current === itemId;
	}, []);
	const focusItem = React$1.useCallback((currentIndex, direction, wrap, isItemFocusableOverride) => {
		const nextItem = getNextActiveItem(getNavigableItemsSnapshot(itemMapRef.current), currentIndex, direction, wrap, isItemFocusableOverride ?? itemFilter);
		if (!nextItem) return null;
		nextItem.element?.focus();
		setActiveItemIdState(nextItem.id);
		return nextItem;
	}, [itemFilter]);
	const getContainerProps = React$1.useCallback((ref, onFocusProp, onKeyDownProp) => {
		const onFocus = (event) => {
			onFocusProp?.(event);
			const snapshot = getNavigableItemsSnapshot(itemMapRef.current);
			const focusedIndex = findItemIndexByElement(snapshot, event.target);
			if (focusedIndex !== -1) setActiveItemIdState(snapshot[focusedIndex].id);
		};
		const onKeyDown = (event) => {
			onKeyDownProp?.(event);
			if (event.defaultPrevented || event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
			if (!SUPPORTED_KEYS.includes(event.key)) return;
			let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
			let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
			if (orientation === "horizontal" && isRtl) {
				previousItemKey = "ArrowRight";
				nextItemKey = "ArrowLeft";
			}
			const snapshot = getNavigableItemsSnapshot(itemMapRef.current);
			const currentFocus = activeElement(ownerDocument(containerRef.current));
			const isFocusOnContainer = currentFocus === containerRef.current;
			let currentIndex = getCurrentActiveItemIndex(snapshot, currentFocus, activeItemIdRef.current);
			let direction = "next";
			switch (event.key) {
				case previousItemKey:
					direction = "previous";
					event.preventDefault();
					if (isFocusOnContainer) currentIndex = snapshot.length;
					break;
				case nextItemKey:
					event.preventDefault();
					if (isFocusOnContainer) currentIndex = -1;
					break;
				case "Home":
					event.preventDefault();
					currentIndex = -1;
					break;
				case "End":
					event.preventDefault();
					direction = "previous";
					currentIndex = snapshot.length;
					break;
				default: return;
			}
			focusItem(currentIndex, direction, wrap);
		};
		return {
			onFocus,
			onKeyDown,
			ref: handleRefs(ref, (elementNode) => {
				containerRef.current = elementNode;
			})
		};
	}, [
		focusItem,
		isRtl,
		orientation,
		wrap
	]);
	const focusNext = React$1.useCallback((isItemFocusableOverride) => {
		const snapshot = getNavigableItemsSnapshot(itemMapRef.current);
		const currentFocus = activeElement(ownerDocument(containerRef.current));
		const currentIndex = currentFocus === containerRef.current ? -1 : getCurrentActiveItemIndex(snapshot, currentFocus, activeItemIdRef.current);
		return focusItem(currentIndex, "next", true, isItemFocusableOverride)?.id ?? null;
	}, [focusItem]);
	return React$1.useMemo(() => ({
		activeItemId: resolvedActiveItemId,
		focusNext,
		getActiveItem,
		getContainerProps,
		getItemMap,
		isItemActive,
		registerItem,
		setActiveItemId,
		unregisterItem
	}), [
		resolvedActiveItemId,
		focusNext,
		getActiveItem,
		getContainerProps,
		getItemMap,
		isItemActive,
		registerItem,
		setActiveItemId,
		unregisterItem
	]);
}
function useRovingTabIndexItem(params) {
	const { activeItemId, registerItem, unregisterItem } = useRovingTabIndexContext();
	const elementRef = React$1.useRef(null);
	const item = React$1.useMemo(() => ({
		disabled: params.disabled ?? false,
		element: null,
		focusableWhenDisabled: params.focusableWhenDisabled ?? false,
		id: params.id,
		selected: params.selected ?? false,
		textValue: params.textValue
	}), [
		params.disabled,
		params.focusableWhenDisabled,
		params.id,
		params.selected,
		params.textValue
	]);
	const latestItemRef = React$1.useRef(item);
	latestItemRef.current = item;
	const handleElementRef = React$1.useCallback((element) => {
		elementRef.current = element;
		if (element == null) {
			queueMicrotask(() => {
				if (elementRef.current == null) unregisterItem(params.id);
			});
			return;
		}
		registerItem({
			...latestItemRef.current,
			element
		});
	}, [
		params.id,
		registerItem,
		unregisterItem
	]);
	const mergedRef = useForkRef(params.ref, handleElementRef);
	useEnhancedEffect(() => {
		if (!elementRef.current) return;
		registerItem({
			...item,
			element: elementRef.current
		});
	}, [item, registerItem]);
	useEnhancedEffect(() => {
		const itemId = params.id;
		return () => {
			unregisterItem(itemId);
		};
	}, [params.id, unregisterItem]);
	return {
		ref: mergedRef,
		tabIndex: activeItemId === params.id ? 0 : -1
	};
}
/**
* Resolves which item id should own the roving tab stop for the current render.
*
* This is the top-level decision point for "who gets `tabIndex=0` right now?".
* For example:
* - `Tabs` sometimes passes `selectedValue` as `activeItemId` so the selected tab becomes
*   the tab stop when focus enters the list from outside.
* - `MenuList` leaves `activeItemId` undefined and relies on the default-item logic below
*   so that menu-specific rules decide which menu item should initially own the tab stop.
*
* @param activeItemId The item id supplied through the root hook's `activeItemId` option.
*   `undefined` means "the caller did not ask for a specific item, use the default-item
*   logic instead". `null` means "there is intentionally no preferred item, so also fall
*   back to the default-item logic".
* @param items The ordered registered items currently in the roving set.
* @param isFocusable A predicate that decides whether an item may receive roving focus.
* @param getDefaultActiveItemId Optional caller-provided function that picks the preferred
*   default item when `activeItemId` is not driving the tab stop directly.
* @returns The id of the item that should own `tabIndex=0`, or `null` if no item is focusable.
*/
function resolveActiveItemId(activeItemId, items, isFocusable, getDefaultActiveItemId) {
	if (activeItemId != null) return resolveRequestedItemId(activeItemId, items, isFocusable);
	return resolveDefaultItemId(items, isFocusable, getDefaultActiveItemId);
}
/**
* Resolves the item id supplied through the root hook's `activeItemId` option.
*
* This path is used when a component such as `Tabs` or `MenuList` wants roving focus to
* follow a specific logical item. For example, `Tabs` can pass the selected tab's value as
* `activeItemId` so that the selected tab owns `tabIndex=0` when focus enters the list.
*
* @param requestedItemId The item id passed to the root hook's `activeItemId` option.
* @param items The ordered registered items currently in the roving set.
* @param isFocusable A predicate that decides whether an item may receive roving focus.
* @returns The same id when it still points to a focusable item. If that id no longer exists,
*   returns the first focusable item. If the id still exists but the item is not focusable,
*   returns the next focusable item after it without wrapping.
*/
function resolveRequestedItemId(requestedItemId, items, isFocusable) {
	const requestedItemIndex = findItemIndexById(items, requestedItemId);
	if (requestedItemIndex === -1) return getFirstFocusableItemId(items, isFocusable);
	if (isFocusable(items[requestedItemIndex])) return items[requestedItemIndex].id;
	return getNextActiveItem(items, requestedItemIndex, "next", false, isFocusable)?.id ?? null;
}
/**
* Resolves the default active item when the caller is not driving roving focus with
* `activeItemId`.
*
* This path is used on the initial render and whenever the caller leaves the choice of tab
* stop to the hook. `getDefaultActiveItemId` lets a component prefer a specific logical item
* before falling back to the first focusable item.
*
* For example:
* - `MenuList` uses this path all the time. When `variant="selectedMenu"`, it prefers the
*   selected menu item; otherwise it prefers the first focusable menu item.
* - `Tabs` uses this path while focus is already inside the tab list, because at that point
*   the current roving position should be driven by actual focus movement rather than by the
*   selected tab value.
*
* @param items The ordered registered items currently in the roving set.
* @param isFocusable A predicate that decides whether an item may receive roving focus.
* @param getDefaultActiveItemId Optional caller-provided function that chooses which item
*   should own the tab stop before the generic "first focusable item" fallback runs.
* @returns The default item id when it points to a focusable item, otherwise the first
*   focusable item in the snapshot, or `null` when none are focusable.
*/
function resolveDefaultItemId(items, isFocusable, getDefaultActiveItemId) {
	const defaultItemId = getDefaultActiveItemId?.(items);
	if (defaultItemId != null) {
		const defaultItem = getItemById(items, defaultItemId);
		if (defaultItem && isFocusable(defaultItem)) return defaultItem.id;
	}
	return getFirstFocusableItemId(items, isFocusable);
}
/**
* Finds the best starting index for keyboard navigation.
*
* This is used immediately before keyboard navigation and `focusNext()` navigation. It prefers
* the item that currently holds DOM focus, but if focus is on the container or outside the item
* set it falls back to the last known active item id.
*
* @param items The navigable item snapshot used for the current keyboard interaction.
* @param currentFocus The element that currently has DOM focus, if any.
* @param fallbackActiveItemId The last known active item id when focus is not on an item.
* @returns The focused item's index when focus is currently on an item. Otherwise, the index
*   of the fallback active item id, or `-1` when no matching item exists.
*/
function getCurrentActiveItemIndex(items, currentFocus, fallbackActiveItemId) {
	if (currentFocus) {
		const focusedIndex = findItemIndexByElement(items, currentFocus);
		if (focusedIndex !== -1) return focusedIndex;
	}
	return findItemIndexById(items, fallbackActiveItemId);
}
/**
* Walks the item snapshot to find the next focusable item in the requested direction.
*
* This is the shared navigation primitive used by keyboard handling and imperative helpers
* such as `focusNext()`. It starts from the supplied index, advances through the snapshot in
* the requested direction, and skips over items that fail the `isFocusable` predicate.
*
* @param items The ordered navigable item snapshot.
* @param currentIndex The index to start from. Use `-1` to start before the first item or
*   `items.length` to start after the last item.
* @param direction The direction to move through the snapshot.
* @param wrap Whether navigation should wrap around at the ends of the list.
* @param isFocusable A predicate that decides whether an item may receive roving focus.
* @returns The next focusable item record, or `null` when no focusable item can be reached.
*/
function getNextActiveItem(items, currentIndex, direction, wrap, isFocusable) {
	const lastIndex = items.length - 1;
	if (lastIndex === -1) return null;
	let wrappedOnce = false;
	let nextIndex = getNextIndex(currentIndex, lastIndex, direction, wrap);
	const startIndex = nextIndex;
	while (nextIndex !== -1) {
		if (nextIndex === startIndex) {
			if (wrappedOnce) return null;
			wrappedOnce = true;
		}
		const nextItem = items[nextIndex];
		if (!nextItem || !isFocusable(nextItem)) nextIndex = getNextIndex(nextIndex, lastIndex, direction, wrap);
		else return nextItem;
	}
	return null;
}
function getFirstFocusableItemId(items, isFocusable) {
	return items.find((item) => isFocusable(item))?.id ?? null;
}
function getItemById(items, itemId) {
	return itemId == null ? null : items.find((item) => item.id === itemId) ?? null;
}
function findItemIndexById(items, itemId) {
	return itemId == null ? -1 : items.findIndex((item) => item.id === itemId);
}
function findItemIndexByElement(items, element) {
	if (!element) return -1;
	return items.findIndex((item) => item.element === element || item.element?.contains(element));
}
function getOrderedItems(itemMap) {
	const items = Array.from(itemMap.values());
	if (items.every((item) => item.element == null)) return items;
	const connectedItems = items.filter(isConnectedItem).sort((itemA, itemB) => sortByDocumentPosition(itemA.element, itemB.element));
	const disconnectedItems = items.filter((item) => !isConnectedItem(item));
	return [...connectedItems, ...disconnectedItems];
}
function getNavigableItemsSnapshot(itemMap) {
	return getOrderedItems(itemMap).filter(isConnectedItem);
}
function getNextIndex(currentIndex, lastIndex, direction, wrap = true) {
	if (direction === "next") {
		if (currentIndex === lastIndex) return wrap ? 0 : -1;
		return currentIndex + 1;
	}
	if (currentIndex === 0) return wrap ? lastIndex : -1;
	return currentIndex - 1;
}
function isItemFocusable(item) {
	if (!item.element) return false;
	if (item.focusableWhenDisabled) return true;
	return !item.disabled && !item.element.hasAttribute("disabled") && item.element.getAttribute("aria-disabled") !== "true" && item.element.hasAttribute("tabindex");
}
function isConnectedItem(item) {
	return item.element != null && item.element.isConnected;
}
function sortByDocumentPosition(a, b) {
	if (a === b) return 0;
	const position = a.compareDocumentPosition(b);
	if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
	if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
	return 0;
}
function handleRefs(...refs) {
	return (node) => {
		refs.forEach((ref) => {
			setRef(ref ?? null, node);
		});
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/getScrollbarSize.mjs
var getScrollbarSize_default = getScrollbarSize;
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/utils/focusWithVisible.mjs
/**
* If `focusSource` is present, attempt to pass `focusVisible` through `focus()` options.
* Fall back to a plain focus call when the browser does not support it.
*/
function focusWithVisible(element, focusSource) {
	if (focusSource == null) {
		element.focus();
		return;
	}
	try {
		element.focus({ focusVisible: focusSource === "keyboard" });
	} catch (error) {
		element.focus();
	}
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Select/utils/getOpenInteractionType.mjs
function getOpenInteractionType(event) {
	if (!event) return null;
	if (event.type === "mousedown" || event.type === "pointerdown" || event.type === "touchstart") return "pointer";
	if (event.type === "keydown" || event.type === "click" && event.detail === 0) return "keyboard";
	return null;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Select/utils/isEmpty.mjs
function isEmpty(display) {
	return display == null || typeof display === "string" && !display.trim();
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Select/utils/areEqualValues.mjs
function areEqualValues$1(a, b) {
	if (typeof b === "object" && b !== null) return a === b;
	return String(a) === String(b);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Select/utils/SelectFocusSourceContext.mjs
const SelectFocusSourceContext = /*#__PURE__*/ React$1.createContext(null);
SelectFocusSourceContext.displayName = "SelectFocusSourceContext";
function useSelectFocusSource() {
	return React$1.useContext(SelectFocusSourceContext);
}
const SelectFocusSourceProvider = SelectFocusSourceContext.Provider;
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/MenuList/MenuListContext.mjs
/**
* @ignore - internal component.
*/
const MenuListContext = /*#__PURE__*/ React$1.createContext(void 0);
MenuListContext.displayName = "MenuListContext";
function useMenuListContext() {
	const context = React$1.useContext(MenuListContext);
	if (context === void 0) throw new Error("MUI: MenuListContext is missing. MenuItems must be placed within Menu or MenuList.");
	return context;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/MenuList/MenuList.mjs
function getItemText(itemOrElement) {
	const element = itemOrElement?.element ?? itemOrElement;
	if (!element) return "";
	if (itemOrElement?.textValue !== void 0) return itemOrElement.textValue;
	let text = element.innerText;
	if (text === void 0) text = element.textContent;
	return text ?? "";
}
function textCriteriaMatches(itemOrElement, textCriteria) {
	if (textCriteria === void 0) return true;
	let text = getItemText(itemOrElement);
	text = text.trim().toLowerCase();
	if (text.length === 0) return false;
	if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
	return text.startsWith(textCriteria.keys.join(""));
}
function isItemFocusableWithTextCriteria(item, criteria) {
	if (!textCriteriaMatches(item, criteria)) return false;
	return isItemFocusable(item);
}
function focusInitialItem(element, focusSource) {
	focusWithVisible(element, focusSource);
}
/**
* A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
* It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
* use it separately you need to move focus into the component manually. Once
* the focus is placed inside the component it is fully keyboard accessible.
*/
const MenuList = /*#__PURE__*/ React$1.forwardRef(function MenuList(props, ref) {
	const { actions, autoFocus: autoFocusList = false, autoFocusItem: autoFocusActiveItem = false, children, className, disabledItemsFocusable = false, disableListWrap = false, onKeyDown, variant = "selectedMenu", ...other } = props;
	const listRef = React$1.useRef(null);
	const hasFocusedInitialTargetRef = React$1.useRef(false);
	const [suppressInitialFocusVisible, setSuppressInitialFocusVisible] = React$1.useState(false);
	const focusSource = useSelectFocusSource();
	const textCriteriaRef = React$1.useRef({
		keys: [],
		repeating: true,
		previousKeyMatched: true,
		lastTime: null
	});
	const rovingContainer = useRovingTabIndexRoot({
		activeItemId: void 0,
		getDefaultActiveItemId: React$1.useCallback((items) => {
			if (variant === "selectedMenu") return items.find((item) => item.selected && isItemFocusable(item))?.id ?? items.find((item) => isItemFocusable(item))?.id ?? null;
			return items.find((item) => isItemFocusable(item))?.id ?? null;
		}, [variant]),
		orientation: "vertical",
		wrap: !disableListWrap
	});
	const { activeItemId, focusNext, getActiveItem, getContainerProps, getItemMap } = rovingContainer;
	const focusInitialTarget = useEventCallback_default((force = false) => {
		if (!listRef.current || !force && hasFocusedInitialTargetRef.current) return null;
		if (autoFocusActiveItem) {
			const activeItem = getActiveItem();
			if (activeItem?.element) {
				const hasSelectedItem = Array.from(getItemMap().values()).some((item) => item.selected);
				const shouldSuppressInitialFocusVisible = variant === "menu" && hasSelectedItem && !activeItem.selected && focusSource == null;
				setSuppressInitialFocusVisible(shouldSuppressInitialFocusVisible);
				focusInitialItem(activeItem.element, focusSource);
				hasFocusedInitialTargetRef.current = true;
				return activeItem.element;
			}
			if (!autoFocusList) return null;
			setSuppressInitialFocusVisible(false);
			listRef.current.focus();
			return listRef.current;
		}
		if (!autoFocusList) {
			setSuppressInitialFocusVisible(false);
			return null;
		}
		setSuppressInitialFocusVisible(false);
		listRef.current.focus();
		hasFocusedInitialTargetRef.current = true;
		return listRef.current;
	});
	useEnhancedEffect_default(() => {
		if (!autoFocusList && !autoFocusActiveItem) {
			hasFocusedInitialTargetRef.current = false;
			setSuppressInitialFocusVisible(false);
			return;
		}
		focusInitialTarget();
	}, [
		activeItemId,
		autoFocusActiveItem,
		autoFocusList,
		focusInitialTarget
	]);
	React$1.useImperativeHandle(actions, () => ({
		adjustStyleForScrollbar: (containerElement, { direction }) => {
			const noExplicitWidth = !listRef.current.style.width;
			if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
				const win = ownerWindow_default(containerElement);
				const scrollbarSize = getScrollbarSize_default(win);
				if (scrollbarSize > 0) {
					const scrollbarSizePx = `${scrollbarSize}px`;
					const paddingKey = direction === "rtl" ? "paddingLeft" : "paddingRight";
					const existingPadding = parseFloat(win.getComputedStyle(listRef.current)[paddingKey]) || 0;
					listRef.current.style[paddingKey] = `${existingPadding + scrollbarSize}px`;
					listRef.current.style.width = `calc(100% + ${scrollbarSizePx})`;
				}
			}
			return listRef.current;
		},
		focusInitialTarget: () => {
			if (!listRef.current) return null;
			const currentFocus = getActiveElement_default(ownerDocument_default(listRef.current));
			if (currentFocus && contains_default(listRef.current, currentFocus)) return currentFocus;
			return focusInitialTarget(true);
		}
	}), [focusInitialTarget]);
	const rovingContainerProps = getContainerProps(void 0, other.onFocus);
	const handleRef = useForkRef_default(listRef, rovingContainerProps.ref, ref);
	const menuListContextValue = React$1.useMemo(() => ({
		itemsFocusableWhenDisabled: disabledItemsFocusable,
		suppressInitialFocusVisible,
		variant
	}), [
		disabledItemsFocusable,
		suppressInitialFocusVisible,
		variant
	]);
	const handleKeyDown = useEventCallback_default((event) => {
		if (suppressInitialFocusVisible) setSuppressInitialFocusVisible(false);
		if ((event.ctrlKey || event.metaKey || event.altKey) && onKeyDown) {
			onKeyDown(event);
			return;
		}
		rovingContainerProps.onKeyDown(event);
		if (event.key.length === 1) {
			const criteria = textCriteriaRef.current;
			const lowerKey = event.key.toLowerCase();
			const currTime = performance.now();
			if (criteria.keys.length > 0) {
				if (currTime - criteria.lastTime > 500) {
					criteria.keys = [];
					criteria.repeating = true;
					criteria.previousKeyMatched = true;
				} else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
			}
			criteria.lastTime = currTime;
			criteria.keys.push(lowerKey);
			const currentFocus = getActiveElement_default(ownerDocument_default(listRef.current));
			const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
			if (criteria.previousKeyMatched && (keepFocusOnCurrent || focusNext((item) => isItemFocusableWithTextCriteria(item, criteria)) != null)) event.preventDefault();
			else criteria.previousKeyMatched = false;
		}
		if (onKeyDown) onKeyDown(event);
	});
	return /*#__PURE__*/ jsx(List$1, {
		role: "menu",
		ref: handleRef,
		className,
		onKeyDown: handleKeyDown,
		tabIndex: -1,
		...other,
		onFocus: rovingContainerProps.onFocus,
		children: /*#__PURE__*/ jsx(MenuListContext.Provider, {
			value: menuListContextValue,
			children: /*#__PURE__*/ jsx(RovingTabIndexContext.Provider, {
				value: rovingContainer,
				children
			})
		})
	});
});
MenuList.propTypes = {
	/**
	* If `true`, will focus the `[role="menu"]` container and move into tab order.
	* @default false
	*/
	autoFocus: import_prop_types.default.bool,
	/**
	* If `true`, will focus the first menuitem if `variant="menu"` or selected item
	* if `variant="selectedMenu"`.
	* @default false
	*/
	autoFocusItem: import_prop_types.default.bool,
	/**
	* MenuList contents, normally `MenuItem`s.
	*/
	children: import_prop_types.default.node,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* If `true`, will allow focus on disabled items.
	* @default false
	*/
	disabledItemsFocusable: import_prop_types.default.bool,
	/**
	* If `true`, the menu items will not wrap focus.
	* @default false
	*/
	disableListWrap: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	onFocus: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onKeyDown: import_prop_types.default.func,
	/**
	* The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	* and the vertical alignment relative to the anchor element.
	* @default 'selectedMenu'
	*/
	variant: import_prop_types.default.oneOf(["menu", "selectedMenu"])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Popover/popoverClasses.mjs
function getPopoverUtilityClass(slot) {
	return generateUtilityClass("MuiPopover", slot);
}
const popoverClasses = generateUtilityClasses("MuiPopover", ["root", "paper"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Popover/Popover.mjs
function getOffsetTop(rect, vertical) {
	let offset = 0;
	if (typeof vertical === "number") offset = vertical;
	else if (vertical === "center") offset = rect.height / 2;
	else if (vertical === "bottom") offset = rect.height;
	return offset;
}
function getOffsetLeft(rect, horizontal) {
	let offset = 0;
	if (typeof horizontal === "number") offset = horizontal;
	else if (horizontal === "center") offset = rect.width / 2;
	else if (horizontal === "right") offset = rect.width;
	return offset;
}
function getTransformOriginValue(transformOrigin) {
	return [transformOrigin.horizontal, transformOrigin.vertical].map((n) => typeof n === "number" ? `${n}px` : n).join(" ");
}
function resolveAnchorEl(anchorEl) {
	return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const useUtilityClasses$31 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({
		root: ["root"],
		paper: ["paper"]
	}, getPopoverUtilityClass, classes);
};
const PopoverRoot = styled$2(Modal, {
	name: "MuiPopover",
	slot: "Root"
})({});
const PopoverPaper = styled$2(Paper, {
	name: "MuiPopover",
	slot: "Paper"
})({
	position: "absolute",
	overflowY: "auto",
	overflowX: "hidden",
	minWidth: 16,
	minHeight: 16,
	maxWidth: "calc(100% - 32px)",
	maxHeight: "calc(100% - 32px)",
	outline: 0
});
const Popover$1 = /*#__PURE__*/ React$1.forwardRef(function Popover(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiPopover"
	});
	const { action, anchorEl, anchorOrigin = {
		vertical: "top",
		horizontal: "left"
	}, anchorPosition, anchorReference = "anchorEl", children, className, container: containerProp, disableAutoFocus = false, elevation = 8, marginThreshold = 16, open, slots = {}, slotProps = {}, transformOrigin = {
		vertical: "top",
		horizontal: "left"
	}, transitionDuration: transitionDurationProp = "auto", disableScrollLock = false, ...other } = props;
	const paperRef = React$1.useRef();
	const ownerState = {
		...props,
		anchorOrigin,
		anchorReference,
		elevation,
		marginThreshold,
		transformOrigin,
		transitionDuration: transitionDurationProp
	};
	const classes = useUtilityClasses$31(ownerState);
	const getAnchorOffset = React$1.useCallback(() => {
		if (anchorReference === "anchorPosition") {
			if (!anchorPosition) console.error("MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference=\"anchorPosition\" />.");
			return anchorPosition;
		}
		const resolvedAnchorEl = resolveAnchorEl(anchorEl);
		const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : ownerDocument_default(paperRef.current).body;
		const anchorRect = anchorElement.getBoundingClientRect();
		{
			const box = anchorElement.getBoundingClientRect();
			if (isLayoutSupported() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) console.warn([
				"MUI: The `anchorEl` prop provided to the component is invalid.",
				"The anchor element should be part of the document layout.",
				"Make sure the element is present in the document or that it's not display none."
			].join("\n"));
		}
		return {
			top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
			left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
		};
	}, [
		anchorEl,
		anchorOrigin.horizontal,
		anchorOrigin.vertical,
		anchorPosition,
		anchorReference
	]);
	const getTransformOrigin = React$1.useCallback((elemRect) => {
		return {
			vertical: getOffsetTop(elemRect, transformOrigin.vertical),
			horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
		};
	}, [transformOrigin.horizontal, transformOrigin.vertical]);
	const getPositioningStyle = React$1.useCallback((element) => {
		const elemRect = {
			width: element.offsetWidth,
			height: element.offsetHeight
		};
		const elemTransformOrigin = getTransformOrigin(elemRect);
		if (anchorReference === "none") return {
			top: null,
			left: null,
			transformOrigin: getTransformOriginValue(elemTransformOrigin)
		};
		const anchorOffset = getAnchorOffset();
		let top = anchorOffset.top - elemTransformOrigin.vertical;
		let left = anchorOffset.left - elemTransformOrigin.horizontal;
		const bottom = top + elemRect.height;
		const right = left + elemRect.width;
		const containerWindow = ownerWindow_default(resolveAnchorEl(anchorEl));
		const heightThreshold = containerWindow.innerHeight - marginThreshold;
		const widthThreshold = containerWindow.innerWidth - marginThreshold;
		if (marginThreshold != null && top < marginThreshold) {
			const diff = top - marginThreshold;
			top -= diff;
			elemTransformOrigin.vertical += diff;
		} else if (marginThreshold != null && bottom > heightThreshold) {
			const diff = bottom - heightThreshold;
			top -= diff;
			elemTransformOrigin.vertical += diff;
		}
		if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) console.error([
			"MUI: The popover component is too tall.",
			`Some part of it can not be seen on the screen (${elemRect.height - heightThreshold}px).`,
			"Please consider adding a `max-height` to improve the user-experience."
		].join("\n"));
		if (marginThreshold != null && left < marginThreshold) {
			const diff = left - marginThreshold;
			left -= diff;
			elemTransformOrigin.horizontal += diff;
		} else if (right > widthThreshold) {
			const diff = right - widthThreshold;
			left -= diff;
			elemTransformOrigin.horizontal += diff;
		}
		return {
			top: `${Math.round(top)}px`,
			left: `${Math.round(left)}px`,
			transformOrigin: getTransformOriginValue(elemTransformOrigin)
		};
	}, [
		anchorEl,
		anchorReference,
		getAnchorOffset,
		getTransformOrigin,
		marginThreshold
	]);
	const [isPositioned, setIsPositioned] = React$1.useState(open);
	const setPositioningStyles = React$1.useCallback(() => {
		const element = paperRef.current;
		if (!element) return;
		const positioning = getPositioningStyle(element);
		if (positioning.top != null) element.style.setProperty("top", positioning.top);
		if (positioning.left != null) element.style.left = positioning.left;
		element.style.transformOrigin = positioning.transformOrigin;
		setIsPositioned(true);
	}, [getPositioningStyle]);
	React$1.useEffect(() => {
		if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
		return () => window.removeEventListener("scroll", setPositioningStyles);
	}, [
		anchorEl,
		disableScrollLock,
		setPositioningStyles
	]);
	const handleEntering = () => {
		setPositioningStyles();
	};
	const handleExited = () => {
		setIsPositioned(false);
	};
	React$1.useEffect(() => {
		if (open) setPositioningStyles();
	});
	React$1.useImperativeHandle(action, () => open ? { updatePosition: () => {
		setPositioningStyles();
	} } : null, [open, setPositioningStyles]);
	React$1.useEffect(() => {
		if (!open) return;
		const handleResize = debounce_default(() => {
			setPositioningStyles();
		});
		const containerWindow = ownerWindow_default(resolveAnchorEl(anchorEl));
		containerWindow.addEventListener("resize", handleResize);
		return () => {
			handleResize.clear();
			containerWindow.removeEventListener("resize", handleResize);
		};
	}, [
		anchorEl,
		open,
		setPositioningStyles
	]);
	let transitionDuration = transitionDurationProp;
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [TransitionSlot, transitionSlotProps] = useSlot("transition", {
		elementType: Grow,
		externalForwardedProps,
		ownerState,
		getSlotProps: (handlers) => ({
			...handlers,
			onEntering: (element, isAppearing) => {
				handlers.onEntering?.(element, isAppearing);
				handleEntering();
			},
			onExited: (element) => {
				handlers.onExited?.(element);
				handleExited();
			}
		}),
		additionalProps: {
			appear: true,
			in: open
		}
	});
	if (transitionDurationProp === "auto" && !TransitionSlot.muiSupportAuto) transitionDuration = void 0;
	const container = containerProp || (anchorEl ? ownerDocument_default(resolveAnchorEl(anchorEl)).body : void 0);
	const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = useSlot("root", {
		ref,
		elementType: PopoverRoot,
		externalForwardedProps: {
			...externalForwardedProps,
			...other
		},
		shouldForwardComponentProp: true,
		additionalProps: {
			slots: { backdrop: slots.backdrop },
			slotProps: { backdrop: mergeSlotProps$1(typeof slotProps.backdrop === "function" ? slotProps.backdrop(ownerState) : slotProps.backdrop, { invisible: true }) },
			container,
			open
		},
		ownerState,
		className: clsx(classes.root, className)
	});
	const [PaperSlot, paperProps] = useSlot("paper", {
		ref: paperRef,
		className: classes.paper,
		elementType: PopoverPaper,
		externalForwardedProps,
		shouldForwardComponentProp: true,
		additionalProps: {
			elevation,
			style: isPositioned ? void 0 : { opacity: 0 }
		},
		ownerState
	});
	return /*#__PURE__*/ jsx(RootSlot, {
		...rootProps,
		...!isHostComponent(RootSlot) && {
			slots: rootSlotsProp,
			slotProps: rootSlotPropsProp,
			disableAutoFocus,
			disableScrollLock
		},
		children: /*#__PURE__*/ jsx(TransitionSlot, {
			...transitionSlotProps,
			timeout: transitionDuration,
			children: /*#__PURE__*/ jsx(PaperSlot, {
				...paperProps,
				children
			})
		})
	});
});
Popover$1.propTypes = {
	/**
	* A ref for imperative actions.
	* It currently only supports updatePosition() action.
	*/
	action: refType,
	/**
	* An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
	* or a function that returns either.
	* It's used to set the position of the popover.
	*/
	anchorEl: chainPropTypes(import_prop_types.default.oneOfType([HTMLElementType, import_prop_types.default.func]), (props) => {
		if (props.open && (!props.anchorReference || props.anchorReference === "anchorEl")) {
			const resolvedAnchorEl = resolveAnchorEl(props.anchorEl);
			if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
				const box = resolvedAnchorEl.getBoundingClientRect();
				if (isLayoutSupported() && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
					"MUI: The `anchorEl` prop provided to the component is invalid.",
					"The anchor element should be part of the document layout.",
					"Make sure the element is present in the document or that it's not display none."
				].join("\n"));
			} else return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${resolvedAnchorEl}\` instead.`].join("\n"));
		}
		return null;
	}),
	/**
	* This is the point on the anchor where the popover's
	* `anchorEl` will attach to. This is not used when the
	* anchorReference is 'anchorPosition'.
	*
	* Options:
	* vertical: [top, center, bottom];
	* horizontal: [left, center, right].
	* @default {
	*   vertical: 'top',
	*   horizontal: 'left',
	* }
	*/
	anchorOrigin: import_prop_types.default.shape({
		horizontal: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
			"center",
			"left",
			"right"
		]), import_prop_types.default.number]).isRequired,
		vertical: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
			"bottom",
			"center",
			"top"
		]), import_prop_types.default.number]).isRequired
	}),
	/**
	* This is the position that may be used to set the position of the popover.
	* The coordinates are relative to the application's client area.
	*/
	anchorPosition: import_prop_types.default.shape({
		left: import_prop_types.default.number.isRequired,
		top: import_prop_types.default.number.isRequired
	}),
	/**
	* This determines which anchor prop to refer to when setting
	* the position of the popover.
	* @default 'anchorEl'
	*/
	anchorReference: import_prop_types.default.oneOf([
		"anchorEl",
		"anchorPosition",
		"none"
	]),
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* An HTML element, component instance, or function that returns either.
	* The `container` will passed to the Modal component.
	*
	* By default, it uses the body of the anchorEl's top-level document object,
	* so it's simply `document.body` most of the time.
	*/
	container: import_prop_types.default.oneOfType([HTMLElementType, import_prop_types.default.func]),
	/**
	* If `true`, the modal will not automatically shift focus to itself when it opens, and
	* replace it to the last focused element when it closes.
	* This also works correctly with any modal children that have the `disableAutoFocus` prop.
	*
	* Generally this should never be set to `true` as it makes the modal less
	* accessible to assistive technologies, like screen readers.
	* @default false
	*/
	disableAutoFocus: import_prop_types.default.bool,
	/**
	* Disable the scroll lock behavior.
	* @default false
	*/
	disableScrollLock: import_prop_types.default.bool,
	/**
	* The elevation of the popover.
	* @default 8
	*/
	elevation: integerPropType,
	/**
	* Specifies how close to the edge of the window the popover can appear.
	* If null, the popover will not be constrained by the window.
	* @default 16
	*/
	marginThreshold: import_prop_types.default.number,
	/**
	* Callback fired when the component requests to be closed.
	* The `reason` parameter can optionally be used to control the response to `onClose`.
	*/
	onClose: import_prop_types.default.func,
	/**
	* If `true`, the component is shown.
	*/
	open: import_prop_types.default.bool.isRequired,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		backdrop: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		paper: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		transition: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		backdrop: import_prop_types.default.elementType,
		paper: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType,
		transition: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* This is the point on the popover which
	* will attach to the anchor's origin.
	*
	* Options:
	* vertical: [top, center, bottom, x(px)];
	* horizontal: [left, center, right, x(px)].
	* @default {
	*   vertical: 'top',
	*   horizontal: 'left',
	* }
	*/
	transformOrigin: import_prop_types.default.shape({
		horizontal: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
			"center",
			"left",
			"right"
		]), import_prop_types.default.number]).isRequired,
		vertical: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
			"bottom",
			"center",
			"top"
		]), import_prop_types.default.number]).isRequired
	}),
	/**
	* Set to 'auto' to automatically calculate transition time based on height.
	* @default 'auto'
	*/
	transitionDuration: import_prop_types.default.oneOfType([
		import_prop_types.default.oneOf(["auto"]),
		import_prop_types.default.number,
		import_prop_types.default.shape({
			appear: import_prop_types.default.number,
			enter: import_prop_types.default.number,
			exit: import_prop_types.default.number
		})
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Menu/menuClasses.mjs
function getMenuUtilityClass(slot) {
	return generateUtilityClass("MuiMenu", slot);
}
const menuClasses = generateUtilityClasses("MuiMenu", [
	"root",
	"paper",
	"list"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Menu/Menu.mjs
const RTL_ORIGIN = {
	vertical: "top",
	horizontal: "right"
};
const LTR_ORIGIN = {
	vertical: "top",
	horizontal: "left"
};
const useUtilityClasses$30 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({
		root: ["root"],
		paper: ["paper"],
		list: ["list"]
	}, getMenuUtilityClass, classes);
};
const MenuRoot = styled$2(Popover$1, {
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
	name: "MuiMenu",
	slot: "Root"
})({});
const MenuPaper = styled$2(PopoverPaper, {
	name: "MuiMenu",
	slot: "Paper"
})({
	maxHeight: "calc(100% - 96px)",
	WebkitOverflowScrolling: "touch"
});
const MenuMenuList = styled$2(MenuList, {
	name: "MuiMenu",
	slot: "List"
})({ outline: 0 });
const Menu$1 = /*#__PURE__*/ React$1.forwardRef(function Menu(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiMenu"
	});
	const { autoFocus = true, children, className, disableAutoFocusItem = false, onClose, open, PopoverClasses, transitionDuration = "auto", variant = "selectedMenu", slots = {}, slotProps = {}, ...other } = props;
	const isRtl = useRtl();
	const ownerState = {
		...props,
		autoFocus,
		disableAutoFocusItem,
		transitionDuration,
		variant
	};
	const classes = useUtilityClasses$30(ownerState);
	const shouldManageInitialFocus = autoFocus && open;
	const shouldAutoFocusActiveItem = shouldManageInitialFocus && !disableAutoFocusItem;
	const menuListActionsRef = React$1.useRef(null);
	const handleEntering = (element, _isAppearing) => {
		if (menuListActionsRef.current) {
			menuListActionsRef.current.adjustStyleForScrollbar(element, { direction: isRtl ? "rtl" : "ltr" });
			if (shouldManageInitialFocus) menuListActionsRef.current.focusInitialTarget?.();
		}
	};
	const handleListKeyDown = (event) => {
		if (event.key === "Tab") {
			event.preventDefault();
			if (onClose) onClose(event, "tabKeyDown");
		}
	};
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const rootSlotProps = useSlotProps({
		elementType: slots.root,
		externalSlotProps: slotProps.root,
		ownerState,
		className: [classes.root, className]
	});
	const [PaperSlot, paperSlotProps] = useSlot("paper", {
		className: classes.paper,
		elementType: MenuPaper,
		externalForwardedProps,
		shouldForwardComponentProp: true,
		ownerState
	});
	const [ListSlot, listSlotProps] = useSlot("list", {
		className: classes.list,
		elementType: MenuMenuList,
		shouldForwardComponentProp: true,
		externalForwardedProps,
		getSlotProps: (handlers) => ({
			...handlers,
			onKeyDown: (event) => {
				handleListKeyDown(event);
				handlers.onKeyDown?.(event);
			}
		}),
		ownerState
	});
	const resolvedTransitionProps = typeof slotProps.transition === "function" ? slotProps.transition(ownerState) : slotProps.transition;
	return /*#__PURE__*/ jsx(MenuRoot, {
		disableAutoFocus: autoFocus,
		onClose,
		anchorOrigin: {
			vertical: "bottom",
			horizontal: isRtl ? "right" : "left"
		},
		transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
		slots: {
			root: slots.root,
			paper: PaperSlot,
			backdrop: slots.backdrop,
			transition: slots.transition
		},
		slotProps: {
			root: rootSlotProps,
			paper: paperSlotProps,
			backdrop: typeof slotProps.backdrop === "function" ? slotProps.backdrop(ownerState) : slotProps.backdrop,
			transition: {
				...resolvedTransitionProps,
				onEntering: (...args) => {
					handleEntering(...args);
					resolvedTransitionProps?.onEntering?.(...args);
				}
			}
		},
		open,
		ref,
		transitionDuration,
		ownerState,
		...other,
		classes: PopoverClasses,
		children: /*#__PURE__*/ jsx(ListSlot, {
			actions: menuListActionsRef,
			autoFocus: shouldManageInitialFocus,
			autoFocusItem: shouldAutoFocusActiveItem,
			variant,
			...listSlotProps,
			children
		})
	});
});
Menu$1.propTypes = {
	/**
	* An HTML element, or a function that returns one.
	* It's used to set the position of the menu.
	*/
	anchorEl: import_prop_types.default.oneOfType([HTMLElementType, import_prop_types.default.func]),
	/**
	* If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
	* children are not focusable. If you set this prop to `false` focus will be placed
	* on the parent modal container. This has severe accessibility implications
	* and should only be considered if you manage focus otherwise.
	* @default true
	*/
	autoFocus: import_prop_types.default.bool,
	/**
	* Menu contents, normally `MenuItem`s.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* When opening the menu will not focus the active item but the `[role="menu"]`
	* unless `autoFocus` is also set to `false`. Not using the default means not
	* following WAI-ARIA authoring practices. Please be considerate about possible
	* accessibility implications.
	* @default false
	*/
	disableAutoFocusItem: import_prop_types.default.bool,
	/**
	* Callback fired when the component requests to be closed.
	*
	* @param {object} event The event source of the callback.
	* @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
	*/
	onClose: import_prop_types.default.func,
	/**
	* If `true`, the component is shown.
	*/
	open: import_prop_types.default.bool.isRequired,
	/**
	* `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
	*/
	PopoverClasses: import_prop_types.default.object,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		backdrop: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		list: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		paper: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		transition: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		backdrop: import_prop_types.default.elementType,
		list: import_prop_types.default.elementType,
		paper: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType,
		transition: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The length of the transition in `ms`, or 'auto'
	* @default 'auto'
	*/
	transitionDuration: import_prop_types.default.oneOfType([
		import_prop_types.default.oneOf(["auto"]),
		import_prop_types.default.number,
		import_prop_types.default.shape({
			appear: import_prop_types.default.number,
			enter: import_prop_types.default.number,
			exit: import_prop_types.default.number
		})
	]),
	/**
	* The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
	* @default 'selectedMenu'
	*/
	variant: import_prop_types.default.oneOf(["menu", "selectedMenu"])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/MenuItem/MenuItem.mjs
const overridesResolver$1 = (props, styles) => {
	const { ownerState } = props;
	return [
		styles.root,
		ownerState.dense && styles.dense,
		ownerState.divider && styles.divider,
		!ownerState.disableGutters && styles.gutters
	];
};
const useUtilityClasses$29 = (ownerState) => {
	const { disabled, dense, divider, disableGutters, selected, classes } = ownerState;
	const composedClasses = composeClasses({ root: [
		"root",
		dense && "dense",
		disabled && "disabled",
		!disableGutters && "gutters",
		divider && "divider",
		selected && "selected"
	] }, getMenuItemUtilityClass, classes);
	return {
		...classes,
		...composedClasses
	};
};
const MenuItemRoot = styled$2(ButtonBase, {
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
	name: "MuiMenuItem",
	slot: "Root",
	overridesResolver: overridesResolver$1
})(memoTheme(({ theme }) => ({
	...theme.typography.body1,
	display: "flex",
	justifyContent: "flex-start",
	alignItems: "center",
	position: "relative",
	textDecoration: "none",
	minHeight: 48,
	paddingTop: 6,
	paddingBottom: 6,
	boxSizing: "border-box",
	whiteSpace: "nowrap",
	"&:hover": {
		textDecoration: "none",
		backgroundColor: (theme.vars || theme).palette.action.hover,
		"@media (hover: none)": { backgroundColor: "transparent" }
	},
	[`&.${menuItemClasses.selected}`]: {
		backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
		...!theme.focusVisible && { [`&.${menuItemClasses.focusVisible}`]: { backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`) } }
	},
	[`&.${menuItemClasses.selected}:hover`]: {
		backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
		"@media (hover: none)": { backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity) }
	},
	...theme.focusVisible ? applyInsetFocusVisible(1) : { [`&.${menuItemClasses.focusVisible}`]: { backgroundColor: (theme.vars || theme).palette.action.focus } },
	[`&.${menuItemClasses.disabled}`]: { opacity: (theme.vars || theme).palette.action.disabledOpacity },
	[`& + .${dividerClasses.root}`]: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1)
	},
	[`& + .${dividerClasses.inset}`]: { marginLeft: 52 },
	[`& .${listItemTextClasses.root}`]: {
		marginTop: 0,
		marginBottom: 0
	},
	[`& .${listItemTextClasses.inset}`]: { paddingLeft: 36 },
	[`& .${listItemIconClasses.root}`]: { minWidth: 36 },
	variants: [
		{
			props: ({ ownerState }) => !ownerState.disableGutters,
			style: {
				paddingLeft: 16,
				paddingRight: 16
			}
		},
		{
			props: ({ ownerState }) => ownerState.divider,
			style: {
				borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
				backgroundClip: "padding-box"
			}
		},
		{
			props: ({ ownerState }) => !ownerState.dense,
			style: { [theme.breakpoints.up("sm")]: { minHeight: "auto" } }
		},
		{
			props: ({ ownerState }) => ownerState.dense,
			style: {
				minHeight: 32,
				paddingTop: 4,
				paddingBottom: 4,
				...theme.typography.body2,
				[`& .${listItemIconClasses.root} svg`]: { fontSize: "1.25rem" }
			}
		}
	]
})));
const MenuItem$1 = /*#__PURE__*/ React$1.forwardRef(function MenuItem(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiMenuItem"
	});
	const { autoFocus: shouldAutoFocusOnMount = false, component = "li", dense = false, divider = false, disableGutters = false, focusVisibleClassName, role = "menuitem", tabIndex: tabIndexProp, className, ...other } = props;
	const ariaChecked = role === "menuitemcheckbox" || role === "menuitemradio" ? Boolean(props.selected) : void 0;
	const focusSource = useSelectFocusSource();
	const context = React$1.useContext(ListContext);
	const childContext = React$1.useMemo(() => ({
		dense: dense || context.dense || false,
		disableGutters
	}), [
		context.dense,
		dense,
		disableGutters
	]);
	const menuListContext = useMenuListContext();
	const rovingItemId = useId_default();
	const suppressFocusVisible = menuListContext.suppressInitialFocusVisible;
	const itemsFocusableWhenDisabled = menuListContext.itemsFocusableWhenDisabled;
	const menuItemRef = React$1.useRef(null);
	useEnhancedEffect_default(() => {
		if (shouldAutoFocusOnMount) {
			if (menuItemRef.current) focusWithVisible(menuItemRef.current, focusSource);
			else console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered.");
		}
	}, [shouldAutoFocusOnMount]);
	const ownerState = {
		...props,
		dense: childContext.dense,
		divider,
		disableGutters
	};
	const classes = useUtilityClasses$29(props);
	const { root, ...forwardedClasses } = classes;
	const rovingItemProps = useRovingTabIndexItem({
		id: rovingItemId,
		ref,
		disabled: props.disabled,
		focusableWhenDisabled: itemsFocusableWhenDisabled,
		selected: props.selected
	});
	const handleRef = useForkRef_default(menuItemRef, rovingItemProps.ref);
	let tabIndex;
	if (tabIndexProp !== void 0) tabIndex = tabIndexProp;
	else if (menuListContext.variant === "selectedMenu") tabIndex = rovingItemProps.tabIndex;
	else if (!props.disabled || itemsFocusableWhenDisabled) tabIndex = -1;
	return /*#__PURE__*/ jsx(ListContext.Provider, {
		value: childContext,
		children: /*#__PURE__*/ jsx(MenuItemRoot, {
			ref: handleRef,
			role,
			"aria-checked": ariaChecked,
			tabIndex,
			component,
			internalNativeButton: false,
			focusableWhenDisabled: itemsFocusableWhenDisabled,
			suppressFocusVisible,
			focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
			className: clsx(classes.root, className),
			...other,
			ownerState,
			classes: forwardedClasses
		})
	});
});
MenuItem$1.propTypes = {
	/**
	* If `true`, the list item is focused during the first mount.
	* Focus will also be triggered if the value changes from false to true.
	* @default false
	*/
	autoFocus: import_prop_types.default.bool,
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, compact vertical padding designed for keyboard and mouse input is used.
	* The prop defaults to the value inherited from the parent Menu component.
	* @default false
	*/
	dense: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the left and right padding is removed.
	* @default false
	*/
	disableGutters: import_prop_types.default.bool,
	/**
	* If `true`, a 1px light border is added to the bottom of the menu item.
	* @default false
	*/
	divider: import_prop_types.default.bool,
	/**
	* This prop can help identify which element has keyboard focus.
	* The class name will be applied when the element gains the focus through keyboard interaction.
	* It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	* The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
	* A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
	* if needed.
	*/
	focusVisibleClassName: import_prop_types.default.string,
	/**
	* @ignore
	*/
	role: import_prop_types.default.string,
	/**
	* If `true`, the component is selected.
	* For `menuitemcheckbox` and `menuitemradio` roles, this also drives `aria-checked`.
	* @default false
	*/
	selected: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* @default 0
	*/
	tabIndex: import_prop_types.default.number
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/NativeSelect/NativeSelectInput.mjs
const useUtilityClasses$28 = (ownerState) => {
	const { classes, variant, disabled, multiple, open, error } = ownerState;
	const slots = {
		select: [
			"select",
			variant,
			disabled && "disabled",
			multiple && "multiple",
			error && "error"
		],
		icon: [
			"icon",
			`icon${capitalize_default(variant)}`,
			open && "iconOpen",
			disabled && "disabled"
		]
	};
	return composeClasses(slots, getNativeSelectUtilityClasses, classes);
};
const StyledSelectSelect = styled$2("select", { name: "MuiNativeSelect" })(({ theme }) => ({
	MozAppearance: "none",
	WebkitAppearance: "none",
	userSelect: "none",
	borderRadius: 0,
	cursor: "pointer",
	"&:focus": { borderRadius: 0 },
	[`&.${nativeSelectClasses.disabled}`]: { cursor: "default" },
	"&[multiple]": { height: "auto" },
	"&:not([multiple]) option, &:not([multiple]) optgroup": { backgroundColor: (theme.vars || theme).palette.background.paper },
	[`& ~ .${inputAdornmentClasses.root}`]: {
		position: "absolute",
		top: "50%",
		transform: "translateY(-50%)",
		right: "calc(var(--_caret, 24px) + (var(--_endAdornment, 28px) - 1.5rem)/2)"
	},
	[`.${inputBaseClasses.root}:has(> &)`]: { "--_endAdornment": "0px" },
	variants: [
		{
			props: ({ ownerState }) => ownerState.variant !== "filled" && ownerState.variant !== "outlined",
			style: {
				[`.${inputBaseClasses.root}:has(> &)`]: { "--_caret": "24px" },
				[`.${inputBaseClasses.root}:has(> & ~ .${inputAdornmentClasses.root})`]: { "--_endAdornment": "28px" },
				"&&&": {
					paddingRight: "calc(var(--_caret, 24px) + var(--_endAdornment, 0px))",
					minWidth: 16
				}
			}
		},
		{
			props: { variant: "filled" },
			style: {
				[`.${inputBaseClasses.root}:has(> &)`]: { "--_caret": "32px" },
				[`.${inputBaseClasses.root}:has(> & ~ .${inputAdornmentClasses.root})`]: { "--_endAdornment": "28px" },
				"&&&": { paddingRight: "calc(var(--_caret, 32px) + var(--_endAdornment, 0px))" }
			}
		},
		{
			props: { variant: "outlined" },
			style: {
				[`.${inputBaseClasses.root}:has(> &)`]: { "--_caret": "32px" },
				[`.${inputBaseClasses.root}:has(> & ~ .${inputAdornmentClasses.root})`]: { "--_endAdornment": "28px" },
				borderRadius: (theme.vars || theme).shape.borderRadius,
				"&:focus": { borderRadius: (theme.vars || theme).shape.borderRadius },
				"&&&": { paddingRight: "calc(var(--_caret, 32px) + var(--_endAdornment, 0px))" }
			}
		}
	]
}));
const NativeSelectSelect = styled$2(StyledSelectSelect, {
	name: "MuiNativeSelect",
	slot: "Select",
	shouldForwardProp: rootShouldForwardProp,
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.select,
			styles[ownerState.variant],
			ownerState.error && styles.error,
			{ [`&.${nativeSelectClasses.multiple}`]: styles.multiple }
		];
	}
})({});
const StyledSelectIcon = styled$2("svg", { name: "MuiNativeSelect" })(({ theme }) => ({
	position: "absolute",
	right: 0,
	top: "calc(50% - .5em)",
	pointerEvents: "none",
	color: (theme.vars || theme).palette.action.active,
	[`&.${nativeSelectClasses.disabled}`]: { color: (theme.vars || theme).palette.action.disabled },
	variants: [
		{
			props: ({ ownerState }) => ownerState.open,
			style: { transform: "rotate(180deg)" }
		},
		{
			props: { variant: "filled" },
			style: { right: 7 }
		},
		{
			props: { variant: "outlined" },
			style: { right: 7 }
		}
	]
}));
const NativeSelectIcon = styled$2(StyledSelectIcon, {
	name: "MuiNativeSelect",
	slot: "Icon",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.icon,
			ownerState.variant && styles[`icon${capitalize_default(ownerState.variant)}`],
			ownerState.open && styles.iconOpen
		];
	}
})({});
/**
* @ignore - internal component.
*/
const NativeSelectInput = /*#__PURE__*/ React$1.forwardRef(function NativeSelectInput(props, ref) {
	const { className, disabled, error, IconComponent, inputRef, variant = "standard", ...other } = props;
	const ownerState = {
		...props,
		disabled,
		variant,
		error
	};
	const classes = useUtilityClasses$28(ownerState);
	return /*#__PURE__*/ jsxs(React$1.Fragment, { children: [/*#__PURE__*/ jsx(NativeSelectSelect, {
		ownerState,
		className: clsx(classes.select, className),
		disabled,
		ref: inputRef || ref,
		...other
	}), props.multiple ? null : /*#__PURE__*/ jsx(NativeSelectIcon, {
		as: IconComponent,
		ownerState,
		className: classes.icon
	})] });
});
NativeSelectInput.propTypes = {
	/**
	* The option elements to populate the select with.
	* Can be some `<option>` elements.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* The CSS class name of the select element.
	*/
	className: import_prop_types.default.string,
	/**
	* If `true`, the select is disabled.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the `select input` will indicate an error.
	*/
	error: import_prop_types.default.bool,
	/**
	* The icon that displays the arrow.
	*/
	IconComponent: import_prop_types.default.elementType.isRequired,
	/**
	* Use that prop to pass a ref to the native select element.
	* @deprecated
	*/
	inputRef: refType,
	/**
	* @ignore
	*/
	multiple: import_prop_types.default.bool,
	/**
	* Name attribute of the `select` or hidden `input` element.
	*/
	name: import_prop_types.default.string,
	/**
	* Callback fired when a menu item is selected.
	*
	* @param {object} event The event source of the callback.
	* You can pull out the new value by accessing `event.target.value` (string).
	*/
	onChange: import_prop_types.default.func,
	/**
	* The input value.
	*/
	value: import_prop_types.default.any,
	/**
	* The variant to use.
	*/
	variant: import_prop_types.default.oneOf([
		"standard",
		"outlined",
		"filled"
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/OutlinedInput/NotchedOutline.mjs
var _span$1;
const NotchedOutlineRoot$1 = styled$2("fieldset", {
	name: "MuiNotchedOutlined",
	shouldForwardProp: rootShouldForwardProp
})({
	textAlign: "left",
	position: "absolute",
	bottom: 0,
	right: 0,
	top: -5,
	left: 0,
	margin: 0,
	padding: "0 8px",
	pointerEvents: "none",
	borderRadius: "inherit",
	borderStyle: "solid",
	borderWidth: 1,
	overflow: "hidden",
	minWidth: "0%"
});
const NotchedOutlineLegend = styled$2("legend", {
	name: "MuiNotchedOutlined",
	shouldForwardProp: rootShouldForwardProp
})(memoTheme(({ theme }) => ({
	float: "unset",
	width: "auto",
	overflow: "hidden",
	variants: [
		{
			props: ({ ownerState }) => !ownerState.withLabel,
			style: {
				padding: 0,
				lineHeight: "11px",
				...getTransitionStyles(theme, "width", {
					duration: 150,
					easing: theme.transitions.easing.easeOut
				})
			}
		},
		{
			props: ({ ownerState }) => ownerState.withLabel,
			style: {
				display: "block",
				padding: 0,
				height: 11,
				fontSize: "0.75em",
				visibility: "hidden",
				maxWidth: .01,
				...getTransitionStyles(theme, "max-width", {
					duration: 50,
					easing: theme.transitions.easing.easeOut
				}),
				whiteSpace: "nowrap",
				"& > span": {
					paddingLeft: 5,
					paddingRight: 5,
					display: "inline-block",
					opacity: 0,
					visibility: "visible"
				}
			}
		},
		{
			props: ({ ownerState }) => ownerState.withLabel && ownerState.notched,
			style: {
				maxWidth: "100%",
				...getTransitionStyles(theme, "max-width", {
					duration: 100,
					easing: theme.transitions.easing.easeOut,
					delay: 50
				})
			}
		}
	]
})));
/**
* @ignore - internal component.
*/
function NotchedOutline(props) {
	const { children, classes, className, label, notched, ...other } = props;
	const withLabel = label != null && label !== "";
	const ownerState = {
		...props,
		notched,
		withLabel
	};
	return /*#__PURE__*/ jsx(NotchedOutlineRoot$1, {
		"aria-hidden": true,
		className,
		ownerState,
		...other,
		children: /*#__PURE__*/ jsx(NotchedOutlineLegend, {
			ownerState,
			children: withLabel ? /*#__PURE__*/ jsx("span", { children: label }) : _span$1 || (_span$1 = /*#__PURE__*/ jsx("span", {
				className: "notranslate",
				"aria-hidden": true,
				children: "​"
			}))
		})
	});
}
NotchedOutline.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The label.
	*/
	label: import_prop_types.default.node,
	/**
	* If `true`, the outline is notched to accommodate the label.
	*/
	notched: import_prop_types.default.bool.isRequired,
	/**
	* @ignore
	*/
	style: import_prop_types.default.object
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/OutlinedInput/OutlinedInput.mjs
const useUtilityClasses$27 = (ownerState) => {
	const { classes } = ownerState;
	const composedClasses = composeClasses({
		root: ["root"],
		notchedOutline: ["notchedOutline"],
		input: ["input"]
	}, getOutlinedInputUtilityClass, classes);
	return {
		...classes,
		...composedClasses
	};
};
const OutlinedInputRoot = styled$2(InputBaseRoot, {
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
	name: "MuiOutlinedInput",
	slot: "Root",
	overridesResolver: rootOverridesResolver
})(memoTheme(({ theme }) => {
	const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
	return {
		position: "relative",
		borderRadius: (theme.vars || theme).shape.borderRadius,
		[`&:hover .${outlinedInputClasses.notchedOutline}`]: { borderColor: (theme.vars || theme).palette.text.primary },
		"@media (hover: none)": { [`&:hover .${outlinedInputClasses.notchedOutline}`]: { borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, .23) : borderColor } },
		[`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: { borderWidth: 2 },
		variants: [
			...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
				props: { color },
				style: { [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: { borderColor: (theme.vars || theme).palette[color].main } }
			})),
			{
				props: {},
				style: {
					[`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: { borderColor: (theme.vars || theme).palette.error.main },
					[`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: { borderColor: (theme.vars || theme).palette.action.disabled }
				}
			},
			{
				props: ({ ownerState }) => ownerState.startAdornment,
				style: { paddingLeft: 14 }
			},
			{
				props: ({ ownerState }) => ownerState.endAdornment,
				style: {
					"--_trailingPad": "14px",
					paddingRight: "var(--_trailingPad)",
					[`&.${selectClasses.root}`]: { "--_trailingPad": "0px" }
				}
			},
			{
				props: ({ ownerState }) => ownerState.multiline,
				style: { padding: "16.5px 14px" }
			},
			{
				props: ({ ownerState, size }) => ownerState.multiline && size === "small",
				style: { padding: "8.5px 14px" }
			}
		]
	};
}));
const NotchedOutlineRoot = styled$2(NotchedOutline, {
	name: "MuiOutlinedInput",
	slot: "NotchedOutline"
})(memoTheme(({ theme }) => {
	const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
	return { borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, .23) : borderColor };
}));
const OutlinedInputInput = styled$2(InputBaseInput, {
	name: "MuiOutlinedInput",
	slot: "Input",
	overridesResolver: inputOverridesResolver
})(memoTheme(({ theme }) => ({
	padding: "16.5px 14px",
	"&:-webkit-autofill": {
		...!theme.vars && {
			WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
			WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
			caretColor: theme.palette.mode === "light" ? null : "#fff"
		},
		borderRadius: "inherit",
		...theme.vars && theme.applyStyles("dark", {
			WebkitBoxShadow: "0 0 0 100px #266798 inset",
			WebkitTextFillColor: "#fff",
			caretColor: "#fff"
		})
	},
	variants: [
		{
			props: { size: "small" },
			style: { padding: "8.5px 14px" }
		},
		{
			props: ({ ownerState }) => ownerState.multiline,
			style: { padding: 0 }
		},
		{
			props: ({ ownerState }) => ownerState.startAdornment,
			style: { paddingLeft: 0 }
		},
		{
			props: ({ ownerState }) => ownerState.endAdornment,
			style: { paddingRight: 0 }
		}
	]
})));
const OutlinedInput = /*#__PURE__*/ React$1.forwardRef(function OutlinedInput(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiOutlinedInput"
	});
	const { fullWidth = false, inputComponent = "input", label, multiline = false, notched, slots = {}, slotProps = {}, type = "text", ...other } = props;
	const classes = useUtilityClasses$27(props);
	const [fcs, muiFormControl] = useFormControlState({
		props,
		states: [
			"color",
			"disabled",
			"error",
			"focused",
			"hiddenLabel",
			"size",
			"required"
		]
	});
	const ownerState = {
		...props,
		color: fcs.color || "primary",
		disabled: fcs.disabled,
		error: fcs.error,
		focused: fcs.focused,
		formControl: muiFormControl,
		fullWidth,
		hiddenLabel: fcs.hiddenLabel,
		multiline,
		size: fcs.size,
		type
	};
	const RootSlot = slots.root ?? OutlinedInputRoot;
	const InputSlot = slots.input ?? OutlinedInputInput;
	const [NotchedSlot, notchedProps] = useSlot("notchedOutline", {
		elementType: NotchedOutlineRoot,
		className: classes.notchedOutline,
		shouldForwardComponentProp: true,
		ownerState,
		externalForwardedProps: {
			slots,
			slotProps
		},
		additionalProps: { label: label != null && label !== "" && fcs.required ? /*#__PURE__*/ jsxs(React$1.Fragment, { children: [
			label,
			" ",
			"*"
		] }) : label }
	});
	return /*#__PURE__*/ jsx(InputBase, {
		slots: {
			root: RootSlot,
			input: InputSlot
		},
		slotProps,
		renderSuffix: (state) => /*#__PURE__*/ jsx(NotchedSlot, {
			...notchedProps,
			notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
		}),
		fullWidth,
		inputComponent,
		multiline,
		ref,
		type,
		...other,
		classes: {
			...classes,
			notchedOutline: null
		}
	});
});
OutlinedInput.propTypes = {
	/**
	* This prop helps users to fill forms faster, especially on mobile devices.
	* The name can be confusing, as it's more like an autofill.
	* You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	*/
	autoComplete: import_prop_types.default.string,
	/**
	* If `true`, the `input` element is focused during the first mount.
	*/
	autoFocus: import_prop_types.default.bool,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["primary", "secondary"]), import_prop_types.default.string]),
	/**
	* The default value. Use when the component is not controlled.
	*/
	defaultValue: import_prop_types.default.any,
	/**
	* If `true`, the component is disabled.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* End `InputAdornment` for this component.
	*/
	endAdornment: import_prop_types.default.node,
	/**
	* If `true`, the `input` will indicate an error.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	error: import_prop_types.default.bool,
	/**
	* If `true`, the `input` will take up the full width of its container.
	* @default false
	*/
	fullWidth: import_prop_types.default.bool,
	/**
	* The id of the `input` element.
	*/
	id: import_prop_types.default.string,
	/**
	* The component used for the `input` element.
	* Either a string to use a HTML element or a component.
	* @default 'input'
	*/
	inputComponent: import_prop_types.default.elementType,
	/**
	* [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
	* @default {}
	*/
	inputProps: import_prop_types.default.object,
	/**
	* Pass a ref to the `input` element.
	*/
	inputRef: refType,
	/**
	* The label of the `input`. It is only used for layout. The actual labelling
	* is handled by `InputLabel`.
	*/
	label: import_prop_types.default.node,
	/**
	* If `dense`, will adjust vertical spacing. This is normally obtained via context from
	* FormControl.
	* The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
	*/
	margin: import_prop_types.default.oneOf(["dense", "none"]),
	/**
	* Maximum number of rows to display when multiline option is set to true.
	*/
	maxRows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* Minimum number of rows to display when multiline option is set to true.
	*/
	minRows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
	* @default false
	*/
	multiline: import_prop_types.default.bool,
	/**
	* Name attribute of the `input` element.
	*/
	name: import_prop_types.default.string,
	/**
	* If `true`, the outline is notched to accommodate the label.
	*/
	notched: import_prop_types.default.bool,
	/**
	* Callback fired when the value is changed.
	*
	* @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
	* You can pull out the new value by accessing `event.target.value` (string).
	*/
	onChange: import_prop_types.default.func,
	/**
	* The short hint displayed in the `input` before the user enters a value.
	*/
	placeholder: import_prop_types.default.string,
	/**
	* It prevents the user from changing the value of the field
	* (not from interacting with the field).
	*/
	readOnly: import_prop_types.default.bool,
	/**
	* If `true`, the `input` element is required.
	* The prop defaults to the value (`false`) inherited from the parent FormControl component.
	*/
	required: import_prop_types.default.bool,
	/**
	* Number of rows to display when multiline option is set to true.
	*/
	rows: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		input: import_prop_types.default.object,
		notchedOutline: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.object
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		input: import_prop_types.default.elementType,
		notchedOutline: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* Start `InputAdornment` for this component.
	*/
	startAdornment: import_prop_types.default.node,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
	* @default 'text'
	*/
	type: import_prop_types.default.string,
	/**
	* The value of the `input` element, required for a controlled component.
	*/
	value: import_prop_types.default.any
};
OutlinedInput.muiName = "Input";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Pagination/paginationClasses.mjs
function getPaginationUtilityClass(slot) {
	return generateUtilityClass("MuiPagination", slot);
}
const paginationClasses = generateUtilityClasses("MuiPagination", [
	"root",
	"ul",
	"outlined",
	"text"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/usePagination/usePagination.mjs
function usePagination(props = {}) {
	const { boundaryCount = 1, componentName = "usePagination", count = 1, defaultPage = 1, disabled = false, hideNextButton = false, hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton = false, showLastButton = false, siblingCount = 1, ...other } = props;
	const [page, setPageState] = useControlled({
		controlled: pageProp,
		default: defaultPage,
		name: componentName,
		state: "page"
	});
	const handleClick = (event, value) => {
		if (!pageProp) setPageState(value);
		if (handleChange) handleChange(event, value);
	};
	const range = (start, end) => {
		const length = end - start + 1;
		return Array.from({ length }, (_, i) => start + i);
	};
	const startPages = range(1, Math.min(boundaryCount, count));
	const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
	const siblingsStart = Math.max(Math.min(page - siblingCount, count - boundaryCount - siblingCount * 2 - 1), boundaryCount + 2);
	const siblingsEnd = Math.min(Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2), count - boundaryCount - 1);
	const itemList = [
		...showFirstButton ? ["first"] : [],
		...hidePrevButton ? [] : ["previous"],
		...startPages,
		...siblingsStart > boundaryCount + 2 ? ["start-ellipsis"] : boundaryCount + 1 < count - boundaryCount ? [boundaryCount + 1] : [],
		...range(siblingsStart, siblingsEnd),
		...siblingsEnd < count - boundaryCount - 1 ? ["end-ellipsis"] : count - boundaryCount > boundaryCount ? [count - boundaryCount] : [],
		...endPages,
		...hideNextButton ? [] : ["next"],
		...showLastButton ? ["last"] : []
	];
	const buttonPage = (type) => {
		switch (type) {
			case "first": return 1;
			case "previous": return page - 1;
			case "next": return page + 1;
			case "last": return count;
			default: return null;
		}
	};
	return {
		items: itemList.map((item) => {
			return typeof item === "number" ? {
				onClick: (event) => {
					handleClick(event, item);
				},
				type: "page",
				page: item,
				selected: item === page,
				disabled,
				"aria-current": item === page ? "page" : void 0
			} : {
				onClick: (event) => {
					handleClick(event, buttonPage(item));
				},
				type: item,
				page: buttonPage(item),
				selected: false,
				disabled: disabled || !item.includes("ellipsis") && (item === "next" || item === "last" ? page >= count : page <= 1)
			};
		}),
		...other
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/PaginationItem/paginationItemClasses.mjs
function getPaginationItemUtilityClass(slot) {
	return generateUtilityClass("MuiPaginationItem", slot);
}
const paginationItemClasses = generateUtilityClasses("MuiPaginationItem", [
	"root",
	"page",
	"sizeSmall",
	"sizeLarge",
	"text",
	"outlined",
	"rounded",
	"ellipsis",
	"firstLast",
	"previousNext",
	"focusVisible",
	"disabled",
	"selected",
	"icon",
	"colorPrimary",
	"colorSecondary"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/FirstPage.mjs
/**
* @ignore - internal component.
*/
var FirstPage_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" }), "FirstPage");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/LastPage.mjs
/**
* @ignore - internal component.
*/
var LastPage_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" }), "LastPage");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/NavigateBefore.mjs
/**
* @ignore - internal component.
*/
var NavigateBefore_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" }), "NavigateBefore");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/NavigateNext.mjs
/**
* @ignore - internal component.
*/
var NavigateNext_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" }), "NavigateNext");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/PaginationItem/PaginationItem.mjs
const overridesResolver = (props, styles) => {
	const { ownerState } = props;
	return [
		styles.root,
		styles[ownerState.variant],
		styles[`size${capitalize_default(ownerState.size)}`],
		ownerState.shape === "rounded" && styles.rounded,
		ownerState.type === "page" && styles.page,
		(ownerState.type === "start-ellipsis" || ownerState.type === "end-ellipsis") && styles.ellipsis,
		(ownerState.type === "previous" || ownerState.type === "next") && styles.previousNext,
		(ownerState.type === "first" || ownerState.type === "last") && styles.firstLast
	];
};
const useUtilityClasses$26 = (ownerState) => {
	const { classes, color, disabled, selected, size, shape, type, variant } = ownerState;
	const slots = {
		root: [
			"root",
			`size${capitalize_default(size)}`,
			variant,
			shape,
			color !== "standard" && `color${capitalize_default(color)}`,
			disabled && "disabled",
			selected && "selected",
			{
				page: "page",
				first: "firstLast",
				last: "firstLast",
				"start-ellipsis": "ellipsis",
				"end-ellipsis": "ellipsis",
				previous: "previousNext",
				next: "previousNext"
			}[type]
		],
		icon: ["icon"]
	};
	return composeClasses(slots, getPaginationItemUtilityClass, classes);
};
const PaginationItemEllipsis = styled$2("div", {
	name: "MuiPaginationItem",
	slot: "Root",
	overridesResolver
})(memoTheme(({ theme }) => ({
	...theme.typography.body2,
	borderRadius: 16,
	textAlign: "center",
	boxSizing: "border-box",
	minWidth: 32,
	padding: "0 6px",
	margin: "0 3px",
	color: (theme.vars || theme).palette.text.primary,
	height: "auto",
	[`&.${paginationItemClasses.disabled}`]: { opacity: (theme.vars || theme).palette.action.disabledOpacity },
	variants: [{
		props: { size: "small" },
		style: {
			minWidth: 26,
			borderRadius: 13,
			margin: "0 1px",
			padding: "0 4px"
		}
	}, {
		props: { size: "large" },
		style: {
			minWidth: 40,
			borderRadius: 20,
			padding: "0 10px",
			fontSize: theme.typography.pxToRem(15)
		}
	}]
})));
const PaginationItemPage = styled$2(ButtonBase, {
	name: "MuiPaginationItem",
	slot: "Root",
	overridesResolver
})(memoTheme(({ theme }) => ({
	...theme.typography.body2,
	borderRadius: 16,
	textAlign: "center",
	boxSizing: "border-box",
	minWidth: 32,
	height: 32,
	padding: "0 6px",
	margin: "0 3px",
	color: (theme.vars || theme).palette.text.primary,
	...!theme.focusVisible && { [`&.${paginationItemClasses.focusVisible}`]: { backgroundColor: (theme.vars || theme).palette.action.focus } },
	[`&.${paginationItemClasses.disabled}`]: { opacity: (theme.vars || theme).palette.action.disabledOpacity },
	...getTransitionStyles(theme, ["color", "background-color"], { duration: theme.transitions.duration.short }),
	"&:hover": {
		backgroundColor: (theme.vars || theme).palette.action.hover,
		"@media (hover: none)": { backgroundColor: "transparent" }
	},
	[`&.${paginationItemClasses.selected}`]: {
		backgroundColor: (theme.vars || theme).palette.action.selected,
		"&:hover": {
			backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
			"@media (hover: none)": { backgroundColor: (theme.vars || theme).palette.action.selected }
		},
		...!theme.focusVisible && { [`&.${paginationItemClasses.focusVisible}`]: { backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`) } },
		[`&.${paginationItemClasses.disabled}`]: {
			opacity: 1,
			color: (theme.vars || theme).palette.action.disabled,
			backgroundColor: (theme.vars || theme).palette.action.selected
		}
	},
	variants: [
		{
			props: { size: "small" },
			style: {
				minWidth: 26,
				height: 26,
				borderRadius: 13,
				margin: "0 1px",
				padding: "0 4px"
			}
		},
		{
			props: { size: "large" },
			style: {
				minWidth: 40,
				height: 40,
				borderRadius: 20,
				padding: "0 10px",
				fontSize: theme.typography.pxToRem(15)
			}
		},
		{
			props: { shape: "rounded" },
			style: { borderRadius: (theme.vars || theme).shape.borderRadius }
		},
		{
			props: { variant: "outlined" },
			style: {
				border: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, .23)}` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
				[`&.${paginationItemClasses.selected}`]: { [`&.${paginationItemClasses.disabled}`]: {
					borderColor: (theme.vars || theme).palette.action.disabledBackground,
					color: (theme.vars || theme).palette.action.disabled
				} }
			}
		},
		{
			props: { variant: "text" },
			style: { [`&.${paginationItemClasses.selected}`]: { [`&.${paginationItemClasses.disabled}`]: { color: (theme.vars || theme).palette.action.disabled } } }
		},
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["dark", "contrastText"])).map(([color]) => ({
			props: {
				variant: "text",
				color
			},
			style: { [`&.${paginationItemClasses.selected}`]: {
				color: (theme.vars || theme).palette[color].contrastText,
				backgroundColor: (theme.vars || theme).palette[color].main,
				"&:hover": {
					backgroundColor: (theme.vars || theme).palette[color].dark,
					"@media (hover: none)": { backgroundColor: (theme.vars || theme).palette[color].main }
				},
				...!theme.focusVisible && { [`&.${paginationItemClasses.focusVisible}`]: { backgroundColor: (theme.vars || theme).palette[color].dark } },
				[`&.${paginationItemClasses.disabled}`]: { color: (theme.vars || theme).palette.action.disabled }
			} }
		})),
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["light"])).map(([color]) => ({
			props: {
				variant: "outlined",
				color
			},
			style: { [`&.${paginationItemClasses.selected}`]: {
				color: (theme.vars || theme).palette[color].main,
				border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, .5)}`,
				backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.activatedOpacity),
				"&:hover": {
					backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.activatedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`),
					"@media (hover: none)": { backgroundColor: "transparent" }
				},
				...!theme.focusVisible && { [`&.${paginationItemClasses.focusVisible}`]: { backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.activatedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`) } }
			} }
		}))
	]
})));
const PaginationItemPageIcon = styled$2("div", {
	name: "MuiPaginationItem",
	slot: "Icon"
})(memoTheme(({ theme }) => ({
	fontSize: theme.typography.pxToRem(20),
	margin: "0 -8px",
	variants: [{
		props: { size: "small" },
		style: { fontSize: theme.typography.pxToRem(18) }
	}, {
		props: { size: "large" },
		style: { fontSize: theme.typography.pxToRem(22) }
	}]
})));
const PaginationItem$1 = /*#__PURE__*/ React$1.forwardRef(function PaginationItem(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiPaginationItem"
	});
	const { className, color = "standard", component, disabled = false, page, selected = false, shape = "circular", size = "medium", slots = {}, slotProps = {}, type = "page", variant = "text", ...other } = props;
	const ownerState = {
		...props,
		color,
		disabled,
		selected,
		shape,
		size,
		type,
		variant
	};
	const isRtl = useRtl();
	const classes = useUtilityClasses$26(ownerState);
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [PreviousSlot, previousSlotProps] = useSlot("previous", {
		elementType: NavigateBefore_default,
		externalForwardedProps,
		ownerState
	});
	const [NextSlot, nextSlotProps] = useSlot("next", {
		elementType: NavigateNext_default,
		externalForwardedProps,
		ownerState
	});
	const [FirstSlot, firstSlotProps] = useSlot("first", {
		elementType: FirstPage_default,
		externalForwardedProps,
		ownerState
	});
	const [LastSlot, lastSlotProps] = useSlot("last", {
		elementType: LastPage_default,
		externalForwardedProps,
		ownerState
	});
	const rtlAwareType = isRtl ? {
		previous: "next",
		next: "previous",
		first: "last",
		last: "first"
	}[type] : type;
	const IconSlot = {
		previous: PreviousSlot,
		next: NextSlot,
		first: FirstSlot,
		last: LastSlot
	}[rtlAwareType];
	const iconSlotProps = {
		previous: previousSlotProps,
		next: nextSlotProps,
		first: firstSlotProps,
		last: lastSlotProps
	}[rtlAwareType];
	return type === "start-ellipsis" || type === "end-ellipsis" ? /*#__PURE__*/ jsx(PaginationItemEllipsis, {
		ref,
		ownerState,
		className: clsx(classes.root, className),
		children: "…"
	}) : /*#__PURE__*/ jsxs(PaginationItemPage, {
		ref,
		ownerState,
		component,
		internalNativeButton: true,
		disabled,
		className: clsx(classes.root, className),
		...other,
		children: [type === "page" && page, IconSlot ? /*#__PURE__*/ jsx(PaginationItemPageIcon, {
			...iconSlotProps,
			className: classes.icon,
			as: IconSlot
		}) : null]
	});
});
PaginationItem$1.propTypes = {
	/**
	* @ignore
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The active color.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'standard'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"primary",
		"secondary",
		"standard"
	]), import_prop_types.default.string]),
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* Whether the custom component should render a native `<button>` element when
	* rendering a React component with the `component` or `slots` prop.
	*/
	nativeButton: import_prop_types.default.bool,
	/**
	* The current page number.
	*/
	page: import_prop_types.default.node,
	/**
	* If `true` the pagination item is selected.
	* @default false
	*/
	selected: import_prop_types.default.bool,
	/**
	* The shape of the pagination item.
	* @default 'circular'
	*/
	shape: import_prop_types.default.oneOf(["circular", "rounded"]),
	/**
	* The size of the component.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"small",
		"medium",
		"large"
	]), import_prop_types.default.string]),
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		first: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		last: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		next: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		previous: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		first: import_prop_types.default.elementType,
		last: import_prop_types.default.elementType,
		next: import_prop_types.default.elementType,
		previous: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The type of pagination item.
	* @default 'page'
	*/
	type: import_prop_types.default.oneOf([
		"end-ellipsis",
		"first",
		"last",
		"next",
		"page",
		"previous",
		"start-ellipsis"
	]),
	/**
	* The variant to use.
	* @default 'text'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["outlined", "text"]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Pagination/Pagination.mjs
const useUtilityClasses$25 = (ownerState) => {
	const { classes, variant } = ownerState;
	return composeClasses({
		root: ["root", variant],
		ul: ["ul"]
	}, getPaginationUtilityClass, classes);
};
const PaginationRoot = styled$2("nav", {
	name: "MuiPagination",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, styles[ownerState.variant]];
	}
})({});
const PaginationUl = styled$2("ul", {
	name: "MuiPagination",
	slot: "Ul"
})({
	display: "flex",
	flexWrap: "wrap",
	alignItems: "center",
	padding: 0,
	margin: 0,
	listStyle: "none"
});
function defaultGetAriaLabel$1(type, page, selected) {
	if (type === "page") return `${selected ? "" : "Go to "}page ${page}`;
	return `Go to ${type} page`;
}
const Pagination$1 = /*#__PURE__*/ React$1.forwardRef(function Pagination(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiPagination"
	});
	const { boundaryCount = 1, className, color = "standard", count = 1, defaultPage = 1, disabled = false, getItemAriaLabel = defaultGetAriaLabel$1, hideNextButton = false, hidePrevButton = false, onChange, page, renderItem = (item) => /*#__PURE__*/ jsx(PaginationItem$1, { ...item }), shape = "circular", showFirstButton = false, showLastButton = false, siblingCount = 1, size = "medium", variant = "text", ...other } = props;
	const { items } = usePagination({
		...props,
		componentName: "Pagination"
	});
	const ownerState = {
		...props,
		boundaryCount,
		color,
		count,
		defaultPage,
		disabled,
		getItemAriaLabel,
		hideNextButton,
		hidePrevButton,
		renderItem,
		shape,
		showFirstButton,
		showLastButton,
		siblingCount,
		size,
		variant
	};
	const classes = useUtilityClasses$25(ownerState);
	const paginationRef = React$1.useRef(null);
	const pendingFocusRef = React$1.useRef(null);
	const handleRef = useForkRef_default(ref, paginationRef);
	const selectedPage = items.find((item) => item.selected)?.page;
	const handleItemClick = React$1.useCallback((item, event) => {
		pendingFocusRef.current = null;
		if (((item.type === "first" || item.type === "previous") && item.page === 1 || (item.type === "next" || item.type === "last") && item.page === count) && getActiveElement_default(ownerDocument_default(event.currentTarget)) === event.currentTarget) pendingFocusRef.current = {
			page: item.page,
			trigger: event.currentTarget
		};
		item.onClick(event);
	}, [count]);
	useEnhancedEffect_default(() => {
		const pending = pendingFocusRef.current;
		if (!pending || pending.page !== selectedPage) return;
		const document = ownerDocument_default(paginationRef.current);
		const activeElement = getActiveElement_default(document);
		if (activeElement === document.body || activeElement === document.documentElement || activeElement === pending.trigger || activeElement == null) paginationRef.current.querySelector("[aria-current=\"page\"]")?.focus();
		pendingFocusRef.current = null;
	}, [selectedPage]);
	return /*#__PURE__*/ jsx(PaginationRoot, {
		"aria-label": "pagination navigation",
		className: clsx(classes.root, className),
		ownerState,
		ref: handleRef,
		...other,
		children: /*#__PURE__*/ jsx(PaginationUl, {
			className: classes.ul,
			ownerState,
			children: items.map((item, index) => /*#__PURE__*/ jsx("li", { children: renderItem({
				...item,
				color,
				"aria-label": getItemAriaLabel(item.type, item.page, item.selected),
				shape,
				size,
				variant,
				onClick: (event) => handleItemClick(item, event)
			}) }, index))
		})
	});
});
Pagination$1.propTypes = {
	/**
	* Number of always visible pages at the beginning and end.
	* @default 1
	*/
	boundaryCount: integerPropType,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The active color.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'standard'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"primary",
		"secondary",
		"standard"
	]), import_prop_types.default.string]),
	/**
	* The total number of pages.
	* @default 1
	*/
	count: integerPropType,
	/**
	* The page selected by default when the component is uncontrolled.
	* @default 1
	*/
	defaultPage: integerPropType,
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* Accepts a function which returns a string value that provides a user-friendly name for the current page.
	* This is important for screen reader users.
	*
	* For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
	* @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
	* @param {number | null} page The page number to format.
	* @param {boolean} selected If true, the current page is selected.
	* @returns {string}
	*/
	getItemAriaLabel: import_prop_types.default.func,
	/**
	* If `true`, hide the next-page button.
	* @default false
	*/
	hideNextButton: import_prop_types.default.bool,
	/**
	* If `true`, hide the previous-page button.
	* @default false
	*/
	hidePrevButton: import_prop_types.default.bool,
	/**
	* Callback fired when the page is changed.
	*
	* @param {React.ChangeEvent<unknown>} event The event source of the callback.
	* @param {number} page The page selected.
	*/
	onChange: import_prop_types.default.func,
	/**
	* The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
	*/
	page: integerPropType,
	/**
	* Render the item.
	* @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
	* @returns {ReactNode}
	* @default (item) => <PaginationItem {...item} />
	*/
	renderItem: import_prop_types.default.func,
	/**
	* The shape of the pagination items.
	* @default 'circular'
	*/
	shape: import_prop_types.default.oneOf(["circular", "rounded"]),
	/**
	* If `true`, show the first-page button.
	* @default false
	*/
	showFirstButton: import_prop_types.default.bool,
	/**
	* If `true`, show the last-page button.
	* @default false
	*/
	showLastButton: import_prop_types.default.bool,
	/**
	* Number of always visible pages before and after the current page.
	* @default 1
	*/
	siblingCount: integerPropType,
	/**
	* The size of the component.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"small",
		"medium",
		"large"
	]), import_prop_types.default.string]),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The variant to use.
	* @default 'text'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["outlined", "text"]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/RadioButtonUnchecked.mjs
/**
* @ignore - internal component.
*/
var RadioButtonUnchecked_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" }), "RadioButtonUnchecked");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/RadioButtonChecked.mjs
/**
* @ignore - internal component.
*/
var RadioButtonChecked_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z" }), "RadioButtonChecked");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Radio/RadioButtonIcon.mjs
const RadioButtonIconRoot = styled$2("span", {
	name: "MuiRadioButtonIcon",
	shouldForwardProp: rootShouldForwardProp
})({
	position: "relative",
	display: "flex"
});
const RadioButtonIconBackground = styled$2(RadioButtonUnchecked_default, { name: "MuiRadioButtonIcon" })({ transform: "scale(1)" });
const RadioButtonIconDot = styled$2(RadioButtonChecked_default, { name: "MuiRadioButtonIcon" })(memoTheme(({ theme }) => ({
	left: 0,
	position: "absolute",
	transform: "scale(0)",
	...getTransitionStyles(theme, "transform", {
		easing: theme.transitions.easing.easeIn,
		duration: theme.transitions.duration.shortest
	}),
	variants: [{
		props: { checked: true },
		style: {
			transform: "scale(1)",
			...getTransitionStyles(theme, "transform", {
				easing: theme.transitions.easing.easeOut,
				duration: theme.transitions.duration.shortest
			})
		}
	}]
})));
/**
* @ignore - internal component.
*/
function RadioButtonIcon(props) {
	const { checked = false, classes = {}, fontSize } = props;
	const ownerState = {
		...props,
		checked
	};
	return /*#__PURE__*/ jsxs(RadioButtonIconRoot, {
		className: classes.root,
		ownerState,
		children: [/*#__PURE__*/ jsx(RadioButtonIconBackground, {
			fontSize,
			className: classes.background,
			ownerState
		}), /*#__PURE__*/ jsx(RadioButtonIconDot, {
			fontSize,
			className: classes.dot,
			ownerState
		})]
	});
}
RadioButtonIcon.propTypes = {
	/**
	* If `true`, the component is checked.
	*/
	checked: import_prop_types.default.bool,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* The size of the component.
	* `small` is equivalent to the dense radio styling.
	*/
	fontSize: import_prop_types.default.oneOf(["small", "medium"])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/RadioGroup/RadioGroupContext.mjs
/**
* @ignore - internal component.
*/
const RadioGroupContext = /*#__PURE__*/ React$1.createContext(void 0);
RadioGroupContext.displayName = "RadioGroupContext";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/RadioGroup/useRadioGroup.mjs
function useRadioGroup() {
	return React$1.useContext(RadioGroupContext);
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Radio/Radio.mjs
const useUtilityClasses$24 = (ownerState) => {
	const { classes, color, size } = ownerState;
	const slots = { root: [
		"root",
		`color${capitalize_default(color)}`,
		size !== "medium" && `size${capitalize_default(size)}`
	] };
	return {
		...classes,
		...composeClasses(slots, getRadioUtilityClass, classes)
	};
};
const RadioRoot = styled$2(SwitchBase, {
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
	name: "MuiRadio",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.size !== "medium" && styles[`size${capitalize_default(ownerState.size)}`],
			styles[`color${capitalize_default(ownerState.color)}`]
		];
	}
})(memoTheme(({ theme }) => ({
	color: (theme.vars || theme).palette.text.secondary,
	...theme.focusVisible && { [`&.${buttonBaseClasses.focusVisible} svg:first-of-type`]: {
		...outsetFocusRing,
		borderRadius: 99,
		...theme.focusVisible
	} },
	[`&.${radioClasses.disabled}`]: { color: (theme.vars || theme).palette.action.disabled },
	variants: [
		{
			props: {
				color: "default",
				disabled: false,
				disableRipple: false
			},
			style: { "&:hover": { backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity) } }
		},
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
			props: {
				color,
				disabled: false,
				disableRipple: false
			},
			style: { "&:hover": { backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity) } }
		})),
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
			props: {
				color,
				disabled: false
			},
			style: { [`&.${radioClasses.checked}`]: { color: (theme.vars || theme).palette[color].main } }
		})),
		{
			props: { disableRipple: false },
			style: { "&:hover": { "@media (hover: none)": { backgroundColor: "transparent" } } }
		}
	]
})));
function areEqualValues(a, b) {
	if (typeof b === "object" && b !== null) return a === b;
	return String(a) === String(b);
}
const defaultCheckedIcon = /*#__PURE__*/ jsx(RadioButtonIcon, { checked: true });
const defaultIcon = /*#__PURE__*/ jsx(RadioButtonIcon, {});
const Radio$1 = /*#__PURE__*/ React$1.forwardRef(function Radio(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiRadio"
	});
	const { checked: checkedProp, checkedIcon = defaultCheckedIcon, color = "primary", icon = defaultIcon, name: nameProp, onChange: onChangeProp, size = "medium", className, disabled: disabledProp, disableRipple = false, slots = {}, slotProps = {}, ...other } = props;
	const muiFormControl = useFormControl();
	let disabled = disabledProp;
	if (muiFormControl) {
		if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
	}
	disabled ??= false;
	const ownerState = {
		...props,
		disabled,
		disableRipple,
		color,
		size
	};
	const classes = useUtilityClasses$24(ownerState);
	const radioGroup = useRadioGroup();
	let checked = checkedProp;
	const onChange = createChainedFunction_default(onChangeProp, radioGroup && radioGroup.onChange);
	let name = nameProp;
	if (radioGroup) {
		if (typeof checked === "undefined") checked = areEqualValues(radioGroup.value, props.value);
		if (typeof name === "undefined") name = radioGroup.name;
	}
	const externalInputProps = slotProps.input;
	const [RootSlot, rootSlotProps] = useSlot("root", {
		ref,
		elementType: RadioRoot,
		className: clsx(classes.root, className),
		shouldForwardComponentProp: true,
		externalForwardedProps: {
			slots,
			slotProps,
			...other
		},
		getSlotProps: (handlers) => ({
			...handlers,
			onChange: (event, ...args) => {
				handlers.onChange?.(event, ...args);
				onChange(event, ...args);
			}
		}),
		ownerState,
		additionalProps: {
			type: "radio",
			icon: /*#__PURE__*/ React$1.cloneElement(icon, { fontSize: icon.props.fontSize ?? size }),
			checkedIcon: /*#__PURE__*/ React$1.cloneElement(checkedIcon, { fontSize: checkedIcon.props.fontSize ?? size }),
			disabled,
			name,
			checked,
			disableRipple: props.disableRipple,
			slots,
			slotProps: { input: typeof externalInputProps === "function" ? externalInputProps(ownerState) : externalInputProps }
		}
	});
	return /*#__PURE__*/ jsx(RootSlot, {
		...rootSlotProps,
		classes
	});
});
Radio$1.propTypes = {
	/**
	* If `true`, the component is checked.
	*/
	checked: import_prop_types.default.bool,
	/**
	* The icon to display when the component is checked.
	* @default <RadioButtonIcon checked />
	*/
	checkedIcon: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'primary'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"default",
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* If `true`, the component is disabled.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the ripple effect is disabled.
	* @default false
	*/
	disableRipple: import_prop_types.default.bool,
	/**
	* The icon to display when the component is unchecked.
	* @default <RadioButtonIcon />
	*/
	icon: import_prop_types.default.node,
	/**
	* The id of the `input` element.
	*/
	id: import_prop_types.default.string,
	/**
	* Name attribute of the `input` element.
	*/
	name: import_prop_types.default.string,
	/**
	* Callback fired when the state is changed.
	*
	* @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
	* You can pull out the new value by accessing `event.target.value` (string).
	* You can pull out the new checked state by accessing `event.target.checked` (boolean).
	*/
	onChange: import_prop_types.default.func,
	/**
	* If `true`, the `input` element is required.
	* @default false
	*/
	required: import_prop_types.default.bool,
	/**
	* The size of the component.
	* `small` is equivalent to the dense radio styling.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["medium", "small"]), import_prop_types.default.string]),
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		input: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		input: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The value of the component. The DOM API casts this to a string.
	*/
	value: import_prop_types.default.any
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/RadioGroup/radioGroupClasses.mjs
function getRadioGroupUtilityClass(slot) {
	return generateUtilityClass("MuiRadioGroup", slot);
}
generateUtilityClasses("MuiRadioGroup", [
	"root",
	"row",
	"error"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/RadioGroup/RadioGroup.mjs
const useUtilityClasses$23 = (props) => {
	const { classes, row, error } = props;
	return composeClasses({ root: [
		"root",
		row && "row",
		error && "error"
	] }, getRadioGroupUtilityClass, classes);
};
const RadioGroup$1 = /*#__PURE__*/ React$1.forwardRef(function RadioGroup(props, ref) {
	const { actions, children, className, defaultValue, name: nameProp, onChange, value: valueProp, ...other } = props;
	const rootRef = React$1.useRef(null);
	const classes = useUtilityClasses$23(props);
	const [value, setValueState] = useControlled_default({
		controlled: valueProp,
		default: defaultValue,
		name: "RadioGroup"
	});
	React$1.useImperativeHandle(actions, () => ({ focus: () => {
		let input = rootRef.current.querySelector("input:not(:disabled):checked");
		if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
		if (input) input.focus();
	} }), []);
	const handleRef = useForkRef_default(ref, rootRef);
	const name = useId_default(nameProp);
	const contextValue = React$1.useMemo(() => ({
		name,
		onChange(event) {
			setValueState(event.target.value);
			if (onChange) onChange(event, event.target.value);
		},
		value
	}), [
		name,
		onChange,
		setValueState,
		value
	]);
	return /*#__PURE__*/ jsx(RadioGroupContext.Provider, {
		value: contextValue,
		children: /*#__PURE__*/ jsx(FormGroup$1, {
			role: "radiogroup",
			ref: handleRef,
			className: clsx(classes.root, className),
			...other,
			children
		})
	});
});
RadioGroup$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The default value. Use when the component is not controlled.
	*/
	defaultValue: import_prop_types.default.any,
	/**
	* The name used to reference the value of the control.
	* If you don't provide this prop, it falls back to a randomly generated name.
	*/
	name: import_prop_types.default.string,
	/**
	* Callback fired when a radio button is selected.
	*
	* @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
	* @param {string} value The value of the selected radio button.
	* You can pull out the new value by accessing `event.target.value` (string).
	*/
	onChange: import_prop_types.default.func,
	/**
	* Value of the selected radio button. The DOM API casts this to a string.
	*/
	value: import_prop_types.default.any
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Select/utils/closedTypeahead.mjs
function hasOwnValueProp(child) {
	return Object.prototype.hasOwnProperty.call(child.props, "value");
}
function getTextFromReactNode(node) {
	if (typeof node === "string" || typeof node === "number") return String(node);
	let text = "";
	React$1.Children.forEach(node, (child) => {
		if (typeof child === "string" || typeof child === "number") text += String(child);
		else if (/*#__PURE__*/ React$1.isValidElement(child)) text += getTextFromReactNode(child.props.children);
	});
	return text;
}
function getMatchingOptionIndex(options, search, startIndex = 0) {
	if (options.length === 0) return -1;
	const normalizedStartIndex = (startIndex % options.length + options.length) % options.length;
	for (let offset = 0; offset < options.length; offset += 1) {
		const index = (normalizedStartIndex + offset) % options.length;
		if (options[index].label.startsWith(search)) return index;
	}
	return -1;
}
function canCycleRepeatedCharacter(options, key) {
	return !options.some((option) => option.label[0] === key && option.label[1] === key);
}
function getTypeaheadOptions(childrenArray, value) {
	const options = [];
	let selectedIndex = -1;
	for (let index = 0; index < childrenArray.length; index += 1) {
		const child = childrenArray[index];
		if (!/*#__PURE__*/ React$1.isValidElement(child) || !hasOwnValueProp(child) || child.props.disabled) continue;
		const label = getTextFromReactNode(child.props.children).trim().toLowerCase();
		if (label === "") continue;
		if (selectedIndex === -1 && areEqualValues$1(value, child.props.value)) selectedIndex = options.length;
		options.push({
			child,
			label,
			value: child.props.value
		});
	}
	return {
		options,
		selectedIndex
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Select/SelectInput.mjs
var _span;
const OPENING_MOUSE_UP_BOUNDARY_OFFSET = 2;
const SELECTED_MOUSE_UP_DELAY = 400;
const UNSELECTED_MOUSE_UP_DELAY = 200;
const TYPEAHEAD_RESET_MS = 750;
const SPACE = " ";
const ARROW_UP = "ArrowUp";
const ARROW_DOWN = "ArrowDown";
const ENTER = "Enter";
/**
* Returns true when a native mouse event should be treated as happening inside
* the element, even if a portal or backdrop retargeted the event away from it.
*
* Select uses this for the opening mouseup: when the menu opens over the
* trigger, the release can target the backdrop or portaled menu even though the
* pointer is still inside the trigger or menu bounds.
*/
function isMouseEventInsideElement(event, element) {
	if (!element) return false;
	if (event.composedPath().includes(element)) return true;
	if (event.target?.nodeType && element.contains(event.target)) return true;
	const rect = element.getBoundingClientRect();
	if (rect.width === 0 && rect.height === 0) return false;
	return event.clientX >= rect.left - OPENING_MOUSE_UP_BOUNDARY_OFFSET && event.clientX <= rect.right + OPENING_MOUSE_UP_BOUNDARY_OFFSET && event.clientY >= rect.top - OPENING_MOUSE_UP_BOUNDARY_OFFSET && event.clientY <= rect.bottom + OPENING_MOUSE_UP_BOUNDARY_OFFSET;
}
const SelectSelect = styled$2(StyledSelectSelect, {
	name: "MuiSelect",
	slot: "Select",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			{ [`&.${selectClasses.select}`]: styles.select },
			{ [`&.${selectClasses.select}`]: styles[ownerState.variant] },
			{ [`&.${selectClasses.error}`]: styles.error },
			{ [`&.${selectClasses.multiple}`]: styles.multiple }
		];
	}
})({ [`&.${selectClasses.select}`]: {
	height: "auto",
	minHeight: "1.4375em",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
	overflow: "hidden"
} });
const SelectIcon = styled$2(StyledSelectIcon, {
	name: "MuiSelect",
	slot: "Icon",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.icon, ownerState.open && styles.iconOpen];
	}
})({});
const SelectNativeInput = styled$2("input", {
	shouldForwardProp: (prop) => slotShouldForwardProp(prop) && prop !== "classes",
	name: "MuiSelect",
	slot: "NativeInput"
})({
	bottom: 0,
	left: 0,
	position: "absolute",
	opacity: 0,
	pointerEvents: "none",
	width: "100%",
	boxSizing: "border-box"
});
const useUtilityClasses$22 = (ownerState) => {
	const { classes, variant, disabled, multiple, open, error } = ownerState;
	return composeClasses({
		select: [
			"select",
			variant,
			disabled && "disabled",
			multiple && "multiple",
			error && "error"
		],
		icon: [
			"icon",
			open && "iconOpen",
			disabled && "disabled"
		],
		nativeInput: ["nativeInput"]
	}, getSelectUtilityClasses, classes);
};
/**
* @ignore - internal component.
*/
const SelectInput$1 = /*#__PURE__*/ React$1.forwardRef(function SelectInput(props, ref) {
	const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus, autoWidth, children, className, defaultOpen, defaultValue, disabled, displayEmpty, error = false, IconComponent, inputRef: inputRefProp, labelId, MenuProps = {}, multiple, name, onBlur, onChange, onClose, onFocus, onKeyDown, onMouseDown, onOpen, open: openProp, readOnly, renderValue, required, SelectDisplayProps = {}, tabIndex: tabIndexProp, type, value: valueProp, variant = "standard", ...other } = props;
	const [value, setValueState] = useControlled_default({
		controlled: valueProp,
		default: defaultValue,
		name: "Select"
	});
	const [openState, setOpenState] = useControlled_default({
		controlled: openProp,
		default: defaultOpen,
		name: "Select"
	});
	const inputRef = React$1.useRef(null);
	const displayRef = React$1.useRef(null);
	const paperRef = React$1.useRef(null);
	const openRef = React$1.useRef(false);
	const hasSelectedItemInListRef = React$1.useRef(false);
	const openingMouseUpListenerCleanupRef = React$1.useRef(null);
	const didPointerDownOnItemRef = React$1.useRef(false);
	const selectionRef = React$1.useRef({
		allowSelectedMouseUp: false,
		allowUnselectedMouseUp: false
	});
	const closedTypeaheadRef = React$1.useRef({
		buffer: "",
		previousSearchIndex: null,
		matchedIndex: null
	});
	const selectedMouseUpTimer = useTimeout();
	const unselectedMouseUpTimer = useTimeout();
	const typeaheadResetTimer = useTimeout();
	const [displayNode, setDisplayNode] = React$1.useState(null);
	const { current: isOpenControlled } = React$1.useRef(openProp != null);
	const [menuMinWidthState, setMenuMinWidthState] = React$1.useState();
	const [openInteractionType, setOpenInteractionType] = React$1.useState(null);
	const handleRef = useForkRef_default(ref, inputRefProp);
	const handleDisplayRef = React$1.useCallback((node) => {
		displayRef.current = node;
		if (node) setDisplayNode(node);
	}, []);
	const anchorElement = displayNode?.parentNode;
	React$1.useImperativeHandle(handleRef, () => ({
		focus: () => {
			displayRef.current.focus();
		},
		node: inputRef.current,
		value
	}), [value]);
	const open = displayNode !== null && openState;
	const resetClosedTypeahead = React$1.useCallback(() => {
		typeaheadResetTimer.clear();
		closedTypeaheadRef.current.buffer = "";
		closedTypeaheadRef.current.previousSearchIndex = null;
		closedTypeaheadRef.current.matchedIndex = null;
	}, [typeaheadResetTimer]);
	useEnhancedEffect_default(() => {
		openRef.current = open;
		if (open) resetClosedTypeahead();
	}, [open, resetClosedTypeahead]);
	const clearSelectionTimers = React$1.useCallback(() => {
		selectedMouseUpTimer.clear();
		unselectedMouseUpTimer.clear();
	}, [selectedMouseUpTimer, unselectedMouseUpTimer]);
	const resetMouseUpSelection = React$1.useCallback(() => {
		clearSelectionTimers();
		didPointerDownOnItemRef.current = false;
		selectionRef.current = {
			allowSelectedMouseUp: false,
			allowUnselectedMouseUp: false
		};
	}, [clearSelectionTimers]);
	const clearOpeningMouseUpListener = React$1.useCallback(() => {
		if (openingMouseUpListenerCleanupRef.current) {
			openingMouseUpListenerCleanupRef.current();
			openingMouseUpListenerCleanupRef.current = null;
		}
	}, []);
	React$1.useEffect(() => {
		if (!open) {
			resetMouseUpSelection();
			clearOpeningMouseUpListener();
		}
	}, [
		open,
		resetMouseUpSelection,
		clearOpeningMouseUpListener
	]);
	React$1.useEffect(() => {
		return () => {
			resetMouseUpSelection();
			clearOpeningMouseUpListener();
			resetClosedTypeahead();
		};
	}, [
		resetMouseUpSelection,
		clearOpeningMouseUpListener,
		resetClosedTypeahead
	]);
	React$1.useEffect(() => {
		if (!open || !anchorElement || autoWidth) return;
		if (typeof ResizeObserver === "undefined") return;
		const observer = new ResizeObserver(() => {
			setMenuMinWidthState(anchorElement.clientWidth);
		});
		observer.observe(anchorElement);
		return () => {
			observer.disconnect();
		};
	}, [
		open,
		anchorElement,
		autoWidth
	]);
	React$1.useEffect(() => {
		if (defaultOpen && openState && displayNode && !isOpenControlled) {
			setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
			displayRef.current.focus();
		}
	}, [displayNode, autoWidth]);
	React$1.useEffect(() => {
		if (autoFocus) displayRef.current.focus();
	}, [autoFocus]);
	React$1.useEffect(() => {
		if (!labelId) return;
		const label = ownerDocument_default(displayRef.current).getElementById(labelId);
		if (label) {
			const handler = () => {
				if (getSelection().isCollapsed) displayRef.current.focus();
			};
			label.addEventListener("click", handler);
			return () => {
				label.removeEventListener("click", handler);
			};
		}
	}, [labelId]);
	const update = useEventCallback_default((openParam, event) => {
		if (!openParam) {
			resetMouseUpSelection();
			clearOpeningMouseUpListener();
		}
		if (openParam) {
			resetClosedTypeahead();
			setOpenInteractionType(getOpenInteractionType(event));
			if (onOpen) onOpen(event);
		} else {
			setOpenInteractionType(null);
			if (onClose) onClose(event);
		}
		if (!isOpenControlled) {
			openRef.current = openParam;
			setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
			setOpenState(openParam);
		}
	});
	const scheduleMouseUpSelection = () => {
		resetMouseUpSelection();
		if (!hasSelectedItemInListRef.current) selectedMouseUpTimer.start(SELECTED_MOUSE_UP_DELAY, () => {
			selectionRef.current.allowSelectedMouseUp = true;
			selectionRef.current.allowUnselectedMouseUp = true;
		});
		else unselectedMouseUpTimer.start(UNSELECTED_MOUSE_UP_DELAY, () => {
			selectionRef.current.allowUnselectedMouseUp = true;
			selectedMouseUpTimer.start(UNSELECTED_MOUSE_UP_DELAY, () => {
				selectionRef.current.allowSelectedMouseUp = true;
			});
		});
	};
	const handleMouseDown = (event) => {
		onMouseDown?.(event);
		if (event.button !== 0) return;
		event.preventDefault();
		if (!displayRef.current) return;
		displayRef.current.focus();
		const doc = ownerDocument_default(event.currentTarget);
		scheduleMouseUpSelection();
		clearOpeningMouseUpListener();
		const handleMouseUp = (mouseEvent) => {
			openingMouseUpListenerCleanupRef.current = null;
			if (!displayRef.current) return;
			if (isMouseEventInsideElement(mouseEvent, displayRef.current) || isMouseEventInsideElement(mouseEvent, paperRef.current)) return;
			if (!openRef.current && isOpenControlled) return;
			update(false, mouseEvent);
		};
		doc.addEventListener("mouseup", handleMouseUp, {
			capture: true,
			once: true
		});
		openingMouseUpListenerCleanupRef.current = () => {
			doc.removeEventListener("mouseup", handleMouseUp, true);
		};
		update(true, event);
	};
	const handleClose = (event) => {
		update(false, event);
	};
	const childrenArray = React$1.Children.toArray(children);
	const handleChange = (event) => {
		const child = childrenArray.find((childItem) => childItem.props.value === event.target.value);
		if (child === void 0) return;
		setValueState(child.props.value);
		if (onChange) onChange(event, child);
	};
	const handleValueChange = (event, child, newValue) => {
		setValueState(newValue);
		if (onChange) {
			const nativeEvent = event.nativeEvent || event;
			const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
			Object.defineProperty(clonedEvent, "target", {
				writable: true,
				value: {
					value: newValue,
					name
				}
			});
			onChange(clonedEvent, child);
		}
	};
	const handleItemClick = (child) => (event) => {
		didPointerDownOnItemRef.current = false;
		let newValue;
		if (!event.currentTarget.hasAttribute("tabindex")) return;
		if (multiple) {
			newValue = Array.isArray(value) ? value.slice() : [];
			const itemIndex = value.indexOf(child.props.value);
			if (itemIndex === -1) newValue.push(child.props.value);
			else newValue.splice(itemIndex, 1);
		} else newValue = child.props.value;
		if (child.props.onClick) child.props.onClick(event);
		if (value !== newValue) handleValueChange(event, child, newValue);
		if (!multiple) update(false, event);
	};
	const handleItemMouseUp = (child, selected) => (event) => {
		child.props.onMouseUp?.(event);
		if (didPointerDownOnItemRef.current) {
			didPointerDownOnItemRef.current = false;
			return;
		}
		const disallowSelectedMouseUp = !selectionRef.current.allowSelectedMouseUp && selected;
		const disallowUnselectedMouseUp = !selectionRef.current.allowUnselectedMouseUp && !selected;
		if (disallowSelectedMouseUp || disallowUnselectedMouseUp) return;
		event.currentTarget.click();
	};
	const handleClosedTypeahead = (event) => {
		const state = closedTypeaheadRef.current;
		const hasActiveBuffer = state.buffer !== "";
		if (open || multiple || disabled || event.defaultPrevented || event.nativeEvent?.isComposing || event.key.length !== 1 || event.ctrlKey || event.metaKey || event.altKey || event.key === SPACE && !hasActiveBuffer) return false;
		if (event.key === SPACE) event.preventDefault();
		const isNewSession = state.buffer === "";
		const { options: searchableOptions, selectedIndex } = getTypeaheadOptions(childrenArray, value);
		if (searchableOptions.length === 0) {
			if (event.key !== SPACE) resetClosedTypeahead();
			return true;
		}
		if (isNewSession) state.previousSearchIndex = selectedIndex;
		const key = event.key.toLowerCase();
		if (state.buffer === key && canCycleRepeatedCharacter(searchableOptions, key)) {
			state.buffer = "";
			state.previousSearchIndex = state.matchedIndex;
		}
		state.buffer += key;
		typeaheadResetTimer.start(TYPEAHEAD_RESET_MS, resetClosedTypeahead);
		const matchingIndex = getMatchingOptionIndex(searchableOptions, state.buffer, (state.previousSearchIndex ?? -1) + 1);
		if (matchingIndex !== -1) {
			const matchedOption = searchableOptions[matchingIndex];
			state.matchedIndex = matchingIndex;
			if (!areEqualValues$1(value, matchedOption.value)) handleValueChange(event, matchedOption.child, matchedOption.value);
			return true;
		}
		if (event.key !== SPACE) resetClosedTypeahead();
		return true;
	};
	const handleKeyDown = (event) => {
		if (!readOnly) {
			const isClosedTypeaheadHandled = handleClosedTypeahead(event);
			const isOpenKey = event.key === SPACE || event.key === ARROW_UP || event.key === ARROW_DOWN || event.key === ENTER;
			if (!isClosedTypeaheadHandled && isOpenKey) {
				event.preventDefault();
				update(true, event);
			}
			onKeyDown?.(event);
		}
	};
	const handleBlur = (event) => {
		resetClosedTypeahead();
		if (!open && onBlur) {
			Object.defineProperty(event, "target", {
				writable: true,
				value: {
					value,
					name
				}
			});
			onBlur(event);
		}
	};
	const handleItemKeyDown = (child) => (event) => {
		child?.props?.onKeyDown?.(event);
		if (event.key === SPACE && event.target === event.currentTarget && !event.defaultPrevented) {
			event.preventDefault();
			if (!event.repeat) event.currentTarget.click();
		}
	};
	delete other["aria-invalid"];
	let display;
	let displaySingle;
	const displayMultiple = [];
	let computeDisplay = false;
	let foundMatch = false;
	if (isFilled({ value }) || displayEmpty) {
		if (renderValue) display = renderValue(value);
		else computeDisplay = true;
	}
	const items = childrenArray.map((child) => {
		if (!/*#__PURE__*/ React$1.isValidElement(child)) return null;
		if ((0, import_react_is.isFragment)(child)) console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join("\n"));
		let selected;
		if (multiple) {
			if (!Array.isArray(value)) throw new Error("MUI: The `value` prop must be an array when using the `Select` component with `multiple`.");
			selected = value.some((v) => areEqualValues$1(v, child.props.value));
			if (selected && computeDisplay) displayMultiple.push(child.props.children);
		} else {
			selected = areEqualValues$1(value, child.props.value);
			if (selected && computeDisplay) displaySingle = child.props.children;
		}
		if (selected) foundMatch = true;
		return /*#__PURE__*/ React$1.cloneElement(child, {
			"aria-selected": selected ? "true" : "false",
			onMouseDown: (event) => {
				didPointerDownOnItemRef.current = true;
				child.props.onMouseDown?.(event);
			},
			onPointerDown: (event) => {
				didPointerDownOnItemRef.current = true;
				child.props.onPointerDown?.(event);
			},
			onClick: handleItemClick(child),
			onMouseUp: handleItemMouseUp(child, selected),
			onKeyUp: (event) => {
				if (event.key === SPACE) event.preventDefault();
				if (child.props.onKeyUp) child.props.onKeyUp(event);
			},
			onKeyDown: handleItemKeyDown(child),
			role: "option",
			selected,
			value: void 0,
			"data-value": child.props.value
		});
	});
	useEnhancedEffect_default(() => {
		hasSelectedItemInListRef.current = foundMatch;
		if (!open && !multiple && !foundMatch) resetClosedTypeahead();
	}, [
		foundMatch,
		multiple,
		open,
		resetClosedTypeahead
	]);
	React$1.useEffect(() => {
		if (!foundMatch && !multiple && value !== "") {
			const values = childrenArray.map((child) => child.props.value);
			console.warn([
				`MUI: You have provided an out-of-range value \`${value}\` for the select ${name ? `(name="${name}") ` : ""}component.`,
				"Consider providing a value that matches one of the available options or ''.",
				`The available values are ${values.filter((x) => x != null).map((x) => `\`${x}\``).join(", ") || "\"\""}.`
			].join("\n"));
		}
	}, [
		foundMatch,
		childrenArray,
		multiple,
		name,
		value
	]);
	if (computeDisplay) {
		if (multiple) {
			if (displayMultiple.length === 0) display = null;
			else display = displayMultiple.reduce((output, child, index) => {
				output.push(child);
				if (index < displayMultiple.length - 1) output.push(", ");
				return output;
			}, []);
		} else display = displaySingle;
	}
	let menuMinWidth = menuMinWidthState;
	if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
	let tabIndex;
	if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
	else tabIndex = disabled ? null : 0;
	const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : void 0);
	const ownerState = {
		...props,
		variant,
		value,
		open,
		error
	};
	const classes = useUtilityClasses$22(ownerState);
	const menuPaperSlotProps = typeof MenuProps.slotProps?.paper === "function" ? MenuProps.slotProps.paper(ownerState) : MenuProps.slotProps?.paper;
	const handlePaperRef = useForkRef_default(menuPaperSlotProps?.ref, paperRef);
	const menuListSlotProps = typeof MenuProps.slotProps?.list === "function" ? MenuProps.slotProps.list(ownerState) : MenuProps.slotProps?.list;
	const listboxId = useId();
	const nativeInputId = useId();
	return /*#__PURE__*/ jsxs(React$1.Fragment, { children: [
		/*#__PURE__*/ jsx(SelectSelect, {
			as: "div",
			ref: handleDisplayRef,
			tabIndex,
			role: "combobox",
			"aria-controls": open ? listboxId : void 0,
			"aria-disabled": disabled ? "true" : void 0,
			"aria-expanded": open ? "true" : "false",
			"aria-haspopup": "listbox",
			"aria-readonly": readOnly ? "true" : void 0,
			"aria-label": ariaLabel,
			"aria-labelledby": labelId,
			"aria-describedby": ariaDescribedby,
			"aria-required": required ? "true" : void 0,
			"aria-invalid": error ? "true" : void 0,
			onKeyDown: handleKeyDown,
			onMouseDown: disabled || readOnly ? null : handleMouseDown,
			onBlur: handleBlur,
			onFocus,
			...SelectDisplayProps,
			ownerState,
			className: clsx(SelectDisplayProps.className, classes.select, className),
			id: buttonId,
			children: isEmpty(display) ? _span || (_span = /*#__PURE__*/ jsx("span", {
				className: "notranslate",
				"aria-hidden": true,
				children: "​"
			})) : display
		}),
		/*#__PURE__*/ jsx(SelectNativeInput, {
			"aria-invalid": error,
			value: Array.isArray(value) ? value.join(",") : value,
			name,
			ref: inputRef,
			"aria-hidden": true,
			onChange: handleChange,
			tabIndex: -1,
			disabled,
			readOnly,
			className: classes.nativeInput,
			autoFocus,
			required,
			...other,
			id: other.id ?? nativeInputId,
			ownerState
		}),
		/*#__PURE__*/ jsx(SelectIcon, {
			as: IconComponent,
			className: classes.icon,
			ownerState
		}),
		/*#__PURE__*/ jsx(SelectFocusSourceProvider, {
			value: openInteractionType,
			children: /*#__PURE__*/ jsx(Menu$1, {
				id: `menu-${name || ""}`,
				anchorEl: anchorElement,
				open,
				onClose: handleClose,
				anchorOrigin: {
					vertical: "bottom",
					horizontal: "center"
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "center"
				},
				...MenuProps,
				slotProps: {
					...MenuProps.slotProps,
					list: {
						"aria-labelledby": labelId,
						role: "listbox",
						"aria-multiselectable": multiple ? "true" : void 0,
						disableListWrap: true,
						id: listboxId,
						...menuListSlotProps
					},
					paper: {
						...menuPaperSlotProps,
						ref: handlePaperRef,
						style: {
							minWidth: menuMinWidth,
							...menuPaperSlotProps?.style
						}
					}
				},
				children: items
			})
		})
	] });
});
SelectInput$1.propTypes = {
	/**
	* @ignore
	*/
	"aria-describedby": import_prop_types.default.string,
	/**
	* @ignore
	*/
	"aria-label": import_prop_types.default.string,
	/**
	* @ignore
	*/
	autoFocus: import_prop_types.default.bool,
	/**
	* If `true`, the width of the popover will automatically be set according to the items inside the
	* menu, otherwise it will be at least the width of the select input.
	*/
	autoWidth: import_prop_types.default.bool,
	/**
	* The option elements to populate the select with.
	* Can be some `<MenuItem>` elements.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* The CSS class name of the select element.
	*/
	className: import_prop_types.default.string,
	/**
	* If `true`, the component is toggled on mount. Use when the component open state is not controlled.
	* You can only use it when the `native` prop is `false` (default).
	*/
	defaultOpen: import_prop_types.default.bool,
	/**
	* The default value. Use when the component is not controlled.
	*/
	defaultValue: import_prop_types.default.any,
	/**
	* If `true`, the select is disabled.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the selected item is displayed even if its value is empty.
	*/
	displayEmpty: import_prop_types.default.bool,
	/**
	* If `true`, the `select input` will indicate an error.
	*/
	error: import_prop_types.default.bool,
	/**
	* The icon that displays the arrow.
	*/
	IconComponent: import_prop_types.default.elementType.isRequired,
	/**
	* Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
	* Equivalent to `ref`
	*/
	inputRef: refType,
	/**
	* The ID of an element that acts as an additional label. The Select will
	* be labelled by the additional label and the selected value.
	*/
	labelId: import_prop_types.default.string,
	/**
	* Props applied to the [`Menu`](/material-ui/api/menu/) element.
	*/
	MenuProps: import_prop_types.default.object,
	/**
	* If `true`, `value` must be an array and the menu will support multiple selections.
	*/
	multiple: import_prop_types.default.bool,
	/**
	* Name attribute of the `select` or hidden `input` element.
	*/
	name: import_prop_types.default.string,
	/**
	* @ignore
	*/
	onBlur: import_prop_types.default.func,
	/**
	* Callback fired when a menu item is selected.
	*
	* @param {object} event The event source of the callback.
	* You can pull out the new value by accessing `event.target.value` (any).
	* @param {object} [child] The react element that was selected.
	*/
	onChange: import_prop_types.default.func,
	/**
	* Callback fired when the component requests to be closed.
	* Use in controlled mode (see open).
	*
	* @param {object} event The event source of the callback.
	*/
	onClose: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onFocus: import_prop_types.default.func,
	/**
	* Callback fired when the component requests to be opened.
	* Use in controlled mode (see open).
	*
	* @param {object} event The event source of the callback.
	*/
	onOpen: import_prop_types.default.func,
	/**
	* If `true`, the component is shown.
	*/
	open: import_prop_types.default.bool,
	/**
	* @ignore
	*/
	readOnly: import_prop_types.default.bool,
	/**
	* Render the selected value.
	*
	* @param {any} value The `value` provided to the component.
	* @returns {ReactNode}
	*/
	renderValue: import_prop_types.default.func,
	/**
	* If `true`, the component is required.
	*/
	required: import_prop_types.default.bool,
	/**
	* Props applied to the clickable div element.
	*/
	SelectDisplayProps: import_prop_types.default.object,
	/**
	* @ignore
	*/
	tabIndex: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* @ignore
	*/
	type: import_prop_types.default.any,
	/**
	* The input value.
	*/
	value: import_prop_types.default.any,
	/**
	* The variant to use.
	*/
	variant: import_prop_types.default.oneOf([
		"standard",
		"outlined",
		"filled"
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Select/Select.mjs
const useUtilityClasses$21 = (ownerState) => {
	const { classes } = ownerState;
	const composedClasses = composeClasses({ root: ["root"] }, getSelectUtilityClasses, classes);
	return {
		...classes,
		...composedClasses
	};
};
const styledRootConfig = {
	name: "MuiSelect",
	slot: "Root",
	shouldForwardProp: (prop) => rootShouldForwardProp(prop) && prop !== "variant"
};
const StyledInput = styled$2(Input$1, styledRootConfig)("");
const StyledOutlinedInput = styled$2(OutlinedInput, styledRootConfig)("");
const StyledFilledInput = styled$2(FilledInput, styledRootConfig)("");
const Select$1 = /*#__PURE__*/ React$1.forwardRef(function Select(inProps, ref) {
	const props = useDefaultProps({
		name: "MuiSelect",
		props: inProps
	});
	const { autoWidth = false, children, classes: classesProp = {}, className, defaultOpen = false, displayEmpty = false, IconComponent = ArrowDropDown_default, id, input, inputProps, label, labelId, MenuProps, multiple = false, native = false, onClose, onOpen, open, renderValue, SelectDisplayProps, variant: variantProp = "outlined", ...other } = props;
	const inputComponent = native ? NativeSelectInput : SelectInput$1;
	const [fcs] = useFormControlState({
		props,
		states: ["variant", "error"]
	});
	const variant = fcs.variant || variantProp;
	const ownerState = {
		...props,
		variant,
		classes: classesProp
	};
	const classes = useUtilityClasses$21(ownerState);
	const { root, ...restOfClasses } = classes;
	const InputComponent = input || {
		standard: /*#__PURE__*/ jsx(StyledInput, { ownerState }),
		outlined: /*#__PURE__*/ jsx(StyledOutlinedInput, {
			label,
			ownerState
		}),
		filled: /*#__PURE__*/ jsx(StyledFilledInput, { ownerState })
	}[variant];
	const inputComponentRef = useForkRef_default(ref, getReactElementRef(InputComponent));
	return /*#__PURE__*/ jsx(React$1.Fragment, { children: /*#__PURE__*/ React$1.cloneElement(InputComponent, {
		inputComponent,
		inputProps: {
			children,
			error: fcs.error,
			IconComponent,
			variant,
			type: void 0,
			multiple,
			...native ? { id } : {
				autoWidth,
				defaultOpen,
				displayEmpty,
				labelId,
				MenuProps,
				onClose,
				onOpen,
				open,
				renderValue,
				SelectDisplayProps: {
					id,
					...SelectDisplayProps
				}
			},
			...inputProps,
			classes: inputProps ? deepmerge(restOfClasses, inputProps.classes) : restOfClasses,
			...input ? input.props.inputProps : {}
		},
		...(multiple && native || displayEmpty) && variant === "outlined" ? { notched: true } : {},
		ref: inputComponentRef,
		className: clsx(InputComponent.props.className, className, classes.root),
		...!input && { variant },
		...other
	}) });
});
Select$1.propTypes = {
	/**
	* If `true`, the width of the popover will automatically be set according to the items inside the
	* menu, otherwise it will be at least the width of the select input.
	* @default false
	*/
	autoWidth: import_prop_types.default.bool,
	/**
	* The option elements to populate the select with.
	* Can be some `MenuItem` when `native` is false and `option` when `native` is true.
	*
	* ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	* @default {}
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
	* You can only use it when the `native` prop is `false` (default).
	* @default false
	*/
	defaultOpen: import_prop_types.default.bool,
	/**
	* The default value. Use when the component is not controlled.
	*/
	defaultValue: import_prop_types.default.any,
	/**
	* If `true`, a value is displayed even if no items are selected.
	*
	* In order to display a meaningful value, a function can be passed to the `renderValue` prop which
	* returns the value to be displayed when no items are selected.
	*
	* ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
	* The label should either be hidden or forced to a shrunk state.
	* @default false
	*/
	displayEmpty: import_prop_types.default.bool,
	/**
	* The icon that displays the arrow.
	* @default ArrowDropDownIcon
	*/
	IconComponent: import_prop_types.default.elementType,
	/**
	* The `id` of the wrapper element or the `select` element when `native`.
	*/
	id: import_prop_types.default.string,
	/**
	* An `Input` element; does not have to be a material-ui specific `Input`.
	*/
	input: import_prop_types.default.element,
	/**
	* [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
	* When `native` is `true`, the attributes are applied on the `select` element.
	*/
	inputProps: import_prop_types.default.object,
	/**
	* See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
	*/
	label: import_prop_types.default.node,
	/**
	* The ID of an element that acts as an additional label. The Select will
	* be labelled by the additional label and the selected value.
	*/
	labelId: import_prop_types.default.string,
	/**
	* Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
	*/
	MenuProps: import_prop_types.default.object,
	/**
	* If `true`, `value` must be an array and the menu will support multiple selections.
	* @default false
	*/
	multiple: import_prop_types.default.bool,
	/**
	* If `true`, the component uses a native `select` element.
	* @default false
	*/
	native: import_prop_types.default.bool,
	/**
	* Callback fired when a menu item is selected.
	*
	* @param {SelectChangeEvent<Value>} event The event source of the callback.
	* You can pull out the new value by accessing `event.target.value` (any).
	* **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
	* @param {object} [child] The react element that was selected when `native` is `false` (default).
	*/
	onChange: import_prop_types.default.func,
	/**
	* Callback fired when the component requests to be closed.
	* Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
	*
	* @param {object} event The event source of the callback.
	*/
	onClose: import_prop_types.default.func,
	/**
	* Callback fired when the component requests to be opened.
	* Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
	*
	* @param {object} event The event source of the callback.
	*/
	onOpen: import_prop_types.default.func,
	/**
	* If `true`, the component is shown.
	* You can only use it when the `native` prop is `false` (default).
	*/
	open: import_prop_types.default.bool,
	/**
	* Render the selected value.
	* You can only use it when the `native` prop is `false` (default).
	*
	* @param {any} value The `value` provided to the component.
	* @returns {ReactNode}
	*/
	renderValue: import_prop_types.default.func,
	/**
	* Props applied to the clickable div element.
	*/
	SelectDisplayProps: import_prop_types.default.object,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The `input` value. Providing an empty string will select no options.
	* Set to an empty string `''` if you don't want any of the available options to be selected.
	*
	* If the value is an object it must have reference equality with the option in order to be selected.
	* If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
	*/
	value: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([""]), import_prop_types.default.any]),
	/**
	* The variant to use.
	* @default 'outlined'
	*/
	variant: import_prop_types.default.oneOf([
		"filled",
		"outlined",
		"standard"
	])
};
Select$1.muiName = "Select";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Skeleton/skeletonClasses.mjs
function getSkeletonUtilityClass(slot) {
	return generateUtilityClass("MuiSkeleton", slot);
}
const skeletonClasses = generateUtilityClasses("MuiSkeleton", [
	"root",
	"text",
	"rectangular",
	"rounded",
	"circular",
	"pulse",
	"wave",
	"withChildren",
	"fitContent",
	"heightAuto"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Skeleton/Skeleton.mjs
const useUtilityClasses$20 = (ownerState) => {
	const { classes, variant, animation, hasChildren, width, height } = ownerState;
	return composeClasses({ root: [
		"root",
		variant,
		animation,
		hasChildren && "withChildren",
		hasChildren && !width && "fitContent",
		hasChildren && !height && "heightAuto"
	] }, getSkeletonUtilityClass, classes);
};
const pulseKeyframe = keyframes`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const waveKeyframe = keyframes`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
const pulseAnimation = typeof pulseKeyframe !== "string" ? css`
        animation: ${pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const waveAnimation = typeof waveKeyframe !== "string" ? css`
        &::after {
          animation: ${waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const SkeletonRoot = styled$2("span", {
	name: "MuiSkeleton",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[ownerState.variant],
			ownerState.animation !== false && styles[ownerState.animation],
			ownerState.hasChildren && styles.withChildren,
			ownerState.hasChildren && !ownerState.width && styles.fitContent,
			ownerState.hasChildren && !ownerState.height && styles.heightAuto
		];
	}
})(memoTheme(({ theme }) => {
	const radiusUnit = getUnit(theme.shape.borderRadius) || "px";
	const radiusValue = toUnitless(theme.shape.borderRadius);
	const reducedMotionPulseStyles = getReducedMotionStyles(theme, { animation: "none" });
	const reducedMotionWaveStyles = getReducedMotionStyles(theme, { "&::after": {
		animation: "none",
		display: "none"
	} });
	return {
		display: "block",
		backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : theme.alpha(theme.palette.text.primary, theme.palette.mode === "light" ? .11 : .13),
		height: "1.2em",
		variants: [
			{
				props: { variant: "text" },
				style: {
					marginTop: 0,
					marginBottom: 0,
					height: "auto",
					transformOrigin: "0 55%",
					transform: "scale(1, 0.60)",
					borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / .6 * 10) / 10}${radiusUnit}`,
					"&:empty:before": { content: "\"\\00a0\"" }
				}
			},
			{
				props: { variant: "circular" },
				style: { borderRadius: "50%" }
			},
			{
				props: { variant: "rounded" },
				style: { borderRadius: (theme.vars || theme).shape.borderRadius }
			},
			{
				props: ({ ownerState }) => ownerState.hasChildren,
				style: { "& > *": { visibility: "hidden" } }
			},
			{
				props: ({ ownerState }) => ownerState.hasChildren && !ownerState.width,
				style: { maxWidth: "fit-content" }
			},
			{
				props: ({ ownerState }) => ownerState.hasChildren && !ownerState.height,
				style: { height: "auto" }
			},
			{
				props: { animation: "pulse" },
				style: pulseAnimation || { animation: `${pulseKeyframe} 2s ease-in-out 0.5s infinite` }
			},
			...reducedMotionPulseStyles ? [{
				props: { animation: "pulse" },
				style: reducedMotionPulseStyles
			}] : [],
			{
				props: { animation: "wave" },
				style: {
					position: "relative",
					overflow: "hidden",
					WebkitMaskImage: "-webkit-radial-gradient(white, black)",
					"&::after": {
						background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
						content: "\"\"",
						position: "absolute",
						transform: "translateX(-100%)",
						bottom: 0,
						left: 0,
						right: 0,
						top: 0
					}
				}
			},
			{
				props: { animation: "wave" },
				style: waveAnimation || { "&::after": { animation: `${waveKeyframe} 2s linear 0.5s infinite` } }
			},
			...reducedMotionWaveStyles ? [{
				props: { animation: "wave" },
				style: reducedMotionWaveStyles
			}] : []
		]
	};
}));
const Skeleton$1 = /*#__PURE__*/ React$1.forwardRef(function Skeleton(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiSkeleton"
	});
	const { animation = "pulse", className, component = "span", height, style, variant = "text", width, ...other } = props;
	const ownerState = {
		...props,
		animation,
		component,
		variant,
		hasChildren: Boolean(other.children)
	};
	const classes = useUtilityClasses$20(ownerState);
	return /*#__PURE__*/ jsx(SkeletonRoot, {
		as: component,
		ref,
		className: clsx(classes.root, className),
		ownerState,
		...other,
		style: {
			width,
			height,
			...style
		}
	});
});
Skeleton$1.propTypes = {
	/**
	* The animation.
	* If `false` the animation effect is disabled.
	* @default 'pulse'
	*/
	animation: import_prop_types.default.oneOf([
		"pulse",
		"wave",
		false
	]),
	/**
	* Optional children to infer width and height from.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* Height of the skeleton.
	* Useful when you don't want to adapt the skeleton to a text element but for instance a card.
	*/
	height: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string]),
	/**
	* @ignore
	*/
	style: import_prop_types.default.object,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The type of content that will be rendered.
	* @default 'text'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"circular",
		"rectangular",
		"rounded",
		"text"
	]), import_prop_types.default.string]),
	/**
	* Width of the skeleton.
	* Useful when the skeleton is inside an inline element with no width of its own.
	*/
	width: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Snackbar/useSnackbar.mjs
function useSnackbar(parameters = {}) {
	const { autoHideDuration = null, disableWindowBlurListener = false, onClose, open, resumeHideDuration } = parameters;
	const timerAutoHide = useTimeout();
	React$1.useEffect(() => {
		if (!open) return;
		/**
		* @param {KeyboardEvent} nativeEvent
		*/
		function handleKeyDown(nativeEvent) {
			if (!nativeEvent.defaultPrevented) {
				if (nativeEvent.key === "Escape") onClose?.(nativeEvent, "escapeKeyDown");
			}
		}
		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [open, onClose]);
	const handleClose = useEventCallback((event, reason) => {
		onClose?.(event, reason);
	});
	const setAutoHideTimer = useEventCallback((autoHideDurationParam) => {
		if (!onClose || autoHideDurationParam == null) return;
		timerAutoHide.start(autoHideDurationParam, () => {
			handleClose(null, "timeout");
		});
	});
	React$1.useEffect(() => {
		if (open) setAutoHideTimer(autoHideDuration);
		return timerAutoHide.clear;
	}, [
		open,
		autoHideDuration,
		setAutoHideTimer,
		timerAutoHide
	]);
	const handleClickAway = (event) => {
		onClose?.(event, "clickaway");
	};
	const handlePause = timerAutoHide.clear;
	const handleResume = React$1.useCallback(() => {
		if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * .5);
	}, [
		autoHideDuration,
		resumeHideDuration,
		setAutoHideTimer
	]);
	const createHandleBlur = (otherHandlers) => (event) => {
		const onBlurCallback = otherHandlers.onBlur;
		onBlurCallback?.(event);
		handleResume();
	};
	const createHandleFocus = (otherHandlers) => (event) => {
		const onFocusCallback = otherHandlers.onFocus;
		onFocusCallback?.(event);
		handlePause();
	};
	const createMouseEnter = (otherHandlers) => (event) => {
		const onMouseEnterCallback = otherHandlers.onMouseEnter;
		onMouseEnterCallback?.(event);
		handlePause();
	};
	const createMouseLeave = (otherHandlers) => (event) => {
		const onMouseLeaveCallback = otherHandlers.onMouseLeave;
		onMouseLeaveCallback?.(event);
		handleResume();
	};
	React$1.useEffect(() => {
		if (!disableWindowBlurListener && open) {
			window.addEventListener("focus", handleResume);
			window.addEventListener("blur", handlePause);
			return () => {
				window.removeEventListener("focus", handleResume);
				window.removeEventListener("blur", handlePause);
			};
		}
	}, [
		disableWindowBlurListener,
		open,
		handleResume,
		handlePause
	]);
	const getRootProps = (externalProps = {}) => {
		const externalEventHandlers = {
			...extractEventHandlers(parameters),
			...extractEventHandlers(externalProps)
		};
		return {
			role: "presentation",
			...externalProps,
			...externalEventHandlers,
			onBlur: createHandleBlur(externalEventHandlers),
			onFocus: createHandleFocus(externalEventHandlers),
			onMouseEnter: createMouseEnter(externalEventHandlers),
			onMouseLeave: createMouseLeave(externalEventHandlers)
		};
	};
	return {
		getRootProps,
		onClickAway: handleClickAway
	};
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/SnackbarContent/snackbarContentClasses.mjs
function getSnackbarContentUtilityClass(slot) {
	return generateUtilityClass("MuiSnackbarContent", slot);
}
generateUtilityClasses("MuiSnackbarContent", [
	"root",
	"message",
	"action"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/SnackbarContent/SnackbarContent.mjs
const useUtilityClasses$19 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({
		root: ["root"],
		action: ["action"],
		message: ["message"]
	}, getSnackbarContentUtilityClass, classes);
};
const SnackbarContentRoot = styled$2(Paper, {
	name: "MuiSnackbarContent",
	slot: "Root"
})(memoTheme(({ theme }) => {
	const emphasis = theme.palette.mode === "light" ? .8 : .98;
	return {
		...theme.focusVisible && applyChildrenFocusVisible(`0 0 0 4px ${(theme.vars || theme).palette.background.default}`),
		...theme.typography.body2,
		color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(emphasize(theme.palette.background.default, emphasis)),
		backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : emphasize(theme.palette.background.default, emphasis),
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		padding: "6px 16px",
		flexGrow: 1,
		[theme.breakpoints.up("sm")]: {
			flexGrow: "initial",
			minWidth: 288
		}
	};
}));
const SnackbarContentMessage = styled$2("div", {
	name: "MuiSnackbarContent",
	slot: "Message"
})({ padding: "8px 0" });
const SnackbarContentAction = styled$2("div", {
	name: "MuiSnackbarContent",
	slot: "Action"
})({
	display: "flex",
	alignItems: "center",
	marginLeft: "auto",
	paddingLeft: 16,
	marginRight: -8
});
const SnackbarContent$1 = /*#__PURE__*/ React$1.forwardRef(function SnackbarContent(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiSnackbarContent"
	});
	const { action, className, message, role = "alert", ...other } = props;
	const ownerState = props;
	const classes = useUtilityClasses$19(ownerState);
	return /*#__PURE__*/ jsxs(SnackbarContentRoot, {
		role,
		elevation: 6,
		className: clsx(classes.root, className),
		ownerState,
		ref,
		...other,
		children: [/*#__PURE__*/ jsx(SnackbarContentMessage, {
			className: classes.message,
			ownerState,
			children: message
		}), action ? /*#__PURE__*/ jsx(SnackbarContentAction, {
			className: classes.action,
			ownerState,
			children: action
		}) : null]
	});
});
SnackbarContent$1.propTypes = {
	/**
	* The action to display. It renders after the message, at the end of the snackbar.
	*/
	action: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The message to display.
	*/
	message: import_prop_types.default.node,
	/**
	* The ARIA role attribute of the element.
	* @default 'alert'
	*/
	role: import_prop_types.default.string,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Snackbar/snackbarClasses.mjs
function getSnackbarUtilityClass(slot) {
	return generateUtilityClass("MuiSnackbar", slot);
}
const snackbarClasses = generateUtilityClasses("MuiSnackbar", [
	"root",
	"anchorOriginTopCenter",
	"anchorOriginBottomCenter",
	"anchorOriginTopRight",
	"anchorOriginBottomRight",
	"anchorOriginTopLeft",
	"anchorOriginBottomLeft"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Snackbar/Snackbar.mjs
const useUtilityClasses$18 = (ownerState) => {
	const { classes, anchorOrigin } = ownerState;
	const slots = { root: ["root", `anchorOrigin${capitalize_default(anchorOrigin.vertical)}${capitalize_default(anchorOrigin.horizontal)}`] };
	return composeClasses(slots, getSnackbarUtilityClass, classes);
};
const SnackbarRoot = styled$2("div", {
	name: "MuiSnackbar",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, styles[`anchorOrigin${capitalize_default(ownerState.anchorOrigin.vertical)}${capitalize_default(ownerState.anchorOrigin.horizontal)}`]];
	}
})(memoTheme(({ theme }) => ({
	zIndex: (theme.vars || theme).zIndex.snackbar,
	position: "fixed",
	display: "flex",
	left: 8,
	right: 8,
	justifyContent: "center",
	alignItems: "center",
	variants: [
		{
			props: ({ ownerState }) => ownerState.anchorOrigin.vertical === "top",
			style: {
				top: 8,
				[theme.breakpoints.up("sm")]: { top: 24 }
			}
		},
		{
			props: ({ ownerState }) => ownerState.anchorOrigin.vertical !== "top",
			style: {
				bottom: 8,
				[theme.breakpoints.up("sm")]: { bottom: 24 }
			}
		},
		{
			props: ({ ownerState }) => ownerState.anchorOrigin.horizontal === "left",
			style: {
				justifyContent: "flex-start",
				[theme.breakpoints.up("sm")]: {
					left: 24,
					right: "auto"
				}
			}
		},
		{
			props: ({ ownerState }) => ownerState.anchorOrigin.horizontal === "right",
			style: {
				justifyContent: "flex-end",
				[theme.breakpoints.up("sm")]: {
					right: 24,
					left: "auto"
				}
			}
		},
		{
			props: ({ ownerState }) => ownerState.anchorOrigin.horizontal === "center",
			style: { [theme.breakpoints.up("sm")]: {
				left: "50%",
				right: "auto",
				transform: "translateX(-50%)"
			} }
		}
	]
})));
const Snackbar$1 = /*#__PURE__*/ React$1.forwardRef(function Snackbar(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiSnackbar"
	});
	const theme = useTheme$1();
	const defaultTransitionDuration = {
		enter: theme.transitions.duration.enteringScreen,
		exit: theme.transitions.duration.leavingScreen
	};
	const { action, anchorOrigin: { vertical, horizontal } = {
		vertical: "bottom",
		horizontal: "left"
	}, autoHideDuration = null, children, className, disableWindowBlurListener = false, message, onBlur, onClose, onFocus, onMouseEnter, onMouseLeave, open, resumeHideDuration, slots = {}, slotProps = {}, transitionDuration = defaultTransitionDuration, ...other } = props;
	const ownerState = {
		...props,
		anchorOrigin: {
			vertical,
			horizontal
		},
		autoHideDuration,
		disableWindowBlurListener,
		transitionDuration
	};
	const classes = useUtilityClasses$18(ownerState);
	const { getRootProps, onClickAway } = useSnackbar(ownerState);
	const [exited, setExited] = React$1.useState(true);
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [Root, rootProps] = useSlot("root", {
		ref,
		className: [classes.root, className],
		elementType: SnackbarRoot,
		getSlotProps: getRootProps,
		externalForwardedProps: {
			...externalForwardedProps,
			...other
		},
		ownerState
	});
	const [ClickAwaySlot, { ownerState: clickAwayOwnerStateProp, ...clickAwayListenerProps }] = useSlot("clickAwayListener", {
		elementType: ClickAwayListener,
		externalForwardedProps,
		getSlotProps: (handlers) => ({ onClickAway: (...params) => {
			const event = params[0];
			handlers.onClickAway?.(...params);
			if (event?.defaultMuiPrevented) return;
			onClickAway(...params);
		} }),
		ownerState
	});
	const [ContentSlot, contentSlotProps] = useSlot("content", {
		elementType: SnackbarContent$1,
		shouldForwardComponentProp: true,
		externalForwardedProps,
		additionalProps: {
			message,
			action
		},
		ownerState
	});
	const [TransitionSlot, transitionProps] = useSlot("transition", {
		elementType: Grow,
		externalForwardedProps,
		getSlotProps: (handlers) => ({
			onEnter: (...params) => {
				handlers.onEnter?.(...params);
				setExited(false);
			},
			onExited: (...params) => {
				handlers.onExited?.(...params);
				setExited(true);
			}
		}),
		additionalProps: {
			appear: true,
			in: open,
			timeout: transitionDuration,
			direction: vertical === "top" ? "down" : "up"
		},
		ownerState
	});
	if (!open && exited) return null;
	return /*#__PURE__*/ jsx(ClickAwaySlot, {
		...clickAwayListenerProps,
		...slots.clickAwayListener && { ownerState: clickAwayOwnerStateProp },
		children: /*#__PURE__*/ jsx(Root, {
			...rootProps,
			children: /*#__PURE__*/ jsx(TransitionSlot, {
				...transitionProps,
				children: children || /*#__PURE__*/ jsx(ContentSlot, { ...contentSlotProps })
			})
		})
	});
});
Snackbar$1.propTypes = {
	/**
	* The action to display. It renders after the message, at the end of the snackbar.
	*/
	action: import_prop_types.default.node,
	/**
	* The anchor of the `Snackbar`.
	* On smaller screens, the component grows to occupy all the available width,
	* the horizontal alignment is ignored.
	* @default { vertical: 'bottom', horizontal: 'left' }
	*/
	anchorOrigin: import_prop_types.default.shape({
		horizontal: import_prop_types.default.oneOf([
			"center",
			"left",
			"right"
		]).isRequired,
		vertical: import_prop_types.default.oneOf(["bottom", "top"]).isRequired
	}),
	/**
	* The number of milliseconds to wait before automatically calling the
	* `onClose` function. `onClose` should then set the state of the `open`
	* prop to hide the Snackbar. This behavior is disabled by default with
	* the `null` value.
	* @default null
	*/
	autoHideDuration: import_prop_types.default.number,
	/**
	* Replace the `SnackbarContent` component.
	*/
	children: import_prop_types.default.element,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
	* @default false
	*/
	disableWindowBlurListener: import_prop_types.default.bool,
	/**
	* When displaying multiple consecutive snackbars using a single parent-rendered
	* `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
	* For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
	* in place, and features like `autoHideDuration` could be affected.
	*/
	key: () => null,
	/**
	* The message to display.
	*/
	message: import_prop_types.default.node,
	/**
	* @ignore
	*/
	onBlur: import_prop_types.default.func,
	/**
	* Callback fired when the component requests to be closed.
	* Typically `onClose` is used to set state in the parent component,
	* which is used to control the `Snackbar` `open` prop.
	* The `reason` parameter can optionally be used to control the response to `onClose`,
	* for example ignoring `clickaway`.
	*
	* @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
	* @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
	*/
	onClose: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onFocus: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onMouseEnter: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onMouseLeave: import_prop_types.default.func,
	/**
	* If `true`, the component is shown.
	*/
	open: import_prop_types.default.bool,
	/**
	* The number of milliseconds to wait before dismissing after user interaction.
	* If `autoHideDuration` prop isn't specified, it does nothing.
	* If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
	* we default to `autoHideDuration / 2` ms.
	*/
	resumeHideDuration: import_prop_types.default.number,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		clickAwayListener: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		content: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		transition: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		clickAwayListener: import_prop_types.default.elementType,
		content: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType,
		transition: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The duration for the transition, in milliseconds.
	* You may specify a single timeout for all transitions, or individually with an object.
	* @default {
	*   enter: theme.transitions.duration.enteringScreen,
	*   exit: theme.transitions.duration.leavingScreen,
	* }
	*/
	transitionDuration: import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.shape({
		appear: import_prop_types.default.number,
		enter: import_prop_types.default.number,
		exit: import_prop_types.default.number
	})])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Tooltip/tooltipClasses.mjs
function getTooltipUtilityClass(slot) {
	return generateUtilityClass("MuiTooltip", slot);
}
const tooltipClasses = generateUtilityClasses("MuiTooltip", [
	"popper",
	"popperInteractive",
	"popperArrow",
	"popperClose",
	"tooltip",
	"tooltipArrow",
	"touch",
	"tooltipPlacementLeft",
	"tooltipPlacementRight",
	"tooltipPlacementTop",
	"tooltipPlacementBottom",
	"arrow"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Tooltip/Tooltip.mjs
function round(value) {
	return Math.round(value * 1e5) / 1e5;
}
const useUtilityClasses$17 = (ownerState) => {
	const { classes, disableInteractive, arrow, touch, placement } = ownerState;
	const slots = {
		popper: [
			"popper",
			!disableInteractive && "popperInteractive",
			arrow && "popperArrow"
		],
		tooltip: [
			"tooltip",
			arrow && "tooltipArrow",
			touch && "touch",
			`tooltipPlacement${capitalize_default(placement.split("-")[0])}`
		],
		arrow: ["arrow"]
	};
	return composeClasses(slots, getTooltipUtilityClass, classes);
};
const TooltipPopper = styled$2(Popper, {
	name: "MuiTooltip",
	slot: "Popper",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.popper,
			!ownerState.disableInteractive && styles.popperInteractive,
			ownerState.arrow && styles.popperArrow,
			!ownerState.open && styles.popperClose
		];
	}
})(memoTheme(({ theme }) => ({
	zIndex: (theme.vars || theme).zIndex.tooltip,
	pointerEvents: "none",
	variants: [{
		props: ({ ownerState, open }) => open && !ownerState.disableInteractive,
		style: { pointerEvents: "auto" }
	}, {
		props: ({ ownerState }) => ownerState.arrow,
		style: {
			[`&[data-popper-placement*="bottom"] .${tooltipClasses.arrow}`]: {
				top: 0,
				marginTop: "-0.71em",
				"&::before": { transformOrigin: "0 100%" }
			},
			[`&[data-popper-placement*="top"] .${tooltipClasses.arrow}`]: {
				bottom: 0,
				marginBottom: "-0.71em",
				"&::before": { transformOrigin: "100% 0" }
			},
			[`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: {
				height: "1em",
				width: "0.71em",
				insetInlineStart: 0,
				marginInlineStart: "-0.71em",
				"&::before": { transformOrigin: "100% 100%" }
			},
			[`&[data-popper-placement*="left"] .${tooltipClasses.arrow}`]: {
				height: "1em",
				width: "0.71em",
				insetInlineEnd: 0,
				marginInlineEnd: "-0.71em",
				"&::before": { transformOrigin: "0 0" }
			}
		}
	}]
})));
const TooltipTooltip = styled$2("div", {
	name: "MuiTooltip",
	slot: "Tooltip",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.tooltip,
			ownerState.touch && styles.touch,
			ownerState.arrow && styles.tooltipArrow,
			styles[`tooltipPlacement${capitalize_default(ownerState.placement.split("-")[0])}`]
		];
	}
})(memoTheme(({ theme }) => ({
	backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], .92),
	borderRadius: (theme.vars || theme).shape.borderRadius,
	color: (theme.vars || theme).palette.common.white,
	fontFamily: theme.typography.fontFamily,
	padding: "4px 8px",
	fontSize: theme.typography.pxToRem(11),
	maxWidth: 300,
	margin: 2,
	wordWrap: "break-word",
	fontWeight: theme.typography.fontWeightMedium,
	[`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
		transformOrigin: "right center",
		marginInlineEnd: "14px"
	},
	[`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
		transformOrigin: "left center",
		marginInlineStart: "14px"
	},
	[`.${tooltipClasses.popper}[data-popper-placement*="top"] &`]: {
		transformOrigin: "center bottom",
		marginBottom: "14px"
	},
	[`.${tooltipClasses.popper}[data-popper-placement*="bottom"] &`]: {
		transformOrigin: "center top",
		marginTop: "14px"
	},
	variants: [
		{
			props: ({ ownerState }) => ownerState.arrow,
			style: {
				position: "relative",
				marginBlock: 0
			}
		},
		{
			props: ({ ownerState }) => ownerState.touch,
			style: {
				padding: "8px 16px",
				fontSize: theme.typography.pxToRem(14),
				lineHeight: `${round(16 / 14)}em`,
				fontWeight: theme.typography.fontWeightRegular
			}
		},
		{
			props: ({ ownerState }) => ownerState.touch,
			style: {
				[`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: { marginInlineEnd: "24px" },
				[`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: { marginInlineStart: "24px" },
				[`.${tooltipClasses.popper}[data-popper-placement*="top"] &`]: { marginBottom: "24px" },
				[`.${tooltipClasses.popper}[data-popper-placement*="bottom"] &`]: { marginTop: "24px" }
			}
		}
	]
})));
const TooltipArrow = styled$2("span", {
	name: "MuiTooltip",
	slot: "Arrow"
})(memoTheme(({ theme }) => ({
	overflow: "hidden",
	position: "absolute",
	width: "1em",
	height: "0.71em",
	boxSizing: "border-box",
	color: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], .9),
	"&::before": {
		content: "\"\"",
		margin: "auto",
		display: "block",
		width: "100%",
		height: "100%",
		backgroundColor: "currentColor",
		transform: "rotate(45deg)"
	}
})));
let hystersisOpen = false;
const hystersisTimer = new Timeout();
let cursorPosition = {
	x: 0,
	y: 0
};
function composeEventHandler(handler, eventHandler) {
	return (event, ...params) => {
		if (eventHandler) eventHandler(event, ...params);
		handler(event, ...params);
	};
}
const Tooltip$1 = /*#__PURE__*/ React$1.forwardRef(function Tooltip(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTooltip"
	});
	const { arrow = false, children: childrenProp, classes: classesProp, describeChild = false, disableFocusListener = false, disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener = false, enterDelay = 100, enterNextDelay = 0, enterTouchDelay = 700, followCursor = false, id: idProp, leaveDelay = 0, leaveTouchDelay = 1500, onClose, onOpen, open: openProp, placement = "bottom", slotProps = {}, slots = {}, title, ...other } = props;
	const children = /*#__PURE__*/ React$1.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ jsx("span", { children: childrenProp });
	const theme = useTheme$1();
	const [childNode, setChildNode] = React$1.useState();
	const [arrowRef, setArrowRef] = React$1.useState(null);
	const ignoreNonTouchEvents = React$1.useRef(false);
	const openedByDisabledTriggerRef = React$1.useRef(false);
	const disableInteractive = disableInteractiveProp || followCursor;
	const closeTimer = useTimeout();
	const enterTimer = useTimeout();
	const leaveTimer = useTimeout();
	const touchTimer = useTimeout();
	const [openState, setOpenState] = useControlled_default({
		controlled: openProp,
		default: false,
		name: "Tooltip",
		state: "open"
	});
	let open = openState;
	const { current: isControlled } = React$1.useRef(openProp !== void 0);
	const id = useId_default(idProp);
	const prevUserSelect = React$1.useRef();
	const stopTouchInteraction = useEventCallback_default(() => {
		if (prevUserSelect.current !== void 0) {
			document.body.style.WebkitUserSelect = prevUserSelect.current;
			prevUserSelect.current = void 0;
		}
		touchTimer.clear();
	});
	React$1.useEffect(() => stopTouchInteraction, [stopTouchInteraction]);
	const handleOpen = (event) => {
		hystersisTimer.clear();
		hystersisOpen = true;
		setOpenState(true);
		if (onOpen && !open) onOpen(event);
	};
	const handleClose = useEventCallback_default(
		/**
		* @param {React.SyntheticEvent | Event} event
		*/
		(event) => {
			openedByDisabledTriggerRef.current = false;
			hystersisTimer.start(800 + leaveDelay, () => {
				hystersisOpen = false;
			});
			setOpenState(false);
			if (onClose && open) onClose(event);
			closeTimer.start(theme.transitions.duration.shortest, () => {
				ignoreNonTouchEvents.current = false;
			});
		}
	);
	const handleMouseOver = (event) => {
		if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
		if (childNode) childNode.removeAttribute("title");
		enterTimer.clear();
		leaveTimer.clear();
		if (enterDelay || hystersisOpen && enterNextDelay) enterTimer.start(hystersisOpen ? enterNextDelay : enterDelay, () => {
			handleOpen(event);
		});
		else handleOpen(event);
	};
	const handleTriggerMouseOver = (event) => {
		if (childNode?.disabled && !isControlled) {
			if (open && !openedByDisabledTriggerRef.current) return;
			openedByDisabledTriggerRef.current = true;
		} else openedByDisabledTriggerRef.current = false;
		handleMouseOver(event);
	};
	const handleInteractiveWrapperMouseOver = (event) => {
		if (childNode?.disabled && !isControlled && !openedByDisabledTriggerRef.current) return;
		handleMouseOver(event);
	};
	const handleMouseLeave = (event) => {
		enterTimer.clear();
		leaveTimer.start(leaveDelay, () => {
			handleClose(event);
		});
	};
	const [, setChildIsFocusVisible] = React$1.useState(false);
	const handleBlur = (event) => {
		const target = event?.target ?? childNode;
		if (!target || target.disabled || !isFocusVisible(target)) {
			setChildIsFocusVisible(false);
			const closeEvent = event ?? new Event("blur");
			if (!event && target) {
				Object.defineProperty(closeEvent, "target", { value: target });
				Object.defineProperty(closeEvent, "currentTarget", { value: target });
			}
			handleMouseLeave(closeEvent);
		}
	};
	const handleFocus = (event) => {
		if (!childNode) setChildNode(event.currentTarget);
		openedByDisabledTriggerRef.current = false;
		if (isFocusVisible(event.target)) {
			const handleNativeBlur = (blurEvent) => {
				if (blurEvent.target.disabled) handleBlur(blurEvent);
				blurEvent.target.removeEventListener("blur", handleNativeBlur);
			};
			event.target.addEventListener("blur", handleNativeBlur);
			setChildIsFocusVisible(true);
			handleMouseOver(event);
		}
	};
	const detectTouchStart = (event) => {
		ignoreNonTouchEvents.current = true;
		const childrenProps = children.props;
		if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
	};
	const handleTouchStart = (event) => {
		detectTouchStart(event);
		leaveTimer.clear();
		closeTimer.clear();
		stopTouchInteraction();
		prevUserSelect.current = document.body.style.WebkitUserSelect;
		document.body.style.WebkitUserSelect = "none";
		touchTimer.start(enterTouchDelay, () => {
			document.body.style.WebkitUserSelect = prevUserSelect.current;
			handleTriggerMouseOver(event);
		});
	};
	const handleTouchEnd = (event) => {
		if (children.props.onTouchEnd) children.props.onTouchEnd(event);
		stopTouchInteraction();
		leaveTimer.start(leaveTouchDelay, () => {
			handleClose(event);
		});
	};
	React$1.useEffect(() => {
		if (!open) return;
		/**
		* @param {KeyboardEvent} nativeEvent
		*/
		function handleKeyDown(nativeEvent) {
			if (nativeEvent.key === "Escape") handleClose(nativeEvent);
		}
		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [handleClose, open]);
	const handleRef = useForkRef_default(getReactElementRef(children), setChildNode, ref);
	if (!title && title !== 0) open = false;
	const popperRef = React$1.useRef();
	const handleMouseMove = (event) => {
		const childrenProps = children.props;
		if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
		cursorPosition = {
			x: event.clientX,
			y: event.clientY
		};
		if (popperRef.current) popperRef.current.update();
	};
	const nameOrDescProps = {};
	const titleIsString = typeof title === "string";
	if (describeChild) {
		nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
		nameOrDescProps["aria-describedby"] = open ? id : null;
	} else {
		nameOrDescProps["aria-label"] = titleIsString ? title : null;
		nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
	}
	const childrenProps = {
		...nameOrDescProps,
		...other,
		...children.props,
		className: clsx(other.className, children.props.className),
		onTouchStart: detectTouchStart,
		ref: handleRef,
		...followCursor ? { onMouseMove: handleMouseMove } : {}
	};
	childrenProps["data-mui-internal-clone-element"] = true;
	React$1.useEffect(() => {
		if (childNode && !childNode.getAttribute("data-mui-internal-clone-element")) console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join("\n"));
	}, [childNode]);
	const interactiveWrapperListeners = {};
	if (!disableTouchListener) {
		childrenProps.onTouchStart = handleTouchStart;
		childrenProps.onTouchEnd = handleTouchEnd;
	}
	if (!disableHoverListener) {
		childrenProps.onMouseOver = composeEventHandler(handleTriggerMouseOver, childrenProps.onMouseOver);
		childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
		if (!disableInteractive) {
			interactiveWrapperListeners.onMouseOver = handleInteractiveWrapperMouseOver;
			interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
		}
	}
	if (!disableFocusListener) {
		childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
		childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);
		if (!disableInteractive) {
			interactiveWrapperListeners.onFocus = handleFocus;
			interactiveWrapperListeners.onBlur = handleBlur;
		}
	}
	if (children.props.title) console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${children.props.title}\` or the Tooltip component.`].join("\n"));
	const ownerState = {
		...props,
		arrow,
		disableInteractive,
		placement,
		touch: ignoreNonTouchEvents.current
	};
	const resolvedPopperProps = typeof slotProps.popper === "function" ? slotProps.popper(ownerState) : slotProps.popper;
	const popperOptions = React$1.useMemo(() => {
		let tooltipModifiers = [{
			name: "arrow",
			enabled: Boolean(arrowRef),
			options: {
				element: arrowRef,
				padding: 4
			}
		}];
		if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
		return {
			...resolvedPopperProps?.popperOptions,
			modifiers: tooltipModifiers
		};
	}, [arrowRef, resolvedPopperProps?.popperOptions]);
	const classes = useUtilityClasses$17(ownerState);
	const externalForwardedProps = {
		slots,
		slotProps: {
			arrow: slotProps.arrow,
			popper: resolvedPopperProps,
			tooltip: slotProps.tooltip,
			transition: slotProps.transition
		}
	};
	const [PopperSlot, popperSlotProps] = useSlot("popper", {
		elementType: TooltipPopper,
		externalForwardedProps,
		ownerState,
		className: classes.popper
	});
	const [TransitionSlot, transitionSlotProps] = useSlot("transition", {
		elementType: Grow,
		externalForwardedProps,
		ownerState
	});
	const [TooltipSlot, tooltipSlotProps] = useSlot("tooltip", {
		elementType: TooltipTooltip,
		className: classes.tooltip,
		externalForwardedProps,
		ownerState
	});
	const [ArrowSlot, arrowSlotProps] = useSlot("arrow", {
		elementType: TooltipArrow,
		className: classes.arrow,
		externalForwardedProps,
		ownerState,
		ref: setArrowRef
	});
	return /*#__PURE__*/ jsxs(React$1.Fragment, { children: [/*#__PURE__*/ React$1.cloneElement(children, childrenProps), /*#__PURE__*/ jsx(PopperSlot, {
		as: Popper,
		placement,
		anchorEl: followCursor ? { getBoundingClientRect: () => ({
			top: cursorPosition.y,
			left: cursorPosition.x,
			right: cursorPosition.x,
			bottom: cursorPosition.y,
			width: 0,
			height: 0
		}) } : childNode,
		popperRef,
		open: childNode ? open : false,
		id,
		transition: true,
		...interactiveWrapperListeners,
		...popperSlotProps,
		popperOptions,
		children: ({ TransitionProps: TransitionPropsInner }) => /*#__PURE__*/ jsx(TransitionSlot, {
			timeout: theme.transitions.duration.shorter,
			...TransitionPropsInner,
			...transitionSlotProps,
			children: /*#__PURE__*/ jsxs(TooltipSlot, {
				...tooltipSlotProps,
				children: [title, arrow ? /*#__PURE__*/ jsx(ArrowSlot, { ...arrowSlotProps }) : null]
			})
		})
	})] });
});
Tooltip$1.propTypes = {
	/**
	* If `true`, adds an arrow to the tooltip.
	* @default false
	*/
	arrow: import_prop_types.default.bool,
	/**
	* Tooltip reference element.
	*/
	children: elementAcceptingRef.isRequired,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* Set to `true` if the `title` acts as an accessible description.
	* By default the `title` acts as an accessible label for the child.
	* @default false
	*/
	describeChild: import_prop_types.default.bool,
	/**
	* Do not respond to focus-visible events.
	* @default false
	*/
	disableFocusListener: import_prop_types.default.bool,
	/**
	* Do not respond to hover events.
	* @default false
	*/
	disableHoverListener: import_prop_types.default.bool,
	/**
	* Makes a tooltip not interactive, i.e. it will close when the user
	* hovers over the tooltip before the `leaveDelay` is expired.
	* @default false
	*/
	disableInteractive: import_prop_types.default.bool,
	/**
	* Do not respond to long press touch events.
	* @default false
	*/
	disableTouchListener: import_prop_types.default.bool,
	/**
	* The number of milliseconds to wait before showing the tooltip.
	* This prop won't impact the enter touch delay (`enterTouchDelay`).
	* @default 100
	*/
	enterDelay: import_prop_types.default.number,
	/**
	* The number of milliseconds to wait before showing the tooltip when one was already recently opened.
	* @default 0
	*/
	enterNextDelay: import_prop_types.default.number,
	/**
	* The number of milliseconds a user must touch the element before showing the tooltip.
	* @default 700
	*/
	enterTouchDelay: import_prop_types.default.number,
	/**
	* If `true`, the tooltip follow the cursor over the wrapped element.
	* @default false
	*/
	followCursor: import_prop_types.default.bool,
	/**
	* This prop is used to help implement the accessibility logic.
	* If you don't provide this prop. It falls back to a randomly generated id.
	*/
	id: import_prop_types.default.string,
	/**
	* The number of milliseconds to wait before hiding the tooltip.
	* This prop won't impact the leave touch delay (`leaveTouchDelay`).
	* @default 0
	*/
	leaveDelay: import_prop_types.default.number,
	/**
	* The number of milliseconds after the user stops touching an element before hiding the tooltip.
	* @default 1500
	*/
	leaveTouchDelay: import_prop_types.default.number,
	/**
	* Callback fired when the component requests to be closed.
	*
	* @param {React.SyntheticEvent} event The event source of the callback.
	*/
	onClose: import_prop_types.default.func,
	/**
	* Callback fired when the component requests to be open.
	*
	* @param {React.SyntheticEvent} event The event source of the callback.
	*/
	onOpen: import_prop_types.default.func,
	/**
	* If `true`, the component is shown.
	*/
	open: import_prop_types.default.bool,
	/**
	* Tooltip placement.
	* @default 'bottom'
	*/
	placement: import_prop_types.default.oneOf([
		"auto-end",
		"auto-start",
		"auto",
		"bottom-end",
		"bottom-start",
		"bottom",
		"left-end",
		"left-start",
		"left",
		"right-end",
		"right-start",
		"right",
		"top-end",
		"top-start",
		"top"
	]),
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		arrow: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		popper: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		tooltip: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		transition: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		arrow: import_prop_types.default.elementType,
		popper: import_prop_types.default.elementType,
		tooltip: import_prop_types.default.elementType,
		transition: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
	*/
	title: import_prop_types.default.node
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Stack/Stack.mjs
const Stack = createStack({
	createStyledComponent: styled$2("div", {
		name: "MuiStack",
		slot: "Root"
	}),
	useThemeProps: (inProps) => useDefaultProps({
		props: inProps,
		name: "MuiStack"
	})
});
Stack.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* Defines the `flex-direction` style property.
	* It is applied for all screen sizes.
	* @default 'column'
	*/
	direction: import_prop_types.default.oneOfType([
		import_prop_types.default.oneOf([
			"column-reverse",
			"column",
			"row-reverse",
			"row"
		]),
		import_prop_types.default.arrayOf(import_prop_types.default.oneOf([
			"column-reverse",
			"column",
			"row-reverse",
			"row"
		])),
		import_prop_types.default.object
	]),
	/**
	* Add an element between each child.
	*/
	divider: import_prop_types.default.node,
	/**
	* Defines the space between immediate children.
	* @default 0
	*/
	spacing: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.string])),
		import_prop_types.default.number,
		import_prop_types.default.object,
		import_prop_types.default.string
	]),
	/**
	* The system prop, which allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
	*
	* While CSS `gap` removes the known limitations,
	* it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
	*
	* To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
	* @default false
	*/
	useFlexGap: import_prop_types.default.bool
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Switch/switchClasses.mjs
function getSwitchUtilityClass(slot) {
	return generateUtilityClass("MuiSwitch", slot);
}
const switchClasses = generateUtilityClasses("MuiSwitch", [
	"root",
	"edgeStart",
	"edgeEnd",
	"switchBase",
	"colorPrimary",
	"colorSecondary",
	"sizeSmall",
	"sizeMedium",
	"checked",
	"disabled",
	"input",
	"thumb",
	"track"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Switch/Switch.mjs
const useUtilityClasses$16 = (ownerState) => {
	const { classes, edge, size, color, checked, disabled } = ownerState;
	const slots = {
		root: [
			"root",
			edge && `edge${capitalize_default(edge)}`,
			`size${capitalize_default(size)}`
		],
		switchBase: [
			"switchBase",
			`color${capitalize_default(color)}`,
			checked && "checked",
			disabled && "disabled"
		],
		thumb: ["thumb"],
		track: ["track"],
		input: ["input"]
	};
	const composedClasses = composeClasses(slots, getSwitchUtilityClass, classes);
	return {
		...classes,
		...composedClasses
	};
};
const SwitchRoot = styled$2("span", {
	name: "MuiSwitch",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.edge && styles[`edge${capitalize_default(ownerState.edge)}`],
			styles[`size${capitalize_default(ownerState.size)}`]
		];
	}
})({
	display: "inline-flex",
	width: 58,
	height: 38,
	overflow: "hidden",
	padding: 12,
	boxSizing: "border-box",
	position: "relative",
	flexShrink: 0,
	zIndex: 0,
	verticalAlign: "middle",
	"@media print": { colorAdjust: "exact" },
	variants: [
		{
			props: { edge: "start" },
			style: { marginLeft: -8 }
		},
		{
			props: { edge: "end" },
			style: { marginRight: -8 }
		},
		{
			props: { size: "small" },
			style: {
				width: 40,
				height: 24,
				padding: 7,
				[`& .${switchClasses.thumb}`]: {
					width: 16,
					height: 16
				},
				[`& .${switchClasses.switchBase}`]: {
					padding: 4,
					[`&.${switchClasses.checked}`]: { transform: "translateX(16px)" }
				}
			}
		}
	]
});
const SwitchSwitchBase = styled$2(SwitchBase, {
	name: "MuiSwitch",
	slot: "SwitchBase",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.switchBase,
			{ [`& .${switchClasses.input}`]: styles.input },
			ownerState.color !== "default" && styles[`color${capitalize_default(ownerState.color)}`]
		];
	}
})(memoTheme(({ theme }) => ({
	position: "absolute",
	top: 0,
	left: 0,
	zIndex: 1,
	color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
	...getTransitionStyles(theme, ["left", "transform"], { duration: theme.transitions.duration.shortest }),
	[`&.${switchClasses.checked}`]: { transform: "translateX(20px)" },
	[`&.${switchClasses.disabled}`]: { color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}` },
	...theme.focusVisible ? {
		[`&.${buttonBaseClasses.focusVisible} ~ .${switchClasses.track}`]: {
			...outsetFocusRing,
			...theme.focusVisible
		},
		[`&.${switchClasses.checked} + .${switchClasses.track}`]: { backgroundColor: theme.alpha(theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`, .5) },
		[`&.${switchClasses.disabled} + .${switchClasses.track}`]: { backgroundColor: theme.alpha(theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`, theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? .12 : .2}`) }
	} : {
		[`&.${switchClasses.checked} + .${switchClasses.track}`]: { opacity: .5 },
		[`&.${switchClasses.disabled} + .${switchClasses.track}`]: { opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? .12 : .2}` }
	},
	[`& .${switchClasses.input}`]: {
		left: "-100%",
		width: "300%"
	}
})), memoTheme(({ theme }) => ({
	"&:hover": {
		backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
		"@media (hover: none)": { backgroundColor: "transparent" }
	},
	variants: [...Object.entries(theme.palette).filter(createSimplePaletteValueFilter(["light"])).map(([color]) => ({
		props: { color },
		style: {
			[`&.${switchClasses.checked}`]: {
				color: (theme.vars || theme).palette[color].main,
				"&:hover": {
					backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
					"@media (hover: none)": { backgroundColor: "transparent" }
				},
				[`&.${switchClasses.disabled}`]: { color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === "light" ? theme.lighten(theme.palette[color].main, .62) : theme.darken(theme.palette[color].main, .55)}` }
			},
			[`&.${switchClasses.checked} + .${switchClasses.track}`]: { backgroundColor: (theme.vars || theme).palette[color].main },
			...theme.focusVisible && {
				[`&.${switchClasses.checked} + .${switchClasses.track}`]: { backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, .5) },
				[`&.${switchClasses.disabled} + .${switchClasses.track}`]: { backgroundColor: theme.alpha(theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`, theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? .12 : .2}`) },
				[`&.${switchClasses.checked}.${switchClasses.disabled} + .${switchClasses.track}`]: { backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? .12 : .2}`) }
			}
		}
	}))]
})));
const SwitchTrack = styled$2("span", {
	name: "MuiSwitch",
	slot: "Track"
})(memoTheme(({ theme }) => ({
	height: "100%",
	width: "100%",
	borderRadius: 7,
	zIndex: -1,
	...getTransitionStyles(theme, ["opacity", "background-color"], { duration: theme.transitions.duration.shortest }),
	"@media (forced-colors: active)": {
		boxSizing: "border-box",
		border: "1px solid ButtonBorder"
	},
	...theme.focusVisible ? { backgroundColor: theme.alpha(theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`, theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? .38 : .3}`) } : {
		backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
		opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? .38 : .3}`
	}
})));
const SwitchThumb = styled$2("span", {
	name: "MuiSwitch",
	slot: "Thumb"
})(memoTheme(({ theme }) => ({
	boxShadow: (theme.vars || theme).shadows[1],
	backgroundColor: "currentColor",
	boxSizing: "border-box",
	border: "1px solid transparent",
	width: 20,
	height: 20,
	borderRadius: "50%"
})));
const Switch$1 = /*#__PURE__*/ React$1.forwardRef(function Switch(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiSwitch"
	});
	const { className, color = "primary", edge = false, size = "medium", sx, slots = {}, slotProps = {}, ...other } = props;
	const ownerState = {
		...props,
		color,
		edge,
		size
	};
	const classes = useUtilityClasses$16(ownerState);
	const externalInputProps = slotProps.input;
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [RootSlot, rootSlotProps] = useSlot("root", {
		className: clsx(classes.root, className),
		elementType: SwitchRoot,
		externalForwardedProps,
		ownerState,
		additionalProps: { sx }
	});
	const [ThumbSlot, thumbSlotProps] = useSlot("thumb", {
		className: classes.thumb,
		elementType: SwitchThumb,
		externalForwardedProps,
		ownerState
	});
	const icon = /*#__PURE__*/ jsx(ThumbSlot, { ...thumbSlotProps });
	const [TrackSlot, trackSlotProps] = useSlot("track", {
		className: classes.track,
		elementType: SwitchTrack,
		externalForwardedProps,
		ownerState
	});
	return /*#__PURE__*/ jsxs(RootSlot, {
		...rootSlotProps,
		children: [/*#__PURE__*/ jsx(SwitchSwitchBase, {
			type: "checkbox",
			icon,
			checkedIcon: icon,
			ref,
			ownerState,
			...other,
			classes: {
				...classes,
				root: classes.switchBase
			},
			slots: {
				...slots.switchBase && { root: slots.switchBase },
				...slots.input && { input: slots.input }
			},
			slotProps: {
				...slotProps.switchBase && { root: typeof slotProps.switchBase === "function" ? slotProps.switchBase(ownerState) : slotProps.switchBase },
				input: mergeSlotProps$1(typeof externalInputProps === "function" ? externalInputProps(ownerState) : externalInputProps, { role: "switch" })
			}
		}), /*#__PURE__*/ jsx(TrackSlot, { ...trackSlotProps })]
	});
});
Switch$1.propTypes = {
	/**
	* If `true`, the component is checked.
	*/
	checked: import_prop_types.default.bool,
	/**
	* The icon to display when the component is checked.
	*/
	checkedIcon: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the component.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'primary'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"default",
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* The default checked state. Use when the component is not controlled.
	*/
	defaultChecked: import_prop_types.default.bool,
	/**
	* If `true`, the component is disabled.
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the ripple effect is disabled.
	* @default false
	*/
	disableRipple: import_prop_types.default.bool,
	/**
	* If given, uses a negative margin to counteract the padding on one
	* side (this is often helpful for aligning the left or right
	* side of the icon with content above or below, without ruining the border
	* size and shape).
	* @default false
	*/
	edge: import_prop_types.default.oneOf([
		"end",
		"start",
		false
	]),
	/**
	* The icon to display when the component is unchecked.
	*/
	icon: import_prop_types.default.node,
	/**
	* The id of the `input` element.
	*/
	id: import_prop_types.default.string,
	/**
	* Callback fired when the state is changed.
	*
	* @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
	* You can pull out the new value by accessing `event.target.value` (string).
	* You can pull out the new checked state by accessing `event.target.checked` (boolean).
	*/
	onChange: import_prop_types.default.func,
	/**
	* If `true`, the `input` element is required.
	* @default false
	*/
	required: import_prop_types.default.bool,
	/**
	* The size of the component.
	* `small` is equivalent to the dense switch styling.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["medium", "small"]), import_prop_types.default.string]),
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		input: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		switchBase: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		thumb: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		track: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		input: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType,
		switchBase: import_prop_types.default.elementType,
		thumb: import_prop_types.default.elementType,
		track: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The value of the component. The DOM API casts this to a string.
	* The browser uses "on" as the default value.
	*/
	value: import_prop_types.default.any
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Tab/tabClasses.mjs
function getTabUtilityClass(slot) {
	return generateUtilityClass("MuiTab", slot);
}
const tabClasses = generateUtilityClasses("MuiTab", [
	"root",
	"labelIcon",
	"textColorInherit",
	"textColorPrimary",
	"textColorSecondary",
	"selected",
	"disabled",
	"fullWidth",
	"wrapped",
	"icon"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Tab/Tab.mjs
const useUtilityClasses$15 = (ownerState) => {
	const { classes, textColor, fullWidth, wrapped, icon, label, selected, disabled } = ownerState;
	const slots = {
		root: [
			"root",
			icon && label && "labelIcon",
			`textColor${capitalize_default(textColor)}`,
			fullWidth && "fullWidth",
			wrapped && "wrapped",
			selected && "selected",
			disabled && "disabled"
		],
		icon: ["icon"]
	};
	return composeClasses(slots, getTabUtilityClass, classes);
};
const TabRoot = styled$2(ButtonBase, {
	name: "MuiTab",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.label && ownerState.icon && styles.labelIcon,
			styles[`textColor${capitalize_default(ownerState.textColor)}`],
			ownerState.fullWidth && styles.fullWidth,
			ownerState.wrapped && styles.wrapped,
			{ [`& .${tabClasses.icon}`]: styles.icon }
		];
	}
})(memoTheme(({ theme }) => ({
	...theme.typography.button,
	maxWidth: 360,
	minWidth: 90,
	position: "relative",
	minHeight: 48,
	flexShrink: 0,
	padding: "12px 16px",
	overflow: "hidden",
	whiteSpace: "normal",
	textAlign: "center",
	lineHeight: 1.25,
	...theme.focusVisible && applyInsetFocusVisible(3),
	variants: [
		{
			props: ({ ownerState }) => ownerState.label && (ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom"),
			style: { flexDirection: "column" }
		},
		{
			props: ({ ownerState }) => ownerState.label && ownerState.iconPosition !== "top" && ownerState.iconPosition !== "bottom",
			style: { flexDirection: "row" }
		},
		{
			props: ({ ownerState }) => ownerState.icon && ownerState.label,
			style: {
				minHeight: 72,
				paddingTop: 9,
				paddingBottom: 9
			}
		},
		{
			props: ({ ownerState, iconPosition }) => ownerState.icon && ownerState.label && iconPosition === "top",
			style: { [`& > .${tabClasses.icon}`]: { marginBottom: 6 } }
		},
		{
			props: ({ ownerState, iconPosition }) => ownerState.icon && ownerState.label && iconPosition === "bottom",
			style: { [`& > .${tabClasses.icon}`]: { marginTop: 6 } }
		},
		{
			props: ({ ownerState, iconPosition }) => ownerState.icon && ownerState.label && iconPosition === "start",
			style: { [`& > .${tabClasses.icon}`]: { marginRight: theme.spacing(1) } }
		},
		{
			props: ({ ownerState, iconPosition }) => ownerState.icon && ownerState.label && iconPosition === "end",
			style: { [`& > .${tabClasses.icon}`]: { marginLeft: theme.spacing(1) } }
		},
		{
			props: { textColor: "inherit" },
			style: {
				color: "inherit",
				opacity: .6,
				[`&.${tabClasses.selected}`]: { opacity: 1 },
				...theme.focusVisible && { [`&.${buttonBaseClasses.focusVisible}`]: { opacity: 1 } },
				[`&.${tabClasses.disabled}`]: { opacity: (theme.vars || theme).palette.action.disabledOpacity }
			}
		},
		{
			props: { textColor: "primary" },
			style: {
				color: (theme.vars || theme).palette.text.secondary,
				[`&.${tabClasses.selected}`]: { color: (theme.vars || theme).palette.primary.main },
				[`&.${tabClasses.disabled}`]: { color: (theme.vars || theme).palette.text.disabled }
			}
		},
		{
			props: { textColor: "secondary" },
			style: {
				color: (theme.vars || theme).palette.text.secondary,
				[`&.${tabClasses.selected}`]: { color: (theme.vars || theme).palette.secondary.main },
				[`&.${tabClasses.disabled}`]: { color: (theme.vars || theme).palette.text.disabled }
			}
		},
		{
			props: ({ ownerState }) => ownerState.fullWidth,
			style: {
				flexShrink: 1,
				flexGrow: 1,
				flexBasis: 0,
				maxWidth: "none"
			}
		},
		{
			props: ({ ownerState }) => ownerState.wrapped,
			style: { fontSize: theme.typography.pxToRem(12) }
		}
	]
})));
const Tab$1 = /*#__PURE__*/ React$1.forwardRef(function Tab(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTab"
	});
	const { className, disabled = false, disableFocusRipple = false, fullWidth, icon: iconProp, iconPosition = "top", indicator, label, onChange, onClick, onFocus, selected, selectionFollowsFocus, textColor = "inherit", value, wrapped = false, ...other } = props;
	const rovingContext = useRovingTabIndexContext();
	const rovingItemProps = useRovingTabIndexItem({
		id: value,
		ref,
		disabled,
		selected
	});
	const tabIndex = rovingContext.getItemMap().size === 0 && selected ? 0 : rovingItemProps.tabIndex;
	const ownerState = {
		...props,
		disabled,
		disableFocusRipple,
		selected,
		icon: !!iconProp,
		iconPosition,
		label: !!label,
		fullWidth,
		textColor,
		wrapped
	};
	const classes = useUtilityClasses$15(ownerState);
	const icon = iconProp && label && /*#__PURE__*/ React$1.isValidElement(iconProp) ? /*#__PURE__*/ React$1.cloneElement(iconProp, { className: clsx(classes.icon, iconProp.props.className) }) : iconProp;
	const handleClick = (event) => {
		if (!selected && onChange) onChange(event, value);
		if (onClick) onClick(event);
	};
	const handleFocus = (event) => {
		if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
		if (onFocus) onFocus(event);
	};
	return /*#__PURE__*/ jsxs(TabRoot, {
		internalNativeButton: true,
		focusRipple: !disableFocusRipple,
		className: clsx(classes.root, className),
		ref: rovingItemProps.ref,
		role: "tab",
		"aria-selected": selected,
		disabled,
		onClick: handleClick,
		onFocus: handleFocus,
		tabIndex,
		ownerState,
		...other,
		children: [iconPosition === "top" || iconPosition === "start" ? /*#__PURE__*/ jsxs(React$1.Fragment, { children: [icon, label] }) : /*#__PURE__*/ jsxs(React$1.Fragment, { children: [label, icon] }), indicator]
	});
});
Tab$1.propTypes = {
	/**
	* This prop isn't supported.
	* Use the `component` prop if you need to change the children structure.
	*/
	children: unsupportedProp_default,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the  keyboard focus ripple is disabled.
	* @default false
	*/
	disableFocusRipple: import_prop_types.default.bool,
	/**
	* If `true`, the ripple effect is disabled.
	*
	* ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	* to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
	* @default false
	*/
	disableRipple: import_prop_types.default.bool,
	/**
	* The icon to display.
	*/
	icon: import_prop_types.default.oneOfType([import_prop_types.default.element, import_prop_types.default.string]),
	/**
	* The position of the icon relative to the label.
	* @default 'top'
	*/
	iconPosition: import_prop_types.default.oneOf([
		"bottom",
		"end",
		"start",
		"top"
	]),
	/**
	* The label element.
	*/
	label: import_prop_types.default.node,
	/**
	* @ignore
	*/
	onChange: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onClick: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onFocus: import_prop_types.default.func,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* You can provide your own value. Otherwise, we fallback to the child position index.
	*/
	value: import_prop_types.default.any,
	/**
	* Tab labels appear in a single row.
	* They can use a second line if needed.
	* @default false
	*/
	wrapped: import_prop_types.default.bool
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Table/TableContext.mjs
/**
* @ignore - internal component.
*/
const TableContext = /*#__PURE__*/ React$1.createContext();
TableContext.displayName = "TableContext";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Table/tableClasses.mjs
function getTableUtilityClass(slot) {
	return generateUtilityClass("MuiTable", slot);
}
const tableClasses = generateUtilityClasses("MuiTable", ["root", "stickyHeader"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Table/Table.mjs
const useUtilityClasses$14 = (ownerState) => {
	const { classes, stickyHeader } = ownerState;
	return composeClasses({ root: ["root", stickyHeader && "stickyHeader"] }, getTableUtilityClass, classes);
};
const TableRoot = styled$2("table", {
	name: "MuiTable",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, ownerState.stickyHeader && styles.stickyHeader];
	}
})(memoTheme(({ theme }) => ({
	display: "table",
	width: "100%",
	borderCollapse: "collapse",
	borderSpacing: 0,
	"& caption": {
		...theme.typography.body2,
		padding: theme.spacing(2),
		color: (theme.vars || theme).palette.text.secondary,
		textAlign: "left",
		captionSide: "bottom"
	},
	variants: [{
		props: ({ ownerState }) => ownerState.stickyHeader,
		style: { borderCollapse: "separate" }
	}]
})));
const defaultComponent$4 = "table";
const Table$1 = /*#__PURE__*/ React$1.forwardRef(function Table(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTable"
	});
	const { className, component = defaultComponent$4, padding = "normal", size = "medium", stickyHeader = false, ...other } = props;
	const ownerState = {
		...props,
		component,
		padding,
		size,
		stickyHeader
	};
	const classes = useUtilityClasses$14(ownerState);
	const table = React$1.useMemo(() => ({
		padding,
		size,
		stickyHeader
	}), [
		padding,
		size,
		stickyHeader
	]);
	return /*#__PURE__*/ jsx(TableContext.Provider, {
		value: table,
		children: /*#__PURE__*/ jsx(TableRoot, {
			as: component,
			role: component === defaultComponent$4 ? null : "table",
			ref,
			className: clsx(classes.root, className),
			ownerState,
			...other
		})
	});
});
Table$1.propTypes = {
	/**
	* The content of the table, normally `TableHead` and `TableBody`.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* Allows TableCells to inherit padding of the Table.
	* @default 'normal'
	*/
	padding: import_prop_types.default.oneOf([
		"checkbox",
		"none",
		"normal"
	]),
	/**
	* Allows TableCells to inherit size of the Table.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["medium", "small"]), import_prop_types.default.string]),
	/**
	* Set the header sticky.
	* @default false
	*/
	stickyHeader: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Table/Tablelvl2Context.mjs
/**
* @ignore - internal component.
*/
const Tablelvl2Context = /*#__PURE__*/ React$1.createContext();
Tablelvl2Context.displayName = "Tablelvl2Context";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableBody/tableBodyClasses.mjs
function getTableBodyUtilityClass(slot) {
	return generateUtilityClass("MuiTableBody", slot);
}
generateUtilityClasses("MuiTableBody", ["root"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableBody/TableBody.mjs
const useUtilityClasses$13 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({ root: ["root"] }, getTableBodyUtilityClass, classes);
};
const TableBodyRoot = styled$2("tbody", {
	name: "MuiTableBody",
	slot: "Root"
})({ display: "table-row-group" });
const tablelvl2$2 = { variant: "body" };
const defaultComponent$3 = "tbody";
const TableBody = /*#__PURE__*/ React$1.forwardRef(function TableBody(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTableBody"
	});
	const { className, component = defaultComponent$3, ...other } = props;
	const ownerState = {
		...props,
		component
	};
	const classes = useUtilityClasses$13(ownerState);
	return /*#__PURE__*/ jsx(Tablelvl2Context.Provider, {
		value: tablelvl2$2,
		children: /*#__PURE__*/ jsx(TableBodyRoot, {
			className: clsx(classes.root, className),
			as: component,
			ref,
			role: component === defaultComponent$3 ? null : "rowgroup",
			ownerState,
			...other
		})
	});
});
TableBody.propTypes = {
	/**
	* The content of the component, normally `TableRow`.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableCell/tableCellClasses.mjs
function getTableCellUtilityClass(slot) {
	return generateUtilityClass("MuiTableCell", slot);
}
const tableCellClasses = generateUtilityClasses("MuiTableCell", [
	"root",
	"head",
	"body",
	"footer",
	"sizeSmall",
	"sizeMedium",
	"paddingCheckbox",
	"paddingNone",
	"alignLeft",
	"alignCenter",
	"alignRight",
	"alignJustify",
	"stickyHeader"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableCell/TableCell.mjs
const useUtilityClasses$12 = (ownerState) => {
	const { classes, variant, align, padding, size, stickyHeader } = ownerState;
	const slots = { root: [
		"root",
		variant,
		stickyHeader && "stickyHeader",
		align !== "inherit" && `align${capitalize_default(align)}`,
		padding !== "normal" && `padding${capitalize_default(padding)}`,
		`size${capitalize_default(size)}`
	] };
	return composeClasses(slots, getTableCellUtilityClass, classes);
};
const TableCellRoot = styled$2("td", {
	name: "MuiTableCell",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			styles[ownerState.variant],
			styles[`size${capitalize_default(ownerState.size)}`],
			ownerState.padding !== "normal" && styles[`padding${capitalize_default(ownerState.padding)}`],
			ownerState.align !== "inherit" && styles[`align${capitalize_default(ownerState.align)}`],
			ownerState.stickyHeader && styles.stickyHeader
		];
	}
})(memoTheme(({ theme }) => ({
	...theme.typography.body2,
	display: "table-cell",
	verticalAlign: "inherit",
	borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? theme.lighten(theme.alpha(theme.palette.divider, 1), .88) : theme.darken(theme.alpha(theme.palette.divider, 1), .68)}`,
	textAlign: "left",
	padding: 16,
	variants: [
		{
			props: { variant: "head" },
			style: {
				color: (theme.vars || theme).palette.text.primary,
				lineHeight: theme.typography.pxToRem(24),
				fontWeight: theme.typography.fontWeightMedium
			}
		},
		{
			props: { variant: "body" },
			style: { color: (theme.vars || theme).palette.text.primary }
		},
		{
			props: { variant: "footer" },
			style: {
				color: (theme.vars || theme).palette.text.secondary,
				lineHeight: theme.typography.pxToRem(21),
				fontSize: theme.typography.pxToRem(12)
			}
		},
		{
			props: { size: "small" },
			style: {
				padding: "6px 16px",
				[`&.${tableCellClasses.paddingCheckbox}`]: {
					width: 24,
					padding: "0 12px 0 16px",
					"& > *": { padding: 0 }
				}
			}
		},
		{
			props: { padding: "checkbox" },
			style: {
				width: 48,
				padding: "0 0 0 4px"
			}
		},
		{
			props: { padding: "none" },
			style: { padding: 0 }
		},
		{
			props: { align: "left" },
			style: { textAlign: "left" }
		},
		{
			props: { align: "center" },
			style: { textAlign: "center" }
		},
		{
			props: { align: "right" },
			style: {
				textAlign: "right",
				flexDirection: "row-reverse"
			}
		},
		{
			props: { align: "justify" },
			style: { textAlign: "justify" }
		},
		{
			props: ({ ownerState }) => ownerState.stickyHeader,
			style: {
				position: "sticky",
				top: 0,
				zIndex: 2,
				backgroundColor: (theme.vars || theme).palette.background.default
			}
		}
	]
})));
/**
* The component renders a `<th>` element when the parent context is a header
* or otherwise a `<td>` element.
*/
const TableCell$1 = /*#__PURE__*/ React$1.forwardRef(function TableCell(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTableCell"
	});
	const { align = "inherit", className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection, variant: variantProp, ...other } = props;
	const table = React$1.useContext(TableContext);
	const tablelvl2 = React$1.useContext(Tablelvl2Context);
	const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
	let component;
	if (componentProp) component = componentProp;
	else component = isHeadCell ? "th" : "td";
	let scope = scopeProp;
	if (component === "td") scope = void 0;
	else if (!scope && isHeadCell) scope = "col";
	const variant = variantProp || tablelvl2 && tablelvl2.variant;
	const ownerState = {
		...props,
		align,
		component,
		padding: paddingProp || (table && table.padding ? table.padding : "normal"),
		size: sizeProp || (table && table.size ? table.size : "medium"),
		sortDirection,
		stickyHeader: variant === "head" && table && table.stickyHeader,
		variant
	};
	const classes = useUtilityClasses$12(ownerState);
	let ariaSort = null;
	if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
	return /*#__PURE__*/ jsx(TableCellRoot, {
		as: component,
		ref,
		className: clsx(classes.root, className),
		"aria-sort": ariaSort,
		scope,
		ownerState,
		...other
	});
});
TableCell$1.propTypes = {
	/**
	* Set the text-align on the table cell content.
	*
	* Monetary or generally number fields **should be right aligned** as that allows
	* you to add them up quickly in your head without having to worry about decimals.
	* @default 'inherit'
	*/
	align: import_prop_types.default.oneOf([
		"center",
		"inherit",
		"justify",
		"left",
		"right"
	]),
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* Sets the padding applied to the cell.
	* The prop defaults to the value (`'default'`) inherited from the parent Table component.
	*/
	padding: import_prop_types.default.oneOf([
		"checkbox",
		"none",
		"normal"
	]),
	/**
	* Set scope attribute.
	*/
	scope: import_prop_types.default.string,
	/**
	* Specify the size of the cell.
	* The prop defaults to the value (`'medium'`) inherited from the parent Table component.
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["medium", "small"]), import_prop_types.default.string]),
	/**
	* Set aria-sort direction.
	*/
	sortDirection: import_prop_types.default.oneOf([
		"asc",
		"desc",
		false
	]),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* Specify the cell type.
	* The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"body",
		"footer",
		"head"
	]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableContainer/tableContainerClasses.mjs
function getTableContainerUtilityClass(slot) {
	return generateUtilityClass("MuiTableContainer", slot);
}
generateUtilityClasses("MuiTableContainer", ["root"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableContainer/TableContainer.mjs
const useUtilityClasses$11 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({ root: ["root"] }, getTableContainerUtilityClass, classes);
};
const TableContainerRoot = styled$2("div", {
	name: "MuiTableContainer",
	slot: "Root"
})({
	width: "100%",
	overflowX: "auto"
});
const TableContainer$1 = /*#__PURE__*/ React$1.forwardRef(function TableContainer(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTableContainer"
	});
	const { className, component = "div", ...other } = props;
	const ownerState = {
		...props,
		component
	};
	const classes = useUtilityClasses$11(ownerState);
	return /*#__PURE__*/ jsx(TableContainerRoot, {
		ref,
		as: component,
		className: clsx(classes.root, className),
		ownerState,
		...other
	});
});
TableContainer$1.propTypes = {
	/**
	* The content of the component, normally `Table`.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableFooter/tableFooterClasses.mjs
function getTableFooterUtilityClass(slot) {
	return generateUtilityClass("MuiTableFooter", slot);
}
generateUtilityClasses("MuiTableFooter", ["root"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableFooter/TableFooter.mjs
const useUtilityClasses$10 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({ root: ["root"] }, getTableFooterUtilityClass, classes);
};
const TableFooterRoot = styled$2("tfoot", {
	name: "MuiTableFooter",
	slot: "Root"
})({ display: "table-footer-group" });
const tablelvl2$1 = { variant: "footer" };
const defaultComponent$2 = "tfoot";
const TableFooter$1 = /*#__PURE__*/ React$1.forwardRef(function TableFooter(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTableFooter"
	});
	const { className, component = defaultComponent$2, ...other } = props;
	const ownerState = {
		...props,
		component
	};
	const classes = useUtilityClasses$10(ownerState);
	return /*#__PURE__*/ jsx(Tablelvl2Context.Provider, {
		value: tablelvl2$1,
		children: /*#__PURE__*/ jsx(TableFooterRoot, {
			as: component,
			className: clsx(classes.root, className),
			ref,
			role: component === defaultComponent$2 ? null : "rowgroup",
			ownerState,
			...other
		})
	});
});
TableFooter$1.propTypes = {
	/**
	* The content of the component, normally `TableRow`.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableHead/tableHeadClasses.mjs
function getTableHeadUtilityClass(slot) {
	return generateUtilityClass("MuiTableHead", slot);
}
generateUtilityClasses("MuiTableHead", ["root"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableHead/TableHead.mjs
const useUtilityClasses$9 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({ root: ["root"] }, getTableHeadUtilityClass, classes);
};
const TableHeadRoot = styled$2("thead", {
	name: "MuiTableHead",
	slot: "Root"
})({ display: "table-header-group" });
const tablelvl2 = { variant: "head" };
const defaultComponent$1 = "thead";
const TableHead = /*#__PURE__*/ React$1.forwardRef(function TableHead(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTableHead"
	});
	const { className, component = defaultComponent$1, ...other } = props;
	const ownerState = {
		...props,
		component
	};
	const classes = useUtilityClasses$9(ownerState);
	return /*#__PURE__*/ jsx(Tablelvl2Context.Provider, {
		value: tablelvl2,
		children: /*#__PURE__*/ jsx(TableHeadRoot, {
			as: component,
			className: clsx(classes.root, className),
			ref,
			role: component === defaultComponent$1 ? null : "rowgroup",
			ownerState,
			...other
		})
	});
});
TableHead.propTypes = {
	/**
	* The content of the component, normally `TableRow`.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Toolbar/toolbarClasses.mjs
function getToolbarUtilityClass(slot) {
	return generateUtilityClass("MuiToolbar", slot);
}
generateUtilityClasses("MuiToolbar", [
	"root",
	"gutters",
	"regular",
	"dense"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Toolbar/Toolbar.mjs
const useUtilityClasses$8 = (ownerState) => {
	const { classes, disableGutters, variant } = ownerState;
	return composeClasses({ root: [
		"root",
		!disableGutters && "gutters",
		variant
	] }, getToolbarUtilityClass, classes);
};
const ToolbarRoot = styled$2("div", {
	name: "MuiToolbar",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			!ownerState.disableGutters && styles.gutters,
			styles[ownerState.variant]
		];
	}
})(memoTheme(({ theme }) => ({
	position: "relative",
	display: "flex",
	alignItems: "center",
	variants: [
		{
			props: ({ ownerState }) => !ownerState.disableGutters,
			style: {
				paddingLeft: theme.spacing(2),
				paddingRight: theme.spacing(2),
				[theme.breakpoints.up("sm")]: {
					paddingLeft: theme.spacing(3),
					paddingRight: theme.spacing(3)
				}
			}
		},
		{
			props: { variant: "dense" },
			style: { minHeight: 48 }
		},
		{
			props: { variant: "regular" },
			style: theme.mixins.toolbar
		}
	]
})));
const Toolbar = /*#__PURE__*/ React$1.forwardRef(function Toolbar(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiToolbar"
	});
	const { className, component = "div", disableGutters = false, variant = "regular", ...other } = props;
	const ownerState = {
		...props,
		component,
		disableGutters,
		variant
	};
	const classes = useUtilityClasses$8(ownerState);
	return /*#__PURE__*/ jsx(ToolbarRoot, {
		as: component,
		className: clsx(classes.root, className),
		ref,
		ownerState,
		...other
	});
});
Toolbar.propTypes = {
	/**
	* The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
	* The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, disables gutter padding.
	* @default false
	*/
	disableGutters: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The variant to use.
	* @default 'regular'
	*/
	variant: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["dense", "regular"]), import_prop_types.default.string])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/KeyboardArrowLeft.mjs
/**
* @ignore - internal component.
*/
var KeyboardArrowLeft_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" }), "KeyboardArrowLeft");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/KeyboardArrowRight.mjs
/**
* @ignore - internal component.
*/
var KeyboardArrowRight_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" }), "KeyboardArrowRight");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TablePaginationActions/tablePaginationActionsClasses.mjs
function getTablePaginationActionsUtilityClass(slot) {
	return generateUtilityClass("MuiTablePaginationActions", slot);
}
generateUtilityClasses("MuiTablePaginationActions", ["root"]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TablePaginationActions/TablePaginationActions.mjs
const useUtilityClasses$7 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({ root: ["root"] }, getTablePaginationActionsUtilityClass, classes);
};
const TablePaginationActionsRoot = styled$2("div", {
	name: "MuiTablePaginationActions",
	slot: "Root"
})({});
const TablePaginationActions$1 = /*#__PURE__*/ React$1.forwardRef(function TablePaginationActions(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTablePaginationActions"
	});
	const { className, count, disabled = false, getItemAriaLabel, onPageChange, page, rowsPerPage, showFirstButton, showLastButton, slots = {}, slotProps = {}, ...other } = props;
	const isRtl = useRtl();
	const classes = useUtilityClasses$7(props);
	const handleFirstPageButtonClick = (event) => {
		onPageChange(event, 0);
	};
	const handleBackButtonClick = (event) => {
		onPageChange(event, page - 1);
	};
	const handleNextButtonClick = (event) => {
		onPageChange(event, page + 1);
	};
	const handleLastPageButtonClick = (event) => {
		onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
	};
	const FirstButton = slots.firstButton ?? IconButton$1;
	const LastButton = slots.lastButton ?? IconButton$1;
	const NextButton = slots.nextButton ?? IconButton$1;
	const PreviousButton = slots.previousButton ?? IconButton$1;
	const FirstButtonIcon = slots.firstButtonIcon ?? FirstPage_default;
	const LastButtonIcon = slots.lastButtonIcon ?? LastPage_default;
	const NextButtonIcon = slots.nextButtonIcon ?? KeyboardArrowRight_default;
	const PreviousButtonIcon = slots.previousButtonIcon ?? KeyboardArrowLeft_default;
	const FirstButtonSlot = isRtl ? LastButton : FirstButton;
	const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
	const NextButtonSlot = isRtl ? PreviousButton : NextButton;
	const LastButtonSlot = isRtl ? FirstButton : LastButton;
	const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
	const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
	const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
	const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
	return /*#__PURE__*/ jsxs(TablePaginationActionsRoot, {
		ref,
		className: clsx(classes.root, className),
		...other,
		children: [
			showFirstButton && /*#__PURE__*/ jsx(FirstButtonSlot, {
				onClick: handleFirstPageButtonClick,
				disabled: disabled || page === 0,
				"aria-label": getItemAriaLabel("first", page),
				title: getItemAriaLabel("first", page),
				...firstButtonSlotProps,
				children: isRtl ? /*#__PURE__*/ jsx(LastButtonIcon, { ...slotProps.lastButtonIcon }) : /*#__PURE__*/ jsx(FirstButtonIcon, { ...slotProps.firstButtonIcon })
			}),
			/*#__PURE__*/ jsx(PreviousButtonSlot, {
				onClick: handleBackButtonClick,
				disabled: disabled || page === 0,
				color: "inherit",
				"aria-label": getItemAriaLabel("previous", page),
				title: getItemAriaLabel("previous", page),
				...previousButtonSlotProps,
				children: isRtl ? /*#__PURE__*/ jsx(NextButtonIcon, { ...slotProps.nextButtonIcon }) : /*#__PURE__*/ jsx(PreviousButtonIcon, { ...slotProps.previousButtonIcon })
			}),
			/*#__PURE__*/ jsx(NextButtonSlot, {
				onClick: handleNextButtonClick,
				disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
				color: "inherit",
				"aria-label": getItemAriaLabel("next", page),
				title: getItemAriaLabel("next", page),
				...nextButtonSlotProps,
				children: isRtl ? /*#__PURE__*/ jsx(PreviousButtonIcon, { ...slotProps.previousButtonIcon }) : /*#__PURE__*/ jsx(NextButtonIcon, { ...slotProps.nextButtonIcon })
			}),
			showLastButton && /*#__PURE__*/ jsx(LastButtonSlot, {
				onClick: handleLastPageButtonClick,
				disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
				"aria-label": getItemAriaLabel("last", page),
				title: getItemAriaLabel("last", page),
				...lastButtonSlotProps,
				children: isRtl ? /*#__PURE__*/ jsx(FirstButtonIcon, { ...slotProps.firstButtonIcon }) : /*#__PURE__*/ jsx(LastButtonIcon, { ...slotProps.lastButtonIcon })
			})
		]
	});
});
TablePaginationActions$1.propTypes = {
	/**
	* @ignore
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* @ignore
	*/
	count: import_prop_types.default.number.isRequired,
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* Accepts a function which returns a string value that provides a user-friendly name for the current page.
	* This is important for screen reader users.
	*
	* For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
	* @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
	* @returns {string}
	*/
	getItemAriaLabel: import_prop_types.default.func.isRequired,
	/**
	* @ignore
	*/
	onPageChange: import_prop_types.default.func.isRequired,
	/**
	* @ignore
	*/
	page: import_prop_types.default.number.isRequired,
	/**
	* @ignore
	*/
	rowsPerPage: import_prop_types.default.number.isRequired,
	/**
	* @ignore
	*/
	showFirstButton: import_prop_types.default.bool.isRequired,
	/**
	* @ignore
	*/
	showLastButton: import_prop_types.default.bool.isRequired,
	/**
	* @ignore
	*/
	slotProps: import_prop_types.default.shape({
		firstButton: import_prop_types.default.object,
		firstButtonIcon: import_prop_types.default.object,
		lastButton: import_prop_types.default.object,
		lastButtonIcon: import_prop_types.default.object,
		nextButton: import_prop_types.default.object,
		nextButtonIcon: import_prop_types.default.object,
		previousButton: import_prop_types.default.object,
		previousButtonIcon: import_prop_types.default.object
	}),
	/**
	* @ignore
	*/
	slots: import_prop_types.default.shape({
		firstButton: import_prop_types.default.elementType,
		firstButtonIcon: import_prop_types.default.elementType,
		lastButton: import_prop_types.default.elementType,
		lastButtonIcon: import_prop_types.default.elementType,
		nextButton: import_prop_types.default.elementType,
		nextButtonIcon: import_prop_types.default.elementType,
		previousButton: import_prop_types.default.elementType,
		previousButtonIcon: import_prop_types.default.elementType
	})
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TablePagination/tablePaginationClasses.mjs
function getTablePaginationUtilityClass(slot) {
	return generateUtilityClass("MuiTablePagination", slot);
}
const tablePaginationClasses = generateUtilityClasses("MuiTablePagination", [
	"root",
	"toolbar",
	"spacer",
	"selectLabel",
	"selectRoot",
	"select",
	"selectIcon",
	"input",
	"menuItem",
	"displayedRows",
	"actions"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/locale/utils/buildFormatNumber.mjs
const buildFormatNumber = (locale) => {
	let formatter;
	if (typeof Intl !== "undefined" && Intl.NumberFormat) try {
		formatter = new Intl.NumberFormat(locale);
	} catch {}
	return (value) => {
		if (!Number.isFinite(value)) return String(value);
		return formatter ? formatter.format(value) : String(value);
	};
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TablePagination/TablePagination.mjs
var _TablePaginationInput;
const formatNumber = buildFormatNumber("en-US");
const TablePaginationRoot = styled$2(TableCell$1, {
	name: "MuiTablePagination",
	slot: "Root"
})(memoTheme(({ theme }) => ({
	overflow: "auto",
	color: (theme.vars || theme).palette.text.primary,
	fontSize: theme.typography.pxToRem(14),
	"&:last-child": { padding: 0 }
})));
const TablePaginationToolbar = styled$2(Toolbar, {
	name: "MuiTablePagination",
	slot: "Toolbar",
	overridesResolver: (props, styles) => ({
		[`& .${tablePaginationClasses.actions}`]: styles.actions,
		...styles.toolbar
	})
})(memoTheme(({ theme }) => ({
	minHeight: 52,
	paddingRight: 2,
	[`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: { minHeight: 52 },
	[theme.breakpoints.up("sm")]: {
		minHeight: 52,
		paddingRight: 2
	},
	[`& .${tablePaginationClasses.actions}`]: {
		flexShrink: 0,
		marginLeft: 20
	}
})));
const TablePaginationSpacer = styled$2("div", {
	name: "MuiTablePagination",
	slot: "Spacer"
})({ flex: "1 1 100%" });
const TablePaginationSelectLabel = styled$2("p", {
	name: "MuiTablePagination",
	slot: "SelectLabel"
})(memoTheme(({ theme }) => ({
	...theme.typography.body2,
	flexShrink: 0
})));
const TablePaginationSelect = styled$2(Select$1, {
	name: "MuiTablePagination",
	slot: "Select",
	overridesResolver: (props, styles) => ({
		[`& .${tablePaginationClasses.selectIcon}`]: styles.selectIcon,
		[`& .${tablePaginationClasses.select}`]: styles.select,
		...styles.input,
		...styles.selectRoot
	})
})({
	color: "inherit",
	fontSize: "inherit",
	flexShrink: 0,
	marginRight: 32,
	marginLeft: 8,
	[`& .${tablePaginationClasses.select}`]: {
		paddingLeft: 8,
		paddingRight: 24,
		textAlign: "right",
		textAlignLast: "right"
	}
});
const TablePaginationInputBase = styled$2(InputBase)(memoTheme(({ theme }) => ({ [`& .${tablePaginationClasses.select}:focus`]: { backgroundColor: (theme.vars || theme).palette.action.focus } })));
const TablePaginationMenuItem = styled$2(MenuItem$1, {
	name: "MuiTablePagination",
	slot: "MenuItem"
})({});
const TablePaginationDisplayedRows = styled$2("p", {
	name: "MuiTablePagination",
	slot: "DisplayedRows"
})(memoTheme(({ theme }) => ({
	...theme.typography.body2,
	flexShrink: 0
})));
function defaultLabelDisplayedRows({ from, to, count }) {
	return `${formatNumber(from)}–${formatNumber(to)} of ${count !== -1 ? formatNumber(count) : `more than ${formatNumber(to)}`}`;
}
function defaultGetAriaLabel(type) {
	return `Go to ${type} page`;
}
const useUtilityClasses$6 = (ownerState) => {
	const { classes } = ownerState;
	return composeClasses({
		root: ["root"],
		toolbar: ["toolbar"],
		spacer: ["spacer"],
		selectLabel: ["selectLabel"],
		select: ["select"],
		input: ["input"],
		selectIcon: ["selectIcon"],
		menuItem: ["menuItem"],
		displayedRows: ["displayedRows"],
		actions: ["actions"]
	}, getTablePaginationUtilityClass, classes);
};
/**
* A `TableCell` based component for placing inside `TableFooter` for pagination.
*/
const TablePagination$1 = /*#__PURE__*/ React$1.forwardRef(function TablePagination(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTablePagination"
	});
	const { ActionsComponent = TablePaginationActions$1, colSpan: colSpanProp, component = TableCell$1, count, disabled = false, getItemAriaLabel = defaultGetAriaLabel, labelDisplayedRows = defaultLabelDisplayedRows, labelRowsPerPage = "Rows per page:", onPageChange, onRowsPerPageChange, page, rowsPerPage, rowsPerPageOptions = [
		10,
		25,
		50,
		100
	], showFirstButton = false, showLastButton = false, slotProps = {}, slots = {}, ...other } = props;
	const ownerState = props;
	const classes = useUtilityClasses$6(ownerState);
	const selectProps = typeof slotProps?.select === "function" ? slotProps.select(ownerState) : slotProps?.select ?? {};
	const MenuItemComponent = selectProps.native ? "option" : TablePaginationMenuItem;
	let colSpan;
	if (component === TableCell$1 || component === "td") colSpan = colSpanProp || 1e3;
	const selectId = useId_default(selectProps.id);
	const labelId = useId_default(selectProps.labelId);
	const getLabelDisplayedRowsTo = () => {
		if (count === -1) return (page + 1) * rowsPerPage;
		return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
	};
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [RootSlot, rootSlotProps] = useSlot("root", {
		ref,
		className: classes.root,
		elementType: TablePaginationRoot,
		externalForwardedProps: {
			...externalForwardedProps,
			component,
			...other
		},
		ownerState,
		additionalProps: { colSpan }
	});
	const [ToolbarSlot, toolbarSlotProps] = useSlot("toolbar", {
		className: classes.toolbar,
		elementType: TablePaginationToolbar,
		externalForwardedProps,
		ownerState
	});
	const [SpacerSlot, spacerSlotProps] = useSlot("spacer", {
		className: classes.spacer,
		elementType: TablePaginationSpacer,
		externalForwardedProps,
		ownerState
	});
	const [SelectLabelSlot, selectLabelSlotProps] = useSlot("selectLabel", {
		className: classes.selectLabel,
		elementType: TablePaginationSelectLabel,
		externalForwardedProps,
		ownerState,
		additionalProps: { id: labelId }
	});
	const [SelectSlot, selectSlotProps] = useSlot("select", {
		className: classes.select,
		elementType: TablePaginationSelect,
		externalForwardedProps,
		ownerState
	});
	const [MenuItemSlot, menuItemSlotProps] = useSlot("menuItem", {
		className: classes.menuItem,
		elementType: MenuItemComponent,
		externalForwardedProps,
		ownerState
	});
	const [DisplayedRows, displayedRowsProps] = useSlot("displayedRows", {
		className: classes.displayedRows,
		elementType: TablePaginationDisplayedRows,
		externalForwardedProps,
		ownerState
	});
	return /*#__PURE__*/ jsx(RootSlot, {
		...rootSlotProps,
		children: /*#__PURE__*/ jsxs(ToolbarSlot, {
			...toolbarSlotProps,
			children: [
				/*#__PURE__*/ jsx(SpacerSlot, { ...spacerSlotProps }),
				rowsPerPageOptions.length > 1 && /*#__PURE__*/ jsx(SelectLabelSlot, {
					...selectLabelSlotProps,
					children: labelRowsPerPage
				}),
				rowsPerPageOptions.length > 1 && /*#__PURE__*/ jsx(SelectSlot, {
					variant: "standard",
					...!selectProps.variant && { input: _TablePaginationInput || (_TablePaginationInput = /*#__PURE__*/ jsx(TablePaginationInputBase, {})) },
					value: rowsPerPage,
					onChange: onRowsPerPageChange,
					id: selectId,
					labelId,
					...selectProps,
					classes: {
						...selectProps.classes,
						root: clsx(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
						select: clsx(classes.select, (selectProps.classes || {}).select),
						icon: clsx(classes.selectIcon, (selectProps.classes || {}).icon)
					},
					disabled,
					...selectSlotProps,
					children: rowsPerPageOptions.map((rowsPerPageOption) => /*#__PURE__*/ createElement(MenuItemSlot, {
						...menuItemSlotProps,
						key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
						value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
					}, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
				}),
				/*#__PURE__*/ jsx(DisplayedRows, {
					...displayedRowsProps,
					children: labelDisplayedRows({
						from: count === 0 ? 0 : page * rowsPerPage + 1,
						to: getLabelDisplayedRowsTo(),
						count: count === -1 ? -1 : count,
						page
					})
				}),
				/*#__PURE__*/ jsx(ActionsComponent, {
					className: classes.actions,
					count,
					onPageChange,
					page,
					rowsPerPage,
					showFirstButton,
					showLastButton,
					slotProps: slotProps.actions,
					slots: slots.actions,
					getItemAriaLabel,
					disabled
				})
			]
		})
	});
});
TablePagination$1.propTypes = {
	/**
	* The component used for displaying the actions.
	* Either a string to use a HTML element or a component.
	* @default TablePaginationActions
	*/
	ActionsComponent: import_prop_types.default.elementType,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	colSpan: import_prop_types.default.number,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* The total number of rows.
	*
	* To enable server side pagination for an unknown number of items, provide -1.
	*/
	count: integerPropType.isRequired,
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* Accepts a function which returns a string value that provides a user-friendly name for the current page.
	* This is important for screen reader users.
	*
	* For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
	* @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
	* @returns {string}
	* @default function defaultGetAriaLabel(type) {
	*   return `Go to ${type} page`;
	* }
	*/
	getItemAriaLabel: import_prop_types.default.func,
	/**
	* Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
	* object.
	*
	* For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
	* @default function defaultLabelDisplayedRows({ from, to, count }) {
	*   return `${formatNumber(from)}–${formatNumber(to)} of ${count !== -1 ? formatNumber(count) : `more than ${formatNumber(to)}`}`;
	* }
	*/
	labelDisplayedRows: import_prop_types.default.func,
	/**
	* Customize the rows per page label.
	*
	* For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
	* @default 'Rows per page:'
	*/
	labelRowsPerPage: import_prop_types.default.node,
	/**
	* Callback fired when the page is changed.
	*
	* @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
	* @param {number} page The page selected.
	*/
	onPageChange: import_prop_types.default.func.isRequired,
	/**
	* Callback fired when the number of rows per page is changed.
	*
	* @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
	*/
	onRowsPerPageChange: import_prop_types.default.func,
	/**
	* The zero-based index of the current page.
	*/
	page: chainPropTypes(integerPropType.isRequired, (props) => {
		const { count, page, rowsPerPage } = props;
		if (count === -1) return null;
		const newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
		if (page < 0 || page > newLastPage) return /* @__PURE__ */ new Error(`MUI: The page prop of a TablePagination is out of range (0 to ${newLastPage}, but page is ${page}).`);
		return null;
	}),
	/**
	* The number of rows per page.
	*
	* Set -1 to display all the rows.
	*/
	rowsPerPage: integerPropType.isRequired,
	/**
	* Customizes the options of the rows per page select field. If less than two options are
	* available, no select field will be displayed.
	* Use -1 for the value with a custom label to show all the rows.
	* @default [10, 25, 50, 100]
	*/
	rowsPerPageOptions: import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.shape({
		label: import_prop_types.default.string.isRequired,
		value: import_prop_types.default.number.isRequired
	})]).isRequired),
	/**
	* If `true`, show the first-page button.
	* @default false
	*/
	showFirstButton: import_prop_types.default.bool,
	/**
	* If `true`, show the last-page button.
	* @default false
	*/
	showLastButton: import_prop_types.default.bool,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		actions: import_prop_types.default.shape({
			firstButton: import_prop_types.default.object,
			firstButtonIcon: import_prop_types.default.object,
			lastButton: import_prop_types.default.object,
			lastButtonIcon: import_prop_types.default.object,
			nextButton: import_prop_types.default.object,
			nextButtonIcon: import_prop_types.default.object,
			previousButton: import_prop_types.default.object,
			previousButtonIcon: import_prop_types.default.object
		}),
		displayedRows: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		menuItem: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		select: import_prop_types.default.object,
		selectLabel: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		spacer: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		toolbar: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		actions: import_prop_types.default.shape({
			firstButton: import_prop_types.default.elementType,
			firstButtonIcon: import_prop_types.default.elementType,
			lastButton: import_prop_types.default.elementType,
			lastButtonIcon: import_prop_types.default.elementType,
			nextButton: import_prop_types.default.elementType,
			nextButtonIcon: import_prop_types.default.elementType,
			previousButton: import_prop_types.default.elementType,
			previousButtonIcon: import_prop_types.default.elementType
		}),
		displayedRows: import_prop_types.default.elementType,
		menuItem: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType,
		select: import_prop_types.default.elementType,
		selectLabel: import_prop_types.default.elementType,
		spacer: import_prop_types.default.elementType,
		toolbar: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableRow/tableRowClasses.mjs
function getTableRowUtilityClass(slot) {
	return generateUtilityClass("MuiTableRow", slot);
}
const tableRowClasses = generateUtilityClasses("MuiTableRow", [
	"root",
	"selected",
	"hover",
	"head",
	"footer"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableRow/TableRow.mjs
const useUtilityClasses$5 = (ownerState) => {
	const { classes, selected, hover, head, footer } = ownerState;
	return composeClasses({ root: [
		"root",
		selected && "selected",
		hover && "hover",
		head && "head",
		footer && "footer"
	] }, getTableRowUtilityClass, classes);
};
const TableRowRoot = styled$2("tr", {
	name: "MuiTableRow",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.root,
			ownerState.head && styles.head,
			ownerState.footer && styles.footer
		];
	}
})(memoTheme(({ theme }) => ({
	color: "inherit",
	display: "table-row",
	verticalAlign: "middle",
	outline: 0,
	[`&.${tableRowClasses.hover}:hover`]: { backgroundColor: (theme.vars || theme).palette.action.hover },
	[`&.${tableRowClasses.selected}`]: {
		backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
		"&:hover": { backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`) }
	}
})));
const defaultComponent = "tr";
/**
* Will automatically set dynamic row height
* based on the material table element parent (head, body, etc).
*/
const TableRow$1 = /*#__PURE__*/ React$1.forwardRef(function TableRow(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTableRow"
	});
	const { className, component = defaultComponent, hover = false, selected = false, ...other } = props;
	const tablelvl2 = React$1.useContext(Tablelvl2Context);
	const ownerState = {
		...props,
		component,
		hover,
		selected,
		head: tablelvl2 && tablelvl2.variant === "head",
		footer: tablelvl2 && tablelvl2.variant === "footer"
	};
	const classes = useUtilityClasses$5(ownerState);
	return /*#__PURE__*/ jsx(TableRowRoot, {
		as: component,
		ref,
		className: clsx(classes.root, className),
		role: component === defaultComponent ? null : "row",
		ownerState,
		...other
	});
});
TableRow$1.propTypes = {
	/**
	* Should be valid `<tr>` children such as `TableCell`.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* If `true`, the table row will shade on hover.
	* @default false
	*/
	hover: import_prop_types.default.bool,
	/**
	* If `true`, the table row will have the selected shading.
	* @default false
	*/
	selected: import_prop_types.default.bool,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/svg-icons/ArrowDownward.mjs
/**
* @ignore - internal component.
*/
var ArrowDownward_default = createSvgIcon(/*#__PURE__*/ jsx("path", { d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z" }), "ArrowDownward");
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableSortLabel/tableSortLabelClasses.mjs
function getTableSortLabelUtilityClass(slot) {
	return generateUtilityClass("MuiTableSortLabel", slot);
}
const tableSortLabelClasses = generateUtilityClasses("MuiTableSortLabel", [
	"root",
	"active",
	"icon",
	"directionDesc",
	"directionAsc"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TableSortLabel/TableSortLabel.mjs
const useUtilityClasses$4 = (ownerState) => {
	const { classes, direction, active } = ownerState;
	const slots = {
		root: [
			"root",
			active && "active",
			`direction${capitalize_default(direction)}`
		],
		icon: ["icon"]
	};
	return composeClasses(slots, getTableSortLabelUtilityClass, classes);
};
const TableSortLabelRoot = styled$2(ButtonBase, {
	name: "MuiTableSortLabel",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, ownerState.active && styles.active];
	}
})(memoTheme(({ theme }) => ({
	cursor: "pointer",
	display: "inline-flex",
	justifyContent: "flex-start",
	flexDirection: "inherit",
	alignItems: "center",
	"&:focus": { color: (theme.vars || theme).palette.text.secondary },
	"&:hover": {
		color: (theme.vars || theme).palette.text.secondary,
		[`& .${tableSortLabelClasses.icon}`]: { opacity: .5 }
	},
	[`&.${tableSortLabelClasses.active}`]: {
		color: (theme.vars || theme).palette.text.primary,
		[`& .${tableSortLabelClasses.icon}`]: {
			opacity: 1,
			color: (theme.vars || theme).palette.text.secondary
		}
	}
})));
const TableSortLabelIcon = styled$2("span", {
	name: "MuiTableSortLabel",
	slot: "Icon"
})(memoTheme(({ theme }) => ({
	fontSize: 18,
	marginRight: 4,
	marginLeft: 4,
	opacity: 0,
	...getTransitionStyles(theme, ["opacity", "transform"], { duration: theme.transitions.duration.shorter }),
	userSelect: "none",
	variants: [{
		props: { direction: "desc" },
		style: { transform: "rotate(0deg)" }
	}, {
		props: { direction: "asc" },
		style: { transform: "rotate(180deg)" }
	}]
})));
/**
* A button based label for placing inside `TableCell` for column sorting.
*/
const TableSortLabel$1 = /*#__PURE__*/ React$1.forwardRef(function TableSortLabel(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTableSortLabel"
	});
	const { active = false, children, className, direction = "asc", hideSortIcon = false, IconComponent = ArrowDownward_default, slots = {}, slotProps = {}, ...other } = props;
	const ownerState = {
		...props,
		active,
		direction,
		hideSortIcon,
		IconComponent
	};
	const classes = useUtilityClasses$4(ownerState);
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const [RootSlot, rootProps] = useSlot("root", {
		elementType: TableSortLabelRoot,
		externalForwardedProps,
		ownerState,
		className: clsx(classes.root, className),
		ref,
		additionalProps: { internalNativeButton: false }
	});
	const [IconSlot, iconProps] = useSlot("icon", {
		elementType: TableSortLabelIcon,
		externalForwardedProps,
		ownerState,
		className: classes.icon
	});
	return /*#__PURE__*/ jsxs(RootSlot, {
		disableRipple: true,
		component: "span",
		...rootProps,
		...other,
		children: [children, hideSortIcon && !active ? null : /*#__PURE__*/ jsx(IconSlot, {
			as: IconComponent,
			...iconProps
		})]
	});
});
TableSortLabel$1.propTypes = {
	/**
	* If `true`, the label will have the active styling (should be true for the sorted column).
	* @default false
	*/
	active: import_prop_types.default.bool,
	/**
	* Label contents, the arrow will be appended automatically.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The current sort direction.
	* @default 'asc'
	*/
	direction: import_prop_types.default.oneOf(["asc", "desc"]),
	/**
	* Hide sort icon when active is false.
	* @default false
	*/
	hideSortIcon: import_prop_types.default.bool,
	/**
	* Sort icon to use.
	* @default ArrowDownwardIcon
	*/
	IconComponent: import_prop_types.default.elementType,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		icon: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		icon: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/internal/animate.mjs
function easeInOutSin(time) {
	return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function animate(property, element, to, options = {}, cb = () => {}) {
	const { ease = easeInOutSin, duration = 300 } = options;
	let start = null;
	const from = element[property];
	let cancelled = false;
	const cancel = () => {
		cancelled = true;
	};
	const step = (timestamp) => {
		if (cancelled) {
			cb(/* @__PURE__ */ new Error("Animation cancelled"));
			return;
		}
		if (start === null) start = timestamp;
		const time = Math.min(1, (timestamp - start) / duration);
		element[property] = ease(time) * (to - from) + from;
		if (time >= 1) {
			requestAnimationFrame(() => {
				cb(null);
			});
			return;
		}
		requestAnimationFrame(step);
	};
	if (from === to) {
		cb(/* @__PURE__ */ new Error("Element already at target position"));
		return cancel;
	}
	requestAnimationFrame(step);
	return cancel;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Tabs/ScrollbarSize.mjs
const styles = {
	width: 99,
	height: 99,
	position: "absolute",
	top: -9999,
	overflow: "scroll",
	pointerEvents: "none"
};
/**
* @ignore - internal component.
* The component originates from https://github.com/STORIS/react-scrollbar-size.
* It has been moved into the core in order to minimize the bundle size.
*/
function ScrollbarSize(props) {
	const { onChange, ...other } = props;
	const scrollbarHeight = React$1.useRef();
	const nodeRef = React$1.useRef(null);
	const setMeasurements = () => {
		scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
	};
	useEnhancedEffect_default(() => {
		const handleResize = debounce_default(() => {
			const prevHeight = scrollbarHeight.current;
			setMeasurements();
			if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
		});
		const containerWindow = ownerWindow_default(nodeRef.current);
		containerWindow.addEventListener("resize", handleResize);
		return () => {
			handleResize.clear();
			containerWindow.removeEventListener("resize", handleResize);
		};
	}, [onChange]);
	React$1.useEffect(() => {
		setMeasurements();
		onChange(scrollbarHeight.current);
	}, [onChange]);
	return /*#__PURE__*/ jsx("div", {
		style: styles,
		...other,
		ref: nodeRef
	});
}
ScrollbarSize.propTypes = { onChange: import_prop_types.default.func.isRequired };
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TabScrollButton/tabScrollButtonClasses.mjs
function getTabScrollButtonUtilityClass(slot) {
	return generateUtilityClass("MuiTabScrollButton", slot);
}
const tabScrollButtonClasses = generateUtilityClasses("MuiTabScrollButton", [
	"root",
	"vertical",
	"horizontal",
	"disabled"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/TabScrollButton/TabScrollButton.mjs
const useUtilityClasses$3 = (ownerState) => {
	const { classes, orientation, disabled } = ownerState;
	return composeClasses({ root: [
		"root",
		orientation,
		disabled && "disabled"
	] }, getTabScrollButtonUtilityClass, classes);
};
const TabScrollButtonRoot = styled$2(ButtonBase, {
	name: "MuiTabScrollButton",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, ownerState.orientation && styles[ownerState.orientation]];
	}
})({
	width: 40,
	flexShrink: 0,
	opacity: .8,
	[`&.${tabScrollButtonClasses.disabled}`]: { opacity: 0 },
	variants: [{
		props: { orientation: "vertical" },
		style: {
			width: "100%",
			height: 40,
			"& svg": { transform: "var(--TabScrollButton-svgRotate)" }
		}
	}]
});
const TabScrollButton = /*#__PURE__*/ React$1.forwardRef(function TabScrollButton(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTabScrollButton"
	});
	const { className, slots = {}, slotProps = {}, direction, orientation, disabled, ...other } = props;
	const { nativeButton, ...buttonBaseProps } = other;
	const isRtl = useRtl();
	const ownerState = {
		isRtl,
		...props
	};
	const classes = useUtilityClasses$3(ownerState);
	const StartButtonIcon = slots.StartScrollButtonIcon ?? KeyboardArrowLeft_default;
	const EndButtonIcon = slots.EndScrollButtonIcon ?? KeyboardArrowRight_default;
	const startButtonIconProps = useSlotProps({
		elementType: StartButtonIcon,
		externalSlotProps: slotProps.startScrollButtonIcon,
		additionalProps: { fontSize: "small" },
		ownerState
	});
	const endButtonIconProps = useSlotProps({
		elementType: EndButtonIcon,
		externalSlotProps: slotProps.endScrollButtonIcon,
		additionalProps: { fontSize: "small" },
		ownerState
	});
	return /*#__PURE__*/ jsx(TabScrollButtonRoot, {
		component: "div",
		className: clsx(classes.root, className),
		ref,
		role: null,
		ownerState,
		tabIndex: null,
		...buttonBaseProps,
		style: {
			...buttonBaseProps.style,
			...orientation === "vertical" && { "--TabScrollButton-svgRotate": `rotate(${isRtl ? -90 : 90}deg)` }
		},
		children: direction === "left" ? /*#__PURE__*/ jsx(StartButtonIcon, { ...startButtonIconProps }) : /*#__PURE__*/ jsx(EndButtonIcon, { ...endButtonIconProps })
	});
});
TabScrollButton.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The direction the button should indicate.
	*/
	direction: import_prop_types.default.oneOf(["left", "right"]).isRequired,
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* The component orientation (layout flow direction).
	*/
	orientation: import_prop_types.default.oneOf(["horizontal", "vertical"]).isRequired,
	/**
	* The extra props for the slot components.
	* You can override the existing props or add new ones.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		endScrollButtonIcon: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		startScrollButtonIcon: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		EndScrollButtonIcon: import_prop_types.default.elementType,
		StartScrollButtonIcon: import_prop_types.default.elementType
	}),
	/**
	* @ignore
	*/
	style: import_prop_types.default.object,
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	])
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Tabs/tabsClasses.mjs
function getTabsUtilityClass(slot) {
	return generateUtilityClass("MuiTabs", slot);
}
const tabsClasses = generateUtilityClasses("MuiTabs", [
	"root",
	"vertical",
	"list",
	"centered",
	"scroller",
	"fixed",
	"scrollableX",
	"scrollableY",
	"hideScrollbar",
	"scrollButtons",
	"scrollButtonsHideMobile",
	"indicator"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/Tabs/Tabs.mjs
const useUtilityClasses$2 = (ownerState) => {
	const { vertical, fixed, hideScrollbar, scrollableX, scrollableY, centered, scrollButtonsHideMobile, classes } = ownerState;
	return composeClasses({
		root: ["root", vertical && "vertical"],
		scroller: [
			"scroller",
			fixed && "fixed",
			hideScrollbar && "hideScrollbar",
			scrollableX && "scrollableX",
			scrollableY && "scrollableY"
		],
		list: [
			"list",
			vertical && "vertical",
			centered && "centered"
		],
		indicator: ["indicator"],
		scrollButtons: ["scrollButtons", scrollButtonsHideMobile && "scrollButtonsHideMobile"],
		scrollableX: [scrollableX && "scrollableX"],
		hideScrollbar: [hideScrollbar && "hideScrollbar"]
	}, getTabsUtilityClass, classes);
};
const TabsRoot = styled$2("div", {
	name: "MuiTabs",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			{ [`& .${tabsClasses.scrollButtons}`]: styles.scrollButtons },
			{ [`& .${tabsClasses.scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile },
			styles.root,
			ownerState.vertical && styles.vertical
		];
	}
})(memoTheme(({ theme }) => ({
	overflow: "hidden",
	minHeight: 48,
	WebkitOverflowScrolling: "touch",
	display: "flex",
	variants: [{
		props: ({ ownerState }) => ownerState.vertical,
		style: { flexDirection: "column" }
	}, {
		props: ({ ownerState }) => ownerState.scrollButtonsHideMobile,
		style: { [`& .${tabsClasses.scrollButtons}`]: { [theme.breakpoints.down("sm")]: { display: "none" } } }
	}]
})));
const TabsScroller = styled$2("div", {
	name: "MuiTabs",
	slot: "Scroller",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			styles.scroller,
			ownerState.fixed && styles.fixed,
			ownerState.hideScrollbar && styles.hideScrollbar,
			ownerState.scrollableX && styles.scrollableX,
			ownerState.scrollableY && styles.scrollableY
		];
	}
})({
	position: "relative",
	display: "inline-block",
	flex: "1 1 auto",
	whiteSpace: "nowrap",
	variants: [
		{
			props: ({ ownerState }) => ownerState.fixed,
			style: {
				overflowX: "hidden",
				width: "100%"
			}
		},
		{
			props: ({ ownerState }) => ownerState.hideScrollbar,
			style: {
				scrollbarWidth: "none",
				"&::-webkit-scrollbar": { display: "none" }
			}
		},
		{
			props: ({ ownerState }) => ownerState.scrollableX,
			style: {
				overflowX: "auto",
				overflowY: "hidden"
			}
		},
		{
			props: ({ ownerState }) => ownerState.scrollableY,
			style: {
				overflowY: "auto",
				overflowX: "hidden"
			}
		}
	]
});
const List = styled$2("div", {
	name: "MuiTabs",
	slot: "List",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.list, ownerState.centered && styles.centered];
	}
})({
	display: "flex",
	variants: [{
		props: ({ ownerState }) => ownerState.vertical,
		style: { flexDirection: "column" }
	}, {
		props: ({ ownerState }) => ownerState.centered,
		style: { justifyContent: "center" }
	}]
});
const TabsIndicator = styled$2("span", {
	name: "MuiTabs",
	slot: "Indicator"
})(memoTheme(({ theme }) => ({
	position: "absolute",
	height: 2,
	bottom: 0,
	width: "100%",
	...getTransitionStyles(theme),
	variants: [
		{
			props: { indicatorColor: "primary" },
			style: { backgroundColor: (theme.vars || theme).palette.primary.main }
		},
		{
			props: { indicatorColor: "secondary" },
			style: { backgroundColor: (theme.vars || theme).palette.secondary.main }
		},
		{
			props: ({ ownerState }) => ownerState.vertical,
			style: {
				height: "100%",
				width: 2,
				right: 0
			}
		}
	]
})));
const TabsScrollbarSize = styled$2(ScrollbarSize)({
	overflowX: "auto",
	overflowY: "hidden",
	scrollbarWidth: "none",
	"&::-webkit-scrollbar": { display: "none" }
});
const defaultIndicatorStyle = {};
const warnedTabValueInvalid = /* @__PURE__ */ new WeakMap();
let warnedOnceTabPresent = false;
const Tabs$1 = /*#__PURE__*/ React$1.forwardRef(function Tabs(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiTabs"
	});
	const theme = useTheme$1();
	const isRtl = useRtl();
	const reducedMotion = useReducedMotion(theme.motion.reducedMotion, false);
	const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, action, centered = false, children: childrenProp, className, component = "div", allowScrollButtonsMobile = false, indicatorColor = "primary", onChange, orientation = "horizontal", scrollButtons = "auto", selectionFollowsFocus, slots = {}, slotProps = {}, textColor = "primary", value, variant = "standard", visibleScrollbar = false, ...other } = props;
	const scrollable = variant === "scrollable";
	const vertical = orientation === "vertical";
	const scrollStart = vertical ? "scrollTop" : "scrollLeft";
	const start = vertical ? "top" : "left";
	const end = vertical ? "bottom" : "right";
	const clientSize = vertical ? "clientHeight" : "clientWidth";
	const size = vertical ? "height" : "width";
	const ownerState = {
		...props,
		component,
		allowScrollButtonsMobile,
		indicatorColor,
		orientation,
		vertical,
		scrollButtons,
		textColor,
		variant,
		visibleScrollbar,
		fixed: !scrollable,
		hideScrollbar: scrollable && !visibleScrollbar,
		scrollableX: scrollable && !vertical,
		scrollableY: scrollable && vertical,
		centered: centered && !scrollable,
		scrollButtonsHideMobile: !allowScrollButtonsMobile
	};
	const classes = useUtilityClasses$2(ownerState);
	const startScrollButtonIconProps = useSlotProps({
		elementType: slots.startScrollButtonIcon,
		externalSlotProps: slotProps.startScrollButtonIcon,
		ownerState
	});
	const endScrollButtonIconProps = useSlotProps({
		elementType: slots.endScrollButtonIcon,
		externalSlotProps: slotProps.endScrollButtonIcon,
		ownerState
	});
	if (centered && scrollable) console.error("MUI: You can not use the `centered={true}` and `variant=\"scrollable\"` properties at the same time on a `Tabs` component.");
	const [mounted, setMounted] = React$1.useState(false);
	const [indicatorStyle, setIndicatorStyle] = React$1.useState(defaultIndicatorStyle);
	const [displayStartScroll, setDisplayStartScroll] = React$1.useState(false);
	const [displayEndScroll, setDisplayEndScroll] = React$1.useState(false);
	const [updateScrollObserver, setUpdateScrollObserver] = React$1.useState(false);
	const selectedValue = value === false ? null : value;
	const [isFocusWithinList, setIsFocusWithinList] = React$1.useState(false);
	const [scrollerStyle, setScrollerStyle] = React$1.useState({
		overflow: "hidden",
		scrollbarWidth: 0
	});
	const valueToIndex = /* @__PURE__ */ new Map();
	const tabsRef = React$1.useRef(null);
	const tabListRef = React$1.useRef(null);
	const externalForwardedProps = {
		slots,
		slotProps
	};
	const getTabsMeta = () => {
		const tabsNode = tabsRef.current;
		let tabsMeta;
		if (tabsNode) {
			const rect = tabsNode.getBoundingClientRect();
			tabsMeta = {
				clientWidth: tabsNode.clientWidth,
				scrollLeft: tabsNode.scrollLeft,
				scrollTop: tabsNode.scrollTop,
				scrollWidth: tabsNode.scrollWidth,
				top: rect.top,
				bottom: rect.bottom,
				left: rect.left,
				right: rect.right
			};
		}
		let tabMeta;
		if (tabsNode && value !== false) {
			const children = tabListRef.current.children;
			if (children.length > 0) {
				const tab = children[valueToIndex.get(value)];
				if (!tab && !warnedTabValueInvalid.has(tabsRef)) {
					warnedTabValueInvalid.set(tabsRef, true);
					console.error([
						`MUI: The \`value\` provided to the Tabs component is invalid.`,
						`None of the Tabs' children match with "${value}".`,
						valueToIndex.keys ? `You can provide one of the following values: ${Array.from(valueToIndex.keys()).join(", ")}.` : null
					].join("\n"));
				}
				tabMeta = tab ? tab.getBoundingClientRect() : null;
				if (isLayoutSupported() && !warnedOnceTabPresent && tabMeta && tabMeta.width === 0 && tabMeta.height === 0 && tabsMeta.clientWidth !== 0) {
					tabsMeta = null;
					console.error([
						"MUI: The `value` provided to the Tabs component is invalid.",
						`The Tab with this \`value\` ("${value}") is not part of the document layout.`,
						"Make sure the tab item is present in the document or that it's not `display: none`."
					].join("\n"));
					warnedOnceTabPresent = true;
				}
			}
		}
		return {
			tabsMeta,
			tabMeta
		};
	};
	const updateIndicatorState = useEventCallback_default(() => {
		const { tabsMeta, tabMeta } = getTabsMeta();
		let startValue = 0;
		let startIndicator;
		if (vertical) {
			startIndicator = "top";
			if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
		} else {
			startIndicator = isRtl ? "right" : "left";
			if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
		}
		const newIndicatorStyle = {
			[startIndicator]: startValue,
			[size]: tabMeta ? tabMeta[size] : 0
		};
		if (typeof indicatorStyle[startIndicator] !== "number" || typeof indicatorStyle[size] !== "number") setIndicatorStyle(newIndicatorStyle);
		else {
			const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
			const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
			if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
		}
	});
	const scroll = (scrollValue, { animation = true } = {}) => {
		if (animation && !reducedMotion.shouldReduceMotion) animate(scrollStart, tabsRef.current, scrollValue, { duration: theme.transitions.duration.standard });
		else tabsRef.current[scrollStart] = scrollValue;
	};
	const moveTabsScroll = (delta) => {
		let scrollValue = tabsRef.current[scrollStart];
		if (vertical) scrollValue += delta;
		else scrollValue += delta * (isRtl ? -1 : 1);
		scroll(scrollValue);
	};
	const getScrollSize = () => {
		const containerSize = tabsRef.current[clientSize];
		let totalSize = 0;
		const children = Array.from(tabListRef.current.children);
		for (let i = 0; i < children.length; i += 1) {
			const tab = children[i];
			if (totalSize + tab[clientSize] > containerSize) {
				if (i === 0) totalSize = containerSize;
				break;
			}
			totalSize += tab[clientSize];
		}
		return totalSize;
	};
	const handleStartScrollClick = () => {
		moveTabsScroll(-1 * getScrollSize());
	};
	const handleEndScrollClick = () => {
		moveTabsScroll(getScrollSize());
	};
	const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = useSlot("scrollbar", {
		className: clsx(classes.scrollableX, classes.hideScrollbar),
		elementType: TabsScrollbarSize,
		shouldForwardComponentProp: true,
		externalForwardedProps,
		ownerState
	});
	const handleScrollbarSizeChange = React$1.useCallback((scrollbarWidth) => {
		scrollbarOnChange?.(scrollbarWidth);
		setScrollerStyle({
			overflow: null,
			scrollbarWidth
		});
	}, [scrollbarOnChange]);
	const [ScrollButtonsSlot, scrollButtonSlotProps] = useSlot("scrollButtons", {
		className: classes.scrollButtons,
		elementType: TabScrollButton,
		externalForwardedProps,
		ownerState,
		additionalProps: {
			orientation,
			slots: {
				StartScrollButtonIcon: slots.startScrollButtonIcon,
				EndScrollButtonIcon: slots.endScrollButtonIcon
			},
			slotProps: {
				startScrollButtonIcon: startScrollButtonIconProps,
				endScrollButtonIcon: endScrollButtonIconProps
			}
		}
	});
	const getConditionalElements = () => {
		const conditionalElements = {};
		conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ jsx(ScrollbarSlot, {
			...scrollbarSlotProps,
			onChange: handleScrollbarSizeChange
		}) : null;
		const showScrollButtons = scrollable && (scrollButtons === "auto" && (displayStartScroll || displayEndScroll) || scrollButtons === true);
		conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ jsx(ScrollButtonsSlot, {
			direction: isRtl ? "right" : "left",
			onClick: handleStartScrollClick,
			disabled: !displayStartScroll,
			...scrollButtonSlotProps
		}) : null;
		conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ jsx(ScrollButtonsSlot, {
			direction: isRtl ? "left" : "right",
			onClick: handleEndScrollClick,
			disabled: !displayEndScroll,
			...scrollButtonSlotProps
		}) : null;
		return conditionalElements;
	};
	const scrollSelectedIntoView = useEventCallback_default((animation) => {
		const { tabsMeta, tabMeta } = getTabsMeta();
		if (!tabMeta || !tabsMeta) return;
		if (tabMeta[start] < tabsMeta[start]) {
			const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
			scroll(nextScrollStart, { animation });
		} else if (tabMeta[end] > tabsMeta[end]) {
			const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
			scroll(nextScrollStart, { animation });
		}
	});
	const updateScrollButtonState = useEventCallback_default(() => {
		if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
	});
	React$1.useEffect(() => {
		const handleResize = debounce_default(() => {
			if (tabsRef.current) updateIndicatorState();
		});
		let resizeObserver;
		/**
		* @type {MutationCallback}
		*/
		const handleMutation = (records) => {
			records.forEach((record) => {
				record.removedNodes.forEach((item) => {
					resizeObserver?.unobserve(item);
				});
				record.addedNodes.forEach((item) => {
					resizeObserver?.observe(item);
				});
			});
			handleResize();
			updateScrollButtonState();
		};
		const win = ownerWindow_default(tabsRef.current);
		win.addEventListener("resize", handleResize);
		let mutationObserver;
		if (typeof ResizeObserver !== "undefined") {
			resizeObserver = new ResizeObserver(handleResize);
			Array.from(tabListRef.current.children).forEach((child) => {
				resizeObserver.observe(child);
			});
		}
		if (typeof MutationObserver !== "undefined") {
			mutationObserver = new MutationObserver(handleMutation);
			mutationObserver.observe(tabListRef.current, { childList: true });
		}
		return () => {
			handleResize.clear();
			win.removeEventListener("resize", handleResize);
			mutationObserver?.disconnect();
			resizeObserver?.disconnect();
		};
	}, [updateIndicatorState, updateScrollButtonState]);
	/**
	* Toggle visibility of start and end scroll buttons
	* Using IntersectionObserver on first and last Tabs.
	*/
	React$1.useEffect(() => {
		const tabListChildren = Array.from(tabListRef.current.children);
		const length = tabListChildren.length;
		if (typeof IntersectionObserver !== "undefined" && length > 0 && scrollable && scrollButtons !== false) {
			const firstTab = tabListChildren[0];
			const lastTab = tabListChildren[length - 1];
			const observerOptions = {
				root: tabsRef.current,
				threshold: .99
			};
			const handleScrollButtonStart = (entries) => {
				setDisplayStartScroll(!entries[0].isIntersecting);
			};
			const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
			firstObserver.observe(firstTab);
			const handleScrollButtonEnd = (entries) => {
				setDisplayEndScroll(!entries[0].isIntersecting);
			};
			const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
			lastObserver.observe(lastTab);
			return () => {
				firstObserver.disconnect();
				lastObserver.disconnect();
			};
		}
	}, [
		scrollable,
		scrollButtons,
		updateScrollObserver,
		childrenProp?.length
	]);
	React$1.useEffect(() => {
		setMounted(true);
	}, []);
	React$1.useEffect(() => {
		updateIndicatorState();
	});
	React$1.useEffect(() => {
		scrollSelectedIntoView(defaultIndicatorStyle !== indicatorStyle);
	}, [scrollSelectedIntoView, indicatorStyle]);
	React$1.useImperativeHandle(action, () => ({
		updateIndicator: updateIndicatorState,
		updateScrollButtons: updateScrollButtonState
	}), [updateIndicatorState, updateScrollButtonState]);
	const [IndicatorSlot, indicatorSlotProps] = useSlot("indicator", {
		className: classes.indicator,
		elementType: TabsIndicator,
		externalForwardedProps,
		ownerState,
		additionalProps: { style: indicatorStyle }
	});
	const indicator = /*#__PURE__*/ jsx(IndicatorSlot, { ...indicatorSlotProps });
	const rovingContainer = useRovingTabIndexRoot({
		activeItemId: isFocusWithinList ? void 0 : selectedValue,
		orientation,
		isRtl
	});
	const rovingContainerProps = rovingContainer.getContainerProps();
	const children = React$1.Children.toArray(childrenProp).filter(React$1.isValidElement).map((child, index) => {
		const childValue = child.props.value === void 0 ? index : child.props.value;
		if ((0, import_react_is.isFragment)(child)) console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join("\n"));
		valueToIndex.set(childValue, index);
		return {
			child,
			index,
			childValue
		};
	}).map(({ child, childValue }) => {
		const selected = childValue === value;
		return /*#__PURE__*/ React$1.cloneElement(child, {
			fullWidth: variant === "fullWidth",
			indicator: selected && !mounted && indicator,
			selected,
			selectionFollowsFocus,
			onChange,
			textColor,
			value: childValue
		});
	});
	const conditionalElements = getConditionalElements();
	const [RootSlot, rootSlotProps] = useSlot("root", {
		ref,
		className: clsx(classes.root, className),
		elementType: TabsRoot,
		externalForwardedProps: {
			...externalForwardedProps,
			...other,
			component
		},
		ownerState
	});
	const [ScrollerSlot, scrollerSlotProps] = useSlot("scroller", {
		ref: tabsRef,
		className: classes.scroller,
		elementType: TabsScroller,
		externalForwardedProps,
		ownerState,
		additionalProps: { style: {
			overflow: scrollerStyle.overflow,
			[vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? void 0 : -scrollerStyle.scrollbarWidth
		} }
	});
	const mergedRef = useForkRef_default(rovingContainerProps.ref, tabListRef);
	const handleKeyDown = (event) => {
		const list = tabListRef.current;
		if (getActiveElement_default(ownerDocument_default(list))?.getAttribute("role") !== "tab") return;
		rovingContainerProps.onKeyDown(event);
	};
	const [ListSlot, listSlotProps] = useSlot("list", {
		ref: mergedRef,
		className: classes.list,
		elementType: List,
		externalForwardedProps,
		ownerState,
		getSlotProps: (handlers) => ({
			...handlers,
			onBlur: (event) => {
				if (!contains_default(event.currentTarget, event.relatedTarget)) setIsFocusWithinList(false);
				handlers.onBlur?.(event);
			},
			onKeyDown: (event) => {
				handleKeyDown(event);
				handlers.onKeyDown?.(event);
			},
			onFocus: (event) => {
				setIsFocusWithinList(true);
				rovingContainerProps.onFocus(event);
				handlers.onFocus?.(event);
			}
		})
	});
	return /*#__PURE__*/ jsxs(RootSlot, {
		...rootSlotProps,
		children: [
			conditionalElements.scrollButtonStart,
			conditionalElements.scrollbarSizeListener,
			/*#__PURE__*/ jsxs(ScrollerSlot, {
				...scrollerSlotProps,
				children: [/*#__PURE__*/ jsx(ListSlot, {
					"aria-label": ariaLabel,
					"aria-labelledby": ariaLabelledBy,
					"aria-orientation": orientation === "vertical" ? "vertical" : null,
					role: "tablist",
					...listSlotProps,
					children: /*#__PURE__*/ jsx(RovingTabIndexContext.Provider, {
						value: rovingContainer,
						children
					})
				}), mounted && indicator]
			}),
			conditionalElements.scrollButtonEnd
		]
	});
});
Tabs$1.propTypes = {
	/**
	* Callback fired when the component mounts.
	* This is useful when you want to trigger an action programmatically.
	* It supports two actions: `updateIndicator()` and `updateScrollButtons()`
	*
	* @param {object} actions This object contains all possible actions
	* that can be triggered programmatically.
	*/
	action: refType,
	/**
	* If `true`, the scroll buttons aren't forced hidden on mobile.
	* By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
	* @default false
	*/
	allowScrollButtonsMobile: import_prop_types.default.bool,
	/**
	* The label for the Tabs as a string.
	*/
	"aria-label": import_prop_types.default.string,
	/**
	* An id or list of ids separated by a space that label the Tabs.
	*/
	"aria-labelledby": import_prop_types.default.string,
	/**
	* If `true`, the tabs are centered.
	* This prop is intended for large views.
	* @default false
	*/
	centered: import_prop_types.default.bool,
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The component used for the root node.
	* Either a string to use a HTML element or a component.
	*/
	component: import_prop_types.default.elementType,
	/**
	* Determines the color of the indicator.
	* @default 'primary'
	*/
	indicatorColor: import_prop_types.default.oneOfType([import_prop_types.default.oneOf(["primary", "secondary"]), import_prop_types.default.string]),
	/**
	* Callback fired when the value changes.
	*
	* @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
	* @param {any} value We default to the index of the child (number)
	*/
	onChange: import_prop_types.default.func,
	/**
	* The component orientation (layout flow direction).
	* @default 'horizontal'
	*/
	orientation: import_prop_types.default.oneOf(["horizontal", "vertical"]),
	/**
	* Determine behavior of scroll buttons when tabs are set to scroll:
	*
	* - `auto` will only present them when not all the items are visible.
	* - `true` will always present them.
	* - `false` will never present them.
	*
	* By default the scroll buttons are hidden on mobile.
	* This behavior can be disabled with `allowScrollButtonsMobile`.
	* @default 'auto'
	*/
	scrollButtons: import_prop_types.default.oneOf([
		"auto",
		false,
		true
	]),
	/**
	* If `true` the selected tab changes on focus. Otherwise it only
	* changes on activation.
	*/
	selectionFollowsFocus: import_prop_types.default.bool,
	/**
	* The props used for each slot inside.
	* @default {}
	*/
	slotProps: import_prop_types.default.shape({
		endScrollButtonIcon: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		indicator: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		list: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		root: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		scrollbar: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		scrollButtons: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		scroller: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object]),
		startScrollButtonIcon: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.object])
	}),
	/**
	* The components used for each slot inside.
	* @default {}
	*/
	slots: import_prop_types.default.shape({
		endScrollButtonIcon: import_prop_types.default.elementType,
		indicator: import_prop_types.default.elementType,
		list: import_prop_types.default.elementType,
		root: import_prop_types.default.elementType,
		scrollbar: import_prop_types.default.elementType,
		scrollButtons: import_prop_types.default.elementType,
		scroller: import_prop_types.default.elementType,
		startScrollButtonIcon: import_prop_types.default.elementType
	}),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* Determines the color of the `Tab`.
	* @default 'primary'
	*/
	textColor: import_prop_types.default.oneOf([
		"inherit",
		"primary",
		"secondary"
	]),
	/**
	* The value of the currently selected `Tab`.
	* If you don't want any selected `Tab`, you can set this prop to `false`.
	*/
	value: import_prop_types.default.any,
	/**
	* Determines additional display behavior of the tabs:
	*
	*  - `scrollable` will invoke scrolling properties and allow for horizontally
	*  scrolling (or swiping) of the tab bar.
	*  - `fullWidth` will make the tabs grow to use all the available space,
	*  which should be used for small views, like on mobile.
	*  - `standard` will render the default state.
	* @default 'standard'
	*/
	variant: import_prop_types.default.oneOf([
		"fullWidth",
		"scrollable",
		"standard"
	]),
	/**
	* If `true`, the scrollbar is visible. It can be useful when displaying
	* a long vertical list of tabs.
	* @default false
	*/
	visibleScrollbar: import_prop_types.default.bool
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ToggleButtonGroup/ToggleButtonGroupContext.mjs
/**
* @ignore - internal component.
*/
const ToggleButtonGroupContext = /*#__PURE__*/ React$1.createContext({});
ToggleButtonGroupContext.displayName = "ToggleButtonGroupContext";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ToggleButtonGroup/ToggleButtonGroupButtonContext.mjs
/**
* @ignore - internal component.
*/
const ToggleButtonGroupButtonContext = /*#__PURE__*/ React$1.createContext(void 0);
ToggleButtonGroupButtonContext.displayName = "ToggleButtonGroupButtonContext";
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ToggleButtonGroup/isValueSelected.mjs
function isValueSelected(value, candidate) {
	if (candidate === void 0 || value === void 0) return false;
	if (Array.isArray(candidate)) return candidate.includes(value);
	return value === candidate;
}
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ToggleButton/RovingToggleButton.mjs
function RovingToggleButton(props, ref) {
	const { children, disabled = false, selected = false, value } = props;
	const rovingContext = useRovingTabIndexContext();
	const rovingItemProps = useRovingTabIndexItem({
		id: value,
		ref,
		disabled,
		selected
	});
	const tabIndex = rovingContext.getItemMap().size === 0 && selected ? 0 : rovingItemProps.tabIndex;
	return /*#__PURE__*/ React$1.cloneElement(React$1.Children.only(children), {
		...rovingItemProps,
		tabIndex: children.props.tabIndex ?? tabIndex
	});
}
var RovingToggleButton_default = /*#__PURE__*/ React$1.forwardRef(RovingToggleButton);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ToggleButton/ToggleButton.mjs
const useUtilityClasses$1 = (ownerState) => {
	const { classes, fullWidth, selected, disabled, size, color } = ownerState;
	const slots = { root: [
		"root",
		selected && "selected",
		disabled && "disabled",
		fullWidth && "fullWidth",
		`size${capitalize_default(size)}`,
		color
	] };
	return composeClasses(slots, getToggleButtonUtilityClass, classes);
};
const ToggleButtonRoot = styled$2(ButtonBase, {
	name: "MuiToggleButton",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [styles.root, styles[`size${capitalize_default(ownerState.size)}`]];
	}
})(memoTheme(({ theme }) => ({
	...theme.typography.button,
	borderRadius: (theme.vars || theme).shape.borderRadius,
	padding: 11,
	border: `1px solid ${(theme.vars || theme).palette.divider}`,
	color: (theme.vars || theme).palette.action.active,
	[`&.${toggleButtonClasses.disabled}`]: {
		color: (theme.vars || theme).palette.action.disabled,
		border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
	},
	"&:hover": {
		textDecoration: "none",
		backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
		"@media (hover: none)": { backgroundColor: "transparent" }
	},
	variants: [
		{
			props: { color: "standard" },
			style: { [`&.${toggleButtonClasses.selected}`]: {
				color: (theme.vars || theme).palette.text.primary,
				backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity),
				"&:hover": {
					backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
					"@media (hover: none)": { backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity) }
				}
			} }
		},
		...Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(([color]) => ({
			props: { color },
			style: { [`&.${toggleButtonClasses.selected}`]: {
				color: (theme.vars || theme).palette[color].main,
				backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity),
				"&:hover": {
					backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
					"@media (hover: none)": { backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity) }
				}
			} }
		})),
		{
			props: { fullWidth: true },
			style: { width: "100%" }
		},
		{
			props: { size: "small" },
			style: {
				padding: 7,
				fontSize: theme.typography.pxToRem(13)
			}
		},
		{
			props: { size: "large" },
			style: {
				padding: 15,
				fontSize: theme.typography.pxToRem(15)
			}
		}
	]
})));
const ToggleButton$1 = /*#__PURE__*/ React$1.forwardRef(function ToggleButton(inProps, ref) {
	const { value: contextValue, isRovingTabIndex, ...contextProps } = React$1.useContext(ToggleButtonGroupContext);
	const toggleButtonGroupButtonContextPositionClassName = React$1.useContext(ToggleButtonGroupButtonContext);
	const resolvedProps = resolveProps({
		...contextProps,
		selected: isValueSelected(inProps.value, contextValue)
	}, inProps);
	const props = useDefaultProps({
		props: resolvedProps,
		name: "MuiToggleButton"
	});
	const { children, className, color = "standard", disabled = false, disableFocusRipple = false, fullWidth = false, onChange, onClick, selected, size = "medium", value, ...other } = props;
	const ownerState = {
		...props,
		color,
		disabled,
		disableFocusRipple,
		fullWidth,
		size
	};
	const classes = useUtilityClasses$1(ownerState);
	const handleChange = (event) => {
		if (onClick) {
			onClick(event, value);
			if (event.defaultPrevented) return;
		}
		if (onChange) onChange(event, value);
	};
	const positionClassName = toggleButtonGroupButtonContextPositionClassName || "";
	const button = /*#__PURE__*/ jsx(ToggleButtonRoot, {
		className: clsx(contextProps.className, classes.root, className, positionClassName),
		internalNativeButton: true,
		disabled,
		focusRipple: !disableFocusRipple,
		ref: isRovingTabIndex ? void 0 : ref,
		onClick: handleChange,
		onChange,
		value,
		ownerState,
		"aria-pressed": selected,
		...other,
		children
	});
	if (isRovingTabIndex) return /*#__PURE__*/ jsx(RovingToggleButton_default, {
		disabled,
		selected,
		ref,
		value,
		children: button
	});
	return button;
});
ToggleButton$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the button when it is in an active state.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'standard'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"standard",
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* If `true`, the component is disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, the  keyboard focus ripple is disabled.
	* @default false
	*/
	disableFocusRipple: import_prop_types.default.bool,
	/**
	* If `true`, the ripple effect is disabled.
	*
	* ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	* to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
	* @default false
	*/
	disableRipple: import_prop_types.default.bool,
	/**
	* If `true`, the button will take up the full width of its container.
	* @default false
	*/
	fullWidth: import_prop_types.default.bool,
	/**
	* Callback fired when the state changes.
	*
	* @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
	* @param {any} value of the selected button.
	*/
	onChange: import_prop_types.default.func,
	/**
	* Callback fired when the button is clicked.
	*
	* @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
	* @param {any} value of the selected button.
	*/
	onClick: import_prop_types.default.func,
	/**
	* If `true`, the button is rendered in an active state.
	*/
	selected: import_prop_types.default.bool,
	/**
	* The size of the component.
	* The prop defaults to the value inherited from the parent ToggleButtonGroup component.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"small",
		"medium",
		"large"
	]), import_prop_types.default.string]),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The value to associate with the button when selected in a
	* ToggleButtonGroup.
	*/
	value: import_prop_types.default.any.isRequired
};
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ToggleButtonGroup/toggleButtonGroupClasses.mjs
function getToggleButtonGroupUtilityClass(slot) {
	return generateUtilityClass("MuiToggleButtonGroup", slot);
}
const toggleButtonGroupClasses = generateUtilityClasses("MuiToggleButtonGroup", [
	"root",
	"selected",
	"horizontal",
	"vertical",
	"disabled",
	"grouped",
	"fullWidth",
	"firstButton",
	"lastButton",
	"middleButton"
]);
//#endregion
//#region ../node_modules/.pnpm/@mui+material@9.4.0_@emotion+react@11.14.0_@types+react@18.3.31_react@18.3.1_supports-c_6865aabaf86f206a395f0132200fd3c2/node_modules/@mui/material/ToggleButtonGroup/ToggleButtonGroup.mjs
const useUtilityClasses = (ownerState) => {
	const { classes, orientation, fullWidth, disabled } = ownerState;
	return composeClasses({
		root: [
			"root",
			orientation,
			fullWidth && "fullWidth"
		],
		grouped: ["grouped", disabled && "disabled"],
		firstButton: ["firstButton"],
		lastButton: ["lastButton"],
		middleButton: ["middleButton"]
	}, getToggleButtonGroupUtilityClass, classes);
};
const ToggleButtonGroupRoot = styled$2("div", {
	name: "MuiToggleButtonGroup",
	slot: "Root",
	overridesResolver: (props, styles) => {
		const { ownerState } = props;
		return [
			{ [`& .${toggleButtonGroupClasses.grouped}`]: styles.grouped },
			{ [`& .${toggleButtonGroupClasses.firstButton}`]: styles.firstButton },
			{ [`& .${toggleButtonGroupClasses.lastButton}`]: styles.lastButton },
			{ [`& .${toggleButtonGroupClasses.middleButton}`]: styles.middleButton },
			styles.root,
			ownerState.orientation === "vertical" && styles.vertical,
			ownerState.fullWidth && styles.fullWidth
		];
	}
})(memoTheme(({ theme }) => ({
	display: "inline-flex",
	borderRadius: (theme.vars || theme).shape.borderRadius,
	...theme.focusVisible && { [`& .${toggleButtonGroupClasses.grouped}.${buttonBaseClasses.focusVisible}`]: { zIndex: 1 } },
	variants: [
		{
			props: { orientation: "vertical" },
			style: {
				flexDirection: "column",
				[`& .${toggleButtonGroupClasses.grouped}`]: { [`&.${toggleButtonGroupClasses.selected} + .${toggleButtonGroupClasses.grouped}.${toggleButtonGroupClasses.selected}`]: {
					borderTop: 0,
					marginTop: 0
				} },
				[`& .${toggleButtonGroupClasses.firstButton},& .${toggleButtonGroupClasses.middleButton}`]: {
					borderBottomLeftRadius: 0,
					borderBottomRightRadius: 0
				},
				[`& .${toggleButtonGroupClasses.lastButton},& .${toggleButtonGroupClasses.middleButton}`]: {
					marginTop: -1,
					borderTop: "1px solid transparent",
					borderTopLeftRadius: 0,
					borderTopRightRadius: 0
				},
				[`& .${toggleButtonGroupClasses.lastButton}.${toggleButtonClasses.disabled},& .${toggleButtonGroupClasses.middleButton}.${toggleButtonClasses.disabled}`]: { borderTop: "1px solid transparent" }
			}
		},
		{
			props: { fullWidth: true },
			style: { width: "100%" }
		},
		{
			props: { orientation: "horizontal" },
			style: {
				[`& .${toggleButtonGroupClasses.grouped}`]: { [`&.${toggleButtonGroupClasses.selected} + .${toggleButtonGroupClasses.grouped}.${toggleButtonGroupClasses.selected}`]: {
					borderLeft: 0,
					marginLeft: 0
				} },
				[`& .${toggleButtonGroupClasses.firstButton},& .${toggleButtonGroupClasses.middleButton}`]: {
					borderTopRightRadius: 0,
					borderBottomRightRadius: 0
				},
				[`& .${toggleButtonGroupClasses.lastButton},& .${toggleButtonGroupClasses.middleButton}`]: {
					marginLeft: -1,
					borderLeft: "1px solid transparent",
					borderTopLeftRadius: 0,
					borderBottomLeftRadius: 0
				},
				[`& .${toggleButtonGroupClasses.lastButton}.${toggleButtonClasses.disabled},& .${toggleButtonGroupClasses.middleButton}.${toggleButtonClasses.disabled}`]: { borderLeft: "1px solid transparent" }
			}
		}
	]
})));
const ToggleButtonGroup$1 = /*#__PURE__*/ React$1.forwardRef(function ToggleButtonGroup(inProps, ref) {
	const props = useDefaultProps({
		props: inProps,
		name: "MuiToggleButtonGroup"
	});
	const { children, className, color = "standard", disabled = false, exclusive = false, fullWidth = false, onChange, orientation = "horizontal", size = "medium", value, ...other } = props;
	const ownerState = {
		...props,
		disabled,
		fullWidth,
		orientation,
		size
	};
	const classes = useUtilityClasses(ownerState);
	const isRtl = useRtl();
	const handleChange = React$1.useCallback((event, buttonValue) => {
		if (!onChange) return;
		const index = value && value.indexOf(buttonValue);
		let newValue;
		if (value && index >= 0) {
			newValue = value.slice();
			newValue.splice(index, 1);
		} else newValue = value ? value.concat(buttonValue) : [buttonValue];
		onChange(event, newValue);
	}, [onChange, value]);
	const handleExclusiveChange = React$1.useCallback((event, buttonValue) => {
		if (!onChange) return;
		onChange(event, value === buttonValue ? null : buttonValue);
	}, [onChange, value]);
	const context = React$1.useMemo(() => ({
		className: classes.grouped,
		onChange: exclusive ? handleExclusiveChange : handleChange,
		value,
		size,
		fullWidth,
		color,
		disabled,
		isRovingTabIndex: true
	}), [
		classes.grouped,
		exclusive,
		handleExclusiveChange,
		handleChange,
		value,
		size,
		fullWidth,
		color,
		disabled
	]);
	const validChildren = getValidReactChildren(children);
	const childrenCount = validChildren.length;
	const getButtonPositionClassName = (index) => {
		const isFirstButton = index === 0;
		const isLastButton = index === childrenCount - 1;
		if (isFirstButton && isLastButton) return "";
		if (isFirstButton) return classes.firstButton;
		if (isLastButton) return classes.lastButton;
		return classes.middleButton;
	};
	const rovingTabIndexRoot = useRovingTabIndexRoot({
		orientation,
		isRtl
	});
	const rovingContainerProps = rovingTabIndexRoot.getContainerProps(ref, other.onFocus, other.onKeyDown);
	return /*#__PURE__*/ jsx(ToggleButtonGroupRoot, {
		role: "group",
		className: clsx(classes.root, className),
		ownerState,
		...other,
		...rovingContainerProps,
		children: /*#__PURE__*/ jsx(RovingTabIndexContext.Provider, {
			value: rovingTabIndexRoot,
			children: /*#__PURE__*/ jsx(ToggleButtonGroupContext.Provider, {
				value: context,
				children: validChildren.map((child, index) => {
					if ((0, import_react_is.isFragment)(child)) console.error(["MUI: The ToggleButtonGroup component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join("\n"));
					return /*#__PURE__*/ jsx(ToggleButtonGroupButtonContext.Provider, {
						value: getButtonPositionClassName(index),
						children: child
					}, index);
				})
			})
		})
	});
});
ToggleButtonGroup$1.propTypes = {
	/**
	* The content of the component.
	*/
	children: import_prop_types.default.node,
	/**
	* Override or extend the styles applied to the component.
	*/
	classes: import_prop_types.default.object,
	/**
	* @ignore
	*/
	className: import_prop_types.default.string,
	/**
	* The color of the button when it is selected.
	* It supports both default and custom theme colors, which can be added as shown in the
	* [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
	* @default 'standard'
	*/
	color: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"standard",
		"primary",
		"secondary",
		"error",
		"info",
		"success",
		"warning"
	]), import_prop_types.default.string]),
	/**
	* If `true`, the component is disabled. This implies that all ToggleButton children will be disabled.
	* @default false
	*/
	disabled: import_prop_types.default.bool,
	/**
	* If `true`, only allow one of the child ToggleButton values to be selected.
	* @default false
	*/
	exclusive: import_prop_types.default.bool,
	/**
	* If `true`, the button group will take up the full width of its container.
	* @default false
	*/
	fullWidth: import_prop_types.default.bool,
	/**
	* Callback fired when the value changes.
	*
	* @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
	* @param {any} value of the selected buttons. When `exclusive` is true
	* this is a single value; when false an array of selected values. If no value
	* is selected and `exclusive` is true the value is null; when false an empty array.
	*/
	onChange: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onFocus: import_prop_types.default.func,
	/**
	* @ignore
	*/
	onKeyDown: import_prop_types.default.func,
	/**
	* The component orientation (layout flow direction).
	* @default 'horizontal'
	*/
	orientation: import_prop_types.default.oneOf(["horizontal", "vertical"]),
	/**
	* The size of the component.
	* @default 'medium'
	*/
	size: import_prop_types.default.oneOfType([import_prop_types.default.oneOf([
		"small",
		"medium",
		"large"
	]), import_prop_types.default.string]),
	/**
	* The system prop that allows defining system overrides as well as additional CSS styles.
	*/
	sx: import_prop_types.default.oneOfType([
		import_prop_types.default.arrayOf(import_prop_types.default.oneOfType([
			import_prop_types.default.func,
			import_prop_types.default.object,
			import_prop_types.default.bool
		])),
		import_prop_types.default.func,
		import_prop_types.default.object
	]),
	/**
	* The currently selected value within the group or an array of selected
	* values when `exclusive` is false.
	*
	* The value must have reference equality with the option in order to be selected.
	*/
	value: import_prop_types.default.any
};
//#endregion
//#region src/web/utils/resolveCssStyle.ts
const isPlainObject = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
const isBreakpoint = (key) => BREAKPOINTS.includes(key);
const isCssLength = (value) => typeof value === "string" || typeof value === "number";
const isIgnorableKey = (key) => key === "__typename" || key.startsWith("__");
const definedBreakpointEntries = (value) => BREAKPOINTS.flatMap((bp) => {
	const token = value[bp];
	return isCssLength(token) ? [[bp, token]] : [];
});
const isBreakpointMap = (value) => isPlainObject(value) && definedBreakpointEntries(value).length > 0;
const isEmptyOrNoiseObject = (value) => {
	if (!isPlainObject(value)) return false;
	if (definedBreakpointEntries(value).length > 0) return false;
	return Object.keys(value).every((key) => isIgnorableKey(key) || isBreakpoint(key) || value[key] === void 0 || value[key] === null);
};
const mergeBreakpointMap = (defaults, override) => {
	if (!isBreakpointMap(override)) return override;
	const overrideDefined = Object.fromEntries(definedBreakpointEntries(override));
	if (Object.keys(overrideDefined).length === 0) return defaults;
	if (isCssLength(defaults)) return {
		xs: defaults,
		...overrideDefined
	};
	if (!isPlainObject(defaults)) return overrideDefined;
	return {
		...Object.fromEntries(definedBreakpointEntries(defaults)),
		...overrideDefined
	};
};
const mergeTokenValue = (base, override) => {
	if (override === void 0 || override === null || isEmptyOrNoiseObject(override)) return base;
	if (base === void 0) return override;
	if ((isBreakpointMap(base) || isCssLength(base)) && (isBreakpointMap(override) || isCssLength(override))) return mergeBreakpointMap(base, override);
	if (isPlainObject(base) && isPlainObject(override)) return mergeStyleInput(base, override);
	return override;
};
const mergeStyleInput = (base, override) => {
	const merged = { ...base };
	for (const [key, overrideValue] of Object.entries(override)) {
		if (overrideValue === void 0 || overrideValue === null) continue;
		merged[key] = mergeTokenValue(base[key], overrideValue);
	}
	return merged;
};
const expandBreakpointMap = (theme, property, value) => definedBreakpointEntries(value).map(([bp, token]) => bp === "xs" ? [property, token] : [theme.breakpoints.up(bp), { [property]: token }]);
const mergeEntries = (entries) => Object.fromEntries([...new Set(entries.map(([key]) => key))].map((key) => {
	const values = entries.flatMap(([entryKey, value]) => entryKey === key ? [value] : []);
	return [key, values.every(isPlainObject) ? mergeEntries(values.flatMap((value) => Object.entries(value))) : values.at(-1)];
}));
const expandStyleInput = (theme, input) => mergeEntries(Object.entries(input).flatMap(([key, value]) => {
	if (value === void 0 || value === null || isEmptyOrNoiseObject(value)) return [];
	if (isBreakpointMap(value)) return expandBreakpointMap(theme, key, value);
	if (isPlainObject(value)) return [[key, expandStyleInput(theme, value)]];
	return [[key, value]];
}));
/**
* Expand `{ xs, sm }` maps into `@media` via `theme.breakpoints.up`
* (values synced from `theme.hephaestus.breakpoint` in MuiProvider).
* Only `xs` is a bare property; other keys always get `min-width` queries.
* Extra keys (`__typename`, `default`) and non-length values are ignored so
* org JSON cannot leak a nested object into `fontSize` (MUI `h1` `6rem`).
* Empty `{}` / `null` entries are skipped. Pass Figma defaults as `base` and
* org tokens as `override` — partial maps (`{ lg }`) merge onto the default.
*/
const resolveCssStyle = (theme, base, override = {}) => expandStyleInput(theme, mergeStyleInput(base, override));
//#endregion
//#region src/web/atoms/Alert/Alert.tsx
const defaultIcons$2 = {
	neutral: /* @__PURE__ */ jsx(InfoOutlined_default$1, { fontSize: "inherit" }),
	info: /* @__PURE__ */ jsx(InfoOutlined_default$1, { fontSize: "inherit" }),
	success: /* @__PURE__ */ jsx(CheckCircle_default, { fontSize: "inherit" }),
	warning: /* @__PURE__ */ jsx(Warning_default, { fontSize: "inherit" }),
	error: /* @__PURE__ */ jsx(Error_default, { fontSize: "inherit" })
};
const defaultAlertSeverityStyle = (color, severity) => {
	switch (severity) {
		case "neutral": return {
			color: color.onSurfaceVariant,
			backgroundColor: color.surfaceContainerVariant,
			borderColor: color.outline,
			fontColor: color.onSurface
		};
		case "info": return {
			color: color.primary,
			backgroundColor: color.supportOneNewVariant,
			borderColor: color.primaryVariantPressed,
			fontColor: color.onSurface
		};
		case "success": return {
			color: color.positive,
			backgroundColor: color.positiveVariant,
			borderColor: color.positiveVariantPressed,
			fontColor: color.onSurface
		};
		case "warning": return {
			color: color.warning,
			backgroundColor: color.warningVariant,
			borderColor: color.warningVariantPressed,
			fontColor: color.onSurface
		};
		case "error": return {
			color: color.negative,
			backgroundColor: color.negativeVariant,
			borderColor: color.negativeVariantPressed,
			fontColor: color.onSurface
		};
	}
};
const StyledAlert = styled$2(Alert$1)(({ theme, variant, severity }) => {
	const { color: colorToken, component, borderRadius, spacing, font } = theme.hephaestus;
	const resolvedVariant = variant ?? "outlined";
	const resolvedSeverity = severity ?? "info";
	const defaults = defaultAlertSeverityStyle(colorToken, resolvedSeverity);
	const fromComp = component?.alert?.[resolvedVariant]?.[resolvedSeverity];
	const showBorder = resolvedVariant === "outlined";
	return resolveCssStyle(theme, {
		alignItems: "flex-start",
		gap: spacing.md,
		padding: `${spacing.lg} ${spacing.xl}`,
		borderRadius: borderRadius.md,
		backgroundColor: defaults.backgroundColor,
		color: defaults.fontColor,
		border: showBorder ? "1px solid" : "1px solid transparent",
		borderColor: showBorder ? defaults.borderColor ?? "transparent" : "transparent",
		fontFamily: font.base,
		fontSize: "14px",
		fontWeight: 400,
		lineHeight: "20px",
		letterSpacing: "0.25px",
		"& .MuiAlert-icon": {
			margin: 0,
			padding: `${spacing.sm} 0`,
			fontSize: 16,
			color: defaults.color,
			opacity: 1
		},
		"& .MuiAlert-message": {
			padding: 0,
			minWidth: 0,
			flex: "1 1 auto",
			alignSelf: "center",
			lineHeight: "20px"
		},
		"& .MuiAlert-action": {
			margin: 0,
			padding: 0,
			alignSelf: "flex-start",
			alignItems: "center",
			marginRight: 0,
			color: colorToken.onSurface,
			"& .MuiIconButton-root": {
				padding: spacing.sm,
				borderRadius: borderRadius.round,
				color: colorToken.onSurface,
				"& .MuiSvgIcon-root": { fontSize: 16 }
			}
		}
	}, {
		backgroundColor: fromComp?.backgroundColor,
		color: fromComp?.fontColor,
		borderColor: showBorder ? fromComp?.borderColor : void 0,
		"& .MuiAlert-icon": { color: fromComp?.color }
	});
});
const Alert = forwardRef(({ severity = "info", variant = "outlined", icon, iconMapping, ...props }, ref) => /* @__PURE__ */ jsx(StyledAlert, {
	ref,
	"data-testid": "alert",
	severity,
	variant,
	icon,
	iconMapping: {
		...defaultIcons$2,
		...iconMapping
	},
	...props
}));
//#endregion
//#region src/web/atoms/Alert/AlertTitle.tsx
const StyledAlertTitle = styled$2(AlertTitle$1)(({ theme }) => {
	const { font } = theme.hephaestus;
	return resolveCssStyle(theme, {
		fontFamily: font.base,
		fontSize: "16px",
		fontWeight: 600,
		lineHeight: "24px",
		letterSpacing: "0.25px",
		marginTop: 0,
		marginBottom: 0,
		color: "inherit",
		"&:not(:last-child)": { marginBottom: "2px" }
	});
});
const AlertTitle = forwardRef((props, ref) => /* @__PURE__ */ jsx(StyledAlertTitle, {
	ref,
	"data-testid": "alert-title",
	...props
}));
//#endregion
//#region src/web/atoms/AlertBanner/AlertBanner.tsx
const defaultIcons$1 = {
	neutral: /* @__PURE__ */ jsx(InfoOutlined_default$1, { fontSize: "inherit" }),
	info: /* @__PURE__ */ jsx(NewReleases_default, { fontSize: "inherit" }),
	success: /* @__PURE__ */ jsx(CheckCircle_default, { fontSize: "inherit" }),
	warning: /* @__PURE__ */ jsx(Warning_default, { fontSize: "inherit" }),
	error: /* @__PURE__ */ jsx(Error_default, { fontSize: "inherit" })
};
const defaultAlertBannerSeverityStyle = (palette, color, severity) => {
	switch (severity) {
		case "neutral": return {
			backgroundColor: color.surfaceContainerVariant,
			fontColor: color.onSurface
		};
		case "info": return {
			backgroundColor: palette.primary20,
			fontColor: color.onSurface
		};
		case "success": return {
			backgroundColor: palette.positive40,
			fontColor: color.onSurface
		};
		case "warning": return {
			backgroundColor: palette.warning40,
			fontColor: color.onSurface
		};
		case "error": return {
			backgroundColor: palette.negative40,
			fontColor: color.onSurface
		};
	}
};
const StyledAlertBanner = styled$2(Alert$1)(({ theme, severity }) => {
	const { color: colorToken, palette, font } = theme.hephaestus;
	const defaults = defaultAlertBannerSeverityStyle(palette, colorToken, severity ?? "info");
	return resolveCssStyle(theme, {
		display: "grid",
		gridTemplateColumns: "1fr auto 1fr",
		alignItems: "center",
		columnGap: theme.spacing(1),
		boxSizing: "border-box",
		width: "100%",
		height: theme.spacing(6),
		padding: theme.spacing(1, 2),
		borderRadius: 0,
		border: "none",
		backgroundImage: "none",
		backgroundColor: defaults.backgroundColor,
		color: defaults.fontColor,
		fontFamily: font.base,
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "20px",
		letterSpacing: "0.25px",
		[`& .${alertClasses.icon}`]: {
			gridColumn: 1,
			gridRow: 1,
			justifySelf: "end",
			margin: 0,
			padding: 0,
			fontSize: 16,
			color: defaults.fontColor,
			opacity: 1
		},
		[`& .${alertClasses.message}`]: {
			gridColumn: 2,
			gridRow: 1,
			padding: 0,
			minWidth: 0,
			textAlign: "center"
		},
		[`& .${alertClasses.action}`]: {
			gridColumn: 3,
			gridRow: 1,
			justifySelf: "end",
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
			margin: 0,
			padding: 0,
			"& .MuiIconButton-root": {
				padding: theme.spacing(.5),
				color: colorToken.onSurface,
				"& .MuiSvgIcon-root": { fontSize: 16 }
			}
		}
	});
});
const AlertBanner = forwardRef(({ severity = "info", icon, iconMapping, action, onClose, closeText = "Close", ...props }, ref) => /* @__PURE__ */ jsx(StyledAlertBanner, {
	ref,
	square: true,
	severity,
	variant: "standard",
	icon,
	iconMapping: {
		...defaultIcons$1,
		...iconMapping
	},
	action: action != null || onClose != null ? /* @__PURE__ */ jsxs(Fragment, { children: [action, onClose != null && /* @__PURE__ */ jsx(IconButton$1, {
		size: "small",
		"aria-label": closeText,
		title: closeText,
		color: "inherit",
		onClick: onClose,
		children: /* @__PURE__ */ jsx(Close_default$1, { fontSize: "inherit" })
	})] }) : void 0,
	...props
}));
//#endregion
//#region src/web/atoms/Skeleton/Skeleton.tsx
const StyledSkeleton = styled$2(Skeleton$1)(({ theme }) => resolveCssStyle(theme, { [`&.${skeletonClasses.rounded}`]: { borderRadius: theme.hephaestus.borderRadius.xl } }));
const Skeleton = (props) => /* @__PURE__ */ jsx(StyledSkeleton, {
	"data-testid": "skeleton",
	...props
});
//#endregion
//#region src/web/atoms/AppBar/constants.ts
const APP_BAR_HEIGHT = "72px";
//#endregion
//#region src/web/atoms/AppBar/AppBarSkeleton.tsx
const StyledAppBarSkeleton = styled$2(Skeleton, { shouldForwardProp: (prop) => prop !== "position" })(({ theme, position = "fixed" }) => resolveCssStyle(theme, {
	display: "block",
	width: "100%",
	height: APP_BAR_HEIGHT,
	position,
	...position === "static" || position === "relative" ? {} : {
		top: 0,
		left: 0,
		right: 0
	}
}));
const AppBarSkeleton = ({ position = "fixed", ...props }) => /* @__PURE__ */ jsx(StyledAppBarSkeleton, {
	variant: "rectangular",
	position,
	...props
});
//#endregion
//#region src/web/atoms/AppBar/AppBar.tsx
const hoverSelector$13 = "&:hover, &[data-preview-state=\"hover\"]";
const pressedSelector$6 = "&:active, &[data-preview-state=\"pressed\"]";
const focusedSelector$10 = "&:focus-visible, &[data-preview-state=\"focused\"]";
const inkTintStyles = (ink) => ({
	[`& .${iconButtonClasses.root}`]: {
		color: "inherit",
		[hoverSelector$13]: { backgroundColor: Color(ink).alpha(.08).string() },
		[pressedSelector$6]: { backgroundColor: Color(ink).alpha(.16).string() },
		[focusedSelector$10]: { backgroundColor: Color(ink).alpha(.16).string() }
	},
	[`& .${skeletonClasses.root}`]: { backgroundColor: Color(ink).alpha(.2).string() }
});
const StyledAppBar = styled$2(AppBar$1)(({ theme }) => {
	const { color, component } = theme.hephaestus;
	const layout = component?.layout;
	return resolveCssStyle(theme, {
		height: APP_BAR_HEIGHT,
		backgroundColor: color.onSurface,
		color: color.surface,
		boxShadow: "0px 0px 14px 0px rgba(0, 0, 0, 0.05)",
		transition: "color 0.3s, background-color 0.3s",
		...inkTintStyles(color.surface)
	}, {
		backgroundColor: layout?.backgroundColor,
		color: layout?.textColor,
		...layout?.textColor ? inkTintStyles(layout.textColor) : {}
	});
});
const StyledToolbar = styled$2(Toolbar)(({ theme }) => {
	const { spacing } = theme.hephaestus;
	return resolveCssStyle(theme, {
		boxSizing: "border-box",
		height: APP_BAR_HEIGHT,
		minHeight: APP_BAR_HEIGHT,
		maxHeight: APP_BAR_HEIGHT,
		justifyContent: "space-between",
		alignItems: "center",
		paddingLeft: spacing.xxl,
		paddingRight: spacing.xxl,
		paddingTop: 0,
		paddingBottom: 0,
		"@media (min-width: 0px)": { minHeight: APP_BAR_HEIGHT }
	});
});
const AppBarRoot = forwardRef(({ children, elevation = 0, ...props }, ref) => /* @__PURE__ */ jsx(StyledAppBar, {
	ref,
	elevation,
	...props,
	children: /* @__PURE__ */ jsx(StyledToolbar, {
		disableGutters: true,
		children
	})
}));
const AppBar = Object.assign(AppBarRoot, { Skeleton: AppBarSkeleton });
//#endregion
//#region src/web/atoms/Avatar/avatarSize.ts
const avatarSizeTokens = {
	xsmall: {
		diameter: 24,
		singleFontSize: 15,
		doubleFontSize: 12,
		iconFontSize: 6,
		selectedBorderWidth: 1.5
	},
	small: {
		diameter: 32,
		singleFontSize: 20,
		doubleFontSize: 16,
		iconFontSize: 11,
		selectedBorderWidth: 2
	},
	medium: {
		diameter: 40,
		singleFontSize: 24,
		doubleFontSize: 20,
		iconFontSize: 16,
		selectedBorderWidth: 2.5
	},
	large: {
		diameter: 48,
		singleFontSize: 30,
		doubleFontSize: 24,
		iconFontSize: 24,
		selectedBorderWidth: 3
	}
};
const resolveAvatarSizeTokens = (size) => size && avatarSizeTokens[size] || avatarSizeTokens.medium;
//#endregion
//#region src/web/atoms/Avatar/AvatarSkeleton.tsx
const AvatarSkeleton = ({ size = "medium", ...props }) => {
	const diameter = resolveAvatarSizeTokens(size).diameter;
	return /* @__PURE__ */ jsx(Skeleton, {
		variant: "circular",
		width: diameter,
		height: diameter,
		...props
	});
};
//#endregion
//#region src/web/atoms/Avatar/Avatar.tsx
const textCharCount = (children) => {
	if (typeof children !== "string") return 0;
	return [...children.trim()].length;
};
const StyledAvatar = styled$2(Avatar$1, { shouldForwardProp: (prop) => prop !== "ownerState" })(({ theme, ownerState }) => {
	const { color, borderRadius, font, palette } = theme.hephaestus;
	const tokens = resolveAvatarSizeTokens(ownerState?.size);
	const isBrand = ownerState?.tone === "brand";
	const bg = isBrand ? color.onSurface : palette.supportOne10;
	const fg = isBrand ? color.onNavigation : palette.supportOne60;
	const fontSize = (ownerState?.charCount ?? 0) >= 2 ? tokens.doubleFontSize : tokens.singleFontSize;
	return resolveCssStyle(theme, {
		width: tokens.diameter,
		height: tokens.diameter,
		fontFamily: font.base,
		fontWeight: 500,
		fontSize,
		letterSpacing: "0.01em",
		lineHeight: 1,
		color: fg,
		backgroundColor: bg,
		borderRadius: borderRadius.round,
		overflow: "hidden",
		position: "relative",
		...ownerState?.selected && !isBrand ? { "&::after": {
			content: "\"\"",
			position: "absolute",
			inset: 0,
			borderRadius: "inherit",
			boxShadow: `inset 0 0 0 ${tokens.selectedBorderWidth}px currentColor`,
			pointerEvents: "none",
			zIndex: 1
		} } : {},
		"& .MuiSvgIcon-root": {
			fontSize: tokens.iconFontSize,
			color: "inherit"
		},
		"& img": {
			width: "100%",
			height: "100%",
			objectFit: "cover"
		}
	});
});
const AvatarRoot = forwardRef(({ size = "medium", selected = false, tone = "default", children, ownerState: _muiOwnerState, ...props }, ref) => /* @__PURE__ */ jsx(StyledAvatar, {
	ref,
	"data-testid": "avatar",
	...props,
	ownerState: {
		size,
		selected,
		tone,
		charCount: textCharCount(children)
	},
	variant: "circular",
	children
}));
const Avatar = Object.assign(AvatarRoot, { Skeleton: AvatarSkeleton });
//#endregion
//#region src/web/atoms/Avatar/AvatarGroup.tsx
const StyledAvatarGroup = styled$2(AvatarGroup$1)(({ theme }) => {
	const { color } = theme.hephaestus;
	return resolveCssStyle(theme, { "& .MuiAvatar-root": { borderColor: color.surface } });
});
const AvatarGroup = forwardRef(({ size, slots, slotProps, ...props }, ref) => {
	const resolvedSlotProps = {
		...slotProps,
		surplus: {
			size,
			...slotProps?.surplus
		}
	};
	return /* @__PURE__ */ jsx(StyledAvatarGroup, {
		ref,
		"data-testid": "avatar-group",
		variant: "circular",
		slots: {
			surplus: Avatar,
			...slots
		},
		slotProps: resolvedSlotProps,
		...props
	});
});
//#endregion
//#region src/web/atoms/Badge/Badge.tsx
const badgeTone = (colorToken, color) => {
	switch (color) {
		case "success": return {
			backgroundColor: colorToken.positive,
			color: colorToken.onPositive
		};
		case "warning": return {
			backgroundColor: colorToken.warning,
			color: colorToken.onWarning
		};
		case "info":
		case "primary": return {
			backgroundColor: colorToken.primary,
			color: colorToken.onPrimary
		};
		case "secondary": return {
			backgroundColor: colorToken.supportTwo,
			color: colorToken.onPrimary
		};
		case "default": return {
			backgroundColor: colorToken.surfaceContainerVariant,
			color: colorToken.onSurface
		};
		default: return {
			backgroundColor: colorToken.negative,
			color: colorToken.onNegative
		};
	}
};
const StyledBadge = styled$2(Badge$1)(({ theme, color, badgeContent }) => {
	const { color: colorToken, borderRadius, font, component } = theme.hephaestus;
	const badge = component?.badge;
	const tone = badgeTone(colorToken, color);
	const isStatus = isValidElement(badgeContent);
	const number = !isStatus && badgeContent != null && (color == null || color === "error") ? badge?.number : void 0;
	return resolveCssStyle(theme, {
		[`& .${badgeClasses.badge}`]: isStatus ? {
			boxSizing: "border-box",
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			minWidth: 0,
			width: "auto",
			height: "auto",
			padding: 0,
			borderRadius: 0,
			backgroundColor: "transparent",
			color: tone.backgroundColor,
			lineHeight: 0,
			"& .MuiSvgIcon-root": { display: "block" }
		} : {
			boxSizing: "border-box",
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			minWidth: "16px",
			height: "16px",
			padding: "1px 4px",
			borderRadius: borderRadius.round,
			backgroundColor: tone.backgroundColor,
			color: tone.color,
			fontFamily: font.base,
			fontSize: "11px",
			fontWeight: 600,
			lineHeight: "14px",
			letterSpacing: "0.25px",
			textAlign: "center",
			whiteSpace: "nowrap"
		},
		[`& .${badgeClasses.dot}`]: {
			minWidth: "8px",
			width: "8px",
			height: "8px",
			padding: 0
		}
	}, { [`& .${badgeClasses.badge}`]: isStatus ? {} : {
		borderRadius: number?.borderRadius,
		backgroundColor: number?.backgroundColor,
		color: number?.textColor,
		borderColor: number?.borderColor,
		borderStyle: number?.borderStyle,
		borderWidth: number?.borderWidth
	} });
});
const Badge = forwardRef(({ badgeContent, variant, showZero = true, ...props }, ref) => /* @__PURE__ */ jsx(StyledBadge, {
	ref,
	badgeContent,
	variant: variant ?? (badgeContent == null ? "dot" : "standard"),
	showZero,
	...props
}));
//#endregion
//#region src/web/atoms/CircularProgress/CircularProgress.tsx
const pixelBySize$1 = {
	small: 16,
	medium: 24,
	large: 32,
	xlarge: 56
};
const isNamedSize$1 = (size) => Object.hasOwn(pixelBySize$1, size);
const resolveSize$1 = (size) => {
	if (size === void 0) return void 0;
	if (typeof size === "string" && isNamedSize$1(size)) return pixelBySize$1[size];
	return size;
};
const CircularProgress = ({ size, ...props }) => /* @__PURE__ */ jsx(CircularProgress$1, {
	...props,
	...size !== void 0 && { size: resolveSize$1(size) }
});
//#endregion
//#region src/web/atoms/BootSpinner/BootSpinner.tsx
const BootSpinnerContext = createContext(null);
const Backdrop = styled$2(Backdrop$1)(({ theme }) => resolveCssStyle(theme, {
	backgroundColor: "transparent",
	zIndex: theme.zIndex.modal
}));
const BootSpinnerBackdrop = ({ open, disablePortal = false, "data-testid": dataTestId }) => {
	const backdrop = /* @__PURE__ */ jsx(Backdrop, {
		open,
		invisible: true,
		transitionDuration: 0,
		unmountOnExit: false,
		"aria-hidden": !open,
		"data-testid": dataTestId,
		sx: disablePortal ? { position: "absolute" } : void 0,
		children: /* @__PURE__ */ jsx(CircularProgress, {
			"aria-label": "Loading",
			size: "xlarge"
		})
	});
	if (disablePortal) return backdrop;
	return /* @__PURE__ */ jsx(Portal, { children: backdrop });
};
const BootSpinnerProvider = ({ children }) => {
	const [count, setCount] = useState(0);
	const [testId, setTestId] = useState();
	const acquire = useCallback((nextTestId) => {
		setCount((n) => n + 1);
		if (nextTestId) setTestId(nextTestId);
	}, []);
	const release = useCallback(() => {
		setCount((n) => {
			const next = Math.max(0, n - 1);
			if (next === 0) setTestId(void 0);
			return next;
		});
	}, []);
	const api = useMemo(() => ({
		acquire,
		release
	}), [acquire, release]);
	return /* @__PURE__ */ jsxs(BootSpinnerContext.Provider, {
		value: api,
		children: [children, /* @__PURE__ */ jsx(BootSpinnerBackdrop, {
			open: count > 0,
			"data-testid": testId
		})]
	});
};
const BootSpinner = ({ "data-testid": dataTestId }) => {
	const api = useContext(BootSpinnerContext);
	useLayoutEffect(() => {
		if (!api) return;
		api.acquire(dataTestId);
		return () => api.release();
	}, [api, dataTestId]);
	if (api) return null;
	return /* @__PURE__ */ jsx(BootSpinnerBackdrop, {
		open: true,
		"data-testid": dataTestId
	});
};
//#endregion
//#region src/web/atoms/Breadcrumbs/Breadcrumbs.tsx
const ICON_SIZE$2 = 16;
const hoverSelector$12 = "&:hover, &[data-preview-state=\"hover\"]";
const focusedSelector$9 = "&:focus-visible, &[data-preview-state=\"focused\"]";
const currentSelector = "&[aria-current=\"page\"], &[data-current=\"true\"], .MuiBreadcrumbs-li:last-child &";
const StyledBreadcrumb = styled$2(Link$1, { shouldForwardProp: (prop) => prop !== "current" })(({ theme, current }) => {
	const { color, font } = theme.hephaestus;
	return resolveCssStyle(theme, {
		display: "inline-flex",
		alignItems: "center",
		fontFamily: font.base,
		fontSize: "14px",
		fontWeight: current ? 600 : 500,
		lineHeight: "20px",
		letterSpacing: "0.25px",
		color: current ? color.onSurface : color.onSurfaceVariant,
		textDecoration: "none",
		whiteSpace: "nowrap",
		cursor: current ? "default" : "pointer",
		"& .MuiSvgIcon-root": {
			fontSize: ICON_SIZE$2,
			width: ICON_SIZE$2,
			height: ICON_SIZE$2
		},
		[hoverSelector$12]: {
			color: color.onSurface,
			textDecoration: current ? "none" : "underline",
			backgroundColor: "transparent"
		},
		[focusedSelector$9]: {
			outline: `2px solid ${color.focus}`,
			outlineOffset: 2
		},
		[currentSelector]: {
			fontWeight: 600,
			color: color.onSurface,
			cursor: "default",
			textDecoration: "none",
			letterSpacing: "0.25px",
			[hoverSelector$12]: {
				color: color.onSurface,
				textDecoration: "none"
			}
		}
	});
});
const StyledBreadcrumbs = styled$2(Breadcrumbs$1)(({ theme }) => {
	const { color, font, spacing } = theme.hephaestus;
	const collapsedButton = `.${breadcrumbsClasses.ol} > li > .MuiButtonBase-root`;
	return resolveCssStyle(theme, {
		display: "flex",
		alignItems: "center",
		overflow: "hidden",
		fontFamily: font.base,
		fontSize: "14px",
		lineHeight: "20px",
		letterSpacing: "0.25px",
		color: color.onSurfaceVariant,
		[`& .${breadcrumbsClasses.ol}`]: {
			display: "flex",
			flexWrap: "wrap",
			alignItems: "center",
			gap: spacing.sm,
			padding: 0,
			margin: 0
		},
		[`& .${breadcrumbsClasses.li}`]: {
			display: "flex",
			alignItems: "center"
		},
		[`& .${breadcrumbsClasses.separator}`]: {
			display: "flex",
			alignItems: "center",
			margin: 0,
			color: color.onSurfaceVariant,
			"& .MuiSvgIcon-root": {
				fontSize: ICON_SIZE$2,
				width: ICON_SIZE$2,
				height: ICON_SIZE$2
			}
		},
		[`& ${collapsedButton}`]: {
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			minWidth: ICON_SIZE$2,
			padding: 0,
			margin: 0,
			backgroundColor: "transparent",
			borderRadius: 0,
			color: color.onSurfaceVariant,
			"& .MuiSvgIcon-root": {
				fontSize: ICON_SIZE$2,
				width: ICON_SIZE$2,
				height: ICON_SIZE$2
			},
			"& .MuiTouchRipple-root": { display: "none" },
			[hoverSelector$12]: {
				backgroundColor: "transparent",
				color: color.onSurface
			},
			[focusedSelector$9]: {
				outline: `2px solid ${color.focus}`,
				outlineOffset: 2
			}
		},
		[`&[data-preview-state="hover"] ${collapsedButton}`]: {
			backgroundColor: "transparent",
			color: color.onSurface
		}
	});
});
const Breadcrumb = forwardRef(({ current = false, underline = "none", href, component, ...props }, ref) => {
	const isLink = Boolean(href || component);
	return /* @__PURE__ */ jsx(StyledBreadcrumb, {
		ref,
		current,
		underline,
		color: "inherit",
		"aria-current": current ? "page" : void 0,
		"data-current": current || void 0,
		href: isLink ? href : void 0,
		component: isLink ? component : "span",
		...props
	});
});
const Breadcrumbs = forwardRef(({ children, ...props }, ref) => /* @__PURE__ */ jsx(StyledBreadcrumbs, {
	ref,
	maxItems: 5,
	itemsBeforeCollapse: 2,
	itemsAfterCollapse: 2,
	separator: /* @__PURE__ */ jsx(ChevronRight_default, { fontSize: "inherit" }),
	...props,
	children
}));
//#endregion
//#region src/web/atoms/Button/Button.tsx
const hoverSelector$11 = "&:hover, &[data-preview-state=\"hover\"]";
const pressedSelector$5 = "&:active, &[data-preview-state=\"pressed\"]";
const focusedSelector$8 = "&:focus-visible, &[data-preview-state=\"focused\"]";
const defaultSizeTokens = {
	small: {
		height: "32px",
		padding: "0px 16px",
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "20px",
		letterSpacing: "0.25px"
	},
	medium: {
		height: "40px",
		padding: "0px 24px",
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "20px",
		letterSpacing: "0.25px"
	},
	large: {
		height: "48px",
		padding: "0px 24px",
		fontSize: "16px",
		fontWeight: 500,
		lineHeight: "24px",
		letterSpacing: "0.25px"
	}
};
const getContainedColors$1 = (c, color) => {
	if (color === "secondary") return {
		bg: c.primaryVariant,
		bgHover: c.primaryVariantHover,
		bgPressed: c.primaryVariantPressed,
		bgFocused: c.primaryVariantHover,
		bgDisabled: c.disabled,
		text: c.onPrimaryVariant,
		textHover: c.onPrimaryVariant,
		textPressed: c.onPrimaryVariant,
		textFocused: c.onPrimaryVariant,
		textDisabled: c.onDisabled,
		border: "transparent",
		borderHover: "transparent",
		borderPressed: "transparent",
		borderFocused: "transparent",
		borderDisabled: "transparent"
	};
	if (color === "error") return {
		bg: c.negative,
		bgHover: c.negativeHover,
		bgPressed: c.negativePressed,
		bgFocused: c.negativeHover,
		bgDisabled: c.disabled,
		text: c.onNegative,
		textHover: c.onNegative,
		textPressed: c.onNegative,
		textFocused: c.onNegative,
		textDisabled: c.onDisabled,
		border: "transparent",
		borderHover: "transparent",
		borderPressed: "transparent",
		borderFocused: "transparent",
		borderDisabled: "transparent"
	};
	return {
		bg: c.primary,
		bgHover: c.primaryHover,
		bgPressed: c.primaryPressed,
		bgFocused: c.primaryHover,
		bgDisabled: c.disabled,
		text: c.onPrimary,
		textHover: c.onPrimary,
		textPressed: c.onPrimary,
		textFocused: c.onPrimary,
		textDisabled: c.onDisabled,
		border: "transparent",
		borderHover: "transparent",
		borderPressed: "transparent",
		borderFocused: "transparent",
		borderDisabled: "transparent"
	};
};
const getOutlinedColors = (c, color) => {
	if (color === "error") return {
		bg: "transparent",
		bgHover: c.negativeVariantHover,
		bgPressed: c.negativeVariantPressed,
		bgFocused: c.negativeVariantHover,
		bgDisabled: "transparent",
		text: c.onNegativeVariant,
		textHover: c.onNegativeVariant,
		textPressed: c.onNegativeVariant,
		textFocused: c.onNegativeVariant,
		textDisabled: c.onDisabled,
		border: c.negativeOutline,
		borderHover: c.negativeOutline,
		borderPressed: c.negativeOutline,
		borderFocused: c.negativeOutline,
		borderDisabled: c.negativeOutline
	};
	return {
		bg: "transparent",
		bgHover: c.neutralHover,
		bgPressed: c.neutralPressed,
		bgFocused: c.neutralHover,
		bgDisabled: "transparent",
		text: c.onSurface,
		textHover: c.onSurface,
		textPressed: c.onSurface,
		textFocused: c.onSurface,
		textDisabled: c.onDisabled,
		border: c.outline,
		borderHover: c.outline,
		borderPressed: c.outline,
		borderFocused: c.outline,
		borderDisabled: c.onDisabled
	};
};
const getTextColors = (c, color) => {
	if (color === "error") return {
		bg: "transparent",
		bgHover: c.negativeVariantHover,
		bgPressed: c.negativeVariantPressed,
		bgFocused: c.negativeVariantHover,
		bgDisabled: "transparent",
		text: c.onNegativeVariant,
		textHover: c.onNegativeVariant,
		textPressed: c.onNegativeVariant,
		textFocused: c.onNegativeVariant,
		textDisabled: c.onDisabled,
		border: "transparent",
		borderHover: "transparent",
		borderPressed: "transparent",
		borderFocused: "transparent",
		borderDisabled: "transparent"
	};
	return {
		bg: "transparent",
		bgHover: c.neutralHover,
		bgPressed: c.neutralPressed,
		bgFocused: c.neutralHover,
		bgDisabled: "transparent",
		text: c.onSurface,
		textHover: c.onSurface,
		textPressed: c.onSurface,
		textFocused: c.onSurface,
		textDisabled: c.onDisabled,
		border: "transparent",
		borderHover: "transparent",
		borderPressed: "transparent",
		borderFocused: "transparent",
		borderDisabled: "transparent"
	};
};
const defaultColorSet = (c, variant, color) => {
	if (variant === "outlined") return getOutlinedColors(c, color);
	if (variant === "text") return getTextColors(c, color);
	return getContainedColors$1(c, color);
};
const orgButtonState = (comp, variant, color) => {
	if (variant === "outlined") return color === "error" ? comp?.outlined?.destructive : comp?.outlined?.primary;
	if (variant === "text") return color === "error" ? comp?.text?.destructive : comp?.text?.primary;
	if (color === "secondary") return comp?.tonal?.primary;
	if (color === "error") return comp?.filled?.destructive;
	return comp?.filled?.primary;
};
const StyledButton$1 = styled$2(Button$1)(({ theme, variant, color, size }) => {
	const { color: colorToken, component } = theme.hephaestus;
	const comp = component?.button;
	const resolvedVariant = variant ?? "contained";
	const resolvedColor = color ?? "primary";
	const tokens = defaultColorSet(colorToken, resolvedVariant, resolvedColor);
	const org = orgButtonState(comp, resolvedVariant, resolvedColor);
	const orgBorder = org?.enabled?.container?.borderColor;
	const orgBorderHover = org?.hovered?.container?.borderColor;
	const sizeKey = size ?? "medium";
	const sizeDefaults = defaultSizeTokens[sizeKey];
	const compSize = sizeKey === "small" ? comp?.xs : sizeKey === "large" ? comp?.lg : comp?.sm;
	return resolveCssStyle(theme, {
		height: sizeDefaults.height,
		padding: sizeDefaults.padding,
		fontSize: sizeDefaults.fontSize,
		fontWeight: sizeDefaults.fontWeight,
		lineHeight: sizeDefaults.lineHeight,
		letterSpacing: sizeDefaults.letterSpacing,
		borderRadius: "100vmax",
		textTransform: "none",
		whiteSpace: "nowrap",
		backgroundColor: tokens.bg,
		color: tokens.text,
		border: "1px solid",
		borderColor: tokens.border,
		[hoverSelector$11]: {
			backgroundColor: tokens.bgHover,
			borderColor: tokens.borderHover,
			color: tokens.textHover
		},
		[pressedSelector$5]: {
			backgroundColor: tokens.bgPressed,
			borderColor: tokens.borderPressed,
			color: tokens.textPressed
		},
		"& .MuiButton-startIcon": { marginRight: "4px" },
		"& .MuiButton-endIcon": { marginLeft: "4px" },
		"& .MuiButton-startIcon > *:nth-of-type(1), & .MuiButton-endIcon > *:nth-of-type(1)": { fontSize: "16px" },
		[focusedSelector$8]: {
			backgroundColor: tokens.bgFocused,
			borderColor: tokens.borderFocused,
			color: tokens.textFocused,
			outline: `2px solid ${colorToken.focus}`,
			outlineOffset: "2px"
		},
		"&.MuiButton-loading": { color: "transparent" },
		"&.Mui-disabled:not(.MuiButton-loading)": {
			backgroundColor: tokens.bgDisabled,
			color: tokens.textDisabled,
			borderColor: tokens.borderDisabled
		},
		"&.Mui-disabled.MuiButton-loading": {
			backgroundColor: tokens.bg,
			borderColor: tokens.border
		}
	}, {
		height: compSize?.height,
		padding: compSize?.padding,
		fontSize: compSize?.fontSize,
		borderRadius: comp?.borderRadius,
		backgroundColor: org?.enabled?.container?.color,
		color: org?.enabled?.text?.color,
		borderColor: orgBorder,
		[hoverSelector$11]: {
			backgroundColor: org?.hovered?.container?.color,
			borderColor: orgBorderHover,
			color: org?.hovered?.text?.color ?? org?.enabled?.text?.color
		},
		[pressedSelector$5]: {
			backgroundColor: org?.pressed?.container?.color,
			borderColor: org?.pressed?.container?.borderColor ?? orgBorderHover,
			color: org?.pressed?.text?.color ?? org?.enabled?.text?.color
		},
		[focusedSelector$8]: {
			backgroundColor: org?.focused?.container?.color,
			borderColor: org?.focused?.container?.borderColor ?? orgBorderHover,
			color: org?.focused?.text?.color ?? org?.enabled?.text?.color
		},
		"&.Mui-disabled:not(.MuiButton-loading)": {
			backgroundColor: org?.disabled?.container?.color,
			color: org?.disabled?.text?.color,
			borderColor: org?.disabled?.container?.borderColor ?? orgBorder
		},
		"&.Mui-disabled.MuiButton-loading": {
			backgroundColor: org?.enabled?.container?.color,
			borderColor: orgBorder
		}
	});
});
const Button = forwardRef((props, ref) => /* @__PURE__ */ jsx(StyledButton$1, {
	ref,
	"data-testid": "button",
	disableRipple: true,
	disableElevation: true,
	...props
}));
//#endregion
//#region src/web/atoms/Checkbox/Checkbox.tsx
/** Figma defines small (12) and medium (16); map MUI `large` to medium. */
const iconSizePx = {
	small: 12,
	medium: 16,
	large: 16
};
/**
* Figma `_check-icon`: fixed `radius-xs` box + Material done/remove at full icon
* size (optical insets live in the glyph, not a scaled SVG stroke/rx).
*/
const CheckboxIcon = ({ glyph }) => /* @__PURE__ */ jsxs("span", {
	className: "hephaestus-checkbox-icon",
	children: [glyph === "done" ? /* @__PURE__ */ jsx(DoneRounded_default, { className: "hephaestus-checkbox-glyph" }) : null, glyph === "remove" ? /* @__PURE__ */ jsx(RemoveRounded_default, { className: "hephaestus-checkbox-glyph" }) : null]
});
const StyledCheckbox = styled$2(Checkbox$1)(({ theme, size }) => {
	const { color: colorToken, component, borderRadius } = theme.hephaestus;
	const comp = component?.checkbox;
	const iconPx = iconSizePx[size ?? "medium"];
	return resolveCssStyle(theme, {
		padding: 0,
		color: "inherit",
		borderRadius: borderRadius.xs,
		"&:hover": { backgroundColor: "transparent" },
		"& .hephaestus-checkbox-icon": {
			width: iconPx,
			height: iconPx,
			boxSizing: "border-box",
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			borderRadius: borderRadius.xs,
			border: "2px solid",
			borderColor: colorToken.outline,
			backgroundColor: "transparent",
			color: colorToken.onPrimary
		},
		"& .hephaestus-checkbox-glyph": {
			fontSize: iconPx,
			width: iconPx,
			height: iconPx
		},
		"&.Mui-checked .hephaestus-checkbox-icon, &.MuiCheckbox-indeterminate .hephaestus-checkbox-icon": {
			borderColor: colorToken.primary,
			backgroundColor: colorToken.primary,
			color: colorToken.onPrimary
		},
		"&.Mui-disabled .hephaestus-checkbox-icon": {
			borderColor: colorToken.disabled,
			backgroundColor: "transparent",
			color: colorToken.onDisabled
		},
		"&.Mui-disabled.Mui-checked .hephaestus-checkbox-icon, &.Mui-disabled.MuiCheckbox-indeterminate .hephaestus-checkbox-icon": {
			borderColor: colorToken.disabled,
			backgroundColor: colorToken.disabled
		},
		"&.Mui-focusVisible, &[data-preview-state=\"focused\"]": {
			outline: `2px solid ${colorToken.focus}`,
			outlineOffset: 2
		}
	}, {
		"& .hephaestus-checkbox-icon": {
			borderColor: comp?.defaultColor,
			color: comp?.onActiveColor
		},
		"&.Mui-checked .hephaestus-checkbox-icon, &.MuiCheckbox-indeterminate .hephaestus-checkbox-icon": {
			borderColor: comp?.activeColor,
			backgroundColor: comp?.activeColor,
			color: comp?.onActiveColor
		},
		"&.Mui-disabled .hephaestus-checkbox-icon": { color: comp?.onDisabledColor }
	});
});
const Checkbox = forwardRef((props, ref) => /* @__PURE__ */ jsx(StyledCheckbox, {
	...props,
	ref,
	disableRipple: true,
	focusVisibleClassName: "Mui-focusVisible",
	icon: /* @__PURE__ */ jsx(CheckboxIcon, {}),
	checkedIcon: /* @__PURE__ */ jsx(CheckboxIcon, { glyph: "done" }),
	indeterminateIcon: /* @__PURE__ */ jsx(CheckboxIcon, { glyph: "remove" })
}));
//#endregion
//#region src/web/atoms/Chip/Chip.tsx
const hoverSelector$10 = "&:hover, &[data-preview-state=\"hover\"]";
const pressedSelector$4 = "&:active, &[data-preview-state=\"pressed\"]";
const focusedSelector$7 = "&.Mui-focusVisible, &:focus-visible, &[data-preview-state=\"focused\"]";
const isInteractiveChip = ({ clickable, onClick }) => clickable === true || clickable !== false && onClick != null;
const sizeTokens$1 = {
	small: {
		height: "24px",
		padding: "0 8px",
		fontSize: "12px",
		fontWeight: 500,
		lineHeight: "16px",
		letterSpacing: "0.25px",
		iconSize: "12px",
		avatarSize: "16px"
	},
	medium: {
		height: "32px",
		padding: "0 12px",
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "20px",
		letterSpacing: "0.25px",
		iconSize: "16px",
		avatarSize: "20px"
	}
};
const filledColors = (c, color) => {
	if (color === "info" || color === "primary") return {
		bg: c.supportOneVariant,
		bgHover: c.supportOneVariant,
		bgPressed: c.primaryVariantPressed,
		bgDisabled: c.supportOneVariant,
		text: c.supportOneOnVariant,
		textDisabled: c.onDisabled,
		border: "transparent",
		borderHover: "transparent",
		borderDisabled: "transparent"
	};
	if (color === "error") return {
		bg: c.negativeVariant,
		bgHover: c.negativeVariantHover,
		bgPressed: c.negativeVariantPressed,
		bgDisabled: c.negativeVariant,
		text: c.negativeOutline,
		textDisabled: c.onDisabled,
		border: "transparent",
		borderHover: "transparent",
		borderDisabled: "transparent"
	};
	if (color === "success") return {
		bg: c.positiveVariant,
		bgHover: c.positiveVariantHover,
		bgPressed: c.positiveVariantPressed,
		bgDisabled: c.positiveVariant,
		text: c.onPositiveVariant,
		textDisabled: c.onDisabled,
		border: "transparent",
		borderHover: "transparent",
		borderDisabled: "transparent"
	};
	if (color === "warning") return {
		bg: c.warningVariant,
		bgHover: c.warningVariantHover,
		bgPressed: c.warningVariantPressed,
		bgDisabled: c.warningVariant,
		text: c.onWarningVariant,
		textDisabled: c.onDisabled,
		border: "transparent",
		borderHover: "transparent",
		borderDisabled: "transparent"
	};
	return {
		bg: c.surfaceContainerVariant,
		bgHover: c.surfaceContainerVariant,
		bgPressed: c.neutralPressed,
		bgDisabled: c.surfaceContainerVariant,
		text: c.onSurface,
		textDisabled: c.onDisabled,
		border: "transparent",
		borderHover: "transparent",
		borderDisabled: "transparent"
	};
};
const outlinedColors = (c, color) => {
	if (color === "info" || color === "primary") return {
		bg: "transparent",
		bgHover: c.supportOneVariant,
		bgPressed: c.primaryVariantPressed,
		bgDisabled: "transparent",
		text: c.supportOneOnVariant,
		textDisabled: c.onDisabled,
		border: c.supportOneOnVariant,
		borderHover: c.supportOneOnVariant,
		borderDisabled: c.onDisabled
	};
	if (color === "error") return {
		bg: "transparent",
		bgHover: c.negativeVariantHover,
		bgPressed: c.negativeVariantPressed,
		bgDisabled: "transparent",
		text: c.negativeOutline,
		textDisabled: c.onDisabled,
		border: c.negativeOutline,
		borderHover: c.negativeOutline,
		borderDisabled: c.onDisabled
	};
	if (color === "success") return {
		bg: "transparent",
		bgHover: c.positiveVariantHover,
		bgPressed: c.positiveVariantPressed,
		bgDisabled: "transparent",
		text: c.onPositiveVariant,
		textDisabled: c.onDisabled,
		border: c.onPositiveVariant,
		borderHover: c.onPositiveVariant,
		borderDisabled: c.onDisabled
	};
	if (color === "warning") return {
		bg: "transparent",
		bgHover: c.warningVariantHover,
		bgPressed: c.warningVariantPressed,
		bgDisabled: "transparent",
		text: c.onWarningVariant,
		textDisabled: c.onDisabled,
		border: c.onWarningVariant,
		borderHover: c.onWarningVariant,
		borderDisabled: c.onDisabled
	};
	return {
		bg: "transparent",
		bgHover: c.surfaceContainerVariant,
		bgPressed: c.neutralPressed,
		bgDisabled: "transparent",
		text: c.onSurface,
		textDisabled: c.onDisabled,
		border: c.outline,
		borderHover: c.outline,
		borderDisabled: c.onDisabled
	};
};
const restInteraction = (tokens) => ({
	backgroundColor: tokens.bg,
	borderColor: tokens.border,
	color: tokens.text,
	boxShadow: "none"
});
const StyledChip = styled$2(Chip$1)(({ theme, variant, color, size, clickable, onClick }) => {
	const interactive = isInteractiveChip({
		clickable,
		onClick
	});
	const { color: colorToken, borderRadius, spacing, font, component } = theme.hephaestus;
	const chip = component?.chip;
	const resolvedVariant = variant ?? "filled";
	const resolvedColor = color ?? "default";
	const resolvedSize = size ?? "medium";
	const sizeDefaults = sizeTokens$1[resolvedSize];
	const tokens = resolvedVariant === "outlined" ? outlinedColors(colorToken, resolvedColor) : filledColors(colorToken, resolvedColor);
	const isDefault = resolvedColor === "default";
	return resolveCssStyle(theme, {
		height: sizeDefaults.height,
		boxSizing: "border-box",
		maxWidth: "100%",
		padding: sizeDefaults.padding,
		gap: spacing.sm,
		borderRadius: borderRadius.md,
		border: "1px solid",
		borderColor: tokens.border,
		backgroundColor: tokens.bg,
		color: tokens.text,
		fontFamily: font.base,
		fontSize: sizeDefaults.fontSize,
		fontWeight: sizeDefaults.fontWeight,
		lineHeight: sizeDefaults.lineHeight,
		letterSpacing: sizeDefaults.letterSpacing,
		textTransform: "none",
		boxShadow: "none",
		[`& .${chipClasses.label}`]: {
			padding: 0,
			overflow: "hidden",
			color: "inherit"
		},
		[`& .${chipClasses.icon}, & .${chipClasses.deleteIcon}`]: {
			margin: 0,
			fontSize: sizeDefaults.iconSize,
			width: sizeDefaults.iconSize,
			height: sizeDefaults.iconSize,
			color: "inherit"
		},
		[`& .${chipClasses.avatar}`]: {
			margin: 0,
			width: sizeDefaults.avatarSize,
			height: sizeDefaults.avatarSize,
			fontSize: resolvedSize === "small" ? "10px" : "12px"
		},
		"& .MuiSvgIcon-root": {
			fontSize: sizeDefaults.iconSize,
			width: sizeDefaults.iconSize,
			height: sizeDefaults.iconSize
		},
		cursor: interactive ? "pointer" : "default",
		[hoverSelector$10]: interactive ? {
			backgroundColor: tokens.bgHover,
			borderColor: tokens.borderHover,
			color: tokens.text,
			boxShadow: "none"
		} : restInteraction(tokens),
		[pressedSelector$4]: interactive ? {
			backgroundColor: tokens.bgPressed,
			borderColor: tokens.border,
			color: tokens.text,
			boxShadow: "none"
		} : restInteraction(tokens),
		[focusedSelector$7]: {
			...restInteraction(tokens),
			...interactive && {
				outline: `2px solid ${colorToken.focus}`,
				outlineOffset: 2
			}
		},
		"&.Mui-disabled": {
			opacity: 1,
			cursor: "default",
			backgroundColor: tokens.bgDisabled,
			color: tokens.textDisabled,
			borderColor: tokens.borderDisabled
		}
	}, isDefault ? {
		color: chip?.textColor,
		borderColor: chip?.borderColor,
		...interactive && { [hoverSelector$10]: {
			backgroundColor: chip?.hoverColor,
			borderColor: chip?.hoverBorderColor
		} }
	} : {});
});
const Chip = forwardRef(({ deleteIcon, onDelete, ...props }, ref) => /* @__PURE__ */ jsx(StyledChip, {
	ref,
	...props,
	deleteIcon: onDelete ? deleteIcon ?? /* @__PURE__ */ jsx(Close_default$1, { fontSize: "inherit" }) : deleteIcon,
	onDelete
}));
//#endregion
//#region src/web/atoms/Container/Container.tsx
const GUTTER = "20px";
const Container = styled$2(Container$1)(({ theme, disableGutters }) => disableGutters ? {} : resolveCssStyle(theme, { "&&": {
	paddingLeft: {
		xs: GUTTER,
		sm: GUTTER
	},
	paddingRight: {
		xs: GUTTER,
		sm: GUTTER
	}
} }));
//#endregion
//#region src/web/atoms/Dialog/Dialog.tsx
/** Figma Modal Dialog Small / Medium paper widths. */
const dialogPaperMaxWidth = {
	xs: 416,
	sm: 578
};
const Dialog = styled$2(Dialog$1)(({ theme }) => {
	const { color, elevation } = theme.hephaestus;
	return resolveCssStyle(theme, {
		[`& .${backdropClasses.root}`]: { backgroundColor: Color(color.background).alpha(.85).string() },
		[`& .${dialogClasses.paper}`]: {
			boxSizing: "border-box",
			backgroundColor: color.surface,
			backgroundImage: "none",
			borderRadius: "24px",
			boxShadow: elevation.modal,
			overflow: "hidden"
		},
		[`& .${dialogClasses.paperFullScreen}`]: { borderRadius: 0 },
		[`& .${dialogClasses.paperWidthXs}`]: { maxWidth: dialogPaperMaxWidth.xs },
		[`& .${dialogClasses.paperWidthSm}`]: { maxWidth: dialogPaperMaxWidth.sm }
	});
});
//#endregion
//#region src/web/atoms/Dialog/DialogActions.tsx
const StyledDialogActions = styled$2(DialogActions$1)(({ theme }) => ({
	...resolveCssStyle(theme, {
		boxSizing: "border-box",
		alignSelf: "stretch",
		maxWidth: "100%",
		minWidth: 0,
		flex: "0 0 auto",
		alignItems: "center",
		gap: "8px",
		justifyContent: "flex-end"
	}),
	"&&": resolveCssStyle(theme, { padding: "24px" })
}));
const DialogActions = forwardRef((props, ref) => /* @__PURE__ */ jsx(StyledDialogActions, {
	ref,
	disableSpacing: true,
	...props
}));
//#endregion
//#region src/web/atoms/Dialog/DialogContent.tsx
const DialogContent = styled$2(DialogContent$1)(({ theme, dividers }) => ({ "&&": resolveCssStyle(theme, { padding: dividers ? "24px 24px 32px 24px" : "0 24px" }) }));
const DialogContentText = styled$2(DialogContentText$1)(({ theme }) => {
	const { color, font } = theme.hephaestus;
	return resolveCssStyle(theme, {
		fontFamily: font.base,
		fontSize: "14px",
		fontWeight: 400,
		lineHeight: "20px",
		letterSpacing: "0.25px",
		color: color.onSurface
	});
});
//#endregion
//#region src/web/atoms/Dialog/DialogTitle.tsx
const DialogTitle = styled$2(DialogTitle$1)(({ theme }) => {
	const { color } = theme.hephaestus;
	return resolveCssStyle(theme, {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: "8px",
		padding: "16px 16px 0 24px",
		[`&:has(+ .${dialogContentClasses.dividers})`]: { paddingBottom: "16px" },
		fontSize: "24px",
		fontWeight: 600,
		color: color.onSurface
	});
});
//#endregion
//#region src/web/atoms/Form/FormControl.tsx
const FormControl = styled$2(FormControl$1)(({ theme }) => {
	const { spacing } = theme.hephaestus;
	return resolveCssStyle(theme, {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: spacing.sm,
		"&.MuiFormControl-fullWidth": {
			width: "100%",
			alignItems: "stretch"
		}
	});
});
//#endregion
//#region src/web/atoms/Form/FormControlLabel.tsx
const FormControlLabel = styled$2(FormControlLabel$1)(({ theme }) => {
	const { color: colorToken, component, font, spacing } = theme.hephaestus;
	const radio = component?.radio;
	const checkbox = component?.checkbox;
	const switchToken = component?.switch;
	return resolveCssStyle(theme, {
		margin: 0,
		gap: spacing.sm,
		paddingTop: 2,
		paddingBottom: 2,
		paddingRight: spacing.lg,
		alignItems: "center",
		"& .MuiFormControlLabel-label": {
			fontFamily: font.base,
			fontSize: "16px",
			fontWeight: 400,
			lineHeight: "24px",
			letterSpacing: "0.25px",
			color: colorToken.onSurface
		},
		"&:has(.MuiCheckbox-root), &:has(.MuiSwitch-root)": {
			gap: spacing.md,
			paddingTop: 0,
			paddingBottom: 0,
			paddingRight: 0
		},
		"&:has(.MuiCheckbox-sizeSmall) .MuiFormControlLabel-label, &:has(.MuiSwitch-sizeSmall) .MuiFormControlLabel-label": {
			fontSize: "14px",
			lineHeight: "20px"
		},
		"&.Mui-disabled": { cursor: "default" },
		"&.MuiFormControlLabel-root.Mui-disabled .MuiFormControlLabel-label": { color: colorToken.onDisabled }
	}, {
		"& .MuiFormControlLabel-label": {
			fontFamily: radio?.fontFamily,
			color: radio?.defaultColor
		},
		"&:has(.MuiCheckbox-root) .MuiFormControlLabel-label": { color: checkbox?.labelColor },
		"&:has(.MuiSwitch-root) .MuiFormControlLabel-label": { color: switchToken?.labelColor },
		"&.MuiFormControlLabel-root.Mui-disabled .MuiFormControlLabel-label": { color: radio?.disabledColor }
	});
});
//#endregion
//#region src/web/atoms/Form/FormGroup.tsx
const FormGroup = styled$2(FormGroup$1)(({ theme }) => {
	const { spacing } = theme.hephaestus;
	return resolveCssStyle(theme, {
		rowGap: spacing.xl,
		columnGap: "24px",
		marginBlock: spacing.md
	});
});
//#endregion
//#region src/web/atoms/Form/FormHelperText.tsx
const toneIcons = {
	neutral: InfoOutlined_default$1,
	success: CheckCircle_default,
	warning: Warning_default,
	error: Error_default
};
const StyledFormHelperText = styled$2(FormHelperText$1)(({ theme }) => {
	const { color: colorToken, component, font, spacing } = theme.hephaestus;
	const comp = component?.helpText;
	return resolveCssStyle(theme, {
		display: "flex",
		alignItems: "center",
		gap: spacing.sm,
		margin: 0,
		fontFamily: font.base,
		fontSize: "12px",
		fontWeight: 400,
		lineHeight: "16px",
		letterSpacing: "0.25px",
		color: colorToken.onSurfaceVariant,
		"& .hephaestus-form-helper-icon": {
			fontSize: 12,
			width: 12,
			height: 12
		},
		"&[data-tone=\"success\"]": { color: colorToken.positive },
		"&[data-tone=\"warning\"]": { color: colorToken.warning },
		"&.Mui-error, &[data-tone=\"error\"]": { color: colorToken.negative },
		"&.Mui-disabled": { color: colorToken.onDisabled }
	}, {
		color: comp?.neutralColor,
		"&[data-tone=\"success\"]": { color: comp?.successColor },
		"&[data-tone=\"warning\"]": { color: comp?.warningColor },
		"&.Mui-error, &[data-tone=\"error\"]": { color: comp?.errorColor }
	});
});
const FormHelperText = forwardRef((props, ref) => {
	const { showIcon = true, tone: toneProp, error, children, ...rest } = props;
	const ctx = useFormControl();
	const tone = toneProp ?? (error || ctx?.error ? "error" : "neutral");
	const Icon = toneIcons[tone];
	return /* @__PURE__ */ jsxs(StyledFormHelperText, {
		...rest,
		ref,
		error: error ?? tone === "error",
		"data-tone": tone,
		children: [showIcon && /* @__PURE__ */ jsx(Icon, { className: "hephaestus-form-helper-icon" }), children]
	});
});
//#endregion
//#region src/web/atoms/Form/FormLabel.tsx
const FormLabel = styled$2(FormLabel$1)(({ theme }) => {
	const { color: colorToken, component, font } = theme.hephaestus;
	const comp = component?.radio;
	return resolveCssStyle(theme, {
		fontFamily: font.base,
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "16px",
		letterSpacing: "0.25px",
		color: colorToken.onSurfaceVariant,
		margin: 0,
		"&.Mui-focused": { color: colorToken.onSurfaceVariant },
		"&.Mui-error": { color: colorToken.negative },
		"&.Mui-disabled": { color: colorToken.onDisabled },
		"& .MuiFormLabel-asterisk": { color: colorToken.onSurfaceVariant },
		"&.Mui-error .MuiFormLabel-asterisk": { color: colorToken.negative },
		"&.MuiFormLabel-root.Mui-disabled .MuiFormLabel-asterisk": { color: "inherit" }
	}, {
		fontFamily: comp?.fontFamily,
		color: comp?.labelColor,
		"&.Mui-focused": { color: comp?.labelColor },
		"&.Mui-error": { color: comp?.errorColor },
		"&.Mui-disabled": { color: comp?.disabledColor },
		"& .MuiFormLabel-asterisk": { color: comp?.requiredIndicatorColor },
		"&.Mui-error .MuiFormLabel-asterisk": { color: comp?.errorColor },
		"&.MuiFormLabel-root.Mui-disabled .MuiFormLabel-asterisk": { color: "inherit" }
	});
});
//#endregion
//#region src/web/atoms/IconButton/IconButton.tsx
const hoverSelector$9 = "&:hover, &[data-preview-state=\"hover\"]";
const pressedSelector$3 = "&:active, &[data-preview-state=\"pressed\"]";
const focusedSelector$6 = "&:focus-visible, &[data-preview-state=\"focused\"]";
const sizeTokens = {
	xsmall: {
		padding: 4,
		fontSize: 16
	},
	small: {
		padding: 6,
		fontSize: 20
	},
	medium: {
		padding: 8,
		fontSize: 24
	},
	large: {
		padding: 12,
		fontSize: 24
	}
};
const getStandardColors = (c) => ({
	bg: "transparent",
	bgHover: c.neutralHover,
	bgPressed: c.neutralPressed,
	bgFocused: c.neutralPressed,
	bgDisabled: "transparent",
	icon: c.onSurface,
	iconDisabled: c.onDisabled
});
const getContainedColors = (c) => ({
	bg: c.surfaceContainerVariant,
	bgHover: c.neutralHover,
	bgPressed: c.neutralPressed,
	bgFocused: c.neutralPressed,
	bgDisabled: c.surfaceContainerVariant,
	icon: c.onSurface,
	iconDisabled: c.onDisabled
});
const StyledIconButton = styled$2(IconButton$1, { shouldForwardProp: (prop) => prop !== "contained" })(({ theme, size, contained }) => {
	const { color: colorToken, borderRadius } = theme.hephaestus;
	const s = sizeTokens[size ?? "medium"];
	const tokens = contained ? getContainedColors(colorToken) : getStandardColors(colorToken);
	return resolveCssStyle(theme, {
		padding: s.padding,
		fontSize: s.fontSize,
		borderRadius: borderRadius.round,
		backgroundColor: tokens.bg,
		color: tokens.icon,
		"& .MuiSvgIcon-root": { fontSize: "inherit" },
		[hoverSelector$9]: { backgroundColor: tokens.bgHover },
		[pressedSelector$3]: { backgroundColor: tokens.bgPressed },
		[focusedSelector$6]: {
			backgroundColor: tokens.bgFocused,
			outline: `2px solid ${colorToken.focus}`,
			outlineOffset: "2px"
		},
		"&.MuiIconButton-loading": { color: "transparent" },
		"& .MuiIconButton-loadingIndicator": { color: tokens.icon },
		"&.Mui-disabled:not(.MuiIconButton-loading)": {
			backgroundColor: tokens.bgDisabled,
			color: tokens.iconDisabled
		},
		"&.Mui-disabled.MuiIconButton-loading": { backgroundColor: tokens.bg }
	});
});
const IconButton = forwardRef((props, ref) => /* @__PURE__ */ jsx(StyledIconButton, {
	ref,
	"data-testid": "icon-button",
	disableRipple: true,
	...props
}));
//#endregion
//#region src/web/atoms/Input/Input.tsx
const sizeMetrics$2 = {
	small: {
		height: "32px",
		fontSize: "14px",
		lineHeight: "20px",
		paddingY: "6px"
	},
	medium: {
		height: "40px",
		fontSize: "16px",
		lineHeight: "24px",
		paddingY: "8px"
	}
};
const hoverSelector$8 = "&:hover:not(.Mui-disabled):not(.Mui-error):not(.MuiInputBase-colorSuccess), &[data-preview-state=\"hover\"]:not(.Mui-error):not(.MuiInputBase-colorSuccess)";
const focusedSelector$5 = "&.Mui-focused, &[data-preview-state=\"focused\"]";
const focusedDefaultSelector = "&.Mui-focused:not(.Mui-error):not(.MuiInputBase-colorSuccess), &[data-preview-state=\"focused\"]:not(.Mui-error):not(.MuiInputBase-colorSuccess)";
const Input = styled$2(InputBase)(({ theme, size, multiline }) => {
	const { color: colorToken, component, font, borderRadius, spacing } = theme.hephaestus;
	const comp = component?.textField;
	const metrics = sizeMetrics$2[size ?? "medium"];
	return resolveCssStyle(theme, {
		boxSizing: "border-box",
		fontFamily: font.base,
		fontSize: metrics.fontSize,
		fontWeight: 400,
		lineHeight: metrics.lineHeight,
		letterSpacing: "0.25px",
		color: colorToken.onSurface,
		backgroundColor: colorToken.surface,
		border: "1px solid",
		borderColor: colorToken.outline,
		borderRadius: borderRadius.sm,
		height: multiline ? "auto" : metrics.height,
		minHeight: metrics.height,
		paddingLeft: spacing.lg,
		paddingRight: spacing.lg,
		gap: spacing.lg,
		alignItems: "center",
		transition: theme.transitions.create([
			"border-color",
			"background-color",
			"box-shadow"
		]),
		[hoverSelector$8]: { borderColor: colorToken.onSurface },
		[focusedSelector$5]: {
			outline: `2px solid ${colorToken.focus}`,
			outlineOffset: 2
		},
		[focusedDefaultSelector]: { borderColor: colorToken.primary },
		"&.Mui-error:not(.Mui-disabled)": {
			borderColor: colorToken.negative,
			color: colorToken.negative
		},
		"&.MuiInputBase-colorSuccess": {
			borderColor: colorToken.positive,
			color: colorToken.positive
		},
		"&.Mui-disabled": {
			borderColor: colorToken.disabled,
			color: colorToken.disabled
		},
		"& .MuiInputBase-input": {
			paddingTop: metrics.paddingY,
			paddingBottom: metrics.paddingY,
			paddingLeft: 0,
			paddingRight: 0,
			height: "auto",
			boxSizing: "border-box",
			font: "inherit",
			letterSpacing: "inherit",
			color: "inherit"
		},
		"& .MuiInputBase-input::placeholder": {
			color: colorToken.onSurfaceVariant,
			opacity: 1
		},
		"&.Mui-disabled .MuiInputBase-input": { WebkitTextFillColor: colorToken.disabled },
		"& .MuiInputAdornment-root": {
			color: colorToken.onSurfaceVariant,
			margin: 0
		},
		"& .MuiInputAdornment-root .MuiSvgIcon-root": {
			fontSize: 16,
			width: 16,
			height: 16
		},
		"&.Mui-error:not(.Mui-disabled) .MuiInputAdornment-root": { color: colorToken.negative },
		"&.Mui-disabled .MuiInputAdornment-root": { color: colorToken.disabled }
	}, {
		borderRadius: comp?.borderRadius,
		color: comp?.textColor,
		borderColor: comp?.borderColor,
		[hoverSelector$8]: { borderColor: comp?.hoverBorderColor },
		[focusedDefaultSelector]: { borderColor: comp?.focusBorderColor },
		"&.Mui-error:not(.Mui-disabled)": {
			borderColor: comp?.errorColor,
			color: comp?.errorColor
		},
		"&.MuiInputBase-colorSuccess": {
			borderColor: comp?.successColor,
			color: comp?.successColor
		},
		"&.Mui-disabled": {
			borderColor: comp?.disabledColor,
			color: comp?.disabledColor
		},
		"&.Mui-disabled .MuiInputBase-input": { WebkitTextFillColor: comp?.disabledColor },
		"&.Mui-error:not(.Mui-disabled) .MuiInputAdornment-root": { color: comp?.errorColor },
		"&.Mui-disabled .MuiInputAdornment-root": { color: comp?.disabledColor }
	});
});
//#endregion
//#region src/web/atoms/LinearProgress/LinearProgress.tsx
const pixelBySize = {
	small: 4,
	medium: 6,
	large: 8
};
const isNamedSize = (size) => Object.hasOwn(pixelBySize, size);
const resolveSize = (size) => typeof size === "string" && isNamedSize(size) ? pixelBySize[size] : size;
const StyledLinearProgress = styled$2(LinearProgress$1)(({ theme }) => {
	const { color, borderRadius } = theme.hephaestus;
	return resolveCssStyle(theme, {
		borderRadius: borderRadius.sm,
		backgroundColor: color.surfaceContainerVariant,
		[`& .${linearProgressClasses.bar}`]: {
			borderRadius: borderRadius.sm,
			backgroundColor: color.primary
		},
		[`&.${linearProgressClasses.buffer} .${linearProgressClasses.bar2}`]: { backgroundColor: color.surfaceContainerVariant }
	});
});
const LinearProgress = ({ size = "medium", sx, ...props }) => /* @__PURE__ */ jsx(StyledLinearProgress, {
	"data-testid": "linear-progress",
	...props,
	sx: [{ height: resolveSize(size) }, ...Array.isArray(sx) ? sx : [sx]]
});
//#endregion
//#region src/web/atoms/Link/Link.tsx
const Link = forwardRef(({ variant = "body1", ...props }, ref) => /* @__PURE__ */ jsx(Link$1, {
	ref,
	variant,
	...props
}));
//#endregion
//#region src/web/atoms/Menu/Menu.tsx
const StyledMenu = styled$2(Menu$1)(({ theme }) => {
	const { color, borderRadius, elevation, font, spacing } = theme.hephaestus;
	return resolveCssStyle(theme, {
		[`& .${menuClasses.paper}`]: {
			backgroundColor: color.surface,
			borderRadius: borderRadius.lg,
			boxShadow: `${elevation.high}, 0 16px 40px -16px rgba(0, 0, 0, 0.25)`,
			marginTop: spacing.sm
		},
		[`& .${menuClasses.list}, & .${listClasses.root}`]: { padding: 0 },
		[`& .${dividerClasses.root}, & .${menuItemClasses.root} + .${dividerClasses.root}`]: {
			marginTop: 0,
			marginBottom: 0
		},
		[`& .${listSubheaderClasses.root}`]: {
			position: "static",
			display: "flex",
			alignItems: "center",
			height: 32,
			padding: `0 ${spacing.lg}`,
			backgroundColor: color.surface,
			color: color.onSurfaceVariant,
			fontFamily: font.base,
			fontSize: "11px",
			fontWeight: 600,
			lineHeight: "14px",
			letterSpacing: "0.25px"
		}
	});
});
const Menu = forwardRef((props, ref) => /* @__PURE__ */ jsx(StyledMenu, {
	ref,
	"data-testid": "menu",
	elevation: 0,
	...props
}));
//#endregion
//#region src/web/atoms/Menu/MenuItem.tsx
const StyledMenuItem = styled$2(MenuItem$1)(({ theme }) => {
	const { color, font, spacing, borderRadius } = theme.hephaestus;
	return resolveCssStyle(theme, {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		gap: spacing.md,
		minHeight: 40,
		height: "auto",
		padding: `10px ${spacing.lg}`,
		"&:first-of-type": {
			borderTopLeftRadius: borderRadius.lg,
			borderTopRightRadius: borderRadius.lg
		},
		"&:last-of-type": {
			borderBottomLeftRadius: borderRadius.lg,
			borderBottomRightRadius: borderRadius.lg
		},
		backgroundColor: color.surface,
		color: color.onSurface,
		fontFamily: font.base,
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "20px",
		letterSpacing: "0.25px",
		[`&.${menuItemClasses.root} + .${dividerClasses.root}`]: {
			marginTop: 0,
			marginBottom: 0
		},
		[`& .${listItemIconClasses.root}`]: {
			minWidth: "unset",
			color: "inherit"
		},
		"& .MuiSvgIcon-root": {
			fontSize: 16,
			width: 16,
			height: 16
		},
		"& > .MuiSvgIcon-root:last-of-type:not(:first-of-type)": { marginLeft: "auto" },
		[`&:hover, &[data-preview-state="hover"], &.${menuItemClasses.focusVisible}`]: { backgroundColor: color.neutralHover },
		[`&.${menuItemClasses.selected}`]: { backgroundColor: color.surface },
		[`&[role="option"].${menuItemClasses.selected}`]: { backgroundColor: color.primaryVariant },
		[`&.${menuItemClasses.selected}:hover, &.${menuItemClasses.selected}[data-preview-state="hover"], &.${menuItemClasses.selected}.${menuItemClasses.focusVisible}`]: { backgroundColor: color.neutralHover },
		[`&[role="option"].${menuItemClasses.selected}:hover, &[role="option"].${menuItemClasses.selected}[data-preview-state="hover"], &[role="option"].${menuItemClasses.selected}.${menuItemClasses.focusVisible}`]: { backgroundColor: color.primaryVariantHover },
		"&:focus-visible, &[data-preview-state=\"focused\"]": {
			outline: `2px solid ${color.focus}`,
			outlineOffset: -2
		},
		"&.Mui-disabled": {
			backgroundColor: color.surface,
			color: color.onDisabled,
			opacity: 1
		}
	});
});
const MenuItem = forwardRef((props, ref) => /* @__PURE__ */ jsx(StyledMenuItem, {
	ref,
	"data-testid": "menu-item",
	disableRipple: true,
	...props
}));
//#endregion
//#region src/web/atoms/Nav/constants.ts
const navExpandedWidth = 240;
const navCollapsedWidth = 56;
const navTransitionDuration = 300;
const navTransitionEasing = "cubic-bezier(0.4, 0, 0.2, 1)";
//#endregion
//#region src/web/atoms/Nav/Nav.tsx
const NavContext = createContext({ collapsed: false });
const useNavContext = () => useContext(NavContext);
const itemSize = 40;
const hoverSelector$7 = "&:hover, &[data-preview-state=\"hover\"]";
const focusedSelector$4 = "&:focus-visible, &[data-preview-state=\"focused\"]";
const NavRoot = styled$2(Box)(({ theme }) => {
	const { color, component } = theme.hephaestus;
	const navSection = component?.navSection;
	return {
		...resolveCssStyle(theme, {
			boxSizing: "border-box",
			display: "flex",
			flexDirection: "column",
			alignItems: "stretch",
			justifyContent: "flex-start",
			width: 240,
			minWidth: 0,
			maxWidth: 240,
			transition: theme.transitions.create(["width", "max-width"], {
				duration: 300,
				easing: navTransitionEasing
			}),
			minHeight: 0,
			flex: "1 1 auto",
			height: "auto",
			padding: 0,
			overflow: "hidden",
			containerName: "nav-rail",
			containerType: "inline-size",
			backgroundColor: navSection?.backgroundColor ?? color.background,
			borderRadius: 0,
			boxShadow: "none"
		}),
		"&[data-collapsed=\"true\"]": {
			width: 56,
			maxWidth: 56
		}
	};
});
const ListViewport = styled$2("div")(({ theme }) => {
	const { color } = theme.hephaestus;
	return resolveCssStyle(theme, {
		boxSizing: "border-box",
		flex: "1 1 auto",
		minWidth: 0,
		minHeight: 0,
		width: "100%",
		overflowX: "hidden",
		overflowY: "auto",
		scrollbarWidth: "thin",
		scrollbarColor: `${color.outlineVariant} transparent`,
		"@supports (overflow: overlay)": { overflowY: "overlay" },
		"&::-webkit-scrollbar": { width: 4 },
		"&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: color.outlineVariant,
			borderRadius: 4
		}
	});
});
const StyledList = styled$2(List$1)(({ theme }) => {
	const { spacing } = theme.hephaestus;
	return resolveCssStyle(theme, {
		boxSizing: "border-box",
		display: "block",
		width: "100%",
		minWidth: 0,
		margin: 0,
		padding: spacing.md,
		"& > *:not(:last-child)": { marginBottom: "2px" }
	});
});
const CollapseRow = styled$2("div", { shouldForwardProp: (prop) => prop !== "collapsed" })(({ theme, collapsed }) => {
	const { color } = theme.hephaestus;
	return resolveCssStyle(theme, {
		display: "flex",
		boxSizing: "border-box",
		alignItems: "center",
		justifyContent: "flex-end",
		width: collapsed ? 56 : 240,
		minWidth: 56,
		maxWidth: collapsed ? 56 : 240,
		transition: theme.transitions.create(["width", "max-width"], {
			duration: 300,
			easing: navTransitionEasing
		}),
		padding: theme.hephaestus.spacing.md,
		height: "auto",
		flexShrink: 0,
		"& .MuiIconButton-root": {
			width: itemSize,
			minWidth: itemSize,
			height: itemSize,
			flexShrink: 0,
			padding: 0,
			fontSize: 16,
			color: color.onSurface
		},
		"& .MuiSvgIcon-root": {
			transform: collapsed ? "none" : "rotate(180deg)",
			transition: theme.transitions.create("transform", {
				duration: 300,
				easing: navTransitionEasing
			})
		},
		[`& .MuiIconButton-root${hoverSelector$7}`]: { backgroundColor: color.primaryVariantHover },
		[`& .MuiIconButton-root${focusedSelector$4}`]: {
			outline: `2px solid ${color.focus}`,
			outlineOffset: -2
		}
	});
});
const NavCollapse = forwardRef(({ collapsed: collapsedProp, ...props }, ref) => {
	const { collapsed: contextCollapsed } = useNavContext();
	return /* @__PURE__ */ jsx(CollapseRow, {
		collapsed: collapsedProp ?? contextCollapsed,
		children: /* @__PURE__ */ jsx(IconButton, {
			ref,
			size: "medium",
			...props,
			"aria-label": "start",
			children: /* @__PURE__ */ jsx(Start_default, { fontSize: "inherit" })
		})
	});
});
const Nav = forwardRef(({ collapsed = false, children, className, ...rootProps }, ref) => /* @__PURE__ */ jsx(NavContext.Provider, {
	value: { collapsed },
	children: /* @__PURE__ */ jsx(NavRoot, {
		...rootProps,
		component: "nav",
		ref,
		className,
		"data-collapsed": collapsed ? "true" : void 0,
		children: /* @__PURE__ */ jsx(ListViewport, { children: /* @__PURE__ */ jsx(StyledList, {
			disablePadding: true,
			children
		}) })
	})
}));
//#endregion
//#region src/web/atoms/Tooltip/Tooltip.tsx
const widthPx = {
	wrap: void 0,
	fixedSmall: 152,
	fixedMedium: 300,
	fixedLarge: 500
};
const TooltipRoot = forwardRef(({ className, classes, resizing: _resizing, ...props }, ref) => /* @__PURE__ */ jsx(Tooltip$1, {
	...props,
	ref,
	classes: {
		...classes,
		tooltip: [className, classes?.tooltip].filter(Boolean).join(" ")
	}
}));
const StyledTooltip = styled$2(TooltipRoot, { shouldForwardProp: (prop) => prop !== "resizing" })(({ theme, resizing = "wrap" }) => {
	const { color, borderRadius, spacing, font } = theme.hephaestus;
	const width = widthPx[resizing];
	return resolveCssStyle(theme, {
		[`&.${tooltipClasses.tooltip}`]: {
			boxSizing: "border-box",
			width,
			maxWidth: width ?? "none",
			height: "auto",
			minHeight: "unset",
			padding: `${spacing.sm} ${spacing.md}`,
			borderRadius: borderRadius.sm,
			backgroundColor: color.onSurface,
			color: color.surface,
			textAlign: "center",
			fontFamily: font.base,
			fontSize: "12px",
			fontWeight: 500,
			lineHeight: "16px",
			letterSpacing: "0.25px"
		},
		[`& .${tooltipClasses.arrow}`]: { color: color.onSurface }
	});
});
const Tooltip = forwardRef(({ arrow = true, ...props }, ref) => /* @__PURE__ */ jsx(StyledTooltip, {
	...props,
	arrow,
	ref
}));
//#endregion
//#region src/web/atoms/Transitions/Collapse.tsx
/**
* MUI sets a pixel height in `onExit` then `0` in `onExiting` in the same
* frame. Without a reflow, the browser skips `auto` → `0` and close snaps.
*/
const Collapse = forwardRef(({ onExit, ...props }, ref) => /* @__PURE__ */ jsx(Collapse$1, {
	ref,
	...props,
	onExit: (node) => {
		node.offsetHeight;
		onExit?.(node);
	}
}));
//#endregion
//#region src/web/atoms/Nav/NavItem.tsx
const navPaperBackground = (anchor, fallback) => {
	const nav = anchor?.closest("nav");
	if (nav == null) return fallback;
	const value = getComputedStyle(nav).backgroundColor;
	if (value === "" || value === "transparent" || value === "rgba(0, 0, 0, 0)") return fallback;
	return value;
};
const wrapLabelWhenWide = { "& .nav-item-label": {
	whiteSpace: "normal",
	overflow: "visible",
	overflowWrap: "break-word"
} };
const hoverSelector$6 = `&:hover, &[data-preview-state="hover"]`;
const focusedSelector$3 = "&.Mui-focusVisible, &:focus-visible, &[data-preview-state=\"focused\"]";
const parentButtonSelector = `& > span > .${listItemButtonClasses.root}`;
const childSelectedSelector = `&:has(.MuiCollapse-root .${listItemButtonClasses.selected}) > span > .${listItemButtonClasses.root}`;
const StyledListItem = styled$2(ListItem, { shouldForwardProp: (prop) => prop !== "hasFlyout" && prop !== "childSelected" && prop !== "hasInlineTooltip" })(({ theme, hasFlyout, childSelected, hasInlineTooltip }) => {
	const { color, component } = theme.hephaestus;
	const navSection = component?.navSection;
	const selectedBg = navSection?.selectedColor ?? color.primaryVariant;
	const primaryColor = navSection?.color ?? color.onSurface;
	return resolveCssStyle(theme, {
		display: "block",
		position: hasFlyout || hasInlineTooltip ? "relative" : "static",
		width: "100%",
		minWidth: 40,
		padding: 0,
		overflow: hasFlyout || hasInlineTooltip ? "visible" : "hidden",
		[childSelectedSelector]: {
			backgroundColor: selectedBg,
			color: primaryColor,
			fontWeight: 500
		},
		...childSelected ? { [parentButtonSelector]: {
			backgroundColor: selectedBg,
			color: primaryColor,
			fontWeight: 500
		} } : {}
	});
});
const SubItems = styled$2("ul")(({ theme }) => resolveCssStyle(theme, {
	display: "flex",
	flexDirection: "column",
	gap: "2px",
	margin: 0,
	paddingTop: 2,
	paddingRight: 0,
	paddingBottom: 0,
	paddingLeft: 0,
	listStyle: "none"
}));
const StyledButton = styled$2(ListItemButton, { shouldForwardProp: (prop) => prop !== "navVariant" && prop !== "collapsed" })(({ theme, navVariant, collapsed }) => {
	const { color, borderRadius, font, spacing, component } = theme.hephaestus;
	const navSection = component?.navSection;
	const primary = navVariant === "primary";
	const itemRadius = navSection?.radius ?? borderRadius.md;
	const hoverBg = navSection?.hoverColor ?? color.primaryVariantHover;
	const selectedBg = navSection?.selectedColor ?? color.primaryVariant;
	const primaryColor = navSection?.color ?? color.onSurface;
	return resolveCssStyle(theme, {
		boxSizing: "border-box",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: spacing.sm,
		width: "100%",
		minWidth: 40,
		maxWidth: "none",
		flexShrink: 0,
		minHeight: primary ? 40 : 36,
		paddingTop: 0,
		paddingBottom: 0,
		paddingLeft: primary ? 0 : spacing.lg,
		overflow: "hidden",
		borderRadius: itemRadius,
		backgroundColor: "transparent",
		color: primary ? primaryColor : color.onSurfaceVariant,
		fontFamily: font.base,
		fontSize: primary ? "14px" : "12px",
		fontWeight: primary ? 500 : 400,
		lineHeight: primary ? "20px" : "16px",
		letterSpacing: "0.25px",
		textAlign: "left",
		[`& .${listItemIconClasses.root}`]: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			flexShrink: 0,
			minWidth: 40,
			width: 40,
			height: 40,
			margin: 0,
			color: "inherit"
		},
		"& .MuiSvgIcon-root, & .MuiIcon-root": {
			fontSize: 16,
			width: 16,
			height: 16
		},
		"& .nav-item-label": {
			display: "block",
			flex: "1 1 auto",
			minWidth: 0,
			padding: 0,
			lineHeight: primary ? "20px" : "16px",
			overflow: "hidden",
			textOverflow: primary ? "clip" : "ellipsis",
			whiteSpace: "nowrap",
			opacity: collapsed ? 0 : 1,
			transition: theme.transitions.create("opacity", {
				duration: 300,
				easing: navTransitionEasing
			})
		},
		"& .nav-item-trailing": {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			flexShrink: collapsed ? 1 : 0,
			minWidth: 0,
			height: 40,
			overflow: "hidden",
			opacity: collapsed ? 0 : 1,
			color: "inherit",
			marginRight: "12px",
			transition: theme.transitions.create(["width", "opacity"], {
				duration: 300,
				easing: navTransitionEasing
			})
		},
		"& .nav-item-badge": {
			display: "flex",
			alignItems: "center",
			alignSelf: "center",
			flexShrink: 0,
			width: collapsed ? 0 : "auto",
			minWidth: collapsed ? 0 : "auto",
			overflow: collapsed ? "hidden" : "visible",
			opacity: collapsed ? 0 : 1,
			transition: theme.transitions.create(["width", "opacity"], {
				duration: 300,
				easing: navTransitionEasing
			})
		},
		[hoverSelector$6]: {
			backgroundColor: hoverBg,
			color: primaryColor
		},
		[`&.${listItemButtonClasses.selected}`]: {
			backgroundColor: selectedBg,
			color: primaryColor,
			fontWeight: 500,
			[hoverSelector$6]: {
				backgroundColor: selectedBg,
				color: primaryColor
			}
		},
		[focusedSelector$3]: {
			outline: `2px solid ${color.focus}`,
			outlineOffset: -2
		},
		"&.Mui-disabled": {
			backgroundColor: "transparent",
			color: color.onDisabled,
			opacity: 1
		},
		...!collapsed && primary ? { [`@container nav-rail (min-width: 240px)`]: wrapLabelWhenWide } : {}
	});
});
const iconLabelRow = {
	display: "flex",
	alignItems: "center",
	flex: "1 1 auto",
	minWidth: 0
};
const tooltipTriggerStyle = {
	display: "block",
	width: "100%"
};
const NavItem = forwardRef(({ variant = "primary", collapsed: collapsedProp, open: openProp, defaultOpen = false, icon, badge, selected, label, children, onClick, onMouseEnter, onMouseLeave, "data-preview-state": previewState, ...props }, ref) => {
	const { collapsed: collapsedContext } = useNavContext();
	const collapsed = collapsedProp ?? collapsedContext;
	const hasSubItems = variant === "primary" && Children.toArray(children).length > 0;
	const isControlled = openProp !== void 0;
	const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
	const open = isControlled ? Boolean(openProp) : uncontrolledOpen;
	const [anchorEl, setAnchorEl] = useState(null);
	const [hovering, setHovering] = useState(false);
	const closeTimer = useRef(void 0);
	const previewHover = previewState === "hover";
	const hasSelectedChild = Children.toArray(children).some((child) => isValidElement(child) && Boolean(child.props.selected));
	const labelHidden = collapsed && variant === "primary";
	const accessibleName = labelHidden && typeof label === "string" ? label : void 0;
	const showFlyout = Boolean(collapsed && hasSubItems);
	const tooltipTitle = typeof label === "string" ? label : "";
	const showLabelTooltip = Boolean(collapsed && !hasSubItems && tooltipTitle);
	const previewTooltipOpen = previewHover && showLabelTooltip;
	const accordionOpen = open && !collapsed;
	const flyoutOpen = Boolean(showFlyout && anchorEl && (hovering || previewHover));
	const cancelFlyoutClose = () => {
		if (closeTimer.current !== void 0) {
			clearTimeout(closeTimer.current);
			closeTimer.current = void 0;
		}
	};
	const openFlyoutHover = () => {
		if (!showFlyout) return;
		cancelFlyoutClose();
		setHovering(true);
	};
	const closeFlyoutHover = () => {
		cancelFlyoutClose();
		closeTimer.current = setTimeout(() => {
			setHovering(false);
		}, 120);
	};
	const assignButtonRef = (node) => {
		setAnchorEl((current) => current === node ? current : node);
		if (typeof ref === "function") ref(node);
		else if (ref) ref.current = node;
	};
	return /* @__PURE__ */ jsxs(StyledListItem, {
		disablePadding: true,
		hasFlyout: showFlyout,
		hasInlineTooltip: previewTooltipOpen,
		childSelected: hasSelectedChild,
		onMouseEnter: () => {
			openFlyoutHover();
		},
		onMouseLeave: () => {
			closeFlyoutHover();
		},
		children: [/* @__PURE__ */ jsx(Tooltip, {
			title: showLabelTooltip ? tooltipTitle : "",
			placement: "right",
			describeChild: true,
			disableHoverListener: !showLabelTooltip,
			disableFocusListener: !showLabelTooltip,
			disableTouchListener: !showLabelTooltip,
			open: previewTooltipOpen ? true : void 0,
			slotProps: previewTooltipOpen ? {
				popper: {
					disablePortal: true,
					popperOptions: { strategy: "fixed" },
					modifiers: [{
						name: "flip",
						enabled: false
					}]
				},
				transition: { timeout: 0 }
			} : void 0,
			children: /* @__PURE__ */ jsx("span", {
				style: tooltipTriggerStyle,
				children: /* @__PURE__ */ jsxs(StyledButton, {
					ref: assignButtonRef,
					disableRipple: true,
					disableGutters: true,
					navVariant: variant,
					collapsed,
					selected,
					"aria-expanded": hasSubItems ? accordionOpen || flyoutOpen : void 0,
					"aria-haspopup": showFlyout ? "true" : void 0,
					"aria-label": accessibleName,
					"data-preview-state": previewState,
					...props,
					onMouseEnter: (event) => {
						onMouseEnter?.(event);
						openFlyoutHover();
					},
					onMouseLeave: (event) => {
						onMouseLeave?.(event);
						closeFlyoutHover();
					},
					onClick: (event) => {
						onClick?.(event);
						if (event.defaultPrevented || !hasSubItems || collapsed) return;
						if (!isControlled) setUncontrolledOpen((current) => !current);
					},
					children: [
						/* @__PURE__ */ jsxs("span", {
							style: iconLabelRow,
							children: [icon && variant === "primary" && /* @__PURE__ */ jsx(ListItemIcon, { children: icon }), /* @__PURE__ */ jsx("span", {
								className: "nav-item-label",
								"aria-hidden": labelHidden,
								children: label
							})]
						}),
						badge && /* @__PURE__ */ jsx("span", {
							className: "nav-item-badge",
							"aria-hidden": labelHidden,
							children: badge
						}),
						hasSubItems && /* @__PURE__ */ jsx("span", {
							className: "nav-item-trailing",
							"aria-hidden": labelHidden,
							children: accordionOpen ? /* @__PURE__ */ jsx(KeyboardArrowUp_default, { fontSize: "inherit" }) : /* @__PURE__ */ jsx(KeyboardArrowDown_default, { fontSize: "inherit" })
						})
					]
				})
			})
		}), hasSubItems && /* @__PURE__ */ jsxs(NavContext.Provider, {
			value: { collapsed: false },
			children: [/* @__PURE__ */ jsx(Collapse, {
				in: accordionOpen,
				timeout: 300,
				unmountOnExit: true,
				children: /* @__PURE__ */ jsx(SubItems, { children })
			}), showFlyout && /* @__PURE__ */ jsx(Popover$1, {
				className: "nav-item-flyout",
				open: flyoutOpen,
				anchorEl,
				elevation: 0,
				disablePortal: previewHover,
				disableAutoFocus: true,
				disableEnforceFocus: true,
				disableRestoreFocus: true,
				disableScrollLock: true,
				hideBackdrop: true,
				transitionDuration: previewHover ? 0 : 300,
				anchorOrigin: {
					vertical: "top",
					horizontal: "right"
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "left"
				},
				sx: {
					pointerEvents: "none",
					[`& .${popoverClasses.paper}`]: { pointerEvents: "auto" }
				},
				slotProps: { paper: {
					onMouseEnter: openFlyoutHover,
					onMouseLeave: closeFlyoutHover,
					sx: (theme) => {
						const { color, borderRadius, elevation, spacing, component } = theme.hephaestus;
						const navSection = component?.navSection;
						const flyoutFill = navPaperBackground(anchorEl, navSection?.backgroundColor ?? color.background);
						const flyoutShadow = `${elevation.high}, 0 16px 40px -16px rgba(0, 0, 0, 0.25)`;
						return {
							display: "flex",
							flexDirection: "column",
							gap: "2px",
							boxSizing: "border-box",
							width: 232,
							marginLeft: spacing.sm,
							padding: spacing.md,
							overflow: "visible",
							backgroundColor: flyoutFill,
							borderRadius: navSection?.radius ?? borderRadius.md,
							boxShadow: flyoutShadow,
							"&::before": {
								content: "\"\"",
								position: "absolute",
								right: "100%",
								top: 0,
								width: spacing.sm,
								height: "100%"
							}
						};
					}
				} },
				children: /* @__PURE__ */ jsx(SubItems, { children })
			})]
		})]
	});
});
//#endregion
//#region src/web/atoms/Pagination/Pagination.tsx
const hoverSelector$5 = "&:hover, &[data-preview-state=\"hover\"]";
const itemBox = {
	boxSizing: "border-box",
	display: "inline-flex",
	alignItems: "center",
	justifyContent: "center",
	margin: 0,
	padding: 0,
	minWidth: "24px",
	width: "24px",
	height: "24px",
	lineHeight: "24px"
};
const StyledPagination = styled$2(Pagination$1)(({ theme }) => resolveCssStyle(theme, { [`& .${paginationClasses.ul}`]: {
	gap: 0,
	padding: 0,
	flexWrap: "nowrap"
} }));
const PaginationItem = styled$2(PaginationItem$1)(({ theme }) => {
	const { color, font, component } = theme.hephaestus;
	const pagination = component?.pagination;
	return resolveCssStyle(theme, { "&&": {
		...itemBox,
		fontFamily: font.base,
		fontSize: "12px",
		fontWeight: 500,
		letterSpacing: 0,
		fontFeatureSettings: "\"lnum\" 1, \"tnum\" 1",
		textAlign: "center",
		color: color.onSurface,
		backgroundColor: "transparent",
		border: "none",
		borderRadius: "50%",
		overflow: "visible",
		[`&.${paginationItemClasses.sizeSmall}`]: itemBox,
		[`&.${paginationItemClasses.page}`]: itemBox,
		[`& .${paginationItemClasses.icon}`]: {
			margin: 0,
			fontSize: "12px"
		},
		[`&.${paginationItemClasses.page}, &.${paginationItemClasses.previousNext}, &.${paginationItemClasses.firstLast}`]: { [hoverSelector$5]: { backgroundColor: color.surfaceContainerVariant } },
		[`&.${paginationItemClasses.selected}`]: {
			...itemBox,
			fontWeight: 600,
			backgroundColor: color.primaryVariant,
			color: color.onSurface,
			[hoverSelector$5]: {
				backgroundColor: color.primaryVariantHover,
				color: color.onSurface
			}
		},
		[`&.${paginationItemClasses.disabled}`]: {
			color: color.disabled,
			opacity: 1
		},
		[`&.${paginationItemClasses.ellipsis}`]: {
			width: "24px",
			minWidth: "24px",
			height: "24px",
			color: color.onSurface,
			pointerEvents: "none",
			cursor: "default",
			backgroundColor: "transparent",
			[hoverSelector$5]: { backgroundColor: "transparent" }
		}
	} }, { "&&": {
		color: pagination?.item?.color,
		backgroundColor: pagination?.item?.backgroundColor,
		fontSize: pagination?.item?.fontSize,
		fontWeight: pagination?.item?.fontWeight,
		borderRadius: pagination?.item?.borderRadius,
		minWidth: pagination?.item?.minWidth,
		height: pagination?.item?.height,
		[`&:not(.${paginationItemClasses.ellipsis})`]: { [hoverSelector$5]: { backgroundColor: pagination?.item?.hoverBackgroundColor } },
		[`& .${paginationItemClasses.icon}`]: { fontSize: pagination?.navigation?.iconFontSize },
		[`&.${paginationItemClasses.selected}`]: {
			backgroundColor: pagination?.selectedItem?.backgroundColor,
			color: pagination?.selectedItem?.color,
			fontWeight: pagination?.selectedItem?.fontWeight,
			borderRadius: pagination?.selectedItem?.borderRadius,
			borderColor: pagination?.selectedItem?.borderColor,
			borderWidth: pagination?.selectedItem?.borderWidth,
			borderStyle: pagination?.selectedItem?.borderStyle,
			[hoverSelector$5]: { backgroundColor: pagination?.selectedItem?.hoverBackgroundColor }
		},
		[`&.${paginationItemClasses.ellipsis}`]: { color: pagination?.ellipsis?.color },
		[`&.${paginationItemClasses.previousNext}, &.${paginationItemClasses.firstLast}`]: {
			width: pagination?.navigation?.size,
			minWidth: pagination?.navigation?.size,
			height: pagination?.navigation?.size,
			borderRadius: pagination?.navigation?.borderRadius,
			color: pagination?.navigation?.color,
			backgroundColor: pagination?.navigation?.backgroundColor,
			[hoverSelector$5]: { backgroundColor: pagination?.navigation?.hoverBackgroundColor }
		}
	} });
});
const Pagination = forwardRef(({ color = "standard", variant = "text", size = "small", shape = "circular", siblingCount = 1, boundaryCount = 1, renderItem, ...props }, ref) => /* @__PURE__ */ jsx(StyledPagination, {
	ref,
	color,
	variant,
	size,
	shape,
	siblingCount,
	boundaryCount,
	renderItem: (item) => renderItem ? renderItem(item) : /* @__PURE__ */ jsx(PaginationItem, { ...item }),
	...props
}));
//#endregion
//#region src/web/atoms/Popover/Popover.tsx
const StyledPopover = styled$2(Popover$1)(({ theme }) => {
	const { color, borderRadius, elevation, spacing } = theme.hephaestus;
	const thinScrollbar = {
		scrollbarWidth: "thin",
		scrollbarColor: `${color.outlineVariant} transparent`,
		"&::-webkit-scrollbar": {
			width: 4,
			height: 4
		},
		"&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: color.outlineVariant,
			borderRadius: 4
		}
	};
	return resolveCssStyle(theme, {
		[`& .${popoverClasses.paper}`]: {
			backgroundColor: color.surface,
			borderRadius: borderRadius.lg,
			boxShadow: `${elevation.high}, 0 16px 40px -16px rgba(0, 0, 0, 0.25)`,
			overflow: "auto",
			marginTop: spacing.sm,
			...thinScrollbar
		},
		[`&[data-popover-opens-up='true'] .${popoverClasses.paper}`]: { marginTop: `-${spacing.sm}` }
	});
});
const Popover = forwardRef((props, ref) => {
	const transformOrigin = props.transformOrigin;
	const opensUp = transformOrigin != null && typeof transformOrigin === "object" && transformOrigin.vertical === "bottom";
	return /* @__PURE__ */ jsx(StyledPopover, {
		ref,
		elevation: 0,
		"data-popover-opens-up": opensUp ? "true" : void 0,
		...props
	});
});
//#endregion
//#region src/web/atoms/Radio/Radio.tsx
/** Figma medium is a 44px hit target around a 20px ring. Small scales the ring. */
const sizeMetrics$1 = {
	small: {
		hit: 32,
		icon: 16,
		dot: 8
	},
	medium: {
		hit: 44,
		icon: 20,
		dot: 10
	}
};
const hoverSelector$4 = "&:hover, &[data-preview-state=\"hover\"]";
const pressedSelector$2 = "&:active, &[data-preview-state=\"pressed\"]";
const focusedSelector$2 = "&.Mui-focusVisible, &[data-preview-state=\"focused\"]";
/**
* Figma radio ring + inner dot. Halo / hit target live on the SwitchBase
* root (44px), not this icon.
*/
const RadioIcon = ({ checked }) => /* @__PURE__ */ jsx("span", {
	className: "hephaestus-radio-icon",
	children: checked && /* @__PURE__ */ jsx("span", { className: "hephaestus-radio-dot" })
});
const StyledRadio = styled$2(Radio$1)(({ theme, size }) => {
	const { color: colorToken, component, borderRadius } = theme.hephaestus;
	const comp = component?.radio;
	const metrics = sizeMetrics$1[size ?? "medium"];
	const padding = (metrics.hit - metrics.icon) / 2;
	return resolveCssStyle(theme, {
		padding,
		color: "inherit",
		borderRadius: borderRadius.round,
		"& .hephaestus-radio-icon": {
			width: metrics.icon,
			height: metrics.icon,
			boxSizing: "border-box",
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			borderRadius: borderRadius.round,
			border: "2px solid",
			borderColor: colorToken.onSurface,
			backgroundColor: "transparent"
		},
		"& .hephaestus-radio-dot": {
			width: metrics.dot,
			height: metrics.dot,
			borderRadius: borderRadius.round,
			backgroundColor: colorToken.primary
		},
		"&.Mui-checked .hephaestus-radio-icon": { borderColor: colorToken.primary },
		[hoverSelector$4]: { backgroundColor: colorToken.neutralHover },
		"&.Mui-checked:hover, &.Mui-checked[data-preview-state=\"hover\"]": { backgroundColor: colorToken.primaryVariant },
		[pressedSelector$2]: { backgroundColor: colorToken.primaryVariant },
		"&.Mui-checked:active, &.Mui-checked[data-preview-state=\"pressed\"]": { backgroundColor: colorToken.neutralHover },
		[focusedSelector$2]: {
			backgroundColor: colorToken.neutralHover,
			outline: `2px solid ${colorToken.focus}`,
			outlineOffset: 2
		},
		"&.Mui-checked.Mui-focusVisible, &.Mui-checked[data-preview-state=\"focused\"]": { backgroundColor: colorToken.primaryVariant },
		"&.Mui-disabled": { opacity: 1 },
		"&.Mui-disabled .hephaestus-radio-icon": { borderColor: colorToken.onDisabled },
		"&.Mui-disabled .hephaestus-radio-dot": { backgroundColor: colorToken.disabled },
		"&.Mui-disabled:hover, &.Mui-disabled[data-preview-state=\"hover\"], &.Mui-disabled:active, &.Mui-disabled[data-preview-state=\"pressed\"], &.Mui-disabled.Mui-focusVisible, &.Mui-disabled[data-preview-state=\"focused\"]": {
			backgroundColor: "transparent",
			outline: "none"
		}
	}, {
		"& .hephaestus-radio-icon": { borderColor: comp?.defaultColor },
		"& .hephaestus-radio-dot": { backgroundColor: comp?.activeColor },
		"&.Mui-checked .hephaestus-radio-icon": { borderColor: comp?.activeColor },
		"&.Mui-disabled .hephaestus-radio-icon": { borderColor: comp?.disabledColor },
		"&.Mui-disabled .hephaestus-radio-dot": { backgroundColor: comp?.disabledColor }
	});
});
const Radio = forwardRef((props, ref) => /* @__PURE__ */ jsx(StyledRadio, {
	...props,
	ref,
	disableRipple: true,
	focusVisibleClassName: "Mui-focusVisible",
	icon: /* @__PURE__ */ jsx(RadioIcon, {}),
	checkedIcon: /* @__PURE__ */ jsx(RadioIcon, { checked: true })
}));
//#endregion
//#region src/web/atoms/Radio/RadioGroup.tsx
const RadioGroup = styled$2(RadioGroup$1)(({ theme }) => {
	const { spacing } = theme.hephaestus;
	return resolveCssStyle(theme, {
		gap: 0,
		"&.MuiRadioGroup-row": { gap: spacing.xxl }
	});
});
//#endregion
//#region src/web/atoms/SecondaryTab/SecondaryTab.tsx
const TAB_HEIGHT$1 = "40px";
const SecondaryTab = styled$2(Tab$1)(({ theme }) => {
	const { color, spacing, font } = theme.hephaestus;
	return resolveCssStyle(theme, {
		minHeight: TAB_HEIGHT$1,
		height: TAB_HEIGHT$1,
		minWidth: spacing.xxl,
		padding: 0,
		marginLeft: spacing.md,
		marginRight: spacing.md,
		textTransform: "none",
		whiteSpace: "nowrap",
		fontFamily: font.base,
		fontSize: "12px",
		fontWeight: 500,
		lineHeight: "16px",
		letterSpacing: "0.25px",
		color: color.onSurfaceVariant,
		opacity: 1,
		backgroundColor: "transparent",
		borderRadius: 0,
		transition: theme.transitions.create(["color"]),
		[`&.${tabClasses.labelIcon}`]: { minHeight: TAB_HEIGHT$1 },
		[`& .${tabClasses.icon}`]: { margin: 0 },
		"&:hover": {
			color: color.onSurface,
			backgroundColor: "transparent"
		},
		[`&.${tabClasses.selected}`]: {
			color: color.primary,
			backgroundColor: "transparent",
			opacity: 1,
			"&:hover": {
				color: color.primary,
				backgroundColor: "transparent"
			}
		},
		"&.Mui-disabled": {
			color: color.disabled,
			backgroundColor: "transparent",
			opacity: 1
		},
		"&.Mui-focusVisible": {
			outline: `2px solid ${color.focus}`,
			outlineOffset: 2
		}
	});
});
const StyledSecondaryTabs = styled$2(Tabs$1)(({ theme }) => {
	const { color, spacing } = theme.hephaestus;
	return resolveCssStyle(theme, {
		minWidth: 0,
		minHeight: spacing.xxl,
		[`& .${tabsClasses.indicator}`]: { backgroundColor: color.primary },
		[`& .${tabsClasses.scrollButtons}`]: {
			color: color.onSurfaceVariant,
			flexShrink: 0
		}
	});
});
const SecondaryTabs = forwardRef(({ children, variant = "scrollable", scrollButtons = "auto", ...props }, ref) => /* @__PURE__ */ jsx(StyledSecondaryTabs, {
	ref,
	"data-testid": "tabs",
	variant,
	scrollButtons,
	allowScrollButtonsMobile: true,
	...props,
	children
}));
//#endregion
//#region src/web/atoms/Select/Select.tsx
const filledCheckMask = `url("data:image/svg+xml,${encodeURIComponent("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\"/></svg>")}")`;
const filledSelector = "&[data-variant=\"filled\"]";
const filledHoverSelector = `${filledSelector}:hover:not(.Mui-disabled), ${filledSelector}[data-preview-state="hover"]`;
const filledPressedSelector = `${filledSelector}:active:not(.Mui-disabled), ${filledSelector}[data-preview-state="pressed"]`;
const filledFocusedSelector = `${filledSelector}.Mui-focused, ${filledSelector}[data-preview-state="focused"]`;
const SelectInput = styled$2(Input)(({ theme }) => {
	const { color: colorToken, borderRadius, component, spacing } = theme.hephaestus;
	const comp = component?.textField;
	const iconSlot = `calc(16px + ${spacing.lg})`;
	const filledIconSlot = `calc(16px + ${spacing.md} + ${spacing.sm})`;
	return resolveCssStyle(theme, {
		[`&:has(.${selectClasses.multiple})`]: { height: "auto" },
		[`& .${selectClasses.select}`]: { paddingRight: iconSlot },
		[`&:has(.${selectClasses.multiple}) .${selectClasses.select}`]: {
			paddingTop: 0,
			paddingBottom: 0,
			display: "flex",
			alignItems: "center",
			flexWrap: "wrap"
		},
		[`& .${selectClasses.select}:focus`]: { backgroundColor: "transparent" },
		[`& .${selectClasses.icon}`]: {
			color: colorToken.onSurfaceVariant,
			fontSize: 16,
			width: 16,
			height: 16,
			right: spacing.lg,
			top: "50%",
			transform: "translateY(-50%)"
		},
		[`& .${selectClasses.iconOpen}`]: { transform: "translateY(-50%) rotate(180deg)" },
		"&.Mui-error:not(.Mui-disabled) .MuiSelect-icon": { color: colorToken.negative },
		"&.MuiInputBase-colorSuccess .MuiSelect-icon": { color: colorToken.positive },
		"&.Mui-disabled .MuiSelect-icon": { color: colorToken.disabled },
		[filledSelector]: {
			width: "max-content",
			minWidth: "unset",
			height: "32px",
			minHeight: "32px",
			paddingLeft: spacing.lg,
			paddingRight: spacing.md,
			gap: spacing.sm,
			fontSize: "14px",
			fontWeight: 500,
			lineHeight: "20px",
			color: colorToken.onSurface,
			backgroundColor: colorToken.surfaceContainerVariant,
			border: "none",
			borderRadius: borderRadius.md,
			boxShadow: "none"
		},
		[`${filledSelector}.MuiInputBase-fullWidth`]: { width: "100%" },
		[`${filledSelector} .${selectClasses.select}`]: { paddingRight: filledIconSlot },
		[`${filledSelector} .${selectClasses.icon}`]: {
			color: colorToken.onSurface,
			right: spacing.md
		},
		[filledHoverSelector]: {
			backgroundColor: colorToken.neutralHover,
			border: "none"
		},
		[filledPressedSelector]: {
			backgroundColor: colorToken.neutralPressed,
			border: "none"
		},
		[filledFocusedSelector]: {
			border: "none",
			outline: `2px solid ${colorToken.focus}`,
			outlineOffset: 2
		},
		[`${filledSelector}.Mui-disabled`]: {
			backgroundColor: colorToken.surfaceContainerVariant,
			color: colorToken.onDisabled,
			border: "none"
		},
		[`${filledSelector}.Mui-disabled .${selectClasses.select}`]: {
			WebkitTextFillColor: colorToken.onDisabled,
			color: colorToken.onDisabled
		},
		[`${filledSelector}.Mui-disabled .MuiSelect-icon`]: { color: colorToken.onDisabled }
	}, {
		"&.Mui-error:not(.Mui-disabled) .MuiSelect-icon": { color: comp?.errorColor },
		"&.MuiInputBase-colorSuccess .MuiSelect-icon": { color: comp?.successColor },
		"&.Mui-disabled .MuiSelect-icon": { color: comp?.disabledColor },
		[filledSelector]: { border: "none" }
	});
});
const buildMenuProps = (theme, menuProps, variant) => {
	const { color, borderRadius, elevation, spacing, component } = theme.hephaestus;
	const { sx, ...rest } = menuProps ?? {};
	const filled = variant === "filled";
	const inputBorderRadius = component?.textField?.borderRadius ?? borderRadius.sm;
	const itemHover = `& .${menuItemClasses.root}:hover, & .${menuItemClasses.root}[data-preview-state="hover"], & .${menuItemClasses.root}.${menuItemClasses.focusVisible}`;
	const selectedOption = `& .${menuItemClasses.root}[role="option"].${menuItemClasses.selected}`;
	return {
		elevation: 0,
		...rest,
		sx: [{
			[`& .${menuClasses.paper}`]: filled ? {
				backgroundColor: color.surfaceContainer,
				borderRadius: borderRadius.md,
				boxShadow: `${elevation.high}, 0 12px 32px -16px rgba(0, 0, 0, 0.2)`,
				overflow: "hidden",
				marginTop: spacing.sm
			} : {
				backgroundColor: color.surface,
				borderRadius: inputBorderRadius,
				boxShadow: `${elevation.high}, 0 16px 40px -16px rgba(0, 0, 0, 0.25)`,
				overflow: "hidden",
				marginTop: spacing.sm
			},
			[`& .${menuClasses.list}, & .${listClasses.root}`]: { padding: 0 },
			...!filled && { [`& .${menuItemClasses.root}`]: {
				"&:first-of-type": {
					borderTopLeftRadius: inputBorderRadius,
					borderTopRightRadius: inputBorderRadius
				},
				"&:last-of-type": {
					borderBottomLeftRadius: inputBorderRadius,
					borderBottomRightRadius: inputBorderRadius
				}
			} },
			...filled && {
				[`& .${menuItemClasses.root}`]: {
					minHeight: 32,
					height: 32,
					paddingTop: 0,
					paddingBottom: 0,
					paddingLeft: spacing.lg,
					paddingRight: spacing.lg,
					backgroundColor: "transparent",
					"&:first-of-type, &:last-of-type": { borderRadius: 0 }
				},
				[itemHover]: { backgroundColor: color.surfaceContainerVariant },
				[selectedOption]: { backgroundColor: "transparent" },
				[`${selectedOption}:hover, ${selectedOption}[data-preview-state="hover"], ${selectedOption}.${menuItemClasses.focusVisible}`]: { backgroundColor: color.surfaceContainerVariant },
				[`${selectedOption}::after`]: {
					content: "\"\"",
					display: "block",
					width: 16,
					height: 16,
					marginLeft: "auto",
					flexShrink: 0,
					backgroundColor: color.onSurface,
					maskImage: filledCheckMask,
					WebkitMaskImage: filledCheckMask,
					maskRepeat: "no-repeat",
					WebkitMaskRepeat: "no-repeat",
					maskSize: "contain",
					WebkitMaskSize: "contain"
				}
			}
		}, ...Array.isArray(sx) ? sx : [sx]]
	};
};
const Select = forwardRef(({ MenuProps, variant = "standard", ...props }, ref) => {
	const theme = useTheme$1();
	return /* @__PURE__ */ jsx(Select$1, {
		variant: "standard",
		IconComponent: ArrowDropDown_default$1,
		...props,
		input: /* @__PURE__ */ jsx(SelectInput, { "data-variant": variant }),
		"data-variant": variant,
		ref,
		MenuProps: buildMenuProps(theme, MenuProps, variant)
	});
});
//#endregion
//#region src/web/atoms/Snackbar/SnackbarContent.tsx
const defaultIcons = {
	info: /* @__PURE__ */ jsx(InfoOutlined_default$1, { fontSize: "inherit" }),
	success: /* @__PURE__ */ jsx(CheckCircle_default, { fontSize: "inherit" }),
	warning: /* @__PURE__ */ jsx(Warning_default, { fontSize: "inherit" }),
	error: /* @__PURE__ */ jsx(Error_default, { fontSize: "inherit" })
};
const defaultToastStyle = (color, severity) => {
	switch (severity) {
		case "info": return {
			iconColor: color.primary,
			backgroundColor: color.supportOneNewVariant,
			titleColor: color.onSurface,
			descriptionColor: color.onPrimaryVariant
		};
		case "success": return {
			iconColor: color.positive,
			backgroundColor: color.positiveVariant,
			titleColor: color.onSurface,
			descriptionColor: color.onPositiveVariant
		};
		case "warning": return {
			iconColor: color.warning,
			backgroundColor: color.warningVariant,
			titleColor: color.onSurface,
			descriptionColor: color.onWarningVariant
		};
		case "error": return {
			iconColor: color.negative,
			backgroundColor: color.negativeVariant,
			titleColor: color.onSurface,
			descriptionColor: color.onNegativeVariant
		};
	}
};
const IconSlot = styled$2("div", { shouldForwardProp: (prop) => prop !== "severity" })(({ theme, severity }) => {
	const { color } = theme.hephaestus;
	const defaults = defaultToastStyle(color, severity);
	return resolveCssStyle(theme, {
		display: "flex",
		alignItems: "flex-start",
		flexShrink: 0,
		padding: `${theme.hephaestus.spacing.sm} 0`,
		fontSize: 16,
		lineHeight: 0,
		color: defaults.iconColor,
		"& .MuiSvgIcon-root": {
			fontSize: 16,
			color: "inherit"
		}
	});
});
const Root$1 = styled$2("div", { shouldForwardProp: (prop) => prop !== "severity" })(({ theme, severity }) => {
	const { color, borderRadius, elevation, font } = theme.hephaestus;
	const defaults = defaultToastStyle(color, severity);
	return resolveCssStyle(theme, {
		display: "inline-flex",
		flexDirection: "column",
		position: "relative",
		minWidth: 345,
		maxWidth: "100%",
		overflow: "hidden",
		borderRadius: borderRadius.lg,
		backgroundColor: defaults.backgroundColor,
		color: defaults.titleColor,
		boxShadow: `${elevation.high}, 0 16px 40px -16px rgba(0, 0, 0, 0.25)`,
		fontFamily: font.base
	});
});
const Inner = styled$2("div")(({ theme }) => {
	const { spacing } = theme.hephaestus;
	return resolveCssStyle(theme, {
		display: "flex",
		alignItems: "flex-start",
		gap: spacing.lg,
		padding: `${spacing.lg} ${spacing.xl}`
	});
});
const deplete = keyframes`
  from { transform: scaleX(1); }
  to { transform: scaleX(0); }
`;
const SnackbarProgress = ({ severity, progress, autoClose, isPaused }) => {
	const { color } = useTheme$1().hephaestus;
	const defaults = defaultToastStyle(color, severity);
	const isDeterminate = typeof progress === "number";
	const countdownMs = !isDeterminate && typeof autoClose === "number" && autoClose > 0 ? autoClose : void 0;
	if (!isDeterminate && countdownMs === void 0) return null;
	return /* @__PURE__ */ jsx(LinearProgress, {
		size: "small",
		variant: "determinate",
		value: isDeterminate ? progress : 100,
		"data-paused": isPaused ? "" : void 0,
		sx: {
			position: "absolute",
			top: 0,
			left: 0,
			right: 0,
			zIndex: 1,
			borderRadius: 0,
			backgroundColor: "transparent",
			[`& .${linearProgressClasses.bar}`]: {
				borderRadius: 0,
				backgroundColor: defaults.iconColor,
				transformOrigin: "left center",
				...countdownMs ? { animation: `${deplete} ${countdownMs}ms linear forwards` } : {}
			},
			...countdownMs ? { [`&[data-paused] .${linearProgressClasses.bar}`]: { animationPlayState: "paused" } } : {}
		}
	});
};
const Body = styled$2("div")(({ theme }) => resolveCssStyle(theme, {
	display: "flex",
	flexDirection: "column",
	flex: "1 1 auto"
}));
const Message = styled$2("p")(({ theme }) => {
	const { font } = theme.hephaestus;
	return resolveCssStyle(theme, {
		margin: 0,
		whiteSpace: "nowrap",
		fontFamily: font.base,
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "20px",
		letterSpacing: "0.25px"
	});
});
const Description = styled$2("p", { shouldForwardProp: (prop) => prop !== "severity" })(({ theme, severity }) => {
	const { font, color } = theme.hephaestus;
	const defaults = defaultToastStyle(color, severity);
	return resolveCssStyle(theme, {
		margin: 0,
		width: 0,
		minWidth: "100%",
		whiteSpace: "normal",
		overflowWrap: "break-word",
		color: defaults.descriptionColor,
		fontFamily: font.base,
		fontSize: "12px",
		fontWeight: 500,
		lineHeight: "16px",
		letterSpacing: "0.25px"
	});
});
const TopRow = styled$2("div")(({ theme }) => resolveCssStyle(theme, {
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	gap: 8,
	minHeight: 24,
	width: "100%"
}));
const Actions = styled$2("div")(({ theme }) => resolveCssStyle(theme, {
	display: "flex",
	alignItems: "center",
	flexShrink: 0,
	alignSelf: "flex-start"
}));
const actionSx = {
	height: 24,
	minHeight: 24,
	minWidth: 0,
	padding: "2px 4px",
	fontSize: "14px",
	fontWeight: 600,
	lineHeight: "20px",
	letterSpacing: "0.25px",
	color: "inherit"
};
const SnackbarContent = forwardRef(({ severity = "info", message, description, actionLabel, onAction, onClose, icon, progress, autoClose, isPaused, className, style, sx, "data-testid": dataTestId }, ref) => {
	const showActions = Boolean(actionLabel) || Boolean(onClose);
	return /* @__PURE__ */ jsxs(Root$1, {
		ref,
		className,
		style,
		severity,
		role: "alert",
		"data-testid": dataTestId ?? "snackbar-content",
		sx,
		children: [/* @__PURE__ */ jsx(SnackbarProgress, {
			severity,
			progress,
			autoClose,
			isPaused
		}), /* @__PURE__ */ jsxs(Inner, { children: [icon !== false && /* @__PURE__ */ jsx(IconSlot, {
			severity,
			children: icon ?? defaultIcons[severity]
		}), /* @__PURE__ */ jsxs(Body, { children: [/* @__PURE__ */ jsxs(TopRow, { children: [/* @__PURE__ */ jsx(Message, { children: message }), showActions && /* @__PURE__ */ jsxs(Actions, { children: [actionLabel && /* @__PURE__ */ jsx(Button, {
			type: "button",
			variant: "text",
			onClick: onAction,
			sx: actionSx,
			children: actionLabel
		}), onClose && /* @__PURE__ */ jsx(IconButton, {
			size: "xsmall",
			"aria-label": "close",
			onClick: onClose,
			children: /* @__PURE__ */ jsx(Close_default$1, { fontSize: "inherit" })
		})] })] }), description != null && description !== "" && /* @__PURE__ */ jsx(Description, {
			severity,
			children: description
		})] })] })]
	});
});
//#endregion
//#region src/web/atoms/Snackbar/Snackbar.tsx
const Snackbar = forwardRef(({ autoHideDuration = 5e3, severity = "info", message, description, actionLabel, onAction, icon, progress, children, contentSx, dismissible = true, onClose, ...props }, ref) => {
	const content = children ?? /* @__PURE__ */ jsx(SnackbarContent, {
		severity,
		message,
		description,
		actionLabel,
		onAction,
		icon,
		progress,
		autoClose: autoHideDuration ?? false,
		sx: contentSx,
		onClose: onClose && dismissible ? (event) => {
			onClose(event, "closeClick");
		} : void 0
	});
	return /* @__PURE__ */ jsx(Snackbar$1, {
		ref,
		"data-testid": "snackbar",
		anchorOrigin: {
			vertical: "bottom",
			horizontal: "left"
		},
		...props,
		autoHideDuration,
		onClose,
		children: content
	});
});
//#endregion
//#region src/web/atoms/StatusChip/StatusChip.tsx
const STATUS_TO_COLOR = {
	neutral: "default",
	info: "info",
	positive: "success",
	warning: "warning",
	negative: "error"
};
const StatusChip = forwardRef(({ label, variant = "neutral", "data-testid": dataTestId }, ref) => /* @__PURE__ */ jsx(Chip, {
	ref,
	label,
	color: STATUS_TO_COLOR[variant],
	size: "small",
	clickable: false,
	"data-testid": dataTestId
}));
//#endregion
//#region src/web/atoms/Typography/Typography.tsx
const defaultTokens = {
	displayLarge: {
		fontKey: "base",
		fontSize: "40px",
		fontWeight: 600,
		lineHeight: "48px",
		letterSpacing: "0px"
	},
	displayLargeVariant: {
		fontKey: "baseVariant",
		fontSize: "40px",
		fontWeight: 400,
		lineHeight: "48px",
		letterSpacing: "0px"
	},
	displayMedium: {
		fontKey: "base",
		fontSize: "32px",
		fontWeight: 600,
		lineHeight: "40px",
		letterSpacing: "0px"
	},
	displayMediumVariant: {
		fontKey: "baseVariant",
		fontSize: "32px",
		fontWeight: 400,
		lineHeight: "40px",
		letterSpacing: "0px"
	},
	displaySmall: {
		fontKey: "baseVariant",
		fontSize: "24px",
		fontWeight: 500,
		lineHeight: "32px",
		letterSpacing: "0px"
	},
	headingLarge: {
		fontKey: "h3",
		fontSize: "24px",
		fontWeight: 600,
		lineHeight: "32px",
		letterSpacing: "0px"
	},
	headingMedium: {
		fontKey: "h3",
		fontSize: "24px",
		fontWeight: 600,
		lineHeight: "32px",
		letterSpacing: "0px"
	},
	headingSmall: {
		fontKey: "h3",
		fontSize: "20px",
		fontWeight: 600,
		lineHeight: "28px",
		letterSpacing: "0px"
	},
	headingXSmall: {
		fontKey: "h4",
		fontSize: "16px",
		fontWeight: 600,
		lineHeight: "24px",
		letterSpacing: "0.25px"
	},
	headingOverline: {
		fontKey: "h4",
		fontSize: "11px",
		fontWeight: 600,
		lineHeight: "14px",
		letterSpacing: "0.25px"
	},
	titleLarge: {
		fontKey: "base",
		fontSize: "20px",
		fontWeight: 600,
		lineHeight: "28px",
		letterSpacing: "0.25px"
	},
	titleMedium: {
		fontKey: "base",
		fontSize: "16px",
		fontWeight: 600,
		lineHeight: "24px",
		letterSpacing: "0.25px"
	},
	bodyLarge: {
		fontKey: "base",
		fontSize: "16px",
		fontWeight: 400,
		lineHeight: "24px",
		letterSpacing: "0.25px"
	},
	bodyMedium: {
		fontKey: "base",
		fontSize: "14px",
		fontWeight: 400,
		lineHeight: "20px",
		letterSpacing: "0.25px"
	},
	bodySmall: {
		fontKey: "base",
		fontSize: "12px",
		fontWeight: 400,
		lineHeight: "16px",
		letterSpacing: "0.25px"
	},
	labelLarge: {
		fontKey: "base",
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "20px",
		letterSpacing: "0.25px"
	},
	labelSmall: {
		fontKey: "base",
		fontSize: "12px",
		fontWeight: 500,
		lineHeight: "16px",
		letterSpacing: "0.25px"
	},
	button: {
		fontKey: "base",
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "24px",
		letterSpacing: "1px"
	},
	trimmedXSmall: {
		fontKey: "base",
		fontSize: "8px",
		fontWeight: 500,
		lineHeight: "12px",
		letterSpacing: "1px"
	},
	trimmedSmall: {
		fontKey: "base",
		fontSize: "12px",
		fontWeight: 500,
		lineHeight: "16px",
		letterSpacing: "1px"
	},
	trimmedNormal: {
		fontKey: "base",
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "20px",
		letterSpacing: "1px"
	},
	trimmedMedium: {
		fontKey: "base",
		fontSize: "16px",
		fontWeight: 500,
		lineHeight: "24px",
		letterSpacing: "1px"
	},
	trimmedLarge: {
		fontKey: "base",
		fontSize: "20px",
		fontWeight: 500,
		lineHeight: "32px",
		letterSpacing: "1px"
	},
	monospacedXlarge: {
		fontKey: "base",
		fontSize: "16px",
		fontWeight: 500,
		lineHeight: "24px",
		letterSpacing: "1px"
	},
	monospacedLarge: {
		fontKey: "base",
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "20px",
		letterSpacing: "1px"
	},
	monospacedSmall: {
		fontKey: "base",
		fontSize: "12px",
		fontWeight: 500,
		lineHeight: "16px",
		letterSpacing: "1px"
	}
};
const htmlComponentMapping = {
	displayLarge: "h1",
	displayLargeVariant: "h1",
	displayMedium: "p",
	displayMediumVariant: "h1",
	displaySmall: "p",
	headingLarge: "h1",
	headingMedium: "h2",
	headingSmall: "h3",
	headingXSmall: "h4",
	headingOverline: "span",
	titleLarge: "h3",
	titleMedium: "h4",
	bodyLarge: "p",
	bodyMedium: "p",
	bodySmall: "span",
	labelLarge: "span",
	labelSmall: "span",
	button: "span",
	trimmedXSmall: "span",
	trimmedSmall: "span",
	trimmedNormal: "p",
	trimmedMedium: "p",
	trimmedLarge: "p",
	monospacedXlarge: "p",
	monospacedLarge: "p",
	monospacedSmall: "span"
};
const resolveFontFamily = (font, fontKey) => font[fontKey] ?? font.base ?? "";
const StyledTypography = styled$2(Typography$1, { shouldForwardProp: (prop) => prop !== "tokenVariant" })(({ theme, tokenVariant = "bodyMedium", color }) => {
	const { color: colorToken, font, component } = theme.hephaestus;
	const defaults = defaultTokens[tokenVariant];
	const override = component?.typography?.[tokenVariant];
	return resolveCssStyle(theme, {
		fontFamily: resolveFontFamily(font, defaults.fontKey),
		fontWeight: defaults.fontWeight,
		letterSpacing: defaults.letterSpacing,
		textTransform: "none",
		fontSize: defaults.fontSize,
		lineHeight: defaults.lineHeight,
		...(color === void 0 || color === null) && { color: colorToken.onSurface }
	}, {
		fontFamily: override?.fontFamily,
		fontWeight: override?.fontWeight,
		letterSpacing: override?.letterSpacing,
		textTransform: override?.textTransform,
		fontSize: override?.fontSize,
		lineHeight: override?.lineHeight,
		...(color === void 0 || color === null) && { color: override?.color }
	});
});
const Typography = forwardRef(({ variant = "bodyMedium", component, ...props }, ref) => /* @__PURE__ */ jsx(StyledTypography, {
	ref,
	tokenVariant: variant,
	...props,
	variant: "inherit",
	component: component ?? htmlComponentMapping[variant]
}));
//#endregion
//#region src/web/atoms/Stepper/Stepper.tsx
const CURRENT_BAR_WIDTH_PX = 219;
const STEP_DOT_SIZE_PX = 6;
const DEFAULT_CURRENT = 1;
const DEFAULT_VALUE = 32;
const Root = styled$2("div")(({ theme }) => {
	const { spacing } = theme.hephaestus;
	return resolveCssStyle(theme, {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: spacing.md
	});
});
const Steps = styled$2("div")(({ theme }) => {
	const { spacing } = theme.hephaestus;
	return resolveCssStyle(theme, {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		gap: spacing.md
	});
});
const StepSlot = styled$2("div")(({ theme }) => {
	const { color, borderRadius, component } = theme.hephaestus;
	const tokens = component?.basicStepper;
	const completeColor = tokens?.color ?? color.primary;
	const trackColor = tokens?.containerColor ?? color.surfaceContainerVariant;
	const motion = theme.transitions.create([
		"width",
		"background-color",
		"border-radius"
	], {
		duration: theme.transitions.duration.complex,
		easing: theme.transitions.easing.easeInOut
	});
	return resolveCssStyle(theme, {
		boxSizing: "border-box",
		flexShrink: 0,
		height: STEP_DOT_SIZE_PX,
		overflow: "hidden",
		transition: motion,
		"@media (prefers-reduced-motion: reduce)": { transition: "none" },
		"&[data-state=\"complete\"]": {
			width: STEP_DOT_SIZE_PX,
			borderRadius: borderRadius.round,
			backgroundColor: color.primary
		},
		"&[data-state=\"upcoming\"]": {
			width: STEP_DOT_SIZE_PX,
			borderRadius: borderRadius.round,
			backgroundColor: color.surfaceContainerVariant
		},
		"&[data-state=\"current\"]": {
			width: CURRENT_BAR_WIDTH_PX,
			borderRadius: borderRadius.sm,
			backgroundColor: color.surfaceContainerVariant
		}
	}, {
		"&[data-state=\"complete\"]": { backgroundColor: completeColor },
		"&[data-state=\"upcoming\"]": { backgroundColor: trackColor },
		"&[data-state=\"current\"]": { backgroundColor: trackColor }
	});
});
const CurrentBar = styled$2(LinearProgress)(({ theme }) => {
	const { color, component } = theme.hephaestus;
	const tokens = component?.basicStepper;
	return resolveCssStyle(theme, {
		width: "100%",
		height: STEP_DOT_SIZE_PX,
		backgroundColor: color.surfaceContainerVariant,
		[`& .${linearProgressClasses.bar}`]: { backgroundColor: color.primary }
	}, {
		backgroundColor: tokens?.containerColor,
		[`& .${linearProgressClasses.bar}`]: { backgroundColor: tokens?.color }
	});
});
const stepState = (step, current) => {
	if (step < current) return "complete";
	if (step === current) return "current";
	return "upcoming";
};
const Stepper = forwardRef(({ total, current = DEFAULT_CURRENT, value = DEFAULT_VALUE, title, ...props }, ref) => {
	if (!(total > 0) || !(current > 0)) return null;
	const clampedValue = Math.min(100, Math.max(0, value));
	const countLabel = `${current}/${total}`;
	const trimmedTitle = title?.trim() ?? "";
	const accessibleName = trimmedTitle ? `${trimmedTitle} ${countLabel}` : countLabel;
	return /* @__PURE__ */ jsxs(Root, {
		ref,
		role: "progressbar",
		"aria-label": accessibleName,
		"aria-valuemin": 1,
		"aria-valuenow": current,
		"aria-valuemax": total,
		"aria-valuetext": countLabel,
		...props,
		children: [
			trimmedTitle && /* @__PURE__ */ jsx(Typography, {
				variant: "labelLarge",
				color: "textSecondary",
				children: trimmedTitle
			}),
			/* @__PURE__ */ jsx(Typography, {
				variant: "labelLarge",
				color: "textSecondary",
				children: countLabel
			}),
			/* @__PURE__ */ jsx(Steps, { children: Array.from({ length: total }, (_, index) => {
				const step = index + 1;
				const state = stepState(step, current);
				return /* @__PURE__ */ jsx(StepSlot, {
					"data-state": state,
					"aria-hidden": true,
					children: state === "current" && /* @__PURE__ */ jsx(CurrentBar, {
						variant: "determinate",
						value: clampedValue,
						"aria-hidden": true,
						"data-testid": void 0
					})
				}, index);
			}) })
		]
	});
});
//#endregion
//#region src/web/atoms/Switch/Switch.tsx
const sizeMetrics = {
	small: {
		width: 28,
		height: 16,
		thumb: 12,
		translateX: 12
	},
	medium: {
		width: 44,
		height: 24,
		thumb: 20,
		translateX: 20
	}
};
const StyledSwitch = styled$2(Switch$1)(({ theme, size }) => {
	const { color: colorToken, component, borderRadius } = theme.hephaestus;
	const comp = component?.switch;
	const metrics = sizeMetrics[size ?? "medium"];
	return resolveCssStyle(theme, {
		width: metrics.width,
		height: metrics.height,
		padding: 0,
		overflow: "visible",
		borderRadius: borderRadius.round,
		"& .MuiSwitch-switchBase": {
			padding: 0,
			margin: 2,
			transitionDuration: "300ms",
			color: colorToken.onPrimary,
			"&:hover": { backgroundColor: "transparent" },
			"&.Mui-checked": {
				transform: `translateX(${metrics.translateX}px)`,
				color: colorToken.onPrimary
			},
			"&.Mui-disabled": { color: colorToken.onDisabled },
			"&.Mui-checked.Mui-disabled": { color: colorToken.onDisabled }
		},
		"&:has(.MuiSwitch-switchBase.Mui-focusVisible), &[data-preview-state=\"focused\"]": {
			outline: `2px solid ${colorToken.focus}`,
			outlineOffset: 2
		},
		"& .MuiSwitch-thumb": {
			boxShadow: "none",
			width: metrics.thumb,
			height: metrics.thumb,
			backgroundColor: "currentColor"
		},
		"& .MuiSwitch-track": {
			borderRadius: borderRadius.round,
			backgroundColor: colorToken.onSurfaceVariant,
			opacity: 1
		},
		"& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
			backgroundColor: colorToken.primary,
			opacity: 1
		},
		"& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track": {
			backgroundColor: colorToken.disabled,
			opacity: 1
		},
		"& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
			backgroundColor: colorToken.disabled,
			opacity: 1
		}
	}, {
		"& .MuiSwitch-switchBase": {
			"&.Mui-disabled": { color: comp?.onDisabled },
			"&.Mui-checked.Mui-disabled": { color: comp?.onDisabled }
		},
		"& .MuiSwitch-track": { backgroundColor: comp?.offColor ?? comp?.onContainer },
		"& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: comp?.onColor },
		"& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track": { backgroundColor: comp?.disabledColor },
		"& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": { backgroundColor: comp?.disabledColor }
	});
});
const Switch = forwardRef((props, ref) => /* @__PURE__ */ jsx(StyledSwitch, {
	...props,
	ref,
	disableRipple: true,
	focusVisibleClassName: "Mui-focusVisible"
}));
//#endregion
//#region src/web/atoms/Table/Table.tsx
const Table = styled$2(Table$1)(({ theme }) => resolveCssStyle(theme, {
	width: "100%",
	borderCollapse: "separate",
	borderSpacing: 0,
	backgroundColor: theme.hephaestus.color.surface
}));
//#endregion
//#region src/web/atoms/Table/TableCell.tsx
const headHoverSelector = "&:hover, &[data-preview-state=\"hover\"]";
const rowHoverSelector = `.${tableRowClasses.root}:hover &, .${tableRowClasses.root}[data-preview-state="hover"] &`;
const TableCell = styled$2(TableCell$1)(({ theme }) => {
	const { color, font, component } = theme.hephaestus;
	const table = component?.table;
	return resolveCssStyle(theme, {
		fontFamily: font.base,
		fontFeatureSettings: "\"lnum\" 1, \"tnum\" 1",
		letterSpacing: "0.25px",
		verticalAlign: "middle",
		boxSizing: "border-box",
		borderBottom: `1px solid ${color.outlineVariant}`,
		backgroundColor: color.surface,
		color: color.onSurface,
		fontSize: "14px",
		fontWeight: 400,
		lineHeight: "20px",
		padding: "14px 16px",
		height: "48px",
		[`&.${tableCellClasses.head}`]: {
			backgroundColor: color.background,
			color: color.onSurfaceVariant,
			fontSize: "12px",
			fontWeight: 600,
			lineHeight: "16px",
			padding: "16px",
			height: "48px",
			borderBottom: "none",
			[headHoverSelector]: {
				backgroundColor: color.neutralHover,
				color: color.onSurface
			}
		},
		[`&.${tableCellClasses.body}`]: {
			backgroundColor: color.surface,
			[rowHoverSelector]: { backgroundColor: color.surfaceContainerVariant }
		},
		[`&.${tableCellClasses.sizeSmall}.${tableCellClasses.body}`]: {
			padding: "10px 16px",
			height: "40px",
			fontSize: "12px",
			fontWeight: 400,
			lineHeight: "16px"
		},
		[`&.MuiTableCell-sizeLarge.${tableCellClasses.body}`]: {
			padding: "10px 16px",
			height: "56px",
			fontSize: "14px",
			fontWeight: 400,
			lineHeight: "20px"
		},
		[`&.${tableCellClasses.footer}`]: {
			backgroundColor: color.surface,
			borderBottom: "none",
			borderTop: `1px solid ${color.outlineVariant}`,
			color: color.onSurface,
			fontSize: "14px",
			fontWeight: 500,
			lineHeight: "20px",
			padding: "0 16px",
			minHeight: "56px",
			height: "56px",
			verticalAlign: "middle",
			[rowHoverSelector]: { backgroundColor: color.surface }
		},
		[`&.${tableCellClasses.footer}:first-of-type`]: { paddingLeft: "20px" }
	}, {
		color: table?.cellTextColor,
		[`&.${tableCellClasses.head}`]: {
			backgroundColor: table?.headBackgroundColor,
			color: table?.headTextColor,
			fontWeight: table?.headFontWeight,
			[headHoverSelector]: { backgroundColor: table?.headHoverBackgroundColor }
		}
	});
});
//#endregion
//#region src/web/atoms/Table/TableContainer.tsx
const TableContainer = styled$2(TableContainer$1)(({ theme }) => resolveCssStyle(theme, {
	overflowX: "auto",
	backgroundColor: theme.hephaestus.color.surface
}));
//#endregion
//#region src/web/atoms/Table/TableFooter.tsx
const TableFooter = styled$2(TableFooter$1)(({ theme }) => resolveCssStyle(theme, { backgroundColor: theme.hephaestus.color.surface }));
//#endregion
//#region src/web/atoms/Table/TablePagination.tsx
const hoverSelector$3 = "&:hover, &[data-preview-state=\"hover\"]";
const StyledTablePagination = styled$2(TablePagination$1)(({ theme }) => {
	const { color, font, spacing, component } = theme.hephaestus;
	const pagination = component?.pagination;
	return resolveCssStyle(theme, {
		fontFamily: font.base,
		fontFeatureSettings: "\"lnum\" 1, \"tnum\" 1",
		padding: 0,
		borderBottom: "none",
		overflow: "visible",
		minHeight: "56px",
		verticalAlign: "middle",
		[`& .${tablePaginationClasses.toolbar}`]: {
			minHeight: "56px",
			height: "100%",
			padding: "0 16px 0 20px",
			gap: spacing.md,
			alignItems: "center",
			[`& .${tablePaginationClasses.actions}`]: { margin: 0 }
		},
		[`& .${tablePaginationClasses.spacer}`]: { flex: 1 },
		[`& .${tablePaginationClasses.displayedRows}`]: {
			order: -1,
			margin: 0,
			fontFamily: font.base,
			fontSize: "12px",
			fontWeight: 500,
			lineHeight: "16px",
			letterSpacing: "0.25px",
			color: color.onSurface
		},
		[`& .${tablePaginationClasses.selectLabel}:empty`]: { display: "none" },
		[`& .${tablePaginationClasses.selectLabel}`]: {
			margin: 0,
			fontFamily: font.base,
			fontSize: "12px",
			fontWeight: 500,
			lineHeight: "16px",
			color: color.onSurface
		},
		[`& .${tablePaginationClasses.input} .${tablePaginationClasses.select}`]: {
			fontFamily: font.base,
			fontSize: "14px",
			fontWeight: 500,
			lineHeight: "20px",
			letterSpacing: "0.25px",
			color: color.onSurface,
			width: "auto",
			minWidth: "unset",
			overflow: "visible",
			textOverflow: "clip",
			whiteSpace: "nowrap",
			paddingTop: 0,
			paddingBottom: 0
		},
		[`& .${tablePaginationClasses.input}`]: {
			margin: 0,
			width: "auto",
			minWidth: "unset",
			maxWidth: "none",
			overflow: "visible"
		},
		[`& .${tablePaginationClasses.actions}`]: {
			margin: 0,
			[`& .${iconButtonClasses.root}`]: {
				padding: "6px",
				width: "24px",
				height: "24px",
				[hoverSelector$3]: { backgroundColor: color.surfaceContainerVariant }
			}
		}
	}, {
		[`& .${tablePaginationClasses.displayedRows}`]: {
			color: pagination?.item?.color,
			fontSize: pagination?.item?.fontSize,
			fontWeight: pagination?.item?.fontWeight
		},
		[`& .${tablePaginationClasses.input}`]: {
			borderRadius: pagination?.perPageSelect?.borderRadius,
			backgroundColor: pagination?.perPageSelect?.backgroundColor,
			borderColor: pagination?.perPageSelect?.borderColor,
			borderWidth: pagination?.perPageSelect?.borderWidth
		},
		[`& .${tablePaginationClasses.select}`]: {
			color: pagination?.perPageSelect?.color,
			fontSize: pagination?.perPageSelect?.fontSize,
			fontWeight: pagination?.perPageSelect?.fontWeight
		},
		[`& .${tablePaginationClasses.selectIcon}`]: { color: pagination?.perPageSelect?.color },
		[`& .${tablePaginationClasses.actions}`]: { [`& .${iconButtonClasses.root}`]: {
			width: pagination?.navigation?.size,
			height: pagination?.navigation?.size,
			borderRadius: pagination?.navigation?.borderRadius,
			color: pagination?.navigation?.color,
			backgroundColor: pagination?.navigation?.backgroundColor,
			fontSize: pagination?.navigation?.iconFontSize,
			[hoverSelector$3]: { backgroundColor: pagination?.navigation?.hoverBackgroundColor }
		} }
	});
});
const defaultSelectSlotProps = {
	variant: "filled",
	size: "small"
};
const pageCountFor = (count, rowsPerPage, page) => {
	if (count < 0) return Math.max(1, page + 2);
	if (rowsPerPage < 1) return 1;
	return Math.max(1, Math.ceil(count / rowsPerPage));
};
const TablePaginationActions = ({ className, count, disabled = false, getItemAriaLabel, onPageChange, page, rowsPerPage, showFirstButton, showLastButton, slotProps, slots }) => /* @__PURE__ */ jsx(Pagination, {
	className,
	disabled,
	count: pageCountFor(count, rowsPerPage, page),
	page: page + 1,
	hidePrevButton: false,
	hideNextButton: false,
	showFirstButton,
	showLastButton: count >= 0 && showLastButton,
	onChange: (_event, nextPage) => {
		onPageChange(null, nextPage - 1);
	},
	getItemAriaLabel: (type, itemPage, selected) => {
		if (type === "page") return selected ? `page ${itemPage}` : `Go to page ${itemPage}`;
		if (type === "first" || type === "last" || type === "next" || type === "previous") return getItemAriaLabel(type);
		return "";
	},
	renderItem: (item) => {
		const navSlotProps = item.type === "next" ? slotProps?.nextButton : item.type === "previous" ? slotProps?.previousButton : item.type === "first" ? slotProps?.firstButton : item.type === "last" ? slotProps?.lastButton : void 0;
		return /* @__PURE__ */ jsx(PaginationItem, {
			...item,
			...navSlotProps,
			onClick: (event) => {
				item.onClick?.(event);
				const navOnClick = navSlotProps?.onClick;
				navOnClick?.(event);
			},
			slots: {
				first: slots?.firstButtonIcon,
				last: slots?.lastButtonIcon,
				next: slots?.nextButtonIcon,
				previous: slots?.previousButtonIcon
			}
		});
	}
});
const TablePagination = forwardRef(({ slots, slotProps, ...props }, ref) => {
	const selectSlotProps = slotProps?.select;
	const mergedSelect = typeof selectSlotProps === "function" ? (ownerState) => ({
		...defaultSelectSlotProps,
		...selectSlotProps(ownerState)
	}) : {
		...defaultSelectSlotProps,
		...selectSlotProps
	};
	return /* @__PURE__ */ jsx(StyledTablePagination, {
		ref,
		labelRowsPerPage: "",
		labelDisplayedRows: ({ from, to, count }) => count !== -1 ? `${from}-${to} of ${count}` : `${from}-${to}`,
		ActionsComponent: TablePaginationActions,
		...props,
		slots: {
			select: Select,
			menuItem: MenuItem,
			...slots
		},
		slotProps: {
			...slotProps,
			select: mergedSelect
		}
	});
});
//#endregion
//#region src/web/atoms/Table/TableRow.tsx
const hoverSelector$2 = "&:hover, &[data-preview-state=\"hover\"]";
const TableRow = styled$2(TableRow$1)(({ theme }) => {
	const { color } = theme.hephaestus;
	return resolveCssStyle(theme, {
		backgroundColor: color.surface,
		[hoverSelector$2]: { backgroundColor: color.surfaceContainerVariant },
		[`&.${tableRowClasses.head}`]: {
			backgroundColor: "transparent",
			[hoverSelector$2]: { backgroundColor: "transparent" }
		},
		[`&.${tableRowClasses.footer}`]: {
			backgroundColor: color.surface,
			minHeight: "56px",
			[hoverSelector$2]: { backgroundColor: color.surface }
		}
	});
});
//#endregion
//#region src/web/atoms/Table/SortIcons/Ascending.svg
var Ascending_default = "data:image/svg+xml,<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0A<path d=\"M4.31208 7.75245L7.69208 7.75245L6.00208 9.44245L4.31208 7.75245ZM5.64708 10.1475C5.84208 10.3425 6.15708 10.3425 6.35208 10.1475L8.64708 7.85245C8.96208 7.54245 8.74208 7.00245 8.29708 7.00245L3.70708 7.00245C3.26208 7.00245 3.03708 7.54245 3.35208 7.85745L5.64708 10.1475ZM3.70708 5.00245L8.29208 5.00245C8.73708 5.00245 8.96208 4.46245 8.64708 4.14745L6.35208 1.85245C6.15708 1.65745 5.84208 1.65745 5.64708 1.85245L3.35208 4.14745C3.04208 4.46245 3.26208 5.00245 3.70708 5.00245Z\" fill=\"%236A6F7B\"/>%0A</svg>%0A";
//#endregion
//#region src/web/atoms/Table/SortIcons/Descending.svg
var Descending_default = "data:image/svg+xml,<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0A<path d=\"M7.69208 4.24745L4.31208 4.24745L6.00208 2.55745L7.69208 4.24745ZM6.35708 1.85245C6.16208 1.65745 5.84708 1.65745 5.65208 1.85245L3.35708 4.14745C3.04208 4.45745 3.26208 4.99745 3.70708 4.99745L8.29208 4.99745C8.73708 4.99745 8.96208 4.45745 8.64708 4.14245L6.35708 1.85245ZM8.29708 6.99745L3.70708 6.99745C3.26208 6.99745 3.03708 7.53745 3.35208 7.85245L5.64708 10.1475C5.84208 10.3425 6.15708 10.3425 6.35208 10.1475L8.64708 7.85245C8.96208 7.53745 8.74208 6.99745 8.29708 6.99745Z\" fill=\"%236A6F7B\"/>%0A</svg>%0A";
//#endregion
//#region src/web/atoms/Table/SortIcons/Unsorted.svg
var Unsorted_default = "data:image/svg+xml,<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0A<path d=\"M5.64708 10.1475C5.84208 10.3425 6.15708 10.3425 6.35208 10.1475L8.64708 7.85245C8.96208 7.54245 8.74208 7.00245 8.29708 7.00245L3.70708 7.00245C3.26208 7.00245 3.03708 7.54245 3.35208 7.85745L5.64708 10.1475ZM3.70708 5.00245L8.29208 5.00245C8.73708 5.00245 8.96208 4.46245 8.64708 4.14745L6.35208 1.85245C6.15708 1.65745 5.84208 1.65745 5.64708 1.85245L3.35208 4.14745C3.04208 4.46245 3.26208 5.00245 3.70708 5.00245Z\" fill=\"%236A6F7B\"/>%0A</svg>%0A";
//#endregion
//#region src/web/atoms/Table/TableSortLabel.tsx
const hoverSelector$1 = "&:hover, &[data-preview-state=\"hover\"]";
const createSortIcon = (src, name) => {
	const SortIcon = ({ className }) => /* @__PURE__ */ jsx("span", {
		className,
		children: /* @__PURE__ */ jsx("img", {
			alt: "",
			"aria-hidden": true,
			"data-sort-icon": name,
			src,
			width: 12,
			height: 12
		})
	});
	return SortIcon;
};
const UnsortedIcon = createSortIcon(Unsorted_default, "unsorted");
const AscendingIcon = createSortIcon(Ascending_default, "ascending");
const DescendingIcon = createSortIcon(Descending_default, "descending");
const sortIconFor = (active, direction) => {
	if (!active) return UnsortedIcon;
	return direction === "desc" ? DescendingIcon : AscendingIcon;
};
const StyledTableSortLabel = styled$2(TableSortLabel$1)(({ theme }) => {
	const { color, font, component } = theme.hephaestus;
	const table = component?.table;
	return resolveCssStyle(theme, {
		gap: "8px",
		fontFamily: font.base,
		fontFeatureSettings: "\"lnum\" 1, \"tnum\" 1",
		fontSize: "12px",
		fontWeight: 600,
		lineHeight: "16px",
		letterSpacing: "0.25px",
		color: color.onSurfaceVariant,
		[hoverSelector$1]: {
			color: color.onSurface,
			[`& .${tableSortLabelClasses.icon}`]: {
				opacity: 1,
				transform: "none"
			}
		},
		"&.Mui-active": { color: color.onSurface },
		[`& .${tableSortLabelClasses.icon}`]: {
			margin: 0,
			width: "12px",
			height: "12px",
			overflow: "hidden",
			opacity: 1,
			transform: "none",
			"& img": {
				display: "block",
				width: "12px",
				height: "12px"
			}
		},
		[`&.${tableSortLabelClasses.directionAsc} .${tableSortLabelClasses.icon}`]: { transform: "none" },
		[`&.${tableSortLabelClasses.directionDesc} .${tableSortLabelClasses.icon}`]: { transform: "none" }
	}, {
		color: table?.headTextColor,
		fontWeight: table?.headFontWeight
	});
});
const TableSortLabel = forwardRef(({ active = false, direction = "asc", IconComponent, ...props }, ref) => /* @__PURE__ */ jsx(StyledTableSortLabel, {
	ref,
	active,
	direction,
	IconComponent: IconComponent ?? sortIconFor(active, direction),
	...props
}));
//#endregion
//#region src/web/atoms/Table/TableToolbar.tsx
const TableToolbar = styled$2(Box)(({ theme }) => resolveCssStyle(theme, {
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	gap: "8px",
	boxSizing: "border-box",
	minHeight: "72px",
	padding: "0 16px",
	backgroundColor: theme.hephaestus.color.surface
}));
//#endregion
//#region src/web/atoms/Tabs/TabPanel.tsx
const TabPanel = ({ children, value, index, id, "aria-labelledby": ariaLabelledBy, ...other }) => {
	const isActive = value === index;
	return /* @__PURE__ */ jsx(Box, {
		role: "tabpanel",
		hidden: !isActive,
		id: id ?? `tabpanel-${String(index)}`,
		"aria-labelledby": ariaLabelledBy ?? `tab-${String(index)}`,
		"data-testid": "tab-panel",
		...other,
		children: isActive ? /* @__PURE__ */ jsx(Box, { children }) : null
	});
};
//#endregion
//#region src/web/atoms/Tabs/Tabs.tsx
const TAB_HEIGHT = "32px";
const ICON_SIZE$1 = "16px";
const ICON_GAP$1 = "4px";
const hoverSelector = "&:hover, &[data-preview-state=\"hover\"]";
const pressedSelector$1 = "&:active, &[data-preview-state=\"pressed\"]";
const focusedSelector$1 = "&.Mui-focusVisible, &[data-preview-state=\"focused\"]";
const StyledTab = styled$2(Tab$1)(({ theme }) => {
	const { color, borderRadius, spacing, font, component } = theme.hephaestus;
	const tabNav = component?.tabNav;
	return resolveCssStyle(theme, {
		minHeight: TAB_HEIGHT,
		height: TAB_HEIGHT,
		minWidth: "unset",
		padding: `0 ${spacing.lg}`,
		gap: ICON_GAP$1,
		borderRadius: borderRadius.md,
		textTransform: "none",
		whiteSpace: "nowrap",
		fontFamily: font.base,
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "20px",
		letterSpacing: "0.25px",
		backgroundColor: color.surfaceContainerVariant,
		color: color.onSurface,
		opacity: 1,
		transition: theme.transitions.create(["background-color", "color"]),
		[`&.${tabClasses.labelIcon}`]: { minHeight: TAB_HEIGHT },
		[`& .${tabClasses.icon}`]: { margin: 0 },
		"& .MuiSvgIcon-root": {
			fontSize: ICON_SIZE$1,
			width: ICON_SIZE$1,
			height: ICON_SIZE$1
		},
		[hoverSelector]: {
			backgroundColor: color.surfaceContainerVariant,
			color: color.onSurface
		},
		[pressedSelector$1]: {
			backgroundColor: color.neutralPressed,
			color: color.onSurface
		},
		[`&.${tabClasses.selected}`]: {
			backgroundColor: color.primaryVariant,
			color: color.onSurface,
			opacity: 1,
			[hoverSelector]: {
				backgroundColor: color.primaryVariant,
				color: color.onSurface
			},
			[pressedSelector$1]: {
				backgroundColor: color.primaryVariantPressed,
				color: color.onSurface
			}
		},
		"&.Mui-disabled": {
			backgroundColor: color.disabled,
			color: color.onDisabled,
			opacity: 1
		},
		[focusedSelector$1]: {
			outline: `2px solid ${color.focus}`,
			outlineOffset: -2
		}
	}, {
		height: tabNav?.height,
		minHeight: tabNav?.height,
		width: tabNav?.width,
		padding: tabNav?.padding,
		borderRadius: tabNav?.borderRadius,
		backgroundColor: tabNav?.background?.default,
		color: tabNav?.text?.default,
		border: tabNav?.border?.default,
		[hoverSelector]: {
			backgroundColor: tabNav?.background?.default,
			color: tabNav?.text?.default,
			border: tabNav?.border?.default
		},
		[`&.${tabClasses.selected}`]: {
			backgroundColor: tabNav?.background?.active,
			color: tabNav?.text?.active,
			border: tabNav?.border?.active,
			[hoverSelector]: {
				backgroundColor: tabNav?.background?.active,
				color: tabNav?.text?.active,
				border: tabNav?.border?.active
			}
		}
	});
});
const StyledTabs = styled$2(Tabs$1)(({ theme }) => {
	const { color, spacing } = theme.hephaestus;
	const thinScrollbar = {
		scrollbarWidth: "thin",
		scrollbarColor: `${color.outlineVariant} transparent`,
		"&::-webkit-scrollbar": {
			width: 4,
			height: 4
		},
		"&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: color.outlineVariant,
			borderRadius: 4
		}
	};
	return resolveCssStyle(theme, {
		minHeight: TAB_HEIGHT,
		[`& .${tabsClasses.scroller}`]: {
			boxSizing: "border-box",
			overflowX: "auto",
			...thinScrollbar
		},
		[`& .${tabsClasses.list}`]: {
			boxSizing: "border-box",
			gap: spacing.md,
			overflowX: "auto",
			...thinScrollbar
		},
		[`& .${tabsClasses.indicator}`]: { display: "none" },
		[`& .${tabsClasses.scrollButtons}`]: { display: "none" }
	});
});
const Tab = forwardRef((props, ref) => /* @__PURE__ */ jsx(StyledTab, {
	ref,
	disableRipple: true,
	iconPosition: "start",
	...props
}));
const Tabs = forwardRef(({ children, ...props }, ref) => /* @__PURE__ */ jsx(StyledTabs, {
	ref,
	"data-testid": "tabs",
	scrollButtons: false,
	allowScrollButtonsMobile: false,
	...props,
	children
}));
//#endregion
//#region src/web/atoms/ToggleButton/ToggleButton.tsx
const SEGMENT_HEIGHT = "32px";
const ICON_SIZE = "16px";
const ICON_GAP = "4px";
const DIVIDER_HEIGHT = "22px";
const pressedSelector = "&:active, &[data-preview-state=\"pressed\"]";
const focusedSelector = "&.Mui-focusVisible, &[data-preview-state=\"focused\"]";
const StyledToggleButton = styled$2(ToggleButton$1)(({ theme }) => {
	const { color, borderRadius, spacing, font } = theme.hephaestus;
	return resolveCssStyle(theme, {
		minHeight: SEGMENT_HEIGHT,
		height: SEGMENT_HEIGHT,
		minWidth: "unset",
		padding: `0 ${spacing.lg}`,
		gap: ICON_GAP,
		borderRadius: borderRadius.md,
		border: "1px solid transparent",
		textTransform: "none",
		whiteSpace: "nowrap",
		fontFamily: font.base,
		fontSize: "14px",
		fontWeight: 500,
		lineHeight: "20px",
		letterSpacing: "0.25px",
		backgroundColor: "transparent",
		color: color.onSurface,
		opacity: 1,
		transition: theme.transitions.create([
			"background-color",
			"color",
			"border-color"
		]),
		"& .MuiSvgIcon-root": {
			fontSize: ICON_SIZE,
			width: ICON_SIZE,
			height: ICON_SIZE
		},
		"&:hover": {
			backgroundColor: "transparent",
			color: color.onSurface
		},
		[pressedSelector]: {
			backgroundColor: color.neutralPressed,
			color: color.onSurface
		},
		[`&.${toggleButtonClasses.selected}`]: {
			backgroundColor: color.primaryVariant,
			borderColor: color.primaryVariantHover,
			color: color.onSurface,
			opacity: 1,
			zIndex: 1,
			"&:hover": {
				backgroundColor: color.primaryVariant,
				color: color.onSurface
			},
			[pressedSelector]: {
				backgroundColor: color.primaryVariantPressed,
				color: color.onSurface
			},
			"&::before": { opacity: 0 }
		},
		"&.Mui-disabled": {
			backgroundColor: "transparent",
			color: color.onDisabled,
			borderColor: "transparent",
			opacity: 1
		},
		[`&.${toggleButtonClasses.selected}.Mui-disabled`]: {
			backgroundColor: color.primaryVariant,
			borderColor: "transparent",
			color: color.onDisabled
		},
		[focusedSelector]: {
			outline: `2px solid ${color.focus}`,
			outlineOffset: -2
		},
		"&:not(:first-of-type)::before": {
			content: "\"\"",
			position: "absolute",
			left: 0,
			top: "50%",
			transform: "translateY(-50%)",
			width: "1px",
			height: DIVIDER_HEIGHT,
			backgroundColor: color.outlineVariant,
			pointerEvents: "none"
		}
	});
});
const StyledToggleButtonGroup = styled$2(ToggleButtonGroup$1)(({ theme }) => {
	const { color, borderRadius } = theme.hephaestus;
	return resolveCssStyle(theme, {
		backgroundColor: color.surfaceContainerVariant,
		border: `1px solid ${color.outlineVariant}`,
		borderRadius: borderRadius.md,
		[`& .${toggleButtonGroupClasses.grouped}`]: {
			margin: 0,
			borderRadius: borderRadius.md
		},
		[`& .${toggleButtonGroupClasses.firstButton}, & .${toggleButtonGroupClasses.middleButton}, & .${toggleButtonGroupClasses.lastButton}`]: {
			margin: 0,
			borderRadius: borderRadius.md
		},
		[`& .${toggleButtonClasses.selected} + .${toggleButtonClasses.root}::before`]: { opacity: 0 }
	});
});
const ToggleButton = forwardRef((props, ref) => /* @__PURE__ */ jsx(StyledToggleButton, {
	ref,
	disableRipple: true,
	...props
}));
const ToggleButtonGroup = forwardRef(({ exclusive = true, ...props }, ref) => /* @__PURE__ */ jsx(StyledToggleButtonGroup, {
	ref,
	exclusive,
	...props
}));
//#endregion
//#region ../node_modules/.pnpm/react-toastify@11.1.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-toastify/dist/index.mjs
var L = (t) => typeof t == "number" && !isNaN(t);
var N = (t) => typeof t == "string";
var P = (t) => typeof t == "function";
var ut = (t) => N(t) || L(t);
var z = (t) => N(t) || P(t) ? t : null;
var yt = (t, o) => t === !1 || L(t) && t > 0 ? t : o;
var F = (t) => isValidElement(t) || N(t) || P(t) || L(t);
function J(t, o, e = 300) {
	let { scrollHeight: r, style: a } = t;
	requestAnimationFrame(() => {
		a.minHeight = "initial", a.height = r + "px", a.transition = `all ${e}ms`, requestAnimationFrame(() => {
			a.height = "0", a.padding = "0", a.margin = "0", setTimeout(o, e);
		});
	});
}
function R({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: a = 300 }) {
	return function({ children: s, position: f, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
		let C = e ? `${t}--${f}` : t, S = e ? `${o}--${f}` : o, E = useRef(0);
		return useLayoutEffect(() => {
			let d = g.current, p = C.split(" "), b = (n) => {
				n.target === g.current && (x(), d.removeEventListener("animationend", b), d.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && d.classList.remove(...p));
			};
			d.classList.add(...p), d.addEventListener("animationend", b), d.addEventListener("animationcancel", b);
		}, []), useEffect(() => {
			let d = g.current, p = () => {
				d.removeEventListener("animationend", p), r ? J(d, T, a) : T();
			};
			v || (c ? p() : (E.current = 1, d.className += ` ${S}`, d.addEventListener("animationend", p)));
		}, [v]), React.createElement(React.Fragment, null, s);
	};
}
function tt(t, o) {
	return {
		content: ot(t.content, t.props),
		containerId: t.props.containerId,
		id: t.props.toastId,
		theme: t.props.theme,
		type: t.props.type,
		data: t.props.data || {},
		isLoading: t.props.isLoading,
		icon: t.props.icon,
		reason: t.removalReason,
		status: o
	};
}
function ot(t, o, e = !1) {
	return isValidElement(t) && !N(t.type) ? cloneElement(t, {
		closeToast: o.closeToast,
		toastProps: o,
		data: o.data,
		isPaused: e
	}) : P(t) ? t({
		closeToast: o.closeToast,
		toastProps: o,
		data: o.data,
		isPaused: e
	}) : t;
}
function gt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
	return React.createElement("button", {
		className: `Toastify__close-button Toastify__close-button--${o}`,
		type: "button",
		onClick: (r) => {
			r.stopPropagation(), t(!0);
		},
		"aria-label": e
	}, React.createElement("svg", {
		"aria-hidden": "true",
		viewBox: "0 0 14 16"
	}, React.createElement("path", {
		fillRule: "evenodd",
		d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
	})));
}
function bt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: a, className: l, controlledProgress: s, progress: f, rtl: c, isIn: T, theme: g }) {
	let v = a || s && f === 0, x = {
		animationDuration: `${t}ms`,
		animationPlayState: o ? "running" : "paused"
	};
	s && (x.transform = `scaleX(${f})`);
	let C = clsx("Toastify__progress-bar", s ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, { ["Toastify__progress-bar--rtl"]: c }), S = P(l) ? l({
		rtl: c,
		type: r,
		defaultClassName: C
	}) : clsx(C, l), E = { [s && f >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: s && f < 1 ? null : () => {
		T && e();
	} };
	return React.createElement("div", {
		className: "Toastify__progress-bar--wrp",
		"data-hidden": v
	}, React.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}` }), React.createElement("div", {
		role: "progressbar",
		"aria-hidden": v ? "true" : "false",
		"aria-label": "notification timer",
		"aria-valuenow": s ? Math.round(f * 100) : void 0,
		"aria-valuemin": 0,
		"aria-valuemax": 100,
		className: S,
		style: x,
		...E
	}));
}
var Qt = 1;
var st = () => `${Qt++}`;
function vt(t, o, e) {
	let r = 1, a = 0, l = [], s = [], f = o, c = /* @__PURE__ */ new Map(), T = /* @__PURE__ */ new Set(), g = (i) => (T.add(i), () => T.delete(i)), v = () => {
		s = Array.from(c.values()), T.forEach((i) => i());
	}, x = ({ containerId: i, toastId: n, updateId: u }) => {
		let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
		return h || m;
	}, C = (i, n) => {
		c.forEach((u) => {
			var h;
			(n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
		});
	}, S = (i) => {
		var n, u;
		i.isActive && ((u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1, e(tt(i, "removed")));
	}, E = (i) => {
		if (i == null) c.forEach(S);
		else {
			let n = c.get(i);
			n && S(n);
		}
		v();
	}, d = () => {
		a -= l.length, l = [];
	}, p = (i) => {
		var m, _;
		let { toastId: n, updateId: u } = i.props, h = u == null;
		i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e(tt(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
	};
	return {
		id: t,
		props: f,
		observe: g,
		toggle: C,
		removeToast: E,
		toasts: c,
		clearQueue: d,
		buildToast: (i, n) => {
			if (x(n)) return;
			let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, D = h == null;
			D && a++;
			let A = {
				...f,
				style: f.toastStyle,
				key: r++,
				...Object.fromEntries(Object.entries(n).filter(([M, $]) => $ != null)),
				toastId: u,
				updateId: h,
				data: m,
				isIn: !1,
				className: z(n.className || f.toastClassName),
				progressClassName: z(n.progressClassName || f.progressClassName),
				autoClose: n.isLoading ? !1 : yt(n.autoClose, f.autoClose),
				closeToast(M) {
					let $ = c.get(u);
					$ && ($.removalReason = M, E(u));
				},
				deleteToast() {
					if (c.get(u) != null) {
						if (c.delete(u), a--, a < 0 && (a = 0), l.length > 0) {
							p(l.shift());
							return;
						}
						v();
					}
				}
			};
			A.closeButton = f.closeButton, n.closeButton === !1 || F(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = F(f.closeButton) ? f.closeButton : !0);
			let B = {
				content: i,
				props: A,
				staleId: _
			};
			f.limit && f.limit > 0 && a > f.limit && D ? l.push(B) : L(k) ? setTimeout(() => {
				p(B);
			}, k) : p(B);
		},
		setProps(i) {
			f = i;
		},
		setToggle: (i, n) => {
			let u = c.get(i);
			u && (u.toggle = n);
		},
		isToastActive: (i) => {
			var n;
			return (n = c.get(i)) == null ? void 0 : n.isActive;
		},
		getSnapshot: () => s
	};
}
var I = /* @__PURE__ */ new Map();
var U = [];
var rt = /* @__PURE__ */ new Set();
var Wt = (t) => rt.forEach((o) => o(t));
var ht = () => I.size > 0;
function Gt() {
	U.forEach((t) => nt(t.content, t.options)), U = [];
}
var Ct = (t, { containerId: o }) => {
	var e;
	return (e = I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function X(t, o) {
	var r;
	if (o) return !!((r = I.get(o)) != null && r.isToastActive(t));
	let e = !1;
	return I.forEach((a) => {
		a.isToastActive(t) && (e = !0);
	}), e;
}
function xt(t) {
	if (!ht()) {
		U = U.filter((o) => t != null && o.options.toastId !== t);
		return;
	}
	if (t == null || ut(t)) I.forEach((o) => {
		o.removeToast(t);
	});
	else if (t && ("containerId" in t || "id" in t)) {
		let o = I.get(t.containerId);
		o ? o.removeToast(t.id) : I.forEach((e) => {
			e.removeToast(t.id);
		});
	}
}
var Et = (t = {}) => {
	I.forEach((o) => {
		o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
	});
};
function nt(t, o) {
	F(t) && (ht() || U.push({
		content: t,
		options: o
	}), I.forEach((e) => {
		e.buildToast(t, o);
	}));
}
function Pt(t) {
	var o;
	(o = I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function it(t, o) {
	I.forEach((e) => {
		(o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
	});
}
function It(t) {
	let o = t.containerId || 1;
	return {
		subscribe(e) {
			let r = vt(o, t, Wt);
			I.set(o, r);
			let a = r.observe(e);
			return Gt(), () => {
				a(), I.delete(o);
			};
		},
		setProps(e) {
			var r;
			(r = I.get(o)) == null || r.setProps(e);
		},
		getSnapshot() {
			var e;
			return (e = I.get(o)) == null ? void 0 : e.getSnapshot();
		}
	};
}
function St(t) {
	return rt.add(t), () => {
		rt.delete(t);
	};
}
function qt(t) {
	return t && (N(t.toastId) || L(t.toastId)) ? t.toastId : st();
}
function H(t, o) {
	return nt(t, o), o.toastId;
}
function Q(t, o) {
	return {
		...o,
		type: o && o.type || t,
		toastId: qt(o)
	};
}
function W(t) {
	return (o, e) => H(o, Q(t, e));
}
function y(t, o) {
	return H(t, Q("default", o));
}
y.loading = (t, o) => H(t, Q("default", {
	isLoading: !0,
	autoClose: !1,
	closeOnClick: !1,
	closeButton: !1,
	draggable: !1,
	...o
}));
function Kt(t, { pending: o, error: e, success: r }, a) {
	let l;
	o && (l = N(o) ? y.loading(o, a) : y.loading(o.render, {
		...a,
		...o
	}));
	let s = {
		isLoading: null,
		autoClose: null,
		closeOnClick: null,
		closeButton: null,
		draggable: null
	}, f = (T, g, v) => {
		if (g == null) {
			y.dismiss(l);
			return;
		}
		let x = {
			type: T,
			...s,
			...a,
			data: v
		}, C = N(g) ? { render: g } : g;
		return l ? y.update(l, {
			...x,
			...C
		}) : y(C.render, {
			...x,
			...C
		}), v;
	}, c = P(t) ? t() : t;
	return c.then((T) => f("success", r, T)).catch((T) => f("error", e, T)), c;
}
y.promise = Kt;
y.success = W("success");
y.info = W("info");
y.error = W("error");
y.warning = W("warning");
y.warn = y.warning;
y.dark = (t, o) => H(t, Q("default", {
	theme: "dark",
	...o
}));
function Yt(t) {
	xt(t);
}
y.dismiss = Yt;
y.clearWaitingQueue = Et;
y.isActive = X;
y.update = (t, o = {}) => {
	let e = Ct(t, o);
	if (e) {
		let { props: r, content: a } = e, l = {
			delay: 100,
			...r,
			...o,
			toastId: o.toastId || t,
			updateId: st()
		};
		l.toastId !== t && (l.staleId = t);
		let s = l.render || a;
		delete l.render, H(s, l);
	}
};
y.done = (t) => {
	y.update(t, { progress: 1 });
};
y.onChange = St;
y.play = (t) => it(!0, t);
y.pause = (t) => it(!1, t);
function kt(t) {
	var s;
	let { subscribe: o, getSnapshot: e, setProps: r } = useRef(It(t)).current;
	r(t);
	let a = (s = useSyncExternalStore(o, e, e)) == null ? void 0 : s.slice();
	function l(f) {
		if (!a) return [];
		let c = /* @__PURE__ */ new Map();
		return t.newestOnTop && a.reverse(), a.forEach((T) => {
			let { position: g } = T.props;
			c.has(g) || c.set(g, []), c.get(g).push(T);
		}), Array.from(c, (T) => f(T[0], T[1]));
	}
	return {
		getToastToRender: l,
		isToastActive: X,
		count: a == null ? void 0 : a.length
	};
}
function Nt(t) {
	let [o, e] = useState(!1), [r, a] = useState(!1), l = useRef(null), s = useRef({
		start: 0,
		delta: 0,
		removalDistance: 0,
		canCloseOnClick: !0,
		canDrag: !1,
		didMove: !1
	}).current, { autoClose: f, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
	Pt({
		id: t.toastId,
		containerId: t.containerId,
		fn: e
	}), useEffect(() => {
		if (t.pauseOnFocusLoss) return x(), () => {
			C();
		};
	}, [t.pauseOnFocusLoss]);
	function x() {
		document.hasFocus() || p(), window.addEventListener("focus", d), window.addEventListener("blur", p);
	}
	function C() {
		window.removeEventListener("focus", d), window.removeEventListener("blur", p);
	}
	function S(m) {
		if (t.draggable === !0 || t.draggable === m.pointerType) {
			b();
			let _ = l.current;
			s.canCloseOnClick = !0, s.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (s.start = m.clientX, s.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (s.start = m.clientY, s.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
		}
	}
	function E(m) {
		let { top: _, bottom: k, left: D, right: A } = l.current.getBoundingClientRect();
		m.pointerType === "mouse" && t.pauseOnHover && m.clientX >= D && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : d();
	}
	function d() {
		e(!0);
	}
	function p() {
		e(!1);
	}
	function b() {
		s.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
	}
	function i() {
		document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
	}
	function n(m) {
		let _ = l.current;
		if (s.canDrag && _) {
			s.didMove = !0, o && p(), t.draggableDirection === "x" ? s.delta = m.clientX - s.start : s.delta = m.clientY - s.start, s.start !== m.clientX && (s.canCloseOnClick = !1);
			let k = t.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`;
			_.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(s.delta / s.removalDistance)}`;
		}
	}
	function u() {
		i();
		let m = l.current;
		if (s.canDrag && s.didMove && m) {
			if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) {
				a(!0), t.closeToast(!0), t.collapseAll();
				return;
			}
			m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
		}
	}
	let h = {
		onPointerDown: S,
		onPointerUp: E
	};
	return f && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = d)), v && (h.onClick = (m) => {
		g && g(m), s.canCloseOnClick && T(!0);
	}), {
		playToast: d,
		pauseToast: p,
		isRunning: o,
		preventExitTransition: r,
		toastRef: l,
		eventHandlers: h
	};
}
var G = typeof window != "undefined" ? useLayoutEffect : useEffect;
var K = ({ theme: t, type: o, isLoading: e, ...r }) => React.createElement("svg", {
	viewBox: "0 0 24 24",
	width: "100%",
	height: "100%",
	fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
	...r
});
function ro(t) {
	return React.createElement(K, { ...t }, React.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}
function no(t) {
	return React.createElement(K, { ...t }, React.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}
function io(t) {
	return React.createElement(K, { ...t }, React.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}
function lo(t) {
	return React.createElement(K, { ...t }, React.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}
function fo() {
	return React.createElement("div", { className: "Toastify__spinner" });
}
var q = {
	info: no,
	warning: ro,
	success: io,
	error: lo,
	spinner: fo
};
var co = (t) => t in q;
function wt({ theme: t, type: o, isLoading: e, icon: r }) {
	let a = null, l = {
		theme: t,
		type: o
	};
	return r === !1 || (P(r) ? a = r({
		...l,
		isLoading: e
	}) : isValidElement(r) ? a = cloneElement(r, l) : e ? a = q.spinner() : co(o) && (a = q[o](l))), a;
}
var Dt = (t) => {
	let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: a, playToast: l } = Nt(t), { closeButton: s, children: f, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: d, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: D, theme: A, ariaLabel: B } = t, M = clsx("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, { ["Toastify__toast--rtl"]: u }, { ["Toastify__toast--close-on-click"]: D }), $ = P(E) ? E({
		rtl: u,
		position: S,
		type: g,
		defaultClassName: M
	}) : clsx(M, E), mt = wt(t), pt = !!n || !c, Z = {
		closeToast: x,
		type: g,
		theme: A
	}, V = null;
	return s === !1 || (P(s) ? V = s(Z) : isValidElement(s) ? V = cloneElement(s, Z) : V = gt(Z)), React.createElement(C, {
		isIn: _,
		done: m,
		position: S,
		preventExitTransition: e,
		nodeRef: r,
		playToast: l
	}, React.createElement("div", {
		id: h,
		tabIndex: 0,
		onClick: T,
		"data-in": _,
		className: $,
		...a,
		style: d,
		ref: r,
		..._ && {
			role: i,
			"aria-label": B
		}
	}, mt != null && React.createElement("div", { className: clsx("Toastify__toast-icon", { ["Toastify--animate-icon Toastify__zoom-enter"]: !k }) }, mt), ot(f, t, !o), V, !t.customProgressBar && React.createElement(bt, {
		...b && !pt ? { key: `p-${b}` } : {},
		rtl: u,
		theme: A,
		delay: c,
		isRunning: o,
		isIn: _,
		closeToast: x,
		hide: v,
		type: g,
		className: p,
		controlledProgress: pt,
		progress: n || 0
	})));
};
var j = (t, o = !1) => ({
	enter: `Toastify--animate Toastify__${t}-enter`,
	exit: `Toastify--animate Toastify__${t}-exit`,
	appendPosition: o
});
var ft = R(j("bounce", !0));
var uo = R(j("slide", !0));
R(j("zoom"));
R(j("flip"));
var vo = {
	position: "top-right",
	transition: ft,
	autoClose: 5e3,
	closeButton: !0,
	pauseOnHover: !0,
	pauseOnFocusLoss: !0,
	draggable: "touch",
	draggablePercent: 80,
	draggableDirection: "x",
	role: "alert",
	theme: "light",
	"aria-label": "Notifications Alt+T",
	hotKeys: (t) => t.altKey && t.code === "KeyT"
};
function dt(t) {
	let o = {
		...vo,
		...t
	}, e = t.stacked, [r, a] = useState(!0), l = useRef(null), { getToastToRender: s, isToastActive: f, count: c } = kt(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
	function S(d) {
		let p = clsx("Toastify__toast-container", `Toastify__toast-container--${d}`, { ["Toastify__toast-container--rtl"]: v });
		return P(T) ? T({
			position: d,
			rtl: v,
			defaultClassName: p
		}) : clsx(p, z(T));
	}
	function E() {
		e && (a(!0), y.play());
	}
	return G(() => {
		var d;
		if (e) {
			let p = l.current.querySelectorAll("[data-in=\"true\"]"), b = 12, i = (d = o.position) == null ? void 0 : d.includes("top"), n = 0, u = 0;
			Array.from(p).reverse().forEach((h, m) => {
				let _ = h;
				_.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
				let k = n * (r ? .2 : 1) + (r ? 0 : b * m), D = Math.max(.5, 1 - (r ? u : 0));
				_.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${D}`), n += _.offsetHeight, u += .025;
			});
		}
	}, [
		r,
		c,
		e
	]), useEffect(() => {
		function d(p) {
			var i;
			let b = l.current;
			C(p) && ((i = b == null ? void 0 : b.querySelector("[tabIndex=\"0\"]")) == null || i.focus(), a(!1), y.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (a(!0), y.play());
		}
		return document.addEventListener("keydown", d), () => {
			document.removeEventListener("keydown", d);
		};
	}, [C]), React.createElement("section", {
		ref: l,
		className: "Toastify",
		id: x,
		onMouseEnter: () => {
			e && (a(!1), y.pause());
		},
		onMouseLeave: E,
		"aria-live": "polite",
		"aria-atomic": "false",
		"aria-relevant": "additions text",
		"aria-label": o["aria-label"]
	}, s((d, p) => {
		let b = p.length ? { ...g } : {
			...g,
			pointerEvents: "none"
		};
		return React.createElement("div", {
			tabIndex: -1,
			className: S(d),
			"data-stacked": e,
			style: b,
			key: `c-${d}`
		}, p.map(({ content: i, props: n }) => React.createElement(Dt, {
			...n,
			stacked: e,
			collapseAll: E,
			isIn: f(n.toastId, n.containerId),
			key: `t-${n.key}`
		}, i)));
	}));
}
var Mt = `:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #07bc0c;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: hsl(6, 78%, 57%);
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);

  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);

  --toastify-container-width: fit-content;
  --toastify-toast-width: 320px;
  --toastify-toast-offset: 16px;
  --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));
  --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));
  --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));
  --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));
  --toastify-toast-background: #fff;
  --toastify-toast-padding: 14px;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-toast-bd-radius: 6px;
  --toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;

  /* Used only for colored theme */
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;

  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
  /* used to control the opacity of the progress trail */
  --toastify-color-progress-bgo: 0.2;
}

.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index));
  position: fixed;
  width: var(--toastify-container-width);
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.Toastify__toast-container--top-left {
  top: var(--toastify-toast-top);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--top-center {
  top: var(--toastify-toast-top);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--top-right {
  top: var(--toastify-toast-top);
  right: var(--toastify-toast-right);
  align-items: end;
}
.Toastify__toast-container--bottom-left {
  bottom: var(--toastify-toast-bottom);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--bottom-center {
  bottom: var(--toastify-toast-bottom);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--bottom-right {
  bottom: var(--toastify-toast-bottom);
  right: var(--toastify-toast-right);
  align-items: end;
}

.Toastify__toast {
  --y: 0px;
  position: relative;
  touch-action: none;
  width: var(--toastify-toast-width);
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: var(--toastify-toast-padding);
  border-radius: var(--toastify-toast-bd-radius);
  box-shadow: var(--toastify-toast-shadow);
  max-height: var(--toastify-toast-max-height);
  font-family: var(--toastify-font-family);
  /* webkit only issue #791 */
  z-index: 0;
  /* inner swag */
  display: flex;
  flex: 1 auto;
  align-items: center;
  word-break: break-word;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 100vw;
    left: env(safe-area-inset-left);
    margin: 0;
  }
  .Toastify__toast-container--top-left,
  .Toastify__toast-container--top-center,
  .Toastify__toast-container--top-right {
    top: env(safe-area-inset-top);
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left,
  .Toastify__toast-container--bottom-center,
  .Toastify__toast-container--bottom-right {
    bottom: env(safe-area-inset-bottom);
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: env(safe-area-inset-right);
    left: initial;
  }
  .Toastify__toast {
    --toastify-toast-width: 100%;
    margin-bottom: 0;
    border-radius: 0;
  }
}

.Toastify__toast-container[data-stacked='true'] {
  width: var(--toastify-toast-width);
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container[data-stacked='true'] {
    width: 100vw;
  }
}

.Toastify__toast--stacked {
  position: absolute;
  width: 100%;
  transform: translate3d(0, var(--y), 0) scale(var(--s));
  transition: transform 0.3s;
}

.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,
.Toastify__toast--stacked[data-collapsed] .Toastify__close-button {
  transition: opacity 0.1s;
}

.Toastify__toast--stacked[data-collapsed='false'] {
  overflow: visible;
}

.Toastify__toast--stacked[data-collapsed='true']:not(:last-child) > * {
  opacity: 0;
}

.Toastify__toast--stacked:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: calc(var(--g) * 1px);
  bottom: 100%;
}

.Toastify__toast--stacked[data-pos='top'] {
  top: 0;
}

.Toastify__toast--stacked[data-pos='bot'] {
  bottom: 0;
}

.Toastify__toast--stacked[data-pos='bot'].Toastify__toast--stacked:before {
  transform-origin: top;
}

.Toastify__toast--stacked[data-pos='top'].Toastify__toast--stacked:before {
  transform-origin: bottom;
}

.Toastify__toast--stacked:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  transform: scaleY(3);
  z-index: -1;
}

.Toastify__toast--rtl {
  direction: rtl;
}

.Toastify__toast--close-on-click {
  cursor: pointer;
}

.Toastify__toast-icon {
  margin-inline-end: 10px;
  width: 22px;
  flex-shrink: 0;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.5s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

.Toastify__toast-theme--dark {
  background: var(--toastify-color-dark);
  color: var(--toastify-text-color-dark);
}

.Toastify__toast-theme--light {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--default {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--info {
  color: var(--toastify-text-color-info);
  background: var(--toastify-color-info);
}

.Toastify__toast-theme--colored.Toastify__toast--success {
  color: var(--toastify-text-color-success);
  background: var(--toastify-color-success);
}

.Toastify__toast-theme--colored.Toastify__toast--warning {
  color: var(--toastify-text-color-warning);
  background: var(--toastify-color-warning);
}

.Toastify__toast-theme--colored.Toastify__toast--error {
  color: var(--toastify-text-color-error);
  background: var(--toastify-color-error);
}

.Toastify__progress-bar-theme--light {
  background: var(--toastify-color-progress-light);
}

.Toastify__progress-bar-theme--dark {
  background: var(--toastify-color-progress-dark);
}

.Toastify__progress-bar--info {
  background: var(--toastify-color-progress-info);
}

.Toastify__progress-bar--success {
  background: var(--toastify-color-progress-success);
}

.Toastify__progress-bar--warning {
  background: var(--toastify-color-progress-warning);
}

.Toastify__progress-bar--error {
  background: var(--toastify-color-progress-error);
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: var(--toastify-color-transparent);
}

.Toastify__close-button {
  color: #fff;
  position: absolute;
  top: 6px;
  right: 6px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  z-index: 1;
}

.Toastify__toast--rtl .Toastify__close-button {
  left: 6px;
  right: unset;
}

.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}

.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}

.Toastify__close-button:hover,
.Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.7;
  transform-origin: left;
}

.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}

.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}

.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
  border-bottom-left-radius: initial;
}

.Toastify__progress-bar--wrp {
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  border-bottom-left-radius: var(--toastify-toast-bd-radius);
  border-bottom-right-radius: var(--toastify-toast-bd-radius);
}

.Toastify__progress-bar--wrp[data-hidden='true'] {
  opacity: 0;
}

.Toastify__progress-bar--bg {
  opacity: var(--toastify-color-progress-bgo);
  width: 100%;
  height: 100%;
}

.Toastify__spinner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: var(--toastify-spinner-color-empty-area);
  border-right-color: var(--toastify-spinner-color);
  animation: Toastify__spin 0.65s linear infinite;
}

@keyframes Toastify__bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInLeft {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInUp {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}

@keyframes Toastify__bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}

.Toastify__bounce-enter--top-left,
.Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}

.Toastify__bounce-enter--top-right,
.Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}

.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}

.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left,
.Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}

.Toastify__bounce-exit--top-right,
.Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}

.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}

.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}

@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: translate3d(0, var(--y), 0) scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}

.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}

@keyframes Toastify__flipOut {
  from {
    transform: translate3d(0, var(--y), 0) perspective(400px);
  }
  30% {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}

.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}

@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}

.Toastify__slide-enter--top-left,
.Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}

.Toastify__slide-enter--top-right,
.Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}

.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}

.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left,
.Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-right,
.Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

@keyframes Toastify__spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`;
var $t = /* @__PURE__ */ new Map();
var Rt = (t, o) => {
	G(() => {
		if (!t || typeof document == "undefined") return;
		let e = document, r = $t.get(e);
		if (r) {
			o && r.setAttribute("nonce", o);
			return;
		}
		let a = e.createElement("style");
		a.textContent = t, o && a.setAttribute("nonce", o), e.head.appendChild(a), $t.set(e, a);
	}, [o]);
};
function xo(t) {
	return Rt(Mt, t.nonce), React.createElement(dt, { ...t });
}
//#endregion
//#region src/web/molecules/Toast/ToastifyToast.tsx
const ToastifyToast = ({ closeToast, data, toastProps, isPaused }) => /* @__PURE__ */ jsx(SnackbarContent, {
	severity: data?.severity,
	message: data?.message,
	description: data?.description,
	actionLabel: data?.actionLabel,
	onAction: data?.onAction,
	icon: data?.icon,
	progress: data?.progress,
	autoClose: toastProps?.autoClose,
	isPaused,
	onClose: data?.dismissible === false ? void 0 : (event) => {
		closeToast?.(event);
	}
});
//#endregion
//#region src/web/molecules/Toast/enqueueToast.tsx
const toSeverity = (variant) => !variant || variant === "default" ? "info" : variant;
const enqueueToast = (message, options = {}) => {
	const severity = toSeverity(options.variant);
	const data = {
		severity,
		message,
		description: options.description,
		actionLabel: options.actionLabel,
		onAction: options.onAction,
		dismissible: options.dismissible,
		icon: options.icon,
		progress: options.progress
	};
	return y(ToastifyToast, {
		type: severity,
		data,
		...options.autoClose !== void 0 ? { autoClose: options.autoClose } : {}
	});
};
const closeToast = (id) => {
	y.dismiss(id);
};
const useToast = () => ({
	enqueueToast,
	closeToast
});
//#endregion
//#region src/web/molecules/Toast/ToastifyContainer.tsx
const StyledToastContainer = styled$3(xo)`
  & .Toastify__toast {
    padding: 0;
    width: unset;
    min-height: unset;
    max-height: none;
    height: auto;
    overflow: visible;
    background: none;
    box-shadow: none;
    align-items: stretch;
  }

  & .Toastify__toast-body {
    margin: 0;
    padding: 0;
    width: 100%;
    flex: none;
    overflow: visible;
    align-items: stretch;
  }

  &&&.Toastify__toast-container {
    padding: 0;
    width: max-content;
    max-width: 100%;
  }
`;
const ToastifyContainer = () => /* @__PURE__ */ jsx(StyledToastContainer, {
	position: "bottom-left",
	autoClose: 5e3,
	hideProgressBar: true,
	closeOnClick: false,
	draggable: true,
	closeButton: false,
	icon: false,
	pauseOnFocusLoss: true,
	pauseOnHover: true,
	transition: uo,
	role: "none"
});
//#endregion
//#region src/web/providers/ThemeProvider.tsx
const useThemeContext = (props = {}) => {
	const [theme, setTheme] = useState(props.initialTheme);
	return {
		theme: useMemo(() => getTheme(theme), [theme]),
		setTheme
	};
};
const [ThemeProvider, useTheme, useSetTheme] = constate(useThemeContext, (value) => value.theme, (value) => value.setTheme);
//#endregion
//#region src/web/providers/MuiProvider.tsx
const parsePx = (value) => Number.parseFloat(value);
const buildSpacingScale = (tokens) => [
	0,
	parsePx(tokens.sm),
	parsePx(tokens.md),
	parsePx(tokens.lg),
	parsePx(tokens.xl),
	parsePx(tokens.xxl)
];
const resolveScaleIndex = (scale, absoluteIndex) => {
	const lastIndex = scale.length - 1;
	if (absoluteIndex <= lastIndex) return scale[absoluteIndex] ?? 0;
	const sm = scale[1] ?? 4;
	return (scale[lastIndex] ?? 0) + (absoluteIndex - lastIndex) * sm;
};
const resolveSpacingPx = (scale, factor) => {
	const sign = factor < 0 ? -1 : 1;
	const absoluteIndex = Math.abs(factor) * 2;
	if (Number.isInteger(absoluteIndex)) return sign * resolveScaleIndex(scale, absoluteIndex);
	const lower = Math.floor(absoluteIndex);
	const upper = Math.ceil(absoluteIndex);
	const lowerPx = resolveScaleIndex(scale, lower);
	const upperPx = resolveScaleIndex(scale, upper);
	const progress = absoluteIndex - lower;
	return sign * (lowerPx + (upperPx - lowerPx) * progress);
};
const createMuiSpacing = (tokens) => {
	const scale = buildSpacingScale(tokens);
	return (factor) => {
		if (typeof factor === "string") return factor;
		return `${resolveSpacingPx(scale, factor)}px`;
	};
};
const getMuiThemeOptions = (theme) => {
	return {
		hephaestus: theme,
		spacing: createMuiSpacing(theme.spacing),
		breakpoints: { values: Object.fromEntries(BREAKPOINTS.map((bp) => [bp, parsePx(theme.breakpoint[bp])])) },
		palette: {
			primary: {
				main: theme.color.primary,
				light: theme.color.primaryVariant,
				dark: theme.color.primaryHover,
				contrastText: theme.color.onPrimary
			},
			secondary: {
				main: theme.color.primaryVariant,
				light: theme.color.primaryVariant,
				dark: theme.color.primaryVariantHover,
				contrastText: theme.color.onPrimaryVariant
			},
			error: {
				main: theme.color.negative,
				light: theme.color.negativeVariant,
				dark: theme.color.negativeHover,
				contrastText: theme.color.onNegative
			},
			warning: {
				main: theme.color.warning,
				light: theme.color.warningVariant,
				dark: theme.color.warningHover,
				contrastText: theme.color.onWarning
			},
			success: {
				main: theme.color.positive,
				light: theme.color.positiveVariant,
				dark: theme.color.positiveHover,
				contrastText: theme.color.onPositive
			},
			background: {
				default: theme.color.background,
				paper: theme.color.surface
			},
			text: {
				primary: theme.color.onSurface,
				secondary: theme.color.onSurfaceVariant,
				disabled: theme.color.onDisabled
			},
			divider: theme.color.outlineVariant
		},
		typography: { fontFamily: theme.font.base },
		components: { MuiButtonBase: { defaultProps: { disableRipple: true } } }
	};
};
const createHephaestusMuiTheme = (theme) => createTheme$1(getMuiThemeOptions(theme));
const MuiProvider = ({ children }) => {
	const theme = useTheme();
	const muiTheme = useMemo(() => createHephaestusMuiTheme(theme), [theme]);
	return /* @__PURE__ */ jsxs(ThemeProvider$1, {
		theme: muiTheme,
		children: [/* @__PURE__ */ jsx(Global, { styles: css`
        body {
          background-color: ${theme.color.background};
        }
      ` }), children]
	});
};
//#endregion
//#region src/web/providers/HephaestusProvider.tsx
const HephaestusProvider = ({ children, initialTheme }) => /* @__PURE__ */ jsx(ThemeProvider, {
	initialTheme,
	children: /* @__PURE__ */ jsx(MuiProvider, { children: /* @__PURE__ */ jsxs(BootSpinnerProvider, { children: [children, /* @__PURE__ */ jsx(ToastifyContainer, {})] }) })
});
//#endregion
export { APP_BAR_HEIGHT, Alert, AlertBanner, AlertTitle, AppBar, Avatar, AvatarGroup, Badge, BootSpinner, BootSpinnerBackdrop, BootSpinnerProvider, Box, Breadcrumb, Breadcrumbs, Button, Checkbox, Chip, CircularProgress, Collapse, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid, HephaestusProvider, Icon, IconButton, Input, InputAdornment, LinearProgress, Link, ListSubheader, Menu, MenuItem, MuiProvider, Nav, NavCollapse, NavContext, NavItem, Pagination, PaginationItem, Popover, Radio, RadioGroup, SecondaryTab, SecondaryTabs, Select, Skeleton, Snackbar, SnackbarContent, Stack, StatusChip, Stepper, Switch, Tab, TabPanel, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, TableToolbar, Tabs, ThemeProvider, ToastifyContainer, ToggleButton, ToggleButtonGroup, Tooltip, Typography, appBarClasses, badgeClasses, breadcrumbsClasses, chipClasses, circularProgressClasses, closeToast, createHephaestusMuiTheme, createMuiSpacing, dialogActionsClasses, dialogClasses, dialogContentClasses, dialogContentTextClasses, dialogPaperMaxWidth, dialogTitleClasses, enqueueToast, linearProgressClasses, listItemButtonClasses, menuClasses, menuItemClasses, navCollapsedWidth, navExpandedWidth, navTransitionDuration, navTransitionEasing, paginationClasses, paginationItemClasses, popoverClasses, selectClasses, snackbarClasses, tableCellClasses, tableClasses, tablePaginationClasses, tableRowClasses, tableSortLabelClasses, tooltipClasses, useNavContext, useSetTheme, useTheme, useToast };

//# sourceMappingURL=web.js.map